import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {};
/** Priority level of a budget allocation bucket within an AIJobMan budget plan */
export var AiJobManBudgetPlanBucketPriority;
(function (AiJobManBudgetPlanBucketPriority) {
    AiJobManBudgetPlanBucketPriority["High"] = "HIGH";
    AiJobManBudgetPlanBucketPriority["Low"] = "LOW";
    AiJobManBudgetPlanBucketPriority["Medium"] = "MEDIUM";
})(AiJobManBudgetPlanBucketPriority || (AiJobManBudgetPlanBucketPriority = {}));
/** Status of an AI Job Management budget plan generation task */
export var AiJobManBudgetPlanTaskStatus;
(function (AiJobManBudgetPlanTaskStatus) {
    /** Task was superseded by a newer request */
    AiJobManBudgetPlanTaskStatus["Cancelled"] = "CANCELLED";
    /** Task completed successfully; result is populated */
    AiJobManBudgetPlanTaskStatus["Completed"] = "COMPLETED";
    /** Task failed */
    AiJobManBudgetPlanTaskStatus["Failed"] = "FAILED";
    /** Task is rebuilding the advertiser's draft budget plan; result is not yet populated */
    AiJobManBudgetPlanTaskStatus["UpdatingDraft"] = "UPDATING_DRAFT";
    /** Task is actively being processed */
    AiJobManBudgetPlanTaskStatus["Working"] = "WORKING";
})(AiJobManBudgetPlanTaskStatus || (AiJobManBudgetPlanTaskStatus = {}));
/** Current processing step of a budget plan generation task */
export var AiJobManBudgetPlanTaskStep;
(function (AiJobManBudgetPlanTaskStep) {
    /** Analyzing job market conditions and determining optimal budget allocations */
    AiJobManBudgetPlanTaskStep["AnalyzingJobMarket"] = "ANALYZING_JOB_MARKET";
    /** Building and saving the customized budget strategy */
    AiJobManBudgetPlanTaskStep["CreatingStrategy"] = "CREATING_STRATEGY";
    /** Budget allocations determined, preparing to finalize the strategy */
    AiJobManBudgetPlanTaskStep["EvaluatingBudget"] = "EVALUATING_BUDGET";
    /** Retrieving employer jobs and analyzing individual job requirements */
    AiJobManBudgetPlanTaskStep["OrganizingPriorities"] = "ORGANIZING_PRIORITIES";
    /** Initializing the budget plan generation process */
    AiJobManBudgetPlanTaskStep["StartingStrategy"] = "STARTING_STRATEGY";
})(AiJobManBudgetPlanTaskStep || (AiJobManBudgetPlanTaskStep = {}));
/** Status of an AI Job Management calibration task operation */
export var AiJobManCalibrationTaskStatus;
(function (AiJobManCalibrationTaskStatus) {
    /** Task was cancelled */
    AiJobManCalibrationTaskStatus["Cancelled"] = "CANCELLED";
    /** Task completed successfully; calibrationData is populated */
    AiJobManCalibrationTaskStatus["Completed"] = "COMPLETED";
    /** Task failed */
    AiJobManCalibrationTaskStatus["Failed"] = "FAILED";
    /** Task is actively being processed */
    AiJobManCalibrationTaskStatus["Working"] = "WORKING";
})(AiJobManCalibrationTaskStatus || (AiJobManCalibrationTaskStatus = {}));
/** Competitiveness level for a job based on hiring analysis */
export var AiJobManCompetitiveness;
(function (AiJobManCompetitiveness) {
    AiJobManCompetitiveness["High"] = "HIGH";
    AiJobManCompetitiveness["Low"] = "LOW";
    AiJobManCompetitiveness["Medium"] = "MEDIUM";
})(AiJobManCompetitiveness || (AiJobManCompetitiveness = {}));
/** Status of an AI Job Management Job Deep Research (JDR) refresh task */
export var AiJobManJobDeepResearchTaskStatus;
(function (AiJobManJobDeepResearchTaskStatus) {
    /** Task was superseded by a newer request */
    AiJobManJobDeepResearchTaskStatus["Cancelled"] = "CANCELLED";
    /** Task completed successfully; result is populated */
    AiJobManJobDeepResearchTaskStatus["Completed"] = "COMPLETED";
    /** Task failed */
    AiJobManJobDeepResearchTaskStatus["Failed"] = "FAILED";
    /** Task is actively being processed */
    AiJobManJobDeepResearchTaskStatus["Working"] = "WORKING";
})(AiJobManJobDeepResearchTaskStatus || (AiJobManJobDeepResearchTaskStatus = {}));
/** The job attributes exposed as UI filter facets. */
export var AiJobManJobFilterFacetType;
(function (AiJobManJobFilterFacetType) {
    /** The job posting title. */
    AiJobManJobFilterFacetType["JobTitle"] = "JOB_TITLE";
    /** The job's short formatted location. */
    AiJobManJobFilterFacetType["Location"] = "LOCATION";
    /** The job's external requisition / reference number. */
    AiJobManJobFilterFacetType["RefNum"] = "REF_NUM";
    /** The job's source display name. */
    AiJobManJobFilterFacetType["Source"] = "SOURCE";
})(AiJobManJobFilterFacetType || (AiJobManJobFilterFacetType = {}));
/** Lifecycle state of an advertiser's AIJM plan strategy. */
export var AiJobManStrategyStatus;
(function (AiJobManStrategyStatus) {
    /** The strategy is running normally — cron processes daily, AIJM manages campaigns. */
    AiJobManStrategyStatus["Active"] = "ACTIVE";
    /** The strategy is paused — cron skips processing, campaigns have aiJobManagementOptIn cleared. */
    AiJobManStrategyStatus["Paused"] = "PAUSED";
})(AiJobManStrategyStatus || (AiJobManStrategyStatus = {}));
/** How the advertiser targets jobs for AIJM management. For JOB_LIST and RULE, a null or empty ejsFilter means "no jobs" — it is not coerced to "all jobs". ALL_JOBS is the only way to express "every job"; its ejsFilter is ignored. */
export var AiJobManSubsetConfigurationJobSelectionMode;
(function (AiJobManSubsetConfigurationJobSelectionMode) {
    /** Every eligible job is managed by AIJM. ejsFilter is ignored. */
    AiJobManSubsetConfigurationJobSelectionMode["AllJobs"] = "ALL_JOBS";
    /** A static set of jobs identified directly in the ejsFilter. */
    AiJobManSubsetConfigurationJobSelectionMode["JobList"] = "JOB_LIST";
    /** A dynamic set of jobs defined by ejsFilter, re-evaluated at calibration / planning time. */
    AiJobManSubsetConfigurationJobSelectionMode["Rule"] = "RULE";
})(AiJobManSubsetConfigurationJobSelectionMode || (AiJobManSubsetConfigurationJobSelectionMode = {}));
/** The Type of API Call that the tool will be making */
export var AiToolDefinitionType;
(function (AiToolDefinitionType) {
    /** This is for non-OneGraph GraphQL requests, so if you have a standalone graph you would use this */
    AiToolDefinitionType["Graphql"] = "GRAPHQL";
    /** This option is for OneGraph requests, these requests have special permissions because of the rules of OneGraph */
    AiToolDefinitionType["Onegraph"] = "ONEGRAPH";
    /** This is for REST requests, they require an OpenAPI spec */
    AiToolDefinitionType["Rest"] = "REST";
})(AiToolDefinitionType || (AiToolDefinitionType = {}));
export var AcceptScoutResult;
(function (AcceptScoutResult) {
    AcceptScoutResult["JobseekerNotEligible"] = "JOBSEEKER_NOT_ELIGIBLE";
    AcceptScoutResult["JobIneligible"] = "JOB_INELIGIBLE";
    AcceptScoutResult["JobNotAvailable"] = "JOB_NOT_AVAILABLE";
    AcceptScoutResult["ScoutStatusIneligible"] = "SCOUT_STATUS_INELIGIBLE";
    AcceptScoutResult["ServiceUnavailable"] = "SERVICE_UNAVAILABLE";
    AcceptScoutResult["Success"] = "SUCCESS";
})(AcceptScoutResult || (AcceptScoutResult = {}));
/** Product where Account time zone was last updated. */
export var AccountTimeZoneSourceTag;
(function (AccountTimeZoneSourceTag) {
    /** User-provided timezone */
    AccountTimeZoneSourceTag["GlobalSettings"] = "GLOBAL_SETTINGS";
    AccountTimeZoneSourceTag["InterviewRsvpWebapp"] = "INTERVIEW_RSVP_WEBAPP";
    /** Inferred timezone */
    AccountTimeZoneSourceTag["Legacy"] = "LEGACY";
    AccountTimeZoneSourceTag["MyIndeed"] = "MY_INDEED";
    AccountTimeZoneSourceTag["Scim"] = "SCIM";
})(AccountTimeZoneSourceTag || (AccountTimeZoneSourceTag = {}));
/**
 * Enum representing the category of accrued time
 * Currently SICK and PTO times can be accrued but more may be available in the future
 */
export var AccruedTimeCode;
(function (AccruedTimeCode) {
    AccruedTimeCode["Pto"] = "PTO";
    AccruedTimeCode["Sick"] = "SICK";
})(AccruedTimeCode || (AccruedTimeCode = {}));
/**
 * Denotes the category of accrual time
 * -ACCRUAL represents the worker earning time
 * -WITHDRAWAL represents them claiming it for a particular date
 * -WITHDRAWAL_CANCELED represents a cancellation of a previous withdrawal record
 * -PAID represents a payment of a particular WITHDRAWAL record
 * -ROLLOVER represents the balance rollover between calendar years
 */
export var AccruedTimeTransactionStatuses;
(function (AccruedTimeTransactionStatuses) {
    AccruedTimeTransactionStatuses["Accrued"] = "ACCRUED";
    AccruedTimeTransactionStatuses["Paid"] = "PAID";
    AccruedTimeTransactionStatuses["Rollover"] = "ROLLOVER";
    AccruedTimeTransactionStatuses["WithdrawalCanceled"] = "WITHDRAWAL_CANCELED";
    AccruedTimeTransactionStatuses["Withdrawn"] = "WITHDRAWN";
})(AccruedTimeTransactionStatuses || (AccruedTimeTransactionStatuses = {}));
export var AceSystemStatus;
(function (AceSystemStatus) {
    AceSystemStatus["Ok"] = "OK";
    AceSystemStatus["Outage"] = "OUTAGE";
})(AceSystemStatus || (AceSystemStatus = {}));
export var ActionKind;
(function (ActionKind) {
    ActionKind["Deeplink"] = "DEEPLINK";
    ActionKind["Internal"] = "INTERNAL";
    ActionKind["Url"] = "URL";
})(ActionKind || (ActionKind = {}));
/** Action name enumeration */
export var ActionName;
(function (ActionName) {
    /** Get third-party verification status action */
    ActionName["GetThirdPartyVerificationStatusAction"] = "GET_THIRD_PARTY_VERIFICATION_STATUS_ACTION";
    /** Identity verification action */
    ActionName["IdVerificationAction"] = "ID_VERIFICATION_ACTION";
    /** License verification action */
    ActionName["LicenseVerificationAction"] = "LICENSE_VERIFICATION_ACTION";
    /** On-demand license verification action */
    ActionName["OnDemandLicenseVerificationAction"] = "ON_DEMAND_LICENSE_VERIFICATION_ACTION";
    /** Temporary on-demand license verification action */
    ActionName["TemporaryOnDemandLicenseVerificationAction"] = "TEMPORARY_ON_DEMAND_LICENSE_VERIFICATION_ACTION";
})(ActionName || (ActionName = {}));
/** Action status enumeration */
export var ActionStatus;
(function (ActionStatus) {
    /** Action failed */
    ActionStatus["ActionFailed"] = "ACTION_FAILED";
    /** Action is still being processed */
    ActionStatus["ActionInProgress"] = "ACTION_IN_PROGRESS";
    /** Action completed successfully */
    ActionStatus["ActionSuccessful"] = "ACTION_SUCCESSFUL";
    /** Status unknown due to platform/API error */
    ActionStatus["Unknown"] = "UNKNOWN";
})(ActionStatus || (ActionStatus = {}));
export var ActivityLogInvoiceStatus;
(function (ActivityLogInvoiceStatus) {
    ActivityLogInvoiceStatus["Complete"] = "COMPLETE";
    /** @deprecated Replaced by DENIED for clearer terminology. Please use DENIED instead. */
    ActivityLogInvoiceStatus["Declined"] = "DECLINED";
    ActivityLogInvoiceStatus["Denied"] = "DENIED";
    ActivityLogInvoiceStatus["Error"] = "ERROR";
    ActivityLogInvoiceStatus["Pending"] = "PENDING";
    ActivityLogInvoiceStatus["Started"] = "STARTED";
})(ActivityLogInvoiceStatus || (ActivityLogInvoiceStatus = {}));
/** Activity log status */
export var ActivityLogStatus;
(function (ActivityLogStatus) {
    ActivityLogStatus["Complete"] = "COMPLETE";
    /**
     * Indicates the activity completed with a mix of outcomes: at least one operation succeeded
     * and at least one failed. For refunds, this means some invoices were processed successfully
     * while others were not.
     */
    ActivityLogStatus["CompleteWithErrors"] = "COMPLETE_WITH_ERRORS";
    /** @deprecated Replaced by DENIED for clearer terminology. Please use DENIED instead. */
    ActivityLogStatus["Declined"] = "DECLINED";
    ActivityLogStatus["Denied"] = "DENIED";
    ActivityLogStatus["Error"] = "ERROR";
    /**
     * Indicates the activity expired before it could be processed, e.g. a subscription
     * cancellation approval request that was not approved before its effective date.
     */
    ActivityLogStatus["Expired"] = "EXPIRED";
    ActivityLogStatus["Pending"] = "PENDING";
    /**
     * Indicates a refund is approved but waiting for the client to submit their banking
     * information via the Customer Banking Intake (CBI) portal.
     */
    ActivityLogStatus["PendingCustomerBillingIntake"] = "PENDING_CUSTOMER_BILLING_INTAKE";
    ActivityLogStatus["Started"] = "STARTED";
})(ActivityLogStatus || (ActivityLogStatus = {}));
export var ActivityLogSubscriptionStatus;
(function (ActivityLogSubscriptionStatus) {
    ActivityLogSubscriptionStatus["Complete"] = "COMPLETE";
    ActivityLogSubscriptionStatus["Denied"] = "DENIED";
    ActivityLogSubscriptionStatus["Error"] = "ERROR";
    /**
     * Indicates the subscription's cancellation approval request expired before it could be
     * processed, e.g. it was not approved before the requested effective date.
     */
    ActivityLogSubscriptionStatus["Expired"] = "EXPIRED";
    ActivityLogSubscriptionStatus["Pending"] = "PENDING";
    ActivityLogSubscriptionStatus["Started"] = "STARTED";
})(ActivityLogSubscriptionStatus || (ActivityLogSubscriptionStatus = {}));
/** Activity log type */
export var ActivityLogType;
(function (ActivityLogType) {
    ActivityLogType["AdjustPreInvoice"] = "ADJUST_PRE_INVOICE";
    ActivityLogType["AllocateEaCredit"] = "ALLOCATE_EA_CREDIT";
    ActivityLogType["CancelSubscription"] = "CANCEL_SUBSCRIPTION";
    ActivityLogType["Charge"] = "CHARGE";
    ActivityLogType["CreateApprovalRequest"] = "CREATE_APPROVAL_REQUEST";
    ActivityLogType["CreateInvoice"] = "CREATE_INVOICE";
    ActivityLogType["CreateSubscription"] = "CREATE_SUBSCRIPTION";
    ActivityLogType["DeallocateEaCredit"] = "DEALLOCATE_EA_CREDIT";
    ActivityLogType["ExpirePromotion"] = "EXPIRE_PROMOTION";
    ActivityLogType["FundEaCreditPool"] = "FUND_EA_CREDIT_POOL";
    ActivityLogType["GenerateSponsoredJobsInvoice"] = "GENERATE_SPONSORED_JOBS_INVOICE";
    ActivityLogType["GrantPromotion"] = "GRANT_PROMOTION";
    ActivityLogType["IncreaseSubscriptionReassignmentLimit"] = "INCREASE_SUBSCRIPTION_REASSIGNMENT_LIMIT";
    ActivityLogType["ModifySubscription"] = "MODIFY_SUBSCRIPTION";
    ActivityLogType["PauseSubscription"] = "PAUSE_SUBSCRIPTION";
    ActivityLogType["ReactivateSubscription"] = "REACTIVATE_SUBSCRIPTION";
    ActivityLogType["Refund"] = "REFUND";
    ActivityLogType["RevokeSubscription"] = "REVOKE_SUBSCRIPTION";
})(ActivityLogType || (ActivityLogType = {}));
export var ActivityType;
(function (ActivityType) {
    ActivityType["AccountPaused"] = "ACCOUNT_PAUSED";
    ActivityType["AccountUnpaused"] = "ACCOUNT_UNPAUSED";
    ActivityType["AddedToSquallQueue"] = "ADDED_TO_SQUALL_QUEUE";
    ActivityType["AdditionalAccountInformation"] = "ADDITIONAL_ACCOUNT_INFORMATION";
    ActivityType["AdvertiserOptedOutOfPpa"] = "ADVERTISER_OPTED_OUT_OF_PPA";
    ActivityType["AdvActivated"] = "ADV_ACTIVATED";
    ActivityType["AdvDisabled"] = "ADV_DISABLED";
    ActivityType["AdvPaused"] = "ADV_PAUSED";
    ActivityType["AdyenAuthPaymentRefunded"] = "ADYEN_AUTH_PAYMENT_REFUNDED";
    ActivityType["AdyenAuthRefundFailed"] = "ADYEN_AUTH_REFUND_FAILED";
    ActivityType["AdyenPaymentDeclined"] = "ADYEN_PAYMENT_DECLINED";
    ActivityType["AdyenPaymentDeclineEmail"] = "ADYEN_PAYMENT_DECLINE_EMAIL";
    ActivityType["AdyenPaymentPending"] = "ADYEN_PAYMENT_PENDING";
    ActivityType["AdyenPaymentReceived"] = "ADYEN_PAYMENT_RECEIVED";
    ActivityType["AdyenPaymentRefunded"] = "ADYEN_PAYMENT_REFUNDED";
    ActivityType["AdyenPaymentRefundFailed"] = "ADYEN_PAYMENT_REFUND_FAILED";
    ActivityType["AfterFirstRevenue_3D"] = "AFTER_FIRST_REVENUE_3D";
    ActivityType["AfterFirstRevenue_7D"] = "AFTER_FIRST_REVENUE_7D";
    ActivityType["AfterFirstRevenue_14D"] = "AFTER_FIRST_REVENUE_14D";
    ActivityType["AfterFirstRevenue_30D"] = "AFTER_FIRST_REVENUE_30D";
    ActivityType["AfterFirstRevenue_45D"] = "AFTER_FIRST_REVENUE_45D";
    ActivityType["AfterLastRevenue_3D"] = "AFTER_LAST_REVENUE_3D";
    ActivityType["AfterLastRevenue_7D"] = "AFTER_LAST_REVENUE_7D";
    ActivityType["AfterLastRevenue_14D"] = "AFTER_LAST_REVENUE_14D";
    ActivityType["AfterLastRevenue_30D"] = "AFTER_LAST_REVENUE_30D";
    ActivityType["AfterLastRevenue_90D"] = "AFTER_LAST_REVENUE_90D";
    ActivityType["ApproveClaimJobSite"] = "APPROVE_CLAIM_JOB_SITE";
    ActivityType["AutoassignLinkParent"] = "AUTOASSIGN_LINK_PARENT";
    ActivityType["AutoassignParentDefault"] = "AUTOASSIGN_PARENT_DEFAULT";
    ActivityType["AutopauseInactiveAtsJob"] = "AUTOPAUSE_INACTIVE_ATS_JOB";
    ActivityType["AutoPauseJob"] = "AUTO_PAUSE_JOB";
    ActivityType["AutoReassignment"] = "AUTO_REASSIGNMENT";
    ActivityType["AutoUnassignment"] = "AUTO_UNASSIGNMENT";
    ActivityType["BadEntityCurrency"] = "BAD_ENTITY_CURRENCY";
    ActivityType["BidManagementAlert"] = "BID_MANAGEMENT_ALERT";
    ActivityType["BillingEntityMistmatch"] = "BILLING_ENTITY_MISTMATCH";
    ActivityType["BulkJob"] = "BULK_JOB";
    ActivityType["BulkPauseJobEmail"] = "BULK_PAUSE_JOB_EMAIL";
    ActivityType["CalculateUpsells"] = "CALCULATE_UPSELLS";
    ActivityType["CcApproved"] = "CC_APPROVED";
    ActivityType["ChargeOverLimit"] = "CHARGE_OVER_LIMIT";
    ActivityType["ChurnCreditCampaign"] = "CHURN_CREDIT_CAMPAIGN";
    ActivityType["ClaimCompanyPage"] = "CLAIM_COMPANY_PAGE";
    ActivityType["ClaimLoyalCreditConfirmation"] = "CLAIM_LOYAL_CREDIT_CONFIRMATION";
    ActivityType["ClickBalancingAlert"] = "CLICK_BALANCING_ALERT";
    ActivityType["ClosedJobSummary"] = "CLOSED_JOB_SUMMARY";
    ActivityType["CommissionChange"] = "COMMISSION_CHANGE";
    ActivityType["CompeteFollowup"] = "COMPETE_FOLLOWUP";
    ActivityType["CompromisedAccountRecoveryComplete"] = "COMPROMISED_ACCOUNT_RECOVERY_COMPLETE";
    ActivityType["CompromisedAccountRecoverySubmitted"] = "COMPROMISED_ACCOUNT_RECOVERY_SUBMITTED";
    ActivityType["CompromisedAccountRevertConsented"] = "COMPROMISED_ACCOUNT_REVERT_CONSENTED";
    ActivityType["ContactWebForm"] = "CONTACT_WEB_FORM";
    ActivityType["CpaPlanUpdated"] = "CPA_PLAN_UPDATED";
    ActivityType["CpjActiveGroup"] = "CPJ_ACTIVE_GROUP";
    ActivityType["CpqapUpsellEmail"] = "CPQAP_UPSELL_EMAIL";
    ActivityType["CpqaJobSelected"] = "CPQA_JOB_SELECTED";
    ActivityType["CreateAd"] = "CREATE_AD";
    ActivityType["CreateAdConfirmation"] = "CREATE_AD_CONFIRMATION";
    ActivityType["CreateJob"] = "CREATE_JOB";
    ActivityType["CreateJobApplyurl"] = "CREATE_JOB_APPLYURL";
    ActivityType["CreditcardApproved"] = "CREDITCARD_APPROVED";
    ActivityType["CreditcardDeclined"] = "CREDITCARD_DECLINED";
    ActivityType["CreditcardNotauthorized"] = "CREDITCARD_NOTAUTHORIZED";
    ActivityType["CreditGiven_100"] = "CREDIT_GIVEN_100";
    ActivityType["CreditPoolCaseCreationRequested"] = "CREDIT_POOL_CASE_CREATION_REQUESTED";
    ActivityType["CurrencyChangeFailed"] = "CURRENCY_CHANGE_FAILED";
    ActivityType["CurrencyChangeSucceded"] = "CURRENCY_CHANGE_SUCCEDED";
    ActivityType["DailyRevenueDropAll"] = "DAILY_REVENUE_DROP_ALL";
    ActivityType["DarkAccount"] = "DARK_ACCOUNT";
    ActivityType["DeleteAd"] = "DELETE_AD";
    ActivityType["DeleteJob"] = "DELETE_JOB";
    ActivityType["DisableBidManagment"] = "DISABLE_BID_MANAGMENT";
    ActivityType["DradisAdcampaignReached_50Percent"] = "DRADIS_ADCAMPAIGN_REACHED_50_PERCENT";
    ActivityType["DradisAdcampaignReached_75Percent"] = "DRADIS_ADCAMPAIGN_REACHED_75_PERCENT";
    ActivityType["DradisAdcampaignReached_90Percent"] = "DRADIS_ADCAMPAIGN_REACHED_90_PERCENT";
    ActivityType["DradisFreeJobsLimitReached"] = "DRADIS_FREE_JOBS_LIMIT_REACHED";
    ActivityType["DradisJobislive"] = "DRADIS_JOBISLIVE";
    ActivityType["DradisJobUpdateEndDate"] = "DRADIS_JOB_UPDATE_END_DATE";
    ActivityType["DradisUnsponsorJobsNoBilling"] = "DRADIS_UNSPONSOR_JOBS_NO_BILLING";
    ActivityType["EditAdvertiserInfo"] = "EDIT_ADVERTISER_INFO";
    ActivityType["EditDradisApplyUrlMultiLoc"] = "EDIT_DRADIS_APPLY_URL_MULTI_LOC";
    ActivityType["EditMinJobLocOverride"] = "EDIT_MIN_JOB_LOC_OVERRIDE";
    ActivityType["EditProspectInfo"] = "EDIT_PROSPECT_INFO";
    ActivityType["EmailAdvertiserApprovalRequired"] = "EMAIL_ADVERTISER_APPROVAL_REQUIRED";
    ActivityType["EmailAdvertiserNextSteps"] = "EMAIL_ADVERTISER_NEXT_STEPS";
    ActivityType["EmailConfirmedByAdvertiser"] = "EMAIL_CONFIRMED_BY_ADVERTISER";
    ActivityType["EmailConfirmedByCs"] = "EMAIL_CONFIRMED_BY_CS";
    ActivityType["EmailNonspendingSponsoredonlyUpsell"] = "EMAIL_NONSPENDING_SPONSOREDONLY_UPSELL";
    ActivityType["EmailOrganicJobSoonExpiring"] = "EMAIL_ORGANIC_JOB_SOON_EXPIRING";
    ActivityType["EmployerMobileFeedback"] = "EMPLOYER_MOBILE_FEEDBACK";
    ActivityType["EnableBidManagement"] = "ENABLE_BID_MANAGEMENT";
    ActivityType["EntityMigrated"] = "ENTITY_MIGRATED";
    ActivityType["EntityMigrationCancelled"] = "ENTITY_MIGRATION_CANCELLED";
    ActivityType["EntityMigrationScheduled"] = "ENTITY_MIGRATION_SCHEDULED";
    ActivityType["FeaturedEmployer_7DBeforeEnd"] = "FEATURED_EMPLOYER_7D_BEFORE_END";
    ActivityType["FeaturedEmployerCreditGranted"] = "FEATURED_EMPLOYER_CREDIT_GRANTED";
    ActivityType["FeaturedEmployerCreditUngrantable"] = "FEATURED_EMPLOYER_CREDIT_UNGRANTABLE";
    ActivityType["FeaturedEmployerEnd"] = "FEATURED_EMPLOYER_END";
    ActivityType["FeaturedEmployerKickstart_7DBeforeEnd"] = "FEATURED_EMPLOYER_KICKSTART_7D_BEFORE_END";
    ActivityType["FeaturedEmployerKickstartEnd"] = "FEATURED_EMPLOYER_KICKSTART_END";
    ActivityType["FeaturedEmployerKickstartStart"] = "FEATURED_EMPLOYER_KICKSTART_START";
    ActivityType["FeaturedEmployerLoseFreeRez"] = "FEATURED_EMPLOYER_LOSE_FREE_REZ";
    ActivityType["FeaturedEmployerNotMeetCriteria"] = "FEATURED_EMPLOYER_NOT_MEET_CRITERIA";
    ActivityType["FeaturedEmployerPaceSlow_7DBeforeEnd"] = "FEATURED_EMPLOYER_PACE_SLOW_7D_BEFORE_END";
    ActivityType["FeaturedEmployerPaceSlow_14DBeforeEnd"] = "FEATURED_EMPLOYER_PACE_SLOW_14D_BEFORE_END";
    ActivityType["FeaturedEmployerStart"] = "FEATURED_EMPLOYER_START";
    ActivityType["FirstCpaPlanCreated"] = "FIRST_CPA_PLAN_CREATED";
    ActivityType["FirstPaidResumeContact"] = "FIRST_PAID_RESUME_CONTACT";
    ActivityType["ForecastResolved"] = "FORECAST_RESOLVED";
    ActivityType["Ftp_7DLimitReached"] = "FTP_7D_LIMIT_REACHED";
    ActivityType["Ftp_14DLimitReached"] = "FTP_14D_LIMIT_REACHED";
    ActivityType["FtpOpportunityForUpsale"] = "FTP_OPPORTUNITY_FOR_UPSALE";
    ActivityType["GenericClaimMade"] = "GENERIC_CLAIM_MADE";
    ActivityType["GenericClaimRejected"] = "GENERIC_CLAIM_REJECTED";
    ActivityType["GenericInvoiceApproved"] = "GENERIC_INVOICE_APPROVED";
    ActivityType["GenericInvoiceRejected"] = "GENERIC_INVOICE_REJECTED";
    ActivityType["GenericInvoiceRequested"] = "GENERIC_INVOICE_REQUESTED";
    ActivityType["GrantTcpaConsent"] = "GRANT_TCPA_CONSENT";
    ActivityType["HostedJobModeration"] = "HOSTED_JOB_MODERATION";
    ActivityType["HtfSponsorOnlyJobPosted"] = "HTF_SPONSOR_ONLY_JOB_POSTED";
    ActivityType["HupSponsorOnlyJobPosted"] = "HUP_SPONSOR_ONLY_JOB_POSTED";
    ActivityType["HybridAdvidSponsorOnlyJobPosted"] = "HYBRID_ADVID_SPONSOR_ONLY_JOB_POSTED";
    ActivityType["IheClientIntakeSubmission"] = "IHE_CLIENT_INTAKE_SUBMISSION";
    ActivityType["IheEventBudgetNotification_50"] = "IHE_EVENT_BUDGET_NOTIFICATION_50";
    ActivityType["IheEventBudgetNotification_90"] = "IHE_EVENT_BUDGET_NOTIFICATION_90";
    ActivityType["IheNoRsvps_2Days"] = "IHE_NO_RSVPS_2_DAYS";
    ActivityType["IndeedhireAccountManagerAssigned"] = "INDEEDHIRE_ACCOUNT_MANAGER_ASSIGNED";
    ActivityType["IndeedhireApplicationSubmitApproved"] = "INDEEDHIRE_APPLICATION_SUBMIT_APPROVED";
    ActivityType["IndeedhireApplicationSubmitNeedMoreInfo"] = "INDEEDHIRE_APPLICATION_SUBMIT_NEED_MORE_INFO";
    ActivityType["IndeedhireApplicationSubmitRejected"] = "INDEEDHIRE_APPLICATION_SUBMIT_REJECTED";
    ActivityType["IndeedhireAwaitingClientFeedback_5D"] = "INDEEDHIRE_AWAITING_CLIENT_FEEDBACK_5D";
    ActivityType["IndeedhireAwaitingClientFeedback_10D"] = "INDEEDHIRE_AWAITING_CLIENT_FEEDBACK_10D";
    ActivityType["IndeedhireCandidateFeedback"] = "INDEEDHIRE_CANDIDATE_FEEDBACK";
    ActivityType["IndeedhireCandidateInterviewScheduled"] = "INDEEDHIRE_CANDIDATE_INTERVIEW_SCHEDULED";
    ActivityType["IndeedhireCandidateOfferExtended"] = "INDEEDHIRE_CANDIDATE_OFFER_EXTENDED";
    ActivityType["IndeedhireCandidatePlaced"] = "INDEEDHIRE_CANDIDATE_PLACED";
    ActivityType["IndeedhireCandidateSubmitted"] = "INDEEDHIRE_CANDIDATE_SUBMITTED";
    ActivityType["IndeedhireClientConversationHeld"] = "INDEEDHIRE_CLIENT_CONVERSATION_HELD";
    ActivityType["IndeedhireClientDisengaged"] = "INDEEDHIRE_CLIENT_DISENGAGED";
    ActivityType["IndeedhireClientIntakeCompleted"] = "INDEEDHIRE_CLIENT_INTAKE_COMPLETED";
    ActivityType["IndeedhireClientIntakeScheduled"] = "INDEEDHIRE_CLIENT_INTAKE_SCHEDULED";
    ActivityType["IndeedhireClientLeftAfterTos"] = "INDEEDHIRE_CLIENT_LEFT_AFTER_TOS";
    ActivityType["IndeedhireClientRejectedCandidate"] = "INDEEDHIRE_CLIENT_REJECTED_CANDIDATE";
    ActivityType["IndeedhireClientSubmittedJobInfo"] = "INDEEDHIRE_CLIENT_SUBMITTED_JOB_INFO";
    ActivityType["IndeedhireContractSigned"] = "INDEEDHIRE_CONTRACT_SIGNED";
    ActivityType["IndeedhireInvoiceSent"] = "INDEEDHIRE_INVOICE_SENT";
    ActivityType["IndeedhireRecruiterRequestedBusiness"] = "INDEEDHIRE_RECRUITER_REQUESTED_BUSINESS";
    ActivityType["IndeedhireRequisitionLaunched"] = "INDEEDHIRE_REQUISITION_LAUNCHED";
    ActivityType["IndeedhireRequisitionMadeLive"] = "INDEEDHIRE_REQUISITION_MADE_LIVE";
    ActivityType["IndeedhireRequisitionOpened"] = "INDEEDHIRE_REQUISITION_OPENED";
    ActivityType["IndeedhireSalesIntakeCompleted"] = "INDEEDHIRE_SALES_INTAKE_COMPLETED";
    ActivityType["InsiderCampaignFinalBillSubmitted"] = "INSIDER_CAMPAIGN_FINAL_BILL_SUBMITTED";
    ActivityType["InsiderCampaignIntakeSubmitted"] = "INSIDER_CAMPAIGN_INTAKE_SUBMITTED";
    ActivityType["InsiderCampaignIntentSubmitted"] = "INSIDER_CAMPAIGN_INTENT_SUBMITTED";
    ActivityType["InvoicesOverLimit"] = "INVOICES_OVER_LIMIT";
    ActivityType["InvoiceAdjustmentCreated"] = "INVOICE_ADJUSTMENT_CREATED";
    ActivityType["InvoiceCreated"] = "INVOICE_CREATED";
    ActivityType["InvoiceWriteoff"] = "INVOICE_WRITEOFF";
    ActivityType["IoActivityUpdate"] = "IO_ACTIVITY_UPDATE";
    ActivityType["IoBudgetNotification_50"] = "IO_BUDGET_NOTIFICATION_50";
    ActivityType["IoBudgetNotification_95"] = "IO_BUDGET_NOTIFICATION_95";
    ActivityType["IoClientSigned"] = "IO_CLIENT_SIGNED";
    ActivityType["IoMgmtChecked"] = "IO_MGMT_CHECKED";
    ActivityType["IoStarted"] = "IO_STARTED";
    ActivityType["IoStopped"] = "IO_STOPPED";
    ActivityType["IoUserSubmitted"] = "IO_USER_SUBMITTED";
    ActivityType["IpBlacklist"] = "IP_BLACKLIST";
    ActivityType["ItaAdChanged"] = "ITA_AD_CHANGED";
    ActivityType["ItaAdCreated"] = "ITA_AD_CREATED";
    ActivityType["ItaAdDeleted"] = "ITA_AD_DELETED";
    ActivityType["ItaAdDisabled"] = "ITA_AD_DISABLED";
    ActivityType["ItaAdDisabledAdvertiserBillingIssue"] = "ITA_AD_DISABLED_ADVERTISER_BILLING_ISSUE";
    ActivityType["ItaAdEnabled"] = "ITA_AD_ENABLED";
    ActivityType["ItaAdEnabledAdvertiserBillingResolved"] = "ITA_AD_ENABLED_ADVERTISER_BILLING_RESOLVED";
    ActivityType["ItaApplyAdNeedsReview"] = "ITA_APPLY_AD_NEEDS_REVIEW";
    ActivityType["ItaBudgetChanged"] = "ITA_BUDGET_CHANGED";
    ActivityType["ItaBudgetDeleted"] = "ITA_BUDGET_DELETED";
    ActivityType["ItaBudgetExceedsIoAmount"] = "ITA_BUDGET_EXCEEDS_IO_AMOUNT";
    ActivityType["ItaBudgetExpired"] = "ITA_BUDGET_EXPIRED";
    ActivityType["ItaBudgetNoConversionAfter_3Days"] = "ITA_BUDGET_NO_CONVERSION_AFTER_3_DAYS";
    ActivityType["ItaBudgetNoConversionAfter_7Days"] = "ITA_BUDGET_NO_CONVERSION_AFTER_7_DAYS";
    ActivityType["ItaBudgetReached_50Percent"] = "ITA_BUDGET_REACHED_50_PERCENT";
    ActivityType["ItaBudgetReached_75Percent"] = "ITA_BUDGET_REACHED_75_PERCENT";
    ActivityType["ItaBudgetReached_90Percent"] = "ITA_BUDGET_REACHED_90_PERCENT";
    ActivityType["JobcountOverThreshold"] = "JOBCOUNT_OVER_THRESHOLD";
    ActivityType["JobmoBudgetAdopted"] = "JOBMO_BUDGET_ADOPTED";
    ActivityType["JobCompletionEmail"] = "JOB_COMPLETION_EMAIL";
    ActivityType["JobCompletionEmail_30D"] = "JOB_COMPLETION_EMAIL_30D";
    ActivityType["JobReachedFtpLimits"] = "JOB_REACHED_FTP_LIMITS";
    ActivityType["JobVisibilityDecrease_25"] = "JOB_VISIBILITY_DECREASE_25";
    ActivityType["JobVisibilityDecrease_50"] = "JOB_VISIBILITY_DECREASE_50";
    ActivityType["JobVisibilityDecrease_75"] = "JOB_VISIBILITY_DECREASE_75";
    ActivityType["JobVisibilityDecrease_100"] = "JOB_VISIBILITY_DECREASE_100";
    ActivityType["JobVisibilityIncrease_25"] = "JOB_VISIBILITY_INCREASE_25";
    ActivityType["JobVisibilityIncrease_50"] = "JOB_VISIBILITY_INCREASE_50";
    ActivityType["JobVisibilityIncrease_75"] = "JOB_VISIBILITY_INCREASE_75";
    ActivityType["JobVisibilityIncrease_100"] = "JOB_VISIBILITY_INCREASE_100";
    ActivityType["LeadFromHireContactForm"] = "LEAD_FROM_HIRE_CONTACT_FORM";
    ActivityType["LeadFromManualImport"] = "LEAD_FROM_MANUAL_IMPORT";
    ActivityType["LeadFromMarketo"] = "LEAD_FROM_MARKETO";
    ActivityType["Login"] = "LOGIN";
    ActivityType["LowApplicationCountUpsell"] = "LOW_APPLICATION_COUNT_UPSELL";
    ActivityType["LoyalChurnCredit"] = "LOYAL_CHURN_CREDIT";
    ActivityType["LoyalCreditReminder"] = "LOYAL_CREDIT_REMINDER";
    ActivityType["LoyalDailyCandidateApplyEmail"] = "LOYAL_DAILY_CANDIDATE_APPLY_EMAIL";
    ActivityType["LoyalEmployerProfile"] = "LOYAL_EMPLOYER_PROFILE";
    ActivityType["ManualAdjustment"] = "MANUAL_ADJUSTMENT";
    ActivityType["ManualRefund"] = "MANUAL_REFUND";
    ActivityType["MonthlyNewsletter"] = "MONTHLY_NEWSLETTER";
    ActivityType["NearCreditLimit"] = "NEAR_CREDIT_LIMIT";
    ActivityType["NegativeSentiment"] = "NEGATIVE_SENTIMENT";
    ActivityType["NewCommissionAdjustment"] = "NEW_COMMISSION_ADJUSTMENT";
    ActivityType["NewFeedDeployed"] = "NEW_FEED_DEPLOYED";
    ActivityType["NewParentCompany"] = "NEW_PARENT_COMPANY";
    ActivityType["NewUpsell"] = "NEW_UPSELL";
    ActivityType["NotifyReferredAccount"] = "NOTIFY_REFERRED_ACCOUNT";
    ActivityType["NotValid"] = "NOT_VALID";
    ActivityType["NthJob"] = "NTH_JOB";
    ActivityType["OverCreditLimit"] = "OVER_CREDIT_LIMIT";
    ActivityType["OverDailyBudget"] = "OVER_DAILY_BUDGET";
    ActivityType["OverLifetimeBudget"] = "OVER_LIFETIME_BUDGET";
    ActivityType["OverMonthlyBudget"] = "OVER_MONTHLY_BUDGET";
    ActivityType["ParentCompanyReassigned"] = "PARENT_COMPANY_REASSIGNED";
    ActivityType["PauseAd"] = "PAUSE_AD";
    ActivityType["PauseJob"] = "PAUSE_JOB";
    ActivityType["PaymentReceived"] = "PAYMENT_RECEIVED";
    ActivityType["PayToPostLowApplicationAlert"] = "PAY_TO_POST_LOW_APPLICATION_ALERT";
    ActivityType["PhoneVerification"] = "PHONE_VERIFICATION";
    ActivityType["PingMessage"] = "PING_MESSAGE";
    ActivityType["PlzThrow"] = "PLZ_THROW";
    ActivityType["PositiveSentiment"] = "POSITIVE_SENTIMENT";
    ActivityType["PostModerationNowhereJob"] = "POST_MODERATION_NOWHERE_JOB";
    ActivityType["PpcOpportunityForUpsaleToPpa"] = "PPC_OPPORTUNITY_FOR_UPSALE_TO_PPA";
    ActivityType["PrimePaymentPlanChanged"] = "PRIME_PAYMENT_PLAN_CHANGED";
    ActivityType["ProdworksEapEnrolled"] = "PRODWORKS_EAP_ENROLLED";
    ActivityType["ProdworksEapInvitationRejected"] = "PRODWORKS_EAP_INVITATION_REJECTED";
    ActivityType["ProdworksEapInvitationWithdrawn"] = "PRODWORKS_EAP_INVITATION_WITHDRAWN";
    ActivityType["ProdworksEapInvited"] = "PRODWORKS_EAP_INVITED";
    ActivityType["ProdworksEapNominated"] = "PRODWORKS_EAP_NOMINATED";
    ActivityType["ProdworksEapNominationRejected"] = "PRODWORKS_EAP_NOMINATION_REJECTED";
    ActivityType["ProdworksEapNominationWithdrawn"] = "PRODWORKS_EAP_NOMINATION_WITHDRAWN";
    ActivityType["ProdworksEapPaused"] = "PRODWORKS_EAP_PAUSED";
    ActivityType["ProdworksEapProductActivated"] = "PRODWORKS_EAP_PRODUCT_ACTIVATED";
    ActivityType["ProdworksEapProductDeactivated"] = "PRODWORKS_EAP_PRODUCT_DEACTIVATED";
    ActivityType["ProdworksEapProductOffered"] = "PRODWORKS_EAP_PRODUCT_OFFERED";
    ActivityType["PromotionExpirationMetadata"] = "PROMOTION_EXPIRATION_METADATA";
    ActivityType["PromotionGranted"] = "PROMOTION_GRANTED";
    ActivityType["PromotionGrantedMetadata"] = "PROMOTION_GRANTED_METADATA";
    ActivityType["PromotionItemExpired"] = "PROMOTION_ITEM_EXPIRED";
    ActivityType["PromotionItemTransferred"] = "PROMOTION_ITEM_TRANSFERRED";
    ActivityType["ProspectAdvertiserSignup"] = "PROSPECT_ADVERTISER_SIGNUP";
    ActivityType["ProspectCreated"] = "PROSPECT_CREATED";
    ActivityType["QualifiedCandidatesSummary"] = "QUALIFIED_CANDIDATES_SUMMARY";
    ActivityType["QualifiedNotDistributed"] = "QUALIFIED_NOT_DISTRIBUTED";
    ActivityType["QualifiedNotDistributedCwf"] = "QUALIFIED_NOT_DISTRIBUTED_CWF";
    ActivityType["QualifiedNotDistributedDradis"] = "QUALIFIED_NOT_DISTRIBUTED_DRADIS";
    ActivityType["QualifiedNotDistributedMarketo"] = "QUALIFIED_NOT_DISTRIBUTED_MARKETO";
    ActivityType["RavenClickThruEvent"] = "RAVEN_CLICK_THRU_EVENT";
    ActivityType["RavenEvent"] = "RAVEN_EVENT";
    ActivityType["RavenMarketingEmail"] = "RAVEN_MARKETING_EMAIL";
    ActivityType["RavenOnboardingEmail"] = "RAVEN_ONBOARDING_EMAIL";
    ActivityType["RavenTransactionalEmail"] = "RAVEN_TRANSACTIONAL_EMAIL";
    ActivityType["ReexamineSource"] = "REEXAMINE_SOURCE";
    ActivityType["RepAssigned"] = "REP_ASSIGNED";
    ActivityType["RepUnassigned"] = "REP_UNASSIGNED";
    ActivityType["ResumesearchCompletedFreecontacts"] = "RESUMESEARCH_COMPLETED_FREECONTACTS";
    ActivityType["ResumeBudgetReached"] = "RESUME_BUDGET_REACHED";
    ActivityType["ResumeModeration"] = "RESUME_MODERATION";
    ActivityType["ResumeSubscription"] = "RESUME_SUBSCRIPTION";
    ActivityType["ScamFeatures"] = "SCAM_FEATURES";
    ActivityType["SecondaryAccountLinked"] = "SECONDARY_ACCOUNT_LINKED";
    ActivityType["SecondaryAccountLinkRequest"] = "SECONDARY_ACCOUNT_LINK_REQUEST";
    ActivityType["SendEndDateReminder"] = "SEND_END_DATE_REMINDER";
    ActivityType["SendJobSummaryEmail"] = "SEND_JOB_SUMMARY_EMAIL";
    ActivityType["SentToSquall"] = "SENT_TO_SQUALL";
    ActivityType["SevenDayDeclineViewsUpsell"] = "SEVEN_DAY_DECLINE_VIEWS_UPSELL";
    ActivityType["ShowHostedJobsChange"] = "SHOW_HOSTED_JOBS_CHANGE";
    ActivityType["Signup"] = "SIGNUP";
    ActivityType["SourceClaimAction"] = "SOURCE_CLAIM_ACTION";
    ActivityType["SourceDecreaseTotalJobs_50"] = "SOURCE_DECREASE_TOTAL_JOBS_50";
    ActivityType["SourceDecreaseTotalJobs_75"] = "SOURCE_DECREASE_TOTAL_JOBS_75";
    ActivityType["SourceIncreaseTotalJobs_50"] = "SOURCE_INCREASE_TOTAL_JOBS_50";
    ActivityType["SourceIncreaseTotalJobs_75"] = "SOURCE_INCREASE_TOTAL_JOBS_75";
    ActivityType["SourceJobCountZero"] = "SOURCE_JOB_COUNT_ZERO";
    ActivityType["SquallAccountCompromised"] = "SQUALL_ACCOUNT_COMPROMISED";
    ActivityType["SquallApprove"] = "SQUALL_APPROVE";
    ActivityType["SquallCompromisedNoDamage"] = "SQUALL_COMPROMISED_NO_DAMAGE";
    ActivityType["SquallConfirmedCompromised"] = "SQUALL_CONFIRMED_COMPROMISED";
    ActivityType["SquallConfirmedEmailPhoneCompromised"] = "SQUALL_CONFIRMED_EMAIL_PHONE_COMPROMISED";
    ActivityType["SquallEmailPhoneCompromised"] = "SQUALL_EMAIL_PHONE_COMPROMISED";
    ActivityType["SquallEscalate"] = "SQUALL_ESCALATE";
    ActivityType["SquallEscalateDeclined"] = "SQUALL_ESCALATE_DECLINED";
    ActivityType["SquallForcePasswordReset"] = "SQUALL_FORCE_PASSWORD_RESET";
    ActivityType["SquallIgnore"] = "SQUALL_IGNORE";
    ActivityType["SquallModeration"] = "SQUALL_MODERATION";
    ActivityType["SquallMoreInformationRequired"] = "SQUALL_MORE_INFORMATION_REQUIRED";
    ActivityType["SquallNotCompromised"] = "SQUALL_NOT_COMPROMISED";
    ActivityType["SquallNoRedFlags"] = "SQUALL_NO_RED_FLAGS";
    ActivityType["SquallPending"] = "SQUALL_PENDING";
    ActivityType["SquallReject"] = "SQUALL_REJECT";
    ActivityType["SquallRejectionAppealSubmitted"] = "SQUALL_REJECTION_APPEAL_SUBMITTED";
    ActivityType["SquallRemoveForcePasswordReset"] = "SQUALL_REMOVE_FORCE_PASSWORD_RESET";
    ActivityType["SquallRepostSo"] = "SQUALL_REPOST_SO";
    ActivityType["SquallSo"] = "SQUALL_SO";
    ActivityType["StillEvaluatingFollowUp"] = "STILL_EVALUATING_FOLLOW_UP";
    ActivityType["StructuredTagMatch"] = "STRUCTURED_TAG_MATCH";
    ActivityType["SurveyFilled"] = "SURVEY_FILLED";
    ActivityType["UndeleteJob"] = "UNDELETE_JOB";
    ActivityType["UnderCreditLimit"] = "UNDER_CREDIT_LIMIT";
    ActivityType["UnderDailyBudget"] = "UNDER_DAILY_BUDGET";
    ActivityType["UnderLifetimeBudget"] = "UNDER_LIFETIME_BUDGET";
    ActivityType["UnderMonthlyBudget"] = "UNDER_MONTHLY_BUDGET";
    ActivityType["UnkownReasonToTrack"] = "UNKOWN_REASON_TO_TRACK";
    ActivityType["UnpauseAd"] = "UNPAUSE_AD";
    ActivityType["UnpauseJob"] = "UNPAUSE_JOB";
    ActivityType["UpdateAccount"] = "UPDATE_ACCOUNT";
    ActivityType["UpdateAd"] = "UPDATE_AD";
    ActivityType["UpdateAdBid"] = "UPDATE_AD_BID";
    ActivityType["UpdateAdBudget"] = "UPDATE_AD_BUDGET";
    ActivityType["UpdateBilling"] = "UPDATE_BILLING";
    ActivityType["UpdateJob"] = "UPDATE_JOB";
    ActivityType["UpdateJobApplyemail"] = "UPDATE_JOB_APPLYEMAIL";
    ActivityType["UpdateJobApplyurl"] = "UPDATE_JOB_APPLYURL";
    ActivityType["VatExemptRequest"] = "VAT_EXEMPT_REQUEST";
    ActivityType["VerificationReceived"] = "VERIFICATION_RECEIVED";
    ActivityType["VerificationReceivedInvalid"] = "VERIFICATION_RECEIVED_INVALID";
    ActivityType["VerificationSubmitted"] = "VERIFICATION_SUBMITTED";
    ActivityType["WaldoPolicyTag"] = "WALDO_POLICY_TAG";
    ActivityType["ZendeskEscalation"] = "ZENDESK_ESCALATION";
})(ActivityType || (ActivityType = {}));
/** Enumeration of offsite ad channels */
export var AdChannel;
(function (AdChannel) {
    AdChannel["Beeswax"] = "BEESWAX";
    AdChannel["Facebook"] = "FACEBOOK";
    AdChannel["Google"] = "GOOGLE";
    /** @deprecated Twitter integration is no longer supported */
    AdChannel["Twitter"] = "TWITTER";
})(AdChannel || (AdChannel = {}));
/** Enumeration of ad creation sources */
export var AdContentType;
(function (AdContentType) {
    AdContentType["Default"] = "DEFAULT";
    AdContentType["Video"] = "VIDEO";
})(AdContentType || (AdContentType = {}));
export var AdFormat;
(function (AdFormat) {
    AdFormat["Acmemob"] = "ACMEMOB";
    AdFormat["Acmeweb"] = "ACMEWEB";
    AdFormat["An"] = "AN";
    AdFormat["Anlp"] = "ANLP";
    AdFormat["Api"] = "API";
    AdFormat["Feedalert"] = "FEEDALERT";
    AdFormat["Freeapi"] = "FREEAPI";
    AdFormat["Freejobroll"] = "FREEJOBROLL";
    AdFormat["Googlehome"] = "GOOGLEHOME";
    AdFormat["Homepage"] = "HOMEPAGE";
    AdFormat["Homepagedesktop"] = "HOMEPAGEDESKTOP";
    AdFormat["Ijp"] = "IJP";
    AdFormat["Imgad"] = "IMGAD";
    AdFormat["IndeedPlus"] = "INDEED_PLUS";
    AdFormat["Jobalert"] = "JOBALERT";
    AdFormat["Jobalertservice"] = "JOBALERTSERVICE";
    AdFormat["Jobi2A"] = "JOBI2A";
    AdFormat["Jobroll"] = "JOBROLL";
    AdFormat["Jobroll2"] = "JOBROLL2";
    AdFormat["Labs"] = "LABS";
    AdFormat["Mobile"] = "MOBILE";
    AdFormat["Mobrecjob"] = "MOBRECJOB";
    AdFormat["Opensearch"] = "OPENSEARCH";
    AdFormat["Pan"] = "PAN";
    AdFormat["Postapplymob"] = "POSTAPPLYMOB";
    AdFormat["Postapplyweb"] = "POSTAPPLYWEB";
    AdFormat["Postinquirymob"] = "POSTINQUIRYMOB";
    AdFormat["Postinquiryweb"] = "POSTINQUIRYWEB";
    AdFormat["PremiumMatchedCandidates"] = "PREMIUM_MATCHED_CANDIDATES";
    AdFormat["Rss"] = "RSS";
    AdFormat["SjdGdBs"] = "SJD_GD_BS";
    AdFormat["Sourcing"] = "SOURCING";
    AdFormat["UnknownAdFormat"] = "UNKNOWN_AD_FORMAT";
    AdFormat["Web"] = "WEB";
    AdFormat["Webrecjob"] = "WEBRECJOB";
})(AdFormat || (AdFormat = {}));
/** The per-file outcome of an addJobSeekerProfileCredentialFiles request. */
export var AddJobSeekerProfileCredentialFileResult;
(function (AddJobSeekerProfileCredentialFileResult) {
    AddJobSeekerProfileCredentialFileResult["Failure"] = "FAILURE";
    AddJobSeekerProfileCredentialFileResult["Success"] = "SUCCESS";
})(AddJobSeekerProfileCredentialFileResult || (AddJobSeekerProfileCredentialFileResult = {}));
/** A Job Seeker's resume state, for example PUBLIC or HIDDEN. */
export var AddJobSeekerProfileResumeState;
(function (AddJobSeekerProfileResumeState) {
    AddJobSeekerProfileResumeState["Hidden"] = "HIDDEN";
    AddJobSeekerProfileResumeState["Public"] = "PUBLIC";
})(AddJobSeekerProfileResumeState || (AddJobSeekerProfileResumeState = {}));
/** A Job Seeker's privacy sourcing election, for example OPT_IN or OPT_OUT. */
export var AddJobSeekerProfileSourcingElection;
(function (AddJobSeekerProfileSourcingElection) {
    AddJobSeekerProfileSourcingElection["OptIn"] = "OPT_IN";
    AddJobSeekerProfileSourcingElection["OptOut"] = "OPT_OUT";
})(AddJobSeekerProfileSourcingElection || (AddJobSeekerProfileSourcingElection = {}));
/** The user's "more suggestions" rate limit status */
export var AddMoreStatus;
(function (AddMoreStatus) {
    /** The user has exceeded the limit */
    AddMoreStatus["Error"] = "ERROR";
    /** The user has reached the limit */
    AddMoreStatus["Limit"] = "LIMIT";
    /** The user is under the limit */
    AddMoreStatus["Ok"] = "OK";
})(AddMoreStatus || (AddMoreStatus = {}));
export var AdhocInterviewStatusType;
(function (AdhocInterviewStatusType) {
    AdhocInterviewStatusType["CandidateRequested"] = "CANDIDATE_REQUESTED";
    AdhocInterviewStatusType["EmployerCancelled"] = "EMPLOYER_CANCELLED";
    /** Note: this status is not currently in use. */
    AdhocInterviewStatusType["EmployerRequested"] = "EMPLOYER_REQUESTED";
})(AdhocInterviewStatusType || (AdhocInterviewStatusType = {}));
/** Outcome of attempting to schedule or cancel a send for a single employer invitation. */
export var AdminEmployerInvitationEmailScheduleActionStatus;
(function (AdminEmployerInvitationEmailScheduleActionStatus) {
    /**
     * The schedule request was accepted and is being created asynchronously in the background (the
     * recipients path resolves ACTIVE jobs and writes the scheduled emails off the request thread so large
     * selections return immediately). The per-employer outcome is not known yet — query the scheduled-email
     * list to see the created schedules.
     */
    AdminEmployerInvitationEmailScheduleActionStatus["Accepted"] = "ACCEPTED";
    /** The invitation already has an active pending schedule. */
    AdminEmployerInvitationEmailScheduleActionStatus["AlreadyScheduled"] = "ALREADY_SCHEDULED";
    /** An existing pending schedule was cancelled. */
    AdminEmployerInvitationEmailScheduleActionStatus["Cancelled"] = "CANCELLED";
    /** The employer invitation email feature is turned off (employer-outreach.email-enabled=false). */
    AdminEmployerInvitationEmailScheduleActionStatus["Disabled"] = "DISABLED";
    /** The invitation is not active (already onboarded/declined) and cannot be scheduled. */
    AdminEmployerInvitationEmailScheduleActionStatus["Ineligible"] = "INELIGIBLE";
    /** The supplied templateId does not match any configured outreach email template. */
    AdminEmployerInvitationEmailScheduleActionStatus["InvalidTemplate"] = "INVALID_TEMPLATE";
    /** No invitation exists for the requested id. */
    AdminEmployerInvitationEmailScheduleActionStatus["NotFound"] = "NOT_FOUND";
    /** No active pending schedule existed to cancel. */
    AdminEmployerInvitationEmailScheduleActionStatus["NotScheduled"] = "NOT_SCHEDULED";
    /** The requested time is not in the future. */
    AdminEmployerInvitationEmailScheduleActionStatus["PastTime"] = "PAST_TIME";
    /** The system is temporarily overloaded and could not accept the request; retry shortly. Nothing was scheduled. */
    AdminEmployerInvitationEmailScheduleActionStatus["RetryLater"] = "RETRY_LATER";
    /** A new pending schedule was created. */
    AdminEmployerInvitationEmailScheduleActionStatus["Scheduled"] = "SCHEDULED";
})(AdminEmployerInvitationEmailScheduleActionStatus || (AdminEmployerInvitationEmailScheduleActionStatus = {}));
/** Outcome of attempting to send the outreach email for a single employer invitation. */
export var AdminEmployerInvitationEmailSendStatus;
(function (AdminEmployerInvitationEmailSendStatus) {
    /** Sending is globally disabled via employer-outreach.email-enabled. */
    AdminEmployerInvitationEmailSendStatus["Disabled"] = "DISABLED";
    /** CommsHub reported a failure for this invitation's advertiser. */
    AdminEmployerInvitationEmailSendStatus["Failed"] = "FAILED";
    /** The invitation is not in an active status (already onboarded/declined), so outreach was not sent. */
    AdminEmployerInvitationEmailSendStatus["Ineligible"] = "INELIGIBLE";
    /** The supplied templateId does not match any configured outreach email template. */
    AdminEmployerInvitationEmailSendStatus["InvalidTemplate"] = "INVALID_TEMPLATE";
    /** No invitation exists for the requested id. */
    AdminEmployerInvitationEmailSendStatus["NotFound"] = "NOT_FOUND";
    /** The invitation has no targeted job, so the template could not be built. */
    AdminEmployerInvitationEmailSendStatus["NoTargetJob"] = "NO_TARGET_JOB";
    /** Email dispatched successfully. */
    AdminEmployerInvitationEmailSendStatus["Sent"] = "SENT";
})(AdminEmployerInvitationEmailSendStatus || (AdminEmployerInvitationEmailSendStatus = {}));
/** Columns the employer-invitation email list can be sorted by. */
export var AdminEmployerInvitationEmailSortField;
(function (AdminEmployerInvitationEmailSortField) {
    /** Indeed advertiser id of the employer the email belongs to. */
    AdminEmployerInvitationEmailSortField["AdvertiserId"] = "ADVERTISER_ID";
    /** When the email record was created (the default; newest first when descending). */
    AdminEmployerInvitationEmailSortField["CreatedAt"] = "CREATED_AT";
    /** Lifecycle status of the email. */
    AdminEmployerInvitationEmailSortField["Status"] = "STATUS";
})(AdminEmployerInvitationEmailSortField || (AdminEmployerInvitationEmailSortField = {}));
/** Lifecycle status of an employer-invitation outreach email (mirrors the persisted email status). */
export var AdminEmployerInvitationEmailStatus;
(function (AdminEmployerInvitationEmailStatus) {
    /** An admin cancelled a scheduled send before it fired. */
    AdminEmployerInvitationEmailStatus["Cancelled"] = "CANCELLED";
    /** A scheduled send was overdue beyond the grace window and was never sent. */
    AdminEmployerInvitationEmailStatus["Expired"] = "EXPIRED";
    /** A scheduled send fired but failed. */
    AdminEmployerInvitationEmailStatus["Failed"] = "FAILED";
    /** A future send awaiting its scheduled time; the one active (cancellable) state. */
    AdminEmployerInvitationEmailStatus["Scheduled"] = "SCHEDULED";
    /** The email was dispatched. */
    AdminEmployerInvitationEmailStatus["Sent"] = "SENT";
})(AdminEmployerInvitationEmailStatus || (AdminEmployerInvitationEmailStatus = {}));
/** The employer-invitation outreach lifecycle stage of a targeted job's employer. */
export var AdminEmployerOutreachStage;
(function (AdminEmployerOutreachStage) {
    /** The employer declined the invitation. */
    AdminEmployerOutreachStage["Declined"] = "DECLINED";
    /** The employer onboarded (created an RP account). */
    AdminEmployerOutreachStage["Onboarded"] = "ONBOARDED";
    /** At least one outreach email has been sent. */
    AdminEmployerOutreachStage["OutreachSent"] = "OUTREACH_SENT";
    /** Targeted but no outreach email sent yet. */
    AdminEmployerOutreachStage["Targeted"] = "TARGETED";
})(AdminEmployerOutreachStage || (AdminEmployerOutreachStage = {}));
/** Lifecycle status of an employer-targeting batch run. */
export var AdminEmployerTargetingBatchStatus;
(function (AdminEmployerTargetingBatchStatus) {
    /** The run finished successfully; its snapshot counts are final. */
    AdminEmployerTargetingBatchStatus["Completed"] = "COMPLETED";
    /** The run failed (or was abandoned by a crash and reclaimed); its counts are not meaningful. */
    AdminEmployerTargetingBatchStatus["Failed"] = "FAILED";
    /** The run is in progress; its counts are not final yet. */
    AdminEmployerTargetingBatchStatus["Running"] = "RUNNING";
})(AdminEmployerTargetingBatchStatus || (AdminEmployerTargetingBatchStatus = {}));
/** How an employer-targeting batch run was triggered. */
export var AdminEmployerTargetingBatchTriggerSource;
(function (AdminEmployerTargetingBatchTriggerSource) {
    /** Started by an admin via the adminRunEmployerTargeting mutation. */
    AdminEmployerTargetingBatchTriggerSource["Manual"] = "MANUAL";
    /** Started automatically by the daily scheduled targeting job. */
    AdminEmployerTargetingBatchTriggerSource["Scheduled"] = "SCHEDULED";
})(AdminEmployerTargetingBatchTriggerSource || (AdminEmployerTargetingBatchTriggerSource = {}));
/** Outcome of attempting to hide a single employer. */
export var AdminHideEmployerStatus;
(function (AdminHideEmployerStatus) {
    /** The employer was already hidden; no change. */
    AdminHideEmployerStatus["AlreadyHidden"] = "ALREADY_HIDDEN";
    /** The employer was newly hidden. */
    AdminHideEmployerStatus["Hidden"] = "HIDDEN";
    /** No employer (invitation) exists for the requested advertiser id. */
    AdminHideEmployerStatus["NotFound"] = "NOT_FOUND";
})(AdminHideEmployerStatus || (AdminHideEmployerStatus = {}));
/** Outcome of requesting a manual employer targeting run. */
export var AdminRunEmployerTargetingStatus;
(function (AdminRunEmployerTargetingStatus) {
    /** A targeting run (manual or scheduled) is already in progress; no new run was started. */
    AdminRunEmployerTargetingStatus["AlreadyRunning"] = "ALREADY_RUNNING";
    /** A targeting run was started asynchronously. */
    AdminRunEmployerTargetingStatus["Started"] = "STARTED";
    /** Targeting is not available in this environment (Trino not configured). */
    AdminRunEmployerTargetingStatus["Unavailable"] = "UNAVAILABLE";
})(AdminRunEmployerTargetingStatus || (AdminRunEmployerTargetingStatus = {}));
/**
 * Sortable columns for the cross-batch Targeted Employers list. activeJobCount is intentionally absent —
 * it is resolved live from the Job Audit service, not the database, so it cannot be a server-side sort key.
 */
export var AdminTargetedEmployerSortField;
(function (AdminTargetedEmployerSortField) {
    /** The employer's advertiser id. */
    AdminTargetedEmployerSortField["AdvertiserId"] = "ADVERTISER_ID";
    /** The captured company (advertiser) name. */
    AdminTargetedEmployerSortField["CompanyName"] = "COMPANY_NAME";
    /** When the first outreach email was ever sent. */
    AdminTargetedEmployerSortField["InitialOutreachDate"] = "INITIAL_OUTREACH_DATE";
    /** When the most recent outreach email was sent. */
    AdminTargetedEmployerSortField["LastOutreachDate"] = "LAST_OUTREACH_DATE";
    /** The template used in the most recent send. */
    AdminTargetedEmployerSortField["LastTemplateName"] = "LAST_TEMPLATE_NAME";
    /** Date of the most recent batch that targeted the advertiser. */
    AdminTargetedEmployerSortField["LatestBatchDate"] = "LATEST_BATCH_DATE";
    /** Lifetime outreach emails sent to the advertiser. */
    AdminTargetedEmployerSortField["TotalEmailsSent"] = "TOTAL_EMAILS_SENT";
    /** Distinct jobs targeted across all batches. */
    AdminTargetedEmployerSortField["TotalJobs"] = "TOTAL_JOBS";
})(AdminTargetedEmployerSortField || (AdminTargetedEmployerSortField = {}));
/**
 * Fields the admin targeted-job list can be sorted by. Add a value here (and its column mapping in the
 * resolver) to expose a new sortable column — the rest of the sort plumbing is field-agnostic. Fields
 * resolved live from the Job Audit service (jobLifecycleStatus) or per-job email DataLoaders (emailSent,
 * per-job emailSentCount, lastEmailedAt) are intentionally absent — they are not database-backed sort keys.
 */
export var AdminTargetedJobSortField;
(function (AdminTargetedJobSortField) {
    /** The job's employer advertiser id (jobs group by employer). */
    AdminTargetedJobSortField["AdvertiserId"] = "ADVERTISER_ID";
    /** The advertiser type classification. */
    AdminTargetedJobSortField["AdvertiserType"] = "ADVERTISER_TYPE";
    /** The Indeed aggregated job id (aggJobId). */
    AdminTargetedJobSortField["AggJobId"] = "AGG_JOB_ID";
    /** The date of the batch the job was targeted in. */
    AdminTargetedJobSortField["DateTargeted"] = "DATE_TARGETED";
    /** The employer's lifetime outreach email count. */
    AdminTargetedJobSortField["EmployerEmailSentCount"] = "EMPLOYER_EMAIL_SENT_COUNT";
    /** When the employer was last emailed. */
    AdminTargetedJobSortField["EmployerLastEmailedAt"] = "EMPLOYER_LAST_EMAILED_AT";
    /** The employer's invitation lifecycle status. */
    AdminTargetedJobSortField["EmployerStatus"] = "EMPLOYER_STATUS";
    /** The job city. */
    AdminTargetedJobSortField["JobCity"] = "JOB_CITY";
    /** The job's monetization product. */
    AdminTargetedJobSortField["JobProduct"] = "JOB_PRODUCT";
    /** The captured job title. */
    AdminTargetedJobSortField["JobTitle"] = "JOB_TITLE";
    /** The level-1 occupation (industry) label. */
    AdminTargetedJobSortField["OccupationLevel_1"] = "OCCUPATION_LEVEL_1";
    /** The level-2 occupation (sub-industry) label. */
    AdminTargetedJobSortField["OccupationLevel_2"] = "OCCUPATION_LEVEL_2";
    /** The current sales team owning the advertiser. */
    AdminTargetedJobSortField["SalesTeam"] = "SALES_TEAM";
})(AdminTargetedJobSortField || (AdminTargetedJobSortField = {}));
/** Outcome of attempting to restore a single hidden employer. */
export var AdminUnhideEmployerStatus;
(function (AdminUnhideEmployerStatus) {
    /** No employer (invitation) exists for the requested advertiser id. */
    AdminUnhideEmployerStatus["NotFound"] = "NOT_FOUND";
    /** The employer was not hidden; no change. */
    AdminUnhideEmployerStatus["NotHidden"] = "NOT_HIDDEN";
    /** The employer was restored (un-hidden). */
    AdminUnhideEmployerStatus["Restored"] = "RESTORED";
})(AdminUnhideEmployerStatus || (AdminUnhideEmployerStatus = {}));
export var AdvertiserModerationEventType;
(function (AdvertiserModerationEventType) {
    AdvertiserModerationEventType["CreateJob"] = "CREATE_JOB";
    AdvertiserModerationEventType["DisabledAppeal"] = "DISABLED_APPEAL";
    AdvertiserModerationEventType["ModerationAction"] = "MODERATION_ACTION";
    AdvertiserModerationEventType["ModerationDecision"] = "MODERATION_DECISION";
    AdvertiserModerationEventType["SecondaryAccountLinked"] = "SECONDARY_ACCOUNT_LINKED";
    AdvertiserModerationEventType["ShowHostedJobsChange"] = "SHOW_HOSTED_JOBS_CHANGE";
    AdvertiserModerationEventType["VerificationCompleted"] = "VERIFICATION_COMPLETED";
})(AdvertiserModerationEventType || (AdvertiserModerationEventType = {}));
/** Adyen capability verification status from webhook. */
export var AdyenCapabilityVerificationStatusEnum;
(function (AdyenCapabilityVerificationStatusEnum) {
    AdyenCapabilityVerificationStatusEnum["Invalid"] = "INVALID";
    AdyenCapabilityVerificationStatusEnum["Pending"] = "PENDING";
    AdyenCapabilityVerificationStatusEnum["Rejected"] = "REJECTED";
    AdyenCapabilityVerificationStatusEnum["Valid"] = "VALID";
})(AdyenCapabilityVerificationStatusEnum || (AdyenCapabilityVerificationStatusEnum = {}));
/** Steps in the Adyen decommission pipeline. Order matches execution order. */
export var AdyenDecommissionStepEnum;
(function (AdyenDecommissionStepEnum) {
    AdyenDecommissionStepEnum["AccountHolderClosed"] = "ACCOUNT_HOLDER_CLOSED";
    AdyenDecommissionStepEnum["AgencyPersisted"] = "AGENCY_PERSISTED";
    AdyenDecommissionStepEnum["BalancesVerified"] = "BALANCES_VERIFIED";
    AdyenDecommissionStepEnum["BalanceAccountsClosed"] = "BALANCE_ACCOUNTS_CLOSED";
    AdyenDecommissionStepEnum["LogPersisted"] = "LOG_PERSISTED";
    AdyenDecommissionStepEnum["TransferInstrumentsDeleted"] = "TRANSFER_INSTRUMENTS_DELETED";
    AdyenDecommissionStepEnum["Validated"] = "VALIDATED";
})(AdyenDecommissionStepEnum || (AdyenDecommissionStepEnum = {}));
/** Billing terms available */
export var AgencyAdvertiserBillingTerms;
(function (AgencyAdvertiserBillingTerms) {
    AgencyAdvertiserBillingTerms["DueUponReceipt"] = "DUE_UPON_RECEIPT";
    AgencyAdvertiserBillingTerms["Net_15"] = "NET_15";
    AgencyAdvertiserBillingTerms["Net_30"] = "NET_30";
    AgencyAdvertiserBillingTerms["Net_45"] = "NET_45";
    AgencyAdvertiserBillingTerms["Net_60"] = "NET_60";
    AgencyAdvertiserBillingTerms["Net_90"] = "NET_90";
})(AgencyAdvertiserBillingTerms || (AgencyAdvertiserBillingTerms = {}));
/** Finance bypass enum */
export var AgencyAdvertiserFinanceIoBypass;
(function (AgencyAdvertiserFinanceIoBypass) {
    AgencyAdvertiserFinanceIoBypass["Active"] = "ACTIVE";
    AgencyAdvertiserFinanceIoBypass["Inactive"] = "INACTIVE";
})(AgencyAdvertiserFinanceIoBypass || (AgencyAdvertiserFinanceIoBypass = {}));
/** Payment methods available */
export var AgencyAdvertiserPaymentMethod;
(function (AgencyAdvertiserPaymentMethod) {
    AgencyAdvertiserPaymentMethod["Manual"] = "MANUAL";
    AgencyAdvertiserPaymentMethod["PostpayCc"] = "POSTPAY_CC";
    AgencyAdvertiserPaymentMethod["PostpayInvoice"] = "POSTPAY_INVOICE";
    AgencyAdvertiserPaymentMethod["PostpayIo"] = "POSTPAY_IO";
    AgencyAdvertiserPaymentMethod["PrepayInvoice"] = "PREPAY_INVOICE";
})(AgencyAdvertiserPaymentMethod || (AgencyAdvertiserPaymentMethod = {}));
export var AgencyVerificationStatusEnum;
(function (AgencyVerificationStatusEnum) {
    AgencyVerificationStatusEnum["Invalid"] = "INVALID";
    AgencyVerificationStatusEnum["NotStarted"] = "NOT_STARTED";
    AgencyVerificationStatusEnum["Pending"] = "PENDING";
    AgencyVerificationStatusEnum["Rejected"] = "REJECTED";
    AgencyVerificationStatusEnum["Verified"] = "VERIFIED";
})(AgencyVerificationStatusEnum || (AgencyVerificationStatusEnum = {}));
/** Status of the sourcing agent */
export var AgentStatus;
(function (AgentStatus) {
    /** Agent is enabled and actively sourcing */
    AgentStatus["Enabled"] = "ENABLED";
    /** Agent is paused and not sending outreaches */
    AgentStatus["Paused"] = "PAUSED";
})(AgentStatus || (AgentStatus = {}));
export var AggregateJobPostType;
(function (AggregateJobPostType) {
    AggregateJobPostType["FccId"] = "FCC_ID";
    /** Source name, provided with Job Sync API */
    AggregateJobPostType["Source"] = "SOURCE";
})(AggregateJobPostType || (AggregateJobPostType = {}));
/** Fields available for ordering AI Documents */
export var AiDocumentOrderField;
(function (AiDocumentOrderField) {
    AiDocumentOrderField["CreatedAt"] = "CREATED_AT";
    AiDocumentOrderField["UpdatedAt"] = "UPDATED_AT";
})(AiDocumentOrderField || (AiDocumentOrderField = {}));
/** Document visibility scope */
export var AiDocumentScope;
(function (AiDocumentScope) {
    /** Visible only to creating account */
    AiDocumentScope["Account"] = "ACCOUNT";
    /** Visible to all accounts in advertiser */
    AiDocumentScope["Advertiser"] = "ADVERTISER";
})(AiDocumentScope || (AiDocumentScope = {}));
/** Validation strictness level for JSON Schema validation */
export var AiDocumentValidationType;
(function (AiDocumentValidationType) {
    /** Lenient validation — warnings only */
    AiDocumentValidationType["Lenient"] = "LENIENT";
    /** No validation applied */
    AiDocumentValidationType["None"] = "NONE";
    /** Strict validation — errors reject the document */
    AiDocumentValidationType["Strict"] = "STRICT";
})(AiDocumentValidationType || (AiDocumentValidationType = {}));
/** Status of an AI content generation request */
export var AiGenerationResult;
(function (AiGenerationResult) {
    AiGenerationResult["Error"] = "ERROR";
    AiGenerationResult["Pending"] = "PENDING";
    AiGenerationResult["Success"] = "SUCCESS";
})(AiGenerationResult || (AiGenerationResult = {}));
export var AiInterviewDispositionEnum;
(function (AiInterviewDispositionEnum) {
    AiInterviewDispositionEnum["AwaitingReview"] = "AWAITING_REVIEW";
    AiInterviewDispositionEnum["Maybe"] = "MAYBE";
    AiInterviewDispositionEnum["No"] = "NO";
    AiInterviewDispositionEnum["Yes"] = "YES";
})(AiInterviewDispositionEnum || (AiInterviewDispositionEnum = {}));
/** The type of interaction for the interview configuration (text, voice, or video) */
export var AiInterviewInteractionType;
(function (AiInterviewInteractionType) {
    AiInterviewInteractionType["Text"] = "TEXT";
    AiInterviewInteractionType["Video"] = "VIDEO";
    AiInterviewInteractionType["Voice"] = "VOICE";
})(AiInterviewInteractionType || (AiInterviewInteractionType = {}));
/** The status of post-processing for the interview */
export var AiInterviewPostProcessingStatusEnum;
(function (AiInterviewPostProcessingStatusEnum) {
    AiInterviewPostProcessingStatusEnum["Completed"] = "COMPLETED";
    AiInterviewPostProcessingStatusEnum["Incomplete"] = "INCOMPLETE";
})(AiInterviewPostProcessingStatusEnum || (AiInterviewPostProcessingStatusEnum = {}));
export var AiInterviewScore;
(function (AiInterviewScore) {
    AiInterviewScore["Moderate"] = "MODERATE";
    AiInterviewScore["Strong"] = "STRONG";
    AiInterviewScore["Weak"] = "WEAK";
})(AiInterviewScore || (AiInterviewScore = {}));
export var AiInterviewScoreEnum;
(function (AiInterviewScoreEnum) {
    AiInterviewScoreEnum["Moderate"] = "MODERATE";
    AiInterviewScoreEnum["Strong"] = "STRONG";
    AiInterviewScoreEnum["Weak"] = "WEAK";
})(AiInterviewScoreEnum || (AiInterviewScoreEnum = {}));
export var AiInterviewState;
(function (AiInterviewState) {
    AiInterviewState["Completed"] = "COMPLETED";
    AiInterviewState["Started"] = "STARTED";
})(AiInterviewState || (AiInterviewState = {}));
export var AiInterviewStatusEnum;
(function (AiInterviewStatusEnum) {
    AiInterviewStatusEnum["AllStepsCompleted"] = "ALL_STEPS_COMPLETED";
    AiInterviewStatusEnum["BotEntered"] = "BOT_ENTERED";
    AiInterviewStatusEnum["Created"] = "CREATED";
    AiInterviewStatusEnum["Ended"] = "ENDED";
    AiInterviewStatusEnum["Error"] = "ERROR";
    AiInterviewStatusEnum["Initialized"] = "INITIALIZED";
    AiInterviewStatusEnum["InProgress"] = "IN_PROGRESS";
    AiInterviewStatusEnum["ManuallyClosed"] = "MANUALLY_CLOSED";
    AiInterviewStatusEnum["ParticipantEntered"] = "PARTICIPANT_ENTERED";
    AiInterviewStatusEnum["Registered"] = "REGISTERED";
    AiInterviewStatusEnum["Restart"] = "RESTART";
    AiInterviewStatusEnum["WatchdogError"] = "WATCHDOG_ERROR";
})(AiInterviewStatusEnum || (AiInterviewStatusEnum = {}));
export var AiInterviewTranscriptRole;
(function (AiInterviewTranscriptRole) {
    AiInterviewTranscriptRole["Interviewer"] = "INTERVIEWER";
    AiInterviewTranscriptRole["User"] = "USER";
})(AiInterviewTranscriptRole || (AiInterviewTranscriptRole = {}));
/** The type of interaction for the interview (text, voice, or video) */
export var AiInterviewType;
(function (AiInterviewType) {
    AiInterviewType["Text"] = "TEXT";
    AiInterviewType["Video"] = "VIDEO";
    AiInterviewType["Voice"] = "VOICE";
})(AiInterviewType || (AiInterviewType = {}));
export var AiJobManagementTaskStatus;
(function (AiJobManagementTaskStatus) {
    AiJobManagementTaskStatus["Cancelled"] = "CANCELLED";
    AiJobManagementTaskStatus["Completed"] = "COMPLETED";
    AiJobManagementTaskStatus["Failed"] = "FAILED";
    AiJobManagementTaskStatus["Working"] = "WORKING";
})(AiJobManagementTaskStatus || (AiJobManagementTaskStatus = {}));
export var AiMessagingEmployerIntent;
(function (AiMessagingEmployerIntent) {
    AiMessagingEmployerIntent["AssessFit"] = "ASSESS_FIT";
    AiMessagingEmployerIntent["ConfirmInterest"] = "CONFIRM_INTEREST";
    AiMessagingEmployerIntent["Decline"] = "DECLINE";
    AiMessagingEmployerIntent["FollowUp"] = "FOLLOW_UP";
    AiMessagingEmployerIntent["Interview"] = "INTERVIEW";
})(AiMessagingEmployerIntent || (AiMessagingEmployerIntent = {}));
export var AiMessagingEmployerTone;
(function (AiMessagingEmployerTone) {
    AiMessagingEmployerTone["BulletList"] = "BULLET_LIST";
    AiMessagingEmployerTone["Default"] = "DEFAULT";
    AiMessagingEmployerTone["Longer"] = "LONGER";
    AiMessagingEmployerTone["MoreCasual"] = "MORE_CASUAL";
    AiMessagingEmployerTone["MoreFormal"] = "MORE_FORMAL";
    AiMessagingEmployerTone["Shorter"] = "SHORTER";
})(AiMessagingEmployerTone || (AiMessagingEmployerTone = {}));
/** Spotlight pages sections enum */
export var Alignment;
(function (Alignment) {
    Alignment["Center"] = "CENTER";
    Alignment["Left"] = "LEFT";
    Alignment["Right"] = "RIGHT";
})(Alignment || (Alignment = {}));
/**  Alignment of Custom Content Data  */
export var AlignmentType;
(function (AlignmentType) {
    AlignmentType["Center"] = "CENTER";
    AlignmentType["Left"] = "LEFT";
    AlignmentType["Right"] = "RIGHT";
})(AlignmentType || (AlignmentType = {}));
export var AlternateCycle;
(function (AlternateCycle) {
    AlternateCycle["Childbirth"] = "CHILDBIRTH";
    AlternateCycle["Class"] = "CLASS";
    AlternateCycle["Contact"] = "CONTACT";
    AlternateCycle["ContactHour"] = "CONTACT_HOUR";
    AlternateCycle["CreditHour"] = "CREDIT_HOUR";
    AlternateCycle["Delivery"] = "DELIVERY";
    AlternateCycle["Event"] = "EVENT";
    AlternateCycle["FlightHour"] = "FLIGHT_HOUR";
    AlternateCycle["Game"] = "GAME";
    AlternateCycle["Gig"] = "GIG";
    AlternateCycle["Kilometer"] = "KILOMETER";
    AlternateCycle["Lesson"] = "LESSON";
    AlternateCycle["Mile"] = "MILE";
    AlternateCycle["Occasion"] = "OCCASION";
    AlternateCycle["Occurrence"] = "OCCURRENCE";
    AlternateCycle["Order"] = "ORDER";
    AlternateCycle["Point"] = "POINT";
    AlternateCycle["Referral"] = "REFERRAL";
    AlternateCycle["Sale"] = "SALE";
    AlternateCycle["Session"] = "SESSION";
    AlternateCycle["Shift"] = "SHIFT";
    AlternateCycle["Student"] = "STUDENT";
    AlternateCycle["Trip"] = "TRIP";
})(AlternateCycle || (AlternateCycle = {}));
/**
 * Represents the aggregation function applied to a metric field.
 * Used to describe how raw values are combined when grouping query results.
 */
export var AnalyticsAggregationType;
(function (AnalyticsAggregationType) {
    /** Approximates the count of distinct values. */
    AnalyticsAggregationType["ApproxCount"] = "APPROX_COUNT";
    /** Computes the arithmetic mean. */
    AnalyticsAggregationType["Avg"] = "AVG";
    /** Counts all non-null rows. */
    AnalyticsAggregationType["Count"] = "COUNT";
    /** Counts distinct non-null values. */
    AnalyticsAggregationType["CountDistinct"] = "COUNT_DISTINCT";
    /** Returns the largest value. */
    AnalyticsAggregationType["Max"] = "MAX";
    /** Returns the smallest value. */
    AnalyticsAggregationType["Min"] = "MIN";
    /** Represents a computed ratio between two values, such as a rate or percentage. */
    AnalyticsAggregationType["Ratio"] = "RATIO";
    /** Adds all values together. */
    AnalyticsAggregationType["Sum"] = "SUM";
})(AnalyticsAggregationType || (AnalyticsAggregationType = {}));
/**
 * Represents the data type of an analytics field, used by clients to determine
 * how to render or format field values.
 */
export var AnalyticsFieldDataType;
(function (AnalyticsFieldDataType) {
    /** A true/false value. */
    AnalyticsFieldDataType["Boolean"] = "BOOLEAN";
    /** A monetary value associated with a currency code. Corresponds to CurrencyAnalyticsMetricData. */
    AnalyticsFieldDataType["Currency"] = "CURRENCY";
    /** A calendar date value. */
    AnalyticsFieldDataType["Date"] = "DATE";
    /** A floating-point numeric value. */
    AnalyticsFieldDataType["Decimal"] = "DECIMAL";
    /** A whole number value. */
    AnalyticsFieldDataType["Integer"] = "INTEGER";
    /** A text value. */
    AnalyticsFieldDataType["String"] = "STRING";
    /** A date and time value. */
    AnalyticsFieldDataType["Timestamp"] = "TIMESTAMP";
})(AnalyticsFieldDataType || (AnalyticsFieldDataType = {}));
export var AnalyticsMetricsDataStringSupportedOperation;
(function (AnalyticsMetricsDataStringSupportedOperation) {
    AnalyticsMetricsDataStringSupportedOperation["Equals"] = "EQUALS";
    AnalyticsMetricsDataStringSupportedOperation["NotEquals"] = "NOT_EQUALS";
})(AnalyticsMetricsDataStringSupportedOperation || (AnalyticsMetricsDataStringSupportedOperation = {}));
export var AnalyticsMetricsDateSupportedOperation;
(function (AnalyticsMetricsDateSupportedOperation) {
    AnalyticsMetricsDateSupportedOperation["Equals"] = "EQUALS";
    AnalyticsMetricsDateSupportedOperation["GreaterThan"] = "GREATER_THAN";
    AnalyticsMetricsDateSupportedOperation["GreaterThanOrEqual"] = "GREATER_THAN_OR_EQUAL";
    AnalyticsMetricsDateSupportedOperation["LessThan"] = "LESS_THAN";
    AnalyticsMetricsDateSupportedOperation["LessThanOrEqual"] = "LESS_THAN_OR_EQUAL";
    AnalyticsMetricsDateSupportedOperation["NotEquals"] = "NOT_EQUALS";
    AnalyticsMetricsDateSupportedOperation["NotNull"] = "NOT_NULL";
})(AnalyticsMetricsDateSupportedOperation || (AnalyticsMetricsDateSupportedOperation = {}));
/** Supported comparison operators for numeric filters. */
export var AnalyticsMetricsNumericSupportedOperation;
(function (AnalyticsMetricsNumericSupportedOperation) {
    AnalyticsMetricsNumericSupportedOperation["Equals"] = "EQUALS";
    AnalyticsMetricsNumericSupportedOperation["GreaterThan"] = "GREATER_THAN";
    AnalyticsMetricsNumericSupportedOperation["GreaterThanOrEqual"] = "GREATER_THAN_OR_EQUAL";
    AnalyticsMetricsNumericSupportedOperation["IsNull"] = "IS_NULL";
    AnalyticsMetricsNumericSupportedOperation["LessThan"] = "LESS_THAN";
    AnalyticsMetricsNumericSupportedOperation["LessThanOrEqual"] = "LESS_THAN_OR_EQUAL";
    AnalyticsMetricsNumericSupportedOperation["NotEquals"] = "NOT_EQUALS";
    AnalyticsMetricsNumericSupportedOperation["NotNull"] = "NOT_NULL";
})(AnalyticsMetricsNumericSupportedOperation || (AnalyticsMetricsNumericSupportedOperation = {}));
/** Sort directions supported by analytics metrics. */
export var AnalyticsMetricsSortDirection;
(function (AnalyticsMetricsSortDirection) {
    /** Use ASCENDING for smallest-to-largest or A-Z ordering. */
    AnalyticsMetricsSortDirection["Ascending"] = "ASCENDING";
    /** Use DESCENDING for largest-to-smallest or Z-A ordering. */
    AnalyticsMetricsSortDirection["Descending"] = "DESCENDING";
})(AnalyticsMetricsSortDirection || (AnalyticsMetricsSortDirection = {}));
/** Supported comparison operators for string filters. */
export var AnalyticsMetricsStringSupportedOperation;
(function (AnalyticsMetricsStringSupportedOperation) {
    AnalyticsMetricsStringSupportedOperation["Contains"] = "CONTAINS";
    AnalyticsMetricsStringSupportedOperation["Equals"] = "EQUALS";
    AnalyticsMetricsStringSupportedOperation["IsNull"] = "IS_NULL";
    AnalyticsMetricsStringSupportedOperation["NotEquals"] = "NOT_EQUALS";
    AnalyticsMetricsStringSupportedOperation["NotNull"] = "NOT_NULL";
})(AnalyticsMetricsStringSupportedOperation || (AnalyticsMetricsStringSupportedOperation = {}));
export var AppealRejectAutoResponse;
(function (AppealRejectAutoResponse) {
    AppealRejectAutoResponse["AutoEnabled"] = "AUTO_ENABLED";
    AppealRejectAutoResponse["AutoRejected"] = "AUTO_REJECTED";
    AppealRejectAutoResponse["Manual"] = "MANUAL";
})(AppealRejectAutoResponse || (AppealRejectAutoResponse = {}));
/** Enum representing the different states a user appeal draft can be in */
export var AppealRejectionDraftStatus;
(function (AppealRejectionDraftStatus) {
    /** Status when there is no draft on record */
    AppealRejectionDraftStatus["None"] = "NONE";
    /** Status when a draft has been submitted and is pending scan */
    AppealRejectionDraftStatus["Pending"] = "PENDING";
    /** Status when a draft has been saved but not submitted */
    AppealRejectionDraftStatus["Saved"] = "SAVED";
    /** Status when a draft has been submitted and a zendesk ticket created (pending moderator review) */
    AppealRejectionDraftStatus["Submitted"] = "SUBMITTED";
})(AppealRejectionDraftStatus || (AppealRejectionDraftStatus = {}));
/** Enumeration for the type of user filling out an appeal rejection form */
export var AppealUserType;
(function (AppealUserType) {
    AppealUserType["BusinessOwner"] = "business_owner";
    AppealUserType["DirectEmployer"] = "direct_employer";
    AppealUserType["JobSeeker"] = "job_seeker";
    AppealUserType["NotRecruiter"] = "not_recruiter";
    AppealUserType["Other"] = "other";
    AppealUserType["Recruiter"] = "recruiter";
})(AppealUserType || (AppealUserType = {}));
/** Defines the status of an applicant-reported job application disposition */
export var ApplicantReportedDispositionType;
(function (ApplicantReportedDispositionType) {
    ApplicantReportedDispositionType["Applied"] = "APPLIED";
    ApplicantReportedDispositionType["Hired"] = "HIRED";
    ApplicantReportedDispositionType["Interviewing"] = "INTERVIEWING";
    ApplicantReportedDispositionType["Offered"] = "OFFERED";
    ApplicantReportedDispositionType["Rejected"] = "REJECTED";
})(ApplicantReportedDispositionType || (ApplicantReportedDispositionType = {}));
/** Enum defining frequency preferences for the application email settings */
export var ApplicationEmailFrequency;
(function (ApplicationEmailFrequency) {
    ApplicationEmailFrequency["AllApplications"] = "ALL_APPLICATIONS";
    ApplicationEmailFrequency["Bundling"] = "BUNDLING";
    ApplicationEmailFrequency["DailyOnly"] = "DAILY_ONLY";
    ApplicationEmailFrequency["None"] = "NONE";
})(ApplicationEmailFrequency || (ApplicationEmailFrequency = {}));
export var ApplicationEventType;
(function (ApplicationEventType) {
    ApplicationEventType["ApplicationSubmitted"] = "APPLICATION_SUBMITTED";
})(ApplicationEventType || (ApplicationEventType = {}));
/** Where AOAPI got the application from. Usage of these is more to increase performance. */
export var ApplicationOutcomeDataSourceType;
(function (ApplicationOutcomeDataSourceType) {
    /** Originally came from the dradis-events-exchange */
    ApplicationOutcomeDataSourceType["Dradis"] = "DRADIS";
    /** Originally came from the indeed-apply-submit-exchange */
    ApplicationOutcomeDataSourceType["IndeedApply"] = "INDEED_APPLY";
})(ApplicationOutcomeDataSourceType || (ApplicationOutcomeDataSourceType = {}));
/** Defines the application status state for the job */
export var ApplicationStatusState;
(function (ApplicationStatusState) {
    ApplicationStatusState["Applied"] = "APPLIED";
    ApplicationStatusState["Hired"] = "HIRED";
    ApplicationStatusState["Interview"] = "INTERVIEW";
    ApplicationStatusState["MaybeApplied"] = "MAYBE_APPLIED";
    ApplicationStatusState["NotInterested"] = "NOT_INTERESTED";
    ApplicationStatusState["Offer"] = "OFFER";
    ApplicationStatusState["Rejected"] = "REJECTED";
})(ApplicationStatusState || (ApplicationStatusState = {}));
/** The location type on which the Indeed Apply Button will be rendered. */
export var ApplyDomainEnum;
(function (ApplyDomainEnum) {
    ApplyDomainEnum["Indeed"] = "INDEED";
    ApplyDomainEnum["ThirdParty"] = "THIRD_PARTY";
})(ApplyDomainEnum || (ApplyDomainEnum = {}));
/** The location type on which the Indeed Apply form will be rendered. */
export var ApplyDomainProperty;
(function (ApplyDomainProperty) {
    ApplyDomainProperty["Indeed"] = "INDEED";
    ApplyDomainProperty["ThirdParty"] = "THIRD_PARTY";
})(ApplyDomainProperty || (ApplyDomainProperty = {}));
export var ApplyParametersApplyDomain;
(function (ApplyParametersApplyDomain) {
    ApplyParametersApplyDomain["Indeed"] = "INDEED";
    ApplyParametersApplyDomain["ThirdParty"] = "THIRD_PARTY";
})(ApplyParametersApplyDomain || (ApplyParametersApplyDomain = {}));
export var ApplyParametersIntegrationType;
(function (ApplyParametersIntegrationType) {
    ApplyParametersIntegrationType["Email"] = "EMAIL";
    ApplyParametersIntegrationType["PostCall"] = "POST_CALL";
})(ApplyParametersIntegrationType || (ApplyParametersIntegrationType = {}));
export var ApplyParametersNameFormat;
(function (ApplyParametersNameFormat) {
    ApplyParametersNameFormat["FirstLastName"] = "FIRST_LAST_NAME";
    ApplyParametersNameFormat["FullName"] = "FULL_NAME";
})(ApplyParametersNameFormat || (ApplyParametersNameFormat = {}));
export var ApplyParametersStandardFieldRequirement;
(function (ApplyParametersStandardFieldRequirement) {
    ApplyParametersStandardFieldRequirement["Hidden"] = "HIDDEN";
    ApplyParametersStandardFieldRequirement["Optional"] = "OPTIONAL";
    ApplyParametersStandardFieldRequirement["Required"] = "REQUIRED";
})(ApplyParametersStandardFieldRequirement || (ApplyParametersStandardFieldRequirement = {}));
export var ApplyPreviewErrorCode;
(function (ApplyPreviewErrorCode) {
    ApplyPreviewErrorCode["AccessDenied"] = "ACCESS_DENIED";
    ApplyPreviewErrorCode["AccountOwnershipChanged"] = "ACCOUNT_OWNERSHIP_CHANGED";
    ApplyPreviewErrorCode["ApplicationSizeTooBig"] = "APPLICATION_SIZE_TOO_BIG";
    ApplyPreviewErrorCode["AuthFailed"] = "AUTH_FAILED";
    ApplyPreviewErrorCode["BackendError"] = "BACKEND_ERROR";
    ApplyPreviewErrorCode["DraftUpdateFailed"] = "DRAFT_UPDATE_FAILED";
    ApplyPreviewErrorCode["EmailNotVerified"] = "EMAIL_NOT_VERIFIED";
    ApplyPreviewErrorCode["HasApplied"] = "HAS_APPLIED";
    ApplyPreviewErrorCode["InvalidRequest"] = "INVALID_REQUEST";
    ApplyPreviewErrorCode["InvalidResumeFileType"] = "INVALID_RESUME_FILE_TYPE";
    ApplyPreviewErrorCode["InvalidRezqInput"] = "INVALID_REZQ_INPUT";
    ApplyPreviewErrorCode["JobSeekerProfileFetchFailed"] = "JOB_SEEKER_PROFILE_FETCH_FAILED";
    ApplyPreviewErrorCode["LoggedOut"] = "LOGGED_OUT";
    ApplyPreviewErrorCode["ResumeFileTooLarge"] = "RESUME_FILE_TOO_LARGE";
    ApplyPreviewErrorCode["SqFileSizeTooBig"] = "SQ_FILE_SIZE_TOO_BIG";
    ApplyPreviewErrorCode["Unknown"] = "UNKNOWN";
})(ApplyPreviewErrorCode || (ApplyPreviewErrorCode = {}));
/** Question categories for Apply */
export var ApplyQuestionCategory;
(function (ApplyQuestionCategory) {
    ApplyQuestionCategory["Demographic"] = "DEMOGRAPHIC";
    ApplyQuestionCategory["Qualification"] = "QUALIFICATION";
    ApplyQuestionCategory["Screener"] = "SCREENER";
})(ApplyQuestionCategory || (ApplyQuestionCategory = {}));
export var ApplyResumeType;
(function (ApplyResumeType) {
    ApplyResumeType["IndeedProfile"] = "INDEED_PROFILE";
    ApplyResumeType["RecruitProfile"] = "RECRUIT_PROFILE";
    ApplyResumeType["SavedResume"] = "SAVED_RESUME";
    ApplyResumeType["TailoredResume"] = "TAILORED_RESUME";
    ApplyResumeType["UserUploaded"] = "USER_UPLOADED";
})(ApplyResumeType || (ApplyResumeType = {}));
export var ApplyStatus;
(function (ApplyStatus) {
    ApplyStatus["Error"] = "ERROR";
    ApplyStatus["Skipped"] = "SKIPPED";
    ApplyStatus["Submitted"] = "SUBMITTED";
})(ApplyStatus || (ApplyStatus = {}));
export var ApplyUrlLinkedClickTrackingKeyType;
(function (ApplyUrlLinkedClickTrackingKeyType) {
    ApplyUrlLinkedClickTrackingKeyType["BillableEventTrackingKey"] = "BILLABLE_EVENT_TRACKING_KEY";
    ApplyUrlLinkedClickTrackingKeyType["CustomizedTrackingKey"] = "CUSTOMIZED_TRACKING_KEY";
})(ApplyUrlLinkedClickTrackingKeyType || (ApplyUrlLinkedClickTrackingKeyType = {}));
export var ApprovalRequestInvoicePaymentStatus;
(function (ApprovalRequestInvoicePaymentStatus) {
    ApprovalRequestInvoicePaymentStatus["Credited"] = "CREDITED";
    ApprovalRequestInvoicePaymentStatus["Paid"] = "PAID";
    ApprovalRequestInvoicePaymentStatus["PartiallyPaid"] = "PARTIALLY_PAID";
    ApprovalRequestInvoicePaymentStatus["Unknown"] = "UNKNOWN";
    ApprovalRequestInvoicePaymentStatus["Unpaid"] = "UNPAID";
})(ApprovalRequestInvoicePaymentStatus || (ApprovalRequestInvoicePaymentStatus = {}));
/** Represents the type of operation associated with the approval request */
export var ApprovalRequestOperationType;
(function (ApprovalRequestOperationType) {
    /** Indicates that no process was executed */
    ApprovalRequestOperationType["NotApplicable"] = "NOT_APPLICABLE";
    /** Indicates that the refund was processed automatically without human intervention */
    ApprovalRequestOperationType["PostAdjustmentAutomated"] = "POST_ADJUSTMENT_AUTOMATED";
    /** Indicates that the refund was processed manually, requiring human intervention to review and complete the refund */
    ApprovalRequestOperationType["PostAdjustmentManual"] = "POST_ADJUSTMENT_MANUAL";
})(ApprovalRequestOperationType || (ApprovalRequestOperationType = {}));
/** Indicates the category of the case created during the manual refund process */
export var ApproveApprovalRequestCaseType;
(function (ApproveApprovalRequestCaseType) {
    /** Credit Category for a case */
    ApproveApprovalRequestCaseType["Credit"] = "CREDIT";
    /** Refund Category for a case */
    ApproveApprovalRequestCaseType["Refund"] = "REFUND";
})(ApproveApprovalRequestCaseType || (ApproveApprovalRequestCaseType = {}));
/** Why a chosen approver may not approve a subscription invoice refund. */
export var ApproverIneligibilityReason;
(function (ApproverIneligibilityReason) {
    /** The approver's refund limit is below the requested amount. */
    ApproverIneligibilityReason["LimitExceeded"] = "LIMIT_EXCEEDED";
    /** The approver is not in a manager-or-above group authorized to approve. */
    ApproverIneligibilityReason["NotManager"] = "NOT_MANAGER";
})(ApproverIneligibilityReason || (ApproverIneligibilityReason = {}));
/**  Types of products for an advertiser  */
export var ArAdvertiserProduct;
(function (ArAdvertiserProduct) {
    ArAdvertiserProduct["BrandedAds"] = "BRANDED_ADS";
    ArAdvertiserProduct["Interviews"] = "INTERVIEWS";
    ArAdvertiserProduct["Jobs"] = "JOBS";
    ArAdvertiserProduct["Resume"] = "RESUME";
    ArAdvertiserProduct["UnifiedSourcing"] = "UNIFIED_SOURCING";
})(ArAdvertiserProduct || (ArAdvertiserProduct = {}));
/**  Types of purchased products for an advertiser  */
export var ArAdvertiserPurchasedProduct;
(function (ArAdvertiserPurchasedProduct) {
    ArAdvertiserPurchasedProduct["BrandedAds"] = "BRANDED_ADS";
    ArAdvertiserPurchasedProduct["Interviews"] = "INTERVIEWS";
    ArAdvertiserPurchasedProduct["Jobs"] = "JOBS";
    ArAdvertiserPurchasedProduct["Resume"] = "RESUME";
    ArAdvertiserPurchasedProduct["UnifiedSourcing"] = "UNIFIED_SOURCING";
})(ArAdvertiserPurchasedProduct || (ArAdvertiserPurchasedProduct = {}));
/** AskemLogEventType is the type of log (aka logType) being sent to LogRepo */
export var AskemLogEventType;
(function (AskemLogEventType) {
    AskemLogEventType["AskemErrorTrackEvent"] = "askemErrorTrackEvent";
    AskemLogEventType["AskemImpressionTrackEvent"] = "askemImpressionTrackEvent";
    AskemLogEventType["AskemPreSurveyImpressionTrackEvent"] = "askemPreSurveyImpressionTrackEvent";
    AskemLogEventType["AskemPreSurveyResultTrackEvent"] = "askemPreSurveyResultTrackEvent";
    AskemLogEventType["AskemResultTrackEvent"] = "askemResultTrackEvent";
    AskemLogEventType["AskemTriggerTrackEvent"] = "askemTriggerTrackEvent";
})(AskemLogEventType || (AskemLogEventType = {}));
/** Variants of the Assessment optimization */
export var AssessmentOptimizationVariant;
(function (AssessmentOptimizationVariant) {
    /** @deprecated Assessment optimization is deprecated */
    AssessmentOptimizationVariant["AssessmentOptimizationVariantDefault"] = "ASSESSMENT_OPTIMIZATION_VARIANT_DEFAULT";
})(AssessmentOptimizationVariant || (AssessmentOptimizationVariant = {}));
/** Available assessment type for the assessment step */
export var AssessmentType;
(function (AssessmentType) {
    AssessmentType["Numeric"] = "NUMERIC";
    AssessmentType["Scored"] = "SCORED";
})(AssessmentType || (AssessmentType = {}));
/** Represents the different kinds of ATS_SYNC integrations in terms of the connection method with an Employer */
export var AtsIntegrationMethodKind;
(function (AtsIntegrationMethodKind) {
    AtsIntegrationMethodKind["Api"] = "API";
    AtsIntegrationMethodKind["PartnerBuiltApi"] = "PARTNER_BUILT_API";
    AtsIntegrationMethodKind["Xml"] = "XML";
})(AtsIntegrationMethodKind || (AtsIntegrationMethodKind = {}));
/** The possible overall install states an integration can be in */
export var AtsIntegrationModelInstallStatusKind;
(function (AtsIntegrationModelInstallStatusKind) {
    /** The user has completed the install process and the integration should be active. There could still be configuration issues etc, see status details for more information */
    AtsIntegrationModelInstallStatusKind["Installed"] = "INSTALLED";
    /** The user has started the process of installing but the integration is not fully ready yet. */
    AtsIntegrationModelInstallStatusKind["InProgress"] = "IN_PROGRESS";
    /** The integration is not currently installed and the user hasn't starting installing */
    AtsIntegrationModelInstallStatusKind["NotInstalled"] = "NOT_INSTALLED";
    /** The integration was previosuly installed and is either disabled pending removal/deletion or has recently be uninstalled */
    AtsIntegrationModelInstallStatusKind["Uninstalled"] = "UNINSTALLED";
})(AtsIntegrationModelInstallStatusKind || (AtsIntegrationModelInstallStatusKind = {}));
/** Status that represents the overall ATS Sync status */
export var AtsLinkStatusKind;
(function (AtsLinkStatusKind) {
    /** The link is working properly and data can flow through it */
    AtsLinkStatusKind["Active"] = "ACTIVE";
    /** The link is broken. Pipelines using this link cannot move any data. */
    AtsLinkStatusKind["Broken"] = "BROKEN";
    /**
     * The link requires additional configuration in order to
     * activate
     */
    AtsLinkStatusKind["ConfigurationRequired"] = "CONFIGURATION_REQUIRED";
    /** The link is disabled. Data cannot flow through it */
    AtsLinkStatusKind["Disabled"] = "DISABLED";
    /** The link is in an unknown state */
    AtsLinkStatusKind["Indeterminate"] = "INDETERMINATE";
    /** The ATS rejected the provided credentials */
    AtsLinkStatusKind["InvalidCredentials"] = "INVALID_CREDENTIALS";
    /** The link requires a user to login */
    AtsLinkStatusKind["LoginRequired"] = "LOGIN_REQUIRED";
    /**
     * The link is pending to be deleted after it completes any
     * pending work
     */
    AtsLinkStatusKind["PendingDelete"] = "PENDING_DELETE";
    /** The link will be disabled after completes any pending work */
    AtsLinkStatusKind["PendingDisable"] = "PENDING_DISABLE";
    /** The state is relevant Indeed Apply Sync setup state when the setup is in review */
    AtsLinkStatusKind["PendingReview"] = "PENDING_REVIEW";
    /** The link configuration is being validated */
    AtsLinkStatusKind["PendingValidation"] = "PENDING_VALIDATION";
})(AtsLinkStatusKind || (AtsLinkStatusKind = {}));
/** Scope at which an ATS role applies */
export var AtsRoleScope;
(function (AtsRoleScope) {
    /** Role applies at the account/system level (Kombo SYSTEM) */
    AtsRoleScope["Account"] = "ACCOUNT";
    /** Role applies at the job level (Kombo JOB) */
    AtsRoleScope["Job"] = "JOB";
})(AtsRoleScope || (AtsRoleScope = {}));
/** Enumerations for application attachment checksum algorithm. */
export var AtsSyncCandidateSyncApplicationAttachmentChecksumAlgorithm;
(function (AtsSyncCandidateSyncApplicationAttachmentChecksumAlgorithm) {
    /** MD5 hashing algorithm. */
    AtsSyncCandidateSyncApplicationAttachmentChecksumAlgorithm["Md5"] = "MD5";
})(AtsSyncCandidateSyncApplicationAttachmentChecksumAlgorithm || (AtsSyncCandidateSyncApplicationAttachmentChecksumAlgorithm = {}));
/** Enumerations for application attachment checksum algorithms. */
export var AtsSyncCandidateSyncApplicationAttachmentChecksumAlgorithmInput;
(function (AtsSyncCandidateSyncApplicationAttachmentChecksumAlgorithmInput) {
    /** MD5 hashing algorithm. */
    AtsSyncCandidateSyncApplicationAttachmentChecksumAlgorithmInput["Md5"] = "MD5";
})(AtsSyncCandidateSyncApplicationAttachmentChecksumAlgorithmInput || (AtsSyncCandidateSyncApplicationAttachmentChecksumAlgorithmInput = {}));
/** Enumerations for application attachment checksum format. */
export var AtsSyncCandidateSyncApplicationAttachmentChecksumFormat;
(function (AtsSyncCandidateSyncApplicationAttachmentChecksumFormat) {
    /**
     * Base64 encoding format.
     *
     * Checksum bytes are encoded as a Base64 string.
     */
    AtsSyncCandidateSyncApplicationAttachmentChecksumFormat["Base64"] = "BASE64";
})(AtsSyncCandidateSyncApplicationAttachmentChecksumFormat || (AtsSyncCandidateSyncApplicationAttachmentChecksumFormat = {}));
/** Enumerations for application attachment checksum formats. */
export var AtsSyncCandidateSyncApplicationAttachmentChecksumFormatInput;
(function (AtsSyncCandidateSyncApplicationAttachmentChecksumFormatInput) {
    /** Base64 encoding format. Raw checksum bytes are encoded as a Base64 string. */
    AtsSyncCandidateSyncApplicationAttachmentChecksumFormatInput["Base64"] = "BASE64";
})(AtsSyncCandidateSyncApplicationAttachmentChecksumFormatInput || (AtsSyncCandidateSyncApplicationAttachmentChecksumFormatInput = {}));
/** How the data was modified. */
export var AtsSyncCandidateSyncApplicationDataModificationAction;
(function (AtsSyncCandidateSyncApplicationDataModificationAction) {
    /** Data was masked or replaced (for example, PII removed). */
    AtsSyncCandidateSyncApplicationDataModificationAction["Redacted"] = "REDACTED";
    /** Data was entirely omitted or discarded. */
    AtsSyncCandidateSyncApplicationDataModificationAction["Removed"] = "REMOVED";
    /** Data was shortened to fit a length limit. */
    AtsSyncCandidateSyncApplicationDataModificationAction["Truncated"] = "TRUNCATED";
})(AtsSyncCandidateSyncApplicationDataModificationAction || (AtsSyncCandidateSyncApplicationDataModificationAction = {}));
/** How the data was modified. */
export var AtsSyncCandidateSyncApplicationDataModificationActionInput;
(function (AtsSyncCandidateSyncApplicationDataModificationActionInput) {
    /** Data was masked or replaced (for example, PII removed). */
    AtsSyncCandidateSyncApplicationDataModificationActionInput["Redacted"] = "REDACTED";
    /** Data was entirely omitted or discarded. */
    AtsSyncCandidateSyncApplicationDataModificationActionInput["Removed"] = "REMOVED";
    /** Data was shortened to fit a length limit. */
    AtsSyncCandidateSyncApplicationDataModificationActionInput["Truncated"] = "TRUNCATED";
})(AtsSyncCandidateSyncApplicationDataModificationActionInput || (AtsSyncCandidateSyncApplicationDataModificationActionInput = {}));
/** Why the data was modified. */
export var AtsSyncCandidateSyncApplicationDataModificationReason;
(function (AtsSyncCandidateSyncApplicationDataModificationReason) {
    /** Source data was invalid, malformed, or corrupt. */
    AtsSyncCandidateSyncApplicationDataModificationReason["InvalidData"] = "INVALID_DATA";
    /** Reason not covered by the other values; additional context can be provided in the `details` field. */
    AtsSyncCandidateSyncApplicationDataModificationReason["Other"] = "OTHER";
    /** Withheld for privacy, consent, or compliance reasons. */
    AtsSyncCandidateSyncApplicationDataModificationReason["PrivacyOrConsent"] = "PRIVACY_OR_CONSENT";
    /** Exceeded a per-item size limit (for example, an attachment too large). */
    AtsSyncCandidateSyncApplicationDataModificationReason["SizeLimitExceeded"] = "SIZE_LIMIT_EXCEEDED";
})(AtsSyncCandidateSyncApplicationDataModificationReason || (AtsSyncCandidateSyncApplicationDataModificationReason = {}));
/** Why the data was modified. */
export var AtsSyncCandidateSyncApplicationDataModificationReasonInput;
(function (AtsSyncCandidateSyncApplicationDataModificationReasonInput) {
    /** Source data was invalid, malformed, or corrupt. */
    AtsSyncCandidateSyncApplicationDataModificationReasonInput["InvalidData"] = "INVALID_DATA";
    /** Reason not covered by the other values; additional context can be provided in the `details` field. */
    AtsSyncCandidateSyncApplicationDataModificationReasonInput["Other"] = "OTHER";
    /** Withheld for privacy, consent, or compliance reasons. */
    AtsSyncCandidateSyncApplicationDataModificationReasonInput["PrivacyOrConsent"] = "PRIVACY_OR_CONSENT";
    /** Exceeded a per-item size limit (for example, an attachment too large). */
    AtsSyncCandidateSyncApplicationDataModificationReasonInput["SizeLimitExceeded"] = "SIZE_LIMIT_EXCEEDED";
})(AtsSyncCandidateSyncApplicationDataModificationReasonInput || (AtsSyncCandidateSyncApplicationDataModificationReasonInput = {}));
/** Which part of the application was modified. */
export var AtsSyncCandidateSyncApplicationDataModificationTarget;
(function (AtsSyncCandidateSyncApplicationDataModificationTarget) {
    /** Applicant contact information, such as email, phone, or address. */
    AtsSyncCandidateSyncApplicationDataModificationTarget["ApplicantContactInfo"] = "APPLICANT_CONTACT_INFO";
    /** A file attachment on the application. */
    AtsSyncCandidateSyncApplicationDataModificationTarget["Attachment"] = "ATTACHMENT";
    /** Applicant education history. */
    AtsSyncCandidateSyncApplicationDataModificationTarget["Education"] = "EDUCATION";
    /** A part of the application not covered by the other values; additional context can be provided in the `details` field. */
    AtsSyncCandidateSyncApplicationDataModificationTarget["Other"] = "OTHER";
    /** Screener questions and answers. */
    AtsSyncCandidateSyncApplicationDataModificationTarget["QuestionsAndAnswers"] = "QUESTIONS_AND_ANSWERS";
    /** Applicant work experience. */
    AtsSyncCandidateSyncApplicationDataModificationTarget["WorkExperience"] = "WORK_EXPERIENCE";
})(AtsSyncCandidateSyncApplicationDataModificationTarget || (AtsSyncCandidateSyncApplicationDataModificationTarget = {}));
/** Which part of the application was modified. */
export var AtsSyncCandidateSyncApplicationDataModificationTargetInput;
(function (AtsSyncCandidateSyncApplicationDataModificationTargetInput) {
    /** Applicant contact information, such as email, phone, or address. */
    AtsSyncCandidateSyncApplicationDataModificationTargetInput["ApplicantContactInfo"] = "APPLICANT_CONTACT_INFO";
    /** A file attachment on the application. */
    AtsSyncCandidateSyncApplicationDataModificationTargetInput["Attachment"] = "ATTACHMENT";
    /** Applicant education history. */
    AtsSyncCandidateSyncApplicationDataModificationTargetInput["Education"] = "EDUCATION";
    /** A part of the application not covered by the other values; additional context can be provided in the `details` field. */
    AtsSyncCandidateSyncApplicationDataModificationTargetInput["Other"] = "OTHER";
    /** Screener questions and answers. */
    AtsSyncCandidateSyncApplicationDataModificationTargetInput["QuestionsAndAnswers"] = "QUESTIONS_AND_ANSWERS";
    /** Applicant work experience. */
    AtsSyncCandidateSyncApplicationDataModificationTargetInput["WorkExperience"] = "WORK_EXPERIENCE";
})(AtsSyncCandidateSyncApplicationDataModificationTargetInput || (AtsSyncCandidateSyncApplicationDataModificationTargetInput = {}));
export var AtsSyncCandidateSyncApplicationErrorType;
(function (AtsSyncCandidateSyncApplicationErrorType) {
    /** One or more question / answer sets was not imported */
    AtsSyncCandidateSyncApplicationErrorType["AllQuestionsAnswersNotImported"] = "ALL_QUESTIONS_ANSWERS_NOT_IMPORTED";
    /** One or more of the files attached to the application failed a virus scan */
    AtsSyncCandidateSyncApplicationErrorType["FileContainedVirus"] = "FILE_CONTAINED_VIRUS";
    /** One or more of the files attached to an application was not uploaded to the presigned S3 URL prior to submission of the application. */
    AtsSyncCandidateSyncApplicationErrorType["FileNotUploaded"] = "FILE_NOT_UPLOADED";
    /** An error was encountered by Indeed during publishing */
    AtsSyncCandidateSyncApplicationErrorType["InternalPublishingError"] = "INTERNAL_PUBLISHING_ERROR";
    /**
     * Partner reported during initialization that the provided data had been modified (partially removed, truncated,
     * or redacted)
     */
    AtsSyncCandidateSyncApplicationErrorType["PartnerReportedModification"] = "PARTNER_REPORTED_MODIFICATION";
})(AtsSyncCandidateSyncApplicationErrorType || (AtsSyncCandidateSyncApplicationErrorType = {}));
/** Enumerations for application file types. */
export var AtsSyncCandidateSyncApplicationFileType;
(function (AtsSyncCandidateSyncApplicationFileType) {
    /** Primary cover letter attachment on the application. */
    AtsSyncCandidateSyncApplicationFileType["CoverLetter"] = "COVER_LETTER";
    /** Uncategorized additional attachment on the application. */
    AtsSyncCandidateSyncApplicationFileType["Other"] = "OTHER";
    /** Additional cover letter attachment on the application. */
    AtsSyncCandidateSyncApplicationFileType["OtherCoverLetter"] = "OTHER_COVER_LETTER";
    /** Additional resume attachment on the application. */
    AtsSyncCandidateSyncApplicationFileType["OtherResume"] = "OTHER_RESUME";
    /** Primary resume attachment on the application. */
    AtsSyncCandidateSyncApplicationFileType["Resume"] = "RESUME";
})(AtsSyncCandidateSyncApplicationFileType || (AtsSyncCandidateSyncApplicationFileType = {}));
/** Enumerations for application file types. */
export var AtsSyncCandidateSyncApplicationFileTypeInput;
(function (AtsSyncCandidateSyncApplicationFileTypeInput) {
    /** Primary cover letter attached to an application. */
    AtsSyncCandidateSyncApplicationFileTypeInput["CoverLetter"] = "COVER_LETTER";
    /** Uncategorized additional attachment on an application. */
    AtsSyncCandidateSyncApplicationFileTypeInput["Other"] = "OTHER";
    /** Additional cover letter attached to an application. */
    AtsSyncCandidateSyncApplicationFileTypeInput["OtherCoverLetter"] = "OTHER_COVER_LETTER";
    /** Additional resume attached to an application. */
    AtsSyncCandidateSyncApplicationFileTypeInput["OtherResume"] = "OTHER_RESUME";
    /** Primary resume for the application. */
    AtsSyncCandidateSyncApplicationFileTypeInput["Resume"] = "RESUME";
})(AtsSyncCandidateSyncApplicationFileTypeInput || (AtsSyncCandidateSyncApplicationFileTypeInput = {}));
export var AtsSyncCandidateSyncApplicationProcessingStatusType;
(function (AtsSyncCandidateSyncApplicationProcessingStatusType) {
    /** Application has been deleted */
    AtsSyncCandidateSyncApplicationProcessingStatusType["Deleted"] = "DELETED";
    /** Deletion of an application failed to process successfully */
    AtsSyncCandidateSyncApplicationProcessingStatusType["DeletionFailed"] = "DELETION_FAILED";
    /** Processing of an application completed without error */
    AtsSyncCandidateSyncApplicationProcessingStatusType["ImportCompletedSuccessfully"] = "IMPORT_COMPLETED_SUCCESSFULLY";
    /** Processing of an application completed with non-critical errors. Inspect the `errors` for additional information. */
    AtsSyncCandidateSyncApplicationProcessingStatusType["ImportCompletedWithErrors"] = "IMPORT_COMPLETED_WITH_ERRORS";
    /** Processing of an application completed unsuccessfully with critical errors. Inspect the `errors` for additional information. */
    AtsSyncCandidateSyncApplicationProcessingStatusType["ImportFailed"] = "IMPORT_FAILED";
})(AtsSyncCandidateSyncApplicationProcessingStatusType || (AtsSyncCandidateSyncApplicationProcessingStatusType = {}));
/** Enumerations for application version status types. */
export var AtsSyncCandidateSyncApplicationVersionStatusType;
(function (AtsSyncCandidateSyncApplicationVersionStatusType) {
    /** Application submitted for deletion. Processing status is available once deletion completes. */
    AtsSyncCandidateSyncApplicationVersionStatusType["Deleted"] = "DELETED";
    /** Application initialized. No processing status is available until the application is submitted. */
    AtsSyncCandidateSyncApplicationVersionStatusType["Initialized"] = "INITIALIZED";
    /** Application submitted. Processing status is available once publishing completes. */
    AtsSyncCandidateSyncApplicationVersionStatusType["Submitted"] = "SUBMITTED";
})(AtsSyncCandidateSyncApplicationVersionStatusType || (AtsSyncCandidateSyncApplicationVersionStatusType = {}));
/** Enumerations for application version status input. */
export var AtsSyncCandidateSyncApplicationVersionStatusTypeInput;
(function (AtsSyncCandidateSyncApplicationVersionStatusTypeInput) {
    /** Application submitted for deletion. Processing status is available once deletion completes. */
    AtsSyncCandidateSyncApplicationVersionStatusTypeInput["Deleted"] = "DELETED";
    /** Application initialized. No processing status is available until the application is submitted. */
    AtsSyncCandidateSyncApplicationVersionStatusTypeInput["Initialized"] = "INITIALIZED";
    /** Application submitted. Processing status is available once publishing completes. */
    AtsSyncCandidateSyncApplicationVersionStatusTypeInput["Submitted"] = "SUBMITTED";
})(AtsSyncCandidateSyncApplicationVersionStatusTypeInput || (AtsSyncCandidateSyncApplicationVersionStatusTypeInput = {}));
/** Enumerations for work authorization types. */
export var AtsSyncCandidateSyncApplicationWorkAuthorizationType;
(function (AtsSyncCandidateSyncApplicationWorkAuthorizationType) {
    /** Singapore citizen. */
    AtsSyncCandidateSyncApplicationWorkAuthorizationType["SgCitizen"] = "SG_CITIZEN";
    /** Singapore Employment Pass holder. */
    AtsSyncCandidateSyncApplicationWorkAuthorizationType["SgEmploymentPass"] = "SG_EMPLOYMENT_PASS";
    /** Other Singapore work authorization. */
    AtsSyncCandidateSyncApplicationWorkAuthorizationType["SgOther"] = "SG_OTHER";
    /** Authorized to work in Singapore with employer sponsorship. */
    AtsSyncCandidateSyncApplicationWorkAuthorizationType["SgSponsorship"] = "SG_SPONSORSHIP";
    /** Singapore Training Employment Pass holder. */
    AtsSyncCandidateSyncApplicationWorkAuthorizationType["SgTrainingEmploymentPass"] = "SG_TRAINING_EMPLOYMENT_PASS";
    /** Unknown or unspecified authorization type. */
    AtsSyncCandidateSyncApplicationWorkAuthorizationType["UnknownAuthorization"] = "UNKNOWN_AUTHORIZATION";
    /** Authorized to work in the US for any employer. */
    AtsSyncCandidateSyncApplicationWorkAuthorizationType["UsEligible"] = "US_ELIGIBLE";
    /** Authorized to work in the US with employer sponsorship. */
    AtsSyncCandidateSyncApplicationWorkAuthorizationType["UsWithSponsorship"] = "US_WITH_SPONSORSHIP";
    /** Authorized to work in the specified country. */
    AtsSyncCandidateSyncApplicationWorkAuthorizationType["Yes"] = "YES";
})(AtsSyncCandidateSyncApplicationWorkAuthorizationType || (AtsSyncCandidateSyncApplicationWorkAuthorizationType = {}));
/** Enumerations for work authorization types. */
export var AtsSyncCandidateSyncApplicationWorkAuthorizationTypeInput;
(function (AtsSyncCandidateSyncApplicationWorkAuthorizationTypeInput) {
    /** Singapore citizen. */
    AtsSyncCandidateSyncApplicationWorkAuthorizationTypeInput["SgCitizen"] = "SG_CITIZEN";
    /** Singapore Employment Pass holder. */
    AtsSyncCandidateSyncApplicationWorkAuthorizationTypeInput["SgEmploymentPass"] = "SG_EMPLOYMENT_PASS";
    /** Other Singapore work authorization. */
    AtsSyncCandidateSyncApplicationWorkAuthorizationTypeInput["SgOther"] = "SG_OTHER";
    /** Authorized to work in Singapore with employer sponsorship. */
    AtsSyncCandidateSyncApplicationWorkAuthorizationTypeInput["SgSponsorship"] = "SG_SPONSORSHIP";
    /** Singapore Training Employment Pass holder. */
    AtsSyncCandidateSyncApplicationWorkAuthorizationTypeInput["SgTrainingEmploymentPass"] = "SG_TRAINING_EMPLOYMENT_PASS";
    /** Unknown or unspecified authorization type. */
    AtsSyncCandidateSyncApplicationWorkAuthorizationTypeInput["UnknownAuthorization"] = "UNKNOWN_AUTHORIZATION";
    /** Authorized to work in the US for any employer. */
    AtsSyncCandidateSyncApplicationWorkAuthorizationTypeInput["UsEligible"] = "US_ELIGIBLE";
    /** Authorized to work in the US with employer sponsorship. */
    AtsSyncCandidateSyncApplicationWorkAuthorizationTypeInput["UsWithSponsorship"] = "US_WITH_SPONSORSHIP";
    /** Authorized to work in the specified country. */
    AtsSyncCandidateSyncApplicationWorkAuthorizationTypeInput["Yes"] = "YES";
})(AtsSyncCandidateSyncApplicationWorkAuthorizationTypeInput || (AtsSyncCandidateSyncApplicationWorkAuthorizationTypeInput = {}));
/** The kinds of features that can be supported by an ATS_SYNC kind integration model */
export var AtsSyncFeaturesKind;
(function (AtsSyncFeaturesKind) {
    AtsSyncFeaturesKind["ApplySync"] = "APPLY_SYNC";
    AtsSyncFeaturesKind["CandidateSync"] = "CANDIDATE_SYNC";
    AtsSyncFeaturesKind["DispositionSync"] = "DISPOSITION_SYNC";
    AtsSyncFeaturesKind["JobSync"] = "JOB_SYNC";
})(AtsSyncFeaturesKind || (AtsSyncFeaturesKind = {}));
export var AtsSyncIntegrationType;
(function (AtsSyncIntegrationType) {
    /** Indeed-built integration */
    AtsSyncIntegrationType["Acdc"] = "ACDC";
    /** Partner-built integration */
    AtsSyncIntegrationType["PartnerBuilt"] = "PARTNER_BUILT";
})(AtsSyncIntegrationType || (AtsSyncIntegrationType = {}));
export var AtsSyncStatus;
(function (AtsSyncStatus) {
    AtsSyncStatus["NotSent"] = "NOT_SENT";
    AtsSyncStatus["Sent"] = "SENT";
    AtsSyncStatus["WorkflowInProgress"] = "WORKFLOW_IN_PROGRESS";
})(AtsSyncStatus || (AtsSyncStatus = {}));
/**  Reasons that user wishes to attach a new candidate resume to an email notification  */
export var AttachResumeUsageReason;
(function (AttachResumeUsageReason) {
    /**  Resumes are used in another tool or ATS  */
    AttachResumeUsageReason["InAnotherToolOrAts"] = "IN_ANOTHER_TOOL_OR_ATS";
    /**  Resumes are used in another way  */
    AttachResumeUsageReason["OtherNotListed"] = "OTHER_NOT_LISTED";
})(AttachResumeUsageReason || (AttachResumeUsageReason = {}));
/**
 * This is manually converted from the AttributeSource in MDP Data Catalog Avro Schema:
 * https://code.corp.indeed.com/niffler/mdp-data-catalog/-/blob/master/catalog/jsdp/common.avdl#L26-43
 */
export var AttributeSource;
(function (AttributeSource) {
    AttributeSource["Deduced"] = "DEDUCED";
    AttributeSource["Employer"] = "EMPLOYER";
    AttributeSource["Extracted"] = "EXTRACTED";
    AttributeSource["ExtractedCrowtagMatchTag"] = "EXTRACTED_CROWTAG_MATCH_TAG";
    AttributeSource["ExtractedCrowtagOqvtTag"] = "EXTRACTED_CROWTAG_OQVT_TAG";
    AttributeSource["HighRecall"] = "HIGH_RECALL";
    AttributeSource["NotApplicableOrUnknown"] = "NOT_APPLICABLE_OR_UNKNOWN";
    AttributeSource["UnknownAttributeSource"] = "UNKNOWN_ATTRIBUTE_SOURCE";
})(AttributeSource || (AttributeSource = {}));
/** Standard GraphQL error code. See [MUST report standardized error codes for commonly encountered errors [229]](https://api-wg.indeed.gitlab-dedicated.site/api-recommendations/recommendations/graphql/errors/errors/#must-report-standardized-error-codes-for-commonly-encountered-errors-229). */
export var AttributeUpdateResponseCode;
(function (AttributeUpdateResponseCode) {
    /** Invalid input parameter. Applies to validation beyond standard GraphQL type/`null` checking. */
    AttributeUpdateResponseCode["BadUserInput"] = "BAD_USER_INPUT";
    /** Valid credentials but insufficient permissions. Equivalent to HTTP `403 Forbidden`. */
    AttributeUpdateResponseCode["Forbidden"] = "FORBIDDEN";
    /** Unexpected server failure. Generic error for unhandled failures. */
    AttributeUpdateResponseCode["InternalServerError"] = "INTERNAL_SERVER_ERROR";
    AttributeUpdateResponseCode["Ok"] = "OK";
    /** Partial success due to some failures. */
    AttributeUpdateResponseCode["PartialSuccess"] = "PARTIAL_SUCCESS";
    /** Query exceeded complexity limit. */
    AttributeUpdateResponseCode["QueryTooComplex"] = "QUERY_TOO_COMPLEX";
    /** Insufficient authentication credentials. Equivalent to HTTP `401 Unauthorized`. */
    AttributeUpdateResponseCode["Unauthenticated"] = "UNAUTHENTICATED";
})(AttributeUpdateResponseCode || (AttributeUpdateResponseCode = {}));
/** Sortable fields for Aurora database access logs */
export var AuroraDatabaseAccessLogSortBy;
(function (AuroraDatabaseAccessLogSortBy) {
    AuroraDatabaseAccessLogSortBy["Actioner"] = "ACTIONER";
    AuroraDatabaseAccessLogSortBy["Database"] = "DATABASE";
    AuroraDatabaseAccessLogSortBy["Date"] = "DATE";
    AuroraDatabaseAccessLogSortBy["ExpiryDate"] = "EXPIRY_DATE";
    AuroraDatabaseAccessLogSortBy["Id"] = "ID";
    AuroraDatabaseAccessLogSortBy["Object"] = "OBJECT";
    AuroraDatabaseAccessLogSortBy["Restricted"] = "RESTRICTED";
    AuroraDatabaseAccessLogSortBy["Ticket"] = "TICKET";
    AuroraDatabaseAccessLogSortBy["Type"] = "TYPE";
    AuroraDatabaseAccessLogSortBy["User"] = "USER";
})(AuroraDatabaseAccessLogSortBy || (AuroraDatabaseAccessLogSortBy = {}));
/** Classifies access change as either a GRANT or a REVOKE */
export var AuroraDatabaseAccessLogType;
(function (AuroraDatabaseAccessLogType) {
    AuroraDatabaseAccessLogType["Grant"] = "GRANT";
    AuroraDatabaseAccessLogType["Revoke"] = "REVOKE";
})(AuroraDatabaseAccessLogType || (AuroraDatabaseAccessLogType = {}));
/** Status for an AutoDBA batch row in the UI */
export var AuroraDatabaseAutoDbaBatchStatus;
(function (AuroraDatabaseAutoDbaBatchStatus) {
    AuroraDatabaseAutoDbaBatchStatus["Complete"] = "COMPLETE";
    AuroraDatabaseAutoDbaBatchStatus["Error"] = "ERROR";
    AuroraDatabaseAutoDbaBatchStatus["Skipped"] = "SKIPPED";
})(AuroraDatabaseAutoDbaBatchStatus || (AuroraDatabaseAutoDbaBatchStatus = {}));
export var AuroraDatabaseDdlGroupType;
(function (AuroraDatabaseDdlGroupType) {
    AuroraDatabaseDdlGroupType["Owner"] = "OWNER";
    AuroraDatabaseDdlGroupType["TableDdl"] = "TABLE_DDL";
})(AuroraDatabaseDdlGroupType || (AuroraDatabaseDdlGroupType = {}));
export var AuroraDatabaseDmlGroupType;
(function (AuroraDatabaseDmlGroupType) {
    AuroraDatabaseDmlGroupType["Owner"] = "OWNER";
    AuroraDatabaseDmlGroupType["TableDml"] = "TABLE_DML";
})(AuroraDatabaseDmlGroupType || (AuroraDatabaseDmlGroupType = {}));
export var AuroraDatabaseDmlQuerySafety;
(function (AuroraDatabaseDmlQuerySafety) {
    AuroraDatabaseDmlQuerySafety["Safe"] = "SAFE";
    AuroraDatabaseDmlQuerySafety["Warning"] = "WARNING";
})(AuroraDatabaseDmlQuerySafety || (AuroraDatabaseDmlQuerySafety = {}));
/** Execution status for a submitted DML query */
export var AuroraDatabaseJobQueryExecutionStatus;
(function (AuroraDatabaseJobQueryExecutionStatus) {
    /** Executed and errored */
    AuroraDatabaseJobQueryExecutionStatus["Error"] = "ERROR";
    /** Not started (pre-run only) */
    AuroraDatabaseJobQueryExecutionStatus["NotRun"] = "NOT_RUN";
    /** Not executed due to previous failures blocking the rest */
    AuroraDatabaseJobQueryExecutionStatus["Skipped"] = "SKIPPED";
    /** Executed successfully */
    AuroraDatabaseJobQueryExecutionStatus["Success"] = "SUCCESS";
})(AuroraDatabaseJobQueryExecutionStatus || (AuroraDatabaseJobQueryExecutionStatus = {}));
/** Describes how the job was executed */
export var AuroraDatabaseJobQueryType;
(function (AuroraDatabaseJobQueryType) {
    /** AutoDBA DML jobs */
    AuroraDatabaseJobQueryType["Autodba"] = "AUTODBA";
    /** Job submitted via file for DML */
    AuroraDatabaseJobQueryType["File"] = "FILE";
    /** Percona pt-online-schema-change for MySQL */
    AuroraDatabaseJobQueryType["Ptosc"] = "PTOSC";
    /** Standard job submission for DDL */
    AuroraDatabaseJobQueryType["Standard"] = "STANDARD";
    /** Job submitted via raw text for DML */
    AuroraDatabaseJobQueryType["Text"] = "TEXT";
})(AuroraDatabaseJobQueryType || (AuroraDatabaseJobQueryType = {}));
/** Sortable fields for Aurora database jobs */
export var AuroraDatabaseJobSortBy;
(function (AuroraDatabaseJobSortBy) {
    AuroraDatabaseJobSortBy["CreatedBy"] = "CREATED_BY";
    AuroraDatabaseJobSortBy["Database"] = "DATABASE";
    AuroraDatabaseJobSortBy["Id"] = "ID";
    AuroraDatabaseJobSortBy["JobType"] = "JOB_TYPE";
    AuroraDatabaseJobSortBy["QueryType"] = "QUERY_TYPE";
    AuroraDatabaseJobSortBy["RunDate"] = "RUN_DATE";
    AuroraDatabaseJobSortBy["Status"] = "STATUS";
    AuroraDatabaseJobSortBy["Ticket"] = "TICKET";
})(AuroraDatabaseJobSortBy || (AuroraDatabaseJobSortBy = {}));
/** Lifecycle state for a job */
export var AuroraDatabaseJobStatus;
(function (AuroraDatabaseJobStatus) {
    AuroraDatabaseJobStatus["Complete"] = "COMPLETE";
    AuroraDatabaseJobStatus["Error"] = "ERROR";
    AuroraDatabaseJobStatus["PendingRun"] = "PENDING_RUN";
    AuroraDatabaseJobStatus["PendingStart"] = "PENDING_START";
})(AuroraDatabaseJobStatus || (AuroraDatabaseJobStatus = {}));
/** Classifies the job as either DML (data manipulation) or DDL (schema change) */
export var AuroraDatabaseJobType;
(function (AuroraDatabaseJobType) {
    AuroraDatabaseJobType["Ddl"] = "DDL";
    AuroraDatabaseJobType["Dml"] = "DML";
})(AuroraDatabaseJobType || (AuroraDatabaseJobType = {}));
/** Search scope for fuzzy search when filtering processes */
export var AuroraDatabaseProcessSearchField;
(function (AuroraDatabaseProcessSearchField) {
    AuroraDatabaseProcessSearchField["Everything"] = "EVERYTHING";
    AuroraDatabaseProcessSearchField["Host"] = "HOST";
    AuroraDatabaseProcessSearchField["Info"] = "INFO";
    AuroraDatabaseProcessSearchField["ProcessId"] = "PROCESS_ID";
    AuroraDatabaseProcessSearchField["Status"] = "STATUS";
    AuroraDatabaseProcessSearchField["User"] = "USER";
})(AuroraDatabaseProcessSearchField || (AuroraDatabaseProcessSearchField = {}));
/** Sortable fields for Aurora database processes */
export var AuroraDatabaseProcessSortBy;
(function (AuroraDatabaseProcessSortBy) {
    AuroraDatabaseProcessSortBy["Command"] = "COMMAND";
    AuroraDatabaseProcessSortBy["Database"] = "DATABASE";
    AuroraDatabaseProcessSortBy["Host"] = "HOST";
    AuroraDatabaseProcessSortBy["InitiatedAt"] = "INITIATED_AT";
    AuroraDatabaseProcessSortBy["ProcessId"] = "PROCESS_ID";
    AuroraDatabaseProcessSortBy["Status"] = "STATUS";
    AuroraDatabaseProcessSortBy["User"] = "USER";
})(AuroraDatabaseProcessSortBy || (AuroraDatabaseProcessSortBy = {}));
/** Sortable fields for Aurora databases */
export var AuroraDatabaseSortBy;
(function (AuroraDatabaseSortBy) {
    AuroraDatabaseSortBy["ClusterIdentifier"] = "CLUSTER_IDENTIFIER";
    AuroraDatabaseSortBy["ClusterRegion"] = "CLUSTER_REGION";
    AuroraDatabaseSortBy["Engine"] = "ENGINE";
    AuroraDatabaseSortBy["Name"] = "NAME";
    AuroraDatabaseSortBy["PermissionsType"] = "PERMISSIONS_TYPE";
})(AuroraDatabaseSortBy || (AuroraDatabaseSortBy = {}));
/** Manageable permissions for MySQL self-service grants */
export var AuroraSelfServicePermission;
(function (AuroraSelfServicePermission) {
    AuroraSelfServicePermission["Delete"] = "DELETE";
    AuroraSelfServicePermission["Insert"] = "INSERT";
    AuroraSelfServicePermission["Select"] = "SELECT";
    AuroraSelfServicePermission["Update"] = "UPDATE";
})(AuroraSelfServicePermission || (AuroraSelfServicePermission = {}));
/** Types of identifiers that can be used to sign into account */
export var AuthIdentifier;
(function (AuthIdentifier) {
    AuthIdentifier["Email"] = "EMAIL";
    AuthIdentifier["Phone"] = "PHONE";
})(AuthIdentifier || (AuthIdentifier = {}));
export var AutoApplyEligibleQuestionType;
(function (AutoApplyEligibleQuestionType) {
    AutoApplyEligibleQuestionType["Date"] = "DATE";
    AutoApplyEligibleQuestionType["File"] = "FILE";
    AutoApplyEligibleQuestionType["Hierarchical"] = "HIERARCHICAL";
    AutoApplyEligibleQuestionType["Information"] = "INFORMATION";
    AutoApplyEligibleQuestionType["Multiselect"] = "MULTISELECT";
    AutoApplyEligibleQuestionType["Pagebreak"] = "PAGEBREAK";
    AutoApplyEligibleQuestionType["QuestionBank"] = "QUESTION_BANK";
    AutoApplyEligibleQuestionType["Select"] = "SELECT";
    AutoApplyEligibleQuestionType["Text"] = "TEXT";
    AutoApplyEligibleQuestionType["Textarea"] = "TEXTAREA";
})(AutoApplyEligibleQuestionType || (AutoApplyEligibleQuestionType = {}));
export var AutoApplyMode;
(function (AutoApplyMode) {
    /**
     * User has delegated full authority to Indeed to apply for jobs automatically
     * Jobs are applied directly without user review
     */
    AutoApplyMode["ApplyForMe"] = "APPLY_FOR_ME";
    /**
     * User wants to review and approve each job before Indeed submits the application
     * Jobs require manual approval before submission
     */
    AutoApplyMode["ReviewBeforeSubmit"] = "REVIEW_BEFORE_SUBMIT";
})(AutoApplyMode || (AutoApplyMode = {}));
export var AutoApplySetupStatus;
(function (AutoApplySetupStatus) {
    /** The user has completed the set up */
    AutoApplySetupStatus["Completed"] = "COMPLETED";
    /** The user has not started the set up */
    AutoApplySetupStatus["NotStarted"] = "NOT_STARTED";
    /** The user has started but not completed the set up */
    AutoApplySetupStatus["Started"] = "STARTED";
})(AutoApplySetupStatus || (AutoApplySetupStatus = {}));
export var AutoApplyStatus;
(function (AutoApplyStatus) {
    AutoApplyStatus["Disabled"] = "DISABLED";
    AutoApplyStatus["Enabled"] = "ENABLED";
})(AutoApplyStatus || (AutoApplyStatus = {}));
/** Result of a NEXUS auto-enrollment attempt. */
export var AutoEnrollmentStatus;
(function (AutoEnrollmentStatus) {
    /** The advertiser failed at least one auto-enrollment eligibility gate. */
    AutoEnrollmentStatus["NotEligible"] = "NOT_ELIGIBLE";
    /** The advertiser was activated and an advertiser-scoped NEXUS auto-enrollment rule exists. */
    AutoEnrollmentStatus["Success"] = "SUCCESS";
})(AutoEnrollmentStatus || (AutoEnrollmentStatus = {}));
/** Application source for the auto-generate content */
export var AutoGenerateContentSource;
(function (AutoGenerateContentSource) {
    /** @deprecated Horizon Messaging no longer exists */
    AutoGenerateContentSource["HorizonMessaging"] = "HORIZON_MESSAGING";
    /** @deprecated Instant Match no longer exists */
    AutoGenerateContentSource["InstantMatch"] = "INSTANT_MATCH";
    AutoGenerateContentSource["InterviewSchedule"] = "INTERVIEW_SCHEDULE";
    AutoGenerateContentSource["ResumeSearch"] = "RESUME_SEARCH";
    AutoGenerateContentSource["Scout"] = "SCOUT";
})(AutoGenerateContentSource || (AutoGenerateContentSource = {}));
/** Available statuses of AutoGeneratedMessage feature for the current user */
export var AutoGeneratedMessageStatus;
(function (AutoGeneratedMessageStatus) {
    /** The current user is permitted to use an AutoGeneratedMessage if required conditions are met */
    AutoGeneratedMessageStatus["ConditionallyEnabled"] = "CONDITIONALLY_ENABLED";
    /** The current user is not permitted to use an AutoGeneratedMessage */
    AutoGeneratedMessageStatus["Disabled"] = "DISABLED";
})(AutoGeneratedMessageStatus || (AutoGeneratedMessageStatus = {}));
/** Represents the eligibility of the job to be enabled for AutoInvite */
export var AutoInviteEligibility;
(function (AutoInviteEligibility) {
    AutoInviteEligibility["Eligible"] = "ELIGIBLE";
    AutoInviteEligibility["Ineligible"] = "INELIGIBLE";
    AutoInviteEligibility["IneligibleInUse"] = "INELIGIBLE_IN_USE";
})(AutoInviteEligibility || (AutoInviteEligibility = {}));
/**
 * Reason why a job is not eligible for AutoInvite assignment.
 * Intentionally vague to avoid exposing internal visibility details.
 */
export var AutoInviteJobEligibilityReason;
(function (AutoInviteJobEligibilityReason) {
    AutoInviteJobEligibilityReason["AlreadyEnabledPremium"] = "ALREADY_ENABLED_PREMIUM";
    AutoInviteJobEligibilityReason["AlreadyEnabledSs"] = "ALREADY_ENABLED_SS";
    AutoInviteJobEligibilityReason["NotEnUs"] = "NOT_EN_US";
    AutoInviteJobEligibilityReason["NotIndeedApplyable"] = "NOT_INDEED_APPLYABLE";
    AutoInviteJobEligibilityReason["Other"] = "OTHER";
})(AutoInviteJobEligibilityReason || (AutoInviteJobEligibilityReason = {}));
/** Represents the overall state of an AutoInvite configuration */
export var AutoInviteState;
(function (AutoInviteState) {
    /** AutoInvite is fully enabled and sending outreaches automatically */
    AutoInviteState["Enabled"] = "ENABLED";
    /** AutoInvite is paused/disabled with no active manual review batch */
    AutoInviteState["Paused"] = "PAUSED";
    /** AutoInvite is in training mode - manual review is active and the configuration is disabled */
    AutoInviteState["Training"] = "TRAINING";
    /** AutoInvite has not been initialized - no configuration exists or it has never been queued */
    AutoInviteState["Uninitialized"] = "UNINITIALIZED";
})(AutoInviteState || (AutoInviteState = {}));
/**  ResultCode for autoVerifyEmployer mutation   */
export var AutoVerifyEmployerResultCode;
(function (AutoVerifyEmployerResultCode) {
    /**  Auto-verification has not been sent to the  T&S queue. */
    AutoVerifyEmployerResultCode["AutoVerificationSignalNotSent"] = "AutoVerificationSignalNotSent";
    /**  Auto-verification has been sent to the  T&S queue. */
    AutoVerifyEmployerResultCode["AutoVerificationSignalSent"] = "AutoVerificationSignalSent";
})(AutoVerifyEmployerResultCode || (AutoVerifyEmployerResultCode = {}));
export var AutoplatAutomationStatus;
(function (AutoplatAutomationStatus) {
    AutoplatAutomationStatus["Active"] = "ACTIVE";
    AutoplatAutomationStatus["Deactivated"] = "DEACTIVATED";
    AutoplatAutomationStatus["Deleted"] = "DELETED";
})(AutoplatAutomationStatus || (AutoplatAutomationStatus = {}));
export var AutoplatNotificationType;
(function (AutoplatNotificationType) {
    AutoplatNotificationType["Email"] = "EMAIL";
    AutoplatNotificationType["Sms"] = "SMS";
})(AutoplatNotificationType || (AutoplatNotificationType = {}));
/** Type of jobs to apply the bulk enable operation to. */
export var AutosourcerBulkEnableTaskInput;
(function (AutosourcerBulkEnableTaskInput) {
    /** The operation will only be applied on hosted jobs. */
    AutosourcerBulkEnableTaskInput["HostedJob"] = "HOSTED_JOB";
    /** The operation will only be applied on index jobs. */
    AutosourcerBulkEnableTaskInput["IndexJob"] = "INDEX_JOB";
})(AutosourcerBulkEnableTaskInput || (AutosourcerBulkEnableTaskInput = {}));
/** Status values for a bulk enable task. */
export var AutosourcerBulkEnableTaskStatus;
(function (AutosourcerBulkEnableTaskStatus) {
    /** External batch tasks finished successfully */
    AutosourcerBulkEnableTaskStatus["Completed"] = "COMPLETED";
    /** The task has been created */
    AutosourcerBulkEnableTaskStatus["Created"] = "CREATED";
    /** The task has been created, but system identifies there's no eligible jobs */
    AutosourcerBulkEnableTaskStatus["NoEligibleJobs"] = "NO_ELIGIBLE_JOBS";
    /** External batch tasks are pending */
    AutosourcerBulkEnableTaskStatus["Pending"] = "PENDING";
    /** A permanent error occurred in an external batch task or in the system */
    AutosourcerBulkEnableTaskStatus["PermanentError"] = "PERMANENT_ERROR";
    /** External batch tasks finished with retryable error */
    AutosourcerBulkEnableTaskStatus["RetryableError"] = "RETRYABLE_ERROR";
    /** The task has been created, but system identifies there're more jobs to be processed than the limitation. */
    AutosourcerBulkEnableTaskStatus["SizeLimitExceeded"] = "SIZE_LIMIT_EXCEEDED";
})(AutosourcerBulkEnableTaskStatus || (AutosourcerBulkEnableTaskStatus = {}));
/** Specifies the scope level at which availability is defined at. */
export var AvailabilityScope;
(function (AvailabilityScope) {
    AvailabilityScope["General"] = "GENERAL";
    AvailabilityScope["Interview"] = "INTERVIEW";
})(AvailabilityScope || (AvailabilityScope = {}));
export var AvailabilitySlotFormat;
(function (AvailabilitySlotFormat) {
    /**
     * Generate slots that match the calendar availability settings. This will return time slots matching defined
     * availability periods and rules without any trimming or merging. There are several important qualities of this output
     * format:
     * 1. Slots are not trimmed to the start and end times, and may extend past them.
     * 2. Slots are not combined if overlapping or adjacent, so there may be overlapping slots.
     * 3. Slots that would have any overlap with an exclude period are not returned.
     * 4. Slots overlapping existing calendar events where the total weight + appointmentWeight > maxWeight are not returned.
     * 5. Slots are only returned if their duration is equal to or greater than the requiredDuration argument.
     */
    AvailabilitySlotFormat["AvailabilityPeriods"] = "AVAILABILITY_PERIODS";
    /**
     * Generate available non-overlapping slots that satisfy requiredDuration and startInterval that will
     * not shift around due to changes in the availabilityWindow. (e.g. 10:00-12:00 availability; 1hr duration; 30m start
     * interval: slots returned would be 10:00-11:00 and 11:00-12:00 always. If the slot logic were not consistent and the
     * availabilityWindow start time was between 10:01 and 10:30, then only a single 10:30-11:30 slot would be returned)
     */
    AvailabilitySlotFormat["ConsistentSlots"] = "CONSISTENT_SLOTS";
    /** Generate all available slots that satisfy requiredDuration and startInterval even if the slots overlap eachother. */
    AvailabilitySlotFormat["OverlappingSlots"] = "OVERLAPPING_SLOTS";
    /** Generate contiguous available periods that satisfy startInterval and are at least requiredDuration in length. */
    AvailabilitySlotFormat["Periods"] = "PERIODS";
})(AvailabilitySlotFormat || (AvailabilitySlotFormat = {}));
export var AwsAccountEnvironment;
(function (AwsAccountEnvironment) {
    AwsAccountEnvironment["Inf"] = "INF";
    AwsAccountEnvironment["Prod"] = "PROD";
    AwsAccountEnvironment["Qa"] = "QA";
    AwsAccountEnvironment["Sandbox"] = "SANDBOX";
})(AwsAccountEnvironment || (AwsAccountEnvironment = {}));
/** Status of a backfill operation */
export var BackfillStatus;
(function (BackfillStatus) {
    BackfillStatus["Canceled"] = "CANCELED";
    BackfillStatus["Canceling"] = "CANCELING";
    BackfillStatus["Completed"] = "COMPLETED";
    BackfillStatus["Failed"] = "FAILED";
    BackfillStatus["InProgress"] = "IN_PROGRESS";
    BackfillStatus["Queued"] = "QUEUED";
})(BackfillStatus || (BackfillStatus = {}));
export var BankAccountType;
(function (BankAccountType) {
    BankAccountType["Dda"] = "DDA";
    BankAccountType["Sa"] = "SA";
})(BankAccountType || (BankAccountType = {}));
/**
 * Visual style variants for banner elements.
 * Determines color scheme and visual prominence.
 */
export var BannerStyle;
(function (BannerStyle) {
    /** Critical/error banner (typically red) */
    BannerStyle["Critical"] = "CRITICAL";
    /** Informational banner (typically blue) */
    BannerStyle["Info"] = "INFO";
    /** Neutral style with filled background */
    BannerStyle["NeutralFill"] = "NEUTRAL_FILL";
    /** Success banner (typically green) */
    BannerStyle["Success"] = "SUCCESS";
    /** Warning banner (typically yellow/orange) */
    BannerStyle["Warning"] = "WARNING";
})(BannerStyle || (BannerStyle = {}));
/** Per-input outcome status for a batch AI generation mutation entry. */
export var BatchAiSubmissionEntryStatus;
(function (BatchAiSubmissionEntryStatus) {
    /** Input was accepted; `generation` carries the (possibly pre-existing) PENDING record. */
    BatchAiSubmissionEntryStatus["Accepted"] = "ACCEPTED";
    /** Input was dropped because the caller hit the per-user PENDING rolling-window cap. */
    BatchAiSubmissionEntryStatus["SkippedRateLimited"] = "SKIPPED_RATE_LIMITED";
    /** Input was unresolvable: IRN not in the catalog or field not on the asset. */
    BatchAiSubmissionEntryStatus["SkippedUnresolved"] = "SKIPPED_UNRESOLVED";
})(BatchAiSubmissionEntryStatus || (BatchAiSubmissionEntryStatus = {}));
/** Status of a batch outreach */
export var BatchOutreachState;
(function (BatchOutreachState) {
    /** One or more outreaches failed */
    BatchOutreachState["Error"] = "ERROR";
    /** Outreach sending is in progress */
    BatchOutreachState["InProgress"] = "IN_PROGRESS";
    /** All outreaches were sent successfully */
    BatchOutreachState["Sent"] = "SENT";
})(BatchOutreachState || (BatchOutreachState = {}));
/** The types of outcomes that can be benchmarked */
export var BenchmarkOutcomeType;
(function (BenchmarkOutcomeType) {
    /** Total applies outcome type */
    BenchmarkOutcomeType["Applies"] = "APPLIES";
    /** Total apply starts outcome type */
    BenchmarkOutcomeType["ApplyStarts"] = "APPLY_STARTS";
    /** Total clicks outcome type */
    BenchmarkOutcomeType["Clicks"] = "CLICKS";
    /** Total impressions outcome type */
    BenchmarkOutcomeType["Impressions"] = "IMPRESSIONS";
    /** Time to reach X apply starts outcome type. Measures the time (in days) required to achieve a specified number of apply starts. */
    BenchmarkOutcomeType["TimeToFirstXApplyStarts"] = "TIME_TO_FIRST_X_APPLY_STARTS";
})(BenchmarkOutcomeType || (BenchmarkOutcomeType = {}));
/** Budget tier levels for job sponsorship */
export var BenchmarkTier;
(function (BenchmarkTier) {
    BenchmarkTier["Free"] = "FREE";
    BenchmarkTier["Premium"] = "PREMIUM";
    BenchmarkTier["Standard"] = "STANDARD";
})(BenchmarkTier || (BenchmarkTier = {}));
/** Variants of the Benefit optimization */
export var BenefitOptimizationVariant;
(function (BenefitOptimizationVariant) {
    BenefitOptimizationVariant["BenefitOptimizationVariantDefault"] = "BENEFIT_OPTIMIZATION_VARIANT_DEFAULT";
})(BenefitOptimizationVariant || (BenefitOptimizationVariant = {}));
export var BigEasyOptimizationsCacheMode;
(function (BigEasyOptimizationsCacheMode) {
    /** Ignore all cached results and always calculate the optimizations. */
    BigEasyOptimizationsCacheMode["Bypass"] = "BYPASS";
    /** Only return cached results. */
    BigEasyOptimizationsCacheMode["CachedOnly"] = "CACHED_ONLY";
    /**
     * Default cache mode.
     * Uses the cache if available and the job hasn't changed, otherwise calculates the optimizations.
     */
    BigEasyOptimizationsCacheMode["Default"] = "DEFAULT";
})(BigEasyOptimizationsCacheMode || (BigEasyOptimizationsCacheMode = {}));
/** Billable event type */
export var BillableEventType;
(function (BillableEventType) {
    BillableEventType["ApplyStart"] = "APPLY_START";
    BillableEventType["Click"] = "CLICK";
})(BillableEventType || (BillableEventType = {}));
/**
 * Whether the annual contract has fixed, flexible, or custom subscription pricing semantics.
 * Sourced from Salesforce DealIntakeApprovalFlow__c.AnnualContractType__c.
 */
export var BillingContractDealContractType;
(function (BillingContractDealContractType) {
    BillingContractDealContractType["Custom"] = "CUSTOM";
    BillingContractDealContractType["Fixed"] = "FIXED";
    BillingContractDealContractType["Flexible"] = "FLEXIBLE";
})(BillingContractDealContractType || (BillingContractDealContractType = {}));
/** Type of discount applied to an annual deal */
export var BillingContractDealDiscountType;
(function (BillingContractDealDiscountType) {
    BillingContractDealDiscountType["AnnualDeal"] = "ANNUAL_DEAL";
})(BillingContractDealDiscountType || (BillingContractDealDiscountType = {}));
/** Unit of a billing contract deal discount value */
export var BillingContractDealDiscountValueUnit;
(function (BillingContractDealDiscountValueUnit) {
    BillingContractDealDiscountValueUnit["FixedAmount"] = "FIXED_AMOUNT";
    BillingContractDealDiscountValueUnit["Percentage"] = "PERCENTAGE";
})(BillingContractDealDiscountValueUnit || (BillingContractDealDiscountValueUnit = {}));
/** Distinguishes bonus-credit deals from discount deals */
export var BillingContractDealIncentiveType;
(function (BillingContractDealIncentiveType) {
    BillingContractDealIncentiveType["BonusCredits"] = "BONUS_CREDITS";
    BillingContractDealIncentiveType["Discounts"] = "DISCOUNTS";
})(BillingContractDealIncentiveType || (BillingContractDealIncentiveType = {}));
/** Derived from advertiserService BillingState. This includes sourcing-specific rules to determine advertiser eligibility and, if ineligible, the reason for ineligibility */
export var BillingDecision;
(function (BillingDecision) {
    BillingDecision["AdvertiserDisabled"] = "ADVERTISER_DISABLED";
    BillingDecision["CanPurchase"] = "CAN_PURCHASE";
    BillingDecision["InvalidAddress"] = "INVALID_ADDRESS";
    BillingDecision["NonMonetized"] = "NON_MONETIZED";
    BillingDecision["NoBilling"] = "NO_BILLING";
    BillingDecision["UnrecoverableIssue"] = "UNRECOVERABLE_ISSUE";
})(BillingDecision || (BillingDecision = {}));
/** The frequency the order item is billed, e.g MONTH, ANNUAL */
export var BillingFrequency;
(function (BillingFrequency) {
    BillingFrequency["Annual"] = "ANNUAL";
    BillingFrequency["Month"] = "MONTH";
})(BillingFrequency || (BillingFrequency = {}));
/** The billing platform version */
export var BillingPlatformVersion;
(function (BillingPlatformVersion) {
    BillingPlatformVersion["V1"] = "V1";
    BillingPlatformVersion["V2"] = "V2";
    BillingPlatformVersion["Version_1"] = "VERSION_1";
    BillingPlatformVersion["Version_2"] = "VERSION_2";
})(BillingPlatformVersion || (BillingPlatformVersion = {}));
export var Brand;
(function (Brand) {
    Brand["Glassdoor"] = "GLASSDOOR";
    Brand["Indeed"] = "INDEED";
    Brand["Simplyhired"] = "SIMPLYHIRED";
    Brand["UnknownBrand"] = "UNKNOWN_BRAND";
})(Brand || (Brand = {}));
/** Where the assets surfaced from `getBrandAssets` came from. Mirrors the gRPC BrandSource enum. */
export var BrandSource;
(function (BrandSource) {
    /** Company Data brand assets, resolved via the Acme Dossier fallback. */
    BrandSource["AcmeDossierService"] = "ACME_DOSSIER_SERVICE";
    /** Employer-managed assets stored by Brand Store. */
    BrandSource["BrandStoreService"] = "BRAND_STORE_SERVICE";
    /** No assets found for the brand. */
    BrandSource["None"] = "NONE";
})(BrandSource || (BrandSource = {}));
/** Networks that an ad format is available on */
export var BrandedAdsCapabilityNetwork;
(function (BrandedAdsCapabilityNetwork) {
    BrandedAdsCapabilityNetwork["Beeswax"] = "BEESWAX";
    BrandedAdsCapabilityNetwork["Facebook"] = "FACEBOOK";
    BrandedAdsCapabilityNetwork["Glassdoor"] = "GLASSDOOR";
    BrandedAdsCapabilityNetwork["Google"] = "GOOGLE";
    BrandedAdsCapabilityNetwork["Indeed"] = "INDEED";
})(BrandedAdsCapabilityNetwork || (BrandedAdsCapabilityNetwork = {}));
/**   members to be used in building filters for branded ads measures  */
export var BrandedAdsMeasureFilterMember;
(function (BrandedAdsMeasureFilterMember) {
    BrandedAdsMeasureFilterMember["AvgCtr"] = "AVG_CTR";
    BrandedAdsMeasureFilterMember["SumCampaignClicks"] = "SUM_CAMPAIGN_CLICKS";
    BrandedAdsMeasureFilterMember["SumCampaignImpressions"] = "SUM_CAMPAIGN_IMPRESSIONS";
    BrandedAdsMeasureFilterMember["SumCompanyClicks"] = "SUM_COMPANY_CLICKS";
    BrandedAdsMeasureFilterMember["SumCompanyImpressions"] = "SUM_COMPANY_IMPRESSIONS";
    BrandedAdsMeasureFilterMember["SumFollows"] = "SUM_FOLLOWS";
    BrandedAdsMeasureFilterMember["SumPageViews"] = "SUM_PAGE_VIEWS";
    BrandedAdsMeasureFilterMember["SumReviewsViewed"] = "SUM_REVIEWS_VIEWED";
    BrandedAdsMeasureFilterMember["SumVideosPlayed"] = "SUM_VIDEOS_PLAYED";
})(BrandedAdsMeasureFilterMember || (BrandedAdsMeasureFilterMember = {}));
/**  BrandedAds order by fields  */
export var BrandedAdsOrderByField;
(function (BrandedAdsOrderByField) {
    BrandedAdsOrderByField["ActivityDate"] = "ACTIVITY_DATE";
    BrandedAdsOrderByField["AdName"] = "AD_NAME";
    BrandedAdsOrderByField["AvgCtr"] = "AVG_CTR";
    BrandedAdsOrderByField["CompanyName"] = "COMPANY_NAME";
    BrandedAdsOrderByField["SumCampaignClicks"] = "SUM_CAMPAIGN_CLICKS";
    BrandedAdsOrderByField["SumCampaignImpressions"] = "SUM_CAMPAIGN_IMPRESSIONS";
    BrandedAdsOrderByField["SumCompanyClicks"] = "SUM_COMPANY_CLICKS";
    BrandedAdsOrderByField["SumCompanyImpressions"] = "SUM_COMPANY_IMPRESSIONS";
    BrandedAdsOrderByField["SumFollows"] = "SUM_FOLLOWS";
    BrandedAdsOrderByField["SumPageViews"] = "SUM_PAGE_VIEWS";
    BrandedAdsOrderByField["SumReviewsViewed"] = "SUM_REVIEWS_VIEWED";
    BrandedAdsOrderByField["SumVideosPlayed"] = "SUM_VIDEOS_PLAYED";
})(BrandedAdsOrderByField || (BrandedAdsOrderByField = {}));
/** Branded Ads Product Types */
export var BrandedAdsProductType;
(function (BrandedAdsProductType) {
    BrandedAdsProductType["Static"] = "STATIC";
    BrandedAdsProductType["Video"] = "VIDEO";
})(BrandedAdsProductType || (BrandedAdsProductType = {}));
/** Surfaces where jobs can be displayed with branding. */
export var BrandingRequestSource;
(function (BrandingRequestSource) {
    /** Homepage. */
    BrandingRequestSource["Homepage"] = "HOMEPAGE";
    /** Indeed Apply confirmation email surface. */
    BrandingRequestSource["IndeedApplyConfirmationEmail"] = "INDEED_APPLY_CONFIRMATION_EMAIL";
    /** Indeed Apply view/application form surface. */
    BrandingRequestSource["IndeedApplyViewForm"] = "INDEED_APPLY_VIEW_FORM";
    /** Search Engine Results Page. */
    BrandingRequestSource["Serp"] = "SERP";
    /** View Job (job details) page. */
    BrandingRequestSource["ViewJob"] = "VIEW_JOB";
})(BrandingRequestSource || (BrandingRequestSource = {}));
/** Current state of the Subscription */
export var BrandingSubscriptionState;
(function (BrandingSubscriptionState) {
    BrandingSubscriptionState["Active"] = "ACTIVE";
    BrandingSubscriptionState["Deactivated"] = "DEACTIVATED";
    BrandingSubscriptionState["Expired"] = "EXPIRED";
    BrandingSubscriptionState["Grace"] = "GRACE";
    BrandingSubscriptionState["NotApplicable"] = "NOT_APPLICABLE";
    BrandingSubscriptionState["Scheduled"] = "SCHEDULED";
})(BrandingSubscriptionState || (BrandingSubscriptionState = {}));
/**
 * Example schema.
 *
 * GraphQL Schema Basics: https://www.apollographql.com/docs/apollo-server/schema/schema/
 * Indeed API Recommendations: https://link.indeed.tech/api-recommendations
 *
 * Need help designing your schema? Check out the schema designer tool: https://graphql-schema-designer.sandbox.indeed.net/
 *
 *
 * Current type of the Subscription
 */
export var BrandingSubscriptionType;
(function (BrandingSubscriptionType) {
    BrandingSubscriptionType["Contract"] = "CONTRACT";
    BrandingSubscriptionType["FeaturedEmployer"] = "FEATURED_EMPLOYER";
    BrandingSubscriptionType["Other"] = "OTHER";
})(BrandingSubscriptionType || (BrandingSubscriptionType = {}));
/** Origin of a brief section's data. Mirrors com.indeed.scout.understanding.api.collection.Provenance on the API side. */
export var BriefSectionProvenance;
(function (BriefSectionProvenance) {
    /** Hardcoded stub from a Fixture* client / fetcher. Do not surface to product. */
    BriefSectionProvenance["Fixture"] = "FIXTURE";
    /** Live data from a real backing service or captured directly from the user's browser. */
    BriefSectionProvenance["Real"] = "REAL";
    /** Provenance was not stamped — defensive default. */
    BriefSectionProvenance["Unknown"] = "UNKNOWN";
})(BriefSectionProvenance || (BriefSectionProvenance = {}));
/** The types of errors */
export var BrsErrorType;
(function (BrsErrorType) {
    BrsErrorType["BudgetCurrencyNotSupported"] = "BUDGET_CURRENCY_NOT_SUPPORTED";
    BrsErrorType["DependencyFailed"] = "DEPENDENCY_FAILED";
    BrsErrorType["InvalidBudget"] = "INVALID_BUDGET";
    BrsErrorType["InvalidInput"] = "INVALID_INPUT";
    BrsErrorType["InvalidRequest"] = "INVALID_REQUEST";
    BrsErrorType["JobCountryNotSupported"] = "JOB_COUNTRY_NOT_SUPPORTED";
    BrsErrorType["JobLocationNotResolved"] = "JOB_LOCATION_NOT_RESOLVED";
    BrsErrorType["JobNotResolved"] = "JOB_NOT_RESOLVED";
    BrsErrorType["JobTitleNotResolved"] = "JOB_TITLE_NOT_RESOLVED";
    BrsErrorType["MaxBudgetSupported"] = "MAX_BUDGET_SUPPORTED";
    BrsErrorType["MaxOutcomeValuePossible"] = "MAX_OUTCOME_VALUE_POSSIBLE";
    BrsErrorType["PredictionsNotSupported"] = "PREDICTIONS_NOT_SUPPORTED";
    BrsErrorType["UnauthorizedField"] = "UNAUTHORIZED_FIELD";
    BrsErrorType["Unknown"] = "UNKNOWN";
    BrsErrorType["UnsupportedBudget"] = "UNSUPPORTED_BUDGET";
})(BrsErrorType || (BrsErrorType = {}));
/** The types of Job IDs that BRS supports */
export var BrsJobIdType;
(function (BrsJobIdType) {
    /** Non encrypted job ID. */
    BrsJobIdType["AggJobId"] = "AGG_JOB_ID";
    /**
     * Encrypted job ID (preferred)
     *
     * The encryption library [common-idkey](https://code.corp.indeed.com/common/common-idkey) could be used for encryption
     */
    BrsJobIdType["JobKey"] = "JOB_KEY";
})(BrsJobIdType || (BrsJobIdType = {}));
/** The products that BRS supports */
export var BrsProduct;
(function (BrsProduct) {
    /** Indeed Hiring Platform (IHP) product */
    BrsProduct["IhpEvents"] = "IHP_EVENTS";
    /** Sponsored jobs that can happen across multiple channels on Indeed */
    BrsProduct["SponsoredJobs"] = "SPONSORED_JOBS";
})(BrsProduct || (BrsProduct = {}));
/** The budget cap type of an ADB (Average Daily Budget) campaign. */
export var BudgetCapType;
(function (BudgetCapType) {
    BudgetCapType["Flexible"] = "FLEXIBLE";
    BudgetCapType["Lifetime"] = "LIFETIME";
    BudgetCapType["Monthly"] = "MONTHLY";
})(BudgetCapType || (BudgetCapType = {}));
/** The outcome type to distribute budget for */
export var BudgetDistributionOutcomeType;
(function (BudgetDistributionOutcomeType) {
    BudgetDistributionOutcomeType["Applies"] = "APPLIES";
    BudgetDistributionOutcomeType["ApplyStarts"] = "APPLY_STARTS";
    BudgetDistributionOutcomeType["Rsvps"] = "RSVPS";
    BudgetDistributionOutcomeType["Shows"] = "SHOWS";
    BudgetDistributionOutcomeType["SponsoredApplies"] = "SPONSORED_APPLIES";
    BudgetDistributionOutcomeType["SponsoredApplyStarts"] = "SPONSORED_APPLY_STARTS";
})(BudgetDistributionOutcomeType || (BudgetDistributionOutcomeType = {}));
export var BudgetRecommendationLabel;
(function (BudgetRecommendationLabel) {
    /** Resolved into either EXPEDITED, PREMIUM or PREMIUM_PACKAGE depending on the job locale and proctor */
    BudgetRecommendationLabel["Advanced"] = "ADVANCED";
    /** @deprecated Competitive Min Budget is deprecated */
    BudgetRecommendationLabel["CompetitiveMinBudget"] = "COMPETITIVE_MIN_BUDGET";
    BudgetRecommendationLabel["Default"] = "DEFAULT";
    BudgetRecommendationLabel["Expedited"] = "EXPEDITED";
    /** @deprecated Competitive Min Budget is deprecated */
    BudgetRecommendationLabel["ExpeditedCompetitiveMinBudget"] = "EXPEDITED_COMPETITIVE_MIN_BUDGET";
    /** @deprecated MOC is deprecated */
    BudgetRecommendationLabel["ExpeditedMoc"] = "EXPEDITED_MOC";
    /** @deprecated MOC is deprecated */
    BudgetRecommendationLabel["Moc"] = "MOC";
    /** Premium Intro (a copy of expedited) */
    BudgetRecommendationLabel["Premium"] = "PREMIUM";
    BudgetRecommendationLabel["PremiumPackage"] = "PREMIUM_PACKAGE";
    BudgetRecommendationLabel["PremiumPlus"] = "PREMIUM_PLUS";
})(BudgetRecommendationLabel || (BudgetRecommendationLabel = {}));
/** The package tier for sponsorship packages */
export var BudgetTier;
(function (BudgetTier) {
    BudgetTier["Free"] = "FREE";
    BudgetTier["Premium"] = "PREMIUM";
    BudgetTier["PremiumPlus"] = "PREMIUM_PLUS";
    BudgetTier["Standard"] = "STANDARD";
})(BudgetTier || (BudgetTier = {}));
/** Enumeration of possible message template types. */
export var BulkMessageTemplateType;
(function (BulkMessageTemplateType) {
    BulkMessageTemplateType["Candidate"] = "CANDIDATE";
    BulkMessageTemplateType["Interview"] = "INTERVIEW";
})(BulkMessageTemplateType || (BulkMessageTemplateType = {}));
export var BulkMessagingStatusType;
(function (BulkMessagingStatusType) {
    BulkMessagingStatusType["Disabled"] = "DISABLED";
    BulkMessagingStatusType["Enabled"] = "ENABLED";
    BulkMessagingStatusType["LimitExceeded"] = "LIMIT_EXCEEDED";
    BulkMessagingStatusType["Unknown"] = "UNKNOWN";
})(BulkMessagingStatusType || (BulkMessagingStatusType = {}));
export var BusinessMetricLabel;
(function (BusinessMetricLabel) {
    BusinessMetricLabel["Cpx"] = "CPX";
    BusinessMetricLabel["DollarsPerJob"] = "DOLLARS_PER_JOB";
    BusinessMetricLabel["JobCount"] = "JOB_COUNT";
    BusinessMetricLabel["OutcomesPerJob"] = "OUTCOMES_PER_JOB";
    BusinessMetricLabel["TotalOutcomes"] = "TOTAL_OUTCOMES";
    BusinessMetricLabel["TotalRevenue"] = "TOTAL_REVENUE";
})(BusinessMetricLabel || (BusinessMetricLabel = {}));
export var ButtonKind;
(function (ButtonKind) {
    ButtonKind["Primary"] = "PRIMARY";
    ButtonKind["Secondary"] = "SECONDARY";
    ButtonKind["Tertiary"] = "TERTIARY";
})(ButtonKind || (ButtonKind = {}));
/** Types of invitation CTA buttons */
export var CtaButton;
(function (CtaButton) {
    CtaButton["AcceptInvite"] = "ACCEPT_INVITE";
    CtaButton["DeclineInvite"] = "DECLINE_INVITE";
    CtaButton["TalkToEmployer"] = "TALK_TO_EMPLOYER";
})(CtaButton || (CtaButton = {}));
/** Status of a period on calendar */
export var CalendarBusyPeriodStatus;
(function (CalendarBusyPeriodStatus) {
    CalendarBusyPeriodStatus["Busy"] = "BUSY";
    CalendarBusyPeriodStatus["Free"] = "FREE";
})(CalendarBusyPeriodStatus || (CalendarBusyPeriodStatus = {}));
/** Type of a period on calendar */
export var CalendarBusyPeriodType;
(function (CalendarBusyPeriodType) {
    CalendarBusyPeriodType["Appointment"] = "APPOINTMENT";
    CalendarBusyPeriodType["ConnectedCalendarEvent"] = "CONNECTED_CALENDAR_EVENT";
})(CalendarBusyPeriodType || (CalendarBusyPeriodType = {}));
/** An enum type used to specify which calendar events should be considered in the availability calculation for a calendar configuration. */
export var CalendarConfigurationEventFilter;
(function (CalendarConfigurationEventFilter) {
    /** Include all types of calendar events in the availability calculation. */
    CalendarConfigurationEventFilter["All"] = "ALL";
    /** Exclude all calendar events from the availability calculation. */
    CalendarConfigurationEventFilter["None"] = "NONE";
})(CalendarConfigurationEventFilter || (CalendarConfigurationEventFilter = {}));
/**
 * Represents the status of an employer's consent to be contacted by a sales representative.
 * This is especially important for legal compliance in certain regions (e.g., TCPA in the US).
 */
export var CallConsentStatus;
(function (CallConsentStatus) {
    /**
     * The employer has explicitly denied or revoked consent to be called.
     *
     * This status corresponds to a 'consentToCall' property record in the database with
     * any value other than null or a case-insensitive 'true' (e.g., 'false', 'disabled').
     */
    CallConsentStatus["Denied"] = "DENIED";
    /**
     * The employer has explicitly granted consent to be called.
     *
     * This status corresponds to a 'consentToCall' property record in the database with a case-insensitive value of 'true'.
     */
    CallConsentStatus["Granted"] = "GRANTED";
    /**
     * The employer's consent status is not explicitly specified or is not required.
     *
     * UNSPECIFIED is used in the following cases:
     * - No 'consentToCall' property record exists for the advertiser in the database.
     * - A 'consentToCall' property record exists, but its value is `null`.
     */
    CallConsentStatus["Unspecified"] = "UNSPECIFIED";
})(CallConsentStatus || (CallConsentStatus = {}));
/**
 * Defines the proration behavior for the monthly platform budget.
 *
 * This value is configured to START_NOW_FULL_AMOUNT by the platform at the start of each new month.
 * Clients are recommended to update the proration behavior here to the intended one on each update to the ad group monthly platform budget and campaign scheduled date.
 */
export var CampaignAdGroupPlatformBudgetMonthlyProrationBehavior;
(function (CampaignAdGroupPlatformBudgetMonthlyProrationBehavior) {
    /**
     * The budget is allocated in full amount starting from the current date, without any proration.
     * The entire budget limit is available for spending immediately in the current period.
     */
    CampaignAdGroupPlatformBudgetMonthlyProrationBehavior["StartNowFullAmount"] = "START_NOW_FULL_AMOUNT";
    /**
     * The monthly budget is prorated based on the remaining days in the current month.
     * Proration formula: monthlyBudget * (daysLeftInMonth / daysInMonth).
     * Only this prorated portion of the budget is available for spending in the current month
     */
    CampaignAdGroupPlatformBudgetMonthlyProrationBehavior["StartNowProratedAmount"] = "START_NOW_PRORATED_AMOUNT";
})(CampaignAdGroupPlatformBudgetMonthlyProrationBehavior || (CampaignAdGroupPlatformBudgetMonthlyProrationBehavior = {}));
/**
 * The product which an Ad is influencing.
 *
 * This enum is non-exhaustive and new values will be added from time to time.
 */
export var CampaignAdGroupType;
(function (CampaignAdGroupType) {
    /** Product offering that monetizes the hires made by the employer. */
    CampaignAdGroupType["Hiring"] = "HIRING";
    /**
     * The historical Sponsored Jobs product offering which boosts engagement between employers
     * and job seekers by prioritizing job placement and reach on surfaces displayed to job seekers.
     */
    CampaignAdGroupType["SponsoredJobs"] = "SPONSORED_JOBS";
})(CampaignAdGroupType || (CampaignAdGroupType = {}));
/**
 * The status of the Ad, whether it is active or not.
 *
 * This enum is non-exhaustive and new values will be added from time to time.
 */
export var CampaignAdStatus;
(function (CampaignAdStatus) {
    CampaignAdStatus["Active"] = "ACTIVE";
    CampaignAdStatus["Archived"] = "ARCHIVED";
    CampaignAdStatus["Paused"] = "PAUSED";
})(CampaignAdStatus || (CampaignAdStatus = {}));
/**
 * Defines the recurring duration of the budget.
 * For example if it’s monthly then the total budget is refreshed monthly by the limit amount.
 *
 * This enum is non-exhaustive and new values will be added from time to time.
 */
export var CampaignBudgetDuration;
(function (CampaignBudgetDuration) {
    CampaignBudgetDuration["AvgDaily"] = "AVG_DAILY";
    CampaignBudgetDuration["Lifetime"] = "LIFETIME";
    CampaignBudgetDuration["Monthly"] = "MONTHLY";
})(CampaignBudgetDuration || (CampaignBudgetDuration = {}));
/**
 * Defines the behavior for the last month of the recurring duration.
 * Is the budget full-amount or prorated.
 * Must be only used for campaigns with recurringUnit as MONTHLY.
 *
 * This enum is non-exhaustive and new values will be added from time to time.
 */
export var CampaignBudgetLastMonthProrationBehavior;
(function (CampaignBudgetLastMonthProrationBehavior) {
    CampaignBudgetLastMonthProrationBehavior["LastMonthFullAmount"] = "LAST_MONTH_FULL_AMOUNT";
    CampaignBudgetLastMonthProrationBehavior["LastMonthProratedAmount"] = "LAST_MONTH_PRORATED_AMOUNT";
})(CampaignBudgetLastMonthProrationBehavior || (CampaignBudgetLastMonthProrationBehavior = {}));
/**
 * The budget level of the campaign.
 *
 * This enum is non-exhaustive and new values may be added in future.
 */
export var CampaignBudgetLevel;
(function (CampaignBudgetLevel) {
    CampaignBudgetLevel["Custom"] = "CUSTOM";
    CampaignBudgetLevel["Recommended"] = "RECOMMENDED";
})(CampaignBudgetLevel || (CampaignBudgetLevel = {}));
/** The campaign budget optimization type */
export var CampaignBudgetOptimizationType;
(function (CampaignBudgetOptimizationType) {
    /**
     * If the campaign is infeasible under the maximum_budget constraint, results will be returned to meet job-level
     * constraints of as many jobs possible (regardless of the order they were input)
     */
    CampaignBudgetOptimizationType["Coverage"] = "COVERAGE";
    /**
     * If the campaign is infeasible under the maximum_budget constraint, results will be returned that describe the
     * budget needed in order to meet job-level constraints of all jobs
     */
    CampaignBudgetOptimizationType["Volume"] = "VOLUME";
})(CampaignBudgetOptimizationType || (CampaignBudgetOptimizationType = {}));
/**
 * Defines the behavior of the first or last recurring duration.
 * Is the budget full-amount, prorated, or delayed to the next period.
 *
 * This enum is non-exhaustive and new values will be added from time to time.
 */
export var CampaignBudgetProrationBehavior;
(function (CampaignBudgetProrationBehavior) {
    CampaignBudgetProrationBehavior["StartNextMonthFullAmount"] = "START_NEXT_MONTH_FULL_AMOUNT";
    CampaignBudgetProrationBehavior["StartNowFullAmount"] = "START_NOW_FULL_AMOUNT";
    CampaignBudgetProrationBehavior["StartNowProratedAmount"] = "START_NOW_PRORATED_AMOUNT";
})(CampaignBudgetProrationBehavior || (CampaignBudgetProrationBehavior = {}));
/** Defines the current proration state of the budget. */
export var CampaignBudgetProrationState;
(function (CampaignBudgetProrationState) {
    /** The entire budget limit is available for the current month. */
    CampaignBudgetProrationState["Full"] = "FULL";
    /** The budget is prorated, i.e. a fractional amount of the budget is available for the current month. */
    CampaignBudgetProrationState["Prorated"] = "PRORATED";
    /**
     * The budget is unallocated, i.e. no budget is available for the current month.
     * It may be scheduled for a different state in the following months.
     */
    CampaignBudgetProrationState["Unallocated"] = "UNALLOCATED";
})(CampaignBudgetProrationState || (CampaignBudgetProrationState = {}));
/** Groups on which performance can be aggregated. */
export var CampaignCampaignPerformancesConnectionGroupInput;
(function (CampaignCampaignPerformancesConnectionGroupInput) {
    /** Performance aggregated on channel. */
    CampaignCampaignPerformancesConnectionGroupInput["Channel"] = "CHANNEL";
    /** Performance aggregated on device. */
    CampaignCampaignPerformancesConnectionGroupInput["Device"] = "DEVICE";
    /**
     * Performance aggregated on job.
     * Job identifiers will be present in response payload.
     */
    CampaignCampaignPerformancesConnectionGroupInput["Job"] = "JOB";
    /** Performance aggregated on traffic. */
    CampaignCampaignPerformancesConnectionGroupInput["Traffic"] = "TRAFFIC";
})(CampaignCampaignPerformancesConnectionGroupInput || (CampaignCampaignPerformancesConnectionGroupInput = {}));
/**
 * Sort criteria for performance.
 * May be helpful for the day level metrics.
 */
export var CampaignCampaignPerformancesConnectionSortInput;
(function (CampaignCampaignPerformancesConnectionSortInput) {
    /** DateTime ascending order. */
    CampaignCampaignPerformancesConnectionSortInput["TimeAsc"] = "TIME_ASC";
    /** DateTime descending order. */
    CampaignCampaignPerformancesConnectionSortInput["TimeDesc"] = "TIME_DESC";
})(CampaignCampaignPerformancesConnectionSortInput || (CampaignCampaignPerformancesConnectionSortInput = {}));
/**
 * Different advertising channels that can be enabled or disabled individually.
 *
 * This enum is non-exhaustive and new values will be added from time to time.
 */
export var CampaignChannel;
(function (CampaignChannel) {
    CampaignChannel["Glassdoor"] = "GLASSDOOR";
    CampaignChannel["Indeed"] = "INDEED";
    CampaignChannel["OffsiteAudienceNetwork"] = "OFFSITE_AUDIENCE_NETWORK";
    CampaignChannel["PerformanceDisplay"] = "PERFORMANCE_DISPLAY";
    CampaignChannel["TrustedMediaNetwork"] = "TRUSTED_MEDIA_NETWORK";
})(CampaignChannel || (CampaignChannel = {}));
/**
 * The target cost unit.
 *
 * This enum is non-exhaustive and new values will be added from time to time.
 */
export var CampaignCostControlUnit;
(function (CampaignCostControlUnit) {
    CampaignCostControlUnit["CostPerApply"] = "COST_PER_APPLY";
    CampaignCostControlUnit["CostPerClick"] = "COST_PER_CLICK";
})(CampaignCostControlUnit || (CampaignCostControlUnit = {}));
/** Defines the deprecated preset delivery objective configuration which corresponds to a legacy objective type used by enterprise clients. */
export var CampaignDeliveryObjectiveDeprecatedLegacyPreset;
(function (CampaignDeliveryObjectiveDeprecatedLegacyPreset) {
    CampaignDeliveryObjectiveDeprecatedLegacyPreset["LegacyManualBidding"] = "LEGACY_MANUAL_BIDDING";
})(CampaignDeliveryObjectiveDeprecatedLegacyPreset || (CampaignDeliveryObjectiveDeprecatedLegacyPreset = {}));
/**
 * Defines the preset delivery objective configuration which corresponds to a legacy objective type used by enterprise clients.
 * This is regarded as the source-of-truth of objectives for such clients.
 *
 * This enum is non-exhaustive and new values might be added.
 */
export var CampaignDeliveryObjectiveLegacyPreset;
(function (CampaignDeliveryObjectiveLegacyPreset) {
    CampaignDeliveryObjectiveLegacyPreset["Balance"] = "BALANCE";
    CampaignDeliveryObjectiveLegacyPreset["Budget"] = "BUDGET";
    CampaignDeliveryObjectiveLegacyPreset["Interview"] = "INTERVIEW";
    CampaignDeliveryObjectiveLegacyPreset["Quick"] = "QUICK";
    CampaignDeliveryObjectiveLegacyPreset["TargetApplies"] = "TARGET_APPLIES";
    CampaignDeliveryObjectiveLegacyPreset["Tcpa"] = "TCPA";
    /**
     * The UNSPECIFIED preset signifies that the Campaign has no legacy objective type associated with it.
     * Note that it is not equivalent to a missing `legacyPreset` field,
     * which means that an existing delivery objective for the Campaign cannot be defined
     * in terms of a legacy preset which is interpretable by enterprise clients.
     */
    CampaignDeliveryObjectiveLegacyPreset["Unspecified"] = "UNSPECIFIED";
})(CampaignDeliveryObjectiveLegacyPreset || (CampaignDeliveryObjectiveLegacyPreset = {}));
/**
 * The type of campaign pacing configured by the employer.
 * This enum is non-exhaustive and new values will be added from time to time.
 */
export var CampaignDeliveryPacingExpectationType;
(function (CampaignDeliveryPacingExpectationType) {
    /**
     * Optimize for as many outcomes as possible, while balancing outcomes evenly across jobs in the campaign.
     * Currently used as default.
     */
    CampaignDeliveryPacingExpectationType["Standard"] = "STANDARD";
    /** Deliver outcome at a steady pace. */
    CampaignDeliveryPacingExpectationType["Steady"] = "STEADY";
    /** Optimize for outcomes as soon as possible after campaign creation. */
    CampaignDeliveryPacingExpectationType["Urgent"] = "URGENT";
})(CampaignDeliveryPacingExpectationType || (CampaignDeliveryPacingExpectationType = {}));
/**
 * Enum representing the expiry level of a campaign.
 * Campaigns progress through these levels during the expiry lifecycle.
 */
export var CampaignExpiryLevel;
(function (CampaignExpiryLevel) {
    /** Campaign data is read-only and mutations are disabled. This state is non-reversible. */
    CampaignExpiryLevel["ExpiredImmutable"] = "EXPIRED_IMMUTABLE";
    /** Campaign is filtered and removed from CAMPES. This state is non-reversible. */
    CampaignExpiryLevel["ExpiredStreamFiltered"] = "EXPIRED_STREAM_FILTERED";
    /** Campaign is flagged for expiry monitoring. This state is reversible. */
    CampaignExpiryLevel["MarkedForExpiry"] = "MARKED_FOR_EXPIRY";
    /** Campaign is not expired and operates normally. */
    CampaignExpiryLevel["Unexpired"] = "UNEXPIRED";
})(CampaignExpiryLevel || (CampaignExpiryLevel = {}));
/** Enum representing the reason for campaign expiry. */
export var CampaignExpiryReason;
(function (CampaignExpiryReason) {
    /** Campaign was expired because it is a keyword campaign. */
    CampaignExpiryReason["KeywordCampaign"] = "KEYWORD_CAMPAIGN";
    /** Campaign was expired because it is an orphaned Dradis campaign (Pre One Delivery / Unlinked SMB Campaign). */
    CampaignExpiryReason["OrphanedDradisCampaign"] = "ORPHANED_DRADIS_CAMPAIGN";
})(CampaignExpiryReason || (CampaignExpiryReason = {}));
/**
 * Constraints are applied to the campaign, as per an external reference type which is natively respected by the platform. These constraints may be related to campaigns, jobs, budget etc.
 * This enum is non-exhaustive and new values may be added from time to time.
 */
export var CampaignExtRefType;
(function (CampaignExtRefType) {
    /** SMB_MULTI_JOB campaign is a type of SMB campaign where a campaign will have multiple hosted jobs in it, however the jobs cannot be sponsored by other campaigns which handle hosted jobs. */
    CampaignExtRefType["SmbMultiJob"] = "SMB_MULTI_JOB";
    /** SMB_SINGLE_JOB campaign is a type of SMB campaign where a campaign will have only one hosted job in it, which cannot be sponsored by other campaigns which handle hosted jobs */
    CampaignExtRefType["SmbSingleJob"] = "SMB_SINGLE_JOB";
})(CampaignExtRefType || (CampaignExtRefType = {}));
/**
 * The funding source for a campaign.
 * Determines how the campaign spend is funded.
 *
 * If no value is set, it defaults to ADVERTISER.
 *
 * This enum is non-exhaustive and new values may be added from time to time.
 */
export var CampaignFundingSource;
(function (CampaignFundingSource) {
    /** Campaign funded by advertiser's standard budget (default). */
    CampaignFundingSource["Advertiser"] = "ADVERTISER";
    /** Campaign funded by Enterprise Agreement credits. */
    CampaignFundingSource["EaCredit"] = "EA_CREDIT";
})(CampaignFundingSource || (CampaignFundingSource = {}));
/**
 * Defines the recurring duration of the job expectation.
 * For example if it’s monthly then the job expectation is refreshed monthly by the value.
 *
 * This enum is non-exhaustive and new values will be added from time to time.
 */
export var CampaignJobExpectationDuration;
(function (CampaignJobExpectationDuration) {
    CampaignJobExpectationDuration["Daily"] = "DAILY";
    CampaignJobExpectationDuration["Monthly"] = "MONTHLY";
    CampaignJobExpectationDuration["Onetime"] = "ONETIME";
})(CampaignJobExpectationDuration || (CampaignJobExpectationDuration = {}));
/**
 * Defines different job expectation outcome cap types
 * CAP: we should not go over this threshold but it's okay not to reach the threshold
 *
 * This enum is non-exhaustive and new values will be added from time to time.
 */
export var CampaignJobExpectationOutcomeCapType;
(function (CampaignJobExpectationOutcomeCapType) {
    CampaignJobExpectationOutcomeCapType["OutcomeApplyCap"] = "OUTCOME_APPLY_CAP";
    CampaignJobExpectationOutcomeCapType["OutcomeStartedApplyCap"] = "OUTCOME_STARTED_APPLY_CAP";
})(CampaignJobExpectationOutcomeCapType || (CampaignJobExpectationOutcomeCapType = {}));
/**
 * Defines different job expectation outcome target types
 * TARGET: a goal to reach for outcome or budget on job, it's okay to be under or over
 *
 * This enum is non-exhaustive and new values will be added from time to time.
 */
export var CampaignJobExpectationOutcomeTargetType;
(function (CampaignJobExpectationOutcomeTargetType) {
    CampaignJobExpectationOutcomeTargetType["OutcomeApplyTarget"] = "OUTCOME_APPLY_TARGET";
    CampaignJobExpectationOutcomeTargetType["OutcomeStartedApplyTarget"] = "OUTCOME_STARTED_APPLY_TARGET";
})(CampaignJobExpectationOutcomeTargetType || (CampaignJobExpectationOutcomeTargetType = {}));
/**
 * The type of job ID used in static job lists.
 *
 * This enum is non-exhaustive and new values may be added from time to time.
 */
export var CampaignJobQueryGroupJobIdType;
(function (CampaignJobQueryGroupJobIdType) {
    /**
     *   An employer job ID is a UUID that uniquely represents an employer’s overall “hiring need” on Indeed.
     *
     * Example: "5b9fc07b-c7db-4a94-b907-8324bf5114bf"
     */
    CampaignJobQueryGroupJobIdType["EmployerJobId"] = "EMPLOYER_JOB_ID";
    /**
     *   A unique identifier for the job within the ATS. This was historically referred to as the
     *   “reference number”, but it is rarely an actual number, and in many places its actually called
     *   referenceId like jobArchive, its called external requisition id in Employer Job domain.
     *
     * Example: "R003B85NV34"
     */
    CampaignJobQueryGroupJobIdType["ReferenceNumber"] = "REFERENCE_NUMBER";
})(CampaignJobQueryGroupJobIdType || (CampaignJobQueryGroupJobIdType = {}));
/** Defines the legacy objective type. */
export var CampaignLegacyObjectiveType;
(function (CampaignLegacyObjectiveType) {
    /** Balances the budget across all jobs within the Campaign. This aims to deliver as many applications as possible. */
    CampaignLegacyObjectiveType["Balance"] = "BALANCE";
    /**
     * Does not balance budget across jobs. This may result in some jobs using the majority of the budget.
     * Delivers as many applications as possible but will favor some jobs over others.
     */
    CampaignLegacyObjectiveType["Budget"] = "BUDGET";
    /**
     * Set a specific number of interviews to target for the jobs within a campaign.
     * This can be set to the same number for all jobs, or tailored for unique jobs.
     * When the target number of interviews is hit, spend on these jobs will be significantly reduced and allocated elsewhere.
     */
    CampaignLegacyObjectiveType["Interview"] = "INTERVIEW";
    /** An experimental objective, which enables results to be delivered as quickly as possible. */
    CampaignLegacyObjectiveType["Quick"] = "QUICK";
    /**
     * Set a specific number of applications to target for the jobs within a campaign.
     * This can be set to the same number for all jobs, or tailored for unique jobs.
     * When the target number of applications is hit, spend on these jobs will be significantly reduced and allocated elsewhere.
     */
    CampaignLegacyObjectiveType["TargetApplies"] = "TARGET_APPLIES";
    /**
     * Target Cost Per Application.
     * The Campaign will aim to achieve the selected Cost Per Apply price across the Campaign.
     */
    CampaignLegacyObjectiveType["Tcpa"] = "TCPA";
    /** The Campaign does not have any specified Objective, it will not be optimized. */
    CampaignLegacyObjectiveType["Unspecified"] = "UNSPECIFIED";
})(CampaignLegacyObjectiveType || (CampaignLegacyObjectiveType = {}));
/**
 * The model version of the campaign
 *
 * - DEFAULT signifies interoperability with gRPC APIs
 * - INTERMEDIATE signifies non interoperability with gRPC APIs,
 * and that the campaign uses new features introduced in the GraphQL API
 * - FINAL signifies that this is the final state of the campaign,
 * and it is not interoperable with gRPC APIs
 *
 * This enum is exhaustive
 */
export var CampaignModelVersion;
(function (CampaignModelVersion) {
    CampaignModelVersion["Default"] = "DEFAULT";
    CampaignModelVersion["Final"] = "FINAL";
    CampaignModelVersion["Intermediate"] = "INTERMEDIATE";
})(CampaignModelVersion || (CampaignModelVersion = {}));
/**
 * Defines the desired outcome.
 *
 * This enum is non-exhaustive and new values will be added from time to time.
 */
export var CampaignObjective;
(function (CampaignObjective) {
    CampaignObjective["Apply"] = "APPLY";
    CampaignObjective["ApplyStart"] = "APPLY_START";
    CampaignObjective["Click"] = "CLICK";
    CampaignObjective["InterviewRsvp"] = "INTERVIEW_RSVP";
})(CampaignObjective || (CampaignObjective = {}));
/** The subscription tier for a package */
export var CampaignOfferPackageTier;
(function (CampaignOfferPackageTier) {
    CampaignOfferPackageTier["Premium"] = "PREMIUM";
    CampaignOfferPackageTier["PremiumPlus"] = "PREMIUM_PLUS";
    CampaignOfferPackageTier["Standard"] = "STANDARD";
})(CampaignOfferPackageTier || (CampaignOfferPackageTier = {}));
/** Features available on a Premium Package */
export var CampaignPackageFeatureName;
(function (CampaignPackageFeatureName) {
    /** Represents that this is a branded campaign */
    CampaignPackageFeatureName["Brand"] = "BRAND";
    /** Instant Match: Invite people who match the job description to apply */
    CampaignPackageFeatureName["Im"] = "IM";
    /** Location Targeting: Attract people within X miles of the job */
    CampaignPackageFeatureName["Loc"] = "LOC";
    /** Minimum Occupation Criteria: Promote only to people whose profile fits relevant criteria */
    CampaignPackageFeatureName["Moc"] = "MOC";
    /** Label to show that there is urgent hiring */
    CampaignPackageFeatureName["Urgent"] = "URGENT";
})(CampaignPackageFeatureName || (CampaignPackageFeatureName = {}));
/**
 * Granularity for performance.
 *
 * By default no aggregation, which means client want performance for
 * the entire query date range @CampaignPerformanceTimeRangeInput
 */
export var CampaignPerformanceTimeRangeGranularityInput;
(function (CampaignPerformanceTimeRangeGranularityInput) {
    /** Metric aggregated on daily basis. */
    CampaignPerformanceTimeRangeGranularityInput["Daily"] = "DAILY";
})(CampaignPerformanceTimeRangeGranularityInput || (CampaignPerformanceTimeRangeGranularityInput = {}));
/** Channel dimension for the performance. */
export var CampaignPerformancesChannelInput;
(function (CampaignPerformancesChannelInput) {
    /** Performance with channel as Glassdoor. */
    CampaignPerformancesChannelInput["Glassdoor"] = "GLASSDOOR";
    /** Performance with channel as Indeed. */
    CampaignPerformancesChannelInput["Indeed"] = "INDEED";
    /** Performance on offsite network. */
    CampaignPerformancesChannelInput["OffsiteAudienceNetwork"] = "OFFSITE_AUDIENCE_NETWORK";
    /** Performance on other channel. */
    CampaignPerformancesChannelInput["Other"] = "OTHER";
    /** Performance with channel as TMN. */
    CampaignPerformancesChannelInput["TrustedMediaNetwork"] = "TRUSTED_MEDIA_NETWORK";
})(CampaignPerformancesChannelInput || (CampaignPerformancesChannelInput = {}));
/** Device dimension for the performance. */
export var CampaignPerformancesDeviceInput;
(function (CampaignPerformancesDeviceInput) {
    /** Performance across device as desktop. */
    CampaignPerformancesDeviceInput["Desktop"] = "DESKTOP";
    /** Performance across device as mobile. */
    CampaignPerformancesDeviceInput["Mobile"] = "MOBILE";
    /** Performance for unknown device */
    CampaignPerformancesDeviceInput["Other"] = "OTHER";
})(CampaignPerformancesDeviceInput || (CampaignPerformancesDeviceInput = {}));
/** Traffic dimension for the performance. */
export var CampaignPerformancesTrafficInput;
(function (CampaignPerformancesTrafficInput) {
    /** Performance for the organic traffic. */
    CampaignPerformancesTrafficInput["Organic"] = "ORGANIC";
    /** Performance across unknown traffic. */
    CampaignPerformancesTrafficInput["Other"] = "OTHER";
    /** Performance for the sponsored traffic. */
    CampaignPerformancesTrafficInput["Sponsored"] = "SPONSORED";
})(CampaignPerformancesTrafficInput || (CampaignPerformancesTrafficInput = {}));
/**
 * The pricing model of the campaign decides how the campaign will be charged,
 * whether it is per-click or per-outcome.
 *
 * This enum is non-exhaustive and new values will be added from time to time.
 */
export var CampaignPricingModel;
(function (CampaignPricingModel) {
    CampaignPricingModel["ApiCost"] = "API_COST";
    CampaignPricingModel["FairSpend"] = "FAIR_SPEND";
    CampaignPricingModel["PayPerApplication"] = "PAY_PER_APPLICATION";
    CampaignPricingModel["PayPerClick"] = "PAY_PER_CLICK";
    CampaignPricingModel["PayPerDay"] = "PAY_PER_DAY";
    CampaignPricingModel["PayPerHire"] = "PAY_PER_HIRE";
    CampaignPricingModel["PayPerSmartSourcingUpsell"] = "PAY_PER_SMART_SOURCING_UPSELL";
    CampaignPricingModel["PayPerStartedApplication"] = "PAY_PER_STARTED_APPLICATION";
    CampaignPricingModel["PayPerStartedRsvp"] = "PAY_PER_STARTED_RSVP";
})(CampaignPricingModel || (CampaignPricingModel = {}));
/**
 * Defines the time period which influences when a proration period is reset.
 * Must be only used for campaigns with recurringUnit as MONTHLY.
 *
 * This enum is non-exhaustive and new values will be added from time to time.
 */
export var CampaignProrationPeriodResetSubRange;
(function (CampaignProrationPeriodResetSubRange) {
    CampaignProrationPeriodResetSubRange["Always"] = "ALWAYS";
    CampaignProrationPeriodResetSubRange["FirstMonthOnly"] = "FIRST_MONTH_ONLY";
    CampaignProrationPeriodResetSubRange["Never"] = "NEVER";
})(CampaignProrationPeriodResetSubRange || (CampaignProrationPeriodResetSubRange = {}));
/** Campaign target types available for recommendations */
export var CampaignRecommendationTarget;
(function (CampaignRecommendationTarget) {
    /** Premium campaign targeting */
    CampaignRecommendationTarget["Premium"] = "PREMIUM";
    /** Standard campaign targeting */
    CampaignRecommendationTarget["Standard"] = "STANDARD";
})(CampaignRecommendationTarget || (CampaignRecommendationTarget = {}));
/** "Smart Sourcing" Ad's all possible statuses */
export var CampaignSmartSourcingAdStatus;
(function (CampaignSmartSourcingAdStatus) {
    CampaignSmartSourcingAdStatus["Active"] = "ACTIVE";
    CampaignSmartSourcingAdStatus["Deleted"] = "DELETED";
    CampaignSmartSourcingAdStatus["Paused"] = "PAUSED";
})(CampaignSmartSourcingAdStatus || (CampaignSmartSourcingAdStatus = {}));
/**
 * Maps to the Spending eligibility definition in the campaign-job mapping domain.
 *
 * doc: https://indeed.atlassian.net/wiki/x/_YuVEw
 */
export var CampaignSpendingEligibilityEnum;
(function (CampaignSpendingEligibilityEnum) {
    CampaignSpendingEligibilityEnum["FullSpendingEligibility"] = "FULL_SPENDING_ELIGIBILITY";
    CampaignSpendingEligibilityEnum["FundedPeriodEligibility"] = "FUNDED_PERIOD_ELIGIBILITY";
    CampaignSpendingEligibilityEnum["NonPacingSpendingEligibility"] = "NON_PACING_SPENDING_ELIGIBILITY";
    CampaignSpendingEligibilityEnum["PremiumFeatureEligibility"] = "PREMIUM_FEATURE_ELIGIBILITY";
    CampaignSpendingEligibilityEnum["ScheduledPeriodEligibility"] = "SCHEDULED_PERIOD_ELIGIBILITY";
    CampaignSpendingEligibilityEnum["UserSpendingEligibility"] = "USER_SPENDING_ELIGIBILITY";
})(CampaignSpendingEligibilityEnum || (CampaignSpendingEligibilityEnum = {}));
/** Enum of availabile eligibility types to filter on */
export var CampaignSpendingEligibilityType;
(function (CampaignSpendingEligibilityType) {
    CampaignSpendingEligibilityType["FullSpendingEligibility"] = "FULL_SPENDING_ELIGIBILITY";
    CampaignSpendingEligibilityType["FundedPeriodEligibility"] = "FUNDED_PERIOD_ELIGIBILITY";
    CampaignSpendingEligibilityType["UserSpendingEligibility"] = "USER_SPENDING_ELIGIBILITY";
})(CampaignSpendingEligibilityType || (CampaignSpendingEligibilityType = {}));
/**
 * Different Spending Ineligibility Reasons.
 *
 * This enum is non-exhaustive and new values will be added from time to time.
 */
export var CampaignSpendingIneligibilityReason;
(function (CampaignSpendingIneligibilityReason) {
    /** credit related reasons  */
    CampaignSpendingIneligibilityReason["AdvertiserCreditUnavailable"] = "ADVERTISER_CREDIT_UNAVAILABLE";
    /** advertiser monthly budget hit  */
    CampaignSpendingIneligibilityReason["AdvertiserMonthlyBudgetHit"] = "ADVERTISER_MONTHLY_BUDGET_HIT";
    /** end date related reasons  */
    CampaignSpendingIneligibilityReason["AfterEndDate"] = "AFTER_END_DATE";
    /** campaign is archived  */
    CampaignSpendingIneligibilityReason["ArchivedCampaign"] = "ARCHIVED_CAMPAIGN";
    /** start date & end date related reasons  */
    CampaignSpendingIneligibilityReason["BeforeStartDate"] = "BEFORE_START_DATE";
    /** Billing pending for advertiser  */
    CampaignSpendingIneligibilityReason["BillingPending"] = "BILLING_PENDING";
    /** job source is not verified */
    CampaignSpendingIneligibilityReason["JobSourceNotVerified"] = "JOB_SOURCE_NOT_VERIFIED";
    /** job source is null  */
    CampaignSpendingIneligibilityReason["JobSourceStatusIsNull"] = "JOB_SOURCE_STATUS_IS_NULL";
    /** max applies related reasons  */
    CampaignSpendingIneligibilityReason["MaxAppliesHit"] = "MAX_APPLIES_HIT";
    /** campaign monthly budget hit  */
    CampaignSpendingIneligibilityReason["MonthlyBudgetHit"] = "MONTHLY_BUDGET_HIT";
    /** campaign one time budget hit  */
    CampaignSpendingIneligibilityReason["OnetimeBudgetHit"] = "ONETIME_BUDGET_HIT";
    /** campaign is paused  */
    CampaignSpendingIneligibilityReason["PausedCampaign"] = "PAUSED_CAMPAIGN";
})(CampaignSpendingIneligibilityReason || (CampaignSpendingIneligibilityReason = {}));
/**
 * Different Spending Ineligibility System Driven Reasons.
 *
 * This enum is non-exhaustive and new values will be added from time to time.
 */
export var CampaignSpendingIneligibilitySystemDrivenReason;
(function (CampaignSpendingIneligibilitySystemDrivenReason) {
    /** campaign daily budget hit  */
    CampaignSpendingIneligibilitySystemDrivenReason["DailyBudgetHit"] = "DAILY_BUDGET_HIT";
})(CampaignSpendingIneligibilitySystemDrivenReason || (CampaignSpendingIneligibilitySystemDrivenReason = {}));
/**
 * The sponsorship tier of the campaign.
 *
 * This enum is non-exhaustive and new values may be added in future.
 */
export var CampaignSponsorshipTier;
(function (CampaignSponsorshipTier) {
    /**
     * Default tier for hosted campaigns when no tier is explicitly provided.
     * Only valid for hosted campaigns.
     */
    CampaignSponsorshipTier["Basic"] = "BASIC";
    CampaignSponsorshipTier["CustomPremium"] = "CUSTOM_PREMIUM";
    CampaignSponsorshipTier["CustomPremiumPlus"] = "CUSTOM_PREMIUM_PLUS";
    CampaignSponsorshipTier["CustomStandard"] = "CUSTOM_STANDARD";
    CampaignSponsorshipTier["Enhanced"] = "ENHANCED";
    CampaignSponsorshipTier["LegacyPremium"] = "LEGACY_PREMIUM";
    /**
     * Default tier for source campaigns when no tier is explicitly provided.
     * Only valid for source campaigns.
     */
    CampaignSponsorshipTier["NonTiered"] = "NON_TIERED";
    CampaignSponsorshipTier["Premium"] = "PREMIUM";
    CampaignSponsorshipTier["PremiumPlus"] = "PREMIUM_PLUS";
    CampaignSponsorshipTier["Standard"] = "STANDARD";
})(CampaignSponsorshipTier || (CampaignSponsorshipTier = {}));
/**
 * The status of the campaign, whether it is active or not.
 *
 * This enum is non-exhaustive and new values will be added from time to time.
 */
export var CampaignStatus;
(function (CampaignStatus) {
    CampaignStatus["Active"] = "ACTIVE";
    CampaignStatus["Archived"] = "ARCHIVED";
    CampaignStatus["Paused"] = "PAUSED";
})(CampaignStatus || (CampaignStatus = {}));
/**  Possible campaign status types in JobCampaignDetailsInput  */
export var CampaignStatusType;
(function (CampaignStatusType) {
    CampaignStatusType["Active"] = "ACTIVE";
    CampaignStatusType["Deleted"] = "DELETED";
    CampaignStatusType["Paused"] = "PAUSED";
})(CampaignStatusType || (CampaignStatusType = {}));
export var CancellationType;
(function (CancellationType) {
    CancellationType["Cancelled"] = "CANCELLED";
    CancellationType["Declined"] = "DECLINED";
})(CancellationType || (CancellationType = {}));
/** Enum of access types used as input to checkCandidateSubmissionAccess query */
export var CandidateAccessPermission;
(function (CandidateAccessPermission) {
    CandidateAccessPermission["Read"] = "READ";
    CandidateAccessPermission["ReadOrProfileRead"] = "READ_OR_PROFILE_READ";
    CandidateAccessPermission["Update"] = "UPDATE";
})(CandidateAccessPermission || (CandidateAccessPermission = {}));
/** Enum of access results used in payload of checkCandidateSubmissionAccess query */
export var CandidateAccessResult;
(function (CandidateAccessResult) {
    CandidateAccessResult["Denied"] = "DENIED";
    CandidateAccessResult["Granted"] = "GRANTED";
    CandidateAccessResult["Hidden"] = "HIDDEN";
    CandidateAccessResult["NotFound"] = "NOT_FOUND";
})(CandidateAccessResult || (CandidateAccessResult = {}));
/** Enum of candidate attribute of auto contact timestamp */
export var CandidateAttribute;
(function (CandidateAttribute) {
    /** CANDAUTO_AUTO_CONTACT_SCHEDULE_TIME */
    CandidateAttribute["CandautoAutoContactScheduleTime"] = "CANDAUTO_AUTO_CONTACT_SCHEDULE_TIME";
    /** CANDAUTO_AUTO_CONTACT_SENT_TIMESTAMP */
    CandidateAttribute["CandautoAutoContactSentTimestamp"] = "CANDAUTO_AUTO_CONTACT_SENT_TIMESTAMP";
})(CandidateAttribute || (CandidateAttribute = {}));
export var CandidateAutomationActionStatus;
(function (CandidateAutomationActionStatus) {
    CandidateAutomationActionStatus["Canceled"] = "CANCELED";
    CandidateAutomationActionStatus["Completed"] = "COMPLETED";
    CandidateAutomationActionStatus["NotQualified"] = "NOT_QUALIFIED";
    CandidateAutomationActionStatus["NotScheduled"] = "NOT_SCHEDULED";
    CandidateAutomationActionStatus["Pending"] = "PENDING";
    CandidateAutomationActionStatus["Started"] = "STARTED";
})(CandidateAutomationActionStatus || (CandidateAutomationActionStatus = {}));
export var CandidateBioSourceType;
(function (CandidateBioSourceType) {
    CandidateBioSourceType["AtsApplication"] = "ATS_APPLICATION";
    CandidateBioSourceType["AtsCandidate"] = "ATS_CANDIDATE";
    CandidateBioSourceType["AutosourcerInvite"] = "AUTOSOURCER_INVITE";
    CandidateBioSourceType["FlexInterview"] = "FLEX_INTERVIEW";
    CandidateBioSourceType["GuidedDiscoveryReplay"] = "GUIDED_DISCOVERY_REPLAY";
    CandidateBioSourceType["HireReplay"] = "HIRE_REPLAY";
    CandidateBioSourceType["HiringEvent"] = "HIRING_EVENT";
    CandidateBioSourceType["HorizonSourcing"] = "HORIZON_SOURCING";
    CandidateBioSourceType["IndeedApply"] = "INDEED_APPLY";
    CandidateBioSourceType["IndeedPlusScout"] = "INDEED_PLUS_SCOUT";
    CandidateBioSourceType["LegacyInvited"] = "LEGACY_INVITED";
    CandidateBioSourceType["LegacyMatch"] = "LEGACY_MATCH";
    CandidateBioSourceType["LegacyReferral"] = "LEGACY_REFERRAL";
    CandidateBioSourceType["Manual"] = "MANUAL";
    CandidateBioSourceType["Match"] = "MATCH";
    CandidateBioSourceType["PremiumInvite"] = "PREMIUM_INVITE";
    CandidateBioSourceType["ResumeSearch"] = "RESUME_SEARCH";
    CandidateBioSourceType["ResumeSearchFastApply"] = "RESUME_SEARCH_FAST_APPLY";
    CandidateBioSourceType["SavedSourcingCandidate"] = "SAVED_SOURCING_CANDIDATE";
    CandidateBioSourceType["Text_2Apply"] = "TEXT_2_APPLY";
    CandidateBioSourceType["ThirdPartyIndeedApply"] = "THIRD_PARTY_INDEED_APPLY";
})(CandidateBioSourceType || (CandidateBioSourceType = {}));
export var CandidateBioWorkAuthorizationType;
(function (CandidateBioWorkAuthorizationType) {
    CandidateBioWorkAuthorizationType["SgCitizen"] = "SG_CITIZEN";
    CandidateBioWorkAuthorizationType["SgEmploymentPass"] = "SG_EMPLOYMENT_PASS";
    CandidateBioWorkAuthorizationType["SgOther"] = "SG_OTHER";
    CandidateBioWorkAuthorizationType["SgSponsorship"] = "SG_SPONSORSHIP";
    CandidateBioWorkAuthorizationType["SgTrainingEmploymentPass"] = "SG_TRAINING_EMPLOYMENT_PASS";
    CandidateBioWorkAuthorizationType["UnknownAuthorization"] = "UNKNOWN_AUTHORIZATION";
    CandidateBioWorkAuthorizationType["UsEligible"] = "US_ELIGIBLE";
    CandidateBioWorkAuthorizationType["UsWithSponsorship"] = "US_WITH_SPONSORSHIP";
    CandidateBioWorkAuthorizationType["Yes"] = "YES";
})(CandidateBioWorkAuthorizationType || (CandidateBioWorkAuthorizationType = {}));
export var CandidateEngagementStatusEnum;
(function (CandidateEngagementStatusEnum) {
    CandidateEngagementStatusEnum["Accepted"] = "ACCEPTED";
    CandidateEngagementStatusEnum["Expired"] = "EXPIRED";
    CandidateEngagementStatusEnum["Pending"] = "PENDING";
    CandidateEngagementStatusEnum["Refused"] = "REFUSED";
})(CandidateEngagementStatusEnum || (CandidateEngagementStatusEnum = {}));
/** Candidate feedback note types */
export var CandidateFeedbackNoteType;
(function (CandidateFeedbackNoteType) {
    /** General candidate feedback note (the default value) */
    CandidateFeedbackNoteType["General"] = "GENERAL";
    /** Candidate feedback note with a reason for a candidate rejection */
    CandidateFeedbackNoteType["RejectionReason"] = "REJECTION_REASON";
})(CandidateFeedbackNoteType || (CandidateFeedbackNoteType = {}));
/** Candidate feedback related entities types */
export var CandidateFeedbackRelatedEntityType;
(function (CandidateFeedbackRelatedEntityType) {
    CandidateFeedbackRelatedEntityType["CollaborationRequest"] = "COLLABORATION_REQUEST";
    CandidateFeedbackRelatedEntityType["Feedback"] = "FEEDBACK";
})(CandidateFeedbackRelatedEntityType || (CandidateFeedbackRelatedEntityType = {}));
/** Candidate feedback sentiment values. */
export var CandidateFeedbackSentimentValue;
(function (CandidateFeedbackSentimentValue) {
    /** Negative sentiment value */
    CandidateFeedbackSentimentValue["Negative"] = "NEGATIVE";
    /** Positive sentiment value */
    CandidateFeedbackSentimentValue["Positive"] = "POSITIVE";
    /** Undecided sentiment value */
    CandidateFeedbackSentimentValue["Undecided"] = "UNDECIDED";
    /** Unset sentiment value */
    CandidateFeedbackSentimentValue["Unset"] = "UNSET";
})(CandidateFeedbackSentimentValue || (CandidateFeedbackSentimentValue = {}));
/** The different sources of feedback within CAFEEN. */
export var CandidateFeedbackSource;
(function (CandidateFeedbackSource) {
    /**
     * Feedback provided through the Candidate Management UI.
     * It is linked to a candidate, and to a Candidate Submission.
     * In the future, will also be linked to a Hiring Journey.
     */
    CandidateFeedbackSource["CandidateManagement"] = "CANDIDATE_MANAGEMENT";
    /**
     * Feedback provided through Dradis. Source cannot be used for creating feedback through GraphQL, only for filtering.
     * It is linked to a candidate, and to a Candidate Submission.
     * In the future, will also be linked to a Hiring Journey.
     *
     * Note: filtering by DRADIS is incomplete — it does not include feedback records ingested via the
     * Roaster Dradis Backfill (stored under ROASTER_DRADIS_BACKFILL, which is not exposed for filtering
     * through GraphQL). Reach out to the Candidate Management Platform Capabilities team if you need
     * full Dradis coverage.
     */
    CandidateFeedbackSource["Dradis"] = "DRADIS";
    /**
     * Feedback provided through EEGQL.
     * It is linked to a Candidate Submission and Candidate.
     */
    CandidateFeedbackSource["EegqlUcp"] = "EEGQL_UCP";
    /**
     * Feedback provided through Horizon UI.
     * It is linked to a candidate, and to a Candidate Submission.
     * In the future, will also be linked to a Hiring Journey.
     */
    CandidateFeedbackSource["Horizon"] = "HORIZON";
    /**
     * Internal source representing feedback ingested via Roaster's Dradis Backfill. This value exists for
     * backwards compatibility with persisted records and the gRPC API; it is not intended for use by
     * GraphQL clients. Creating feedback and filtering with this source via GraphQL is rejected — if you need Dradis coverage,
     * filter by DRADIS and reach out to the Candidate Management Platform Capabilities team to ensure backfill records are included.
     */
    CandidateFeedbackSource["RoasterDradisBackfill"] = "ROASTER_DRADIS_BACKFILL";
})(CandidateFeedbackSource || (CandidateFeedbackSource = {}));
/** Candidate feedback types */
export var CandidateFeedbackType;
(function (CandidateFeedbackType) {
    CandidateFeedbackType["Note"] = "NOTE";
    CandidateFeedbackType["Rating"] = "RATING";
    CandidateFeedbackType["Sentiment"] = "SENTIMENT";
})(CandidateFeedbackType || (CandidateFeedbackType = {}));
/** Importance level of a criterion */
export var CandidateFitEvaluationImportance;
(function (CandidateFitEvaluationImportance) {
    CandidateFitEvaluationImportance["Preferred"] = "PREFERRED";
    CandidateFitEvaluationImportance["Required"] = "REQUIRED";
    CandidateFitEvaluationImportance["Unspecified"] = "UNSPECIFIED";
})(CandidateFitEvaluationImportance || (CandidateFitEvaluationImportance = {}));
/** Match status for a criterion */
export var CandidateFitEvaluationMatchStatus;
(function (CandidateFitEvaluationMatchStatus) {
    CandidateFitEvaluationMatchStatus["Met"] = "MET";
    CandidateFitEvaluationMatchStatus["Unknown"] = "UNKNOWN";
    CandidateFitEvaluationMatchStatus["Unmet"] = "UNMET";
})(CandidateFitEvaluationMatchStatus || (CandidateFitEvaluationMatchStatus = {}));
/** Match status for a criterion */
export var CandidateFitMatchStatus;
(function (CandidateFitMatchStatus) {
    CandidateFitMatchStatus["Met"] = "MET";
    CandidateFitMatchStatus["Unknown"] = "UNKNOWN";
    CandidateFitMatchStatus["Unmet"] = "UNMET";
})(CandidateFitMatchStatus || (CandidateFitMatchStatus = {}));
/** @deprecated Use summaryStats instead */
export var CandidateFitSummaryLabel;
(function (CandidateFitSummaryLabel) {
    /** Label candidate as not a match */
    CandidateFitSummaryLabel["NotAMatch"] = "NOT_A_MATCH";
    /** Label candidate as a partial match */
    CandidateFitSummaryLabel["Partial"] = "PARTIAL";
    /** Label candidate as a strong match */
    CandidateFitSummaryLabel["Strong"] = "STRONG";
})(CandidateFitSummaryLabel || (CandidateFitSummaryLabel = {}));
/** The different types of context for a custom key to create a group */
export var CandidateGroupCustomKeyContext;
(function (CandidateGroupCustomKeyContext) {
    /** Context containing all the CURRENT_ADVERTISER custom keys created for the advertiser. */
    CandidateGroupCustomKeyContext["CurrentAdvertiser"] = "CURRENT_ADVERTISER";
    /** Context containing all CURRENT_USER custom keys created by the user making the request. */
    CandidateGroupCustomKeyContext["CurrentUser"] = "CURRENT_USER";
    /**
     * Context containing all INTERNAL custom keys for the advertiser.  Only Indeed private clients can create
     * custom keys in this context.
     */
    CandidateGroupCustomKeyContext["Internal"] = "INTERNAL";
})(CandidateGroupCustomKeyContext || (CandidateGroupCustomKeyContext = {}));
/** The different types of permissions a metadata user has */
export var CandidateGroupPermissionType;
(function (CandidateGroupPermissionType) {
    CandidateGroupPermissionType["Admin"] = "ADMIN";
    CandidateGroupPermissionType["Editor"] = "EDITOR";
    CandidateGroupPermissionType["Viewer"] = "VIEWER";
})(CandidateGroupPermissionType || (CandidateGroupPermissionType = {}));
export var CandidateJourneyAccessPermission;
(function (CandidateJourneyAccessPermission) {
    CandidateJourneyAccessPermission["Read"] = "READ";
    CandidateJourneyAccessPermission["Update"] = "UPDATE";
})(CandidateJourneyAccessPermission || (CandidateJourneyAccessPermission = {}));
/** The status that a Candidate Journey is in */
export var CandidateJourneyStatus;
(function (CandidateJourneyStatus) {
    /** The Candidate Journey is in active status. */
    CandidateJourneyStatus["Active"] = "ACTIVE";
    /**
     * An initiated candidate journey has been created in the source of truth but has not been fully initialized.
     * Data expected to be associated with the journey is not guaranteed to be present yet.
     */
    CandidateJourneyStatus["Initiated"] = "INITIATED";
    /** The Candidate Journey is in terminated status. */
    CandidateJourneyStatus["Terminated"] = "TERMINATED";
})(CandidateJourneyStatus || (CandidateJourneyStatus = {}));
export var CandidateRejectionReasonEnum;
(function (CandidateRejectionReasonEnum) {
    CandidateRejectionReasonEnum["ArrangementLocationNotCompatible"] = "ARRANGEMENT_LOCATION_NOT_COMPATIBLE";
    CandidateRejectionReasonEnum["CandidateAlreadySubmitted"] = "CANDIDATE_ALREADY_SUBMITTED";
    CandidateRejectionReasonEnum["CandidateIneligibleToWork"] = "CANDIDATE_INELIGIBLE_TO_WORK";
    CandidateRejectionReasonEnum["LacksCertificationEducation"] = "LACKS_CERTIFICATION_EDUCATION";
    CandidateRejectionReasonEnum["LacksSkillsExperience"] = "LACKS_SKILLS_EXPERIENCE";
    CandidateRejectionReasonEnum["OfferExtendedToAnotherCandidate"] = "OFFER_EXTENDED_TO_ANOTHER_CANDIDATE";
    CandidateRejectionReasonEnum["Other"] = "OTHER";
    CandidateRejectionReasonEnum["SalaryExpectationsTooHigh"] = "SALARY_EXPECTATIONS_TOO_HIGH";
})(CandidateRejectionReasonEnum || (CandidateRejectionReasonEnum = {}));
/** Available candidate result viewing structures are GRID/LIST */
export var CandidateResultViewOption;
(function (CandidateResultViewOption) {
    /** Candidate results should be rendered using a grid view */
    CandidateResultViewOption["Grid"] = "GRID";
    /** Candidate results should be rendered using a list view */
    CandidateResultViewOption["List"] = "LIST";
})(CandidateResultViewOption || (CandidateResultViewOption = {}));
export var CandidateSourceEnum;
(function (CandidateSourceEnum) {
    CandidateSourceEnum["Created"] = "CREATED";
    CandidateSourceEnum["SmartSource"] = "SMART_SOURCE";
})(CandidateSourceEnum || (CandidateSourceEnum = {}));
/** Types of source events */
export var CandidateSourceEventType;
(function (CandidateSourceEventType) {
    CandidateSourceEventType["CallbackRelay"] = "CALLBACK_RELAY";
    CandidateSourceEventType["ClickToCall"] = "CLICK_TO_CALL";
    CandidateSourceEventType["DirectToInterview"] = "DIRECT_TO_INTERVIEW";
    CandidateSourceEventType["EmailReceived"] = "EMAIL_RECEIVED";
    CandidateSourceEventType["EmailSent"] = "EMAIL_SENT";
    CandidateSourceEventType["EmployerManualInvite"] = "EMPLOYER_MANUAL_INVITE";
    CandidateSourceEventType["JobseekerInitiated"] = "JOBSEEKER_INITIATED";
    CandidateSourceEventType["Note"] = "NOTE";
    CandidateSourceEventType["RejectionReason"] = "REJECTION_REASON";
    CandidateSourceEventType["UntrackedPhone"] = "UNTRACKED_PHONE";
})(CandidateSourceEventType || (CandidateSourceEventType = {}));
/** Types of source products */
export var CandidateSourceProduct;
(function (CandidateSourceProduct) {
    CandidateSourceProduct["AdhocInterview"] = "ADHOC_INTERVIEW";
    CandidateSourceProduct["CmiInternalAts"] = "CMI_INTERNAL_ATS";
    CandidateSourceProduct["ExternalAts"] = "EXTERNAL_ATS";
    CandidateSourceProduct["Flex"] = "FLEX";
    CandidateSourceProduct["Hire"] = "HIRE";
    CandidateSourceProduct["IndeedApply"] = "INDEED_APPLY";
    CandidateSourceProduct["IndeedHiringPlatform"] = "INDEED_HIRING_PLATFORM";
    CandidateSourceProduct["InstantMatch"] = "INSTANT_MATCH";
    CandidateSourceProduct["InternalAts"] = "INTERNAL_ATS";
    CandidateSourceProduct["Interview"] = "INTERVIEW";
    CandidateSourceProduct["ResumeSearch"] = "RESUME_SEARCH";
    CandidateSourceProduct["VirtualInterviewPlatform"] = "VIRTUAL_INTERVIEW_PLATFORM";
})(CandidateSourceProduct || (CandidateSourceProduct = {}));
export var CandidateSubmissionAccessPermission;
(function (CandidateSubmissionAccessPermission) {
    CandidateSubmissionAccessPermission["Read"] = "READ";
    CandidateSubmissionAccessPermission["ReadOrProfileRead"] = "READ_OR_PROFILE_READ";
    CandidateSubmissionAccessPermission["Update"] = "UPDATE";
})(CandidateSubmissionAccessPermission || (CandidateSubmissionAccessPermission = {}));
/** Types of entities that can take action on a candidate submission and generate a CandidateSubmissionActivity. */
export var CandidateSubmissionActivityAuthorType;
(function (CandidateSubmissionActivityAuthorType) {
    CandidateSubmissionActivityAuthorType["Automated"] = "AUTOMATED";
    CandidateSubmissionActivityAuthorType["Employer"] = "EMPLOYER";
    CandidateSubmissionActivityAuthorType["Jobseeker"] = "JOBSEEKER";
})(CandidateSubmissionActivityAuthorType || (CandidateSubmissionActivityAuthorType = {}));
export var CandidateSubmissionAutomationAttributeKey;
(function (CandidateSubmissionAutomationAttributeKey) {
    CandidateSubmissionAutomationAttributeKey["AutoContactNumReminder"] = "AUTO_CONTACT_NUM_REMINDER";
    CandidateSubmissionAutomationAttributeKey["AutoContactNumWillNotSend"] = "AUTO_CONTACT_NUM_WILL_NOT_SEND";
    CandidateSubmissionAutomationAttributeKey["AutoReplyNumReminder"] = "AUTO_REPLY_NUM_REMINDER";
    CandidateSubmissionAutomationAttributeKey["AutoReplyNumWillNotSend"] = "AUTO_REPLY_NUM_WILL_NOT_SEND";
    CandidateSubmissionAutomationAttributeKey["MaybeAutomationNumReminder"] = "MAYBE_AUTOMATION_NUM_REMINDER";
    CandidateSubmissionAutomationAttributeKey["MaybeAutomationNumWillNotSend"] = "MAYBE_AUTOMATION_NUM_WILL_NOT_SEND";
})(CandidateSubmissionAutomationAttributeKey || (CandidateSubmissionAutomationAttributeKey = {}));
/** The status of a hosted job post */
export var CandidateSubmissionHostedJobPostStatusFilter;
(function (CandidateSubmissionHostedJobPostStatusFilter) {
    CandidateSubmissionHostedJobPostStatusFilter["Active"] = "ACTIVE";
    CandidateSubmissionHostedJobPostStatusFilter["Deleted"] = "DELETED";
    CandidateSubmissionHostedJobPostStatusFilter["Paused"] = "PAUSED";
})(CandidateSubmissionHostedJobPostStatusFilter || (CandidateSubmissionHostedJobPostStatusFilter = {}));
/** An employer sentiment about candidates that can be used for filtering by the findCandidateSubmissions query. */
export var CandidateSubmissionInterestLevelFilter;
(function (CandidateSubmissionInterestLevelFilter) {
    CandidateSubmissionInterestLevelFilter["Maybe"] = "MAYBE";
    CandidateSubmissionInterestLevelFilter["No"] = "NO";
    CandidateSubmissionInterestLevelFilter["Unset"] = "UNSET";
    CandidateSubmissionInterestLevelFilter["Yes"] = "YES";
})(CandidateSubmissionInterestLevelFilter || (CandidateSubmissionInterestLevelFilter = {}));
/** A candidate submission data field that can be used for sorting by the findCandidateSubmissions query */
export var CandidateSubmissionSortKey;
(function (CandidateSubmissionSortKey) {
    CandidateSubmissionSortKey["DateCreated"] = "DATE_CREATED";
    CandidateSubmissionSortKey["Interest"] = "INTEREST";
    CandidateSubmissionSortKey["Milestone"] = "MILESTONE";
    CandidateSubmissionSortKey["Name"] = "NAME";
})(CandidateSubmissionSortKey || (CandidateSubmissionSortKey = {}));
/** A sort order for the findCandidateSubmissions query */
export var CandidateSubmissionSortOrder;
(function (CandidateSubmissionSortOrder) {
    CandidateSubmissionSortOrder["Ascending"] = "ASCENDING";
    CandidateSubmissionSortOrder["Descending"] = "DESCENDING";
})(CandidateSubmissionSortOrder || (CandidateSubmissionSortOrder = {}));
/** The types of sources which can cause a candidate submission to be created */
export var CandidateSubmissionSourceType;
(function (CandidateSubmissionSourceType) {
    CandidateSubmissionSourceType["AtsApplication"] = "ATS_APPLICATION";
    CandidateSubmissionSourceType["AtsCandidate"] = "ATS_CANDIDATE";
    CandidateSubmissionSourceType["AutosourcerInvite"] = "AUTOSOURCER_INVITE";
    CandidateSubmissionSourceType["GuidedDiscoveryReplay"] = "GUIDED_DISCOVERY_REPLAY";
    CandidateSubmissionSourceType["HireReplay"] = "HIRE_REPLAY";
    CandidateSubmissionSourceType["HiringEvent"] = "HIRING_EVENT";
    CandidateSubmissionSourceType["HorizonSourcing"] = "HORIZON_SOURCING";
    CandidateSubmissionSourceType["HqmConversation"] = "HQM_CONVERSATION";
    CandidateSubmissionSourceType["IndeedApply"] = "INDEED_APPLY";
    CandidateSubmissionSourceType["IndeedApplyIta"] = "INDEED_APPLY_ITA";
    CandidateSubmissionSourceType["IndeedApplySponsored"] = "INDEED_APPLY_SPONSORED";
    CandidateSubmissionSourceType["IndeedPlusScout"] = "INDEED_PLUS_SCOUT";
    CandidateSubmissionSourceType["InstantMatch"] = "INSTANT_MATCH";
    CandidateSubmissionSourceType["ManualImport"] = "MANUAL_IMPORT";
    CandidateSubmissionSourceType["PremiumInvite"] = "PREMIUM_INVITE";
    CandidateSubmissionSourceType["ResumeSearch"] = "RESUME_SEARCH";
    CandidateSubmissionSourceType["ResumeSearchEngagement"] = "RESUME_SEARCH_ENGAGEMENT";
    CandidateSubmissionSourceType["ResumeSearchFastApply"] = "RESUME_SEARCH_FAST_APPLY";
    CandidateSubmissionSourceType["SavedSourcingCandidate"] = "SAVED_SOURCING_CANDIDATE";
    CandidateSubmissionSourceType["ThirdPartyIndeedApply"] = "THIRD_PARTY_INDEED_APPLY";
    CandidateSubmissionSourceType["Unknown"] = "UNKNOWN";
})(CandidateSubmissionSourceType || (CandidateSubmissionSourceType = {}));
export var CandidateSubmissionStatusEnum;
(function (CandidateSubmissionStatusEnum) {
    CandidateSubmissionStatusEnum["Contacted"] = "CONTACTED";
    CandidateSubmissionStatusEnum["DeclinedToInterview"] = "DECLINED_TO_INTERVIEW";
    CandidateSubmissionStatusEnum["EmploymentStarted"] = "EMPLOYMENT_STARTED";
    CandidateSubmissionStatusEnum["Hired"] = "HIRED";
    CandidateSubmissionStatusEnum["Interviewing"] = "INTERVIEWING";
    CandidateSubmissionStatusEnum["OfferSent"] = "OFFER_SENT";
    CandidateSubmissionStatusEnum["Rejected"] = "REJECTED";
    CandidateSubmissionStatusEnum["Reviewed"] = "REVIEWED";
    CandidateSubmissionStatusEnum["Screened"] = "SCREENED";
    CandidateSubmissionStatusEnum["Submitted"] = "SUBMITTED";
})(CandidateSubmissionStatusEnum || (CandidateSubmissionStatusEnum = {}));
/** The kind of opaque actor that produced a status change. */
export var CandidateSubmissionStatusOpaqueActorKind;
(function (CandidateSubmissionStatusOpaqueActorKind) {
    /** The status change was made by an internal Indeed system or automated process. */
    CandidateSubmissionStatusOpaqueActorKind["System"] = "SYSTEM";
    /** The originating actor is not known. */
    CandidateSubmissionStatusOpaqueActorKind["Unknown"] = "UNKNOWN";
})(CandidateSubmissionStatusOpaqueActorKind || (CandidateSubmissionStatusOpaqueActorKind = {}));
/**
 * A candidate submission status value.
 *
 * See https://indeed.atlassian.net/wiki/spaces/CandidatePlatform/pages/1114702575/CandStat+Product+Page
 * for descriptions of each status value.
 */
export var CandidateSubmissionStatusValue;
(function (CandidateSubmissionStatusValue) {
    CandidateSubmissionStatusValue["AssessQualifications"] = "ASSESS_QUALIFICATIONS";
    CandidateSubmissionStatusValue["AwaitingResponse"] = "AWAITING_RESPONSE";
    CandidateSubmissionStatusValue["BackgroundCheck"] = "BACKGROUND_CHECK";
    CandidateSubmissionStatusValue["Contacting"] = "CONTACTING";
    CandidateSubmissionStatusValue["Declined"] = "DECLINED";
    CandidateSubmissionStatusValue["Hired"] = "HIRED";
    CandidateSubmissionStatusValue["Incomplete"] = "INCOMPLETE";
    CandidateSubmissionStatusValue["Interviewing"] = "INTERVIEWING";
    CandidateSubmissionStatusValue["JobClosed"] = "JOB_CLOSED";
    CandidateSubmissionStatusValue["JobInactive"] = "JOB_INACTIVE";
    CandidateSubmissionStatusValue["Liked"] = "LIKED";
    CandidateSubmissionStatusValue["New"] = "NEW";
    CandidateSubmissionStatusValue["NotSelected"] = "NOT_SELECTED";
    CandidateSubmissionStatusValue["OfferDeclined"] = "OFFER_DECLINED";
    CandidateSubmissionStatusValue["OfferMade"] = "OFFER_MADE";
    CandidateSubmissionStatusValue["Onboarded"] = "ONBOARDED";
    CandidateSubmissionStatusValue["PendingProminent"] = "PENDING_PROMINENT";
    CandidateSubmissionStatusValue["PositivelyScreened"] = "POSITIVELY_SCREENED";
    CandidateSubmissionStatusValue["Reviewing"] = "REVIEWING";
    CandidateSubmissionStatusValue["Screening"] = "SCREENING";
    CandidateSubmissionStatusValue["Sourcing"] = "SOURCING";
    CandidateSubmissionStatusValue["UnableToMap"] = "UNABLE_TO_MAP";
    CandidateSubmissionStatusValue["VerifyEligibility"] = "VERIFY_ELIGIBILITY";
    CandidateSubmissionStatusValue["Withdrawn"] = "WITHDRAWN";
})(CandidateSubmissionStatusValue || (CandidateSubmissionStatusValue = {}));
/** Types of candidate submissions that can be searched for using the findCandidateSubmissions query */
export var CandidateSubmissionType;
(function (CandidateSubmissionType) {
    CandidateSubmissionType["EmployerGenerated"] = "EMPLOYER_GENERATED";
    CandidateSubmissionType["Hqm"] = "HQM";
    CandidateSubmissionType["IndeedApply"] = "INDEED_APPLY";
    /** Returns both INDEED_APPLY and EMPLOYER_GENERATED submissions */
    CandidateSubmissionType["Legacy"] = "LEGACY";
})(CandidateSubmissionType || (CandidateSubmissionType = {}));
/** Direction of the candidate sync */
export var CandidateSyncDirection;
(function (CandidateSyncDirection) {
    CandidateSyncDirection["Inbound"] = "INBOUND";
    CandidateSyncDirection["Outbound"] = "OUTBOUND";
})(CandidateSyncDirection || (CandidateSyncDirection = {}));
/** Possible statuses for a candidate sync enrollment. */
export var CandidateSyncEnrollmentStatus;
(function (CandidateSyncEnrollmentStatus) {
    CandidateSyncEnrollmentStatus["FailedOptIn"] = "FAILED_OPT_IN";
    CandidateSyncEnrollmentStatus["FailedOptOut"] = "FAILED_OPT_OUT";
    CandidateSyncEnrollmentStatus["OptedIn"] = "OPTED_IN";
    CandidateSyncEnrollmentStatus["OptedOut"] = "OPTED_OUT";
    CandidateSyncEnrollmentStatus["PendingOptIn"] = "PENDING_OPT_IN";
    CandidateSyncEnrollmentStatus["PendingOptOut"] = "PENDING_OPT_OUT";
    CandidateSyncEnrollmentStatus["Unspecified"] = "UNSPECIFIED";
})(CandidateSyncEnrollmentStatus || (CandidateSyncEnrollmentStatus = {}));
export var CandidateSyncSmartSourcingExportStatusEventKind;
(function (CandidateSyncSmartSourcingExportStatusEventKind) {
    /** Export for the specified resource has completed unsuccessfully */
    CandidateSyncSmartSourcingExportStatusEventKind["CompletedFailure"] = "COMPLETED_FAILURE";
    /** Export for the specified resources has completed, but the outcome was unable to be determined */
    CandidateSyncSmartSourcingExportStatusEventKind["CompletedIndeterminate"] = "COMPLETED_INDETERMINATE";
    /** Export for the specified resource has completed successfully */
    CandidateSyncSmartSourcingExportStatusEventKind["CompletedSuccess"] = "COMPLETED_SUCCESS";
    /** Export for the specified resources has been deferred */
    CandidateSyncSmartSourcingExportStatusEventKind["Deferred"] = "DEFERRED";
    /** Unable to determine export status for the specified resource */
    CandidateSyncSmartSourcingExportStatusEventKind["Indeterminate"] = "INDETERMINATE";
    /** Export for the specified resource has been queued */
    CandidateSyncSmartSourcingExportStatusEventKind["Queued"] = "QUEUED";
    /** Export for the specified resources has resumed */
    CandidateSyncSmartSourcingExportStatusEventKind["Resumed"] = "RESUMED";
    /** Export for the specified resource has been started */
    CandidateSyncSmartSourcingExportStatusEventKind["Started"] = "STARTED";
})(CandidateSyncSmartSourcingExportStatusEventKind || (CandidateSyncSmartSourcingExportStatusEventKind = {}));
/**
 * NOTE: The GraphQL ExportEventType enum duplicates the protobuf EventType enum from ocs-export-service.
 * These enums must be kept in sync. If new event types are added to ocs-export-service,
 * they should also be added to:
 * 1. The GraphQL schema (exportEvent.graphqls)
 * 2. This converter method
 */
export var CandidateSyncSmartSourcingLastExportEventType;
(function (CandidateSyncSmartSourcingLastExportEventType) {
    CandidateSyncSmartSourcingLastExportEventType["Acknowledged"] = "ACKNOWLEDGED";
    CandidateSyncSmartSourcingLastExportEventType["Deferred"] = "DEFERRED";
    CandidateSyncSmartSourcingLastExportEventType["EventTypeUnknown"] = "EVENT_TYPE_UNKNOWN";
    CandidateSyncSmartSourcingLastExportEventType["Failed"] = "FAILED";
    CandidateSyncSmartSourcingLastExportEventType["Invalid"] = "INVALID";
    CandidateSyncSmartSourcingLastExportEventType["Processing"] = "PROCESSING";
    CandidateSyncSmartSourcingLastExportEventType["Received"] = "RECEIVED";
    CandidateSyncSmartSourcingLastExportEventType["Staged"] = "STAGED";
    CandidateSyncSmartSourcingLastExportEventType["Success"] = "SUCCESS";
})(CandidateSyncSmartSourcingLastExportEventType || (CandidateSyncSmartSourcingLastExportEventType = {}));
export var CandidateSyncSmartSourcingOneClickExportCandidateExternalLocationType;
(function (CandidateSyncSmartSourcingOneClickExportCandidateExternalLocationType) {
    /** A reference not currently supported by this api */
    CandidateSyncSmartSourcingOneClickExportCandidateExternalLocationType["Indeterminate"] = "INDETERMINATE";
    /** A reference to a requisition (or requisition equivalent) in the ats */
    CandidateSyncSmartSourcingOneClickExportCandidateExternalLocationType["Requisition"] = "REQUISITION";
    /** A reference to a talent pool (or talent pool equivalent) in the ats */
    CandidateSyncSmartSourcingOneClickExportCandidateExternalLocationType["TalentPool"] = "TALENT_POOL";
})(CandidateSyncSmartSourcingOneClickExportCandidateExternalLocationType || (CandidateSyncSmartSourcingOneClickExportCandidateExternalLocationType = {}));
/** Status of Candidate Sync */
export var CandidateSyncStatus;
(function (CandidateSyncStatus) {
    /** The link is working properly and data can flow through it */
    CandidateSyncStatus["Active"] = "ACTIVE";
    /** The link is broken. Pipelines using this link cannot move any data. */
    CandidateSyncStatus["Broken"] = "BROKEN";
    /**
     * The link requires additional configuration in order to
     * activate
     */
    CandidateSyncStatus["ConfigurationRequired"] = "CONFIGURATION_REQUIRED";
    /** The link is disabled. Data cannot flow through it */
    CandidateSyncStatus["Disabled"] = "DISABLED";
    /** The link is in an unknown state */
    CandidateSyncStatus["Indeterminate"] = "INDETERMINATE";
    /** The ATS rejected the provided credentials */
    CandidateSyncStatus["InvalidCredentials"] = "INVALID_CREDENTIALS";
    /** The link requires a user to login */
    CandidateSyncStatus["LoginRequired"] = "LOGIN_REQUIRED";
    /**
     * The link is pending to be deleted after it completes any
     * pending work
     */
    CandidateSyncStatus["PendingDelete"] = "PENDING_DELETE";
    /** The link will be disabled after completes any pending work */
    CandidateSyncStatus["PendingDisable"] = "PENDING_DISABLE";
    /** The link configuration is being validated */
    CandidateSyncStatus["PendingValidation"] = "PENDING_VALIDATION";
})(CandidateSyncStatus || (CandidateSyncStatus = {}));
export var CandidateTypeFilter;
(function (CandidateTypeFilter) {
    CandidateTypeFilter["Applicant"] = "APPLICANT";
    CandidateTypeFilter["Prospect"] = "PROSPECT";
})(CandidateTypeFilter || (CandidateTypeFilter = {}));
/**
 * Enum describing the type of "CannotOptimizeReason" why the optimization can not be applied.
 * It needs to be mapped to the enum from VRES proto which has prefix of CANNOT_OPTIMIZE_REASON_.
 */
export var CannotOptimizeReason;
(function (CannotOptimizeReason) {
    CannotOptimizeReason["AdvertiserIdRequired"] = "ADVERTISER_ID_REQUIRED";
    CannotOptimizeReason["AlreadyOptimal"] = "ALREADY_OPTIMAL";
    CannotOptimizeReason["CandidatePoolDecrease"] = "CANDIDATE_POOL_DECREASE";
    CannotOptimizeReason["CodingError"] = "CODING_ERROR";
    CannotOptimizeReason["DisabledByProctor"] = "DISABLED_BY_PROCTOR";
    CannotOptimizeReason["InsufficientJobData"] = "INSUFFICIENT_JOB_DATA";
    CannotOptimizeReason["InsufficientMarketData"] = "INSUFFICIENT_MARKET_DATA";
    CannotOptimizeReason["JobNotApplicable"] = "JOB_NOT_APPLICABLE";
    CannotOptimizeReason["MissingRequiredOverride"] = "MISSING_REQUIRED_OVERRIDE";
    CannotOptimizeReason["ServiceOutage"] = "SERVICE_OUTAGE";
    CannotOptimizeReason["ServiceReturnedInvalidResponse"] = "SERVICE_RETURNED_INVALID_RESPONSE";
    CannotOptimizeReason["Unknown"] = "UNKNOWN";
    CannotOptimizeReason["UnsupportedOperation"] = "UNSUPPORTED_OPERATION";
})(CannotOptimizeReason || (CannotOptimizeReason = {}));
/**
 * Visual style variants for card elements.
 * Determines visual treatment and color scheme.
 */
export var CardStyle;
(function (CardStyle) {
    /** Critical/error card (typically red) */
    CardStyle["Critical"] = "CRITICAL";
    /** Informational card (typically blue) */
    CardStyle["Info"] = "INFO";
    /** Neutral style with minimal background */
    CardStyle["Neutral"] = "NEUTRAL";
    /** Neutral style with filled background */
    CardStyle["NeutralFill"] = "NEUTRAL_FILL";
    /** Success card (typically green) */
    CardStyle["Success"] = "SUCCESS";
    /** Warning card (typically yellow/orange) */
    CardStyle["Warning"] = "WARNING";
})(CardStyle || (CardStyle = {}));
export var CareersApiServiceDataSource;
(function (CareersApiServiceDataSource) {
    CareersApiServiceDataSource["Glassdoor"] = "GLASSDOOR";
    CareersApiServiceDataSource["Indeed"] = "INDEED";
})(CareersApiServiceDataSource || (CareersApiServiceDataSource = {}));
/** Defines the category of the case created during the manual refund process */
export var CaseCategory;
(function (CaseCategory) {
    /** Credit Category for a case */
    CaseCategory["Credit"] = "CREDIT";
    /** Refund Category for a case */
    CaseCategory["Refund"] = "REFUND";
})(CaseCategory || (CaseCategory = {}));
/** Enum specifies the occupation level to filter for */
export var CategoricalOqvtOccupationsFilterLevel;
(function (CategoricalOqvtOccupationsFilterLevel) {
    CategoricalOqvtOccupationsFilterLevel["Leaf"] = "LEAF";
    CategoricalOqvtOccupationsFilterLevel["Top"] = "TOP";
})(CategoricalOqvtOccupationsFilterLevel || (CategoricalOqvtOccupationsFilterLevel = {}));
/**
 * Categorical Hierarchy Question Types to render and collect
 * data for a question
 */
export var CategoricalOqvtQuestionType;
(function (CategoricalOqvtQuestionType) {
    CategoricalOqvtQuestionType["Multiselect"] = "MULTISELECT";
    CategoricalOqvtQuestionType["Select"] = "SELECT";
})(CategoricalOqvtQuestionType || (CategoricalOqvtQuestionType = {}));
/**
 * The origin type of a CBI request, indicating what triggered it.
 * Used by the frontend to differentiate display context.
 */
export var CbiSourceType;
(function (CbiSourceType) {
    /** Standard post-adjustment refund CBI (CS enters billing email in refund flow) */
    CbiSourceType["PostAdjustment"] = "POST_ADJUSTMENT";
    /** Subscription revoke CBI (auto-triggered by Kafka listener after BATS cancellation) */
    CbiSourceType["SubscriptionRefund"] = "SUBSCRIPTION_REFUND";
})(CbiSourceType || (CbiSourceType = {}));
/** Source of the latest event reflected by a channel notification status */
export var ChannelNotificationEventSource;
(function (ChannelNotificationEventSource) {
    /** Event came from an external last-mile delivery callback */
    ChannelNotificationEventSource["External"] = "EXTERNAL";
    /** Event was published by an internal system */
    ChannelNotificationEventSource["Internal"] = "INTERNAL";
    /** Source is unknown for legacy data */
    ChannelNotificationEventSource["Unknown"] = "UNKNOWN";
})(ChannelNotificationEventSource || (ChannelNotificationEventSource = {}));
/** Status of a channel notification */
export var ChannelNotificationStatus;
(function (ChannelNotificationStatus) {
    /** Notification has been created but not yet processed */
    ChannelNotificationStatus["Created"] = "CREATED";
    /** Notification was delegated to another system */
    ChannelNotificationStatus["Delegated"] = "DELEGATED";
    /** Notification was successfully delivered */
    ChannelNotificationStatus["Delivered"] = "DELIVERED";
    /** Notification was dropped (e.g., filtered out, user opted out) */
    ChannelNotificationStatus["Dropped"] = "DROPPED";
    /** Notification delivery failed */
    ChannelNotificationStatus["Failed"] = "FAILED";
})(ChannelNotificationStatus || (ChannelNotificationStatus = {}));
/** The kind of entity a [ChatAccessor] points to. */
export var ChatAccessorKind;
(function (ChatAccessorKind) {
    /** Identified by an advertiser id */
    ChatAccessorKind["Advertiser"] = "ADVERTISER";
    /** Identified by a partner app id */
    ChatAccessorKind["PartnerApp"] = "PARTNER_APP";
})(ChatAccessorKind || (ChatAccessorKind = {}));
/**
 * Machine-readable lock classification for first-party consumers, mirroring the internal lock
 * reasons. First-party only, so adding a value is a non-breaking change.
 */
export var ChatConversationLockCode;
(function (ChatConversationLockCode) {
    /** The conversation is incompatible with IMS (the legacy/JP migration case). */
    ChatConversationLockCode["ImsIncompatible"] = "IMS_INCOMPATIBLE";
})(ChatConversationLockCode || (ChatConversationLockCode = {}));
/**
 * Partner-facing lock state. Deliberately generic: no value names a product, internal
 * system, or moderation action. Internal lock reasons map many-to-one onto these states.
 */
export var ChatConversationLockState;
(function (ChatConversationLockState) {
    /** The conversation has ended. Terminal. */
    ChatConversationLockState["Closed"] = "CLOSED";
    /** Not available right now; expected to reopen. */
    ChatConversationLockState["TemporarilyUnavailable"] = "TEMPORARILY_UNAVAILABLE";
    /** Indefinitely unavailable with no stated reason (disclosure bucket); also the safe default for any unmapped or unknown internal reason. */
    ChatConversationLockState["Unavailable"] = "UNAVAILABLE";
})(ChatConversationLockState || (ChatConversationLockState = {}));
export var CheckStatus;
(function (CheckStatus) {
    CheckStatus["Error"] = "ERROR";
    CheckStatus["Failed"] = "FAILED";
    CheckStatus["Passed"] = "PASSED";
})(CheckStatus || (CheckStatus = {}));
/** Status values for company claims */
export var ClaimStatus;
(function (ClaimStatus) {
    /** Claim has been deleted */
    ClaimStatus["Deleted"] = "DELETED";
    /** Claim is pending approval */
    ClaimStatus["Pending"] = "PENDING";
    /** Claim has been rejected */
    ClaimStatus["Rejected"] = "REJECTED";
    /** Claim has been verified */
    ClaimStatus["Verified"] = "VERIFIED";
})(ClaimStatus || (ClaimStatus = {}));
/** Used for claimed job updates to indicate that the source of the data is from outside of Indeed. */
export var ClaimedJobInputDataSource;
(function (ClaimedJobInputDataSource) {
    ClaimedJobInputDataSource["External"] = "EXTERNAL";
})(ClaimedJobInputDataSource || (ClaimedJobInputDataSource = {}));
/** Variants of the ClickSponsor optimization */
export var ClickSponsorOptimizationVariant;
(function (ClickSponsorOptimizationVariant) {
    /** @deprecated This optimization variant is deprecated */
    ClickSponsorOptimizationVariant["ClickSponsorOptimizationVariantDefault"] = "CLICK_SPONSOR_OPTIMIZATION_VARIANT_DEFAULT";
})(ClickSponsorOptimizationVariant || (ClickSponsorOptimizationVariant = {}));
export var ClickToCallDisclaimerType;
(function (ClickToCallDisclaimerType) {
    ClickToCallDisclaimerType["ClickToCallOptInCheckbox"] = "CLICK_TO_CALL_OPT_IN_CHECKBOX";
    ClickToCallDisclaimerType["ClickToCallOptInDisclaimer"] = "CLICK_TO_CALL_OPT_IN_DISCLAIMER";
    ClickToCallDisclaimerType["None"] = "NONE";
    ClickToCallDisclaimerType["NormalDisclaimer"] = "NORMAL_DISCLAIMER";
})(ClickToCallDisclaimerType || (ClickToCallDisclaimerType = {}));
export var ClientContextInput;
(function (ClientContextInput) {
    /** Triggered during apply submission */
    ClientContextInput["ApplyComplete"] = "APPLY_COMPLETE";
    /** Triggered during form load */
    ClientContextInput["ApplyStart"] = "APPLY_START";
    /** Triggered before rendering qualification questions page */
    ClientContextInput["BeforeQualificationQuestions"] = "BEFORE_QUALIFICATION_QUESTIONS";
    /** Triggered on third party job's button click to show YLQ intervention */
    ClientContextInput["ThirdPartyApplyStart"] = "THIRD_PARTY_APPLY_START";
    /** Triggered when job seeker's profile is updated after answering YLQ questions on third party job button click */
    ClientContextInput["ThirdPartyYlqComplete"] = "THIRD_PARTY_YLQ_COMPLETE";
})(ClientContextInput || (ClientContextInput = {}));
/** Detailed reason why the job is being paused or closed. */
export var ClosedJobReason;
(function (ClosedJobReason) {
    ClosedJobReason["AccidentallyPostedJob"] = "ACCIDENTALLY_POSTED_JOB";
    ClosedJobReason["BillingProblem"] = "BILLING_PROBLEM";
    ClosedJobReason["HireTypeIndeed"] = "HIRE_TYPE_INDEED";
    ClosedJobReason["HireTypeNone"] = "HIRE_TYPE_NONE";
    ClosedJobReason["HireTypeNotIndeed"] = "HIRE_TYPE_NOT_INDEED";
    ClosedJobReason["HireTypeNoGoodCandidates"] = "HIRE_TYPE_NO_GOOD_CANDIDATES";
    ClosedJobReason["HireTypeNoNeedToHire"] = "HIRE_TYPE_NO_NEED_TO_HIRE";
    ClosedJobReason["HireTypeOther"] = "HIRE_TYPE_OTHER";
    ClosedJobReason["HireTypeStillEvaluating"] = "HIRE_TYPE_STILL_EVALUATING";
    ClosedJobReason["HiringOnHold"] = "HIRING_ON_HOLD";
    ClosedJobReason["HiringOnHoldOrCancelled"] = "HIRING_ON_HOLD_OR_CANCELLED";
    ClosedJobReason["InterviewingCandidates"] = "INTERVIEWING_CANDIDATES";
    ClosedJobReason["NoResponse"] = "NO_RESPONSE";
    ClosedJobReason["SpendingHigh"] = "SPENDING_HIGH";
    ClosedJobReason["TechnicalIssues"] = "TECHNICAL_ISSUES";
    ClosedJobReason["UnqualifiedCandidates"] = "UNQUALIFIED_CANDIDATES";
})(ClosedJobReason || (ClosedJobReason = {}));
/** Survey collecting this data. */
export var ClosedJobReasonSource;
(function (ClosedJobReasonSource) {
    ClosedJobReasonSource["AutoPausedBanner"] = "AUTO_PAUSED_BANNER";
    ClosedJobReasonSource["CloseJobModal"] = "CLOSE_JOB_MODAL";
    ClosedJobReasonSource["DidYouHireBanner"] = "DID_YOU_HIRE_BANNER";
    ClosedJobReasonSource["DidYouHireSheetOnehost"] = "DID_YOU_HIRE_SHEET_ONEHOST";
    ClosedJobReasonSource["EmployerMobileAndroidClose"] = "EMPLOYER_MOBILE_ANDROID_CLOSE";
    ClosedJobReasonSource["EmployerMobileAndroidPause"] = "EMPLOYER_MOBILE_ANDROID_PAUSE";
    ClosedJobReasonSource["EmployerMobileIosClose"] = "EMPLOYER_MOBILE_IOS_CLOSE";
    ClosedJobReasonSource["EmployerMobileIosPause"] = "EMPLOYER_MOBILE_IOS_PAUSE";
    ClosedJobReasonSource["HireProgressTracker"] = "HIRE_PROGRESS_TRACKER";
    ClosedJobReasonSource["HireSignalIjm"] = "HIRE_SIGNAL_IJM";
    ClosedJobReasonSource["PauseJobModal"] = "PAUSE_JOB_MODAL";
    ClosedJobReasonSource["ReportBulkHiresModal"] = "REPORT_BULK_HIRES_MODAL";
    ClosedJobReasonSource["ReportHirePauseJobModal"] = "REPORT_HIRE_PAUSE_JOB_MODAL";
    ClosedJobReasonSource["ReportHireSheetOnehost"] = "REPORT_HIRE_SHEET_ONEHOST";
    ClosedJobReasonSource["ReportNoHireSheetOnehost"] = "REPORT_NO_HIRE_SHEET_ONEHOST";
    ClosedJobReasonSource["ReportSkippedHireSheetOnehost"] = "REPORT_SKIPPED_HIRE_SHEET_ONEHOST";
    ClosedJobReasonSource["StillEvaluatingFollowUp"] = "STILL_EVALUATING_FOLLOW_UP";
    ClosedJobReasonSource["UnpauseEmail"] = "UNPAUSE_EMAIL";
})(ClosedJobReasonSource || (ClosedJobReasonSource = {}));
/** Primary reason why the job is being paused or closed. */
export var ClosedJobReasonTopLevelResponse;
(function (ClosedJobReasonTopLevelResponse) {
    ClosedJobReasonTopLevelResponse["BillingOrTechnicalIssue"] = "BILLING_OR_TECHNICAL_ISSUE";
    ClosedJobReasonTopLevelResponse["Hired"] = "HIRED";
    ClosedJobReasonTopLevelResponse["NoHire"] = "NO_HIRE";
    ClosedJobReasonTopLevelResponse["Skipped"] = "SKIPPED";
    ClosedJobReasonTopLevelResponse["StillEvaluating"] = "STILL_EVALUATING";
    ClosedJobReasonTopLevelResponse["Unsure"] = "UNSURE";
})(ClosedJobReasonTopLevelResponse || (ClosedJobReasonTopLevelResponse = {}));
export var CoWorkerAgentType;
(function (CoWorkerAgentType) {
    /** @deprecated No longer supported */
    CoWorkerAgentType["CareerCriteriaAgent"] = "CAREER_CRITERIA_AGENT";
    CoWorkerAgentType["CareerDetailsOverviewAgent"] = "CAREER_DETAILS_OVERVIEW_AGENT";
    CoWorkerAgentType["CareerDetailsSalaryAgent"] = "CAREER_DETAILS_SALARY_AGENT";
    CoWorkerAgentType["CareerDetailsSkillsAgent"] = "CAREER_DETAILS_SKILLS_AGENT";
    CoWorkerAgentType["CareerDetailsSkillsEvaluateAgent"] = "CAREER_DETAILS_SKILLS_EVALUATE_AGENT";
    CoWorkerAgentType["CareerDetailsUpskillAgent"] = "CAREER_DETAILS_UPSKILL_AGENT";
    CoWorkerAgentType["CareerExploreAgent"] = "CAREER_EXPLORE_AGENT";
    CoWorkerAgentType["CareerGenerationAgent"] = "CAREER_GENERATION_AGENT";
    CoWorkerAgentType["CareerQuizAgent"] = "CAREER_QUIZ_AGENT";
    CoWorkerAgentType["CareerRecommendationAgent"] = "CAREER_RECOMMENDATION_AGENT";
    CoWorkerAgentType["CareerSkillsGroupsAgent"] = "CAREER_SKILLS_GROUPS_AGENT";
    CoWorkerAgentType["CommunicationMessagingAgent"] = "COMMUNICATION_MESSAGING_AGENT";
    CoWorkerAgentType["CompanyInsightsAgent"] = "COMPANY_INSIGHTS_AGENT";
    CoWorkerAgentType["ConciergeAgent"] = "CONCIERGE_AGENT";
    CoWorkerAgentType["ConversationalPathfinderAgent"] = "CONVERSATIONAL_PATHFINDER_AGENT";
    /** @deprecated No longer supported */
    CoWorkerAgentType["CuratedJobsAgent"] = "CURATED_JOBS_AGENT";
    CoWorkerAgentType["DevExampleMcpToolAgent"] = "DEV_EXAMPLE_MCP_TOOL_AGENT";
    CoWorkerAgentType["DevExampleParallelToolCallsAgent"] = "DEV_EXAMPLE_PARALLEL_TOOL_CALLS_AGENT";
    CoWorkerAgentType["DevExampleReactAgent"] = "DEV_EXAMPLE_REACT_AGENT";
    CoWorkerAgentType["FutureSearchAgent"] = "FUTURE_SEARCH_AGENT";
    CoWorkerAgentType["Gpt5TestAgent"] = "GPT5_TEST_AGENT";
    CoWorkerAgentType["GreeterAgent"] = "GREETER_AGENT";
    CoWorkerAgentType["InterviewPrepAgent"] = "INTERVIEW_PREP_AGENT";
    CoWorkerAgentType["InterviewSchedulingAgent"] = "INTERVIEW_SCHEDULING_AGENT";
    CoWorkerAgentType["JobSearchAgent"] = "JOB_SEARCH_AGENT";
    CoWorkerAgentType["JobSearchPrepAgent"] = "JOB_SEARCH_PREP_AGENT";
    CoWorkerAgentType["MatchGroupSearchAgent"] = "MATCH_GROUP_SEARCH_AGENT";
    CoWorkerAgentType["MatchGroupSpecAgent"] = "MATCH_GROUP_SPEC_AGENT";
    CoWorkerAgentType["OnboardingConversationExtractedDataConfirmationAgent"] = "ONBOARDING_CONVERSATION_EXTRACTED_DATA_CONFIRMATION_AGENT";
    CoWorkerAgentType["OnboardingConversationGreeterAgent"] = "ONBOARDING_CONVERSATION_GREETER_AGENT";
    CoWorkerAgentType["OnboardingConversationInstructionsAgent"] = "ONBOARDING_CONVERSATION_INSTRUCTIONS_AGENT";
    CoWorkerAgentType["OnboardingConversationResumeUploadConfirmationAgent"] = "ONBOARDING_CONVERSATION_RESUME_UPLOAD_CONFIRMATION_AGENT";
    CoWorkerAgentType["OnboardingConversationRouterAgent"] = "ONBOARDING_CONVERSATION_ROUTER_AGENT";
    CoWorkerAgentType["OnboardingConversationWorkExtractionAgent"] = "ONBOARDING_CONVERSATION_WORK_EXTRACTION_AGENT";
    CoWorkerAgentType["OnboardingConversationWorkExtractionCorrectionsAgent"] = "ONBOARDING_CONVERSATION_WORK_EXTRACTION_CORRECTIONS_AGENT";
    CoWorkerAgentType["OnboardingSearchIntentAgent"] = "ONBOARDING_SEARCH_INTENT_AGENT";
    CoWorkerAgentType["ResumeAgent"] = "RESUME_AGENT";
    CoWorkerAgentType["ResumeCertificationsTailoringAgent"] = "RESUME_CERTIFICATIONS_TAILORING_AGENT";
    CoWorkerAgentType["ResumeEducationTailoringAgent"] = "RESUME_EDUCATION_TAILORING_AGENT";
    CoWorkerAgentType["ResumeParentAgent"] = "RESUME_PARENT_AGENT";
    CoWorkerAgentType["ResumeSkillsTailoringAgent"] = "RESUME_SKILLS_TAILORING_AGENT";
    CoWorkerAgentType["ResumeSummaryAgent"] = "RESUME_SUMMARY_AGENT";
    CoWorkerAgentType["ResumeSummaryTailoringAgent"] = "RESUME_SUMMARY_TAILORING_AGENT";
    CoWorkerAgentType["ResumeWorkExperienceTailoringAgent"] = "RESUME_WORK_EXPERIENCE_TAILORING_AGENT";
    CoWorkerAgentType["SearchParametersAgent"] = "SEARCH_PARAMETERS_AGENT";
    /** @deprecated Top Match Agent functionality has been removed. */
    CoWorkerAgentType["TopMatchAgent"] = "TOP_MATCH_AGENT";
})(CoWorkerAgentType || (CoWorkerAgentType = {}));
export var CoWorkerChatMessageRole;
(function (CoWorkerChatMessageRole) {
    CoWorkerChatMessageRole["Assistant"] = "ASSISTANT";
    CoWorkerChatMessageRole["System"] = "SYSTEM";
    CoWorkerChatMessageRole["User"] = "USER";
})(CoWorkerChatMessageRole || (CoWorkerChatMessageRole = {}));
export var CoWorkerCommunicationAgentPromoType;
(function (CoWorkerCommunicationAgentPromoType) {
    CoWorkerCommunicationAgentPromoType["ConversationData"] = "CONVERSATION_DATA";
    CoWorkerCommunicationAgentPromoType["ConversationRedirect"] = "CONVERSATION_REDIRECT";
})(CoWorkerCommunicationAgentPromoType || (CoWorkerCommunicationAgentPromoType = {}));
export var CoWorkerFeedbackState;
(function (CoWorkerFeedbackState) {
    CoWorkerFeedbackState["Flagged"] = "FLAGGED";
    CoWorkerFeedbackState["Negative"] = "NEGATIVE";
    CoWorkerFeedbackState["Positive"] = "POSITIVE";
})(CoWorkerFeedbackState || (CoWorkerFeedbackState = {}));
export var CoWorkerInferredIntent;
(function (CoWorkerInferredIntent) {
    CoWorkerInferredIntent["MoreJobs"] = "MORE_JOBS";
})(CoWorkerInferredIntent || (CoWorkerInferredIntent = {}));
export var CoWorkerInterviewStatus;
(function (CoWorkerInterviewStatus) {
    CoWorkerInterviewStatus["JobseekerCancelled"] = "JOBSEEKER_CANCELLED";
    CoWorkerInterviewStatus["JobseekerRequestNewTimes"] = "JOBSEEKER_REQUEST_NEW_TIMES";
    CoWorkerInterviewStatus["Requested"] = "REQUESTED";
    CoWorkerInterviewStatus["Scheduled"] = "SCHEDULED";
})(CoWorkerInterviewStatus || (CoWorkerInterviewStatus = {}));
export var CoWorkerInterviewType;
(function (CoWorkerInterviewType) {
    CoWorkerInterviewType["HostedPhone"] = "HOSTED_PHONE";
    CoWorkerInterviewType["HostedVideo"] = "HOSTED_VIDEO";
    CoWorkerInterviewType["InPerson"] = "IN_PERSON";
    CoWorkerInterviewType["ThirdPartyPhone"] = "THIRD_PARTY_PHONE";
    CoWorkerInterviewType["ThirdPartyVideo"] = "THIRD_PARTY_VIDEO";
})(CoWorkerInterviewType || (CoWorkerInterviewType = {}));
export var CoWorkerJobDataRetrievalStrategy;
(function (CoWorkerJobDataRetrievalStrategy) {
    /** Job search will be performed to retrieve enough jobs if necessary. Currently only supported when hit by getCoWorkerChatMessage */
    CoWorkerJobDataRetrievalStrategy["Active"] = "ACTIVE";
    /** Default value. Only jobs stored in message.data will be retrieved. */
    CoWorkerJobDataRetrievalStrategy["Default"] = "DEFAULT";
})(CoWorkerJobDataRetrievalStrategy || (CoWorkerJobDataRetrievalStrategy = {}));
export var CoWorkerJobSeekerProfileLicenseType;
(function (CoWorkerJobSeekerProfileLicenseType) {
    CoWorkerJobSeekerProfileLicenseType["AccountingLicense"] = "ACCOUNTING_LICENSE";
    CoWorkerJobSeekerProfileLicenseType["DriversLicense"] = "DRIVERS_LICENSE";
    CoWorkerJobSeekerProfileLicenseType["NursesLicense"] = "NURSES_LICENSE";
    CoWorkerJobSeekerProfileLicenseType["Unknown"] = "UNKNOWN";
})(CoWorkerJobSeekerProfileLicenseType || (CoWorkerJobSeekerProfileLicenseType = {}));
export var CoWorkerJobSeekerProfileMonthType;
(function (CoWorkerJobSeekerProfileMonthType) {
    CoWorkerJobSeekerProfileMonthType["April"] = "APRIL";
    CoWorkerJobSeekerProfileMonthType["August"] = "AUGUST";
    CoWorkerJobSeekerProfileMonthType["December"] = "DECEMBER";
    CoWorkerJobSeekerProfileMonthType["February"] = "FEBRUARY";
    CoWorkerJobSeekerProfileMonthType["January"] = "JANUARY";
    CoWorkerJobSeekerProfileMonthType["July"] = "JULY";
    CoWorkerJobSeekerProfileMonthType["June"] = "JUNE";
    CoWorkerJobSeekerProfileMonthType["March"] = "MARCH";
    CoWorkerJobSeekerProfileMonthType["May"] = "MAY";
    CoWorkerJobSeekerProfileMonthType["NotSpecified"] = "NOT_SPECIFIED";
    CoWorkerJobSeekerProfileMonthType["November"] = "NOVEMBER";
    CoWorkerJobSeekerProfileMonthType["October"] = "OCTOBER";
    CoWorkerJobSeekerProfileMonthType["September"] = "SEPTEMBER";
})(CoWorkerJobSeekerProfileMonthType || (CoWorkerJobSeekerProfileMonthType = {}));
export var CoWorkerJobSeekerProfileTimeUnit;
(function (CoWorkerJobSeekerProfileTimeUnit) {
    CoWorkerJobSeekerProfileTimeUnit["Days"] = "Days";
    CoWorkerJobSeekerProfileTimeUnit["Months"] = "Months";
    CoWorkerJobSeekerProfileTimeUnit["Weeks"] = "Weeks";
    CoWorkerJobSeekerProfileTimeUnit["Years"] = "Years";
})(CoWorkerJobSeekerProfileTimeUnit || (CoWorkerJobSeekerProfileTimeUnit = {}));
export var CoWorkerMatchGroupFeedbackValue;
(function (CoWorkerMatchGroupFeedbackValue) {
    CoWorkerMatchGroupFeedbackValue["Disinterested"] = "DISINTERESTED";
    CoWorkerMatchGroupFeedbackValue["Liked"] = "LIKED";
    CoWorkerMatchGroupFeedbackValue["Neutral"] = "NEUTRAL";
})(CoWorkerMatchGroupFeedbackValue || (CoWorkerMatchGroupFeedbackValue = {}));
export var CoWorkerMessageSender;
(function (CoWorkerMessageSender) {
    CoWorkerMessageSender["Automated"] = "AUTOMATED";
    CoWorkerMessageSender["User"] = "USER";
})(CoWorkerMessageSender || (CoWorkerMessageSender = {}));
export var CoWorkerMessagingConversationRole;
(function (CoWorkerMessagingConversationRole) {
    CoWorkerMessagingConversationRole["Employer"] = "EMPLOYER";
    CoWorkerMessagingConversationRole["JobSeeker"] = "JOB_SEEKER";
    CoWorkerMessagingConversationRole["Unknown"] = "UNKNOWN";
})(CoWorkerMessagingConversationRole || (CoWorkerMessagingConversationRole = {}));
export var CoWorkerPromoType;
(function (CoWorkerPromoType) {
    CoWorkerPromoType["HomeRoutePromo"] = "HOME_ROUTE_PROMO";
    CoWorkerPromoType["InterviewCardPromo"] = "INTERVIEW_CARD_PROMO";
    CoWorkerPromoType["InterviewPrepPromo"] = "INTERVIEW_PREP_PROMO";
    CoWorkerPromoType["MessagesRoutePromo"] = "MESSAGES_ROUTE_PROMO";
    CoWorkerPromoType["MessagingPromo"] = "MESSAGING_PROMO";
    CoWorkerPromoType["MyjobsRoutePromo"] = "MYJOBS_ROUTE_PROMO";
    CoWorkerPromoType["PathfinderPromo"] = "PATHFINDER_PROMO";
    CoWorkerPromoType["PathfinderSkillsGroupsPromo"] = "PATHFINDER_SKILLS_GROUPS_PROMO";
    CoWorkerPromoType["PathfinderSuggestionCardsPromo"] = "PATHFINDER_SUGGESTION_CARDS_PROMO";
    CoWorkerPromoType["ProfileDataMergePromo"] = "PROFILE_DATA_MERGE_PROMO";
    CoWorkerPromoType["ProfileRoutePromo"] = "PROFILE_ROUTE_PROMO";
})(CoWorkerPromoType || (CoWorkerPromoType = {}));
export var CoWorkerSalaryType;
(function (CoWorkerSalaryType) {
    CoWorkerSalaryType["Biweekly"] = "BIWEEKLY";
    CoWorkerSalaryType["Daily"] = "DAILY";
    CoWorkerSalaryType["Hourly"] = "HOURLY";
    CoWorkerSalaryType["Monthly"] = "MONTHLY";
    CoWorkerSalaryType["Weekly"] = "WEEKLY";
    CoWorkerSalaryType["Yearly"] = "YEARLY";
})(CoWorkerSalaryType || (CoWorkerSalaryType = {}));
/** Part of the Collaboration Request Filter Input for querying Collaboration Request Connection nodes by sender / recipient */
export var CollaborationRequestDirection;
(function (CollaborationRequestDirection) {
    /** Limits Collaboration Requests to ones that were initiated to the current user (i.e. as the recipient) */
    CollaborationRequestDirection["Incoming"] = "INCOMING";
    /** Limits Collaboration Requests to ones that were initiated by the current user (i.e. as the sender) */
    CollaborationRequestDirection["Outgoing"] = "OUTGOING";
})(CollaborationRequestDirection || (CollaborationRequestDirection = {}));
/**
 * Current state of a Collaboration Request entity
 * Initiated is the starting state when a new record is created
 * Completed after the recipient acts on the request (i.e. provide feedback)
 * Reviewed after the sender reviews the recipients action
 */
export var CollaborationState;
(function (CollaborationState) {
    CollaborationState["Completed"] = "COMPLETED";
    CollaborationState["Initiated"] = "INITIATED";
    CollaborationState["Reviewed"] = "REVIEWED";
})(CollaborationState || (CollaborationState = {}));
/**
 * Specifies which Collaboration Request configuration to use
 * Uniquely identifies client
 */
export var CollaborationType;
(function (CollaborationType) {
    CollaborationType["EmployerJobCandidateJourneyFeedback"] = "EMPLOYER_JOB_CANDIDATE_JOURNEY_FEEDBACK";
    CollaborationType["ProjectInvite"] = "PROJECT_INVITE";
    CollaborationType["ProjectJobseekerFeedback"] = "PROJECT_JOBSEEKER_FEEDBACK";
})(CollaborationType || (CollaborationType = {}));
export var ColumnName;
(function (ColumnName) {
    ColumnName["CompanyName"] = "COMPANY_NAME";
    ColumnName["JobKey"] = "JOB_KEY";
    ColumnName["JobReference"] = "JOB_REFERENCE";
    ColumnName["JobTitle"] = "JOB_TITLE";
    ColumnName["Location"] = "LOCATION";
    ColumnName["Taxes"] = "TAXES";
})(ColumnName || (ColumnName = {}));
/** The type of the job commitment benefit. */
export var CommitmentBenefitType;
(function (CommitmentBenefitType) {
    CommitmentBenefitType["CertifiedEmployerBadge"] = "CERTIFIED_EMPLOYER_BADGE";
})(CommitmentBenefitType || (CommitmentBenefitType = {}));
/** Enum for CampaignDataSource */
export var CommunicationsHubCampaignDataSource;
(function (CommunicationsHubCampaignDataSource) {
    CommunicationsHubCampaignDataSource["Api"] = "API";
    CommunicationsHubCampaignDataSource["Csv"] = "CSV";
    CommunicationsHubCampaignDataSource["Iql"] = "IQL";
    CommunicationsHubCampaignDataSource["Ishbook"] = "ISHBOOK";
    CommunicationsHubCampaignDataSource["Presto"] = "PRESTO";
})(CommunicationsHubCampaignDataSource || (CommunicationsHubCampaignDataSource = {}));
/** Enum for CampaignStatus */
export var CommunicationsHubCampaignStatus;
(function (CommunicationsHubCampaignStatus) {
    CommunicationsHubCampaignStatus["Active"] = "ACTIVE";
    CommunicationsHubCampaignStatus["Archived"] = "ARCHIVED";
    CommunicationsHubCampaignStatus["Complete"] = "COMPLETE";
    CommunicationsHubCampaignStatus["Deactivated"] = "DEACTIVATED";
    CommunicationsHubCampaignStatus["Draft"] = "DRAFT";
    CommunicationsHubCampaignStatus["Paused"] = "PAUSED";
})(CommunicationsHubCampaignStatus || (CommunicationsHubCampaignStatus = {}));
/** Enum for campaign Type */
export var CommunicationsHubCampaignType;
(function (CommunicationsHubCampaignType) {
    CommunicationsHubCampaignType["Default"] = "DEFAULT";
    CommunicationsHubCampaignType["Triggered"] = "TRIGGERED";
})(CommunicationsHubCampaignType || (CommunicationsHubCampaignType = {}));
/** Category opt out class */
export var CommunicationsHubCategoryOptOutClass;
(function (CommunicationsHubCategoryOptOutClass) {
    CommunicationsHubCategoryOptOutClass["CategoryOptOut"] = "CATEGORY_OPT_OUT";
    CommunicationsHubCategoryOptOutClass["ContentTypeOptOut"] = "CONTENT_TYPE_OPT_OUT";
    CommunicationsHubCategoryOptOutClass["SubscriptionOptOut"] = "SUBSCRIPTION_OPT_OUT";
    CommunicationsHubCategoryOptOutClass["Transactional"] = "TRANSACTIONAL";
})(CommunicationsHubCategoryOptOutClass || (CommunicationsHubCategoryOptOutClass = {}));
/** enum for channel */
export var CommunicationsHubChannel;
(function (CommunicationsHubChannel) {
    /** Browser push notification channel */
    CommunicationsHubChannel["BrowserPush"] = "BROWSER_PUSH";
    /** Card channel */
    CommunicationsHubChannel["Card"] = "CARD";
    /** Email channel */
    CommunicationsHubChannel["Email"] = "EMAIL";
    /** Employer bell icon channel */
    CommunicationsHubChannel["InApp"] = "IN_APP";
    /** JobSeeker bell icon channel */
    CommunicationsHubChannel["JsInApp"] = "JS_IN_APP";
    /** Native push notification channel */
    CommunicationsHubChannel["NativePush"] = "NATIVE_PUSH";
    /** SMS channel */
    CommunicationsHubChannel["Sms"] = "SMS";
})(CommunicationsHubChannel || (CommunicationsHubChannel = {}));
/** enum for channel */
export var CommunicationsHubDeliveryChannel;
(function (CommunicationsHubDeliveryChannel) {
    CommunicationsHubDeliveryChannel["BrowserPushCommunicationsPlatform"] = "BROWSER_PUSH_COMMUNICATIONS_PLATFORM";
    CommunicationsHubDeliveryChannel["EmailCommunicationsPlatform"] = "EMAIL_COMMUNICATIONS_PLATFORM";
    CommunicationsHubDeliveryChannel["EmailMarketo"] = "EMAIL_MARKETO";
    CommunicationsHubDeliveryChannel["EmailMessageGears"] = "EMAIL_MESSAGE_GEARS";
    CommunicationsHubDeliveryChannel["EmployerNotifCtrCommunicationsPlatform"] = "EMPLOYER_NOTIF_CTR_COMMUNICATIONS_PLATFORM";
    CommunicationsHubDeliveryChannel["FbMessengerCommunicationsPlatform"] = "FB_MESSENGER_COMMUNICATIONS_PLATFORM";
    CommunicationsHubDeliveryChannel["LineCommunicationsPlatform"] = "LINE_COMMUNICATIONS_PLATFORM";
    CommunicationsHubDeliveryChannel["NativePushCommunicationsPlatform"] = "NATIVE_PUSH_COMMUNICATIONS_PLATFORM";
    CommunicationsHubDeliveryChannel["NotifCtrCommunicationsPlatform"] = "NOTIF_CTR_COMMUNICATIONS_PLATFORM";
    CommunicationsHubDeliveryChannel["PushCommunicationsPlatform"] = "PUSH_COMMUNICATIONS_PLATFORM";
    CommunicationsHubDeliveryChannel["SmsCommunicationsPlatform"] = "SMS_COMMUNICATIONS_PLATFORM";
    CommunicationsHubDeliveryChannel["WhatsappCommunicationsPlatform"] = "WHATSAPP_COMMUNICATIONS_PLATFORM";
})(CommunicationsHubDeliveryChannel || (CommunicationsHubDeliveryChannel = {}));
/** Export type for email preferences list export */
export var CommunicationsHubEmailExportType;
(function (CommunicationsHubEmailExportType) {
    CommunicationsHubEmailExportType["DirectMail"] = "DIRECT_MAIL";
    CommunicationsHubEmailExportType["Email"] = "EMAIL";
})(CommunicationsHubEmailExportType || (CommunicationsHubEmailExportType = {}));
/** Email recipient type, passed to RavenR render methods. More equivalent to the modern idea of "ID type" than recipient type */
export var CommunicationsHubEmailRecipientType;
(function (CommunicationsHubEmailRecipientType) {
    CommunicationsHubEmailRecipientType["Account"] = "ACCOUNT";
    CommunicationsHubEmailRecipientType["Advertiser"] = "ADVERTISER";
    CommunicationsHubEmailRecipientType["Email"] = "EMAIL";
})(CommunicationsHubEmailRecipientType || (CommunicationsHubEmailRecipientType = {}));
/** Format of an email template's "htmlBody" field */
export var CommunicationsHubEmailTemplateFormat;
(function (CommunicationsHubEmailTemplateFormat) {
    CommunicationsHubEmailTemplateFormat["Json"] = "JSON";
    CommunicationsHubEmailTemplateFormat["Velocity"] = "VELOCITY";
})(CommunicationsHubEmailTemplateFormat || (CommunicationsHubEmailTemplateFormat = {}));
/** Recipient type of an email template. Controls visual elements of an email - for example, the header and footer styles. */
export var CommunicationsHubEmailTemplateRecipientType;
(function (CommunicationsHubEmailTemplateRecipientType) {
    /** AKA send_type = EMP */
    CommunicationsHubEmailTemplateRecipientType["Employer"] = "EMPLOYER";
    /** AKA send_type = JS in EML */
    CommunicationsHubEmailTemplateRecipientType["JobSeeker"] = "JOB_SEEKER";
})(CommunicationsHubEmailTemplateRecipientType || (CommunicationsHubEmailTemplateRecipientType = {}));
/** Lifecycle status of an async preferences export job. */
export var CommunicationsHubExportPreferencesStatus;
(function (CommunicationsHubExportPreferencesStatus) {
    CommunicationsHubExportPreferencesStatus["Completed"] = "COMPLETED";
    CommunicationsHubExportPreferencesStatus["Failed"] = "FAILED";
    CommunicationsHubExportPreferencesStatus["Pending"] = "PENDING";
    CommunicationsHubExportPreferencesStatus["Running"] = "RUNNING";
})(CommunicationsHubExportPreferencesStatus || (CommunicationsHubExportPreferencesStatus = {}));
/** enum for frequency cap */
export var CommunicationsHubFrequencyCap;
(function (CommunicationsHubFrequencyCap) {
    /** Per-6-month frequency cap */
    CommunicationsHubFrequencyCap["BiAnnual"] = "BI_ANNUAL";
    /** Per-day frequency cap */
    CommunicationsHubFrequencyCap["Day"] = "DAY";
    /** Per-hour frequency cap */
    CommunicationsHubFrequencyCap["Hour"] = "HOUR";
    /** Per-minute frequency cap */
    CommunicationsHubFrequencyCap["Minute"] = "MINUTE";
    /** Per-month frequency cap */
    CommunicationsHubFrequencyCap["Month"] = "MONTH";
    /** Per-3-month frequency cap */
    CommunicationsHubFrequencyCap["QuarterAnnual"] = "QUARTER_ANNUAL";
    /** Per-4-month frequency cap */
    CommunicationsHubFrequencyCap["TriAnnual"] = "TRI_ANNUAL";
    /** Per-week frequency cap */
    CommunicationsHubFrequencyCap["Week"] = "WEEK";
    /** Per-year frequency cap */
    CommunicationsHubFrequencyCap["Year"] = "YEAR";
})(CommunicationsHubFrequencyCap || (CommunicationsHubFrequencyCap = {}));
/** Enum for FrequencyOption */
export var CommunicationsHubFrequencyOption;
(function (CommunicationsHubFrequencyOption) {
    CommunicationsHubFrequencyOption["OneTime"] = "ONE_TIME";
    CommunicationsHubFrequencyOption["Recurring"] = "RECURRING";
})(CommunicationsHubFrequencyOption || (CommunicationsHubFrequencyOption = {}));
/** Enum for FrequencyType */
export var CommunicationsHubFrequencyType;
(function (CommunicationsHubFrequencyType) {
    CommunicationsHubFrequencyType["Hourly"] = "HOURLY";
    CommunicationsHubFrequencyType["Monthly"] = "MONTHLY";
    CommunicationsHubFrequencyType["Oneoff"] = "ONEOFF";
    CommunicationsHubFrequencyType["Weekly"] = "WEEKLY";
})(CommunicationsHubFrequencyType || (CommunicationsHubFrequencyType = {}));
/** Enum for IdType */
export var CommunicationsHubIdType;
(function (CommunicationsHubIdType) {
    CommunicationsHubIdType["Account"] = "ACCOUNT";
    CommunicationsHubIdType["Advertiser"] = "ADVERTISER";
    CommunicationsHubIdType["Email"] = "EMAIL";
    CommunicationsHubIdType["PhoneNumber"] = "PHONE_NUMBER";
})(CommunicationsHubIdType || (CommunicationsHubIdType = {}));
/** enum for campaign priority */
export var CommunicationsHubPriority;
(function (CommunicationsHubPriority) {
    /** DEFAULT priority */
    CommunicationsHubPriority["Default"] = "DEFAULT";
    /** HIGH priority */
    CommunicationsHubPriority["High"] = "HIGH";
    /** LOW priority */
    CommunicationsHubPriority["Low"] = "LOW";
})(CommunicationsHubPriority || (CommunicationsHubPriority = {}));
/** Enum for RecipientExclusion */
export var CommunicationsHubRecipientExclusion;
(function (CommunicationsHubRecipientExclusion) {
    CommunicationsHubRecipientExclusion["IndeedEmailDomain"] = "INDEED_EMAIL_DOMAIN";
    CommunicationsHubRecipientExclusion["NonIndeedEmailDomain"] = "NON_INDEED_EMAIL_DOMAIN";
    CommunicationsHubRecipientExclusion["StaffingAgencyJobBoard"] = "STAFFING_AGENCY_JOB_BOARD";
    CommunicationsHubRecipientExclusion["UnconfirmedAccount"] = "UNCONFIRMED_ACCOUNT";
})(CommunicationsHubRecipientExclusion || (CommunicationsHubRecipientExclusion = {}));
/** Sorting order */
export var CommunicationsHubSortingOrder;
(function (CommunicationsHubSortingOrder) {
    CommunicationsHubSortingOrder["CampaignNameAsc"] = "CAMPAIGN_NAME_ASC";
    CommunicationsHubSortingOrder["CampaignNameDesc"] = "CAMPAIGN_NAME_DESC";
    CommunicationsHubSortingOrder["ChannelAsc"] = "CHANNEL_ASC";
    CommunicationsHubSortingOrder["ChannelDesc"] = "CHANNEL_DESC";
    CommunicationsHubSortingOrder["CreatorAsc"] = "CREATOR_ASC";
    CommunicationsHubSortingOrder["CreatorDesc"] = "CREATOR_DESC";
    CommunicationsHubSortingOrder["ModifiedTimeAsc"] = "MODIFIED_TIME_ASC";
    CommunicationsHubSortingOrder["ModifiedTimeDesc"] = "MODIFIED_TIME_DESC";
    CommunicationsHubSortingOrder["StatusAsc"] = "STATUS_ASC";
    CommunicationsHubSortingOrder["StatusDesc"] = "STATUS_DESC";
    CommunicationsHubSortingOrder["TeamAsc"] = "TEAM_ASC";
    CommunicationsHubSortingOrder["TeamDesc"] = "TEAM_DESC";
    CommunicationsHubSortingOrder["TemplateNameAsc"] = "TEMPLATE_NAME_ASC";
    CommunicationsHubSortingOrder["TemplateNameDesc"] = "TEMPLATE_NAME_DESC";
})(CommunicationsHubSortingOrder || (CommunicationsHubSortingOrder = {}));
/** Enum for SpamLevel */
export var CommunicationsHubSpamLevel;
(function (CommunicationsHubSpamLevel) {
    CommunicationsHubSpamLevel["Solicited"] = "SOLICITED";
    CommunicationsHubSpamLevel["Unsolicited"] = "UNSOLICITED";
})(CommunicationsHubSpamLevel || (CommunicationsHubSpamLevel = {}));
/** Despite its name, this actually represents the campaign recipient type */
export var CommunicationsHubTemplateRecipientType;
(function (CommunicationsHubTemplateRecipientType) {
    /** Partner Console users */
    CommunicationsHubTemplateRecipientType["ConsoleUser"] = "CONSOLE_USER";
    /** Employer */
    CommunicationsHubTemplateRecipientType["Employer"] = "EMPLOYER";
    /** Internal Indeedians */
    CommunicationsHubTemplateRecipientType["Internal"] = "INTERNAL";
    /** Job Seeker */
    CommunicationsHubTemplateRecipientType["JobSeeker"] = "JOB_SEEKER";
    /** Non-Indeed users */
    CommunicationsHubTemplateRecipientType["NonIndeed"] = "NON_INDEED";
})(CommunicationsHubTemplateRecipientType || (CommunicationsHubTemplateRecipientType = {}));
/** Current status of the template */
export var CommunicationsHubTemplateStatus;
(function (CommunicationsHubTemplateStatus) {
    CommunicationsHubTemplateStatus["Complete"] = "COMPLETE";
    CommunicationsHubTemplateStatus["Draft"] = "DRAFT";
    CommunicationsHubTemplateStatus["Pending"] = "PENDING";
})(CommunicationsHubTemplateStatus || (CommunicationsHubTemplateStatus = {}));
/**
 * Lifecycle status of an async template suggestion job. Shared by every kind of
 * template suggestion (i18n wrapping, text-only conversion, etc.) since the
 * lifecycle is identical regardless of which kind of suggestion produced it.
 */
export var CommunicationsHubTemplateSuggestionStatus;
(function (CommunicationsHubTemplateSuggestionStatus) {
    CommunicationsHubTemplateSuggestionStatus["Completed"] = "COMPLETED";
    CommunicationsHubTemplateSuggestionStatus["Failed"] = "FAILED";
    CommunicationsHubTemplateSuggestionStatus["Pending"] = "PENDING";
    CommunicationsHubTemplateSuggestionStatus["Running"] = "RUNNING";
})(CommunicationsHubTemplateSuggestionStatus || (CommunicationsHubTemplateSuggestionStatus = {}));
/** Localization type for a template variable */
export var CommunicationsHubTemplateVariableLocalizationType;
(function (CommunicationsHubTemplateVariableLocalizationType) {
    /** Variable value is a currency and an amount, e.g. 100 USD */
    CommunicationsHubTemplateVariableLocalizationType["Currency"] = "CURRENCY";
    /** Variable represents a date, e.g. April 22, 2026 */
    CommunicationsHubTemplateVariableLocalizationType["Date"] = "DATE";
    /** Variable value is a full date time, e.g. 3:47 on April 22, 2026. */
    CommunicationsHubTemplateVariableLocalizationType["DateTime"] = "DATE_TIME";
    /** Variable is displayed as-is, no special localization logic */
    CommunicationsHubTemplateVariableLocalizationType["Raw"] = "RAW";
    /** Variable represents a time, e.g. 3:47 PM */
    CommunicationsHubTemplateVariableLocalizationType["Time"] = "TIME";
    /** Variable is a year and a month, e.g. April 2026 */
    CommunicationsHubTemplateVariableLocalizationType["YearMonth"] = "YEAR_MONTH";
})(CommunicationsHubTemplateVariableLocalizationType || (CommunicationsHubTemplateVariableLocalizationType = {}));
/**
 * Target audience for a translation request. Provides additional context for translators.
 * Determines what is passed to AddPenguin mutation input in TranslationManager's graphQL API
 */
export var CommunicationsHubTranslationRequestTargetAudience;
(function (CommunicationsHubTranslationRequestTargetAudience) {
    CommunicationsHubTranslationRequestTargetAudience["Employer"] = "EMPLOYER";
    CommunicationsHubTranslationRequestTargetAudience["EmployerAndJobseeker"] = "EMPLOYER_AND_JOBSEEKER";
    CommunicationsHubTranslationRequestTargetAudience["Internal"] = "INTERNAL";
    CommunicationsHubTranslationRequestTargetAudience["Jobseeker"] = "JOBSEEKER";
})(CommunicationsHubTranslationRequestTargetAudience || (CommunicationsHubTranslationRequestTargetAudience = {}));
export var CommuteMethod;
(function (CommuteMethod) {
    /** Automobile without traffic consideration. */
    CommuteMethod["AutomobileNoTraffic"] = "AUTOMOBILE_NO_TRAFFIC";
})(CommuteMethod || (CommuteMethod = {}));
/** Variants of the CompanyDescription optimization */
export var CompanyDescriptionOptimizationVariant;
(function (CompanyDescriptionOptimizationVariant) {
    /** @deprecated Company Description variant is deprecated */
    CompanyDescriptionOptimizationVariant["CompanyDescriptionOptimizationVariantDefault"] = "COMPANY_DESCRIPTION_OPTIMIZATION_VARIANT_DEFAULT";
})(CompanyDescriptionOptimizationVariant || (CompanyDescriptionOptimizationVariant = {}));
/** Types of supported Company Page Analytics Metrics */
export var CompanyPageAnalyticsMetricName;
(function (CompanyPageAnalyticsMetricName) {
    /** @deprecated Use COMPANY_ALERTS instead */
    CompanyPageAnalyticsMetricName["AcmeCompanyAlerts"] = "ACME_COMPANY_ALERTS";
    CompanyPageAnalyticsMetricName["AcmeMobileImpression"] = "ACME_MOBILE_IMPRESSION";
    CompanyPageAnalyticsMetricName["AcmeOrganicImpression"] = "ACME_ORGANIC_IMPRESSION";
    CompanyPageAnalyticsMetricName["AcmeUniqueVisitorsCompany"] = "ACME_UNIQUE_VISITORS_COMPANY";
    CompanyPageAnalyticsMetricName["AcmeUniqueVisitorsReview"] = "ACME_UNIQUE_VISITORS_REVIEW";
    CompanyPageAnalyticsMetricName["CompanyAlerts"] = "COMPANY_ALERTS";
    CompanyPageAnalyticsMetricName["Followers"] = "FOLLOWERS";
    /** @deprecated Use FOLLOWERS instead */
    CompanyPageAnalyticsMetricName["FollowsCompanyPage"] = "FOLLOWS_COMPANY_PAGE";
    CompanyPageAnalyticsMetricName["ItabDesktopBrandingImpressions"] = "ITAB_DESKTOP_BRANDING_IMPRESSIONS";
    CompanyPageAnalyticsMetricName["ItabMobileBrandingImpressions"] = "ITAB_MOBILE_BRANDING_IMPRESSIONS";
    CompanyPageAnalyticsMetricName["ViewFromMobileViewJob"] = "VIEW_FROM_MOBILE_VIEW_JOB";
    CompanyPageAnalyticsMetricName["ViewFromViewJob"] = "VIEW_FROM_VIEW_JOB";
})(CompanyPageAnalyticsMetricName || (CompanyPageAnalyticsMetricName = {}));
export var CompanySizeEnum;
(function (CompanySizeEnum) {
    CompanySizeEnum["Employee_1_49"] = "EMPLOYEE_1_49";
    CompanySizeEnum["Employee_50_149"] = "EMPLOYEE_50_149";
    CompanySizeEnum["Employee_150_249"] = "EMPLOYEE_150_249";
    CompanySizeEnum["Employee_250_499"] = "EMPLOYEE_250_499";
    CompanySizeEnum["Employee_500_749"] = "EMPLOYEE_500_749";
    CompanySizeEnum["Employee_750_999"] = "EMPLOYEE_750_999";
    CompanySizeEnum["Employee_1000More"] = "EMPLOYEE_1000_MORE";
})(CompanySizeEnum || (CompanySizeEnum = {}));
/**  Competition level categories based on competition score  */
export var CompetitionLevel;
(function (CompetitionLevel) {
    CompetitionLevel["High"] = "HIGH";
    CompetitionLevel["Low"] = "LOW";
    CompetitionLevel["Medium"] = "MEDIUM";
})(CompetitionLevel || (CompetitionLevel = {}));
export var CompleteButtonParameterDestinationType;
(function (CompleteButtonParameterDestinationType) {
    CompleteButtonParameterDestinationType["Cancel"] = "CANCEL";
    CompleteButtonParameterDestinationType["Confirm"] = "CONFIRM";
    CompleteButtonParameterDestinationType["Reschedule"] = "RESCHEDULE";
    CompleteButtonParameterDestinationType["Suggesttime"] = "SUGGESTTIME";
})(CompleteButtonParameterDestinationType || (CompleteButtonParameterDestinationType = {}));
/** Enum values for apply domains */
export var CompleteButtonParametersApplyDomain;
(function (CompleteButtonParametersApplyDomain) {
    CompleteButtonParametersApplyDomain["Indeed"] = "INDEED";
    CompleteButtonParametersApplyDomain["ThirdParty"] = "THIRD_PARTY";
})(CompleteButtonParametersApplyDomain || (CompleteButtonParametersApplyDomain = {}));
export var CompleteButtonParametersContactInfoNameFormatType;
(function (CompleteButtonParametersContactInfoNameFormatType) {
    CompleteButtonParametersContactInfoNameFormatType["FirstLastName"] = "FIRST_LAST_NAME";
    CompleteButtonParametersContactInfoNameFormatType["FullName"] = "FULL_NAME";
})(CompleteButtonParametersContactInfoNameFormatType || (CompleteButtonParametersContactInfoNameFormatType = {}));
export var CompleteButtonParametersFieldRequirementType;
(function (CompleteButtonParametersFieldRequirementType) {
    CompleteButtonParametersFieldRequirementType["Hidden"] = "HIDDEN";
    CompleteButtonParametersFieldRequirementType["Optional"] = "OPTIONAL";
    CompleteButtonParametersFieldRequirementType["Required"] = "REQUIRED";
})(CompleteButtonParametersFieldRequirementType || (CompleteButtonParametersFieldRequirementType = {}));
/** Enum representing the possible responses by the advertiser */
export var CompromisedActionState;
(function (CompromisedActionState) {
    CompromisedActionState["EmployerConfirmed"] = "EMPLOYER_CONFIRMED";
    CompromisedActionState["EmployerRefuted"] = "EMPLOYER_REFUTED";
})(CompromisedActionState || (CompromisedActionState = {}));
/** Enum representing the possible types of compromised action */
export var CompromisedActionType;
(function (CompromisedActionType) {
    CompromisedActionType["PostJob"] = "POST_JOB";
    CompromisedActionType["SecondaryAccountLink"] = "SECONDARY_ACCOUNT_LINK";
    CompromisedActionType["UpdateJob"] = "UPDATE_JOB";
})(CompromisedActionType || (CompromisedActionType = {}));
/**
 * The compromised state of an advertiser account.
 * Used to determine if user management permissions should be locked down.
 */
export var CompromisedAdvertiserState;
(function (CompromisedAdvertiserState) {
    /** The advertiser account is awaiting cleanup after compromise was confirmed. */
    CompromisedAdvertiserState["AwaitingCleanup"] = "AWAITING_CLEANUP";
    /** The advertiser account is awaiting confirmation from the owner. */
    CompromisedAdvertiserState["AwaitingConfirmation"] = "AWAITING_CONFIRMATION";
    /** The advertiser account is under review for potential compromise. */
    CompromisedAdvertiserState["InReview"] = "IN_REVIEW";
    /** The advertiser account is not compromised. */
    CompromisedAdvertiserState["NotCompromised"] = "NOT_COMPROMISED";
})(CompromisedAdvertiserState || (CompromisedAdvertiserState = {}));
/**
 * GraphQL Schema Basics: https://www.apollographql.com/docs/apollo-server/schema/schema/
 * Indeed API Recommendations: https://link.indeed.tech/api-recommendations
 *
 * Need help designing your schema? Check out the schema designer tool: https://graphql-schema-designer.sandbox.indeed.net/
 */
export var CompromisedState;
(function (CompromisedState) {
    CompromisedState["AwaitingCleanup"] = "AWAITING_CLEANUP";
    CompromisedState["AwaitingConfirmation"] = "AWAITING_CONFIRMATION";
    CompromisedState["InReview"] = "IN_REVIEW";
    CompromisedState["NotCompromised"] = "NOT_COMPROMISED";
})(CompromisedState || (CompromisedState = {}));
export var CompromisedStatusType;
(function (CompromisedStatusType) {
    CompromisedStatusType["InReview"] = "IN_REVIEW";
    CompromisedStatusType["NotCompromised"] = "NOT_COMPROMISED";
})(CompromisedStatusType || (CompromisedStatusType = {}));
export var ConceptTypeInput;
(function (ConceptTypeInput) {
    /** Concept type is attribute */
    ConceptTypeInput["ConceptTypeAttribute"] = "CONCEPT_TYPE_ATTRIBUTE";
    /** Concept type is occupation */
    ConceptTypeInput["ConceptTypeOccupation"] = "CONCEPT_TYPE_OCCUPATION";
})(ConceptTypeInput || (ConceptTypeInput = {}));
/** Confidence level for a suggestion (HIGH, MEDIUM, LOW, UNKNOWN) */
export var ConfidenceLabel;
(function (ConfidenceLabel) {
    ConfidenceLabel["High"] = "HIGH";
    ConfidenceLabel["Low"] = "LOW";
    ConfidenceLabel["Medium"] = "MEDIUM";
    /** Fallback when confidence data is missing or invalid */
    ConfidenceLabel["Unknown"] = "UNKNOWN";
})(ConfidenceLabel || (ConfidenceLabel = {}));
/**  Confirmation status  */
export var ConfirmationStatus;
(function (ConfirmationStatus) {
    ConfirmationStatus["Confirmed"] = "CONFIRMED";
    ConfirmationStatus["DealCreated"] = "DEAL_CREATED";
    ConfirmationStatus["ManuallyConfirmed"] = "MANUALLY_CONFIRMED";
    ConfirmationStatus["Rejected"] = "REJECTED";
    ConfirmationStatus["RequestSent"] = "REQUEST_SENT";
})(ConfirmationStatus || (ConfirmationStatus = {}));
/** Indicates which side of the movement has the conflicting deal */
export var ConflictingDealSide;
(function (ConflictingDealSide) {
    /** Deal exists in destination advertiser's ancestor chain */
    ConflictingDealSide["Destination"] = "DESTINATION";
    /** Deal exists in source advertiser's sub-tree (source or its descendants) */
    ConflictingDealSide["Source"] = "SOURCE";
})(ConflictingDealSide || (ConflictingDealSide = {}));
/** Types of external calendar services. */
export var ConnectedCalendarProviderType;
(function (ConnectedCalendarProviderType) {
    /** Apple iCloud. */
    ConnectedCalendarProviderType["Apple"] = "APPLE";
    /** Microsoft Exchange. */
    ConnectedCalendarProviderType["Exchange"] = "EXCHANGE";
    /** Google. */
    ConnectedCalendarProviderType["Google"] = "GOOGLE";
    /** Microsoft Windows Live. */
    ConnectedCalendarProviderType["LiveConnect"] = "LIVE_CONNECT";
    /**
     * The underlying calendar provider is currently unknown to the availability service.
     *
     * This is not a value that will normally be returned by the availability service. It will only
     * be returned if the type of calendar provider is new to the service in that it has not yet
     * been added as an entry in the enum.
     */
    ConnectedCalendarProviderType["Unknown"] = "UNKNOWN";
})(ConnectedCalendarProviderType || (ConnectedCalendarProviderType = {}));
/** Language options for connection flows */
export var ConnectionLanguage;
(function (ConnectionLanguage) {
    /** German */
    ConnectionLanguage["De"] = "DE";
    /** English */
    ConnectionLanguage["En"] = "EN";
    /** Spanish */
    ConnectionLanguage["Es"] = "ES";
    /** French */
    ConnectionLanguage["Fr"] = "FR";
    /** Italian */
    ConnectionLanguage["It"] = "IT";
})(ConnectionLanguage || (ConnectionLanguage = {}));
/** Actor performing an action on a consent request. */
export var ConsentRequestActor;
(function (ConsentRequestActor) {
    /** Employer/advertiser */
    ConsentRequestActor["Employer"] = "EMPLOYER";
    /** Sales representative */
    ConsentRequestActor["Rep"] = "REP";
    /** System actor for automated tasks */
    ConsentRequestActor["System"] = "SYSTEM";
})(ConsentRequestActor || (ConsentRequestActor = {}));
/** Type of consent request event in the audit trail. */
export var ConsentRequestEventType;
(function (ConsentRequestEventType) {
    /**
     * Deprecated alias for RESOLUTION, retained for backward compatibility. Never emitted by the server.
     * @deprecated Use RESOLUTION instead. FINAL is no longer emitted and will be removed in a future release.
     */
    ConsentRequestEventType["Final"] = "FINAL";
    /** Initial creation event */
    ConsentRequestEventType["Initial"] = "INITIAL";
    /** Transition to a closed status (accepted, corrected, declined, retracted, or expired) */
    ConsentRequestEventType["Resolution"] = "RESOLUTION";
    /** Status update event */
    ConsentRequestEventType["Update"] = "UPDATE";
})(ConsentRequestEventType || (ConsentRequestEventType = {}));
/** Source system that created the consent request. */
export var ConsentRequestSource;
(function (ConsentRequestSource) {
    /** Created via EVE Chrome Extension */
    ConsentRequestSource["Eve"] = "EVE";
})(ConsentRequestSource || (ConsentRequestSource = {}));
/**
 * Status of a consent request in its lifecycle.
 * Progression: SUBMITTED -> PROCESSED -> SERVED -> ACCEPTED, with optional post-acceptance failure handling.
 */
export var ConsentRequestStatus;
(function (ConsentRequestStatus) {
    /** Employer accepted the consent request */
    ConsentRequestStatus["Accepted"] = "ACCEPTED";
    /** Rep manually corrected the actioning failure and closed the request */
    ConsentRequestStatus["ApplyCorrected"] = "APPLY_CORRECTED";
    /** Actioning of the accepted request failed unrecoverably; awaiting rep clean-up */
    ConsentRequestStatus["ApplyFailed"] = "APPLY_FAILED";
    /** Employer declined the consent request */
    ConsentRequestStatus["Declined"] = "DECLINED";
    /** Employer declined on the basis of making adjustments */
    ConsentRequestStatus["DeclinedAdjust"] = "DECLINED_ADJUST";
    /** Request expired without action */
    ConsentRequestStatus["Expired"] = "EXPIRED";
    /** The request has been processed by Action Center */
    ConsentRequestStatus["Processed"] = "PROCESSED";
    /** Rep retracted the request */
    ConsentRequestStatus["Retracted"] = "RETRACTED";
    /** Rep retracted the request on the basis of making adjustments */
    ConsentRequestStatus["RetractedAdjust"] = "RETRACTED_ADJUST";
    /** Request has been served to the employer */
    ConsentRequestStatus["Served"] = "SERVED";
    /** Initial state when rep creates the request */
    ConsentRequestStatus["Submitted"] = "SUBMITTED";
})(ConsentRequestStatus || (ConsentRequestStatus = {}));
/** Type of consent request. */
export var ConsentRequestType;
(function (ConsentRequestType) {
    /** Consent for sponsoring one or more jobs */
    ConsentRequestType["JobSponsorship"] = "JOB_SPONSORSHIP";
})(ConsentRequestType || (ConsentRequestType = {}));
export var ConsentResponse;
(function (ConsentResponse) {
    ConsentResponse["Accepted"] = "ACCEPTED";
    ConsentResponse["Declined"] = "DECLINED";
    ConsentResponse["NotResponded"] = "NOT_RESPONDED";
})(ConsentResponse || (ConsentResponse = {}));
export var ConsumeFailureReason;
(function (ConsumeFailureReason) {
    ConsumeFailureReason["AssignmentNotFound"] = "ASSIGNMENT_NOT_FOUND";
    ConsumeFailureReason["ConcurrentModification"] = "CONCURRENT_MODIFICATION";
    ConsumeFailureReason["DuplicateRequest"] = "DUPLICATE_REQUEST";
    ConsumeFailureReason["InsufficientEntitlement"] = "INSUFFICIENT_ENTITLEMENT";
    ConsumeFailureReason["Unknown"] = "UNKNOWN";
})(ConsumeFailureReason || (ConsumeFailureReason = {}));
/** Contact error type */
export var ContactIndeedPlusCandidateErrorCode;
(function (ContactIndeedPlusCandidateErrorCode) {
    ContactIndeedPlusCandidateErrorCode["AccountNotFound"] = "ACCOUNT_NOT_FOUND";
    ContactIndeedPlusCandidateErrorCode["EmailNotFound"] = "EMAIL_NOT_FOUND";
    ContactIndeedPlusCandidateErrorCode["InsufficientSourcingContacts"] = "INSUFFICIENT_SOURCING_CONTACTS";
    ContactIndeedPlusCandidateErrorCode["InternalServerError"] = "INTERNAL_SERVER_ERROR";
    ContactIndeedPlusCandidateErrorCode["InvalidAccountKey"] = "INVALID_ACCOUNT_KEY";
    ContactIndeedPlusCandidateErrorCode["UserAlreadyContacted"] = "USER_ALREADY_CONTACTED";
})(ContactIndeedPlusCandidateErrorCode || (ContactIndeedPlusCandidateErrorCode = {}));
export var ContactPreferenceEnum;
(function (ContactPreferenceEnum) {
    ContactPreferenceEnum["Email"] = "EMAIL";
    ContactPreferenceEnum["Phone"] = "PHONE";
})(ContactPreferenceEnum || (ContactPreferenceEnum = {}));
/** Type of contact to consume from the package */
export var ContactType;
(function (ContactType) {
    ContactType["AiContact"] = "AI_CONTACT";
    ContactType["ManualContact"] = "MANUAL_CONTACT";
})(ContactType || (ContactType = {}));
export var ContentFlagFieldType;
(function (ContentFlagFieldType) {
    ContentFlagFieldType["CandidateSubmissionNoteForEmployer"] = "CANDIDATE_SUBMISSION_NOTE_FOR_EMPLOYER";
    ContentFlagFieldType["JobBidDenyReason"] = "JOB_BID_DENY_REASON";
    ContentFlagFieldType["JobBidGreetingMessageFromEmployer"] = "JOB_BID_GREETING_MESSAGE_FROM_EMPLOYER";
    ContentFlagFieldType["JobBidGreetingMessageFromRecruiter"] = "JOB_BID_GREETING_MESSAGE_FROM_RECRUITER";
    ContentFlagFieldType["JobOrderJobInfo"] = "JOB_ORDER_JOB_INFO";
})(ContentFlagFieldType || (ContentFlagFieldType = {}));
export var ContentFlagTargetType;
(function (ContentFlagTargetType) {
    ContentFlagTargetType["CandidateSubmission"] = "CANDIDATE_SUBMISSION";
    ContentFlagTargetType["JobBid"] = "JOB_BID";
    ContentFlagTargetType["JobOrder"] = "JOB_ORDER";
})(ContentFlagTargetType || (ContentFlagTargetType = {}));
/** Describes how much input context backed the generated content. */
export var ContextQualityTier;
(function (ContextQualityTier) {
    ContextQualityTier["Draft"] = "DRAFT";
    ContextQualityTier["Standard"] = "STANDARD";
    ContextQualityTier["Strong"] = "STRONG";
})(ContextQualityTier || (ContextQualityTier = {}));
/** Current contract term of the Subscription */
export var ContractTerm;
(function (ContractTerm) {
    ContractTerm["Annual"] = "ANNUAL";
    ContractTerm["Monthly"] = "MONTHLY";
    ContractTerm["MonthlyPaidUpfront"] = "MONTHLY_PAID_UPFRONT";
    ContractTerm["None"] = "NONE";
})(ContractTerm || (ContractTerm = {}));
export var ConversationCategory;
(function (ConversationCategory) {
    /** interview scheduling related conversation topics, e.g. providing availability, confirming interview times */
    ConversationCategory["InterviewScheduling"] = "INTERVIEW_SCHEDULING";
    /** a catch all item for categories that we don't currently support */
    ConversationCategory["OtherResponseType"] = "OTHER_RESPONSE_TYPE";
})(ConversationCategory || (ConversationCategory = {}));
/** Enumeration of possible conversation contexts. */
export var ConversationContext;
(function (ConversationContext) {
    ConversationContext["Application"] = "APPLICATION";
    ConversationContext["Elephant"] = "ELEPHANT";
    ConversationContext["Flex"] = "FLEX";
    ConversationContext["Hqm"] = "HQM";
    ConversationContext["HqmPreapply"] = "HQM_PREAPPLY";
    ConversationContext["I2A"] = "I2A";
    ConversationContext["Ihp"] = "IHP";
    ConversationContext["IndeedApply"] = "INDEED_APPLY";
    ConversationContext["Inquiry"] = "INQUIRY";
    ConversationContext["ResumeContact"] = "RESUME_CONTACT";
    ConversationContext["TestingContext"] = "TESTING_CONTEXT";
    ConversationContext["Unknown"] = "UNKNOWN";
})(ConversationContext || (ConversationContext = {}));
/** Enumeration of possible conversation event message content formats. */
export var ConversationEventMessageContentFormat;
(function (ConversationEventMessageContentFormat) {
    ConversationEventMessageContentFormat["Html"] = "HTML";
    ConversationEventMessageContentFormat["Plain"] = "PLAIN";
    ConversationEventMessageContentFormat["Unknown"] = "UNKNOWN";
})(ConversationEventMessageContentFormat || (ConversationEventMessageContentFormat = {}));
/**
 * Enumeration of possible conversation event metadata keys.
 * Mapping from https://indeed.sourcegraph.com/code.corp.indeed.com/conversation-platform/conversation-service/-/blob/client/src/main/java/com/indeed/conversation/platform/client/utils/KeyValueReservedKeys.java
 */
export var ConversationEventMetadataKey;
(function (ConversationEventMetadataKey) {
    /**
     * Indicate if conversation event is broadcasted (participant-based).
     * See MSGP-5801 for more details
     */
    ConversationEventMetadataKey["BroadcastOnPlatform"] = "BROADCAST_ON_PLATFORM";
    ConversationEventMetadataKey["CallOutcome"] = "CALL_OUTCOME";
    ConversationEventMetadataKey["CallRequestCallbackNumber"] = "CALL_REQUEST_CALLBACK_NUMBER";
    ConversationEventMetadataKey["CallRequestEmployerNumber"] = "CALL_REQUEST_EMPLOYER_NUMBER";
    ConversationEventMetadataKey["CallRequestFormattedCallbackNumber"] = "CALL_REQUEST_FORMATTED_CALLBACK_NUMBER";
    ConversationEventMetadataKey["CallRequestFormattedEmployerNumber"] = "CALL_REQUEST_FORMATTED_EMPLOYER_NUMBER";
    ConversationEventMetadataKey["CallRequestPin"] = "CALL_REQUEST_PIN";
    /** The jobKey of the job that the candidate applied for. */
    ConversationEventMetadataKey["CandidateDispositionNotificationJobKey"] = "CANDIDATE_DISPOSITION_NOTIFICATION_JOB_KEY";
    /** The new status to be notified to the candidate. */
    ConversationEventMetadataKey["CandidateDispositionNotificationNewStatus"] = "CANDIDATE_DISPOSITION_NOTIFICATION_NEW_STATUS";
    /** The onboarding date in milliseconds since Unix Epoch to be notified to the candidate. */
    ConversationEventMetadataKey["CandidateDispositionNotificationOnboardingDateMs"] = "CANDIDATE_DISPOSITION_NOTIFICATION_ONBOARDING_DATE_MS";
    ConversationEventMetadataKey["DradisMsgTemplateGroup"] = "DRADIS_MSG_TEMPLATE_GROUP";
    ConversationEventMetadataKey["DradisMsgTemplateHasEdited"] = "DRADIS_MSG_TEMPLATE_HAS_EDITED";
    ConversationEventMetadataKey["DradisMsgTemplateName"] = "DRADIS_MSG_TEMPLATE_NAME";
    ConversationEventMetadataKey["DremrSubject"] = "DREMR_SUBJECT";
    /** The ID of Employer Automation that send conversation on behalf of employers */
    ConversationEventMetadataKey["EmployerAutomationId"] = "EMPLOYER_AUTOMATION_ID";
    ConversationEventMetadataKey["InboundEmailDataKey"] = "INBOUND_EMAIL_DATA_KEY";
    /** Indicates that message event used AI to generate its content. */
    ConversationEventMetadataKey["IncludesAiContent"] = "INCLUDES_AI_CONTENT";
    /** IMP interview ID. Must always be the UUID, and not the raw or encrypted MongoDB ID. */
    ConversationEventMetadataKey["InterviewId"] = "INTERVIEW_ID";
    /**
     * Legacy interview message. No new clients should use this field, instead the conversation event
     * messageBody should be used for any user messages tied to an interview action.
     * @deprecated No longer supported
     */
    ConversationEventMetadataKey["InterviewNote"] = "INTERVIEW_NOTE";
    /** IMP interview version. Should only be supplied alongside INTERVIEW_ID. */
    ConversationEventMetadataKey["InterviewVersion"] = "INTERVIEW_VERSION";
    /** Indicates that message event is AI-initiated. */
    ConversationEventMetadataKey["IsAiInitiated"] = "IS_AI_INITIATED";
    /**
     * Legacy interview ID for jobseeker messaging. All clients must migrate to INTERVIEW_ID.
     * @deprecated No longer supported
     */
    ConversationEventMetadataKey["LegacyJsInterviewId"] = "LEGACY_JS_INTERVIEW_ID";
    /** The event locale info */
    ConversationEventMetadataKey["Locale"] = "LOCALE";
    ConversationEventMetadataKey["Other"] = "OTHER";
    ConversationEventMetadataKey["ReplyTo"] = "REPLY_TO";
    ConversationEventMetadataKey["ResumeContactTk"] = "RESUME_CONTACT_TK";
    ConversationEventMetadataKey["SuppressNotifications"] = "SUPPRESS_NOTIFICATIONS";
    /**
     * Indicates that any reminders that are configured by default for this event should be suppressed. This is a stop-gap
     * until more formal reminder support can be added to the API and shouldn't be used unless absolutely necessary. It will
     * be deprecated by the end of 2024
     */
    ConversationEventMetadataKey["SuppressReminders"] = "SUPPRESS_REMINDERS";
})(ConversationEventMetadataKey || (ConversationEventMetadataKey = {}));
/**
 * Enumeration of possible conversation sub event types.
 *
 * These provide additional context about events, and are logged in the conversationEvents index
 * The main use cases are
 * - collecting metrics
 * - extending the behavior of a type
 *
 * When adding or removing a type here, update the relationship defined in application.yml
 */
export var ConversationEventSubType;
(function (ConversationEventSubType) {
    ConversationEventSubType["BulkDradisSend"] = "BULK_DRADIS_SEND";
    ConversationEventSubType["BulkDradisTemplate"] = "BULK_DRADIS_TEMPLATE";
    ConversationEventSubType["CancelEmail"] = "CANCEL_EMAIL";
    ConversationEventSubType["CancelEmailMultitime"] = "CANCEL_EMAIL_MULTITIME";
    ConversationEventSubType["CandautoAutoContact"] = "CANDAUTO_AUTO_CONTACT";
    ConversationEventSubType["CandautoAutoReply"] = "CANDAUTO_AUTO_REPLY";
    /** @deprecated Do not use this subType. The function has been deprecated on Oct 16th, 2024 */
    ConversationEventSubType["CandautoD2M"] = "CANDAUTO_D2M";
    ConversationEventSubType["CandautoMaybeAutomation"] = "CANDAUTO_MAYBE_AUTOMATION";
    ConversationEventSubType["CandautoNexusInterviewInvitation"] = "CANDAUTO_NEXUS_INTERVIEW_INVITATION";
    ConversationEventSubType["CandautoNexusPartialScoreOutreach"] = "CANDAUTO_NEXUS_PARTIAL_SCORE_OUTREACH";
    ConversationEventSubType["CandautoNexusPostApplyCompletedOutreach"] = "CANDAUTO_NEXUS_POST_APPLY_COMPLETED_OUTREACH";
    ConversationEventSubType["CandautoNexusStrongScoreOutreach"] = "CANDAUTO_NEXUS_STRONG_SCORE_OUTREACH";
    ConversationEventSubType["ConfirmationEmail"] = "CONFIRMATION_EMAIL";
    ConversationEventSubType["D2IInterviewInvite"] = "D2I_INTERVIEW_INVITE";
    ConversationEventSubType["D2IInterviewReminder"] = "D2I_INTERVIEW_REMINDER";
    ConversationEventSubType["InboundEmail"] = "INBOUND_EMAIL";
    ConversationEventSubType["InviteEmail"] = "INVITE_EMAIL";
    ConversationEventSubType["InviteEmailMultitime"] = "INVITE_EMAIL_MULTITIME";
    ConversationEventSubType["Normal"] = "NORMAL";
    ConversationEventSubType["NotificationEmail"] = "NOTIFICATION_EMAIL";
    ConversationEventSubType["OneToManyEmpCancel"] = "ONE_TO_MANY_EMP_CANCEL";
    ConversationEventSubType["OneToManyEmpInvite"] = "ONE_TO_MANY_EMP_INVITE";
    ConversationEventSubType["ResumeContactAccepted"] = "RESUME_CONTACT_ACCEPTED";
    ConversationEventSubType["ResumeContactDeclined"] = "RESUME_CONTACT_DECLINED";
    ConversationEventSubType["ResumeContactInitiated"] = "RESUME_CONTACT_INITIATED";
    ConversationEventSubType["System"] = "SYSTEM";
})(ConversationEventSubType || (ConversationEventSubType = {}));
/**
 * Enumeration of possible conversation event types.
 *
 * These types determine behaviors, i.e.
 * - some map to tel modules to determine how messages are rendered
 * - some are used to control notification behavior
 */
export var ConversationEventType;
(function (ConversationEventType) {
    ConversationEventType["C2ICallHistory"] = "C2I_CALL_HISTORY";
    ConversationEventType["Callback"] = "CALLBACK";
    ConversationEventType["CandidateDispositionNotification"] = "CANDIDATE_DISPOSITION_NOTIFICATION";
    ConversationEventType["DradisCallbackRequest"] = "DRADIS_CALLBACK_REQUEST";
    ConversationEventType["I2AInvite"] = "I2A_INVITE";
    ConversationEventType["InterviewConfirmationEmail"] = "INTERVIEW_CONFIRMATION_EMAIL";
    ConversationEventType["InterviewEmployerCancel"] = "INTERVIEW_EMPLOYER_CANCEL";
    ConversationEventType["InterviewEmployerRequest"] = "INTERVIEW_EMPLOYER_REQUEST";
    ConversationEventType["InterviewEmployerUpdateMaintain"] = "INTERVIEW_EMPLOYER_UPDATE_MAINTAIN";
    ConversationEventType["InterviewEmployerUpdateReset"] = "INTERVIEW_EMPLOYER_UPDATE_RESET";
    ConversationEventType["InterviewJobseekerCancel"] = "INTERVIEW_JOBSEEKER_CANCEL";
    ConversationEventType["InterviewJobseekerDecline"] = "INTERVIEW_JOBSEEKER_DECLINE";
    ConversationEventType["InterviewJobseekerRequestNewTimes"] = "INTERVIEW_JOBSEEKER_REQUEST_NEW_TIMES";
    ConversationEventType["InterviewJobseekerRequestNewTimesScheduled"] = "INTERVIEW_JOBSEEKER_REQUEST_NEW_TIMES_SCHEDULED";
    ConversationEventType["InterviewJobseekerSchedule"] = "INTERVIEW_JOBSEEKER_SCHEDULE";
    ConversationEventType["Message"] = "MESSAGE";
    ConversationEventType["Phone"] = "PHONE";
    ConversationEventType["ResumeContactAccepted"] = "RESUME_CONTACT_ACCEPTED";
    ConversationEventType["ResumeContactDeclined"] = "RESUME_CONTACT_DECLINED";
    ConversationEventType["ResumeContactInitiated"] = "RESUME_CONTACT_INITIATED";
    ConversationEventType["Unknown"] = "UNKNOWN";
})(ConversationEventType || (ConversationEventType = {}));
/** Enumeration of possible conversation metadata keys. */
export var ConversationMetadataKey;
(function (ConversationMetadataKey) {
    ConversationMetadataKey["AdvertiserKey"] = "ADVERTISER_KEY";
    ConversationMetadataKey["AtsIsIndeedPlus"] = "ATS_IS_INDEED_PLUS";
    ConversationMetadataKey["AtsPartnerAppId"] = "ATS_PARTNER_APP_ID";
    ConversationMetadataKey["CandidateKey"] = "CANDIDATE_KEY";
    ConversationMetadataKey["Client"] = "CLIENT";
    ConversationMetadataKey["DradisJobKey"] = "DRADIS_JOB_KEY";
    ConversationMetadataKey["EmployerAccountKey"] = "EMPLOYER_ACCOUNT_KEY";
    ConversationMetadataKey["IsAiInitiated"] = "IS_AI_INITIATED";
    ConversationMetadataKey["JbIsIndeedPlus"] = "JB_IS_INDEED_PLUS";
    ConversationMetadataKey["JobseekerKey"] = "JOBSEEKER_KEY";
    ConversationMetadataKey["JobBoardPartnerAppId"] = "JOB_BOARD_PARTNER_APP_ID";
    ConversationMetadataKey["JobBoardPartnerId"] = "JOB_BOARD_PARTNER_ID";
    ConversationMetadataKey["JobKey"] = "JOB_KEY";
    ConversationMetadataKey["ScopeKey"] = "SCOPE_KEY";
    ConversationMetadataKey["Unknown"] = "UNKNOWN";
})(ConversationMetadataKey || (ConversationMetadataKey = {}));
/** Enumeration of possible participant roles. */
export var ConversationParticipantRole;
(function (ConversationParticipantRole) {
    ConversationParticipantRole["Employer"] = "EMPLOYER";
    ConversationParticipantRole["JobSeeker"] = "JOB_SEEKER";
    ConversationParticipantRole["System"] = "SYSTEM";
    ConversationParticipantRole["Unknown"] = "UNKNOWN";
})(ConversationParticipantRole || (ConversationParticipantRole = {}));
/** Enumeration of possible conversation contexts for conversation relay. */
export var ConversationRelayContext;
(function (ConversationRelayContext) {
    ConversationRelayContext["Conversation"] = "CONVERSATION";
    ConversationRelayContext["HqmDradis"] = "HQM_DRADIS";
    ConversationRelayContext["ResumeContact"] = "RESUME_CONTACT";
})(ConversationRelayContext || (ConversationRelayContext = {}));
/** Enumeration of valid conversation scope keys. */
export var ConversationScopeKey;
(function (ConversationScopeKey) {
    ConversationScopeKey["AdvertiserKey"] = "ADVERTISER_KEY";
    ConversationScopeKey["AdvertiserUserKey"] = "ADVERTISER_USER_KEY";
    ConversationScopeKey["ApplicationKey"] = "APPLICATION_KEY";
    ConversationScopeKey["CandidateKey"] = "CANDIDATE_KEY";
    ConversationScopeKey["EmployerEmail"] = "EMPLOYER_EMAIL";
    ConversationScopeKey["JobKey"] = "JOB_KEY";
    ConversationScopeKey["JobSeekerEmail"] = "JOB_SEEKER_EMAIL";
    ConversationScopeKey["JobSeekerKey"] = "JOB_SEEKER_KEY";
})(ConversationScopeKey || (ConversationScopeKey = {}));
/** Enumeration of possible conversation scope types. */
export var ConversationScopeType;
(function (ConversationScopeType) {
    ConversationScopeType["AdvertiserIdCandidateId"] = "ADVERTISER_ID_CANDIDATE_ID";
    ConversationScopeType["AdvertiserIdJsId"] = "ADVERTISER_ID_JS_ID";
    ConversationScopeType["AggJobIdJsId"] = "AGG_JOB_ID_JS_ID";
    ConversationScopeType["ConversationScopeTypeUnknown"] = "CONVERSATION_SCOPE_TYPE_UNKNOWN";
    ConversationScopeType["EmpIdJsId"] = "EMP_ID_JS_ID";
    ConversationScopeType["IhpRsvpId"] = "IHP_RSVP_ID";
    ConversationScopeType["InvitationId"] = "INVITATION_ID";
    ConversationScopeType["LogentryId"] = "LOGENTRY_ID";
})(ConversationScopeType || (ConversationScopeType = {}));
/** Enumeration of possible conversation contexts input for creating ConversationEvent. */
export var ConversationSelectionContext;
(function (ConversationSelectionContext) {
    ConversationSelectionContext["Dradis"] = "DRADIS";
    /** @deprecated Use DRADIS instead */
    ConversationSelectionContext["HqmDradis"] = "HQM_DRADIS";
    ConversationSelectionContext["Inquiry"] = "INQUIRY";
    ConversationSelectionContext["Resume"] = "RESUME";
})(ConversationSelectionContext || (ConversationSelectionContext = {}));
export var ConversationTagFilterType;
(function (ConversationTagFilterType) {
    ConversationTagFilterType["MustHave"] = "MUST_HAVE";
    ConversationTagFilterType["MustNotHave"] = "MUST_NOT_HAVE";
})(ConversationTagFilterType || (ConversationTagFilterType = {}));
/**
 * Client surface consuming Action Center recommendations. Passed through to
 * evo-conversions as a filter on each opportunity's eligibleClients set.
 */
export var ConversionsClientType;
(function (ConversionsClientType) {
    /** Internal customer-success surface */
    ConversionsClientType["Cs"] = "CS";
    /** Advertiser-facing Action Center UI (default) */
    ConversionsClientType["Gtm"] = "GTM";
    /** Internal sales rep surface */
    ConversionsClientType["Sbs"] = "SBS";
})(ConversionsClientType || (ConversionsClientType = {}));
/** Determines which coordination types of interviews are returned. */
export var CoordinationTypeInput;
(function (CoordinationTypeInput) {
    CoordinationTypeInput["AdHocOnly"] = "AD_HOC_ONLY";
    CoordinationTypeInput["All"] = "ALL";
    CoordinationTypeInput["ManagedOnly"] = "MANAGED_ONLY";
})(CoordinationTypeInput || (CoordinationTypeInput = {}));
/** Types of applications supported */
export var CraveApplicationType;
(function (CraveApplicationType) {
    /** Application submitted through Indeed Apply, where externalId is the encrypted apply id. */
    CraveApplicationType["EncryptedIndeedApply"] = "ENCRYPTED_INDEED_APPLY";
    /** Draft application from Indeed Apply (pre-submission) */
    CraveApplicationType["IndeedApplyDraft"] = "INDEED_APPLY_DRAFT";
})(CraveApplicationType || (CraveApplicationType = {}));
/** Types of Checkr webhook result events */
export var CraveCheckrResultType;
(function (CraveCheckrResultType) {
    /** A Checkr report has completed processing */
    CraveCheckrResultType["ReportCompleted"] = "REPORT_COMPLETED";
    /** An unknown result type, pending any potential future expansion */
    CraveCheckrResultType["Unknown"] = "UNKNOWN";
})(CraveCheckrResultType || (CraveCheckrResultType = {}));
/** Types of crave compliance documents */
export var CraveComplianceDocumentType;
(function (CraveComplianceDocumentType) {
    CraveComplianceDocumentType["EmployerArbitration"] = "EMPLOYER_ARBITRATION";
    /** @deprecated This document type is no longer supported */
    CraveComplianceDocumentType["EmployerEeoCertification"] = "EMPLOYER_EEO_CERTIFICATION";
    /** @deprecated This document type is no longer supported */
    CraveComplianceDocumentType["EmployerFcraCertification"] = "EMPLOYER_FCRA_CERTIFICATION";
    CraveComplianceDocumentType["EmployerJobAttestation"] = "EMPLOYER_JOB_ATTESTATION";
    /** @deprecated This document type is no longer supported */
    CraveComplianceDocumentType["EmployerLicenseRequirementCertification"] = "EMPLOYER_LICENSE_REQUIREMENT_CERTIFICATION";
    /** @deprecated This document type is no longer supported */
    CraveComplianceDocumentType["EmployerOnboardingDisclosure"] = "EMPLOYER_ONBOARDING_DISCLOSURE";
    /** @deprecated This document type is no longer supported */
    CraveComplianceDocumentType["EmployerPermissiblePurpose"] = "EMPLOYER_PERMISSIBLE_PURPOSE";
    CraveComplianceDocumentType["EmployerTerms"] = "EMPLOYER_TERMS";
    CraveComplianceDocumentType["JobseekerDisclosure"] = "JOBSEEKER_DISCLOSURE";
})(CraveComplianceDocumentType || (CraveComplianceDocumentType = {}));
/** Verification partner / document owner. */
export var CraveDocumentVendor;
(function (CraveDocumentVendor) {
    CraveDocumentVendor["Checkr"] = "CHECKR";
    CraveDocumentVendor["Indeed"] = "INDEED";
})(CraveDocumentVendor || (CraveDocumentVendor = {}));
/** The surface from which the verification request is being initiated */
export var CraveInitiateLicenseVerificationSurface;
(function (CraveInitiateLicenseVerificationSurface) {
    /** Indeed Apply */
    CraveInitiateLicenseVerificationSurface["IndeedApply"] = "INDEED_APPLY";
    /** My Jobs page */
    CraveInitiateLicenseVerificationSurface["MyJobs"] = "MY_JOBS";
})(CraveInitiateLicenseVerificationSurface || (CraveInitiateLicenseVerificationSurface = {}));
export var CraveJobScreeningConfigEventType;
(function (CraveJobScreeningConfigEventType) {
    /** Job screening configuration added */
    CraveJobScreeningConfigEventType["JobScreeningConfigAdded"] = "JOB_SCREENING_CONFIG_ADDED";
    /** Job screening configuration edited */
    CraveJobScreeningConfigEventType["JobScreeningConfigEdited"] = "JOB_SCREENING_CONFIG_EDITED";
    /** Job screening configuration removed */
    CraveJobScreeningConfigEventType["JobScreeningConfigRemoved"] = "JOB_SCREENING_CONFIG_REMOVED";
})(CraveJobScreeningConfigEventType || (CraveJobScreeningConfigEventType = {}));
export var CraveJsRejectedReason;
(function (CraveJsRejectedReason) {
    /** Rejected because of the answer to the license screener question. */
    CraveJsRejectedReason["License"] = "LICENSE";
    /** Rejected because of the answer to a non-license screener question. */
    CraveJsRejectedReason["ScreenerQuestion"] = "SCREENER_QUESTION";
})(CraveJsRejectedReason || (CraveJsRejectedReason = {}));
export var CraveLicenseConfigEventType;
(function (CraveLicenseConfigEventType) {
    /** License added. */
    CraveLicenseConfigEventType["LicenseAdded"] = "LICENSE_ADDED";
    /** License edited. */
    CraveLicenseConfigEventType["LicenseEdited"] = "LICENSE_EDITED";
    /** License removed. */
    CraveLicenseConfigEventType["LicenseRemoved"] = "LICENSE_REMOVED";
})(CraveLicenseConfigEventType || (CraveLicenseConfigEventType = {}));
/** The surface from which the verification request is being initiated */
export var CraveLicenseVerificationSurface;
(function (CraveLicenseVerificationSurface) {
    /** Indeed Apply */
    CraveLicenseVerificationSurface["IndeedApply"] = "INDEED_APPLY";
    /** My Jobs page */
    CraveLicenseVerificationSurface["MyJobs"] = "MY_JOBS";
})(CraveLicenseVerificationSurface || (CraveLicenseVerificationSurface = {}));
/** The surface from which the verification report is being accessed */
export var CraveReportSurface;
(function (CraveReportSurface) {
    /** Customer Success Portal */
    CraveReportSurface["Csp"] = "CSP";
    /** My Jobs page */
    CraveReportSurface["Myjobs"] = "MYJOBS";
    /** Nexus */
    CraveReportSurface["Nexus"] = "NEXUS";
})(CraveReportSurface || (CraveReportSurface = {}));
export var CraveVerificationEventType;
(function (CraveVerificationEventType) {
    /** T&S moderation check initiated for a JS file upload. */
    CraveVerificationEventType["TsModerationCheckJsFile"] = "TS_MODERATION_CHECK_JS_FILE";
    /** T&S moderation returned FAIL for a JS file upload. */
    CraveVerificationEventType["TsModerationFailJsFile"] = "TS_MODERATION_FAIL_JS_FILE";
    /** T&S moderation returned PASS for a JS file upload. */
    CraveVerificationEventType["TsModerationPassJsFile"] = "TS_MODERATION_PASS_JS_FILE";
})(CraveVerificationEventType || (CraveVerificationEventType = {}));
/** Method used to verify a license credential */
export var CraveVerificationMethod;
(function (CraveVerificationMethod) {
    /** Verification performed via direct file upload by the jobseeker */
    CraveVerificationMethod["FileUpload"] = "FILE_UPLOAD";
    /** Verification performed by a third-party vendor (e.g., Checkr) */
    CraveVerificationMethod["ThirdParty"] = "THIRD_PARTY";
})(CraveVerificationMethod || (CraveVerificationMethod = {}));
/** User type for verification report lookup */
export var CraveVerificationReportUserType;
(function (CraveVerificationReportUserType) {
    /** Employer requesting a candidate's verification report */
    CraveVerificationReportUserType["Employer"] = "EMPLOYER";
    /** Jobseeker requesting their own verification report */
    CraveVerificationReportUserType["Jobseeker"] = "JOBSEEKER";
})(CraveVerificationReportUserType || (CraveVerificationReportUserType = {}));
export var CraveWorkflowEventType;
(function (CraveWorkflowEventType) {
    /** Workflow state transition. → WORKFLOW_STATE */
    CraveWorkflowEventType["WorkflowState"] = "WORKFLOW_STATE";
})(CraveWorkflowEventType || (CraveWorkflowEventType = {}));
export var CraveWorkflowState;
(function (CraveWorkflowState) {
    /** Jobseeker submitted alternate evidence completed. */
    CraveWorkflowState["CorrectionCompleted"] = "CORRECTION_COMPLETED";
    /** Jobseeker is required to submit alternate evidence. */
    CraveWorkflowState["CorrectionRequired"] = "CORRECTION_REQUIRED";
    /** Indeed Apply application available. */
    CraveWorkflowState["IaApplicationAvailable"] = "IA_APPLICATION_AVAILABLE";
    /** Indeed Apply application not available. */
    CraveWorkflowState["IaApplicationNotAvailable"] = "IA_APPLICATION_NOT_AVAILABLE";
    /** Jobseeker submitted the application. */
    CraveWorkflowState["Submitted"] = "SUBMITTED";
})(CraveWorkflowState || (CraveWorkflowState = {}));
/**
 * The status of the campaign when it initially created.
 *
 * This enum is non-exhaustive and new values will be added from time to time.
 */
export var CreateCampaignStatusInput;
(function (CreateCampaignStatusInput) {
    CreateCampaignStatusInput["Active"] = "ACTIVE";
    CreateCampaignStatusInput["Paused"] = "PAUSED";
})(CreateCampaignStatusInput || (CreateCampaignStatusInput = {}));
/** Create from template flows */
export var CreateFromTemplateFlow;
(function (CreateFromTemplateFlow) {
    CreateFromTemplateFlow["EditIndexedJob"] = "EDIT_INDEXED_JOB";
    CreateFromTemplateFlow["EditPublishedJob"] = "EDIT_PUBLISHED_JOB";
    CreateFromTemplateFlow["JobpostingReusepriorjob"] = "JOBPOSTING_REUSEPRIORJOB";
})(CreateFromTemplateFlow || (CreateFromTemplateFlow = {}));
/** Represents the enumeration for sorting invoices export */
export var CreateInvoicesExportDownloadTempUrlSort;
(function (CreateInvoicesExportDownloadTempUrlSort) {
    CreateInvoicesExportDownloadTempUrlSort["AdjustmentAmountAsc"] = "ADJUSTMENT_AMOUNT_ASC";
    CreateInvoicesExportDownloadTempUrlSort["AdjustmentAmountDesc"] = "ADJUSTMENT_AMOUNT_DESC";
    CreateInvoicesExportDownloadTempUrlSort["AmountAsc"] = "AMOUNT_ASC";
    CreateInvoicesExportDownloadTempUrlSort["AmountDesc"] = "AMOUNT_DESC";
    CreateInvoicesExportDownloadTempUrlSort["CompanyNameAsc"] = "COMPANY_NAME_ASC";
    CreateInvoicesExportDownloadTempUrlSort["CompanyNameDesc"] = "COMPANY_NAME_DESC";
    CreateInvoicesExportDownloadTempUrlSort["CurrencyAsc"] = "CURRENCY_ASC";
    CreateInvoicesExportDownloadTempUrlSort["CurrencyDesc"] = "CURRENCY_DESC";
    CreateInvoicesExportDownloadTempUrlSort["DiscountAmountAsc"] = "DISCOUNT_AMOUNT_ASC";
    CreateInvoicesExportDownloadTempUrlSort["DiscountAmountDesc"] = "DISCOUNT_AMOUNT_DESC";
    CreateInvoicesExportDownloadTempUrlSort["DiscountRateAsc"] = "DISCOUNT_RATE_ASC";
    CreateInvoicesExportDownloadTempUrlSort["DiscountRateDesc"] = "DISCOUNT_RATE_DESC";
    CreateInvoicesExportDownloadTempUrlSort["DueDateAsc"] = "DUE_DATE_ASC";
    CreateInvoicesExportDownloadTempUrlSort["DueDateDesc"] = "DUE_DATE_DESC";
    CreateInvoicesExportDownloadTempUrlSort["EmployerIdAsc"] = "EMPLOYER_ID_ASC";
    CreateInvoicesExportDownloadTempUrlSort["EmployerIdDesc"] = "EMPLOYER_ID_DESC";
    CreateInvoicesExportDownloadTempUrlSort["InvoiceDateAsc"] = "INVOICE_DATE_ASC";
    CreateInvoicesExportDownloadTempUrlSort["InvoiceDateDesc"] = "INVOICE_DATE_DESC";
    CreateInvoicesExportDownloadTempUrlSort["InvoiceNumberAsc"] = "INVOICE_NUMBER_ASC";
    CreateInvoicesExportDownloadTempUrlSort["InvoiceNumberDesc"] = "INVOICE_NUMBER_DESC";
    CreateInvoicesExportDownloadTempUrlSort["IoNumberAsc"] = "IO_NUMBER_ASC";
    CreateInvoicesExportDownloadTempUrlSort["IoNumberDesc"] = "IO_NUMBER_DESC";
    CreateInvoicesExportDownloadTempUrlSort["OwnerEmailAsc"] = "OWNER_EMAIL_ASC";
    CreateInvoicesExportDownloadTempUrlSort["OwnerEmailDesc"] = "OWNER_EMAIL_DESC";
    CreateInvoicesExportDownloadTempUrlSort["PaymentStatusAsc"] = "PAYMENT_STATUS_ASC";
    CreateInvoicesExportDownloadTempUrlSort["PaymentStatusDesc"] = "PAYMENT_STATUS_DESC";
    CreateInvoicesExportDownloadTempUrlSort["PoNumberAsc"] = "PO_NUMBER_ASC";
    CreateInvoicesExportDownloadTempUrlSort["PoNumberDesc"] = "PO_NUMBER_DESC";
    CreateInvoicesExportDownloadTempUrlSort["ProductNameAsc"] = "PRODUCT_NAME_ASC";
    CreateInvoicesExportDownloadTempUrlSort["ProductNameDesc"] = "PRODUCT_NAME_DESC";
    CreateInvoicesExportDownloadTempUrlSort["PromotionAmountAsc"] = "PROMOTION_AMOUNT_ASC";
    CreateInvoicesExportDownloadTempUrlSort["PromotionAmountDesc"] = "PROMOTION_AMOUNT_DESC";
    CreateInvoicesExportDownloadTempUrlSort["ServiceAmountAsc"] = "SERVICE_AMOUNT_ASC";
    CreateInvoicesExportDownloadTempUrlSort["ServiceAmountDesc"] = "SERVICE_AMOUNT_DESC";
    CreateInvoicesExportDownloadTempUrlSort["TaxAmountAsc"] = "TAX_AMOUNT_ASC";
    CreateInvoicesExportDownloadTempUrlSort["TaxAmountDesc"] = "TAX_AMOUNT_DESC";
})(CreateInvoicesExportDownloadTempUrlSort || (CreateInvoicesExportDownloadTempUrlSort = {}));
/** Source that created an EmployerOrganization */
export var CreationSourceType;
(function (CreationSourceType) {
    /**  Created during EHS backfill process  */
    CreationSourceType["EhsBackfill"] = "EHS_BACKFILL";
    /**  Created during moderation backfill process  */
    CreationSourceType["ModerationBackfill"] = "MODERATION_BACKFILL";
    /**  Created via the employer organization onboarding UI  */
    CreationSourceType["Onboarding"] = "ONBOARDING";
    /**  Created during standalone advertiser backfill process  */
    CreationSourceType["StandaloneAdvertiserBackfill"] = "STANDALONE_ADVERTISER_BACKFILL";
    /**  Created by a user through the UI or API  */
    CreationSourceType["User"] = "USER";
})(CreationSourceType || (CreationSourceType = {}));
/** Error codes for creative set operations */
export var CreativeSetErrorCode;
(function (CreativeSetErrorCode) {
    CreativeSetErrorCode["CreativeSetAlreadyExists"] = "CREATIVE_SET_ALREADY_EXISTS";
    CreativeSetErrorCode["CreativeSetFetchFailed"] = "CREATIVE_SET_FETCH_FAILED";
    CreativeSetErrorCode["CreativeSetInvalidRequest"] = "CREATIVE_SET_INVALID_REQUEST";
    CreativeSetErrorCode["CreativeSetNotFound"] = "CREATIVE_SET_NOT_FOUND";
    CreativeSetErrorCode["CreativeSetUnrecognized"] = "CREATIVE_SET_UNRECOGNIZED";
})(CreativeSetErrorCode || (CreativeSetErrorCode = {}));
/** Answer to whether the jobseeker has the credential */
export var CredentialAnswer;
(function (CredentialAnswer) {
    /** The jobseeker's credential is in progress */
    CredentialAnswer["InProgress"] = "IN_PROGRESS";
    /** The jobseeker has answered NO to not having the credential */
    CredentialAnswer["No"] = "NO";
    /** The jobseeker has answered YES to having the credential */
    CredentialAnswer["Yes"] = "YES";
})(CredentialAnswer || (CredentialAnswer = {}));
/** The jobseeker's answer to whether they hold the required credential for the job. */
export var CredentialAnswerType;
(function (CredentialAnswerType) {
    /** The jobseeker is in the process of obtaining the required credential. */
    CredentialAnswerType["InProgress"] = "IN_PROGRESS";
    /** The jobseeker does not hold the required credential. */
    CredentialAnswerType["No"] = "NO";
    /** The jobseeker holds the required credential. */
    CredentialAnswerType["Yes"] = "YES";
})(CredentialAnswerType || (CredentialAnswerType = {}));
export var CredentialType;
(function (CredentialType) {
    CredentialType["Apns"] = "APNS";
    CredentialType["Firebase"] = "FIREBASE";
    CredentialType["Gcm"] = "GCM";
    CredentialType["UnknownCredentialType"] = "UNKNOWN_CREDENTIAL_TYPE";
})(CredentialType || (CredentialType = {}));
export var CriteriaChangeType;
(function (CriteriaChangeType) {
    CriteriaChangeType["Added"] = "ADDED";
    CriteriaChangeType["Changed"] = "CHANGED";
    CriteriaChangeType["Removed"] = "REMOVED";
})(CriteriaChangeType || (CriteriaChangeType = {}));
export var CriterionMatchStatus;
(function (CriterionMatchStatus) {
    CriterionMatchStatus["Met"] = "MET";
    CriterionMatchStatus["Unknown"] = "UNKNOWN";
})(CriterionMatchStatus || (CriterionMatchStatus = {}));
/** Lifecycle of an async CSV export job. */
export var CsvExportStatus;
(function (CsvExportStatus) {
    /** The file is ready; `adminCsvExportJob(jobId:).payload` carries the download URL. */
    CsvExportStatus["Complete"] = "COMPLETE";
    /** The export failed; `adminCsvExportJob(jobId:).error` carries the reason. */
    CsvExportStatus["Failed"] = "FAILED";
    /** Accepted and queued; the file is not built yet. */
    CsvExportStatus["Pending"] = "PENDING";
    /** The file is being built (row assembly + upload). */
    CsvExportStatus["Processing"] = "PROCESSING";
})(CsvExportStatus || (CsvExportStatus = {}));
/** Operator for custom class filtering with [`CustomClassFilterInput`](/api/occupational_metadata/objects/CustomClassFilterInput). */
export var CustomClassFilterOperation;
(function (CustomClassFilterOperation) {
    /** Includes concepts that belong to all specified custom classes in [`CustomClassFilterInput.customClasses`](/api/occupational_metadata/objects/CustomClassFilterInput). */
    CustomClassFilterOperation["And"] = "AND";
    /** Includes concepts that belong to any specified custom class in [`CustomClassesFilterInput.customClasses`](/api/occupational_metadata/objects/CustomClassFilterInput). */
    CustomClassFilterOperation["Or"] = "OR";
})(CustomClassFilterOperation || (CustomClassFilterOperation = {}));
/**  Enum for CustomReportViewBreakdownType  */
export var CustomReportViewBreakdownType;
(function (CustomReportViewBreakdownType) {
    CustomReportViewBreakdownType["Campaign"] = "CAMPAIGN";
    CustomReportViewBreakdownType["Job"] = "JOB";
})(CustomReportViewBreakdownType || (CustomReportViewBreakdownType = {}));
/**
 * Allow-listed sortable columns. New entries require a matching column in the
 * SQL builder's SORTABLE_COLUMNS — arbitrary identifiers cannot be passed.
 */
export var CustomerInteractionsSortField;
(function (CustomerInteractionsSortField) {
    CustomerInteractionsSortField["JobsWithPo_90D"] = "JOBS_WITH_PO_90D";
    CustomerInteractionsSortField["LiveJobs_90D"] = "LIVE_JOBS_90D";
    CustomerInteractionsSortField["PiSearchId"] = "PI_SEARCH_ID";
    CustomerInteractionsSortField["ResponseDate"] = "RESPONSE_DATE";
    CustomerInteractionsSortField["Revenue_90D"] = "REVENUE_90D";
    CustomerInteractionsSortField["SponsoredJobs_90D"] = "SPONSORED_JOBS_90D";
})(CustomerInteractionsSortField || (CustomerInteractionsSortField = {}));
export var CustomerRequestCategoryEnum;
(function (CustomerRequestCategoryEnum) {
    CustomerRequestCategoryEnum["BillingAndPayment"] = "BILLING_AND_PAYMENT";
    CustomerRequestCategoryEnum["DisputesAndRefunds"] = "DISPUTES_AND_REFUNDS";
    CustomerRequestCategoryEnum["JobPostingAndManagement"] = "JOB_POSTING_AND_MANAGEMENT";
    CustomerRequestCategoryEnum["Other"] = "OTHER";
    CustomerRequestCategoryEnum["PlatformSupport"] = "PLATFORM_SUPPORT";
})(CustomerRequestCategoryEnum || (CustomerRequestCategoryEnum = {}));
export var CustomerRequestStatusEnum;
(function (CustomerRequestStatusEnum) {
    CustomerRequestStatusEnum["Created"] = "CREATED";
    CustomerRequestStatusEnum["InProgress"] = "IN_PROGRESS";
    CustomerRequestStatusEnum["Resolved"] = "RESOLVED";
})(CustomerRequestStatusEnum || (CustomerRequestStatusEnum = {}));
/** Index builder type options for data assets */
export var DataAssetBuilderType;
(function (DataAssetBuilderType) {
    DataAssetBuilderType["Ibw"] = "IBW";
    DataAssetBuilderType["Iupload"] = "IUPLOAD";
    DataAssetBuilderType["Other"] = "OTHER";
    DataAssetBuilderType["Spark"] = "SPARK";
    DataAssetBuilderType["Swift"] = "SWIFT";
    DataAssetBuilderType["Trino"] = "TRINO";
})(DataAssetBuilderType || (DataAssetBuilderType = {}));
/** Supported query source engines for data reports */
export var DataReportQueryType;
(function (DataReportQueryType) {
    /** Duck DB engine */
    DataReportQueryType["DuckDb"] = "DUCK_DB";
    /** IQL query engine */
    DataReportQueryType["Iql"] = "IQL";
    /** Snowflake query engine */
    DataReportQueryType["Snowflake"] = "SNOWFLAKE";
    /** Trino query engine */
    DataReportQueryType["Trino"] = "TRINO";
})(DataReportQueryType || (DataReportQueryType = {}));
/** Supported data formats for report results */
export var DataReportResultFormat;
(function (DataReportResultFormat) {
    /** Apache Arrow IPC stream format */
    DataReportResultFormat["ArrowIpc"] = "ARROW_IPC";
    /** Standard JSON format */
    DataReportResultFormat["Json"] = "JSON";
    /** JSON format optimized for IDASH client */
    DataReportResultFormat["JsonIdash"] = "JSON_IDASH";
})(DataReportResultFormat || (DataReportResultFormat = {}));
/** Represents the current state of a data report execution */
export var DataReportStatus;
(function (DataReportStatus) {
    /** Report was manually cancelled */
    DataReportStatus["Cancelled"] = "CANCELLED";
    /** Report has successfully completed */
    DataReportStatus["Completed"] = "COMPLETED";
    /** Report processing failed */
    DataReportStatus["Failed"] = "FAILED";
    /** Report is currently being processed */
    DataReportStatus["InProgress"] = "IN_PROGRESS";
    /** Report has been defined but not yet submitted */
    DataReportStatus["New"] = "NEW";
    /** Report is waiting to be processed */
    DataReportStatus["Queued"] = "QUEUED";
})(DataReportStatus || (DataReportStatus = {}));
/** Validation rules that can be applied to report parameters */
export var DataReportValidationRule;
(function (DataReportValidationRule) {
    /** Parameter must be provided */
    DataReportValidationRule["Required"] = "REQUIRED";
    /** Parameter has restricted values */
    DataReportValidationRule["Restricted"] = "RESTRICTED";
})(DataReportValidationRule || (DataReportValidationRule = {}));
/** Deprecated. All clients should remove references to DataSource from hosted job queries and mutations */
export var DataSource;
(function (DataSource) {
    /** @deprecated No longer supported */
    DataSource["Current"] = "CURRENT";
    /** @deprecated No longer supported */
    DataSource["Modern"] = "MODERN";
})(DataSource || (DataSource = {}));
/**
 * Data store preference for writing Hosted Job Data.
 * CURRENT will use the default for the user, while MODERN will write to the new architecture.
 * All writes will eventually move to MODERN as we ramp the [Hosted Job Platform Rearchitecture Project](https://wiki.indeed.com/display/SMBPMO/Hosted+Job+Platform+Re-architecture+Project).
 */
export var DataStore;
(function (DataStore) {
    DataStore["Current"] = "CURRENT";
    DataStore["Modern"] = "MODERN";
})(DataStore || (DataStore = {}));
/** Supported data systems for Timberlake policies */
export var DataSystem;
(function (DataSystem) {
    /** MDP data system */
    DataSystem["Mdp"] = "MDP";
    /** Swift data system */
    DataSystem["Swift"] = "SWIFT";
})(DataSystem || (DataSystem = {}));
export var DatabaseEngine;
(function (DatabaseEngine) {
    DatabaseEngine["Mysql"] = "MYSQL";
    DatabaseEngine["Postgresql"] = "POSTGRESQL";
})(DatabaseEngine || (DatabaseEngine = {}));
/** Preset date ranges to filter the insights for. */
export var DateRangePreset;
(function (DateRangePreset) {
    /**
     * Last 6 Months: Rolling 6-month window ending on the base date.
     * Example: If base date is Feb 15 2026, current range is Aug 16 2025 - Feb 15 2026.
     */
    DateRangePreset["Last_6Months"] = "LAST_6_MONTHS";
    /**
     * Last 30 Days: Rolling 30-day window ending on the base date.
     * Example: If base date is Feb 15, current range is Jan 17 - Feb 15.
     */
    DateRangePreset["Last_30Days"] = "LAST_30_DAYS";
    /**
     * Last Month: The complete previous calendar month.
     * Example: If base date is Feb 15, current range is Jan 1 - Jan 31.
     */
    DateRangePreset["LastMonth"] = "LAST_MONTH";
    /**
     * Last Quarter: The complete previous calendar quarter.
     * Example: If base date is in Q2 2026, current range is Q1 2026 (Jan 1 - Mar 31).
     */
    DateRangePreset["LastQtr"] = "LAST_QTR";
    /**
     * Last Year: The complete previous calendar year.
     * Example: If base date is Feb 15 2026, current range is Jan 1 2025 - Dec 31 2025.
     */
    DateRangePreset["LastYear"] = "LAST_YEAR";
    /**
     * Month to Date: From the 1st of the current month to the base date.
     * Example: If base date is Feb 15, current range is Feb 1 - Feb 15.
     */
    DateRangePreset["Mtd"] = "MTD";
    /**
     * Year to Date: From January 1st of the current year to the base date.
     * Example: If base date is Feb 15 2026, current range is Jan 1 2026 - Feb 15 2026.
     */
    DateRangePreset["Ytd"] = "YTD";
})(DateRangePreset || (DateRangePreset = {}));
/** The days of the week! As an enum! */
export var DayOfWeek;
(function (DayOfWeek) {
    DayOfWeek["Friday"] = "FRIDAY";
    DayOfWeek["Monday"] = "MONDAY";
    DayOfWeek["Saturday"] = "SATURDAY";
    DayOfWeek["Sunday"] = "SUNDAY";
    DayOfWeek["Thursday"] = "THURSDAY";
    DayOfWeek["Tuesday"] = "TUESDAY";
    DayOfWeek["Wednesday"] = "WEDNESDAY";
})(DayOfWeek || (DayOfWeek = {}));
/** Current reason of the Subscription deactivation */
export var DeactivationReason;
(function (DeactivationReason) {
    DeactivationReason["ClientCancelled"] = "CLIENT_CANCELLED";
    DeactivationReason["ErrorInEntry"] = "ERROR_IN_ENTRY";
    DeactivationReason["ExpiredEod"] = "EXPIRED_EOD";
    DeactivationReason["FinanceRequest"] = "FINANCE_REQUEST";
    DeactivationReason["InvoiceFailed"] = "INVOICE_FAILED";
    DeactivationReason["ManualAnother"] = "MANUAL_ANOTHER";
})(DeactivationReason || (DeactivationReason = {}));
/** Reason codes for deal movement validation failures */
export var DealMovementValidationCode;
(function (DealMovementValidationCode) {
    /** Source and destination deal owners have incompatible billing currency or entity (BILLPLAT-5469) */
    DealMovementValidationCode["CurrencyOrEntityMismatch"] = "CURRENCY_OR_ENTITY_MISMATCH";
    /** Both source sub-tree and destination ancestors have overlapping active/pending deals */
    DealMovementValidationCode["DealUnderDealConflict"] = "DEAL_UNDER_DEAL_CONFLICT";
    /** Error fetching destination advertiser hierarchy from EHS */
    DealMovementValidationCode["DestinationHierarchyError"] = "DESTINATION_HIERARCHY_ERROR";
    /** Source and destination advertiser are the same */
    DealMovementValidationCode["SameSourceAndDestination"] = "SAME_SOURCE_AND_DESTINATION";
    /** Error fetching source advertiser hierarchy from EHS */
    DealMovementValidationCode["SourceHierarchyError"] = "SOURCE_HIERARCHY_ERROR";
})(DealMovementValidationCode || (DealMovementValidationCode = {}));
export var DealParticipationValidationCode;
(function (DealParticipationValidationCode) {
    DealParticipationValidationCode["NotInHierarchy"] = "NOT_IN_HIERARCHY";
    DealParticipationValidationCode["OverlappingDeal"] = "OVERLAPPING_DEAL";
    DealParticipationValidationCode["OverlappingLead"] = "OVERLAPPING_LEAD";
})(DealParticipationValidationCode || (DealParticipationValidationCode = {}));
export var DeallocateStrategy;
(function (DeallocateStrategy) {
    DeallocateStrategy["All"] = "ALL";
    DeallocateStrategy["None"] = "NONE";
})(DeallocateStrategy || (DeallocateStrategy = {}));
export var DeclineBidReasonEnum;
(function (DeclineBidReasonEnum) {
    DeclineBidReasonEnum["GeographyExperience"] = "GEOGRAPHY_EXPERIENCE";
    DeclineBidReasonEnum["IndustryExperience"] = "INDUSTRY_EXPERIENCE";
    DeclineBidReasonEnum["Other"] = "OTHER";
    DeclineBidReasonEnum["TakeRateTooHigh"] = "TAKE_RATE_TOO_HIGH";
})(DeclineBidReasonEnum || (DeclineBidReasonEnum = {}));
/**  Reasons a jobseeker declined a contact  */
export var DeclineReasonType;
(function (DeclineReasonType) {
    DeclineReasonType["Company"] = "COMPANY";
    DeclineReasonType["Industry"] = "INDUSTRY";
    DeclineReasonType["JobContent"] = "JOB_CONTENT";
    DeclineReasonType["Location"] = "LOCATION";
    DeclineReasonType["NotActivelyLooking"] = "NOT_ACTIVELY_LOOKING";
    DeclineReasonType["Other"] = "OTHER";
    DeclineReasonType["Salary"] = "SALARY";
    DeclineReasonType["Spam"] = "SPAM";
})(DeclineReasonType || (DeclineReasonType = {}));
/**
 * How well a single explanation reflects the match between the user's
 * job search direction and a specific job.
 */
export var DeepIntakeExplanationMatchLevel;
(function (DeepIntakeExplanationMatchLevel) {
    /** The explanation describes a gap between the job and the user's direction. */
    DeepIntakeExplanationMatchLevel["Gap"] = "GAP";
    /** The explanation describes a point where the job matches the user's direction. */
    DeepIntakeExplanationMatchLevel["Matched"] = "MATCHED";
})(DeepIntakeExplanationMatchLevel || (DeepIntakeExplanationMatchLevel = {}));
/** Job employment type supported by Deep Intake. */
export var DeepIntakeJobType;
(function (DeepIntakeJobType) {
    /** Contract (契約社員). */
    DeepIntakeJobType["Contract"] = "CONTRACT";
    /** Full-time (正社員). */
    DeepIntakeJobType["FullTime"] = "FULL_TIME";
    /** New graduate (新卒). */
    DeepIntakeJobType["NewGrad"] = "NEW_GRAD";
    /** Part-time (パート・アルバイト). */
    DeepIntakeJobType["PartTime"] = "PART_TIME";
    /** Sub-contract (業務委託). */
    DeepIntakeJobType["SubContract"] = "SUB_CONTRACT";
    /** Temporary (派遣). */
    DeepIntakeJobType["Temporary"] = "TEMPORARY";
})(DeepIntakeJobType || (DeepIntakeJobType = {}));
/** The unit in which a salary value is expressed. */
export var DeepIntakeSalaryType;
(function (DeepIntakeSalaryType) {
    /** Salary expressed per day (日給). */
    DeepIntakeSalaryType["Daily"] = "DAILY";
    /** Salary expressed per hour (時給). */
    DeepIntakeSalaryType["Hourly"] = "HOURLY";
    /** Salary expressed per month (月給). */
    DeepIntakeSalaryType["Monthly"] = "MONTHLY";
    /** Salary expressed per year (年俸). */
    DeepIntakeSalaryType["Yearly"] = "YEARLY";
})(DeepIntakeSalaryType || (DeepIntakeSalaryType = {}));
/** How well a single work style description matches the user's stated preferences. */
export var DeepIntakeWorkStyleMatchLevel;
(function (DeepIntakeWorkStyleMatchLevel) {
    /** The description aligns with the user's preferences. */
    DeepIntakeWorkStyleMatchLevel["Matched"] = "MATCHED";
    /** The description does not align with the user's preferences. */
    DeepIntakeWorkStyleMatchLevel["Mismatched"] = "MISMATCHED";
    /** The description partially aligns with the user's preferences. */
    DeepIntakeWorkStyleMatchLevel["PartiallyMatched"] = "PARTIALLY_MATCHED";
})(DeepIntakeWorkStyleMatchLevel || (DeepIntakeWorkStyleMatchLevel = {}));
/** User's reaction to a generated work style. */
export var DeepIntakeWorkStyleReaction;
(function (DeepIntakeWorkStyleReaction) {
    /** User dislikes this work style. */
    DeepIntakeWorkStyleReaction["Dislike"] = "DISLIKE";
    /** User likes this work style. */
    DeepIntakeWorkStyleReaction["Like"] = "LIKE";
    /** User is neutral / undecided about this work style. */
    DeepIntakeWorkStyleReaction["Maybe"] = "MAYBE";
})(DeepIntakeWorkStyleReaction || (DeepIntakeWorkStyleReaction = {}));
export var DeepSourcingApproachStatus;
(function (DeepSourcingApproachStatus) {
    DeepSourcingApproachStatus["Canceled"] = "CANCELED";
    DeepSourcingApproachStatus["Done"] = "DONE";
    DeepSourcingApproachStatus["Failed"] = "FAILED";
    DeepSourcingApproachStatus["Pending"] = "PENDING";
    DeepSourcingApproachStatus["Working"] = "WORKING";
})(DeepSourcingApproachStatus || (DeepSourcingApproachStatus = {}));
export var DeepSourcingApproachStrategyEnum;
(function (DeepSourcingApproachStrategyEnum) {
    DeepSourcingApproachStrategyEnum["NlSearchProspects"] = "NL_SEARCH_PROSPECTS";
    DeepSourcingApproachStrategyEnum["RecommendProspects"] = "RECOMMEND_PROSPECTS";
    DeepSourcingApproachStrategyEnum["SearchApplicants"] = "SEARCH_APPLICANTS";
    DeepSourcingApproachStrategyEnum["SearchOtherJobAppliedApplicants"] = "SEARCH_OTHER_JOB_APPLIED_APPLICANTS";
    DeepSourcingApproachStrategyEnum["SearchProspects"] = "SEARCH_PROSPECTS";
    DeepSourcingApproachStrategyEnum["SearchProspectsSpear"] = "SEARCH_PROSPECTS_SPEAR";
})(DeepSourcingApproachStrategyEnum || (DeepSourcingApproachStrategyEnum = {}));
export var DeepSourcingCreditFailureReason;
(function (DeepSourcingCreditFailureReason) {
    DeepSourcingCreditFailureReason["AssignmentNotFound"] = "ASSIGNMENT_NOT_FOUND";
    DeepSourcingCreditFailureReason["ConcurrentModification"] = "CONCURRENT_MODIFICATION";
    DeepSourcingCreditFailureReason["DuplicateRequest"] = "DUPLICATE_REQUEST";
    DeepSourcingCreditFailureReason["EntitlementNotFound"] = "ENTITLEMENT_NOT_FOUND";
    DeepSourcingCreditFailureReason["Unknown"] = "UNKNOWN";
})(DeepSourcingCreditFailureReason || (DeepSourcingCreditFailureReason = {}));
export var DeepSourcingModeEnum;
(function (DeepSourcingModeEnum) {
    DeepSourcingModeEnum["DeepSourcing"] = "DEEP_SOURCING";
    DeepSourcingModeEnum["QuickSourcing"] = "QUICK_SOURCING";
})(DeepSourcingModeEnum || (DeepSourcingModeEnum = {}));
export var DeepSourcingSessionStatus;
(function (DeepSourcingSessionStatus) {
    DeepSourcingSessionStatus["Canceled"] = "CANCELED";
    DeepSourcingSessionStatus["Done"] = "DONE";
    DeepSourcingSessionStatus["Failed"] = "FAILED";
    DeepSourcingSessionStatus["Ineligible"] = "INELIGIBLE";
    DeepSourcingSessionStatus["NotStarted"] = "NOT_STARTED";
    DeepSourcingSessionStatus["Pending"] = "PENDING";
    DeepSourcingSessionStatus["TimedOut"] = "TIMED_OUT";
    DeepSourcingSessionStatus["Working"] = "WORKING";
})(DeepSourcingSessionStatus || (DeepSourcingSessionStatus = {}));
export var DeepSourcingSourceType;
(function (DeepSourcingSourceType) {
    DeepSourcingSourceType["AutoInvite"] = "AUTO_INVITE";
    DeepSourcingSourceType["RcpHelper"] = "RCP_HELPER";
    DeepSourcingSourceType["TalentScout"] = "TALENT_SCOUT";
})(DeepSourcingSourceType || (DeepSourcingSourceType = {}));
export var DeepSourcingSurface;
(function (DeepSourcingSurface) {
    DeepSourcingSurface["AutoInviteAsyncBatchPremiumPlus"] = "AUTO_INVITE_ASYNC_BATCH_PREMIUM_PLUS";
    DeepSourcingSurface["AutoInviteAsyncBatchSmartSourcing"] = "AUTO_INVITE_ASYNC_BATCH_SMART_SOURCING";
    DeepSourcingSurface["AutoInviteManualReviewPremiumPlus"] = "AUTO_INVITE_MANUAL_REVIEW_PREMIUM_PLUS";
    DeepSourcingSurface["AutoInviteManualReviewSmartSourcing"] = "AUTO_INVITE_MANUAL_REVIEW_SMART_SOURCING";
    DeepSourcingSurface["TalentScout"] = "TALENT_SCOUT";
})(DeepSourcingSurface || (DeepSourcingSurface = {}));
/** The variation of the default engagement template to use */
export var DefaultTalentEngagementTemplateVariant;
(function (DefaultTalentEngagementTemplateVariant) {
    DefaultTalentEngagementTemplateVariant["EmailStandard"] = "EMAIL_STANDARD";
})(DefaultTalentEngagementTemplateVariant || (DefaultTalentEngagementTemplateVariant = {}));
export var DemographicQuestionType;
(function (DemographicQuestionType) {
    DemographicQuestionType["Date"] = "date";
    DemographicQuestionType["Multiselect"] = "multiselect";
    DemographicQuestionType["Select"] = "select";
    DemographicQuestionType["Text"] = "text";
    DemographicQuestionType["Textarea"] = "textarea";
})(DemographicQuestionType || (DemographicQuestionType = {}));
/** Available fields for sorting deployments */
export var DeploymentSortField;
(function (DeploymentSortField) {
    /** Sort by deployment ID */
    DeploymentSortField["Id"] = "ID";
    /** Sort by deployment name */
    DeploymentSortField["Name"] = "NAME";
})(DeploymentSortField || (DeploymentSortField = {}));
/** Job description format. */
export var DescriptionFormatting;
(function (DescriptionFormatting) {
    /** HTML. */
    DescriptionFormatting["Html"] = "HTML";
    /** Plain text. This is the default. */
    DescriptionFormatting["Text"] = "TEXT";
})(DescriptionFormatting || (DescriptionFormatting = {}));
/** SRF DescriptionFormattingAlgorithm enum */
export var DescriptionFormattingAlgorithm;
(function (DescriptionFormattingAlgorithm) {
    DescriptionFormattingAlgorithm["SrfAggV1"] = "SRF_AGG_V1";
    DescriptionFormattingAlgorithm["SrfAggV2"] = "SRF_AGG_V2";
    DescriptionFormattingAlgorithm["SrfDradisV1"] = "SRF_DRADIS_V1";
    DescriptionFormattingAlgorithm["SrfDradisV2"] = "SRF_DRADIS_V2";
    DescriptionFormattingAlgorithm["Unknown"] = "UNKNOWN";
})(DescriptionFormattingAlgorithm || (DescriptionFormattingAlgorithm = {}));
/** Enum representing the result of the DetailedCompromisedAction query */
export var DetailedCompromisedActionResult;
(function (DetailedCompromisedActionResult) {
    DetailedCompromisedActionResult["Error"] = "ERROR";
    DetailedCompromisedActionResult["Success"] = "SUCCESS";
})(DetailedCompromisedActionResult || (DetailedCompromisedActionResult = {}));
/**  Possible device types in DeviceClicksPayload  */
export var DeviceType;
(function (DeviceType) {
    DeviceType["Desktop"] = "DESKTOP";
    DeviceType["Mobile"] = "MOBILE";
    DeviceType["Unknown"] = "UNKNOWN";
})(DeviceType || (DeviceType = {}));
/** Enum with the different environment options */
export var DiagnosticsOneGraphVariant;
(function (DiagnosticsOneGraphVariant) {
    DiagnosticsOneGraphVariant["Dev"] = "DEV";
    DiagnosticsOneGraphVariant["Prod"] = "PROD";
    DiagnosticsOneGraphVariant["Qa"] = "QA";
})(DiagnosticsOneGraphVariant || (DiagnosticsOneGraphVariant = {}));
/** Enum for dataset relationship direction. */
export var Direction;
(function (Direction) {
    /** Represents the 'source' direction. */
    Direction["Source"] = "SOURCE";
    /** Represents the 'target' direction. */
    Direction["Target"] = "TARGET";
})(Direction || (Direction = {}));
export var DisabledAppealStatusType;
(function (DisabledAppealStatusType) {
    DisabledAppealStatusType["DisabledAppealCompleted"] = "DISABLED_APPEAL_COMPLETED";
    DisabledAppealStatusType["DisabledAppealInProgress"] = "DISABLED_APPEAL_IN_PROGRESS";
    DisabledAppealStatusType["DisabledAppealRejected"] = "DISABLED_APPEAL_REJECTED";
    DisabledAppealStatusType["PendingInitiateDa"] = "PENDING_INITIATE_DA";
    DisabledAppealStatusType["Undetermined"] = "UNDETERMINED";
})(DisabledAppealStatusType || (DisabledAppealStatusType = {}));
/** Status of DispositionSync */
export var DispositionSyncStatus;
(function (DispositionSyncStatus) {
    /** The link is working properly and no additional disposition statues need to mapped */
    DispositionSyncStatus["Active"] = "ACTIVE";
    /** The link requires additional configuration in order to activate Disposition Sync */
    DispositionSyncStatus["ConfigurationRequired"] = "CONFIGURATION_REQUIRED";
})(DispositionSyncStatus || (DispositionSyncStatus = {}));
/** Distance unit enumeration */
export var DistanceUnit;
(function (DistanceUnit) {
    DistanceUnit["Kilometers"] = "KILOMETERS";
    DistanceUnit["Miles"] = "MILES";
})(DistanceUnit || (DistanceUnit = {}));
/** Types of email-domain-enforcement lists */
export var DomainEnforcementListType;
(function (DomainEnforcementListType) {
    /** Indicates that only domains in the given list are allowed */
    DomainEnforcementListType["Allowlist"] = "ALLOWLIST";
    /** Indicates that only domains not in the given list are allowed */
    DomainEnforcementListType["Denylist"] = "DENYLIST";
    /** Indicates that all domains are allowed */
    DomainEnforcementListType["None"] = "NONE";
})(DomainEnforcementListType || (DomainEnforcementListType = {}));
/** Lifecycle state of an employer organization's DNS domain verification (FIM-2504 / FIM-2354) */
export var DomainStatus;
(function (DomainStatus) {
    /** The verification challenge expired before successful verification */
    DomainStatus["Expired"] = "EXPIRED";
    /** Security Team spot the current employer organization is malicious and might claiming the domain illegally */
    DomainStatus["Invalid"] = "INVALID";
    /** A verification challenge has been issued and is awaiting DNS proof */
    DomainStatus["Pending"] = "PENDING";
    /** DNS proof succeeded for this organization and domain */
    DomainStatus["Verified"] = "VERIFIED";
})(DomainStatus || (DomainStatus = {}));
export var DomainType;
(function (DomainType) {
    DomainType["Allowlist"] = "ALLOWLIST";
    DomainType["Denylist"] = "DENYLIST";
    DomainType["Primary"] = "PRIMARY";
})(DomainType || (DomainType = {}));
/** DNS record type clients must publish for domain verification */
export var DomainVerificationDnsRecordType;
(function (DomainVerificationDnsRecordType) {
    DomainVerificationDnsRecordType["Txt"] = "TXT";
})(DomainVerificationDnsRecordType || (DomainVerificationDnsRecordType = {}));
/**
 * Verification states customer support is allowed to apply via `updateStatus`.
 *
 * Deliberately excludes `PENDING`: a request only enters `PENDING` through the organic
 * challenge/verify lifecycle, so support can resolve a request (VERIFIED / EXPIRED / INVALID) but
 * cannot move it back into a pending state.
 */
export var DomainVerificationOverrideStatus;
(function (DomainVerificationOverrideStatus) {
    /** The verification challenge is treated as expired */
    DomainVerificationOverrideStatus["Expired"] = "EXPIRED";
    /** The claim is rejected as malicious / illegitimate */
    DomainVerificationOverrideStatus["Invalid"] = "INVALID";
    /** DNS proof is accepted for this organization and domain */
    DomainVerificationOverrideStatus["Verified"] = "VERIFIED";
})(DomainVerificationOverrideStatus || (DomainVerificationOverrideStatus = {}));
/**
 * Input enum for setting the job seeker's demographic questions prefill consent.
 * Only client-settable values are included.
 */
export var DqPrefillConsentInput;
(function (DqPrefillConsentInput) {
    /** The job seeker has consented to prefilling demographic questions. */
    DqPrefillConsentInput["Consent"] = "CONSENT";
    /** The job seeker has explicitly declined to prefill demographic questions. */
    DqPrefillConsentInput["Declined"] = "DECLINED";
})(DqPrefillConsentInput || (DqPrefillConsentInput = {}));
/** Enum representing the job seeker's demographic questions prefill consent status. */
export var DqPrefillConsentStatus;
(function (DqPrefillConsentStatus) {
    /** The job seeker has consented to prefilling demographic questions. */
    DqPrefillConsentStatus["Consent"] = "CONSENT";
    /** The job seeker has explicitly declined to prefill demographic questions. */
    DqPrefillConsentStatus["Declined"] = "DECLINED";
    /** The consent status has not been initialized yet (draft just created or restarted). */
    DqPrefillConsentStatus["NotInitialized"] = "NOT_INITIALIZED";
    /** No consent record exists for this account. */
    DqPrefillConsentStatus["NoRecord"] = "NO_RECORD";
})(DqPrefillConsentStatus || (DqPrefillConsentStatus = {}));
/**
 * User preference for disqualifying question prefilling in AutoApply.
 * Using an enum allows for future states without breaking changes.
 */
export var DqPrefillPreference;
(function (DqPrefillPreference) {
    /** User has opted in to disqualifying question prefilling */
    DqPrefillPreference["OptIn"] = "OPT_IN";
    /** User has opted out of disqualifying question prefilling (default behavior due to legal requirement) */
    DqPrefillPreference["OptOut"] = "OPT_OUT";
})(DqPrefillPreference || (DqPrefillPreference = {}));
export var DraftCreationStatus;
(function (DraftCreationStatus) {
    DraftCreationStatus["ClientValidationFailed"] = "CLIENT_VALIDATION_FAILED";
    DraftCreationStatus["Created"] = "CREATED";
    DraftCreationStatus["Duplicate"] = "DUPLICATE";
    DraftCreationStatus["Failed"] = "FAILED";
    DraftCreationStatus["SkippedIneligible"] = "SKIPPED_INELIGIBLE";
})(DraftCreationStatus || (DraftCreationStatus = {}));
export var DraftHiringEventStatus;
(function (DraftHiringEventStatus) {
    DraftHiringEventStatus["InProgress"] = "IN_PROGRESS";
    DraftHiringEventStatus["PendingApproval"] = "PENDING_APPROVAL";
    DraftHiringEventStatus["Published"] = "PUBLISHED";
})(DraftHiringEventStatus || (DraftHiringEventStatus = {}));
export var DraftHiringEventStatusFilter;
(function (DraftHiringEventStatusFilter) {
    /** Set of Statuses of DraftHiringEvents */
    DraftHiringEventStatusFilter["InProgress"] = "IN_PROGRESS";
    /** To Support filtering by PENDING_APPROVAL */
    DraftHiringEventStatusFilter["PendingApproval"] = "PENDING_APPROVAL";
})(DraftHiringEventStatusFilter || (DraftHiringEventStatusFilter = {}));
/** The method type of the Interview Session */
export var DraftInterviewSessionMethodType;
(function (DraftInterviewSessionMethodType) {
    DraftInterviewSessionMethodType["ByPhone"] = "BY_PHONE";
    DraftInterviewSessionMethodType["ExternalVideo"] = "EXTERNAL_VIDEO";
    DraftInterviewSessionMethodType["IndeedVideo"] = "INDEED_VIDEO";
    DraftInterviewSessionMethodType["InPerson"] = "IN_PERSON";
})(DraftInterviewSessionMethodType || (DraftInterviewSessionMethodType = {}));
/** The draft job post's read strategy */
export var DraftJobPostReadStrategy;
(function (DraftJobPostReadStrategy) {
    DraftJobPostReadStrategy["Primary"] = "PRIMARY";
    DraftJobPostReadStrategy["Secondary"] = "SECONDARY";
})(DraftJobPostReadStrategy || (DraftJobPostReadStrategy = {}));
/** Ordering fields */
export var DraftJobPostsSortField;
(function (DraftJobPostsSortField) {
    DraftJobPostsSortField["DateCreated"] = "DATE_CREATED";
    DraftJobPostsSortField["JobAddress"] = "JOB_ADDRESS";
    DraftJobPostsSortField["Title"] = "TITLE";
})(DraftJobPostsSortField || (DraftJobPostsSortField = {}));
/** Enum values for apply domains */
export var DraftManagementApplyDomain;
(function (DraftManagementApplyDomain) {
    DraftManagementApplyDomain["Indeed"] = "INDEED";
    DraftManagementApplyDomain["ThirdParty"] = "THIRD_PARTY";
})(DraftManagementApplyDomain || (DraftManagementApplyDomain = {}));
/** Enum for tracking NRT billing event lifecycle status */
export var DraftManagementBillingEventStatus;
(function (DraftManagementBillingEventStatus) {
    /** Apply start billing event has been successfully emitted. */
    DraftManagementBillingEventStatus["ApplyStartEmitted"] = "APPLY_START_EMITTED";
    /**
     * Billing details are configured but no billing events have been emitted.
     * Ready for billing event processing.
     */
    DraftManagementBillingEventStatus["Configured"] = "CONFIGURED";
    /**
     * Billing configuration has not been established for this job.
     * No billing-related processing has occurred.
     */
    DraftManagementBillingEventStatus["NotConfigured"] = "NOT_CONFIGURED";
})(DraftManagementBillingEventStatus || (DraftManagementBillingEventStatus = {}));
/** Data type */
export var DraftManagementDataType;
(function (DraftManagementDataType) {
    DraftManagementDataType["Decimal"] = "DECIMAL";
    DraftManagementDataType["Integer"] = "INTEGER";
    DraftManagementDataType["NumericText"] = "NUMERIC_TEXT";
    DraftManagementDataType["Text"] = "TEXT";
})(DraftManagementDataType || (DraftManagementDataType = {}));
/** Enum values for application draft states */
export var DraftManagementDraftStateName;
(function (DraftManagementDraftStateName) {
    DraftManagementDraftStateName["Draft"] = "DRAFT";
    DraftManagementDraftStateName["Preview"] = "PREVIEW";
    DraftManagementDraftStateName["Submitted"] = "SUBMITTED";
})(DraftManagementDraftStateName || (DraftManagementDraftStateName = {}));
/** Enums for the email status. */
export var DraftManagementEmailStatus;
(function (DraftManagementEmailStatus) {
    DraftManagementEmailStatus["NonVerified"] = "NON_VERIFIED";
    DraftManagementEmailStatus["Verified"] = "VERIFIED";
})(DraftManagementEmailStatus || (DraftManagementEmailStatus = {}));
/** Font size */
export var DraftManagementFontSize;
(function (DraftManagementFontSize) {
    DraftManagementFontSize["Large"] = "LARGE";
    DraftManagementFontSize["Medium"] = "MEDIUM";
    DraftManagementFontSize["Small"] = "SMALL";
})(DraftManagementFontSize || (DraftManagementFontSize = {}));
/** Enum values for post call job integration format */
export var DraftManagementJobIntegrationPostCallFormat;
(function (DraftManagementJobIntegrationPostCallFormat) {
    DraftManagementJobIntegrationPostCallFormat["Json"] = "JSON";
})(DraftManagementJobIntegrationPostCallFormat || (DraftManagementJobIntegrationPostCallFormat = {}));
/** Enum values for job integration types */
export var DraftManagementJobIntegrationType;
(function (DraftManagementJobIntegrationType) {
    DraftManagementJobIntegrationType["Email"] = "EMAIL";
    DraftManagementJobIntegrationType["PostCall"] = "POST_CALL";
})(DraftManagementJobIntegrationType || (DraftManagementJobIntegrationType = {}));
/** A Job Seeker's employment eligibility */
export var DraftManagementJobSeekerProfileEmploymentEligibility;
(function (DraftManagementJobSeekerProfileEmploymentEligibility) {
    DraftManagementJobSeekerProfileEmploymentEligibility["Eligible"] = "ELIGIBLE";
    DraftManagementJobSeekerProfileEmploymentEligibility["Ineligible"] = "INELIGIBLE";
    DraftManagementJobSeekerProfileEmploymentEligibility["Unknown"] = "UNKNOWN";
    DraftManagementJobSeekerProfileEmploymentEligibility["WithSponsorship"] = "WITH_SPONSORSHIP";
})(DraftManagementJobSeekerProfileEmploymentEligibility || (DraftManagementJobSeekerProfileEmploymentEligibility = {}));
/** A location geocode precision for example COUNTRY, CITY. */
export var DraftManagementJobSeekerProfileGeocodePrecision;
(function (DraftManagementJobSeekerProfileGeocodePrecision) {
    DraftManagementJobSeekerProfileGeocodePrecision["Address"] = "ADDRESS";
    DraftManagementJobSeekerProfileGeocodePrecision["Admin1"] = "ADMIN1";
    DraftManagementJobSeekerProfileGeocodePrecision["Admin2"] = "ADMIN2";
    DraftManagementJobSeekerProfileGeocodePrecision["Admin3"] = "ADMIN3";
    DraftManagementJobSeekerProfileGeocodePrecision["Admin4"] = "ADMIN4";
    DraftManagementJobSeekerProfileGeocodePrecision["City"] = "CITY";
    DraftManagementJobSeekerProfileGeocodePrecision["Country"] = "COUNTRY";
    DraftManagementJobSeekerProfileGeocodePrecision["Postal"] = "POSTAL";
})(DraftManagementJobSeekerProfileGeocodePrecision || (DraftManagementJobSeekerProfileGeocodePrecision = {}));
/** A Job Seeker's license type, for example ACCOUNTING_LICENSE, DRIVERS_LICENSE or NURSES_LICENSE */
export var DraftManagementJobSeekerProfileLicenseType;
(function (DraftManagementJobSeekerProfileLicenseType) {
    DraftManagementJobSeekerProfileLicenseType["AccountingLicense"] = "ACCOUNTING_LICENSE";
    DraftManagementJobSeekerProfileLicenseType["DriversLicense"] = "DRIVERS_LICENSE";
    DraftManagementJobSeekerProfileLicenseType["NursesLicense"] = "NURSES_LICENSE";
    DraftManagementJobSeekerProfileLicenseType["Unknown"] = "UNKNOWN";
})(DraftManagementJobSeekerProfileLicenseType || (DraftManagementJobSeekerProfileLicenseType = {}));
/** Month type, e.g. JANUARY. Month type of NOT_SPECIFIED is used to update month to null. */
export var DraftManagementJobSeekerProfileMonthType;
(function (DraftManagementJobSeekerProfileMonthType) {
    DraftManagementJobSeekerProfileMonthType["April"] = "APRIL";
    DraftManagementJobSeekerProfileMonthType["August"] = "AUGUST";
    DraftManagementJobSeekerProfileMonthType["December"] = "DECEMBER";
    DraftManagementJobSeekerProfileMonthType["February"] = "FEBRUARY";
    DraftManagementJobSeekerProfileMonthType["January"] = "JANUARY";
    DraftManagementJobSeekerProfileMonthType["July"] = "JULY";
    DraftManagementJobSeekerProfileMonthType["June"] = "JUNE";
    DraftManagementJobSeekerProfileMonthType["March"] = "MARCH";
    DraftManagementJobSeekerProfileMonthType["May"] = "MAY";
    DraftManagementJobSeekerProfileMonthType["NotSpecified"] = "NOT_SPECIFIED";
    DraftManagementJobSeekerProfileMonthType["November"] = "NOVEMBER";
    DraftManagementJobSeekerProfileMonthType["October"] = "OCTOBER";
    DraftManagementJobSeekerProfileMonthType["September"] = "SEPTEMBER";
})(DraftManagementJobSeekerProfileMonthType || (DraftManagementJobSeekerProfileMonthType = {}));
/** A Job Seeker's resume career level, for example EXPERIENCED. */
export var DraftManagementJobSeekerProfileResumeCareerLevel;
(function (DraftManagementJobSeekerProfileResumeCareerLevel) {
    DraftManagementJobSeekerProfileResumeCareerLevel["Experienced"] = "EXPERIENCED";
    DraftManagementJobSeekerProfileResumeCareerLevel["Fresher"] = "FRESHER";
    DraftManagementJobSeekerProfileResumeCareerLevel["NotSpecified"] = "NOT_SPECIFIED";
})(DraftManagementJobSeekerProfileResumeCareerLevel || (DraftManagementJobSeekerProfileResumeCareerLevel = {}));
/** A Job Seeker's resume source, for example DOCUMENT_UPLOAD or INDEED_APPLY. */
export var DraftManagementJobSeekerProfileResumeSource;
(function (DraftManagementJobSeekerProfileResumeSource) {
    DraftManagementJobSeekerProfileResumeSource["BasicProfileOnly"] = "BASIC_PROFILE_ONLY";
    DraftManagementJobSeekerProfileResumeSource["BasicProfileUpload"] = "BASIC_PROFILE_UPLOAD";
    DraftManagementJobSeekerProfileResumeSource["BlankTemplate"] = "BLANK_TEMPLATE";
    DraftManagementJobSeekerProfileResumeSource["DocumentUpload"] = "DOCUMENT_UPLOAD";
    DraftManagementJobSeekerProfileResumeSource["DropboxUpload"] = "DROPBOX_UPLOAD";
    DraftManagementJobSeekerProfileResumeSource["Duplicate"] = "DUPLICATE";
    DraftManagementJobSeekerProfileResumeSource["FacebookProfile"] = "FACEBOOK_PROFILE";
    DraftManagementJobSeekerProfileResumeSource["GoogleDoc"] = "GOOGLE_DOC";
    DraftManagementJobSeekerProfileResumeSource["IndeedApply"] = "INDEED_APPLY";
    DraftManagementJobSeekerProfileResumeSource["LinkedinProfile"] = "LINKEDIN_PROFILE";
    DraftManagementJobSeekerProfileResumeSource["MessagingApp"] = "MESSAGING_APP";
    DraftManagementJobSeekerProfileResumeSource["MicroContent"] = "MICRO_CONTENT";
    DraftManagementJobSeekerProfileResumeSource["MicroContentCarousel"] = "MICRO_CONTENT_CAROUSEL";
    DraftManagementJobSeekerProfileResumeSource["MicroContentJp"] = "MICRO_CONTENT_JP";
    DraftManagementJobSeekerProfileResumeSource["NativeCreate"] = "NATIVE_CREATE";
    DraftManagementJobSeekerProfileResumeSource["NativeUpload"] = "NATIVE_UPLOAD";
    DraftManagementJobSeekerProfileResumeSource["Owain"] = "OWAIN";
    DraftManagementJobSeekerProfileResumeSource["Resumecom"] = "RESUMECOM";
    DraftManagementJobSeekerProfileResumeSource["UniversalResume"] = "UNIVERSAL_RESUME";
    DraftManagementJobSeekerProfileResumeSource["Unknown"] = "UNKNOWN";
})(DraftManagementJobSeekerProfileResumeSource || (DraftManagementJobSeekerProfileResumeSource = {}));
/** A Job Seeker's resume state, for example PUBLIC or HIDDEN. */
export var DraftManagementJobSeekerProfileResumeState;
(function (DraftManagementJobSeekerProfileResumeState) {
    DraftManagementJobSeekerProfileResumeState["Deleted"] = "DELETED";
    DraftManagementJobSeekerProfileResumeState["Hidden"] = "HIDDEN";
    DraftManagementJobSeekerProfileResumeState["Public"] = "PUBLIC";
})(DraftManagementJobSeekerProfileResumeState || (DraftManagementJobSeekerProfileResumeState = {}));
/** A Job Seeker's resume type, for example INDEED_RESUME or PARSED_RESUME. */
export var DraftManagementJobSeekerProfileResumeType;
(function (DraftManagementJobSeekerProfileResumeType) {
    DraftManagementJobSeekerProfileResumeType["Glassdoor"] = "GLASSDOOR";
    DraftManagementJobSeekerProfileResumeType["IndeedResume"] = "INDEED_RESUME";
    DraftManagementJobSeekerProfileResumeType["Parsed"] = "PARSED";
    DraftManagementJobSeekerProfileResumeType["Recruit"] = "RECRUIT";
    DraftManagementJobSeekerProfileResumeType["Resumecom"] = "RESUMECOM";
    DraftManagementJobSeekerProfileResumeType["Simplyhired"] = "SIMPLYHIRED";
})(DraftManagementJobSeekerProfileResumeType || (DraftManagementJobSeekerProfileResumeType = {}));
/** Time unit like Years, Months. */
export var DraftManagementJobSeekerProfileTypeUnit;
(function (DraftManagementJobSeekerProfileTypeUnit) {
    DraftManagementJobSeekerProfileTypeUnit["Days"] = "Days";
    DraftManagementJobSeekerProfileTypeUnit["Months"] = "Months";
    DraftManagementJobSeekerProfileTypeUnit["Weeks"] = "Weeks";
    DraftManagementJobSeekerProfileTypeUnit["Years"] = "Years";
})(DraftManagementJobSeekerProfileTypeUnit || (DraftManagementJobSeekerProfileTypeUnit = {}));
/** Enum values for name formats in standard job fields */
export var DraftManagementJobStandardFieldNameFormat;
(function (DraftManagementJobStandardFieldNameFormat) {
    DraftManagementJobStandardFieldNameFormat["FirstLastName"] = "FIRST_LAST_NAME";
    DraftManagementJobStandardFieldNameFormat["FullName"] = "FULL_NAME";
})(DraftManagementJobStandardFieldNameFormat || (DraftManagementJobStandardFieldNameFormat = {}));
/** Enum values for Job standard field requirement */
export var DraftManagementJobStandardFieldRequirement;
(function (DraftManagementJobStandardFieldRequirement) {
    DraftManagementJobStandardFieldRequirement["Hidden"] = "HIDDEN";
    DraftManagementJobStandardFieldRequirement["Optional"] = "OPTIONAL";
    DraftManagementJobStandardFieldRequirement["Required"] = "REQUIRED";
})(DraftManagementJobStandardFieldRequirement || (DraftManagementJobStandardFieldRequirement = {}));
/** Qualification Match Type */
export var DraftManagementQualificationMatchType;
(function (DraftManagementQualificationMatchType) {
    DraftManagementQualificationMatchType["All"] = "ALL";
    DraftManagementQualificationMatchType["Any"] = "ANY";
})(DraftManagementQualificationMatchType || (DraftManagementQualificationMatchType = {}));
/** Qualification Type */
export var DraftManagementQualificationType;
(function (DraftManagementQualificationType) {
    DraftManagementQualificationType["Knockout"] = "KNOCKOUT";
    DraftManagementQualificationType["NonBlocking"] = "NON_BLOCKING";
})(DraftManagementQualificationType || (DraftManagementQualificationType = {}));
/** Type of Question */
export var DraftManagementQuestionType;
(function (DraftManagementQuestionType) {
    DraftManagementQuestionType["Date"] = "DATE";
    DraftManagementQuestionType["File"] = "FILE";
    DraftManagementQuestionType["Hierarchical"] = "HIERARCHICAL";
    DraftManagementQuestionType["Information"] = "INFORMATION";
    DraftManagementQuestionType["Multifield"] = "MULTIFIELD";
    DraftManagementQuestionType["MultiSelect"] = "MULTI_SELECT";
    DraftManagementQuestionType["PageBreak"] = "PAGE_BREAK";
    DraftManagementQuestionType["Select"] = "SELECT";
    DraftManagementQuestionType["TextArea"] = "TEXT_AREA";
    DraftManagementQuestionType["TextBox"] = "TEXT_BOX";
})(DraftManagementQuestionType || (DraftManagementQuestionType = {}));
/** Specifies whether a is required to answer */
export var DraftManagementQuestionsRequirement;
(function (DraftManagementQuestionsRequirement) {
    DraftManagementQuestionsRequirement["Optional"] = "OPTIONAL";
    DraftManagementQuestionsRequirement["Required"] = "REQUIRED";
})(DraftManagementQuestionsRequirement || (DraftManagementQuestionsRequirement = {}));
/** Resume origin enum. */
export var DraftManagementResumeOrigin;
(function (DraftManagementResumeOrigin) {
    /** The resume is generated by Indeed Profile Services */
    DraftManagementResumeOrigin["IndeedProfile"] = "INDEED_PROFILE";
    /** The resume from Recruit */
    DraftManagementResumeOrigin["RecruitProfile"] = "RECRUIT_PROFILE";
    /** Last saved resume from Indeed Profile Services */
    DraftManagementResumeOrigin["SavedResume"] = "SAVED_RESUME";
    /** AI tailored resume based on the applicant's Indeed resume */
    DraftManagementResumeOrigin["TailoredResume"] = "TAILORED_RESUME";
    /** The resume is provided by an applicant */
    DraftManagementResumeOrigin["UserUploaded"] = "USER_UPLOADED";
})(DraftManagementResumeOrigin || (DraftManagementResumeOrigin = {}));
export var DraftManagementTailoredResumeType;
(function (DraftManagementTailoredResumeType) {
    DraftManagementTailoredResumeType["Custom"] = "CUSTOM";
    DraftManagementTailoredResumeType["Original"] = "ORIGINAL";
    DraftManagementTailoredResumeType["Tailored"] = "TAILORED";
})(DraftManagementTailoredResumeType || (DraftManagementTailoredResumeType = {}));
/** Status of duplicating a campaign */
export var DuplicateCampaignStatus;
(function (DuplicateCampaignStatus) {
    DuplicateCampaignStatus["AdsDuplicationFailed"] = "ADS_DUPLICATION_FAILED";
    DuplicateCampaignStatus["CampaignDuplicationFailed"] = "CAMPAIGN_DUPLICATION_FAILED";
    DuplicateCampaignStatus["FullyDuplicated"] = "FULLY_DUPLICATED";
    DuplicateCampaignStatus["PausePropagationFailed"] = "PAUSE_PROPAGATION_FAILED";
})(DuplicateCampaignStatus || (DuplicateCampaignStatus = {}));
/** Supported duration units for pausing subscriptions. */
export var DurationUnit;
(function (DurationUnit) {
    DurationUnit["Days"] = "DAYS";
    DurationUnit["Months"] = "MONTHS";
    DurationUnit["Weeks"] = "WEEKS";
})(DurationUnit || (DurationUnit = {}));
export var ElssContactSalesFormType;
(function (ElssContactSalesFormType) {
    ElssContactSalesFormType["Help"] = "HELP";
    ElssContactSalesFormType["Purchase"] = "PURCHASE";
})(ElssContactSalesFormType || (ElssContactSalesFormType = {}));
/** Possible education levels (currently US only) */
export var EducationLevel;
(function (EducationLevel) {
    EducationLevel["Associates"] = "ASSOCIATES";
    EducationLevel["Bachelors"] = "BACHELORS";
    EducationLevel["Doctoral"] = "DOCTORAL";
    EducationLevel["Masters"] = "MASTERS";
    EducationLevel["UpperSecondary"] = "UPPER_SECONDARY";
})(EducationLevel || (EducationLevel = {}));
/** Variants of the EducationRequirementV1 optimization */
export var EducationRequirementV1OptimizationVariant;
(function (EducationRequirementV1OptimizationVariant) {
    /** @deprecated Education Requirement V1 optimization is deprecated */
    EducationRequirementV1OptimizationVariant["EducationRequirementV1OptimizationVariantDefault"] = "EDUCATION_REQUIREMENT_V1_OPTIMIZATION_VARIANT_DEFAULT";
})(EducationRequirementV1OptimizationVariant || (EducationRequirementV1OptimizationVariant = {}));
/** Variants of the EducationRequirementV2 optimization */
export var EducationRequirementV2OptimizationVariant;
(function (EducationRequirementV2OptimizationVariant) {
    EducationRequirementV2OptimizationVariant["EducationRequirementOptimizationJocomoScoreGated"] = "EDUCATION_REQUIREMENT_OPTIMIZATION_JOCOMO_SCORE_GATED";
    /** @deprecated No longer supported */
    EducationRequirementV2OptimizationVariant["EducationRequirementV2OptimizationVariantCandidatePool"] = "EDUCATION_REQUIREMENT_V2_OPTIMIZATION_VARIANT_CANDIDATE_POOL";
    EducationRequirementV2OptimizationVariant["EducationRequirementV2OptimizationVariantDefault"] = "EDUCATION_REQUIREMENT_V2_OPTIMIZATION_VARIANT_DEFAULT";
    /** @deprecated This variant is deprecated. Use EDUCATION_REQUIREMENT_V2_OPTIMIZATION_VARIANT_DEFAULT instead. */
    EducationRequirementV2OptimizationVariant["EducationRequirementV2OptimizationVariantReduceEducationRequirement"] = "EDUCATION_REQUIREMENT_V2_OPTIMIZATION_VARIANT_REDUCE_EDUCATION_REQUIREMENT";
    /** @deprecated This variant is deprecated. Use EDUCATION_REQUIREMENT_OPTIMIZATION_JOCOMO_SCORE_GATED instead. */
    EducationRequirementV2OptimizationVariant["EducationRequirementV2OptimizationVariantReduceEducationRequirementAndJocomoScoreGated"] = "EDUCATION_REQUIREMENT_V2_OPTIMIZATION_VARIANT_REDUCE_EDUCATION_REQUIREMENT_AND_JOCOMO_SCORE_GATED";
})(EducationRequirementV2OptimizationVariant || (EducationRequirementV2OptimizationVariant = {}));
export var EjpAutomationActionStatus;
(function (EjpAutomationActionStatus) {
    EjpAutomationActionStatus["Active"] = "ACTIVE";
    EjpAutomationActionStatus["Paused"] = "PAUSED";
})(EjpAutomationActionStatus || (EjpAutomationActionStatus = {}));
export var EjpAutomationActionType;
(function (EjpAutomationActionType) {
    EjpAutomationActionType["AddToEjpGroup"] = "ADD_TO_EJP_GROUP";
    EjpAutomationActionType["EnrollInNexusAction"] = "ENROLL_IN_NEXUS_ACTION";
})(EjpAutomationActionType || (EjpAutomationActionType = {}));
/**
 * Product types supported by EJP Automations API.
 * This is a subset of EjpGroupProductType that are valid for automation actions.
 */
export var EjpAutomationGroupProductType;
(function (EjpAutomationGroupProductType) {
    EjpAutomationGroupProductType["AdvancedAiScreening"] = "ADVANCED_AI_SCREENING";
    EjpAutomationGroupProductType["BasicScreening"] = "BASIC_SCREENING";
    EjpAutomationGroupProductType["BasicScreeningV2"] = "BASIC_SCREENING_V2";
    EjpAutomationGroupProductType["Nexus"] = "NEXUS";
    EjpAutomationGroupProductType["SponsoredJobNexus"] = "SPONSORED_JOB_NEXUS";
})(EjpAutomationGroupProductType || (EjpAutomationGroupProductType = {}));
export var EjpAutomationHostedJobStatus;
(function (EjpAutomationHostedJobStatus) {
    EjpAutomationHostedJobStatus["Active"] = "ACTIVE";
    EjpAutomationHostedJobStatus["Closed"] = "CLOSED";
    EjpAutomationHostedJobStatus["Paused"] = "PAUSED";
    EjpAutomationHostedJobStatus["Unknown"] = "UNKNOWN";
})(EjpAutomationHostedJobStatus || (EjpAutomationHostedJobStatus = {}));
export var EjpAutomationSponsorshipStatus;
(function (EjpAutomationSponsorshipStatus) {
    EjpAutomationSponsorshipStatus["Free"] = "FREE";
    EjpAutomationSponsorshipStatus["Sponsored"] = "SPONSORED";
})(EjpAutomationSponsorshipStatus || (EjpAutomationSponsorshipStatus = {}));
/** Represents the lifecycle state of an automation. */
export var EjpAutomationState;
(function (EjpAutomationState) {
    EjpAutomationState["Active"] = "ACTIVE";
    EjpAutomationState["Deleting"] = "DELETING";
    EjpAutomationState["Initializing"] = "INITIALIZING";
    EjpAutomationState["Updating"] = "UPDATING";
})(EjpAutomationState || (EjpAutomationState = {}));
export var EjpAutomationTransactionStatus;
(function (EjpAutomationTransactionStatus) {
    EjpAutomationTransactionStatus["Completed"] = "COMPLETED";
    EjpAutomationTransactionStatus["Failed"] = "FAILED";
    EjpAutomationTransactionStatus["InProgress"] = "IN_PROGRESS";
})(EjpAutomationTransactionStatus || (EjpAutomationTransactionStatus = {}));
export var EjpAutomationTransactionType;
(function (EjpAutomationTransactionType) {
    EjpAutomationTransactionType["CreateAutomation"] = "CREATE_AUTOMATION";
    EjpAutomationTransactionType["DeleteAutomation"] = "DELETE_AUTOMATION";
    EjpAutomationTransactionType["UpdateAutomationReplaceTrigger"] = "UPDATE_AUTOMATION_REPLACE_TRIGGER";
})(EjpAutomationTransactionType || (EjpAutomationTransactionType = {}));
export var EjpAutomationTriggerType;
(function (EjpAutomationTriggerType) {
    EjpAutomationTriggerType["EmployerJobMatch"] = "EMPLOYER_JOB_MATCH";
})(EjpAutomationTriggerType || (EjpAutomationTriggerType = {}));
/** Enum representing the various product types served by EJG. */
export var EjpGroupProductType;
(function (EjpGroupProductType) {
    EjpGroupProductType["AdvancedAiScreening"] = "ADVANCED_AI_SCREENING";
    EjpGroupProductType["AiJobManagementPriority"] = "AI_JOB_MANAGEMENT_PRIORITY";
    EjpGroupProductType["BasicScreening"] = "BASIC_SCREENING";
    EjpGroupProductType["BasicScreeningV2"] = "BASIC_SCREENING_V2";
    EjpGroupProductType["Campaign"] = "CAMPAIGN";
    EjpGroupProductType["EmployerBillingIdentifier"] = "EMPLOYER_BILLING_IDENTIFIER";
    EjpGroupProductType["EmployerJobAssignments"] = "EMPLOYER_JOB_ASSIGNMENTS";
    EjpGroupProductType["EmployerJobTags"] = "EMPLOYER_JOB_TAGS";
    EjpGroupProductType["HiringPipeline"] = "HIRING_PIPELINE";
    EjpGroupProductType["Horizon"] = "HORIZON";
    EjpGroupProductType["Nexus"] = "NEXUS";
    EjpGroupProductType["SponsoredJobNexus"] = "SPONSORED_JOB_NEXUS";
    EjpGroupProductType["Star"] = "STAR";
    EjpGroupProductType["Test"] = "TEST";
    EjpGroupProductType["TestSingleton"] = "TEST_SINGLETON";
})(EjpGroupProductType || (EjpGroupProductType = {}));
/** Enum representing the various ScopeTypes that a group can be owned under. */
export var EjpGroupScopeType;
(function (EjpGroupScopeType) {
    EjpGroupScopeType["Account"] = "ACCOUNT";
    EjpGroupScopeType["Advertiser"] = "ADVERTISER";
    EjpGroupScopeType["AdvertiserAccount"] = "ADVERTISER_ACCOUNT";
})(EjpGroupScopeType || (EjpGroupScopeType = {}));
export var EjpJobMatchAutomationBaseFilter;
(function (EjpJobMatchAutomationBaseFilter) {
    EjpJobMatchAutomationBaseFilter["AllJobsOpenPaused"] = "ALL_JOBS_OPEN_PAUSED";
    EjpJobMatchAutomationBaseFilter["BasicScreeningEligibleJobs"] = "BASIC_SCREENING_ELIGIBLE_JOBS";
    EjpJobMatchAutomationBaseFilter["NexusEligibleJobs"] = "NEXUS_ELIGIBLE_JOBS";
})(EjpJobMatchAutomationBaseFilter || (EjpJobMatchAutomationBaseFilter = {}));
/** Enum representing the ownership scope. */
export var EjpOwnerScopeType;
(function (EjpOwnerScopeType) {
    EjpOwnerScopeType["Advertiser"] = "ADVERTISER";
})(EjpOwnerScopeType || (EjpOwnerScopeType = {}));
export var EligibilityBlocker;
(function (EligibilityBlocker) {
    EligibilityBlocker["ConflictsWithExistingAutomation"] = "CONFLICTS_WITH_EXISTING_AUTOMATION";
    EligibilityBlocker["ConflictsWithNexusInterviewInvitationAutomationProduct"] = "CONFLICTS_WITH_NEXUS_INTERVIEW_INVITATION_AUTOMATION_PRODUCT";
    EligibilityBlocker["ConflictsWithNexusStrongScoreOutreachAutomationProduct"] = "CONFLICTS_WITH_NEXUS_STRONG_SCORE_OUTREACH_AUTOMATION_PRODUCT";
    /** @deprecated No longer supported */
    EligibilityBlocker["IndexedJobIneligible"] = "INDEXED_JOB_INELIGIBLE";
    EligibilityBlocker["InsufficientPermissions"] = "INSUFFICIENT_PERMISSIONS";
    EligibilityBlocker["InvalidJobId"] = "INVALID_JOB_ID";
    /** @deprecated No longer supported */
    EligibilityBlocker["IsTpiaJob"] = "IS_TPIA_JOB";
    EligibilityBlocker["MissingTriggerActionName"] = "MISSING_TRIGGER_ACTION_NAME";
    EligibilityBlocker["NotOpen"] = "NOT_OPEN";
    EligibilityBlocker["NotSponsored"] = "NOT_SPONSORED";
    EligibilityBlocker["NoCandidateManagement"] = "NO_CANDIDATE_MANAGEMENT";
    EligibilityBlocker["ProctorDisabled"] = "PROCTOR_DISABLED";
    EligibilityBlocker["UnexpectedJobType"] = "UNEXPECTED_JOB_TYPE";
    EligibilityBlocker["UnknownAutomation"] = "UNKNOWN_AUTOMATION";
})(EligibilityBlocker || (EligibilityBlocker = {}));
export var EligibilityRequirementType;
(function (EligibilityRequirementType) {
    /** User has been inactive for 3+ days */
    EligibilityRequirementType["InactiveUser"] = "INACTIVE_USER";
    /** User is missing a valid phone number */
    EligibilityRequirementType["MissingPhoneNumber"] = "MISSING_PHONE_NUMBER";
    /**
     * Selected resume exists but does not meet Minimally Complete Profile requirements.
     * Check mcpCriteria field for specific missing requirements.
     */
    EligibilityRequirementType["ProfileNotMcpComplete"] = "PROFILE_NOT_MCP_COMPLETE";
    /**
     * Selected resume type does not exist in profile.
     * User needs to create or upload a resume of the selected type.
     */
    EligibilityRequirementType["SelectedResumeNotFound"] = "SELECTED_RESUME_NOT_FOUND";
})(EligibilityRequirementType || (EligibilityRequirementType = {}));
export var EligibilityStatus;
(function (EligibilityStatus) {
    EligibilityStatus["Eligible"] = "ELIGIBLE";
    EligibilityStatus["Error"] = "ERROR";
    EligibilityStatus["Ineligible"] = "INELIGIBLE";
    EligibilityStatus["Unknown"] = "UNKNOWN";
})(EligibilityStatus || (EligibilityStatus = {}));
export var EligibleTier;
(function (EligibleTier) {
    EligibleTier["Plus"] = "PLUS";
    EligibleTier["Professional"] = "PROFESSIONAL";
    EligibleTier["Standard"] = "STANDARD";
})(EligibleTier || (EligibleTier = {}));
/** Render modes that can enable disable features needed for live production emails */
export var EmailRenderingMode;
(function (EmailRenderingMode) {
    /** Render content for actual delivery */
    EmailRenderingMode["Actual"] = "ACTUAL";
    /** Render inert content for employer preview */
    EmailRenderingMode["EmployerPreview"] = "EMPLOYER_PREVIEW";
    /** Render actual URLs, but skip AdClickService charging */
    EmailRenderingMode["NoCharge"] = "NO_CHARGE";
    /** Render inert content for internal preview */
    EmailRenderingMode["Preview"] = "PREVIEW";
})(EmailRenderingMode || (EmailRenderingMode = {}));
/** Which set of employer email addresses an email-domain filter applies to. */
export var EmailScope;
(function (EmailScope) {
    /**  Any user email associated with the employer.  */
    EmailScope["AnyUser"] = "ANY_USER";
    /**  Only the employer's owner email.  */
    EmailScope["Owner"] = "OWNER";
})(EmailScope || (EmailScope = {}));
/** Email spam level options */
export var EmailSpamLevel;
(function (EmailSpamLevel) {
    EmailSpamLevel["Solicited"] = "SOLICITED";
    EmailSpamLevel["Unsolicited"] = "UNSOLICITED";
})(EmailSpamLevel || (EmailSpamLevel = {}));
/** Type of template to render. Some templates exist in multiple types, but not all will. */
export var EmailTemplateType;
(function (EmailTemplateType) {
    /** Apache Freemarker template type */
    EmailTemplateType["Freemarker"] = "FREEMARKER";
    /** NodeJs template type, more specifically a React TypeScript template */
    EmailTemplateType["Node"] = "NODE";
})(EmailTemplateType || (EmailTemplateType = {}));
/** Type of Email sent */
export var EmailType;
(function (EmailType) {
    EmailType["Cancellation"] = "CANCELLATION";
    EmailType["Renewal"] = "RENEWAL";
})(EmailType || (EmailType = {}));
export var EmployeeCount;
(function (EmployeeCount) {
    EmployeeCount["Employee_1_49"] = "EMPLOYEE_1_49";
    EmployeeCount["Employee_50_149"] = "EMPLOYEE_50_149";
    EmployeeCount["Employee_150_249"] = "EMPLOYEE_150_249";
    EmployeeCount["Employee_250_499"] = "EMPLOYEE_250_499";
    EmployeeCount["Employee_500_749"] = "EMPLOYEE_500_749";
    EmployeeCount["Employee_750_999"] = "EMPLOYEE_750_999";
    EmployeeCount["Employee_1000More"] = "EMPLOYEE_1000_MORE";
    EmployeeCount["EmployeeNull"] = "EMPLOYEE_NULL";
})(EmployeeCount || (EmployeeCount = {}));
/**
 * Subscription Source
 *
 * Who generated the subscription
 */
export var EmployerAdminActionContextSubscriptionSource;
(function (EmployerAdminActionContextSubscriptionSource) {
    /** Subscription was generated from OTR */
    EmployerAdminActionContextSubscriptionSource["Otr"] = "OTR";
    /** Subscription was generated from Remy */
    EmployerAdminActionContextSubscriptionSource["Remy"] = "REMY";
})(EmployerAdminActionContextSubscriptionSource || (EmployerAdminActionContextSubscriptionSource = {}));
/** Who/what requested the action */
export var EmployerAdminActionRequestedBy;
(function (EmployerAdminActionRequestedBy) {
    /** Actions such as trial upgrade */
    EmployerAdminActionRequestedBy["System"] = "SYSTEM";
    /** Actions such as instant upgrade and post trial purchase */
    EmployerAdminActionRequestedBy["User"] = "USER";
})(EmployerAdminActionRequestedBy || (EmployerAdminActionRequestedBy = {}));
/** An actions resolution status */
export var EmployerAdminActionResolution;
(function (EmployerAdminActionResolution) {
    /** negative-path: the action was archived, usually by SYSTEM */
    EmployerAdminActionResolution["Archived"] = "ARCHIVED";
    /** negative-path: the action was rejected */
    EmployerAdminActionResolution["Dismissed"] = "DISMISSED";
    /** positive-path: the action was fulfilled */
    EmployerAdminActionResolution["Fulfilled"] = "FULFILLED";
    EmployerAdminActionResolution["NoResolution"] = "NO_RESOLUTION";
})(EmployerAdminActionResolution || (EmployerAdminActionResolution = {}));
/** How the action was fulfilled */
export var EmployerAdminActionResolutionFulfillmentMethod;
(function (EmployerAdminActionResolutionFulfillmentMethod) {
    /** An action was fulfilled by moving already-existing resources (e.g., contacts, subscriptions) */
    EmployerAdminActionResolutionFulfillmentMethod["Move"] = "MOVE";
    /** An action was fulfilled through a purchase */
    EmployerAdminActionResolutionFulfillmentMethod["Purchase"] = "PURCHASE";
})(EmployerAdminActionResolutionFulfillmentMethod || (EmployerAdminActionResolutionFulfillmentMethod = {}));
/** An actions status */
export var EmployerAdminActionStatus;
(function (EmployerAdminActionStatus) {
    EmployerAdminActionStatus["Resolved"] = "RESOLVED";
    EmployerAdminActionStatus["Unresolved"] = "UNRESOLVED";
})(EmployerAdminActionStatus || (EmployerAdminActionStatus = {}));
/** The type of action */
export var EmployerAdminActionType;
(function (EmployerAdminActionType) {
    EmployerAdminActionType["ActionTypeUnspecified"] = "ACTION_TYPE_UNSPECIFIED";
    EmployerAdminActionType["AdditionalContacts"] = "ADDITIONAL_CONTACTS";
    EmployerAdminActionType["InstantPurchase"] = "INSTANT_PURCHASE";
    EmployerAdminActionType["InstantUpgrade"] = "INSTANT_UPGRADE";
    EmployerAdminActionType["PostTrialPurchase"] = "POST_TRIAL_PURCHASE";
})(EmployerAdminActionType || (EmployerAdminActionType = {}));
/** Type of actor who performed an activity */
export var EmployerAiAutomationsActivityActorType;
(function (EmployerAiAutomationsActivityActorType) {
    /** An automated AI system */
    EmployerAiAutomationsActivityActorType["AutomationSystem"] = "AUTOMATION_SYSTEM";
    /** A human user */
    EmployerAiAutomationsActivityActorType["User"] = "USER";
})(EmployerAiAutomationsActivityActorType || (EmployerAiAutomationsActivityActorType = {}));
/** Type of campaign bucket for automation execution */
export var EmployerAiAutomationsCampaignBucketType;
(function (EmployerAiAutomationsCampaignBucketType) {
    /** Free campaign bucket */
    EmployerAiAutomationsCampaignBucketType["Free"] = "FREE";
    /** High priority campaign bucket */
    EmployerAiAutomationsCampaignBucketType["HighPriority"] = "HIGH_PRIORITY";
    /** Low priority campaign bucket */
    EmployerAiAutomationsCampaignBucketType["LowPriority"] = "LOW_PRIORITY";
    /** Medium priority campaign bucket */
    EmployerAiAutomationsCampaignBucketType["MediumPriority"] = "MEDIUM_PRIORITY";
})(EmployerAiAutomationsCampaignBucketType || (EmployerAiAutomationsCampaignBucketType = {}));
/** Status of a plan execution request */
export var EmployerAiAutomationsExecutionStatus;
(function (EmployerAiAutomationsExecutionStatus) {
    /** Execution request failed */
    EmployerAiAutomationsExecutionStatus["Failure"] = "FAILURE";
    /** Execution request is in progress */
    EmployerAiAutomationsExecutionStatus["InProgress"] = "IN_PROGRESS";
    /** Execution request completed successfully */
    EmployerAiAutomationsExecutionStatus["Success"] = "SUCCESS";
})(EmployerAiAutomationsExecutionStatus || (EmployerAiAutomationsExecutionStatus = {}));
/** The type of CRUD operation performed on a guardrail configuration */
export var EmployerAiAutomationsGuardrailConfigChangeOperation;
(function (EmployerAiAutomationsGuardrailConfigChangeOperation) {
    /** A new guardrail was created */
    EmployerAiAutomationsGuardrailConfigChangeOperation["Created"] = "CREATED";
    /** A guardrail was deleted */
    EmployerAiAutomationsGuardrailConfigChangeOperation["Deleted"] = "DELETED";
    /** An existing guardrail was updated */
    EmployerAiAutomationsGuardrailConfigChangeOperation["Updated"] = "UPDATED";
})(EmployerAiAutomationsGuardrailConfigChangeOperation || (EmployerAiAutomationsGuardrailConfigChangeOperation = {}));
/** Reset interval for a guardrail spend cap */
export var EmployerAiAutomationsGuardrailSpendCapResetInterval;
(function (EmployerAiAutomationsGuardrailSpendCapResetInterval) {
    /** Cap applies over the lifetime of the job (legacy default) */
    EmployerAiAutomationsGuardrailSpendCapResetInterval["Lifetime"] = "LIFETIME";
    /** Cap resets each calendar month */
    EmployerAiAutomationsGuardrailSpendCapResetInterval["Monthly"] = "MONTHLY";
})(EmployerAiAutomationsGuardrailSpendCapResetInterval || (EmployerAiAutomationsGuardrailSpendCapResetInterval = {}));
/** Status of a guardrail evaluation for a job. */
export var EmployerAiAutomationsGuardrailStatus;
(function (EmployerAiAutomationsGuardrailStatus) {
    /** Guardrail limits have been breached */
    EmployerAiAutomationsGuardrailStatus["Breached"] = "BREACHED";
    /** Guardrail limits are within bounds */
    EmployerAiAutomationsGuardrailStatus["Ok"] = "OK";
})(EmployerAiAutomationsGuardrailStatus || (EmployerAiAutomationsGuardrailStatus = {}));
/** Priority tiers for OneCampaign job grouping */
export var EmployerAiAutomationsPriority;
(function (EmployerAiAutomationsPriority) {
    /** High priority tier */
    EmployerAiAutomationsPriority["High"] = "HIGH";
    /** Low priority tier */
    EmployerAiAutomationsPriority["Low"] = "LOW";
    /** Medium priority tier */
    EmployerAiAutomationsPriority["Medium"] = "MEDIUM";
})(EmployerAiAutomationsPriority || (EmployerAiAutomationsPriority = {}));
/** Types of saved view */
export var EmployerAnalyticsSavedViewType;
(function (EmployerAnalyticsSavedViewType) {
    EmployerAnalyticsSavedViewType["CentralizedAnalyticsBrandedAds"] = "CENTRALIZED_ANALYTICS_BRANDED_ADS";
    EmployerAnalyticsSavedViewType["CentralizedAnalyticsInterviews"] = "CENTRALIZED_ANALYTICS_INTERVIEWS";
    EmployerAnalyticsSavedViewType["CentralizedAnalyticsJobsDetailedReport"] = "CENTRALIZED_ANALYTICS_JOBS_DETAILED_REPORT";
    EmployerAnalyticsSavedViewType["CentralizedAnalyticsJobsSummary"] = "CENTRALIZED_ANALYTICS_JOBS_SUMMARY";
    EmployerAnalyticsSavedViewType["CentralizedAnalyticsOverview"] = "CENTRALIZED_ANALYTICS_OVERVIEW";
    EmployerAnalyticsSavedViewType["CentralizedAnalyticsSourcing"] = "CENTRALIZED_ANALYTICS_SOURCING";
})(EmployerAnalyticsSavedViewType || (EmployerAnalyticsSavedViewType = {}));
export var EmployerAppealEligibility;
(function (EmployerAppealEligibility) {
    /** Value returned when the user has gone over their limit of appeals */
    EmployerAppealEligibility["AppealLimitReached"] = "APPEAL_LIMIT_REACHED";
    /** Value returned when the user can file a new appeal */
    EmployerAppealEligibility["EligibleForAppeal"] = "ELIGIBLE_FOR_APPEAL";
    /** Value returned when the user is not eligible due to other reasons defined by moderation */
    EmployerAppealEligibility["IneligibleForAppeal"] = "INELIGIBLE_FOR_APPEAL";
})(EmployerAppealEligibility || (EmployerAppealEligibility = {}));
/** Enum of options that are possible to display to a user for appealing an employer account moderation. */
export var EmployerAppealOption;
(function (EmployerAppealOption) {
    /**
     * Option that directs user to fill out a form with additional details and documentation to appeal
     * the moderation decision that placed their account on hold. Form is translated into a Zendesk ticket
     * and further communication is done via Zendesk/email.
     */
    EmployerAppealOption["AppealRequestForm"] = "APPEAL_REQUEST_FORM";
    /**
     * Option that directs the user through corporate email OTP verification. The frontend reuses
     * the existing Verification Center corporate email flow; execution stays on VCS. Market
     * eligibility is gated by the DA_CORP_EMAIL_OPTION Rulebook rule.
     */
    EmployerAppealOption["CorporateEmail"] = "CORPORATE_EMAIL";
    /**
     * India-only option that directs user through GSTIN (tax ID) and OTP verification to prove
     * they are associated with a registered Indian business.
     */
    EmployerAppealOption["Gstin"] = "GSTIN";
    /**
     * Option that directs user through ID.me external identity verification flow to verify their identity.
     *
     * Does not validate business credentials versus verified identity, just that the identity is verified
     * and non-fraudulent.
     */
    EmployerAppealOption["IdMe"] = "ID_ME";
    /**
     * Option that directs the user through Persona identity verification. The frontend reuses
     * the existing Verification Center Persona flow; execution stays on VCS. Available in
     * legal-approved markets only — gating is enforced by the DA_PERSONA_OPTION Rulebook rule.
     */
    EmployerAppealOption["Persona"] = "PERSONA";
    /**
     * Option that lets the user request a callback from a moderator to verify their identity
     * over the phone. Reuses the existing VC_INBOUND_CALL Rulebook response from the Verification
     * Center flow.
     */
    EmployerAppealOption["RequestACall"] = "REQUEST_A_CALL";
})(EmployerAppealOption || (EmployerAppealOption = {}));
/**
 * Enum of possible variants that can alter how an appeal option is displayed or what is required.
 *
 * Display effects should be self-explanatory based on variant name; but effects will still be
 * documented in detail on each variant value.
 */
export var EmployerAppealOptionVariant;
(function (EmployerAppealOptionVariant) {
    /**
     * Appeal option variant for APPEAL_REQUEST_FORM that requires uploading documentation to enable
     * submission of the appeal request form. By default, this option does not require documentation upload.
     */
    EmployerAppealOptionVariant["DocumentUploadRequired"] = "DOCUMENT_UPLOAD_REQUIRED";
})(EmployerAppealOptionVariant || (EmployerAppealOptionVariant = {}));
/**
 * Enum of possible statuses for an employer's appeal of their account moderation.
 *
 * Will reflect if an appeal is in progress, awaiting moderator approval, succeeded, failed, etc.
 */
export var EmployerAppealStatus;
(function (EmployerAppealStatus) {
    /** Indicates that a standard appeal request form has been submitted and is pending moderator approval. */
    EmployerAppealStatus["AppealRequestFormPending"] = "APPEAL_REQUEST_FORM_PENDING";
    /** Indicates that ID.me has been completed and account settings have been updated. */
    EmployerAppealStatus["IdMeSuccessComplete"] = "ID_ME_SUCCESS_COMPLETE";
    /** Indicates ID.me has been completed but effects are not propagated through RB/other systems. */
    EmployerAppealStatus["IdMeSuccessPending"] = "ID_ME_SUCCESS_PENDING";
    /** Value returned when there is no started, pending, or completed appeal. */
    EmployerAppealStatus["NoAppealInProgress"] = "NO_APPEAL_IN_PROGRESS";
})(EmployerAppealStatus || (EmployerAppealStatus = {}));
export var EmployerAutomationProductName;
(function (EmployerAutomationProductName) {
    EmployerAutomationProductName["AutoContact"] = "AutoContact";
    EmployerAutomationProductName["AutoReply"] = "AutoReply";
    EmployerAutomationProductName["MaybeAutomation"] = "MaybeAutomation";
    EmployerAutomationProductName["NexusInterviewInvitation"] = "NexusInterviewInvitation";
    EmployerAutomationProductName["NexusInterviewInvitationBasedOnScore"] = "NexusInterviewInvitationBasedOnScore";
    EmployerAutomationProductName["NexusPartialScoreOutreach"] = "NexusPartialScoreOutreach";
    EmployerAutomationProductName["NexusPostApplyCompletedOutreach"] = "NexusPostApplyCompletedOutreach";
    EmployerAutomationProductName["NexusStrongScoreOutreach"] = "NexusStrongScoreOutreach";
    EmployerAutomationProductName["ScheduledRejection"] = "ScheduledRejection";
})(EmployerAutomationProductName || (EmployerAutomationProductName = {}));
/** Employer Automation Status */
export var EmployerAutomationStatus;
(function (EmployerAutomationStatus) {
    EmployerAutomationStatus["Disabled"] = "DISABLED";
    EmployerAutomationStatus["Enabled"] = "ENABLED";
})(EmployerAutomationStatus || (EmployerAutomationStatus = {}));
/** annual contract deal status states */
export var EmployerBillingContractDealStatus;
(function (EmployerBillingContractDealStatus) {
    EmployerBillingContractDealStatus["Active"] = "ACTIVE";
    EmployerBillingContractDealStatus["Expired"] = "EXPIRED";
    EmployerBillingContractDealStatus["Pending"] = "PENDING";
})(EmployerBillingContractDealStatus || (EmployerBillingContractDealStatus = {}));
/** annual contract deal status states for input filter */
export var EmployerBillingContractDealStatusInput;
(function (EmployerBillingContractDealStatusInput) {
    EmployerBillingContractDealStatusInput["Active"] = "ACTIVE";
    EmployerBillingContractDealStatusInput["Expired"] = "EXPIRED";
    EmployerBillingContractDealStatusInput["Pending"] = "PENDING";
})(EmployerBillingContractDealStatusInput || (EmployerBillingContractDealStatusInput = {}));
export var EmployerBusinessDocInfoError;
(function (EmployerBusinessDocInfoError) {
    EmployerBusinessDocInfoError["CriteriaUnsatisfied"] = "CRITERIA_UNSATISFIED";
    EmployerBusinessDocInfoError["DocInfoLimitReached"] = "DOC_INFO_LIMIT_REACHED";
    EmployerBusinessDocInfoError["InvalidDoc"] = "INVALID_DOC";
    EmployerBusinessDocInfoError["LegalNameNotFound"] = "LEGAL_NAME_NOT_FOUND";
    EmployerBusinessDocInfoError["PhoneNumberNotFound"] = "PHONE_NUMBER_NOT_FOUND";
})(EmployerBusinessDocInfoError || (EmployerBusinessDocInfoError = {}));
/** Type of the business document the employer is using */
export var EmployerBusinessDocType;
(function (EmployerBusinessDocType) {
    EmployerBusinessDocType["Gstin"] = "GSTIN";
})(EmployerBusinessDocType || (EmployerBusinessDocType = {}));
/** The types of feedback that can be used for filtering */
export var EmployerCandidateFeedbackTypeFilter;
(function (EmployerCandidateFeedbackTypeFilter) {
    EmployerCandidateFeedbackTypeFilter["Comment"] = "COMMENT";
    EmployerCandidateFeedbackTypeFilter["InterestLevel"] = "INTEREST_LEVEL";
})(EmployerCandidateFeedbackTypeFilter || (EmployerCandidateFeedbackTypeFilter = {}));
/**
 * Employer Candidate Interest Level
 * see also CandidateSubmissionInterestLevel,
 * which is a related enum used as input filter
 */
export var EmployerCandidateInterestLevel;
(function (EmployerCandidateInterestLevel) {
    EmployerCandidateInterestLevel["Maybe"] = "MAYBE";
    EmployerCandidateInterestLevel["No"] = "NO";
    EmployerCandidateInterestLevel["Yes"] = "YES";
})(EmployerCandidateInterestLevel || (EmployerCandidateInterestLevel = {}));
/** State of an EmployerCard */
export var EmployerCardState;
(function (EmployerCardState) {
    /** EmployerCard has been clicked through on by the user */
    EmployerCardState["Clicked"] = "CLICKED";
    /** EmployerCard is no longer visible to the user */
    EmployerCardState["Hidden"] = "HIDDEN";
    /** EmployerCard has been shown to the user */
    EmployerCardState["Seen"] = "SEEN";
    /** EmployerCard has not yet been shown to the user */
    EmployerCardState["Unseen"] = "UNSEEN";
})(EmployerCardState || (EmployerCardState = {}));
/** See IFL Tag documentation for info on tag status */
export var EmployerCardTagStatus;
(function (EmployerCardTagStatus) {
    EmployerCardTagStatus["Alert"] = "ALERT";
    EmployerCardTagStatus["Info"] = "INFO";
    EmployerCardTagStatus["Neutral"] = "NEUTRAL";
    EmployerCardTagStatus["Success"] = "SUCCESS";
    EmployerCardTagStatus["Warning"] = "WARNING";
})(EmployerCardTagStatus || (EmployerCardTagStatus = {}));
/** The type of employer click interactions of a recommended candidate/JS */
export var EmployerClickTypeInput;
(function (EmployerClickTypeInput) {
    /** Downloaded Resume */
    EmployerClickTypeInput["Download"] = "DOWNLOAD";
    /** Forwarded Resume */
    EmployerClickTypeInput["Forward"] = "FORWARD";
    /** Employer opened the invite/contact form draft for a matched candidate (form-open intent; not a completed outreach) */
    EmployerClickTypeInput["InviteDraft"] = "INVITE_DRAFT";
    /** Preview resume */
    EmployerClickTypeInput["Preview"] = "PREVIEW";
    /** Save resume */
    EmployerClickTypeInput["Save"] = "SAVE";
    /** View resume */
    EmployerClickTypeInput["ViewResume"] = "VIEW_RESUME";
})(EmployerClickTypeInput || (EmployerClickTypeInput = {}));
export var EmployerCreditCardExpirationState;
(function (EmployerCreditCardExpirationState) {
    EmployerCreditCardExpirationState["CreditCardExpired"] = "CREDIT_CARD_EXPIRED";
    EmployerCreditCardExpirationState["CreditCardNotExpired"] = "CREDIT_CARD_NOT_EXPIRED";
    EmployerCreditCardExpirationState["NoCreditCardOnFile"] = "NO_CREDIT_CARD_ON_FILE";
})(EmployerCreditCardExpirationState || (EmployerCreditCardExpirationState = {}));
export var EmployerEntityAutomationAttributeKey;
(function (EmployerEntityAutomationAttributeKey) {
    EmployerEntityAutomationAttributeKey["AutomationMergeDone"] = "AUTOMATION_MERGE_DONE";
    EmployerEntityAutomationAttributeKey["AutoContactSendExistingCandidatesNumModalShown"] = "AUTO_CONTACT_SEND_EXISTING_CANDIDATES_NUM_MODAL_SHOWN";
    EmployerEntityAutomationAttributeKey["AutoReplySendExistingCandidatesNumModalShown"] = "AUTO_REPLY_SEND_EXISTING_CANDIDATES_NUM_MODAL_SHOWN";
    EmployerEntityAutomationAttributeKey["MaybeAutomationSendExistingCandidatesNumModalShown"] = "MAYBE_AUTOMATION_SEND_EXISTING_CANDIDATES_NUM_MODAL_SHOWN";
    EmployerEntityAutomationAttributeKey["ScheduledRejectionNumModalShown"] = "SCHEDULED_REJECTION_NUM_MODAL_SHOWN";
    EmployerEntityAutomationAttributeKey["ScheduledRejectionSendExistingCandidatesNumModalShown"] = "SCHEDULED_REJECTION_SEND_EXISTING_CANDIDATES_NUM_MODAL_SHOWN";
})(EmployerEntityAutomationAttributeKey || (EmployerEntityAutomationAttributeKey = {}));
export var EmployerEntityIndustry;
(function (EmployerEntityIndustry) {
    EmployerEntityIndustry["AccountingConsulting"] = "ACCOUNTING_CONSULTING";
    EmployerEntityIndustry["AdvertisingMarketing"] = "ADVERTISING_MARKETING";
    EmployerEntityIndustry["Agriculture"] = "AGRICULTURE";
    EmployerEntityIndustry["ArtsEntertainmentRecreation"] = "ARTS_ENTERTAINMENT_RECREATION";
    EmployerEntityIndustry["Automotive"] = "AUTOMOTIVE";
    EmployerEntityIndustry["BeautyWellness"] = "BEAUTY_WELLNESS";
    EmployerEntityIndustry["ConstructionEngineering"] = "CONSTRUCTION_ENGINEERING";
    EmployerEntityIndustry["DefenseSecurity"] = "DEFENSE_SECURITY";
    EmployerEntityIndustry["Deleted"] = "DELETED";
    EmployerEntityIndustry["Education"] = "EDUCATION";
    EmployerEntityIndustry["EnergyUtilities"] = "ENERGY_UTILITIES";
    EmployerEntityIndustry["FinancialServicesBanking"] = "FINANCIAL_SERVICES_BANKING";
    EmployerEntityIndustry["FoodBeverageServices"] = "FOOD_BEVERAGE_SERVICES";
    EmployerEntityIndustry["FraudScam"] = "FRAUD_SCAM";
    EmployerEntityIndustry["GovernmentMilitary"] = "GOVERNMENT_MILITARY";
    EmployerEntityIndustry["HealthCareMedical"] = "HEALTH_CARE_MEDICAL";
    EmployerEntityIndustry["Hospitality"] = "HOSPITALITY";
    EmployerEntityIndustry["Insurance"] = "INSURANCE";
    EmployerEntityIndustry["JobBoardGeneral"] = "JOB_BOARD_GENERAL";
    EmployerEntityIndustry["JobSeeker"] = "JOB_SEEKER";
    EmployerEntityIndustry["Legal"] = "LEGAL";
    EmployerEntityIndustry["Manufacturing"] = "MANUFACTURING";
    EmployerEntityIndustry["MediaNewspaper"] = "MEDIA_NEWSPAPER";
    EmployerEntityIndustry["NonProfitAssociation"] = "NON_PROFIT_ASSOCIATION";
    EmployerEntityIndustry["Other"] = "OTHER";
    EmployerEntityIndustry["RealEstate"] = "REAL_ESTATE";
    EmployerEntityIndustry["RetailConsumerProducts"] = "RETAIL_CONSUMER_PRODUCTS";
    EmployerEntityIndustry["Spam"] = "SPAM";
    EmployerEntityIndustry["StaffingFirmGeneral"] = "STAFFING_FIRM_GENERAL";
    EmployerEntityIndustry["TechnologyInformation"] = "TECHNOLOGY_INFORMATION";
    EmployerEntityIndustry["Telecom"] = "TELECOM";
    EmployerEntityIndustry["TransportationLogistics"] = "TRANSPORTATION_LOGISTICS";
    EmployerEntityIndustry["WorkAtHome"] = "WORK_AT_HOME";
    EmployerEntityIndustry["XoSJs"] = "XO_S_JS";
})(EmployerEntityIndustry || (EmployerEntityIndustry = {}));
export var EmployerEntityType;
(function (EmployerEntityType) {
    EmployerEntityType["DirectEmployer"] = "DIRECT_EMPLOYER";
    EmployerEntityType["Indeed"] = "INDEED";
    EmployerEntityType["JobBoard"] = "JOB_BOARD";
    EmployerEntityType["None"] = "NONE";
    EmployerEntityType["Other"] = "OTHER";
    EmployerEntityType["Sandbox"] = "SANDBOX";
    EmployerEntityType["StaffingAgency"] = "STAFFING_AGENCY";
    EmployerEntityType["Test"] = "TEST";
})(EmployerEntityType || (EmployerEntityType = {}));
export var EmployerHasCreditCardInfo;
(function (EmployerHasCreditCardInfo) {
    EmployerHasCreditCardInfo["CreditCardInfoUnknown"] = "CREDIT_CARD_INFO_UNKNOWN";
    EmployerHasCreditCardInfo["HasCreditCardInfo"] = "HAS_CREDIT_CARD_INFO";
    EmployerHasCreditCardInfo["NoCreditCardInfo"] = "NO_CREDIT_CARD_INFO";
})(EmployerHasCreditCardInfo || (EmployerHasCreditCardInfo = {}));
/** Defines the possible account type for a given group */
export var EmployerHierarchyGroupType;
(function (EmployerHierarchyGroupType) {
    EmployerHierarchyGroupType["Any"] = "ANY";
    EmployerHierarchyGroupType["Franchisee"] = "FRANCHISEE";
    EmployerHierarchyGroupType["Hiring"] = "HIRING";
    EmployerHierarchyGroupType["None"] = "NONE";
    EmployerHierarchyGroupType["NonHiring"] = "NON_HIRING";
})(EmployerHierarchyGroupType || (EmployerHierarchyGroupType = {}));
/**
 * Which level of the employer hierarchy (child or root advertiser) supplied a field. This is used by any
 * field whose value is resolved via the child → root walk.
 */
export var EmployerHierarchySource;
(function (EmployerHierarchySource) {
    /** Caller's root advertiser supplied the value. */
    EmployerHierarchySource["InheritedFromRoot"] = "INHERITED_FROM_ROOT";
    /** No level supplied a value. */
    EmployerHierarchySource["None"] = "NONE";
    /** Caller's own employer record supplied the value. */
    EmployerHierarchySource["Own"] = "OWN";
})(EmployerHierarchySource || (EmployerHierarchySource = {}));
/** Defines the possible states for a given group */
export var EmployerHierarchyStatus;
(function (EmployerHierarchyStatus) {
    EmployerHierarchyStatus["Active"] = "ACTIVE";
    EmployerHierarchyStatus["Archived"] = "ARCHIVED";
    EmployerHierarchyStatus["Inactive"] = "INACTIVE";
    EmployerHierarchyStatus["None"] = "NONE";
})(EmployerHierarchyStatus || (EmployerHierarchyStatus = {}));
/** Defines the possible hierarchy type for a given group */
export var EmployerHierarchyType;
(function (EmployerHierarchyType) {
    EmployerHierarchyType["AdAgency"] = "AD_AGENCY";
    EmployerHierarchyType["BrandCorporate"] = "BRAND_CORPORATE";
    EmployerHierarchyType["BrandFranchise"] = "BRAND_FRANCHISE";
    EmployerHierarchyType["Default"] = "DEFAULT";
    EmployerHierarchyType["None"] = "NONE";
})(EmployerHierarchyType || (EmployerHierarchyType = {}));
/** Hierarchy types that can be applied to an advertiser */
export var EmployerHierarchyTypeMirrored;
(function (EmployerHierarchyTypeMirrored) {
    EmployerHierarchyTypeMirrored["AdAgency"] = "AD_AGENCY";
    EmployerHierarchyTypeMirrored["BrandCorporate"] = "BRAND_CORPORATE";
    EmployerHierarchyTypeMirrored["BrandFranchise"] = "BRAND_FRANCHISE";
    EmployerHierarchyTypeMirrored["Default"] = "DEFAULT";
    EmployerHierarchyTypeMirrored["None"] = "NONE";
})(EmployerHierarchyTypeMirrored || (EmployerHierarchyTypeMirrored = {}));
/** Reasons why a Hiring Event is Canceled. */
export var EmployerHiringEventCancelReason;
(function (EmployerHiringEventCancelReason) {
    EmployerHiringEventCancelReason["LowAttendees"] = "LOW_ATTENDEES";
    EmployerHiringEventCancelReason["NotEnoughInterviewers"] = "NOT_ENOUGH_INTERVIEWERS";
    EmployerHiringEventCancelReason["Other"] = "OTHER";
    EmployerHiringEventCancelReason["PublicHealthConcern"] = "PUBLIC_HEALTH_CONCERN";
    EmployerHiringEventCancelReason["SevereWeather"] = "SEVERE_WEATHER";
})(EmployerHiringEventCancelReason || (EmployerHiringEventCancelReason = {}));
/** Reasons why a Hiring Event is Rescheduled. */
export var EmployerHiringEventRescheduleReason;
(function (EmployerHiringEventRescheduleReason) {
    EmployerHiringEventRescheduleReason["LowAttendees"] = "LOW_ATTENDEES";
    EmployerHiringEventRescheduleReason["NotEnoughInterviewers"] = "NOT_ENOUGH_INTERVIEWERS";
    EmployerHiringEventRescheduleReason["Other"] = "OTHER";
    EmployerHiringEventRescheduleReason["PublicHealthConcern"] = "PUBLIC_HEALTH_CONCERN";
    EmployerHiringEventRescheduleReason["SevereWeather"] = "SEVERE_WEATHER";
})(EmployerHiringEventRescheduleReason || (EmployerHiringEventRescheduleReason = {}));
/** Fields that Employer Hiring Event Rsvp can be sorted by */
export var EmployerHiringEventRsvpsConnectionSortField;
(function (EmployerHiringEventRsvpsConnectionSortField) {
    EmployerHiringEventRsvpsConnectionSortField["CreatedDate"] = "CREATED_DATE";
})(EmployerHiringEventRsvpsConnectionSortField || (EmployerHiringEventRsvpsConnectionSortField = {}));
/**
 * Status filters
 * COMPLETE excludes canceled events
 * PENDING excludes manually paused events
 */
export var EmployerHiringEventStatusFilter;
(function (EmployerHiringEventStatusFilter) {
    EmployerHiringEventStatusFilter["Active"] = "ACTIVE";
    EmployerHiringEventStatusFilter["Canceled"] = "CANCELED";
    EmployerHiringEventStatusFilter["Complete"] = "COMPLETE";
    EmployerHiringEventStatusFilter["PausedManually"] = "PAUSED_MANUALLY";
    EmployerHiringEventStatusFilter["Pending"] = "PENDING";
    EmployerHiringEventStatusFilter["Scheduled"] = "SCHEDULED";
})(EmployerHiringEventStatusFilter || (EmployerHiringEventStatusFilter = {}));
/** The possible categories for a candidate submission hiring milestone */
export var EmployerHiringMilestoneCategory;
(function (EmployerHiringMilestoneCategory) {
    EmployerHiringMilestoneCategory["AwaitingResponse"] = "AWAITING_RESPONSE";
    EmployerHiringMilestoneCategory["CandidateApplied"] = "CANDIDATE_APPLIED";
    EmployerHiringMilestoneCategory["Hired"] = "HIRED";
    EmployerHiringMilestoneCategory["InitialContact"] = "INITIAL_CONTACT";
    EmployerHiringMilestoneCategory["InterviewContacted"] = "INTERVIEW_CONTACTED";
    EmployerHiringMilestoneCategory["OfferContacted"] = "OFFER_CONTACTED";
    EmployerHiringMilestoneCategory["OutreachDeclined"] = "OUTREACH_DECLINED";
    EmployerHiringMilestoneCategory["Rejected"] = "REJECTED";
    EmployerHiringMilestoneCategory["Reviewing"] = "REVIEWING";
    EmployerHiringMilestoneCategory["Sourcing"] = "SOURCING";
})(EmployerHiringMilestoneCategory || (EmployerHiringMilestoneCategory = {}));
/** The kind of integration this list will be expanded in the future as more types of integrations are supported */
export var EmployerIntegrationKind;
(function (EmployerIntegrationKind) {
    EmployerIntegrationKind["AtsSync"] = "ATS_SYNC";
})(EmployerIntegrationKind || (EmployerIntegrationKind = {}));
/** Different tier for different integration partners */
export var EmployerIntegrationTier;
(function (EmployerIntegrationTier) {
    EmployerIntegrationTier["Gold"] = "GOLD";
    EmployerIntegrationTier["None"] = "NONE";
    EmployerIntegrationTier["Platinum"] = "PLATINUM";
    EmployerIntegrationTier["Silver"] = "SILVER";
})(EmployerIntegrationTier || (EmployerIntegrationTier = {}));
/** The enum of valid interviewer roles of an Employer Participant */
export var EmployerInterviewEmployerRole;
(function (EmployerInterviewEmployerRole) {
    EmployerInterviewEmployerRole["Coordinator"] = "COORDINATOR";
    EmployerInterviewEmployerRole["Interviewer"] = "INTERVIEWER";
})(EmployerInterviewEmployerRole || (EmployerInterviewEmployerRole = {}));
/**
 * The milestones which candidate submissions are grouped into for the counts returned from EmployerJob.applicationsCount
 * and HostedJobPosts.applicationCount
 */
export var EmployerJobApplicationMilestoneType;
(function (EmployerJobApplicationMilestoneType) {
    EmployerJobApplicationMilestoneType["Hired"] = "HIRED";
    EmployerJobApplicationMilestoneType["Interviewed"] = "INTERVIEWED";
    EmployerJobApplicationMilestoneType["New"] = "NEW";
    EmployerJobApplicationMilestoneType["OfferMade"] = "OFFER_MADE";
    EmployerJobApplicationMilestoneType["Pending"] = "PENDING";
    EmployerJobApplicationMilestoneType["PhoneScreened"] = "PHONE_SCREENED";
    EmployerJobApplicationMilestoneType["Rejected"] = "REJECTED";
    EmployerJobApplicationMilestoneType["Reviewed"] = "REVIEWED";
})(EmployerJobApplicationMilestoneType || (EmployerJobApplicationMilestoneType = {}));
/** The augmentation status of the underlying indexed job for this employer job. */
export var EmployerJobAugmentationStatus;
(function (EmployerJobAugmentationStatus) {
    EmployerJobAugmentationStatus["Augmented"] = "AUGMENTED";
    EmployerJobAugmentationStatus["IsHosted"] = "IS_HOSTED";
    EmployerJobAugmentationStatus["NotAugmented"] = "NOT_AUGMENTED";
})(EmployerJobAugmentationStatus || (EmployerJobAugmentationStatus = {}));
export var EmployerJobAutomationAttributeKey;
(function (EmployerJobAutomationAttributeKey) {
    EmployerJobAutomationAttributeKey["AutoContactNumModalShown"] = "AUTO_CONTACT_NUM_MODAL_SHOWN";
    EmployerJobAutomationAttributeKey["AutoContactSendExistingCandidatesNumModalShown"] = "AUTO_CONTACT_SEND_EXISTING_CANDIDATES_NUM_MODAL_SHOWN";
    EmployerJobAutomationAttributeKey["AutoReplySendExistingCandidatesNumModalShown"] = "AUTO_REPLY_SEND_EXISTING_CANDIDATES_NUM_MODAL_SHOWN";
    EmployerJobAutomationAttributeKey["MaybeAutomationNumModalShown"] = "MAYBE_AUTOMATION_NUM_MODAL_SHOWN";
    EmployerJobAutomationAttributeKey["MaybeAutomationSendExistingCandidatesNumModalShown"] = "MAYBE_AUTOMATION_SEND_EXISTING_CANDIDATES_NUM_MODAL_SHOWN";
})(EmployerJobAutomationAttributeKey || (EmployerJobAutomationAttributeKey = {}));
/** EmployerJob level status */
export var EmployerJobBatchEditEmployerJobStatus;
(function (EmployerJobBatchEditEmployerJobStatus) {
    EmployerJobBatchEditEmployerJobStatus["Complete"] = "COMPLETE";
    EmployerJobBatchEditEmployerJobStatus["Pending"] = "PENDING";
    EmployerJobBatchEditEmployerJobStatus["PermanentError"] = "PERMANENT_ERROR";
    EmployerJobBatchEditEmployerJobStatus["RetryableError"] = "RETRYABLE_ERROR";
})(EmployerJobBatchEditEmployerJobStatus || (EmployerJobBatchEditEmployerJobStatus = {}));
/** Top level batch edit status */
export var EmployerJobBatchEditStatus;
(function (EmployerJobBatchEditStatus) {
    EmployerJobBatchEditStatus["Complete"] = "COMPLETE";
    EmployerJobBatchEditStatus["Pending"] = "PENDING";
    EmployerJobBatchEditStatus["PermanentError"] = "PERMANENT_ERROR";
    EmployerJobBatchEditStatus["RetryableError"] = "RETRYABLE_ERROR";
})(EmployerJobBatchEditStatus || (EmployerJobBatchEditStatus = {}));
/** Fields and Order by which campaigns can be sorted. */
export var EmployerJobCampaignsConnectionSort;
(function (EmployerJobCampaignsConnectionSort) {
    EmployerJobCampaignsConnectionSort["CreatedDatetimeAsc"] = "CREATED_DATETIME_ASC";
    EmployerJobCampaignsConnectionSort["CreatedDatetimeDesc"] = "CREATED_DATETIME_DESC";
    EmployerJobCampaignsConnectionSort["NameAsc"] = "NAME_ASC";
    EmployerJobCampaignsConnectionSort["NameDesc"] = "NAME_DESC";
    EmployerJobCampaignsConnectionSort["UpdatedDatetimeAsc"] = "UPDATED_DATETIME_ASC";
    EmployerJobCampaignsConnectionSort["UpdatedDatetimeDesc"] = "UPDATED_DATETIME_DESC";
})(EmployerJobCampaignsConnectionSort || (EmployerJobCampaignsConnectionSort = {}));
/** These are the possible claim statuses for claimed jobs */
export var EmployerJobClaimStatus;
(function (EmployerJobClaimStatus) {
    /** Indicates that the job is currently claimed */
    EmployerJobClaimStatus["Claimed"] = "Claimed";
    /** Indicates that the job has been un-claimed */
    EmployerJobClaimStatus["Unclaimed"] = "Unclaimed";
})(EmployerJobClaimStatus || (EmployerJobClaimStatus = {}));
/** These are the versions of job claiming */
export var EmployerJobClaimVersion;
(function (EmployerJobClaimVersion) {
    /** Indicates that the job was claimed using V1 claiming */
    EmployerJobClaimVersion["V1"] = "V1";
    /** Indicates that the job was claimed using V2 claiming */
    EmployerJobClaimVersion["V2"] = "V2";
})(EmployerJobClaimVersion || (EmployerJobClaimVersion = {}));
/** Enum representing the different permissions that Employers can filter their EmployerJobs on. */
export var EmployerJobFineGrainedPermission;
(function (EmployerJobFineGrainedPermission) {
    EmployerJobFineGrainedPermission["CanReadScreeningCriteria"] = "CAN_READ_SCREENING_CRITERIA";
    EmployerJobFineGrainedPermission["ReadCandidates"] = "READ_CANDIDATES";
})(EmployerJobFineGrainedPermission || (EmployerJobFineGrainedPermission = {}));
export var EmployerJobGroupType;
(function (EmployerJobGroupType) {
    EmployerJobGroupType["List"] = "LIST";
    EmployerJobGroupType["Star"] = "STAR";
})(EmployerJobGroupType || (EmployerJobGroupType = {}));
/** The reason for the hiring advice dismissal. */
export var EmployerJobHiringAdviceDismissReason;
(function (EmployerJobHiringAdviceDismissReason) {
    EmployerJobHiringAdviceDismissReason["DoesNotFitHiringPolicy"] = "DOES_NOT_FIT_HIRING_POLICY";
    EmployerJobHiringAdviceDismissReason["DontAgreeWith"] = "DONT_AGREE_WITH";
    EmployerJobHiringAdviceDismissReason["DontWant"] = "DONT_WANT";
    EmployerJobHiringAdviceDismissReason["NotAuthorizedToMakeChange"] = "NOT_AUTHORIZED_TO_MAKE_CHANGE";
    EmployerJobHiringAdviceDismissReason["Other"] = "OTHER";
})(EmployerJobHiringAdviceDismissReason || (EmployerJobHiringAdviceDismissReason = {}));
/** The type of the employer hiring advice. */
export var EmployerJobHiringAdviceType;
(function (EmployerJobHiringAdviceType) {
    EmployerJobHiringAdviceType["AddPhoneNumber"] = "ADD_PHONE_NUMBER";
    EmployerJobHiringAdviceType["AddPhotos"] = "ADD_PHOTOS";
    EmployerJobHiringAdviceType["AddSjdAdditionalLocation"] = "ADD_SJD_ADDITIONAL_LOCATION";
    EmployerJobHiringAdviceType["AddSjdBenefits"] = "ADD_SJD_BENEFITS";
    EmployerJobHiringAdviceType["AddSjdCommuteInfo"] = "ADD_SJD_COMMUTE_INFO";
    EmployerJobHiringAdviceType["AddSjdEmployerMessage"] = "ADD_SJD_EMPLOYER_MESSAGE";
    EmployerJobHiringAdviceType["AddSjdHolidays"] = "ADD_SJD_HOLIDAYS";
    EmployerJobHiringAdviceType["AddSjdPay"] = "ADD_SJD_PAY";
    EmployerJobHiringAdviceType["AddSjdQualifications"] = "ADD_SJD_QUALIFICATIONS";
    EmployerJobHiringAdviceType["AddSjdShift"] = "ADD_SJD_SHIFT";
    EmployerJobHiringAdviceType["AddStreetAddress"] = "ADD_STREET_ADDRESS";
    EmployerJobHiringAdviceType["Responsiveness"] = "RESPONSIVENESS";
    EmployerJobHiringAdviceType["ResponsivenessNoPermission"] = "RESPONSIVENESS_NO_PERMISSION";
    EmployerJobHiringAdviceType["Sponsorship"] = "SPONSORSHIP";
})(EmployerJobHiringAdviceType || (EmployerJobHiringAdviceType = {}));
export var EmployerJobSourceClaimStatus;
(function (EmployerJobSourceClaimStatus) {
    EmployerJobSourceClaimStatus["Pending"] = "PENDING";
    EmployerJobSourceClaimStatus["Rejected"] = "REJECTED";
    EmployerJobSourceClaimStatus["Verified"] = "VERIFIED";
    EmployerJobSourceClaimStatus["Verifiednotactive"] = "VERIFIEDNOTACTIVE";
})(EmployerJobSourceClaimStatus || (EmployerJobSourceClaimStatus = {}));
/** Defines the job status state for the job */
export var EmployerJobStatusState;
(function (EmployerJobStatusState) {
    EmployerJobStatusState["Closed"] = "CLOSED";
    EmployerJobStatusState["Open"] = "OPEN";
    EmployerJobStatusState["Unknown"] = "UNKNOWN";
})(EmployerJobStatusState || (EmployerJobStatusState = {}));
export var EmployerLegacyBillingState;
(function (EmployerLegacyBillingState) {
    EmployerLegacyBillingState["AwaitingAuthorization"] = "AWAITING_AUTHORIZATION";
    EmployerLegacyBillingState["BillingApproved"] = "BILLING_APPROVED";
    EmployerLegacyBillingState["BillingDisabled"] = "BILLING_DISABLED";
})(EmployerLegacyBillingState || (EmployerLegacyBillingState = {}));
export var EmployerLegacyCreditCardType;
(function (EmployerLegacyCreditCardType) {
    EmployerLegacyCreditCardType["CcAmex"] = "CC_AMEX";
    EmployerLegacyCreditCardType["CcDiners"] = "CC_DINERS";
    EmployerLegacyCreditCardType["CcDiscover"] = "CC_DISCOVER";
    EmployerLegacyCreditCardType["CcJcb"] = "CC_JCB";
    EmployerLegacyCreditCardType["CcMastercard"] = "CC_MASTERCARD";
    EmployerLegacyCreditCardType["CcNone"] = "CC_NONE";
    EmployerLegacyCreditCardType["CcVisa"] = "CC_VISA";
})(EmployerLegacyCreditCardType || (EmployerLegacyCreditCardType = {}));
export var EmployerLegacyPaymentMethod;
(function (EmployerLegacyPaymentMethod) {
    EmployerLegacyPaymentMethod["Credits"] = "CREDITS";
    EmployerLegacyPaymentMethod["Manual"] = "MANUAL";
    EmployerLegacyPaymentMethod["PostpayCc"] = "POSTPAY_CC";
    EmployerLegacyPaymentMethod["PostpayInvoice"] = "POSTPAY_INVOICE";
    EmployerLegacyPaymentMethod["PostpayIo"] = "POSTPAY_IO";
    EmployerLegacyPaymentMethod["PrepayInvoice"] = "PREPAY_INVOICE";
})(EmployerLegacyPaymentMethod || (EmployerLegacyPaymentMethod = {}));
export var EmployerLegacyTerms;
(function (EmployerLegacyTerms) {
    EmployerLegacyTerms["DueUponReceipt"] = "DUE_UPON_RECEIPT";
    EmployerLegacyTerms["Net_15"] = "NET_15";
    EmployerLegacyTerms["Net_30"] = "NET_30";
    EmployerLegacyTerms["Net_45"] = "NET_45";
    EmployerLegacyTerms["Net_60"] = "NET_60";
    EmployerLegacyTerms["Net_90"] = "NET_90";
})(EmployerLegacyTerms || (EmployerLegacyTerms = {}));
/** Various link priorities for an EmployerNotificationCtaLink */
export var EmployerNotificationCtaLinkPriority;
(function (EmployerNotificationCtaLinkPriority) {
    /** CTA link is clickable on the notification card itself */
    EmployerNotificationCtaLinkPriority["Background"] = "BACKGROUND";
    /** CTA link is clickable via the Indeed Primary styled button on the notification card */
    EmployerNotificationCtaLinkPriority["Primary"] = "PRIMARY";
    /** CTA link is clickable via the Indeed Secondary styled button on the notification card */
    EmployerNotificationCtaLinkPriority["Secondary"] = "SECONDARY";
    /** CTA link is clickable via the Indeed Tertiary styled button on the notification card */
    EmployerNotificationCtaLinkPriority["Tertiary"] = "TERTIARY";
    /** CTA link is clickable via the Indeed Text styled button on the notification card */
    EmployerNotificationCtaLinkPriority["Text"] = "TEXT";
})(EmployerNotificationCtaLinkPriority || (EmployerNotificationCtaLinkPriority = {}));
/** Link targets for an EmployerNotificationCtaLink */
export var EmployerNotificationCtaLinkTarget;
(function (EmployerNotificationCtaLinkTarget) {
    /** Open CTA link in a new tab */
    EmployerNotificationCtaLinkTarget["Blank"] = "BLANK";
    /** Trigger a direct action via CTA link (no active campaign usage in yet) */
    EmployerNotificationCtaLinkTarget["Direct"] = "DIRECT";
    /** Trigger a download action via CTA link (no active campaign usage in yet) */
    EmployerNotificationCtaLinkTarget["Download"] = "DOWNLOAD";
    /** Open CTA link in the same tab */
    EmployerNotificationCtaLinkTarget["Self"] = "SELF";
})(EmployerNotificationCtaLinkTarget || (EmployerNotificationCtaLinkTarget = {}));
/** Icon to represent an EmployerNotification */
export var EmployerNotificationIcon;
(function (EmployerNotificationIcon) {
    EmployerNotificationIcon["Analytics"] = "ANALYTICS";
    EmployerNotificationIcon["Ban"] = "BAN";
    EmployerNotificationIcon["Billing"] = "BILLING";
    EmployerNotificationIcon["Calendar"] = "CALENDAR";
    EmployerNotificationIcon["Campaigns"] = "CAMPAIGNS";
    EmployerNotificationIcon["Candidates"] = "CANDIDATES";
    EmployerNotificationIcon["Chat"] = "CHAT";
    EmployerNotificationIcon["Check"] = "CHECK";
    EmployerNotificationIcon["Clock"] = "CLOCK";
    EmployerNotificationIcon["Company"] = "COMPANY";
    EmployerNotificationIcon["Discover"] = "DISCOVER";
    EmployerNotificationIcon["FileImage"] = "FILE_IMAGE";
    EmployerNotificationIcon["HomeInterview"] = "HOME_INTERVIEW";
    EmployerNotificationIcon["Interview"] = "INTERVIEW";
    EmployerNotificationIcon["Jobs"] = "JOBS";
    EmployerNotificationIcon["Lock"] = "LOCK";
    EmployerNotificationIcon["PersonSearch"] = "PERSON_SEARCH";
    EmployerNotificationIcon["Resources"] = "RESOURCES";
    EmployerNotificationIcon["Responsive"] = "RESPONSIVE";
    EmployerNotificationIcon["Warning"] = "WARNING";
})(EmployerNotificationIcon || (EmployerNotificationIcon = {}));
/** Input for the EmployerNotificationRecipientType enum */
export var EmployerNotificationRecipientType;
(function (EmployerNotificationRecipientType) {
    /** The notification recipient type is a console user */
    EmployerNotificationRecipientType["ConsolePlatform"] = "CONSOLE_PLATFORM";
    /** The notification recipient type is an employer */
    EmployerNotificationRecipientType["Employer"] = "EMPLOYER";
})(EmployerNotificationRecipientType || (EmployerNotificationRecipientType = {}));
/** State of an EmployerNotification */
export var EmployerNotificationState;
(function (EmployerNotificationState) {
    /** Notification is no longer visible to the user */
    EmployerNotificationState["Hidden"] = "HIDDEN";
    /** Notification has been interacted with or marked as read by the user */
    EmployerNotificationState["Read"] = "READ";
    /**
     * Notification has been displayed to the user in the notification area,
     * but has not yet been interacted with
     */
    EmployerNotificationState["Unread"] = "UNREAD";
    /**
     * Notification content has not yet been shown to the user in the notification
     * area
     */
    EmployerNotificationState["Unseen"] = "UNSEEN";
})(EmployerNotificationState || (EmployerNotificationState = {}));
/** Entity types that can receive opportunities */
export var EmployerOpportunityEntityType;
(function (EmployerOpportunityEntityType) {
    EmployerOpportunityEntityType["Campaign"] = "CAMPAIGN";
    EmployerOpportunityEntityType["Job"] = "JOB";
})(EmployerOpportunityEntityType || (EmployerOpportunityEntityType = {}));
/** Supported opportunity types in evo-conversions */
export var EmployerOpportunityType;
(function (EmployerOpportunityType) {
    EmployerOpportunityType["BudgetTierFreepostToSponsor"] = "BUDGET_TIER_FREEPOST_TO_SPONSOR";
    EmployerOpportunityType["BudgetTierSponsorToPremium"] = "BUDGET_TIER_SPONSOR_TO_PREMIUM";
    EmployerOpportunityType["BudgetTierSponsorToPremiumPlus"] = "BUDGET_TIER_SPONSOR_TO_PREMIUM_PLUS";
    EmployerOpportunityType["BudgetTierSponsorToStandard"] = "BUDGET_TIER_SPONSOR_TO_STANDARD";
    EmployerOpportunityType["CompanyPage"] = "COMPANY_PAGE";
    EmployerOpportunityType["CreditCardDeclined"] = "CREDIT_CARD_DECLINED";
    EmployerOpportunityType["EmployerAutomations"] = "EMPLOYER_AUTOMATIONS";
    EmployerOpportunityType["HostedJobLocation"] = "HOSTED_JOB_LOCATION";
    EmployerOpportunityType["HostedJobSalary"] = "HOSTED_JOB_SALARY";
    EmployerOpportunityType["Interview"] = "INTERVIEW";
    EmployerOpportunityType["IoStopped"] = "IO_STOPPED";
    EmployerOpportunityType["ItemizedBilling"] = "ITEMIZED_BILLING";
    EmployerOpportunityType["MobileApp"] = "MOBILE_APP";
    EmployerOpportunityType["NowhereJob"] = "NOWHERE_JOB";
    EmployerOpportunityType["ScreenerQuestions"] = "SCREENER_QUESTIONS";
    EmployerOpportunityType["SmartSourcing"] = "SMART_SOURCING";
    EmployerOpportunityType["SponsorHostedJob"] = "SPONSOR_HOSTED_JOB";
})(EmployerOpportunityType || (EmployerOpportunityType = {}));
/** Visibility statuses for opportunities */
export var EmployerOpportunityVisibility;
(function (EmployerOpportunityVisibility) {
    /**  The user has acknowledged the opportunity as having been completed through manual actions  */
    EmployerOpportunityVisibility["Completed"] = "COMPLETED";
    /**  The user has dismissed the opportunity as not relevant or not of interest  */
    EmployerOpportunityVisibility["Ignored"] = "IGNORED";
    /**  The user has not overridden the visibility of the opportunity  */
    EmployerOpportunityVisibility["Visible"] = "VISIBLE";
})(EmployerOpportunityVisibility || (EmployerOpportunityVisibility = {}));
/** Status of an employer entity tag */
export var EmployerOrganizationTagStatus;
(function (EmployerOrganizationTagStatus) {
    EmployerOrganizationTagStatus["Active"] = "ACTIVE";
    EmployerOrganizationTagStatus["Archived"] = "ARCHIVED";
})(EmployerOrganizationTagStatus || (EmployerOrganizationTagStatus = {}));
/** Defines the possible hierarchy type for a given org unit */
export var EmployerOrganizationalUnitHierarchyType;
(function (EmployerOrganizationalUnitHierarchyType) {
    /** An advertising agency hierarchy that manages campaigns on behalf of other employers. */
    EmployerOrganizationalUnitHierarchyType["AdAgency"] = "AD_AGENCY";
    /** A corporate brand hierarchy (e.g. Qdoba) where leaf nodes are corporate-owned locations. */
    EmployerOrganizationalUnitHierarchyType["BrandCorporate"] = "BRAND_CORPORATE";
    /** A franchise brand hierarchy (e.g. Subway) where leaf nodes (franchisees) operate independently. */
    EmployerOrganizationalUnitHierarchyType["BrandFranchise"] = "BRAND_FRANCHISE";
    /** A standard employer hierarchy with no special handling. */
    EmployerOrganizationalUnitHierarchyType["Default"] = "DEFAULT";
    /** Indicates that the employer org unit is invalid or does not have a valid hierarchy type set. */
    EmployerOrganizationalUnitHierarchyType["None"] = "NONE";
})(EmployerOrganizationalUnitHierarchyType || (EmployerOrganizationalUnitHierarchyType = {}));
/** Defines the possible states for a an organizational unit */
export var EmployerOrganizationalUnitStatus;
(function (EmployerOrganizationalUnitStatus) {
    EmployerOrganizationalUnitStatus["Active"] = "ACTIVE";
    EmployerOrganizationalUnitStatus["Archived"] = "ARCHIVED";
    EmployerOrganizationalUnitStatus["Inactive"] = "INACTIVE";
    EmployerOrganizationalUnitStatus["None"] = "NONE";
})(EmployerOrganizationalUnitStatus || (EmployerOrganizationalUnitStatus = {}));
/**  ResultCode for completeSignup mutation   */
export var EmployerSignupCompleteSignupResultCode;
(function (EmployerSignupCompleteSignupResultCode) {
    /**  User was already associated with the requested advertiser  */
    EmployerSignupCompleteSignupResultCode["AlreadyAssociated"] = "AlreadyAssociated";
    /**  User is added as secondary user on the requested advertiser  */
    EmployerSignupCompleteSignupResultCode["ApprovedAsSecondary"] = "ApprovedAsSecondary";
    /**  Request has been sent to the admin of the requested advertiser  */
    EmployerSignupCompleteSignupResultCode["RequestSent"] = "RequestSent";
})(EmployerSignupCompleteSignupResultCode || (EmployerSignupCompleteSignupResultCode = {}));
/** Type indicating how should signup be performed (joinGroup or createSubGroup) */
export var EmployerSignupCompleteSignupType;
(function (EmployerSignupCompleteSignupType) {
    /**  If the new user wants to create a new group  */
    EmployerSignupCompleteSignupType["CreateSubGroup"] = "CreateSubGroup";
    /**  If the new user wants to join the existing group  */
    EmployerSignupCompleteSignupType["JoinGroup"] = "JoinGroup";
})(EmployerSignupCompleteSignupType || (EmployerSignupCompleteSignupType = {}));
/**  Rules by which the new users should signup  */
export var EmployerSignupRuleName;
(function (EmployerSignupRuleName) {
    /**  When user signs up and if the user’s email domain matches EmployerCustomInviteLink.employerEmailDomains and user verifies the email, then add them as secondary  */
    EmployerSignupRuleName["AutoApproveWhenEmailDomainMatchesAndVerified"] = "AutoApprove_WhenEmailDomainMatchesAndVerified";
    /**  When user signs up, then send the request to the advertiser for approval  */
    EmployerSignupRuleName["SendRequestAlways"] = "SendRequest_Always";
})(EmployerSignupRuleName || (EmployerSignupRuleName = {}));
/**  status of the user related to signup through the custom-invite-link for given operation  */
export var EmployerSignupStatus;
(function (EmployerSignupStatus) {
    /**  User was already associated with the admin of the custom-invite-link  */
    EmployerSignupStatus["AlreadyAssociated"] = "AlreadyAssociated";
    /**  User has no relation to the admin of the custom-invite-link  */
    EmployerSignupStatus["Default"] = "Default";
    /**  Request has been denied by the admin of the custom-invite-link  */
    EmployerSignupStatus["RequestDenied"] = "RequestDenied";
    /**  Request has been sent to the admin of the custom-invite-link and is pending approval  */
    EmployerSignupStatus["RequestPending"] = "RequestPending";
})(EmployerSignupStatus || (EmployerSignupStatus = {}));
export var EmployerTier;
(function (EmployerTier) {
    /** This is an enterprise company, being granted all things enterprise-y */
    EmployerTier["Enterprise"] = "ENTERPRISE";
    /** The company is in the free tier */
    EmployerTier["Free"] = "FREE";
    /** The company with no specific tier */
    EmployerTier["Unspecified"] = "UNSPECIFIED";
})(EmployerTier || (EmployerTier = {}));
/** Employer type (used in Japanese market). */
export var EmployerType;
(function (EmployerType) {
    /**
     * Juridical Person
     *
     * 企業区分:法人
     * - 公法人 (地方公共団体, 独立行政法人, 特殊法人)
     * - 私法人 (非営利法人, 営利法人)
     */
    EmployerType["JuridicalPerson"] = "JURIDICAL_PERSON";
    /**
     * An individual that is operating a business without registration as a corporation.
     * 個人は法人としての届け出を行わず事業を行っているところ
     */
    EmployerType["NaturalPerson"] = "NATURAL_PERSON";
    /**
     * Other uncategorized entity that isn't registered as a corporation. Entity who can't issue the taxid should use this employer type.
     * 個人事業者を除く民法上の組合, ㈲事業責任組合など. 法人番号を発行できない組織はこちらを選択ください
     */
    EmployerType["Other"] = "OTHER";
})(EmployerType || (EmployerType = {}));
export var EmployerUserAccessRequestActionTakenFrom;
(function (EmployerUserAccessRequestActionTakenFrom) {
    EmployerUserAccessRequestActionTakenFrom["Email"] = "EMAIL";
    EmployerUserAccessRequestActionTakenFrom["Notification"] = "NOTIFICATION";
    EmployerUserAccessRequestActionTakenFrom["UsersPage"] = "USERS_PAGE";
})(EmployerUserAccessRequestActionTakenFrom || (EmployerUserAccessRequestActionTakenFrom = {}));
export var EmployerUserAccessRequestStatus;
(function (EmployerUserAccessRequestStatus) {
    EmployerUserAccessRequestStatus["Denied"] = "DENIED";
    EmployerUserAccessRequestStatus["Queued"] = "QUEUED";
})(EmployerUserAccessRequestStatus || (EmployerUserAccessRequestStatus = {}));
export var EmployerUserAccessRequestType;
(function (EmployerUserAccessRequestType) {
    EmployerUserAccessRequestType["AdditionalAccess"] = "ADDITIONAL_ACCESS";
    EmployerUserAccessRequestType["NewUser"] = "NEW_USER";
})(EmployerUserAccessRequestType || (EmployerUserAccessRequestType = {}));
/** List of supported product tour component names */
export var EmployerUserCandidateSourcingProductTourComponentName;
(function (EmployerUserCandidateSourcingProductTourComponentName) {
    /** Determine which welcome modal to show based on job sponsorship for potential upsell. Possible values are 'CREATED_BUNDLE_SUBSCRIPTION' and 'MODIFIED_SUBSCRIPTION_FOR_BUNDLE' */
    EmployerUserCandidateSourcingProductTourComponentName["NewSourcingBundleStatus"] = "NEW_SOURCING_BUNDLE_STATUS";
    /** Determines whether to display the natural language search onboarding popup. Possible values are 'SHOW' or 'HIDE'. */
    EmployerUserCandidateSourcingProductTourComponentName["NlSearchOnboardingPopup"] = "NL_SEARCH_ONBOARDING_POPUP";
    /** Determines whether to display the natural language SERP warning popup for MULTI_LOCATION error. Possible values are 'SHOW' or 'HIDE'. */
    EmployerUserCandidateSourcingProductTourComponentName["NlSerpWarningMultiLocation"] = "NL_SERP_WARNING_MULTI_LOCATION";
    /** Determines whether to display the natural language SERP warning popup for NO_LOCATION error. Possible values are 'SHOW' or 'HIDE'. */
    EmployerUserCandidateSourcingProductTourComponentName["NlSerpWarningNoLocation"] = "NL_SERP_WARNING_NO_LOCATION";
    /** Determines whether to display the natural language SERP warning popup for QUERY_TYPE_MISMATCH error. Possible values are 'SHOW' or 'HIDE'. */
    EmployerUserCandidateSourcingProductTourComponentName["NlSerpWarningQueryTypeMismatch"] = "NL_SERP_WARNING_QUERY_TYPE_MISMATCH";
    /** Timestamp for when post-contact job nudge was last dismissed. Possible values are null or a timestamp */
    EmployerUserCandidateSourcingProductTourComponentName["PostContactJobNudge"] = "POST_CONTACT_JOB_NUDGE";
    /** Whether or not to show the premium invited introduction popup. Possible values are 'SHOW' and 'HIDE' */
    EmployerUserCandidateSourcingProductTourComponentName["PremiumInvitedIntroductionPopup"] = "PREMIUM_INVITED_INTRODUCTION_POPUP";
    /** Determines where to display the premium invite goal first contact popover. Possible values are 'DO_NOT_SHOW' or null. */
    EmployerUserCandidateSourcingProductTourComponentName["PremiumInviteGoalFirstContactPopover"] = "PREMIUM_INVITE_GOAL_FIRST_CONTACT_POPOVER";
    /** Determines whether to display the premium invite goal modal. Possible values are 'DO_NOT_SHOW' or null. */
    EmployerUserCandidateSourcingProductTourComponentName["PremiumInviteGoalModal"] = "PREMIUM_INVITE_GOAL_MODAL";
    /** Determine whether or not to collapse premium preview surface in candidate management page. Possible values are 'EXPAND' and 'COLLAPSE' */
    EmployerUserCandidateSourcingProductTourComponentName["PremiumPreviewCollapseStatus"] = "PREMIUM_PREVIEW_COLLAPSE_STATUS";
    /** Determines whether to display the Quick Contact form in confirmation mode. Possible values are 'DO_NOT_SHOW' or null. */
    EmployerUserCandidateSourcingProductTourComponentName["QuickContactConfirmation"] = "QUICK_CONTACT_CONFIRMATION";
    /** Determines whether to display the promo modal for Quick Contact. Possible values are timestamp to denote the last time the user dismissed the modal and 'DO_NOT_SHOW', which means do not show the modal again for the user */
    EmployerUserCandidateSourcingProductTourComponentName["QuickContactIntervention"] = "QUICK_CONTACT_INTERVENTION";
    /** Deprecated, experiment underperformed */
    EmployerUserCandidateSourcingProductTourComponentName["SourcingOnboardingProgressBar"] = "SOURCING_ONBOARDING_PROGRESS_BAR";
    /** Determines whether to display the unified search popup. Possible values are 'SHOW' or 'HIDE'. */
    EmployerUserCandidateSourcingProductTourComponentName["UnifiedSearchPopup"] = "UNIFIED_SEARCH_POPUP";
    /** Whether or not to show the 'Welcome to Smart Sourcing' entry page.  Possible values are 'SHOW' and 'HIDE' */
    EmployerUserCandidateSourcingProductTourComponentName["WelcomeToSmartSourcingEntryPage"] = "WELCOME_TO_SMART_SOURCING_ENTRY_PAGE";
    /** Whether or not to show the 'Welcome to Smart Sourcing' modal.  Possible values are 'SHOW' and 'HIDE' */
    EmployerUserCandidateSourcingProductTourComponentName["WelcomeToSmartSourcingModal"] = "WELCOME_TO_SMART_SOURCING_MODAL";
    EmployerUserCandidateSourcingProductTourComponentName["WelcomeToSmartSourcingModalV2"] = "WELCOME_TO_SMART_SOURCING_MODAL_V2";
})(EmployerUserCandidateSourcingProductTourComponentName || (EmployerUserCandidateSourcingProductTourComponentName = {}));
export var EmployerUserErrorCode;
(function (EmployerUserErrorCode) {
    EmployerUserErrorCode["BadUserInput"] = "BAD_USER_INPUT";
    EmployerUserErrorCode["Forbidden"] = "FORBIDDEN";
    EmployerUserErrorCode["InternalServerError"] = "INTERNAL_SERVER_ERROR";
    EmployerUserErrorCode["RateLimited"] = "RATE_LIMITED";
})(EmployerUserErrorCode || (EmployerUserErrorCode = {}));
/** Hiring responsibilities for an EmployerUser */
export var EmployerUserHiringResponsibility;
(function (EmployerUserHiringResponsibility) {
    /** Advertising jobs from career site */
    EmployerUserHiringResponsibility["AdvertiseJobs"] = "ADVERTISE_JOBS";
    /** Collaborating with a team */
    EmployerUserHiringResponsibility["Collaborate"] = "COLLABORATE";
    /** Evaluating candidates */
    EmployerUserHiringResponsibility["EvaluateCandidates"] = "EVALUATE_CANDIDATES";
    /** Finding candidates */
    EmployerUserHiringResponsibility["FindingCandidates"] = "FINDING_CANDIDATES";
    /** Making final hiring decision */
    EmployerUserHiringResponsibility["HiringDecision"] = "HIRING_DECISION";
    /** Scheduling or conducting interviews */
    EmployerUserHiringResponsibility["Interview"] = "INTERVIEW";
    /** Managing payment */
    EmployerUserHiringResponsibility["ManagePayments"] = "MANAGE_PAYMENTS";
    /** Optimizing job performance */
    EmployerUserHiringResponsibility["OptimizeJobs"] = "OPTIMIZE_JOBS";
    /** Posting jobs from scratch */
    EmployerUserHiringResponsibility["PostJobs"] = "POST_JOBS";
})(EmployerUserHiringResponsibility || (EmployerUserHiringResponsibility = {}));
/** Hiring roles for an EmployerUser */
export var EmployerUserHiringRole;
(function (EmployerUserHiringRole) {
    EmployerUserHiringRole["Assistant"] = "ASSISTANT";
    EmployerUserHiringRole["Ceo"] = "CEO";
    EmployerUserHiringRole["HiringManager"] = "HIRING_MANAGER";
    EmployerUserHiringRole["HumanResources"] = "HUMAN_RESOURCES";
    EmployerUserHiringRole["NotSpecified"] = "NOT_SPECIFIED";
    EmployerUserHiringRole["OfficeManager"] = "OFFICE_MANAGER";
    EmployerUserHiringRole["Other"] = "OTHER";
    EmployerUserHiringRole["Owner"] = "OWNER";
    /** Rather not say */
    EmployerUserHiringRole["RatherNotSay"] = "RATHER_NOT_SAY";
    EmployerUserHiringRole["Recruiter"] = "RECRUITER";
    /** Systems administrator/IT */
    EmployerUserHiringRole["SystemAdministratorIt"] = "SYSTEM_ADMINISTRATOR_IT";
    EmployerUserHiringRole["TalentAcquisition"] = "TALENT_ACQUISITION";
})(EmployerUserHiringRole || (EmployerUserHiringRole = {}));
/**
 * For PAC Internal use
 *
 * Admins can see whether the invitation for a user was processing, pending response, or has
 * been declined
 */
export var EmployerUserInvitationStatus;
(function (EmployerUserInvitationStatus) {
    /** Invitee declined the invitation */
    EmployerUserInvitationStatus["Declined"] = "DECLINED";
    /** Email could not be sent due to an error */
    EmployerUserInvitationStatus["Error"] = "ERROR";
    /** Email has not yet been sent to the invitee */
    EmployerUserInvitationStatus["Queued"] = "QUEUED";
    /** Email has been sent, but invitee has not taken action */
    EmployerUserInvitationStatus["Sent"] = "SENT";
})(EmployerUserInvitationStatus || (EmployerUserInvitationStatus = {}));
/** Object types currently supported by FGP */
export var EmployerUserPermissionsObjectType;
(function (EmployerUserPermissionsObjectType) {
    EmployerUserPermissionsObjectType["Advertiser"] = "ADVERTISER";
    EmployerUserPermissionsObjectType["Candidate"] = "CANDIDATE";
    EmployerUserPermissionsObjectType["CandidateSubmission"] = "CANDIDATE_SUBMISSION";
    EmployerUserPermissionsObjectType["EmployerJob"] = "EMPLOYER_JOB";
    EmployerUserPermissionsObjectType["EmployerUser"] = "EMPLOYER_USER";
    EmployerUserPermissionsObjectType["User"] = "USER";
})(EmployerUserPermissionsObjectType || (EmployerUserPermissionsObjectType = {}));
/** Possible relations between FGP objects */
export var EmployerUserPermissionsRelationType;
(function (EmployerUserPermissionsRelationType) {
    EmployerUserPermissionsRelationType["Advertiser"] = "ADVERTISER";
    EmployerUserPermissionsRelationType["AssociatedWith"] = "ASSOCIATED_WITH";
    EmployerUserPermissionsRelationType["CandidacyDataOf"] = "CANDIDACY_DATA_OF";
    EmployerUserPermissionsRelationType["Deleter"] = "DELETER";
    EmployerUserPermissionsRelationType["NexusReader"] = "NEXUS_READER";
    EmployerUserPermissionsRelationType["NexusUpdater"] = "NEXUS_UPDATER";
    EmployerUserPermissionsRelationType["Reader"] = "READER";
    EmployerUserPermissionsRelationType["ReaderOfCandidates"] = "READER_OF_CANDIDATES";
    EmployerUserPermissionsRelationType["Updater"] = "UPDATER";
    EmployerUserPermissionsRelationType["UpdaterOfCandidates"] = "UPDATER_OF_CANDIDATES";
    EmployerUserPermissionsRelationType["User"] = "USER";
})(EmployerUserPermissionsRelationType || (EmployerUserPermissionsRelationType = {}));
/** Possible permissions that a user can have on an object */
export var EmployerUserPermissionsType;
(function (EmployerUserPermissionsType) {
    EmployerUserPermissionsType["CanReadCandidateProfile"] = "CAN_READ_CANDIDATE_PROFILE";
    EmployerUserPermissionsType["CanReadScreeningCriteria"] = "CAN_READ_SCREENING_CRITERIA";
    EmployerUserPermissionsType["CanUpdateScreeningCriteria"] = "CAN_UPDATE_SCREENING_CRITERIA";
    EmployerUserPermissionsType["Delete"] = "DELETE";
    EmployerUserPermissionsType["Read"] = "READ";
    EmployerUserPermissionsType["ReadCandidates"] = "READ_CANDIDATES";
    EmployerUserPermissionsType["Update"] = "UPDATE";
    EmployerUserPermissionsType["UpdateCandidates"] = "UPDATE_CANDIDATES";
})(EmployerUserPermissionsType || (EmployerUserPermissionsType = {}));
export var EmployerUserSubErrorCode;
(function (EmployerUserSubErrorCode) {
    EmployerUserSubErrorCode["AccessAlreadyExists"] = "ACCESS_ALREADY_EXISTS";
    EmployerUserSubErrorCode["Duplicate"] = "DUPLICATE";
    EmployerUserSubErrorCode["InvalidInput"] = "INVALID_INPUT";
})(EmployerUserSubErrorCode || (EmployerUserSubErrorCode = {}));
/**
 * Options which can be presented to a user for them to verify for elevated privileges.
 *
 * The degree to which each option escalates a user's privileges depends on the option and
 * the confidence we have in it preventing fraud. That information is not represented here
 * as its business logic changes with experimentation and other criteria.
 *
 * In all options, some set of information provided for verification is made available for
 * future moderation as well as for cross-referencing fraud case data. See individual option
 * descriptions for more information. This recorded information is subject to standard PII
 * handling and often has TTLs related to preserve PII privacy. Some of this information
 * is hashed for linking accounts and fraud-related indicators for future moderation.
 */
export var EmployerVerificationOption;
(function (EmployerVerificationOption) {
    /**
     * Automated email verification option for users who signed up with a non-company-associated email.
     * Users can provide a company associated email and verify their ownership of it.
     *
     * The verified email is made available to moderators.
     */
    EmployerVerificationOption["CorporateEmail"] = "CORPORATE_EMAIL";
    /**
     * Option which queries an employer for various pieces of information needed to make a verification
     * decision including documents that prove employer legitimacy. These documents are then scanned
     * and made available to moderators for asynchronous evaluation.
     *
     * All provided information is made available to moderators.
     *
     * ***Note*: This is a "manual" moderation option, meaning it has human time cost.**
     */
    EmployerVerificationOption["DocumentUpload"] = "DOCUMENT_UPLOAD";
    /**
     * India-only automated verification option that allows verification using employer tax ID and
     * mobile phone registration. This information is used to verify government registration and that
     * the person requesting verification is associated with the company.
     *
     * IDs and other information available from the government is made available to moderators.
     */
    EmployerVerificationOption["Gstin"] = "GSTIN";
    /**
     * US-only automated verification option through a vendor that verifies the legitimacy of
     * the person being verified via evaluation of government approved identification documents.
     *
     * A minimum of the verified person information is made available to moderators.
     */
    EmployerVerificationOption["IdMe"] = "ID_ME";
    /**
     * Option by which an employer can call a phone number to speak with a moderator and present
     * information required for verification. The outcome of this option depends on moderator decisions,
     * information presented, and information available. Preserved information depends on what is noted
     * as part of the moderation process.
     *
     * ***Note*: This is a "manual" moderation option, meaning it has human time cost.**
     */
    EmployerVerificationOption["InboundCalling"] = "INBOUND_CALLING";
    /**
     * Automated verification option that allows users to verify via a test charge to a payment option.
     *
     * Payment reference information is preserved and can be cross-referenced with payments APIs.
     * No related PII is recorded to moderation systems.
     */
    EmployerVerificationOption["Payment"] = "PAYMENT";
    /**
     * Internationally-available automated verification option through a vendor that verifies the legitimacy of
     * the person being verified via evaluation of government approved identification documents.
     *
     * A minimum of the verified person information is made available to moderators.
     */
    EmployerVerificationOption["Persona"] = "PERSONA";
})(EmployerVerificationOption || (EmployerVerificationOption = {}));
export var EmploymentAuthorization;
(function (EmploymentAuthorization) {
    /** @deprecated replaced with non-prefixed value */
    EmploymentAuthorization["AeNo"] = "AE_NO";
    /** @deprecated replaced with non-prefixed value */
    EmploymentAuthorization["AeYes"] = "AE_YES";
    /** @deprecated replaced with non-prefixed value */
    EmploymentAuthorization["AuNo"] = "AU_NO";
    /**
     * Other countries
     * @deprecated replaced with non-prefixed value
     */
    EmploymentAuthorization["AuYes"] = "AU_YES";
    /** @deprecated replaced with non-prefixed value */
    EmploymentAuthorization["BhNo"] = "BH_NO";
    /** @deprecated replaced with non-prefixed value */
    EmploymentAuthorization["BhYes"] = "BH_YES";
    /** @deprecated replaced with non-prefixed value */
    EmploymentAuthorization["EgNo"] = "EG_NO";
    /** @deprecated replaced with non-prefixed value */
    EmploymentAuthorization["EgYes"] = "EG_YES";
    /** @deprecated replaced with non-prefixed value */
    EmploymentAuthorization["GbNo"] = "GB_NO";
    /** @deprecated replaced with non-prefixed value */
    EmploymentAuthorization["GbYes"] = "GB_YES";
    /** @deprecated replaced with non-prefixed value */
    EmploymentAuthorization["HkNo"] = "HK_NO";
    /** @deprecated replaced with non-prefixed value */
    EmploymentAuthorization["HkYes"] = "HK_YES";
    /** @deprecated replaced with non-prefixed value */
    EmploymentAuthorization["ItNo"] = "IT_NO";
    /** @deprecated replaced with non-prefixed value */
    EmploymentAuthorization["ItYes"] = "IT_YES";
    /** @deprecated replaced with non-prefixed value */
    EmploymentAuthorization["KwNo"] = "KW_NO";
    /** @deprecated replaced with non-prefixed value */
    EmploymentAuthorization["KwYes"] = "KW_YES";
    /** @deprecated replaced with non-prefixed value */
    EmploymentAuthorization["MaNo"] = "MA_NO";
    /** @deprecated replaced with non-prefixed value */
    EmploymentAuthorization["MaYes"] = "MA_YES";
    EmploymentAuthorization["No"] = "NO";
    /** @deprecated replaced with non-prefixed value */
    EmploymentAuthorization["NzNo"] = "NZ_NO";
    /** @deprecated replaced with non-prefixed value */
    EmploymentAuthorization["NzYes"] = "NZ_YES";
    /** @deprecated replaced with non-prefixed value */
    EmploymentAuthorization["OmNo"] = "OM_NO";
    /** @deprecated replaced with non-prefixed value */
    EmploymentAuthorization["OmYes"] = "OM_YES";
    /** @deprecated replaced with non-prefixed value */
    EmploymentAuthorization["QaNo"] = "QA_NO";
    /** @deprecated replaced with non-prefixed value */
    EmploymentAuthorization["QaYes"] = "QA_YES";
    /** @deprecated replaced with non-prefixed value */
    EmploymentAuthorization["RuNo"] = "RU_NO";
    /** @deprecated replaced with non-prefixed value */
    EmploymentAuthorization["RuYes"] = "RU_YES";
    /** @deprecated replaced with non-prefixed value */
    EmploymentAuthorization["SaNo"] = "SA_NO";
    /** @deprecated replaced with non-prefixed value */
    EmploymentAuthorization["SaYes"] = "SA_YES";
    EmploymentAuthorization["SgCitizen"] = "SG_CITIZEN";
    /** Singapore Specific Values */
    EmploymentAuthorization["SgEmploymentPass"] = "SG_EMPLOYMENT_PASS";
    /** @deprecated replaced with non-prefixed value */
    EmploymentAuthorization["SgNo"] = "SG_NO";
    EmploymentAuthorization["SgOther"] = "SG_OTHER";
    EmploymentAuthorization["SgSponsorship"] = "SG_SPONSORSHIP";
    EmploymentAuthorization["SgTrainingEmploymentPass"] = "SG_TRAINING_EMPLOYMENT_PASS";
    /** @deprecated replaced with non-prefixed value */
    EmploymentAuthorization["SgYes"] = "SG_YES";
    EmploymentAuthorization["Unknown"] = "UNKNOWN";
    EmploymentAuthorization["UsEligible"] = "US_ELIGIBLE";
    EmploymentAuthorization["UsIneligible"] = "US_INELIGIBLE";
    /** @deprecated replaced with non-prefixed value */
    EmploymentAuthorization["UsUnknown"] = "US_UNKNOWN";
    /** United States Specific Values */
    EmploymentAuthorization["UsWithSponsorship"] = "US_WITH_SPONSORSHIP";
    EmploymentAuthorization["Yes"] = "YES";
})(EmploymentAuthorization || (EmploymentAuthorization = {}));
export var EngagementType;
(function (EngagementType) {
    EngagementType["ApplicationView"] = "APPLICATION_VIEW";
    EngagementType["SearchAppearance"] = "SEARCH_APPEARANCE";
    EngagementType["SearchView"] = "SEARCH_VIEW";
})(EngagementType || (EngagementType = {}));
/** Possible enrollment methods for an employer job enrollment. */
export var EnrollmentMethod;
(function (EnrollmentMethod) {
    EnrollmentMethod["Auto"] = "AUTO";
    EnrollmentMethod["Manual"] = "MANUAL";
})(EnrollmentMethod || (EnrollmentMethod = {}));
/** Product types available for automation enrollment */
export var EnrollmentProductType;
(function (EnrollmentProductType) {
    /** @deprecated Use BASIC_SCREENING_V2 instead */
    EnrollmentProductType["BasicScreening"] = "BASIC_SCREENING";
    EnrollmentProductType["BasicScreeningV2"] = "BASIC_SCREENING_V2";
    EnrollmentProductType["Nexus"] = "NEXUS";
    EnrollmentProductType["SponsoredJobNexus"] = "SPONSORED_JOB_NEXUS";
})(EnrollmentProductType || (EnrollmentProductType = {}));
/** Type of job enrollment for workflow rule application */
export var EnrollmentType;
(function (EnrollmentType) {
    /** Apply to existing enrolled jobs */
    EnrollmentType["Existing"] = "EXISTING";
    /** Apply to newly enrolled jobs */
    EnrollmentType["New"] = "NEW";
})(EnrollmentType || (EnrollmentType = {}));
export var EntitlementAvailability;
(function (EntitlementAvailability) {
    /** There are active entitlements that can receive new issuances */
    EntitlementAvailability["HasActiveEntitlements"] = "HAS_ACTIVE_ENTITLEMENTS";
    /** There are no active entitlements that can receive new issuances */
    EntitlementAvailability["NoActiveEntitlements"] = "NO_ACTIVE_ENTITLEMENTS";
})(EntitlementAvailability || (EntitlementAvailability = {}));
export var EntitlementProduct;
(function (EntitlementProduct) {
    EntitlementProduct["Nexus"] = "NEXUS";
})(EntitlementProduct || (EntitlementProduct = {}));
/**
 * Available business domains for drafts.
 * Each domain has specific rules and schemas.
 */
export var EntityDraftDomain;
(function (EntityDraftDomain) {
    EntityDraftDomain["Campaign"] = "CAMPAIGN";
})(EntityDraftDomain || (EntityDraftDomain = {}));
/** Enum which indicates the status of the draft entity. */
export var EntityDraftStatus;
(function (EntityDraftStatus) {
    EntityDraftStatus["Active"] = "ACTIVE";
    EntityDraftStatus["ManuallyDeleted"] = "MANUALLY_DELETED";
    EntityDraftStatus["Published"] = "PUBLISHED";
})(EntityDraftStatus || (EntityDraftStatus = {}));
export var EntityEventType;
(function (EntityEventType) {
    EntityEventType["Onscreen"] = "ONSCREEN";
    EntityEventType["WorkflowMention"] = "WORKFLOW_MENTION";
})(EntityEventType || (EntityEventType = {}));
export var EntityIdType;
(function (EntityIdType) {
    EntityIdType["AccountId"] = "ACCOUNT_ID";
    EntityIdType["AdvertiserId"] = "ADVERTISER_ID";
    EntityIdType["AggJobId"] = "AGG_JOB_ID";
    EntityIdType["Ctk"] = "CTK";
    EntityIdType["EmployerAccountId"] = "EMPLOYER_ACCOUNT_ID";
    EntityIdType["UnknownEntityIdType"] = "UNKNOWN_ENTITY_ID_TYPE";
})(EntityIdType || (EntityIdType = {}));
/** Type of entity associated with a recommendation */
export var EntityType;
(function (EntityType) {
    /** Campaign entity */
    EntityType["Campaign"] = "CAMPAIGN";
    /** Job posting entity */
    EntityType["Job"] = "JOB";
})(EntityType || (EntityType = {}));
/** Enum to consolidate all possible errors from a mutation */
export var Error;
(function (Error) {
    Error["AccessDenied"] = "ACCESS_DENIED";
    /** Advertiser creation failed due to a backend or transport error */
    Error["AdvertiserCreationFailed"] = "ADVERTISER_CREATION_FAILED";
    /** The idempotency key provided to the advertiser service has already been used */
    Error["AdvertiserIdempotencyKeyConflict"] = "ADVERTISER_IDEMPOTENCY_KEY_CONFLICT";
    Error["AdvertiserModeration"] = "ADVERTISER_MODERATION";
    Error["CannotSetSelfAsParent"] = "CANNOT_SET_SELF_AS_PARENT";
    Error["ChildEmployerAlreadyAssociated"] = "CHILD_EMPLOYER_ALREADY_ASSOCIATED";
    /** The requesting user's account could not be resolved from the identity service */
    Error["CreatorAccountNotFound"] = "CREATOR_ACCOUNT_NOT_FOUND";
    Error["DbUpdateError"] = "DB_UPDATE_ERROR";
    Error["DetailedInviteAdvertiserError"] = "DETAILED_INVITE_ADVERTISER_ERROR";
    Error["DifferentRootEmployers"] = "DIFFERENT_ROOT_EMPLOYERS";
    Error["DuplicateInviteRequest"] = "DUPLICATE_INVITE_REQUEST";
    Error["EmployerAccountNotAllowedInHierarchyType"] = "EMPLOYER_ACCOUNT_NOT_ALLOWED_IN_HIERARCHY_TYPE";
    Error["EmployerAccountNotFound"] = "EMPLOYER_ACCOUNT_NOT_FOUND";
    Error["EmployerAccountOwnerNotFound"] = "EMPLOYER_ACCOUNT_OWNER_NOT_FOUND";
    Error["EmployerAccountRenameError"] = "EMPLOYER_ACCOUNT_RENAME_ERROR";
    Error["EmployerAccountUserAlreadyAssociatedWithParent"] = "EMPLOYER_ACCOUNT_USER_ALREADY_ASSOCIATED_WITH_PARENT";
    Error["EmployerAlreadyHasParent"] = "EMPLOYER_ALREADY_HAS_PARENT";
    Error["EmployerAlreadyHasSameRoot"] = "EMPLOYER_ALREADY_HAS_SAME_ROOT";
    Error["Error"] = "ERROR";
    Error["ExceededChildEmployerLimit"] = "EXCEEDED_CHILD_EMPLOYER_LIMIT";
    Error["InvalidInput"] = "INVALID_INPUT";
    Error["InvalidInviteKey"] = "INVALID_INVITE_KEY";
    Error["InvalidRequestingAccountId"] = "INVALID_REQUESTING_ACCOUNT_ID";
    Error["InvalidUpdate"] = "INVALID_UPDATE";
    Error["InviteeAccountNotFound"] = "INVITEE_ACCOUNT_NOT_FOUND";
    Error["InviteeAccountRequestingAccountMismatch"] = "INVITEE_ACCOUNT_REQUESTING_ACCOUNT_MISMATCH";
    Error["InviteeEmployerUserAlreadyAssociatedWithParent"] = "INVITEE_EMPLOYER_USER_ALREADY_ASSOCIATED_WITH_PARENT";
    Error["InviteeEntityNotFound"] = "INVITEE_ENTITY_NOT_FOUND";
    Error["InviteeParentAdvertiserNotFound"] = "INVITEE_PARENT_ADVERTISER_NOT_FOUND";
    Error["InviterAccountNotFound"] = "INVITER_ACCOUNT_NOT_FOUND";
    Error["InviterAdvertiserNotFound"] = "INVITER_ADVERTISER_NOT_FOUND";
    Error["InviterEmailNotVerified"] = "INVITER_EMAIL_NOT_VERIFIED";
    Error["InviterEntityNotFound"] = "INVITER_ENTITY_NOT_FOUND";
    Error["InviteAlreadyDeclined"] = "INVITE_ALREADY_DECLINED";
    Error["InviteEntityNotFound"] = "INVITE_ENTITY_NOT_FOUND";
    Error["InviteNotFound"] = "INVITE_NOT_FOUND";
    Error["MissingPermission"] = "MISSING_PERMISSION";
    Error["ObfuscatedInviteAdvertiserError"] = "OBFUSCATED_INVITE_ADVERTISER_ERROR";
    Error["ParentEmployerAccountIsLocked"] = "PARENT_EMPLOYER_ACCOUNT_IS_LOCKED";
    Error["ParentEmployerAccountNotFound"] = "PARENT_EMPLOYER_ACCOUNT_NOT_FOUND";
    Error["PrimaryAdvertiserNotFound"] = "PRIMARY_ADVERTISER_NOT_FOUND";
    Error["SelfInvite"] = "SELF_INVITE";
    Error["SendEmailFailure"] = "SEND_EMAIL_FAILURE";
    Error["UnableToCreateSubAccount"] = "UNABLE_TO_CREATE_SUB_ACCOUNT";
    Error["Unauthorized"] = "UNAUTHORIZED";
    Error["Unknown"] = "UNKNOWN";
    Error["UpdateGroupTypeFailure"] = "UPDATE_GROUP_TYPE_FAILURE";
})(Error || (Error = {}));
/** Category of a validation failure, distinguishing caller-side mistakes from service-side failures. */
export var ErrorCategory;
(function (ErrorCategory) {
    /** The caller misused the API (e.g. the input did not match the rule). Retrying the same request will not succeed. */
    ErrorCategory["ClientError"] = "CLIENT_ERROR";
    /** A service-side failure: a transient internal fault (no validator registered for the rule, validator threw, malformed rule) or a configuration issue such as an unknown rule key that is not defined in the service's rules. Retrying may succeed for transient faults but will not resolve a missing-rule misconfiguration; branch on `errorCode` to tell them apart. */
    ErrorCategory["ServerError"] = "SERVER_ERROR";
})(ErrorCategory || (ErrorCategory = {}));
/** Enumeration of error codes */
export var ErrorCode;
(function (ErrorCode) {
    /** Internal server error */
    ErrorCode["InternalServerError"] = "INTERNAL_SERVER_ERROR";
    /** Invalid argument error */
    ErrorCode["InvalidArgument"] = "INVALID_ARGUMENT";
    /** Not found error */
    ErrorCode["NotFound"] = "NOT_FOUND";
})(ErrorCode || (ErrorCode = {}));
/**
 * For GraphQL Errors, these are the potential values for extensions.subcode when the
 * extensions.code equals BAD_USER_INPUT, representing a validation error on an input field.
 */
export var ErrorSubCode;
(function (ErrorSubCode) {
    /** Input String cannot be blank */
    ErrorSubCode["CannotBeBlank"] = "CANNOT_BE_BLANK";
    /** Collection size limit reached. Cannot add more items to this collection. */
    ErrorSubCode["CollectionSizeExceededLimit"] = "COLLECTION_SIZE_EXCEEDED_LIMIT";
    /** Input has an ID that was not found */
    ErrorSubCode["IdNotFound"] = "ID_NOT_FOUND";
    /** Input country code is not a valid ISO country code */
    ErrorSubCode["InvalidCountryCode"] = "INVALID_COUNTRY_CODE";
    /** Error updating crowtaxo attribute */
    ErrorSubCode["InvalidCrowtaxoUpdate"] = "INVALID_CROWTAXO_UPDATE";
    /** Input date format is invalid */
    ErrorSubCode["InvalidDateFormat"] = "INVALID_DATE_FORMAT";
    /** Input date of birth is invalid */
    ErrorSubCode["InvalidDateOfBirth"] = "INVALID_DATE_OF_BIRTH";
    /** Input value is not valid for the resume country */
    ErrorSubCode["InvalidInternationalValueForCountry"] = "INVALID_INTERNATIONAL_VALUE_FOR_COUNTRY";
    /** Input is not a valid SUID */
    ErrorSubCode["InvalidSuid"] = "INVALID_SUID";
    /** Input work authorization value is invalid for the given country or context */
    ErrorSubCode["InvalidWorkAuthorization"] = "INVALID_WORK_AUTHORIZATION";
    /** Input String cannot exceed maximum length */
    ErrorSubCode["MaxLengthExceeded"] = "MAX_LENGTH_EXCEEDED";
    /** Input number field cannot exceed maximum value */
    ErrorSubCode["MaxNumberValueExceeded"] = "MAX_NUMBER_VALUE_EXCEEDED";
    /** Input String cannot be below minimum length */
    ErrorSubCode["MinLengthNotMet"] = "MIN_LENGTH_NOT_MET";
    /** Input number field cannot be below minimum value */
    ErrorSubCode["MinNumberValueNotMet"] = "MIN_NUMBER_VALUE_NOT_MET";
    /** Required input field is missing */
    ErrorSubCode["MissingRequiredField"] = "MISSING_REQUIRED_FIELD";
    /** Input cannot contain two or more attributes who are children of the same CrowTaxo parent */
    ErrorSubCode["MultipleCrowtaxoChildren"] = "MULTIPLE_CROWTAXO_CHILDREN";
})(ErrorSubCode || (ErrorSubCode = {}));
/**
 * For a GraphQL error with a MAX_LENGTH_EXCEEDED subcode, these enum values exist as keys in
 * extensions.parameters, representing additional information.
 */
export var ErrorSubCodeMaxLengthExceededParams;
(function (ErrorSubCodeMaxLengthExceededParams) {
    /** Attempted length of the String */
    ErrorSubCodeMaxLengthExceededParams["AttemptedLength"] = "ATTEMPTED_LENGTH";
    /** The max length that a String can be */
    ErrorSubCodeMaxLengthExceededParams["MaxLength"] = "MAX_LENGTH";
})(ErrorSubCodeMaxLengthExceededParams || (ErrorSubCodeMaxLengthExceededParams = {}));
/**
 * For a GraphQL error with a MAX_NUMBER_VALUE_EXCEEDED subcode, these enum values exist as keys in
 * extensions.parameters, representing additional information.
 */
export var ErrorSubCodeMaxNumberValueExceededParams;
(function (ErrorSubCodeMaxNumberValueExceededParams) {
    /** Attempted number value */
    ErrorSubCodeMaxNumberValueExceededParams["AttemptedValue"] = "ATTEMPTED_VALUE";
    /** The max value that a number can be */
    ErrorSubCodeMaxNumberValueExceededParams["MaxValue"] = "MAX_VALUE";
})(ErrorSubCodeMaxNumberValueExceededParams || (ErrorSubCodeMaxNumberValueExceededParams = {}));
/** Parameters for MIN_LENGTH_NOT_MET subcode */
export var ErrorSubCodeMinLengthNotMetParams;
(function (ErrorSubCodeMinLengthNotMetParams) {
    /** Attempted length of the String */
    ErrorSubCodeMinLengthNotMetParams["AttemptedLength"] = "ATTEMPTED_LENGTH";
    /** The min length that a String can be */
    ErrorSubCodeMinLengthNotMetParams["MinLength"] = "MIN_LENGTH";
})(ErrorSubCodeMinLengthNotMetParams || (ErrorSubCodeMinLengthNotMetParams = {}));
/**
 * For a GraphQL error with a MIN_NUMBER_VALUE_NOT_MET subcode, these enum values exist as keys in
 * extensions.parameters, representing additional information.
 */
export var ErrorSubCodeMinNumberValueNotMetParams;
(function (ErrorSubCodeMinNumberValueNotMetParams) {
    /** Attempted number value */
    ErrorSubCodeMinNumberValueNotMetParams["AttemptedValue"] = "ATTEMPTED_VALUE";
    /** The min value that a number can be */
    ErrorSubCodeMinNumberValueNotMetParams["MinValue"] = "MIN_VALUE";
})(ErrorSubCodeMinNumberValueNotMetParams || (ErrorSubCodeMinNumberValueNotMetParams = {}));
export var EstimatedTotalResultsCountType;
(function (EstimatedTotalResultsCountType) {
    /** AT_LEAST = there are AT LEAST X number of results and we should display it as “X+” where “+” denotes there are more jobs */
    EstimatedTotalResultsCountType["AtLeast"] = "AT_LEAST";
    /** EXACT = there are only X number of results and we are returning it */
    EstimatedTotalResultsCountType["Exact"] = "EXACT";
})(EstimatedTotalResultsCountType || (EstimatedTotalResultsCountType = {}));
/** Enum to define various Job salary period types available for salary estimation purpose. */
export var EstimationJobSalaryPeriod;
(function (EstimationJobSalaryPeriod) {
    EstimationJobSalaryPeriod["Day"] = "DAY";
    EstimationJobSalaryPeriod["Hour"] = "HOUR";
    EstimationJobSalaryPeriod["Mile"] = "MILE";
    EstimationJobSalaryPeriod["Month"] = "MONTH";
    EstimationJobSalaryPeriod["Week"] = "WEEK";
    EstimationJobSalaryPeriod["Year"] = "YEAR";
})(EstimationJobSalaryPeriod || (EstimationJobSalaryPeriod = {}));
/** Reason codes for per-entry evaluation failures. */
export var EvaluateApplicationErrorReason;
(function (EvaluateApplicationErrorReason) {
    /**
     * No longer emitted. ADAO partitions writes by the QUALIFICATION label, so the same
     * (questionSetId, questionId) cannot appear in both indeedQualificationQnA and
     * screenerQnA — the dedup branch was unreachable and was removed. Kept in the
     * schema until QA operation history rolls off; slated for removal in a follow-up.
     * @deprecated No longer emitted; ADAO label-partition makes the dedup branch unreachable. Slated for removal after QA operation history rolls off.
     */
    EvaluateApplicationErrorReason["DuplicateSnapshotDiscarded"] = "DUPLICATE_SNAPSHOT_DISCARDED";
    /** A namespace's qualifications could not be evaluated. */
    EvaluateApplicationErrorReason["EvaluationFailed"] = "EVALUATION_FAILED";
    /** A question's answer could not be mapped to an IQP qualification answer. */
    EvaluateApplicationErrorReason["MappingFailed"] = "MAPPING_FAILED";
})(EvaluateApplicationErrorReason || (EvaluateApplicationErrorReason = {}));
/** Step types supported by Evaluate workflows */
export var EvaluateStepType;
(function (EvaluateStepType) {
    EvaluateStepType["EvaluateAssessmentStep"] = "EVALUATE_ASSESSMENT_STEP";
    EvaluateStepType["EvaluateContinueStep"] = "EVALUATE_CONTINUE_STEP";
    EvaluateStepType["EvaluateLicenseStep"] = "EVALUATE_LICENSE_STEP";
    EvaluateStepType["EvaluateLocationStep"] = "EVALUATE_LOCATION_STEP";
    EvaluateStepType["EvaluatePreviousApplicantStep"] = "EVALUATE_PREVIOUS_APPLICANT_STEP";
    EvaluateStepType["EvaluateScreenerQuestionsStep"] = "EVALUATE_SCREENER_QUESTIONS_STEP";
    EvaluateStepType["EvaluateShiftAvailabilityStep"] = "EVALUATE_SHIFT_AVAILABILITY_STEP";
    EvaluateStepType["EvaluateStartStep"] = "EVALUATE_START_STEP";
    EvaluateStepType["EvaluateUnimplementedStep"] = "EVALUATE_UNIMPLEMENTED_STEP";
    EvaluateStepType["EvaluateWatchVideoStep"] = "EVALUATE_WATCH_VIDEO_STEP";
    EvaluateStepType["EvaluateWorkHistoryStep"] = "EVALUATE_WORK_HISTORY_STEP";
})(EvaluateStepType || (EvaluateStepType = {}));
/** Outcome of an evaluation step in the application screening pipeline. */
export var EvaluationStatus;
(function (EvaluationStatus) {
    /** The evaluation could not be completed due to an error. */
    EvaluationStatus["Error"] = "ERROR";
    /** The candidate failed the evaluation. */
    EvaluationStatus["Failed"] = "FAILED";
    /** An employer manually overrode the original evaluation outcome. */
    EvaluationStatus["ManualOverride"] = "MANUAL_OVERRIDE";
    /** The evaluation has not yet been performed. */
    EvaluationStatus["NotEvaluated"] = "NOT_EVALUATED";
    /** The candidate passed the evaluation. */
    EvaluationStatus["Passed"] = "PASSED";
})(EvaluationStatus || (EvaluationStatus = {}));
export var EventType;
(function (EventType) {
    EventType["JsPhoneOnly"] = "JS_PHONE_ONLY";
    EventType["Queued"] = "QUEUED";
    EventType["Single"] = "SINGLE";
})(EventType || (EventType = {}));
/** Email interval for the annual auto renewal email */
export var EvergreenNotice;
(function (EvergreenNotice) {
    EvergreenNotice["AnnualConfirmationRenewalNotice"] = "ANNUAL_CONFIRMATION_RENEWAL_NOTICE";
    EvergreenNotice["AnnualFirstRenewalNotice"] = "ANNUAL_FIRST_RENEWAL_NOTICE";
    EvergreenNotice["AnnualSecondRenewalNotice"] = "ANNUAL_SECOND_RENEWAL_NOTICE";
    EvergreenNotice["CancellationNotice"] = "CANCELLATION_NOTICE";
    EvergreenNotice["MonthlyRenewalNotice"] = "MONTHLY_RENEWAL_NOTICE";
})(EvergreenNotice || (EvergreenNotice = {}));
/** Variants of the ExistsX optimization */
export var ExistsXOptimizationVariant;
(function (ExistsXOptimizationVariant) {
    ExistsXOptimizationVariant["ExistsXOptimizationVariantDefault"] = "EXISTS_X_OPTIMIZATION_VARIANT_DEFAULT";
})(ExistsXOptimizationVariant || (ExistsXOptimizationVariant = {}));
/** Expected hire date for the job */
export var ExpectedHireDate;
(function (ExpectedHireDate) {
    ExpectedHireDate["Empty"] = "EMPTY";
    ExpectedHireDate["FourPlusWeeks"] = "FOUR_PLUS_WEEKS";
    ExpectedHireDate["FourWeeks"] = "FOUR_WEEKS";
    ExpectedHireDate["OneWeek"] = "ONE_WEEK";
    ExpectedHireDate["ThreeDays"] = "THREE_DAYS";
    ExpectedHireDate["TwoWeeks"] = "TWO_WEEKS";
})(ExpectedHireDate || (ExpectedHireDate = {}));
/** enum for CIR export report type */
export var ExportBy;
(function (ExportBy) {
    ExportBy["BillingIdentifier"] = "BILLING_IDENTIFIER";
    ExportBy["BillingInvoice"] = "BILLING_INVOICE";
})(ExportBy || (ExportBy = {}));
/** Supported external locations in external ATS systems */
export var ExternalAtsExternalLocationKind;
(function (ExternalAtsExternalLocationKind) {
    /** A reference not currently supported by this api */
    ExternalAtsExternalLocationKind["Indeterminate"] = "INDETERMINATE";
    /** A reference to a requisition (or requisition equivalent) in the external ats */
    ExternalAtsExternalLocationKind["Requisition"] = "REQUISITION";
    /** A reference to a talent pool (or talent pool equivalent) in the external ats */
    ExternalAtsExternalLocationKind["TalentPool"] = "TALENT_POOL";
})(ExternalAtsExternalLocationKind || (ExternalAtsExternalLocationKind = {}));
/** Supported external locations in external ATS systems */
export var ExternalAtsExternalLocationKindInput;
(function (ExternalAtsExternalLocationKindInput) {
    /** A reference to a requisition (or requisition equivalent) in the external ats */
    ExternalAtsExternalLocationKindInput["Requisition"] = "REQUISITION";
    /** A reference to a talent pool (or talent pool equivalent) in the external ats */
    ExternalAtsExternalLocationKindInput["TalentPool"] = "TALENT_POOL";
})(ExternalAtsExternalLocationKindInput || (ExternalAtsExternalLocationKindInput = {}));
/** Supported metadata types in ATS systems */
export var ExternalAtsExternalMetadataKind;
(function (ExternalAtsExternalMetadataKind) {
    ExternalAtsExternalMetadataKind["ApplicationDisposition"] = "APPLICATION_DISPOSITION";
    ExternalAtsExternalMetadataKind["ApplicationDispositionDetails"] = "APPLICATION_DISPOSITION_DETAILS";
    ExternalAtsExternalMetadataKind["CalculatedField"] = "CALCULATED_FIELD";
    ExternalAtsExternalMetadataKind["CandidateDisposition"] = "CANDIDATE_DISPOSITION";
    ExternalAtsExternalMetadataKind["CandidateFolder"] = "CANDIDATE_FOLDER";
    ExternalAtsExternalMetadataKind["Company"] = "COMPANY";
    ExternalAtsExternalMetadataKind["Country"] = "COUNTRY";
    ExternalAtsExternalMetadataKind["EvergreenRequisition"] = "EVERGREEN_REQUISITION";
    ExternalAtsExternalMetadataKind["Indeterminate"] = "INDETERMINATE";
    ExternalAtsExternalMetadataKind["JobRequisition"] = "JOB_REQUISITION";
    ExternalAtsExternalMetadataKind["OrganizationType"] = "ORGANIZATION_TYPE";
    ExternalAtsExternalMetadataKind["RemoteType"] = "REMOTE_TYPE";
    ExternalAtsExternalMetadataKind["RequisitionFolder"] = "REQUISITION_FOLDER";
    ExternalAtsExternalMetadataKind["Source"] = "SOURCE";
    ExternalAtsExternalMetadataKind["SourceChannel"] = "SOURCE_CHANNEL";
    ExternalAtsExternalMetadataKind["Tags"] = "TAGS";
    ExternalAtsExternalMetadataKind["TalentPoolFolder"] = "TALENT_POOL_FOLDER";
})(ExternalAtsExternalMetadataKind || (ExternalAtsExternalMetadataKind = {}));
/** Supported Indeed data sources for candidate data */
export var ExternalAtsInternalLocationKind;
(function (ExternalAtsInternalLocationKind) {
    /** An employer job.  See EmployerJob */
    ExternalAtsInternalLocationKind["Employer"] = "EMPLOYER";
    /** An unexpected internal type not supported by this api */
    ExternalAtsInternalLocationKind["Unknown"] = "UNKNOWN";
})(ExternalAtsInternalLocationKind || (ExternalAtsInternalLocationKind = {}));
/** Supported Indeed data sources for candidate data */
export var ExternalAtsInternalLocationKindInput;
(function (ExternalAtsInternalLocationKindInput) {
    /** An employer job.  See EmployerJob */
    ExternalAtsInternalLocationKindInput["Employer"] = "EMPLOYER";
})(ExternalAtsInternalLocationKindInput || (ExternalAtsInternalLocationKindInput = {}));
/** Indicates the health status of a link to an ATS */
export var ExternalAtsLinkHealthStatus;
(function (ExternalAtsLinkHealthStatus) {
    /** The ATS link is broken */
    ExternalAtsLinkHealthStatus["Broken"] = "BROKEN";
    /** The ATS link is healthy */
    ExternalAtsLinkHealthStatus["Healthy"] = "HEALTHY";
    /** The ATS link is unhealthy */
    ExternalAtsLinkHealthStatus["Unhealthy"] = "UNHEALTHY";
    /** The ATS link health is unknown */
    ExternalAtsLinkHealthStatus["Unknown"] = "UNKNOWN";
})(ExternalAtsLinkHealthStatus || (ExternalAtsLinkHealthStatus = {}));
/** Status that represents the overall ATS Sync status */
export var ExternalAtsLinkStatusKind;
(function (ExternalAtsLinkStatusKind) {
    /** The link is working properly and data can flow through it */
    ExternalAtsLinkStatusKind["Active"] = "ACTIVE";
    /** The link is broken. Pipelines using this link cannot move any data. */
    ExternalAtsLinkStatusKind["Broken"] = "BROKEN";
    /**
     * The link requires additional configuration in order to
     * activate
     */
    ExternalAtsLinkStatusKind["ConfigurationRequired"] = "CONFIGURATION_REQUIRED";
    /** The link is disabled. Data cannot flow through it */
    ExternalAtsLinkStatusKind["Disabled"] = "DISABLED";
    /** The link is in an unknown state */
    ExternalAtsLinkStatusKind["Indeterminate"] = "INDETERMINATE";
    /** The ATS rejected the provided credentials */
    ExternalAtsLinkStatusKind["InvalidCredentials"] = "INVALID_CREDENTIALS";
    /** The link requires a user to login */
    ExternalAtsLinkStatusKind["LoginRequired"] = "LOGIN_REQUIRED";
    /**
     * The link is pending to be deleted after it completes any
     * pending work
     */
    ExternalAtsLinkStatusKind["PendingDelete"] = "PENDING_DELETE";
    /** The link will be disabled after completes any pending work */
    ExternalAtsLinkStatusKind["PendingDisable"] = "PENDING_DISABLE";
    /** The state is relevant Indeed Apply Sync setup state when the setup is in review */
    ExternalAtsLinkStatusKind["PendingReview"] = "PENDING_REVIEW";
    /** The link configuration is being validated */
    ExternalAtsLinkStatusKind["PendingValidation"] = "PENDING_VALIDATION";
})(ExternalAtsLinkStatusKind || (ExternalAtsLinkStatusKind = {}));
/** Defines the direction in which data flows through the pipeline */
export var ExternalAtsPipelineActionKind;
(function (ExternalAtsPipelineActionKind) {
    /** Data from the internal location is automatically sent to the external location */
    ExternalAtsPipelineActionKind["Export"] = "EXPORT";
    /** Data from an external location is automatically sent to the internal location */
    ExternalAtsPipelineActionKind["Import"] = "IMPORT";
    /** A pipeline action not currently supported by this api */
    ExternalAtsPipelineActionKind["Unknown"] = "UNKNOWN";
})(ExternalAtsPipelineActionKind || (ExternalAtsPipelineActionKind = {}));
/** Defines the direction in which data flows through the pipeline */
export var ExternalAtsPipelineActionKindInput;
(function (ExternalAtsPipelineActionKindInput) {
    /** Data from the internal location is automatically sent to the external location */
    ExternalAtsPipelineActionKindInput["Export"] = "EXPORT";
})(ExternalAtsPipelineActionKindInput || (ExternalAtsPipelineActionKindInput = {}));
/** The kind of state of the pipeline */
export var ExternalAtsPipelineStateKind;
(function (ExternalAtsPipelineStateKind) {
    ExternalAtsPipelineStateKind["Active"] = "ACTIVE";
    ExternalAtsPipelineStateKind["Deleted"] = "DELETED";
    ExternalAtsPipelineStateKind["Disabled"] = "DISABLED";
    ExternalAtsPipelineStateKind["LocationMissing"] = "LOCATION_MISSING";
    ExternalAtsPipelineStateKind["Unknown"] = "UNKNOWN";
})(ExternalAtsPipelineStateKind || (ExternalAtsPipelineStateKind = {}));
/** Defines the possible states of a resource history action kind */
export var ExternalAtsResourceActionKind;
(function (ExternalAtsResourceActionKind) {
    /** The resource was received from an Indeed data source and provided to the external ATS */
    ExternalAtsResourceActionKind["Export"] = "EXPORT";
    /** The resource was received from the external ATS and provided to an Indeed data source */
    ExternalAtsResourceActionKind["Import"] = "IMPORT";
    /** The action performed on the resource is not currently supported by this API */
    ExternalAtsResourceActionKind["Unknown"] = "UNKNOWN";
})(ExternalAtsResourceActionKind || (ExternalAtsResourceActionKind = {}));
/** Supported action kinda for querying resource history */
export var ExternalAtsResourceActionKindInput;
(function (ExternalAtsResourceActionKindInput) {
    /** The resource was received from an Indeed data source and provided to the external ATS */
    ExternalAtsResourceActionKindInput["Export"] = "EXPORT";
    /** The resource was received from an ATS data source and provided to Indeed */
    ExternalAtsResourceActionKindInput["Import"] = "IMPORT";
})(ExternalAtsResourceActionKindInput || (ExternalAtsResourceActionKindInput = {}));
/** Defines the possible origins of a resource history */
export var ExternalAtsResourceOrigin;
(function (ExternalAtsResourceOrigin) {
    /** The transfer was initiated because of an application to a job */
    ExternalAtsResourceOrigin["Application"] = "APPLICATION";
    /** The transfer was initiated by an ATS outside Indeed */
    ExternalAtsResourceOrigin["ExternalAts"] = "EXTERNAL_ATS";
    /** The transfer was initiated by Indeed Apply Sync because of an Indeed Apply application */
    ExternalAtsResourceOrigin["Ias"] = "IAS";
    /** The transfer was initiated because of a positive contact */
    ExternalAtsResourceOrigin["Sourcing"] = "SOURCING";
})(ExternalAtsResourceOrigin || (ExternalAtsResourceOrigin = {}));
/** Defines the possible kinds of work history events */
export var ExternalAtsResourceStatusEventKind;
(function (ExternalAtsResourceStatusEventKind) {
    /** Export for the specified resource has completed unsuccessfully */
    ExternalAtsResourceStatusEventKind["CompletedFailure"] = "COMPLETED_FAILURE";
    /** Export for the specified resources has completed, but the outcome was unable to be determined */
    ExternalAtsResourceStatusEventKind["CompletedIndeterminate"] = "COMPLETED_INDETERMINATE";
    /** Export for the specified resource has completed successfully */
    ExternalAtsResourceStatusEventKind["CompletedSuccess"] = "COMPLETED_SUCCESS";
    /** Export for the specified resources has been deferred */
    ExternalAtsResourceStatusEventKind["Deferred"] = "DEFERRED";
    /** Unable to determine export status for the specified resource */
    ExternalAtsResourceStatusEventKind["Indeterminate"] = "INDETERMINATE";
    /** Export for the specified resource has been queued */
    ExternalAtsResourceStatusEventKind["Queued"] = "QUEUED";
    /** Export for the specified resources has resumed */
    ExternalAtsResourceStatusEventKind["Resumed"] = "RESUMED";
    /** Export for the specified resource has been started */
    ExternalAtsResourceStatusEventKind["Started"] = "STARTED";
})(ExternalAtsResourceStatusEventKind || (ExternalAtsResourceStatusEventKind = {}));
/**
 * Strategy options for Workday's companyNameConfiguration, shared by the read type
 * (`ExternalAtsWorkdayCompanyNameConfiguration`) and the write input (`ExternalAtsWorkdayCompanyNameConfigurationInput`).
 * The GraphQL surface deals in Workday references; internal organization type ids are an implementation detail
 * resolved server-side.
 */
export var ExternalAtsWorkdayCompanyNameConfigurationType;
(function (ExternalAtsWorkdayCompanyNameConfigurationType) {
    /**
     * `value` is a Workday calculated field alias used to derive the company name via WQL when syncing job reqs.
     * Stored verbatim.
     */
    ExternalAtsWorkdayCompanyNameConfigurationType["CalculatedFieldAlias"] = "CALCULATED_FIELD_ALIAS";
    /**
     * `value` is a Workday organization type reference (the same identifier as the legacy `companyNameReferenceId`).
     * On write it is resolved server-side to an internal id for storage; on read that internal id is resolved back to
     * this reference, so it round-trips unchanged. An empty `value` clears the configuration.
     */
    ExternalAtsWorkdayCompanyNameConfigurationType["OrganizationTypeReference"] = "ORGANIZATION_TYPE_REFERENCE";
    /**
     * `value` is a literal company name applied to all job reqs during Job Sync.
     * Stored verbatim.
     */
    ExternalAtsWorkdayCompanyNameConfigurationType["Static"] = "STATIC";
})(ExternalAtsWorkdayCompanyNameConfigurationType || (ExternalAtsWorkdayCompanyNameConfigurationType = {}));
/** Source system where external consent was collected. */
export var ExternalConsentSource;
(function (ExternalConsentSource) {
    /** Consent collected via DocuSign. */
    ExternalConsentSource["Docusign"] = "DOCUSIGN";
    /** Consent collected via email. */
    ExternalConsentSource["Email"] = "EMAIL";
})(ExternalConsentSource || (ExternalConsentSource = {}));
/** The type of external info to sync */
export var ExternalInfoType;
(function (ExternalInfoType) {
    ExternalInfoType["CompanyMetadata"] = "COMPANY_METADATA";
    ExternalInfoType["RemoteType"] = "REMOTE_TYPE";
    ExternalInfoType["Requisition"] = "REQUISITION";
})(ExternalInfoType || (ExternalInfoType = {}));
/** Defines selectable values for education levels in external user info request */
export var ExternalUserInfoEducation;
(function (ExternalUserInfoEducation) {
    ExternalUserInfoEducation["Associates"] = "ASSOCIATES";
    ExternalUserInfoEducation["Bachelors"] = "BACHELORS";
    ExternalUserInfoEducation["HighSchool"] = "HIGH_SCHOOL";
    ExternalUserInfoEducation["Jd"] = "JD";
    ExternalUserInfoEducation["Masters"] = "MASTERS";
    ExternalUserInfoEducation["Mba"] = "MBA";
    ExternalUserInfoEducation["Md"] = "MD";
    ExternalUserInfoEducation["Phd"] = "PHD";
})(ExternalUserInfoEducation || (ExternalUserInfoEducation = {}));
/** Defines selectable values for employer size in external user info request */
export var ExternalUserInfoEmployerSize;
(function (ExternalUserInfoEmployerSize) {
    /** SMGIANTALL: 5000+ employees */
    ExternalUserInfoEmployerSize["Giant"] = "GIANT";
    /** LARGE: 1001 - 5000 employees */
    ExternalUserInfoEmployerSize["Large"] = "LARGE";
    /** MEDIUM: 201 - 500 employees */
    ExternalUserInfoEmployerSize["Medium"] = "MEDIUM";
    /** MEDIUM_TO_LARGE: 501 - 1000 employees */
    ExternalUserInfoEmployerSize["MediumToLarge"] = "MEDIUM_TO_LARGE";
    /** SMALL: 1 - 50 employees */
    ExternalUserInfoEmployerSize["Small"] = "SMALL";
    /** SMALL_TO_MEDIUM: 51 - 200 employees */
    ExternalUserInfoEmployerSize["SmallToMedium"] = "SMALL_TO_MEDIUM";
})(ExternalUserInfoEmployerSize || (ExternalUserInfoEmployerSize = {}));
/** Same enum as saved-jobs-api's ApplicationStatusState */
export var ExtractedApplicationState;
(function (ExtractedApplicationState) {
    ExtractedApplicationState["Applied"] = "APPLIED";
    ExtractedApplicationState["Hired"] = "HIRED";
    ExtractedApplicationState["Interview"] = "INTERVIEW";
    ExtractedApplicationState["Offer"] = "OFFER";
    ExtractedApplicationState["Rejected"] = "REJECTED";
    ExtractedApplicationState["Reviewed"] = "REVIEWED";
    ExtractedApplicationState["Viewed"] = "VIEWED";
})(ExtractedApplicationState || (ExtractedApplicationState = {}));
/** Enum of application types */
export var ExtractedApplicationType;
(function (ExtractedApplicationType) {
    ExtractedApplicationType["IndeedApply"] = "INDEED_APPLY";
    ExtractedApplicationType["NonIndeedApply"] = "NON_INDEED_APPLY";
})(ExtractedApplicationType || (ExtractedApplicationType = {}));
/** Status codes for file content extraction. */
export var ExtractionStatus;
(function (ExtractionStatus) {
    ExtractionStatus["Failed"] = "FAILED";
    ExtractionStatus["FileTooLarge"] = "FILE_TOO_LARGE";
    ExtractionStatus["Success"] = "SUCCESS";
    ExtractionStatus["TextTooLong"] = "TEXT_TOO_LONG";
    ExtractionStatus["UnsupportedFileType"] = "UNSUPPORTED_FILE_TYPE";
})(ExtractionStatus || (ExtractionStatus = {}));
export var FactSource;
(function (FactSource) {
    FactSource["Profile"] = "PROFILE";
    FactSource["ScreenerQuestion"] = "SCREENER_QUESTION";
    FactSource["UnknownFactSource"] = "UNKNOWN_FACT_SOURCE";
})(FactSource || (FactSource = {}));
/** Visual style variants for feature card elements. */
export var FeatureCardStyle;
(function (FeatureCardStyle) {
    /** Neutral style with minimal background */
    FeatureCardStyle["Neutral"] = "NEUTRAL";
    /** Neutral style with filled background */
    FeatureCardStyle["NeutralFill"] = "NEUTRAL_FILL";
})(FeatureCardStyle || (FeatureCardStyle = {}));
export var FeatureQuotaRefreshInterval;
(function (FeatureQuotaRefreshInterval) {
    FeatureQuotaRefreshInterval["Daily"] = "DAILY";
    FeatureQuotaRefreshInterval["Monthly"] = "MONTHLY";
    FeatureQuotaRefreshInterval["Weekly"] = "WEEKLY";
})(FeatureQuotaRefreshInterval || (FeatureQuotaRefreshInterval = {}));
export var FeaturedBrandingReason;
(function (FeaturedBrandingReason) {
    FeaturedBrandingReason["FeaturedEmployer"] = "FEATURED_EMPLOYER";
    FeaturedBrandingReason["PaidBranding"] = "PAID_BRANDING";
    FeaturedBrandingReason["PremiumSponsorship"] = "PREMIUM_SPONSORSHIP";
})(FeaturedBrandingReason || (FeaturedBrandingReason = {}));
/**
 * Surfaces where jobs can be displayed with branding.
 * Contact the Featured Employer team to add new surfaces or update available branding programs.
 */
export var FeaturedBrandingRequestSource;
(function (FeaturedBrandingRequestSource) {
    /** For Jobs displayed on homepage. */
    FeaturedBrandingRequestSource["Homepage"] = "HOMEPAGE";
    /** For Jobs displayed in the Indeed Apply confirmation email surface. */
    FeaturedBrandingRequestSource["IndeedApplyConfirmationEmail"] = "INDEED_APPLY_CONFIRMATION_EMAIL";
    /** For Jobs displayed in the Indeed Apply view/application form surface. */
    FeaturedBrandingRequestSource["IndeedApplyViewForm"] = "INDEED_APPLY_VIEW_FORM";
    /** For Jobs displayed on SERP. */
    FeaturedBrandingRequestSource["Serp"] = "SERP";
    /** For Jobs displayed on the View Job (job details) page. */
    FeaturedBrandingRequestSource["ViewJob"] = "VIEW_JOB";
})(FeaturedBrandingRequestSource || (FeaturedBrandingRequestSource = {}));
/** Types of branding programs available. */
export var FeaturedBrandingSourceType;
(function (FeaturedBrandingSourceType) {
    /**
     * https://indeed.atlassian.net/wiki/spaces/EMPPMO/pages/299312031/Featured+Employer
     * Featured Employer program
     * Employers meet monthly revenue targets across all Indeed products to qualify.
     */
    FeaturedBrandingSourceType["FeaturedEmployer"] = "FEATURED_EMPLOYER";
    /**
     * https://indeedhuddle.com/huddle/indexed-jobs-branded-boost
     * Branded Boost program - enables consistent SERP and homepage branding by allowing
     * employers to place their company logo on all sponsored and organic indexed jobs.
     */
    FeaturedBrandingSourceType["PaidBranding"] = "PAID_BRANDING";
    /**
     * https://indeedinc.lightning.force.com/lightning/r/Knowledge__kav/ka0Qi000000IuQLIA0/view
     * Premium Sponsorship package includes enhanced branding for jobs.
     */
    FeaturedBrandingSourceType["PremiumSponsorship"] = "PREMIUM_SPONSORSHIP";
})(FeaturedBrandingSourceType || (FeaturedBrandingSourceType = {}));
/** an enum that provides options for feedback */
export var FeedbackForQualificationOptionInput;
(function (FeedbackForQualificationOptionInput) {
    /** The option for qualification already included in the job */
    FeedbackForQualificationOptionInput["AlreadyIncluded"] = "ALREADY_INCLUDED";
    /** The option for qualification not matching the job */
    FeedbackForQualificationOptionInput["DoesntMatchMyJob"] = "DOESNT_MATCH_MY_JOB";
    /** The option for not asking again today */
    FeedbackForQualificationOptionInput["DontAskToday"] = "DONT_ASK_TODAY";
    /** The option for qualification not important for the job */
    FeedbackForQualificationOptionInput["NotImportant"] = "NOT_IMPORTANT";
    /** The option for other reasons */
    FeedbackForQualificationOptionInput["Other"] = "OTHER";
})(FeedbackForQualificationOptionInput || (FeedbackForQualificationOptionInput = {}));
/** Type of jobseeker */
export var FeedbackMatchType;
(function (FeedbackMatchType) {
    FeedbackMatchType["CandidateSubmission"] = "CANDIDATE_SUBMISSION";
    FeedbackMatchType["JobSeeker"] = "JOB_SEEKER";
})(FeedbackMatchType || (FeedbackMatchType = {}));
/** Possible sentiment values */
export var FeedbackSentimentValue;
(function (FeedbackSentimentValue) {
    FeedbackSentimentValue["Negative"] = "NEGATIVE";
    FeedbackSentimentValue["Positive"] = "POSITIVE";
    FeedbackSentimentValue["Undecided"] = "UNDECIDED";
})(FeedbackSentimentValue || (FeedbackSentimentValue = {}));
/** The source of the user input. */
export var FeedbackSource;
(function (FeedbackSource) {
    FeedbackSource["FeedbackEmail"] = "FEEDBACK_EMAIL";
})(FeedbackSource || (FeedbackSource = {}));
/** Groups on which performance can be aggregated. */
export var FetchCampaignPerformancesGroupInput;
(function (FetchCampaignPerformancesGroupInput) {
    /**
     * Performance aggregated on campaign.
     * Campaign identifiers will be present in response payload.
     */
    FetchCampaignPerformancesGroupInput["Campaign"] = "CAMPAIGN";
    /** Performance aggregated on channel. */
    FetchCampaignPerformancesGroupInput["Channel"] = "CHANNEL";
    /** Performance aggregated on device. */
    FetchCampaignPerformancesGroupInput["Device"] = "DEVICE";
    /**
     * Performance aggregated on job.
     * Job identifiers will be present in response payload.
     */
    FetchCampaignPerformancesGroupInput["Job"] = "JOB";
    /** Performance aggregated on traffic. */
    FetchCampaignPerformancesGroupInput["Traffic"] = "TRAFFIC";
})(FetchCampaignPerformancesGroupInput || (FetchCampaignPerformancesGroupInput = {}));
/** Available sort criteria for performance. */
export var FetchCampaignPerformancesSortInput;
(function (FetchCampaignPerformancesSortInput) {
    /** DateTime ascending order. */
    FetchCampaignPerformancesSortInput["TimeAsc"] = "TIME_ASC";
    /** DateTime descending order. */
    FetchCampaignPerformancesSortInput["TimeDesc"] = "TIME_DESC";
})(FetchCampaignPerformancesSortInput || (FetchCampaignPerformancesSortInput = {}));
export var FetchExternalCampaignStatsDataGroupByInput;
(function (FetchExternalCampaignStatsDataGroupByInput) {
    FetchExternalCampaignStatsDataGroupByInput["Job"] = "JOB";
})(FetchExternalCampaignStatsDataGroupByInput || (FetchExternalCampaignStatsDataGroupByInput = {}));
export var FieldNecessity;
(function (FieldNecessity) {
    FieldNecessity["Optional"] = "OPTIONAL";
    FieldNecessity["Required"] = "REQUIRED";
})(FieldNecessity || (FieldNecessity = {}));
/** The field's source */
export var FieldSource;
(function (FieldSource) {
    FieldSource["ExternalAts"] = "EXTERNAL_ATS";
    FieldSource["IndeedAts"] = "INDEED_ATS";
})(FieldSource || (FieldSource = {}));
export var FieldType;
(function (FieldType) {
    FieldType["Checkbox"] = "CHECKBOX";
    FieldType["Container"] = "CONTAINER";
    FieldType["Multiselect"] = "MULTISELECT";
    FieldType["NonEmptyString"] = "NON_EMPTY_STRING";
    FieldType["Number"] = "NUMBER";
    FieldType["Radio"] = "RADIO";
    FieldType["String"] = "STRING";
    FieldType["Text"] = "TEXT";
})(FieldType || (FieldType = {}));
/** Fighting style */
export var FightingStyle;
(function (FightingStyle) {
    FightingStyle["Balanced"] = "BALANCED";
    FightingStyle["Grappler"] = "GRAPPLER";
    FightingStyle["Ground"] = "GROUND";
    FightingStyle["Striker"] = "STRIKER";
})(FightingStyle || (FightingStyle = {}));
/** The anti-virus validation status of the file */
export var FileAntiVirusValidationStatus;
(function (FileAntiVirusValidationStatus) {
    /** The file failed anti-virus validation */
    FileAntiVirusValidationStatus["Failed"] = "FAILED";
    /** The anti-virus validation status is not yet available */
    FileAntiVirusValidationStatus["NotAvailable"] = "NOT_AVAILABLE";
    /** The file passed anti-virus validation */
    FileAntiVirusValidationStatus["Passed"] = "PASSED";
})(FileAntiVirusValidationStatus || (FileAntiVirusValidationStatus = {}));
/** Enum of file extension */
export var FileExtension;
(function (FileExtension) {
    FileExtension["Csv"] = "CSV";
    FileExtension["Xls"] = "XLS";
    FileExtension["Xlsx"] = "XLSX";
})(FileExtension || (FileExtension = {}));
/** The moderation status of the file */
export var FileModerationStatus;
(function (FileModerationStatus) {
    /** The moderation status is not yet available. */
    FileModerationStatus["NotAvailable"] = "NOT_AVAILABLE";
    /** The file has passed moderation */
    FileModerationStatus["Passed"] = "PASSED";
    /** The file got rejected during the moderation */
    FileModerationStatus["Rejected"] = "REJECTED";
})(FileModerationStatus || (FileModerationStatus = {}));
/** The region where the file is physically stored */
export var FileUploadRegion;
(function (FileUploadRegion) {
    FileUploadRegion["ApNortheast_1"] = "AP_NORTHEAST_1";
    FileUploadRegion["EuWest_1"] = "EU_WEST_1";
    FileUploadRegion["UsEast_2"] = "US_EAST_2";
})(FileUploadRegion || (FileUploadRegion = {}));
/** The status of the file upload */
export var FileUploadStatus;
(function (FileUploadStatus) {
    FileUploadStatus["Failed"] = "FAILED";
    FileUploadStatus["Succeeded"] = "SUCCEEDED";
    FileUploadStatus["Uploading"] = "UPLOADING";
    FileUploadStatus["Validating"] = "VALIDATING";
})(FileUploadStatus || (FileUploadStatus = {}));
/** The status of a FileVariation */
export var FileVariationStatus;
(function (FileVariationStatus) {
    /** The variation has successfully processed */
    FileVariationStatus["ProcessCompleted"] = "PROCESS_COMPLETED";
    /** The variation failed to be processed */
    FileVariationStatus["ProcessFailed"] = "PROCESS_FAILED";
    /** The variation is still being processed */
    FileVariationStatus["ProcessInProgress"] = "PROCESS_IN_PROGRESS";
})(FileVariationStatus || (FileVariationStatus = {}));
/**
 * Why a filter could not be genuinely evaluated. Additive: clients should treat an unrecognized code
 * as a generic "filter unavailable".
 */
export var FilterFailureCode;
(function (FilterFailureCode) {
    /**  The filter's own evaluation threw.  */
    FilterFailureCode["EvaluationError"] = "EVALUATION_ERROR";
    /**  A required field's augmenter (upstream data) failed to fetch — typically transient.  */
    FilterFailureCode["FailedToFetchData"] = "FAILED_TO_FETCH_DATA";
})(FilterFailureCode || (FilterFailureCode = {}));
/** Supported product names for subscription filtering. */
export var FinancialToolsSubscriptionProductName;
(function (FinancialToolsSubscriptionProductName) {
    /**
     * Employer Branding Hub product line
     * @deprecated Employer Branding Hub is no longer supported.
     */
    FinancialToolsSubscriptionProductName["EmployerBrandingHub"] = "EMPLOYER_BRANDING_HUB";
    /** Smart Sourcing product line */
    FinancialToolsSubscriptionProductName["SmartSourcing"] = "SMART_SOURCING";
})(FinancialToolsSubscriptionProductName || (FinancialToolsSubscriptionProductName = {}));
export var FindAggregateJobPostsSort;
(function (FindAggregateJobPostsSort) {
    FindAggregateJobPostsSort["JobCountAsc"] = "JOB_COUNT_ASC";
    FindAggregateJobPostsSort["JobCountAvailableAsc"] = "JOB_COUNT_AVAILABLE_ASC";
    FindAggregateJobPostsSort["JobCountAvailableDesc"] = "JOB_COUNT_AVAILABLE_DESC";
    FindAggregateJobPostsSort["JobCountDesc"] = "JOB_COUNT_DESC";
    FindAggregateJobPostsSort["JobCountRejectedAsc"] = "JOB_COUNT_REJECTED_ASC";
    FindAggregateJobPostsSort["JobCountRejectedDesc"] = "JOB_COUNT_REJECTED_DESC";
})(FindAggregateJobPostsSort || (FindAggregateJobPostsSort = {}));
export var FindAwsAccountsSortField;
(function (FindAwsAccountsSortField) {
    FindAwsAccountsSortField["AccountId"] = "ACCOUNT_ID";
    FindAwsAccountsSortField["AccountName"] = "ACCOUNT_NAME";
    FindAwsAccountsSortField["AwsOrganizationName"] = "AWS_ORGANIZATION_NAME";
    FindAwsAccountsSortField["CostCenter"] = "COST_CENTER";
    FindAwsAccountsSortField["Environment"] = "ENVIRONMENT";
})(FindAwsAccountsSortField || (FindAwsAccountsSortField = {}));
/** Fields and Order by which campaigns can be sorted. */
export var FindCampaignsSort;
(function (FindCampaignsSort) {
    FindCampaignsSort["CreatedDatetimeAsc"] = "CREATED_DATETIME_ASC";
    FindCampaignsSort["CreatedDatetimeDesc"] = "CREATED_DATETIME_DESC";
    /** Corresponds to CampaignSchedule.endDateTime */
    FindCampaignsSort["EndDatetimeAsc"] = "END_DATETIME_ASC";
    /** Corresponds to CampaignSchedule.endDateTime */
    FindCampaignsSort["EndDatetimeDesc"] = "END_DATETIME_DESC";
    FindCampaignsSort["NameAsc"] = "NAME_ASC";
    FindCampaignsSort["NameDesc"] = "NAME_DESC";
    /**
     *   Sort by spending eligibility in ascending order.
     *
     * Order: FULL_SPENDING_ELIGIBILITY -> USER_SPENDING_ELIGIBILITY -> FUNDED_PERIOD_ELIGIBILITY -> SCHEDULED_PERIOD_ELIGIBILITY -> PREMIUM_FEATURE_ELIGIBILITY
     *
     * Maps to CampaignSpendingEligibilityEnum values.
     *   Reference: https://indeed.atlassian.net/wiki/x/_YuVEw
     *
     * Note: Spending eligibility is only available for active campaigns. Non-active campaigns
     *   are sorted to the end (for ASC) or beginning (for DESC) of the results.
     *
     * When a campaign has multiple eligibility types, precedence is given according to the
     *   presence of the specified eligibility in the sort order above.
     */
    FindCampaignsSort["SpendingEligibilityAsc"] = "SPENDING_ELIGIBILITY_ASC";
    /**
     *   Sort by spending eligibility in descending order.
     *
     * Order: PREMIUM_FEATURE_ELIGIBILITY -> SCHEDULED_PERIOD_ELIGIBILITY -> FUNDED_PERIOD_ELIGIBILITY -> USER_SPENDING_ELIGIBILITY -> FULL_SPENDING_ELIGIBILITY
     *
     * Maps to CampaignSpendingEligibilityEnum values.
     *   Reference: https://indeed.atlassian.net/wiki/x/_YuVEw
     *
     * Note: Spending eligibility is only available for active campaigns. Non-active campaigns
     *   are sorted to the beginning (for DESC) or end (for ASC) of the results.
     *
     * When a campaign has multiple eligibility types, precedence is given according to the
     *   presence of the specified eligibility in the sort order above.
     */
    FindCampaignsSort["SpendingEligibilityDesc"] = "SPENDING_ELIGIBILITY_DESC";
    /**
     *   Sort by campaign status in ascending order.
     *
     * Order: ACTIVE -> PAUSED -> ARCHIVED
     *
     * Maps to CampaignStatus enum values.
     */
    FindCampaignsSort["StatusAsc"] = "STATUS_ASC";
    /**
     *   Sort by campaign status in descending order.
     *
     * Order: ARCHIVED -> PAUSED -> ACTIVE
     *
     * Maps to CampaignStatus enum values.
     */
    FindCampaignsSort["StatusDesc"] = "STATUS_DESC";
    FindCampaignsSort["UpdatedDatetimeAsc"] = "UPDATED_DATETIME_ASC";
    FindCampaignsSort["UpdatedDatetimeDesc"] = "UPDATED_DATETIME_DESC";
})(FindCampaignsSort || (FindCampaignsSort = {}));
/** Sorting options for finding data reports */
export var FindDataReportsSort;
(function (FindDataReportsSort) {
    /** Sort by creation date in ascending order */
    FindDataReportsSort["DateCreatedAsc"] = "DATE_CREATED_ASC";
    /** Sort by creation date in descending order */
    FindDataReportsSort["DateCreatedDesc"] = "DATE_CREATED_DESC";
    /** Sort by data report name in ascending order */
    FindDataReportsSort["NameAsc"] = "NAME_ASC";
    /** Sort by data report name in descending order */
    FindDataReportsSort["NameDesc"] = "NAME_DESC";
})(FindDataReportsSort || (FindDataReportsSort = {}));
/** Sorting criteria and directions */
export var FindEmployerAnalyticsSavedViewSort;
(function (FindEmployerAnalyticsSavedViewSort) {
    FindEmployerAnalyticsSavedViewSort["SavedviewNameAsc"] = "SAVEDVIEW_NAME_ASC";
    FindEmployerAnalyticsSavedViewSort["SavedviewNameDesc"] = "SAVEDVIEW_NAME_DESC";
})(FindEmployerAnalyticsSavedViewSort || (FindEmployerAnalyticsSavedViewSort = {}));
/** Fields that Employer Hiring Events can be sorted by */
export var FindEmployerHiringEventsSortField;
(function (FindEmployerHiringEventsSortField) {
    FindEmployerHiringEventsSortField["AdvertisingStartDate"] = "ADVERTISING_START_DATE";
    FindEmployerHiringEventsSortField["CreatedDate"] = "CREATED_DATE";
    FindEmployerHiringEventsSortField["EventLocationCity"] = "EVENT_LOCATION_CITY";
    FindEmployerHiringEventsSortField["FirstEventDate"] = "FIRST_EVENT_DATE";
    FindEmployerHiringEventsSortField["NextEventDate"] = "NEXT_EVENT_DATE";
})(FindEmployerHiringEventsSortField || (FindEmployerHiringEventsSortField = {}));
export var FindEmployerJobsApplyMethod;
(function (FindEmployerJobsApplyMethod) {
    FindEmployerJobsApplyMethod["Email"] = "EMAIL";
    FindEmployerJobsApplyMethod["InPerson"] = "IN_PERSON";
    FindEmployerJobsApplyMethod["ThirdPartyIndeedApply"] = "THIRD_PARTY_INDEED_APPLY";
    FindEmployerJobsApplyMethod["Unknown"] = "UNKNOWN";
    /** @deprecated ApplyMethod.URL is a legacy name that has been deprecated. Please use WEBSITE instead. */
    FindEmployerJobsApplyMethod["Url"] = "URL";
    FindEmployerJobsApplyMethod["Website"] = "WEBSITE";
})(FindEmployerJobsApplyMethod || (FindEmployerJobsApplyMethod = {}));
/** Set of keys on which the facets can be sorted on. */
export var FindEmployerJobsFacetSortKeyInput;
(function (FindEmployerJobsFacetSortKeyInput) {
    /** The value that represents the number of jobs under each bucket in the facet */
    FindEmployerJobsFacetSortKeyInput["Count"] = "COUNT";
    /** The value of the unique term that represents a bucket in the facet. */
    FindEmployerJobsFacetSortKeyInput["Label"] = "LABEL";
})(FindEmployerJobsFacetSortKeyInput || (FindEmployerJobsFacetSortKeyInput = {}));
/** Sort direction (ascending or descending). */
export var FindEmployerJobsPartnerSortDirection;
(function (FindEmployerJobsPartnerSortDirection) {
    /** Default. Ascending order (lowest to highest). */
    FindEmployerJobsPartnerSortDirection["Asc"] = "ASC";
    /** Descending order (highest to lowest). */
    FindEmployerJobsPartnerSortDirection["Desc"] = "DESC";
})(FindEmployerJobsPartnerSortDirection || (FindEmployerJobsPartnerSortDirection = {}));
/** Sortable job fields. */
export var FindEmployerJobsPartnerSortField;
(function (FindEmployerJobsPartnerSortField) {
    /** Sorts by publish time on Indeed. */
    FindEmployerJobsPartnerSortField["DatePostedOnIndeed"] = "datePostedOnIndeed";
})(FindEmployerJobsPartnerSortField || (FindEmployerJobsPartnerSortField = {}));
/** Specifies whether a sort key should sort results in an "ascending" or "descending" direction. */
export var FindEmployerJobsSortDirection;
(function (FindEmployerJobsSortDirection) {
    /** An ascending sort -- from the lowest value to highest value. */
    FindEmployerJobsSortDirection["Asc"] = "ASC";
    /** A descending sort -- from the highest value to the lowest value. */
    FindEmployerJobsSortDirection["Desc"] = "DESC";
})(FindEmployerJobsSortDirection || (FindEmployerJobsSortDirection = {}));
export var FindEmployerJobsSortField;
(function (FindEmployerJobsSortField) {
    /** Sort results based on the best match criteria. Most applicable when used with a freeText/title search */
    FindEmployerJobsSortField["BestMatch"] = "bestMatch";
    /** Sort results by the time the job is created in jaseDb (posted to the SERP) */
    FindEmployerJobsSortField["DatePostedOnIndeed"] = "datePostedOnIndeed";
    /** Sort results by hosted job status. ASC order is: ACTIVE, PAUSED, CLOSED, UNKNOWN */
    FindEmployerJobsSortField["HostedJobStatus"] = "hostedJobStatus";
    /** Sort results by apply email */
    FindEmployerJobsSortField["IndeedApplyEmail"] = "indeedApplyEmail";
    /** Sort results by jobTitle */
    FindEmployerJobsSortField["JobTitle"] = "jobTitle";
    /** Sort results by the account id of the user that posted the job. */
    FindEmployerJobsSortField["PostedBy"] = "postedBy";
    /**
     * Sort results by created date
     * @deprecated Please use datePostedOnIndeed instead
     */
    FindEmployerJobsSortField["PostedDate"] = "postedDate";
    /** Sort results by the account id of the user that posted or claimed the job */
    FindEmployerJobsSortField["PostedOrClaimedBy"] = "postedOrClaimedBy";
    /** Sort results by referenceId */
    FindEmployerJobsSortField["ReferenceId"] = "referenceId";
    /** *Experimental*. This field may change as the job lifecycle is more clearly defined, but this is a first-pass at unification. ASC order is: ACTIVE hosted jobs, jobs without a hosted jobs status (i.e. agg jobs), PAUSED hosted jobs, CLOSED hosted jobs. */
    FindEmployerJobsSortField["UnifiedJobStatus"] = "unifiedJobStatus";
})(FindEmployerJobsSortField || (FindEmployerJobsSortField = {}));
/** Applies default filters with user-supplied filters. */
export var FindEmployerJobsWithSimpleFiltersBaseFilterInput;
(function (FindEmployerJobsWithSimpleFiltersBaseFilterInput) {
    /** Default: Gets all `OPEN` and `PAUSED` jobs. */
    FindEmployerJobsWithSimpleFiltersBaseFilterInput["AllJobsOpenPaused"] = "ALL_JOBS_OPEN_PAUSED";
    /** Gets only jobs eligible for Basic Screening enrollment. */
    FindEmployerJobsWithSimpleFiltersBaseFilterInput["BasicScreeningEligibleJobs"] = "BASIC_SCREENING_ELIGIBLE_JOBS";
    /** Gets only jobs eligible for Nexus enrollment. */
    FindEmployerJobsWithSimpleFiltersBaseFilterInput["NexusEligibleJobs"] = "NEXUS_ELIGIBLE_JOBS";
})(FindEmployerJobsWithSimpleFiltersBaseFilterInput || (FindEmployerJobsWithSimpleFiltersBaseFilterInput = {}));
/** Supported facets. */
export var FindEmployerJobsWithSimpleFiltersFacetField;
(function (FindEmployerJobsWithSimpleFiltersFacetField) {
    FindEmployerJobsWithSimpleFiltersFacetField["DescriptionHashtags"] = "descriptionHashtags";
    FindEmployerJobsWithSimpleFiltersFacetField["Location"] = "location";
    FindEmployerJobsWithSimpleFiltersFacetField["PostedOrClaimedBy"] = "postedOrClaimedBy";
    FindEmployerJobsWithSimpleFiltersFacetField["SourceId"] = "sourceId";
})(FindEmployerJobsWithSimpleFiltersFacetField || (FindEmployerJobsWithSimpleFiltersFacetField = {}));
/** Sponsorship status of a job. */
export var FindEmployerJobsWithSimpleFiltersSponsorshipStatus;
(function (FindEmployerJobsWithSimpleFiltersSponsorshipStatus) {
    FindEmployerJobsWithSimpleFiltersSponsorshipStatus["Free"] = "FREE";
    FindEmployerJobsWithSimpleFiltersSponsorshipStatus["Sponsored"] = "SPONSORED";
})(FindEmployerJobsWithSimpleFiltersSponsorshipStatus || (FindEmployerJobsWithSimpleFiltersSponsorshipStatus = {}));
/** Matched type of search term */
export var FindEmployersWhatType;
(function (FindEmployersWhatType) {
    FindEmployersWhatType["EmployerName"] = "EMPLOYER_NAME";
    FindEmployersWhatType["JobCategory"] = "JOB_CATEGORY";
    FindEmployersWhatType["JobTitle"] = "JOB_TITLE";
})(FindEmployersWhatType || (FindEmployersWhatType = {}));
/** Matched type of location term */
export var FindEmployersWhereType;
(function (FindEmployersWhereType) {
    FindEmployersWhereType["Admin1"] = "ADMIN1";
    FindEmployersWhereType["Admin2"] = "ADMIN2";
    FindEmployersWhereType["Admin3"] = "ADMIN3";
    FindEmployersWhereType["Admin4"] = "ADMIN4";
    FindEmployersWhereType["City"] = "CITY";
    FindEmployersWhereType["Country"] = "COUNTRY";
})(FindEmployersWhereType || (FindEmployersWhereType = {}));
/** Represents the enumeration for sorting invoices dataset */
export var FindInvoicesSort;
(function (FindInvoicesSort) {
    FindInvoicesSort["AdjustmentAmountAsc"] = "ADJUSTMENT_AMOUNT_ASC";
    FindInvoicesSort["AdjustmentAmountDesc"] = "ADJUSTMENT_AMOUNT_DESC";
    FindInvoicesSort["AmountAsc"] = "AMOUNT_ASC";
    FindInvoicesSort["AmountDesc"] = "AMOUNT_DESC";
    FindInvoicesSort["CompanyNameAsc"] = "COMPANY_NAME_ASC";
    FindInvoicesSort["CompanyNameDesc"] = "COMPANY_NAME_DESC";
    FindInvoicesSort["CurrencyAsc"] = "CURRENCY_ASC";
    FindInvoicesSort["CurrencyDesc"] = "CURRENCY_DESC";
    FindInvoicesSort["DiscountAmountAsc"] = "DISCOUNT_AMOUNT_ASC";
    FindInvoicesSort["DiscountAmountDesc"] = "DISCOUNT_AMOUNT_DESC";
    FindInvoicesSort["DiscountRateAsc"] = "DISCOUNT_RATE_ASC";
    FindInvoicesSort["DiscountRateDesc"] = "DISCOUNT_RATE_DESC";
    FindInvoicesSort["DueDateAsc"] = "DUE_DATE_ASC";
    FindInvoicesSort["DueDateDesc"] = "DUE_DATE_DESC";
    FindInvoicesSort["EmployerIdAsc"] = "EMPLOYER_ID_ASC";
    FindInvoicesSort["EmployerIdDesc"] = "EMPLOYER_ID_DESC";
    FindInvoicesSort["InvoiceDateAsc"] = "INVOICE_DATE_ASC";
    FindInvoicesSort["InvoiceDateDesc"] = "INVOICE_DATE_DESC";
    FindInvoicesSort["InvoiceNumberAsc"] = "INVOICE_NUMBER_ASC";
    FindInvoicesSort["InvoiceNumberDesc"] = "INVOICE_NUMBER_DESC";
    FindInvoicesSort["IoNumberAsc"] = "IO_NUMBER_ASC";
    FindInvoicesSort["IoNumberDesc"] = "IO_NUMBER_DESC";
    FindInvoicesSort["OwnerEmailAsc"] = "OWNER_EMAIL_ASC";
    FindInvoicesSort["OwnerEmailDesc"] = "OWNER_EMAIL_DESC";
    FindInvoicesSort["PaymentStatusAsc"] = "PAYMENT_STATUS_ASC";
    FindInvoicesSort["PaymentStatusDesc"] = "PAYMENT_STATUS_DESC";
    FindInvoicesSort["PoNumberAsc"] = "PO_NUMBER_ASC";
    FindInvoicesSort["PoNumberDesc"] = "PO_NUMBER_DESC";
    FindInvoicesSort["ProductNameAsc"] = "PRODUCT_NAME_ASC";
    FindInvoicesSort["ProductNameDesc"] = "PRODUCT_NAME_DESC";
    FindInvoicesSort["PromotionAmountAsc"] = "PROMOTION_AMOUNT_ASC";
    FindInvoicesSort["PromotionAmountDesc"] = "PROMOTION_AMOUNT_DESC";
    FindInvoicesSort["ServiceAmountAsc"] = "SERVICE_AMOUNT_ASC";
    FindInvoicesSort["ServiceAmountDesc"] = "SERVICE_AMOUNT_DESC";
    FindInvoicesSort["TaxAmountAsc"] = "TAX_AMOUNT_ASC";
    FindInvoicesSort["TaxAmountDesc"] = "TAX_AMOUNT_DESC";
})(FindInvoicesSort || (FindInvoicesSort = {}));
/** Input for sort, multiple options can be applied */
export var FindJpCorporateNumberSort;
(function (FindJpCorporateNumberSort) {
    /** Sort by corporate number */
    FindJpCorporateNumberSort["CorporateNumber"] = "CORPORATE_NUMBER";
    /** Sort by location codes */
    FindJpCorporateNumberSort["Location"] = "LOCATION";
    /** Sort by relavance score */
    FindJpCorporateNumberSort["Relevance"] = "RELEVANCE";
})(FindJpCorporateNumberSort || (FindJpCorporateNumberSort = {}));
export var FindJobPostsSort;
(function (FindJobPostsSort) {
    FindJobPostsSort["JobCreateDateAsc"] = "JOB_CREATE_DATE_ASC";
    FindJobPostsSort["JobCreateDateDesc"] = "JOB_CREATE_DATE_DESC";
    FindJobPostsSort["JobStatusAsc"] = "JOB_STATUS_ASC";
    FindJobPostsSort["JobStatusDesc"] = "JOB_STATUS_DESC";
})(FindJobPostsSort || (FindJobPostsSort = {}));
export var FindJobPostsSurfaceStatusType;
(function (FindJobPostsSurfaceStatusType) {
    /**
     * Job is available on the surface based on all availability factors, and does not
     * violate restrictions on content, inventory, sponsorship, brand, etc.
     */
    FindJobPostsSurfaceStatusType["Available"] = "AVAILABLE";
    /**
     * Job requires sponsorship to be available on the surface, but is not sponsored, or
     * not sponsored to the extent required by the surface
     */
    FindJobPostsSurfaceStatusType["MissingRequiredSponsorship"] = "MISSING_REQUIRED_SPONSORSHIP";
    /**
     * Job is unavailable on the surface due to policy or job inventory restrictions,
     * such as job content, legal, sponsorship, job volume, brand identity, etc.
     */
    FindJobPostsSurfaceStatusType["Rejected"] = "REJECTED";
    /**
     * Job requires sponsorship to be available on the surface. Jobs subject
     * to sponsorship requirements will still show as "requires sponsorship"
     * even once sponsored, and will show as "available" if all other requirements
     * are also met.
     */
    FindJobPostsSurfaceStatusType["RequiresSponsorship"] = "REQUIRES_SPONSORSHIP";
})(FindJobPostsSurfaceStatusType || (FindJobPostsSurfaceStatusType = {}));
export var FindJobseekerInterviewsSortField;
(function (FindJobseekerInterviewsSortField) {
    FindJobseekerInterviewsSortField["CreatedAt"] = "CREATED_AT";
})(FindJobseekerInterviewsSortField || (FindJobseekerInterviewsSortField = {}));
export var FindJobseekerInterviewsSortOrder;
(function (FindJobseekerInterviewsSortOrder) {
    FindJobseekerInterviewsSortOrder["Ascending"] = "ASCENDING";
    FindJobseekerInterviewsSortOrder["Descending"] = "DESCENDING";
})(FindJobseekerInterviewsSortOrder || (FindJobseekerInterviewsSortOrder = {}));
/** Sort options for findLibraryBooks */
export var FindLibraryBooksSort;
(function (FindLibraryBooksSort) {
    FindLibraryBooksSort["PublishedYearAsc"] = "PUBLISHED_YEAR_ASC";
    FindLibraryBooksSort["PublishedYearDesc"] = "PUBLISHED_YEAR_DESC";
    FindLibraryBooksSort["TitleAsc"] = "TITLE_ASC";
    FindLibraryBooksSort["TitleDesc"] = "TITLE_DESC";
})(FindLibraryBooksSort || (FindLibraryBooksSort = {}));
/** Sort options for data asset search results */
export var FindMetadataCatalogDataAssetsSort;
(function (FindMetadataCatalogDataAssetsSort) {
    /** Sort by categorical cost average category in ascending order */
    FindMetadataCatalogDataAssetsSort["CategoricalCostAsc"] = "CATEGORICAL_COST_ASC";
    /** Sort by categorical cost average category in descending order */
    FindMetadataCatalogDataAssetsSort["CategoricalCostDesc"] = "CATEGORICAL_COST_DESC";
    /** Sort by categorical reach average category in ascending order */
    FindMetadataCatalogDataAssetsSort["CategoricalReachAsc"] = "CATEGORICAL_REACH_ASC";
    /** Sort by categorical reach average category in descending order */
    FindMetadataCatalogDataAssetsSort["CategoricalReachDesc"] = "CATEGORICAL_REACH_DESC";
    /** Sort by categorical usage category in ascending order */
    FindMetadataCatalogDataAssetsSort["CategoricalUsageAsc"] = "CATEGORICAL_USAGE_ASC";
    /** Sort by categorical usage category in descending order */
    FindMetadataCatalogDataAssetsSort["CategoricalUsageDesc"] = "CATEGORICAL_USAGE_DESC";
    /** Default sort order */
    FindMetadataCatalogDataAssetsSort["DefaultSortOrder"] = "DEFAULT_SORT_ORDER";
    /** Sort by number of queries in ascending order */
    FindMetadataCatalogDataAssetsSort["HumanQueriesAsc"] = "HUMAN_QUERIES_ASC";
    /** Sort by number of queries in descending order */
    FindMetadataCatalogDataAssetsSort["HumanQueriesDesc"] = "HUMAN_QUERIES_DESC";
    /** Sort by number of users in ascending order */
    FindMetadataCatalogDataAssetsSort["HumanUsersAsc"] = "HUMAN_USERS_ASC";
    /** Sort by number of human users in descending order */
    FindMetadataCatalogDataAssetsSort["HumanUsersDesc"] = "HUMAN_USERS_DESC";
})(FindMetadataCatalogDataAssetsSort || (FindMetadataCatalogDataAssetsSort = {}));
export var FindNoticesSort;
(function (FindNoticesSort) {
    FindNoticesSort["CreatedTimestamp"] = "CREATED_TIMESTAMP";
    FindNoticesSort["CreatedTimestampDesc"] = "CREATED_TIMESTAMP_DESC";
    FindNoticesSort["EndDateExclusive"] = "END_DATE_EXCLUSIVE";
    FindNoticesSort["EndDateExclusiveDesc"] = "END_DATE_EXCLUSIVE_DESC";
    FindNoticesSort["LastUpdatedTimestamp"] = "LAST_UPDATED_TIMESTAMP";
    FindNoticesSort["LastUpdatedTimestampDesc"] = "LAST_UPDATED_TIMESTAMP_DESC";
    FindNoticesSort["StartDateInclusive"] = "START_DATE_INCLUSIVE";
    FindNoticesSort["StartDateInclusiveDesc"] = "START_DATE_INCLUSIVE_DESC";
})(FindNoticesSort || (FindNoticesSort = {}));
/** Enum input to filter WorkedShifts based on approval value */
export var FindWorkedShiftsApprovedFilter;
(function (FindWorkedShiftsApprovedFilter) {
    FindWorkedShiftsApprovedFilter["All"] = "ALL";
    FindWorkedShiftsApprovedFilter["Approved"] = "APPROVED";
    FindWorkedShiftsApprovedFilter["NotApproved"] = "NOT_APPROVED";
})(FindWorkedShiftsApprovedFilter || (FindWorkedShiftsApprovedFilter = {}));
/** Enum input to filter WorkedShifts based on deleted value */
export var FindWorkedShiftsDeletedFilter;
(function (FindWorkedShiftsDeletedFilter) {
    FindWorkedShiftsDeletedFilter["All"] = "ALL";
    FindWorkedShiftsDeletedFilter["Deleted"] = "DELETED";
    FindWorkedShiftsDeletedFilter["NotDeleted"] = "NOT_DELETED";
})(FindWorkedShiftsDeletedFilter || (FindWorkedShiftsDeletedFilter = {}));
/** Filter to allow finding WorkedShifts by the reason it was flagged */
export var FindWorkedShiftsFlaggedForReviewReasonFilter;
(function (FindWorkedShiftsFlaggedForReviewReasonFilter) {
    FindWorkedShiftsFlaggedForReviewReasonFilter["Location"] = "LOCATION";
    FindWorkedShiftsFlaggedForReviewReasonFilter["NoShow"] = "NO_SHOW";
    FindWorkedShiftsFlaggedForReviewReasonFilter["Time"] = "TIME";
})(FindWorkedShiftsFlaggedForReviewReasonFilter || (FindWorkedShiftsFlaggedForReviewReasonFilter = {}));
/**
 * Filter to allow finding WorkedShifts with flexibility to:
 * - return WORKER versions if exists, else nothing
 * - return WORKER versions if exists, else CLIENT if exists
 * - return CLIENT versions if exists, else nothing
 * - return CLIENT versions if exists, else WORKER if exists
 * - return WORKER and CLIENT versions
 *
 * The default behavior for querying for WorkedShifts across the platform is to:
 * - try to find the requested subject (e.g. WORKER)
 * - if it doesn't exist, try to find the other subject (e.g. CLIENT)
 * So conceptually:
 * - querying for WorkedShifts as a Worker should probably filter by WORKER_ELSE_CLIENT
 * - querying for WorkedShifts as a Client should probably filter by CLIENT_ELSE_WORKER
 */
export var FindWorkedShiftsSubjectFilter;
(function (FindWorkedShiftsSubjectFilter) {
    FindWorkedShiftsSubjectFilter["ClientAndWorker"] = "CLIENT_AND_WORKER";
    FindWorkedShiftsSubjectFilter["ClientElseWorker"] = "CLIENT_ELSE_WORKER";
    FindWorkedShiftsSubjectFilter["ClientOnly"] = "CLIENT_ONLY";
    FindWorkedShiftsSubjectFilter["WorkerElseClient"] = "WORKER_ELSE_CLIENT";
    FindWorkedShiftsSubjectFilter["WorkerOnly"] = "WORKER_ONLY";
})(FindWorkedShiftsSubjectFilter || (FindWorkedShiftsSubjectFilter = {}));
export var FitQualityState;
(function (FitQualityState) {
    FitQualityState["Active"] = "ACTIVE";
    FitQualityState["Flagged"] = "FLAGGED";
    FitQualityState["Unknown"] = "UNKNOWN";
})(FitQualityState || (FitQualityState = {}));
/** Denotes the action to take on a client worker waiver */
export var FlexClientWorkerWaiverAction;
(function (FlexClientWorkerWaiverAction) {
    FlexClientWorkerWaiverAction["Completed"] = "COMPLETED";
    FlexClientWorkerWaiverAction["Withdrawn"] = "WITHDRAWN";
})(FlexClientWorkerWaiverAction || (FlexClientWorkerWaiverAction = {}));
/**
 * Categories of modifier that can apply on top of a placement margin's base value (output variant).
 * Mirrors the placement_margin_modifiers.modifier_kind check constraint on the DB side.
 */
export var FlexMarginModifierKind;
(function (FlexMarginModifierKind) {
    /** AWR-parity adjustment (equalises agency-worker pay against direct-employee parity rate). */
    FlexMarginModifierKind["AwrParity"] = "AWR_PARITY";
    /** Premium-pay adjustment (uplifts for overtime / out-of-hours / client-overtime bill codes). */
    FlexMarginModifierKind["PremiumPay"] = "PREMIUM_PAY";
    /** Tenure-discount adjustment (signed-negative reduction once a worker passes a tenure threshold). */
    FlexMarginModifierKind["TenureDiscount"] = "TENURE_DISCOUNT";
})(FlexMarginModifierKind || (FlexMarginModifierKind = {}));
/**
 * Input variant of FlexMarginModifierKind. Split from the output enum so the input and
 * output value sets can evolve independently (OneGraph convention).
 */
export var FlexMarginModifierKindInput;
(function (FlexMarginModifierKindInput) {
    /** AWR-parity adjustment (equalises agency-worker pay against direct-employee parity rate). */
    FlexMarginModifierKindInput["AwrParity"] = "AWR_PARITY";
    /** Premium-pay adjustment (uplifts for overtime / out-of-hours / client-overtime bill codes). */
    FlexMarginModifierKindInput["PremiumPay"] = "PREMIUM_PAY";
    /** Tenure-discount adjustment (signed-negative reduction once a worker passes a tenure threshold). */
    FlexMarginModifierKindInput["TenureDiscount"] = "TENURE_DISCOUNT";
})(FlexMarginModifierKindInput || (FlexMarginModifierKindInput = {}));
/** Source of rate changes for tracking and audit purposes */
export var FlexRateSource;
(function (FlexRateSource) {
    /** Admin edit timesheet */
    FlexRateSource["AdminEditTimesheet"] = "ADMIN_EDIT_TIMESHEET";
    /** Rate context when worker applied to shifts */
    FlexRateSource["Applied"] = "APPLIED";
    /** Rate was automatically uplifted by system rules */
    FlexRateSource["AutomaticRateUplift"] = "AUTOMATIC_RATE_UPLIFT";
    /** Rate context when worker booked shifts */
    FlexRateSource["Booked"] = "BOOKED";
    /** Rate was set directly by client/employer */
    FlexRateSource["Client"] = "CLIENT";
    /** Generic correction */
    FlexRateSource["Correction"] = "CORRECTION";
    /** Granular shift edit */
    FlexRateSource["GranularShiftEdit"] = "GRANULAR_SHIFT_EDIT";
    /** Job attributes changed (e.g. location, role, skill changes on the job/shift) */
    FlexRateSource["JobChanged"] = "JOB_CHANGED";
    /** Rate was derived from rate card resolution */
    FlexRateSource["RateCard"] = "RATE_CARD";
    /** Rate correction flow */
    FlexRateSource["RateCorrected"] = "RATE_CORRECTED";
})(FlexRateSource || (FlexRateSource = {}));
/** Strategy for cascading shift-level rate changes to worker-level rates */
export var FlexShiftRateCascadeStrategy;
(function (FlexShiftRateCascadeStrategy) {
    /** Always update worker shift rates to match the new shift rate */
    FlexShiftRateCascadeStrategy["Always"] = "ALWAYS";
    /** Only update worker shift rates if the new rate is higher than current worker rate */
    FlexShiftRateCascadeStrategy["Increase"] = "INCREASE";
    /** Never update worker shift rates, only update shift rates */
    FlexShiftRateCascadeStrategy["Never"] = "NEVER";
})(FlexShiftRateCascadeStrategy || (FlexShiftRateCascadeStrategy = {}));
/**
 * Flex worker tier levels in the rewards programme.
 * Represents the different tiers workers can achieve based on their activity and performance.
 */
export var FlexTier;
(function (FlexTier) {
    /**
     * Bronze tier.
     * First reward tier above Starter.
     */
    FlexTier["Bronze"] = "BRONZE";
    /**
     * Gold tier.
     * Higher-level reward tier.
     */
    FlexTier["Gold"] = "GOLD";
    /**
     * Platinum tier.
     * Top-level reward tier.
     */
    FlexTier["Platinum"] = "PLATINUM";
    /**
     * Silver tier.
     * Mid-level reward tier.
     */
    FlexTier["Silver"] = "SILVER";
    /**
     * Starter tier (default).
     * The starting tier for all workers.
     */
    FlexTier["Starter"] = "STARTER";
})(FlexTier || (FlexTier = {}));
/** Denotes the type of waiver */
export var FlexWaiverType;
(function (FlexWaiverType) {
    FlexWaiverType["Nevada_410Waiver"] = "NEVADA_410_WAIVER";
})(FlexWaiverType || (FlexWaiverType = {}));
export var FormattingAlgorithm;
(function (FormattingAlgorithm) {
    FormattingAlgorithm["SrfAggV1"] = "SRF_AGG_V1";
    FormattingAlgorithm["SrfAggV2"] = "SRF_AGG_V2";
    FormattingAlgorithm["SrfDradisV1"] = "SRF_DRADIS_V1";
    FormattingAlgorithm["SrfDradisV2"] = "SRF_DRADIS_V2";
    FormattingAlgorithm["Unknown"] = "UNKNOWN";
})(FormattingAlgorithm || (FormattingAlgorithm = {}));
export var Frequency;
(function (Frequency) {
    Frequency["Daily"] = "DAILY";
    Frequency["Monthly"] = "MONTHLY";
    Frequency["Quarterly"] = "QUARTERLY";
    Frequency["Weekly"] = "WEEKLY";
})(Frequency || (Frequency = {}));
export var FundingSource;
(function (FundingSource) {
    FundingSource["Advertiser"] = "ADVERTISER";
    FundingSource["EaCredit"] = "EA_CREDIT";
})(FundingSource || (FundingSource = {}));
export var Gender;
(function (Gender) {
    Gender["Female"] = "FEMALE";
    Gender["Male"] = "MALE";
    Gender["None"] = "NONE";
})(Gender || (Gender = {}));
/** Variants of the GenderDecoder optimization */
export var GenderDecoderOptimizationVariant;
(function (GenderDecoderOptimizationVariant) {
    GenderDecoderOptimizationVariant["GenderDecoderOptimizationVariantDefault"] = "GENDER_DECODER_OPTIMIZATION_VARIANT_DEFAULT";
})(GenderDecoderOptimizationVariant || (GenderDecoderOptimizationVariant = {}));
export var GenerateAiResumeSummaryModels;
(function (GenerateAiResumeSummaryModels) {
    GenerateAiResumeSummaryModels["Gpt4O"] = "GPT4O";
    GenerateAiResumeSummaryModels["Gpt4Omini"] = "GPT4OMINI";
    /** @deprecated Penguin is no longer supported. Results will automatically use GPT4OMMini */
    GenerateAiResumeSummaryModels["Penguin"] = "PENGUIN";
})(GenerateAiResumeSummaryModels || (GenerateAiResumeSummaryModels = {}));
export var GeographyType;
(function (GeographyType) {
    GeographyType["Cities"] = "CITIES";
    GeographyType["Counties"] = "COUNTIES";
    GeographyType["Metros"] = "METROS";
    GeographyType["Provinces"] = "PROVINCES";
    GeographyType["Regions"] = "REGIONS";
    GeographyType["States"] = "STATES";
})(GeographyType || (GeographyType = {}));
/** Details report sort by options */
export var GetSocialImpactPartnersReportDetailSortBy;
(function (GetSocialImpactPartnersReportDetailSortBy) {
    GetSocialImpactPartnersReportDetailSortBy["Date"] = "DATE";
    GetSocialImpactPartnersReportDetailSortBy["Employer"] = "EMPLOYER";
    GetSocialImpactPartnersReportDetailSortBy["LearnerName"] = "LEARNER_NAME";
})(GetSocialImpactPartnersReportDetailSortBy || (GetSocialImpactPartnersReportDetailSortBy = {}));
/** Details report source information */
export var GetSocialImpactPartnersReportDetailSource;
(function (GetSocialImpactPartnersReportDetailSource) {
    GetSocialImpactPartnersReportDetailSource["Applications"] = "APPLICATIONS";
    GetSocialImpactPartnersReportDetailSource["EmployerContacts"] = "EMPLOYER_CONTACTS";
    GetSocialImpactPartnersReportDetailSource["Hires"] = "HIRES";
    GetSocialImpactPartnersReportDetailSource["Interviews"] = "INTERVIEWS";
    GetSocialImpactPartnersReportDetailSource["LearnersCompletedFlow"] = "LEARNERS_COMPLETED_FLOW";
    GetSocialImpactPartnersReportDetailSource["LearnersOnboarded"] = "LEARNERS_ONBOARDED";
    GetSocialImpactPartnersReportDetailSource["SkillConnectResumes"] = "SKILL_CONNECT_RESUMES";
})(GetSocialImpactPartnersReportDetailSource || (GetSocialImpactPartnersReportDetailSource = {}));
export var GhostwriterApplicationStatus;
(function (GhostwriterApplicationStatus) {
    GhostwriterApplicationStatus["AnalyzingJob"] = "ANALYZING_JOB";
    GhostwriterApplicationStatus["Applied"] = "APPLIED";
    GhostwriterApplicationStatus["AutoApplyCancelled"] = "AUTO_APPLY_CANCELLED";
    GhostwriterApplicationStatus["AutoApplyFailed"] = "AUTO_APPLY_FAILED";
    GhostwriterApplicationStatus["AwaitingUserIntervention"] = "AWAITING_USER_INTERVENTION";
    GhostwriterApplicationStatus["FillingOutApplication"] = "FILLING_OUT_APPLICATION";
    GhostwriterApplicationStatus["MissingRequiredInfo"] = "MISSING_REQUIRED_INFO";
    GhostwriterApplicationStatus["ReadyToReview"] = "READY_TO_REVIEW";
    GhostwriterApplicationStatus["RetryPendingCaptcha"] = "RETRY_PENDING_CAPTCHA";
    GhostwriterApplicationStatus["SubmissionFailed"] = "SUBMISSION_FAILED";
    GhostwriterApplicationStatus["SubmittingApplication"] = "SUBMITTING_APPLICATION";
})(GhostwriterApplicationStatus || (GhostwriterApplicationStatus = {}));
export var GhostwriterAutocompleteType;
(function (GhostwriterAutocompleteType) {
    GhostwriterAutocompleteType["City"] = "CITY";
    GhostwriterAutocompleteType["CityState"] = "CITY_STATE";
    GhostwriterAutocompleteType["State"] = "STATE";
})(GhostwriterAutocompleteType || (GhostwriterAutocompleteType = {}));
export var GhostwriterConditionOperator;
(function (GhostwriterConditionOperator) {
    GhostwriterConditionOperator["Eq"] = "EQ";
    GhostwriterConditionOperator["Ne"] = "NE";
})(GhostwriterConditionOperator || (GhostwriterConditionOperator = {}));
export var GhostwriterFormFieldType;
(function (GhostwriterFormFieldType) {
    GhostwriterFormFieldType["Checkbox"] = "CHECKBOX";
    GhostwriterFormFieldType["Date"] = "DATE";
    GhostwriterFormFieldType["Email"] = "EMAIL";
    GhostwriterFormFieldType["File"] = "FILE";
    GhostwriterFormFieldType["Information"] = "INFORMATION";
    GhostwriterFormFieldType["Radio"] = "RADIO";
    GhostwriterFormFieldType["Select"] = "SELECT";
    GhostwriterFormFieldType["Tel"] = "TEL";
    GhostwriterFormFieldType["Text"] = "TEXT";
    GhostwriterFormFieldType["Textarea"] = "TEXTAREA";
})(GhostwriterFormFieldType || (GhostwriterFormFieldType = {}));
export var GhostwriterInterventionKind;
(function (GhostwriterInterventionKind) {
    GhostwriterInterventionKind["Captcha"] = "CAPTCHA";
    GhostwriterInterventionKind["TwoFactor"] = "TWO_FACTOR";
    GhostwriterInterventionKind["Unknown"] = "UNKNOWN";
})(GhostwriterInterventionKind || (GhostwriterInterventionKind = {}));
export var GhostwriterParsingStatus;
(function (GhostwriterParsingStatus) {
    GhostwriterParsingStatus["PageLoadBlocked"] = "PAGE_LOAD_BLOCKED";
    GhostwriterParsingStatus["ParsedSuccessfully"] = "PARSED_SUCCESSFULLY";
    GhostwriterParsingStatus["Parsing"] = "PARSING";
    GhostwriterParsingStatus["ParsingFailed"] = "PARSING_FAILED";
    GhostwriterParsingStatus["PendingParsing"] = "PENDING_PARSING";
    GhostwriterParsingStatus["RequiresAuth"] = "REQUIRES_AUTH";
})(GhostwriterParsingStatus || (GhostwriterParsingStatus = {}));
export var GhostwriterResponseSource;
(function (GhostwriterResponseSource) {
    /** The value was generated by the language model from the user's profile and the job context. */
    GhostwriterResponseSource["AiInferred"] = "AI_INFERRED";
    /** The value was filled deterministically from the user's profile, bypassing the language model so it is never sent to LLMProxy. */
    GhostwriterResponseSource["ProfileDirect"] = "PROFILE_DIRECT";
    /** The value was intentionally left blank because the field is protected or sensitive; the user must complete it. Distinct from an AI_INFERRED blank, where the language model returned nothing. */
    GhostwriterResponseSource["Skipped"] = "SKIPPED";
    /** The value was entered or edited by the user. */
    GhostwriterResponseSource["UserAdded"] = "USER_ADDED";
})(GhostwriterResponseSource || (GhostwriterResponseSource = {}));
export var GhostwriterValidationInputType;
(function (GhostwriterValidationInputType) {
    GhostwriterValidationInputType["PostalCode"] = "POSTAL_CODE";
    GhostwriterValidationInputType["SocialSecurityNumber"] = "SOCIAL_SECURITY_NUMBER";
})(GhostwriterValidationInputType || (GhostwriterValidationInputType = {}));
export var GhostwriterValidationStatus;
(function (GhostwriterValidationStatus) {
    GhostwriterValidationStatus["Invalid"] = "INVALID";
    GhostwriterValidationStatus["Pending"] = "PENDING";
    GhostwriterValidationStatus["Valid"] = "VALID";
})(GhostwriterValidationStatus || (GhostwriterValidationStatus = {}));
/** Current epProvisioningApiOperation of the Subscription */
export var GlassdoorEpProvisioningApiOperation;
(function (GlassdoorEpProvisioningApiOperation) {
    GlassdoorEpProvisioningApiOperation["Cancellation"] = "CANCELLATION";
    GlassdoorEpProvisioningApiOperation["Provisioning"] = "PROVISIONING";
})(GlassdoorEpProvisioningApiOperation || (GlassdoorEpProvisioningApiOperation = {}));
/** Current Ep status of the Subscription */
export var GlassdoorEpStatus;
(function (GlassdoorEpStatus) {
    GlassdoorEpStatus["Active"] = "ACTIVE";
    GlassdoorEpStatus["Cancelled"] = "CANCELLED";
    GlassdoorEpStatus["ErrorCancellation"] = "ERROR_CANCELLATION";
    GlassdoorEpStatus["ErrorCreation"] = "ERROR_CREATION";
    GlassdoorEpStatus["Expired"] = "EXPIRED";
    GlassdoorEpStatus["ProcessingCancellation"] = "PROCESSING_CANCELLATION";
    GlassdoorEpStatus["ProcessingCreation"] = "PROCESSING_CREATION";
    GlassdoorEpStatus["Scheduled"] = "SCHEDULED";
})(GlassdoorEpStatus || (GlassdoorEpStatus = {}));
/** Enumeration of goto url type values */
export var GoToUrlType;
(function (GoToUrlType) {
    GoToUrlType["CompanyPage"] = "COMPANY_PAGE";
    GoToUrlType["CompanyPageJobsTab"] = "COMPANY_PAGE_JOBS_TAB";
    GoToUrlType["ExternalUrl"] = "EXTERNAL_URL";
    GoToUrlType["Glassdoor"] = "GLASSDOOR";
    GoToUrlType["HiringEventUrl"] = "HIRING_EVENT_URL";
    GoToUrlType["JobUrl"] = "JOB_URL";
    GoToUrlType["Other"] = "OTHER";
    GoToUrlType["SerpJobsUrl"] = "SERP_JOBS_URL";
    GoToUrlType["Unknown"] = "UNKNOWN";
})(GoToUrlType || (GoToUrlType = {}));
/** Error codes that can be returned in the response 'errors' array. */
export var GrantAdvertiserPromoError;
(function (GrantAdvertiserPromoError) {
    /** If the advertiser is not eligible to claim the promotion code. */
    GrantAdvertiserPromoError["AdvertiserNotEligible"] = "ADVERTISER_NOT_ELIGIBLE";
    /** If the provided creditValue is above the approved credit value for the promotion code or 0. */
    GrantAdvertiserPromoError["CreditValueNotValid"] = "CREDIT_VALUE_NOT_VALID";
    /** If the provided daysUntilExpiration is above the maximum limit of 730 or 0. */
    GrantAdvertiserPromoError["DaysUntilExpirationNotValid"] = "DAYS_UNTIL_EXPIRATION_NOT_VALID";
    /** If the job does not meet the eligibility requirements. */
    GrantAdvertiserPromoError["JobNotEligible"] = "JOB_NOT_ELIGIBLE";
    /** If the job does not exist or the job key is invalid. */
    GrantAdvertiserPromoError["JobNotExist"] = "JOB_NOT_EXIST";
    GrantAdvertiserPromoError["PromotionCodeNotExist"] = "PROMOTION_CODE_NOT_EXIST";
})(GrantAdvertiserPromoError || (GrantAdvertiserPromoError = {}));
/**  Types of granularity  */
export var Granularity;
(function (Granularity) {
    Granularity["Day"] = "DAY";
    Granularity["Month"] = "MONTH";
    Granularity["Null"] = "NULL";
    Granularity["Week"] = "WEEK";
    Granularity["Year"] = "YEAR";
})(Granularity || (Granularity = {}));
export var GroupMemberType;
(function (GroupMemberType) {
    GroupMemberType["EmployerJob"] = "EMPLOYER_JOB";
})(GroupMemberType || (GroupMemberType = {}));
export var GuidedNudgeMilestone;
(function (GuidedNudgeMilestone) {
    GuidedNudgeMilestone["Contacting"] = "CONTACTING";
    GuidedNudgeMilestone["Interviewing"] = "INTERVIEWING";
    GuidedNudgeMilestone["New"] = "NEW";
    GuidedNudgeMilestone["Reviewing"] = "REVIEWING";
})(GuidedNudgeMilestone || (GuidedNudgeMilestone = {}));
export var GuidedNudgeQualificationResult;
(function (GuidedNudgeQualificationResult) {
    GuidedNudgeQualificationResult["Partial"] = "PARTIAL";
    GuidedNudgeQualificationResult["Strong"] = "STRONG";
})(GuidedNudgeQualificationResult || (GuidedNudgeQualificationResult = {}));
export var GuidedNudgeQualificationType;
(function (GuidedNudgeQualificationType) {
    GuidedNudgeQualificationType["Preferred"] = "PREFERRED";
    GuidedNudgeQualificationType["Required"] = "REQUIRED";
})(GuidedNudgeQualificationType || (GuidedNudgeQualificationType = {}));
export var GuidedNudgeSentiment;
(function (GuidedNudgeSentiment) {
    GuidedNudgeSentiment["Maybe"] = "MAYBE";
    GuidedNudgeSentiment["Negative"] = "NEGATIVE";
    GuidedNudgeSentiment["Positive"] = "POSITIVE";
})(GuidedNudgeSentiment || (GuidedNudgeSentiment = {}));
export var HitlSuggestionStatus;
(function (HitlSuggestionStatus) {
    HitlSuggestionStatus["Confirmed"] = "CONFIRMED";
    HitlSuggestionStatus["Rejected"] = "REJECTED";
})(HitlSuggestionStatus || (HitlSuggestionStatus = {}));
export var HitlSuggestionStrength;
(function (HitlSuggestionStrength) {
    HitlSuggestionStrength["Preferred"] = "PREFERRED";
    HitlSuggestionStrength["Required"] = "REQUIRED";
})(HitlSuggestionStrength || (HitlSuggestionStrength = {}));
/** Represents the interpreted grade or level of happiness. */
export var HappinessGrade;
(function (HappinessGrade) {
    HappinessGrade["Excellent"] = "EXCELLENT";
    HappinessGrade["Fair"] = "FAIR";
    HappinessGrade["Good"] = "GOOD";
    HappinessGrade["Great"] = "GREAT";
    HappinessGrade["Poor"] = "POOR";
})(HappinessGrade || (HappinessGrade = {}));
export var HasProbationaryPeriod;
(function (HasProbationaryPeriod) {
    /** This job DOES NOT have probationary period */
    HasProbationaryPeriod["No"] = "NO";
    /** The employer did not indicate whether there is probationary period for this job */
    HasProbationaryPeriod["Unknown"] = "UNKNOWN";
    /** No data provided by employer. Likely this job was posted before hasProbationaryPeriod was supported */
    HasProbationaryPeriod["Unset"] = "UNSET";
    /** This job has probationary period */
    HasProbationaryPeriod["Yes"] = "YES";
})(HasProbationaryPeriod || (HasProbationaryPeriod = {}));
/**  The granularity levels for locations.  Used to determine radius searchability among other things.  */
export var HiLocationGranularity;
(function (HiLocationGranularity) {
    HiLocationGranularity["Admin1"] = "ADMIN1";
    HiLocationGranularity["Admin2"] = "ADMIN2";
    HiLocationGranularity["Admin3"] = "ADMIN3";
    HiLocationGranularity["Admin4"] = "ADMIN4";
    HiLocationGranularity["Airport"] = "AIRPORT";
    HiLocationGranularity["City"] = "CITY";
    HiLocationGranularity["Country"] = "COUNTRY";
    HiLocationGranularity["County"] = "COUNTY";
    HiLocationGranularity["Misc"] = "MISC";
    HiLocationGranularity["PostalPlace"] = "POSTAL_PLACE";
    HiLocationGranularity["Station"] = "STATION";
    HiLocationGranularity["Water"] = "WATER";
    HiLocationGranularity["Zipcode"] = "ZIPCODE";
})(HiLocationGranularity || (HiLocationGranularity = {}));
/**  Period or Frequency of Salary Statistic  */
export var HiSalaryPeriod;
(function (HiSalaryPeriod) {
    HiSalaryPeriod["Biweekly"] = "BIWEEKLY";
    HiSalaryPeriod["Daily"] = "DAILY";
    HiSalaryPeriod["Gig"] = "GIG";
    HiSalaryPeriod["Hourly"] = "HOURLY";
    HiSalaryPeriod["Invalid"] = "INVALID";
    HiSalaryPeriod["Monthly"] = "MONTHLY";
    HiSalaryPeriod["Quarterly"] = "QUARTERLY";
    HiSalaryPeriod["Semianually"] = "SEMIANUALLY";
    HiSalaryPeriod["Weekly"] = "WEEKLY";
    HiSalaryPeriod["Yearly"] = "YEARLY";
})(HiSalaryPeriod || (HiSalaryPeriod = {}));
/** The satisfaction around the hiring advice feature. */
export var HiringAdviceFeatureSatisfaction;
(function (HiringAdviceFeatureSatisfaction) {
    HiringAdviceFeatureSatisfaction["Neutral"] = "NEUTRAL";
    HiringAdviceFeatureSatisfaction["Satisfied"] = "SATISFIED";
    HiringAdviceFeatureSatisfaction["Unsatisfied"] = "UNSATISFIED";
})(HiringAdviceFeatureSatisfaction || (HiringAdviceFeatureSatisfaction = {}));
/** Types of recommendations to be provided to the user. */
export var HiringAdviceFeedbackRecommendationType;
(function (HiringAdviceFeedbackRecommendationType) {
    HiringAdviceFeedbackRecommendationType["CommunicatingWithCandidates"] = "COMMUNICATING_WITH_CANDIDATES";
    HiringAdviceFeedbackRecommendationType["ImproveJobDescription"] = "IMPROVE_JOB_DESCRIPTION";
    HiringAdviceFeedbackRecommendationType["MoreQualifiedCandidates"] = "MORE_QUALIFIED_CANDIDATES";
    HiringAdviceFeedbackRecommendationType["Other"] = "OTHER";
    HiringAdviceFeedbackRecommendationType["PreferNotToReceive"] = "PREFER_NOT_TO_RECEIVE";
    HiringAdviceFeedbackRecommendationType["SponsoringJob"] = "SPONSORING_JOB";
})(HiringAdviceFeedbackRecommendationType || (HiringAdviceFeedbackRecommendationType = {}));
/** The possible Rejected Reason codes for why an RSVP cancellation attempt was rejected */
export var HiringEventCancelRsvpRejectedReasonCode;
(function (HiringEventCancelRsvpRejectedReasonCode) {
    /** The Hiring Event has a cancelled status */
    HiringEventCancelRsvpRejectedReasonCode["EventCancelled"] = "EVENT_CANCELLED";
    /** Rsvp with the given uuid does not exist */
    HiringEventCancelRsvpRejectedReasonCode["RsvpDoesNotExist"] = "RSVP_DOES_NOT_EXIST";
    /** RSVP end time is before current time */
    HiringEventCancelRsvpRejectedReasonCode["RsvpExpired"] = "RSVP_EXPIRED";
})(HiringEventCancelRsvpRejectedReasonCode || (HiringEventCancelRsvpRejectedReasonCode = {}));
/** The kind of Hiring Event associated with the Client Intake */
export var HiringEventClientIntakeType;
(function (HiringEventClientIntakeType) {
    HiringEventClientIntakeType["IndeedInterview"] = "INDEED_INTERVIEW";
    HiringEventClientIntakeType["InterviewCampaign"] = "INTERVIEW_CAMPAIGN";
    HiringEventClientIntakeType["InPerson"] = "IN_PERSON";
    /** @deprecated Only used for legacy client intakes. */
    HiringEventClientIntakeType["None"] = "NONE";
    HiringEventClientIntakeType["Phone"] = "PHONE";
    HiringEventClientIntakeType["Virtual"] = "VIRTUAL";
})(HiringEventClientIntakeType || (HiringEventClientIntakeType = {}));
/** A currency from one of the countries supported by Hiring Events */
export var HiringEventCurrency;
(function (HiringEventCurrency) {
    HiringEventCurrency["Aud"] = "AUD";
    HiringEventCurrency["Cad"] = "CAD";
    HiringEventCurrency["Eur"] = "EUR";
    HiringEventCurrency["Gbp"] = "GBP";
    HiringEventCurrency["Inr"] = "INR";
    HiringEventCurrency["Jpy"] = "JPY";
    HiringEventCurrency["Usd"] = "USD";
})(HiringEventCurrency || (HiringEventCurrency = {}));
/** A kind of perk offered by employers hosting a hiring event */
export var HiringEventGenericPerk;
(function (HiringEventGenericPerk) {
    HiringEventGenericPerk["CompanySwag"] = "COMPANY_SWAG";
    HiringEventGenericPerk["CouponsOrVouchers"] = "COUPONS_OR_VOUCHERS";
    HiringEventGenericPerk["SnacksAndRefreshments"] = "SNACKS_AND_REFRESHMENTS";
})(HiringEventGenericPerk || (HiringEventGenericPerk = {}));
/** The goal an employer has in mind when measuring success */
export var HiringEventGoal;
(function (HiringEventGoal) {
    HiringEventGoal["CostPerHire"] = "COST_PER_HIRE";
    HiringEventGoal["GetQualifiedCandidates"] = "GET_QUALIFIED_CANDIDATES";
    HiringEventGoal["TimeToHire"] = "TIME_TO_HIRE";
    HiringEventGoal["Volume"] = "VOLUME";
})(HiringEventGoal || (HiringEventGoal = {}));
/** Possible pay periods for a legacy hiring event job type. */
export var HiringEventLegacyJobCompensationPeriod;
(function (HiringEventLegacyJobCompensationPeriod) {
    HiringEventLegacyJobCompensationPeriod["Day"] = "DAY";
    HiringEventLegacyJobCompensationPeriod["Hour"] = "HOUR";
    HiringEventLegacyJobCompensationPeriod["Month"] = "MONTH";
    HiringEventLegacyJobCompensationPeriod["Week"] = "WEEK";
    HiringEventLegacyJobCompensationPeriod["Year"] = "YEAR";
})(HiringEventLegacyJobCompensationPeriod || (HiringEventLegacyJobCompensationPeriod = {}));
/** Possible job types for a legacy hiring event job type. */
export var HiringEventLegacyJobType;
(function (HiringEventLegacyJobType) {
    HiringEventLegacyJobType["Commission"] = "COMMISSION";
    HiringEventLegacyJobType["Contractor"] = "CONTRACTOR";
    HiringEventLegacyJobType["FullTime"] = "FULL_TIME";
    HiringEventLegacyJobType["Internship"] = "INTERNSHIP";
    HiringEventLegacyJobType["NewGrad"] = "NEW_GRAD";
    HiringEventLegacyJobType["PartTime"] = "PART_TIME";
    HiringEventLegacyJobType["Seasonal"] = "SEASONAL";
    HiringEventLegacyJobType["Temporary"] = "TEMPORARY";
})(HiringEventLegacyJobType || (HiringEventLegacyJobType = {}));
/** Reasons why a Hiring Event might be in “pending” status. */
export var HiringEventPendingReason;
(function (HiringEventPendingReason) {
    HiringEventPendingReason["AvailabilityExhausted"] = "AVAILABILITY_EXHAUSTED";
    HiringEventPendingReason["InvalidBilling"] = "INVALID_BILLING";
})(HiringEventPendingReason || (HiringEventPendingReason = {}));
/** The values should reflect allowed values for IA resume button */
export var HiringEventResumeDecisionType;
(function (HiringEventResumeDecisionType) {
    HiringEventResumeDecisionType["Hidden"] = "HIDDEN";
    HiringEventResumeDecisionType["Optional"] = "OPTIONAL";
    HiringEventResumeDecisionType["Required"] = "REQUIRED";
})(HiringEventResumeDecisionType || (HiringEventResumeDecisionType = {}));
/** The disposition of the RSVP update from IRL. */
export var HiringEventRsvpDisposition;
(function (HiringEventRsvpDisposition) {
    /** RSVP disposition is no. */
    HiringEventRsvpDisposition["No"] = "NO";
    /** Unknown disposition. */
    HiringEventRsvpDisposition["Unknown"] = "UNKNOWN";
    /** RSVP disposition is yes. */
    HiringEventRsvpDisposition["Yes"] = "YES";
})(HiringEventRsvpDisposition || (HiringEventRsvpDisposition = {}));
/** The reason code for why a Hiring Event RSVP creation was rejected */
export var HiringEventRsvpRejectedReasonCode;
(function (HiringEventRsvpRejectedReasonCode) {
    /** Email domain is not allowed to RSVP */
    HiringEventRsvpRejectedReasonCode["BlockedEmailDomain"] = "BLOCKED_EMAIL_DOMAIN";
    /** Existing RSVP found, walk-in RSVPs cannot be created if a duplicate has been found */
    HiringEventRsvpRejectedReasonCode["DuplicateRsvp"] = "DUPLICATE_RSVP";
    /** Candidate has opted out from email communications */
    HiringEventRsvpRejectedReasonCode["EmailOptout"] = "EMAIL_OPTOUT";
    /** Employer RSVPed to own Hiring Event */
    HiringEventRsvpRejectedReasonCode["EmployerRsvp"] = "EMPLOYER_RSVP";
    /** The Hiring Event has a cancelled status */
    HiringEventRsvpRejectedReasonCode["EventCancelled"] = "EVENT_CANCELLED";
    /** The Hiring Event event dates are in the past */
    HiringEventRsvpRejectedReasonCode["EventExpired"] = "EVENT_EXPIRED";
    /** Invalid email format */
    HiringEventRsvpRejectedReasonCode["InvalidEmail"] = "INVALID_EMAIL";
    /** The IA Application ID provided is not valid */
    HiringEventRsvpRejectedReasonCode["InvalidIaApplicationId"] = "INVALID_IA_APPLICATION_ID";
    /** Interview period provided is not valid for the Hiring Event */
    HiringEventRsvpRejectedReasonCode["InvalidInterviewPeriod"] = "INVALID_INTERVIEW_PERIOD";
    /** Walkin RSVP received for VIP Hiring Event */
    HiringEventRsvpRejectedReasonCode["InvalidInterviewTypeForWalkin"] = "INVALID_INTERVIEW_TYPE_FOR_WALKIN";
    /** Invalid job inputs such as: providing both a job key and a job title, providing a job key and location, or an invalid uuid for the given job location */
    HiringEventRsvpRejectedReasonCode["InvalidJobInput"] = "INVALID_JOB_INPUT";
    /** Name exceeds max character length or contains invalid character */
    HiringEventRsvpRejectedReasonCode["InvalidName"] = "INVALID_NAME";
    /** Invalid phone number */
    HiringEventRsvpRejectedReasonCode["InvalidPhoneNumber"] = "INVALID_PHONE_NUMBER";
    /** The resume link is invalid/ malformed */
    HiringEventRsvpRejectedReasonCode["InvalidResumeLink"] = "INVALID_RESUME_LINK";
    /** Agg Job Id(s) are not present on the event for the rsvp */
    HiringEventRsvpRejectedReasonCode["MissingAggJobId"] = "MISSING_AGG_JOB_ID";
    /** Candidate provided the wrong answers to the screener question(s), the answer to a different question, or the wrong number of answers */
    HiringEventRsvpRejectedReasonCode["ScreeningRejected"] = "SCREENING_REJECTED";
    /** Hiring Event could not be found */
    HiringEventRsvpRejectedReasonCode["UnknownHiringEvent"] = "UNKNOWN_HIRING_EVENT";
    /** Job title could not be determined */
    HiringEventRsvpRejectedReasonCode["UnknownJobTitle"] = "UNKNOWN_JOB_TITLE";
})(HiringEventRsvpRejectedReasonCode || (HiringEventRsvpRejectedReasonCode = {}));
/** The reason code for why a Hiring Event RSVP reschedule was rejected */
export var HiringEventRsvpRescheduleRejectedReasonCode;
(function (HiringEventRsvpRescheduleRejectedReasonCode) {
    /** The Hiring Event has a cancelled status */
    HiringEventRsvpRescheduleRejectedReasonCode["EventCancelled"] = "EVENT_CANCELLED";
    /** The Hiring Event has a completed status */
    HiringEventRsvpRescheduleRejectedReasonCode["EventCompleted"] = "EVENT_COMPLETED";
    /** The Hiring Event event dates are in the past */
    HiringEventRsvpRescheduleRejectedReasonCode["EventExpired"] = "EVENT_EXPIRED";
    /** The rsvp has invalid time period */
    HiringEventRsvpRescheduleRejectedReasonCode["InvalidTimePeriod"] = "INVALID_TIME_PERIOD";
    /** Rsvp with the given uuid does not exist */
    HiringEventRsvpRescheduleRejectedReasonCode["RsvpDoesNotExist"] = "RSVP_DOES_NOT_EXIST";
    /** RSVP end time is before current time */
    HiringEventRsvpRescheduleRejectedReasonCode["RsvpExpired"] = "RSVP_EXPIRED";
})(HiringEventRsvpRescheduleRejectedReasonCode || (HiringEventRsvpRescheduleRejectedReasonCode = {}));
/** The status of a Hiring Event RSVP */
export var HiringEventRsvpStatus;
(function (HiringEventRsvpStatus) {
    /** Indicates that the RSVP was cancelled by the employer */
    HiringEventRsvpStatus["CancelledByEmployer"] = "CANCELLED_BY_EMPLOYER";
    /** Indicates that the RSVP was cancelled by the job seeker */
    HiringEventRsvpStatus["CancelledByJobseeker"] = "CANCELLED_BY_JOBSEEKER";
    /** Indicates that the RSVP's Hiring Event has been completed */
    HiringEventRsvpStatus["Completed"] = "COMPLETED";
    /** Indicates the RSVP is schedule to interview. RSVPs are created with this status */
    HiringEventRsvpStatus["Scheduled"] = "SCHEDULED";
    /** Indicates that the RSVP does not belong to a Hiring Event or the Hiring Event of the RSVP is in an invalid state */
    HiringEventRsvpStatus["Undefined"] = "UNDEFINED";
})(HiringEventRsvpStatus || (HiringEventRsvpStatus = {}));
/** The value of the screening answer */
export var HiringEventScreeningAnswerValue;
(function (HiringEventScreeningAnswerValue) {
    /** Negative screening question answer */
    HiringEventScreeningAnswerValue["No"] = "NO";
    /** Positive screening question answer */
    HiringEventScreeningAnswerValue["Yes"] = "YES";
})(HiringEventScreeningAnswerValue || (HiringEventScreeningAnswerValue = {}));
/** The status of a Hiring Event */
export var HiringEventStatus;
(function (HiringEventStatus) {
    /** Indicates the event is actively sourcing candidates and available for signing up */
    HiringEventStatus["Active"] = "ACTIVE";
    /** Indicates an employer cancelled a hiring event before the last event date */
    HiringEventStatus["Cancelled"] = "CANCELLED";
    /** Indicates the event is completed on the last event date and is no longer available for signing up */
    HiringEventStatus["Complete"] = "COMPLETE";
    /**
     * Indicates the event requires intervention to become active.
     * An event can be Pending because
     *
     * 1. a person paused it
     *
     * 2. the number of scheduled interviews is greater than the specified capacity
     *
     * 3. the start advertising date is unset
     *
     * 4. the employer's billing information is not configured properly
     */
    HiringEventStatus["Pending"] = "PENDING";
    /** Indicates the event will be become active in the future on the start advertising date */
    HiringEventStatus["Scheduled"] = "SCHEDULED";
})(HiringEventStatus || (HiringEventStatus = {}));
export var HiringLabFrequency;
(function (HiringLabFrequency) {
    HiringLabFrequency["Daily"] = "DAILY";
    HiringLabFrequency["Monthly"] = "MONTHLY";
})(HiringLabFrequency || (HiringLabFrequency = {}));
export var HiringLabGranularity;
(function (HiringLabGranularity) {
    HiringLabGranularity["National"] = "NATIONAL";
    HiringLabGranularity["Regional"] = "REGIONAL";
    HiringLabGranularity["Sectoral"] = "SECTORAL";
})(HiringLabGranularity || (HiringLabGranularity = {}));
export var HiringProduct;
(function (HiringProduct) {
    HiringProduct["HiringEvent"] = "HIRING_EVENT";
    HiringProduct["OrganicJob"] = "ORGANIC_JOB";
    HiringProduct["SmartSourcing"] = "SMART_SOURCING";
    HiringProduct["SponsoredJob"] = "SPONSORED_JOB";
})(HiringProduct || (HiringProduct = {}));
/** Status of a hiring profile representing the current stage in the hiring process */
export var HiringProfileStatus;
(function (HiringProfileStatus) {
    /** Hiring profile has been archived */
    HiringProfileStatus["Archived"] = "ARCHIVED";
    /** Hiring process is closed/completed */
    HiringProfileStatus["Closed"] = "CLOSED";
    /** In the interview process with candidates */
    HiringProfileStatus["Interviewing"] = "INTERVIEWING";
    /** Negotiating offers with selected candidates */
    HiringProfileStatus["Negotiating"] = "NEGOTIATING";
    /** Hiring profile is newly created */
    HiringProfileStatus["New"] = "NEW";
    /** Currently sourcing candidates for the position */
    HiringProfileStatus["Sourcing"] = "SOURCING";
})(HiringProfileStatus || (HiringProfileStatus = {}));
/** Input enum for hiring profile status to be used in mutations and inputs */
export var HiringProfileStatusInput;
(function (HiringProfileStatusInput) {
    /** Hiring profile has been archived */
    HiringProfileStatusInput["Archived"] = "ARCHIVED";
    /** Hiring process is closed/completed */
    HiringProfileStatusInput["Closed"] = "CLOSED";
    /** In the interview process with candidates */
    HiringProfileStatusInput["Interviewing"] = "INTERVIEWING";
    /** Negotiating offers with selected candidates */
    HiringProfileStatusInput["Negotiating"] = "NEGOTIATING";
    /** Hiring profile is newly created */
    HiringProfileStatusInput["New"] = "NEW";
    /** Currently sourcing candidates for the position */
    HiringProfileStatusInput["Sourcing"] = "SOURCING";
})(HiringProfileStatusInput || (HiringProfileStatusInput = {}));
/** Resolution action taken on a HITL learning suggestion */
export var HitlSuggestionResolution;
(function (HitlSuggestionResolution) {
    /** Suggestion was confirmed/accepted by the user */
    HitlSuggestionResolution["Confirmed"] = "CONFIRMED";
    /** Suggestion was rejected by the user */
    HitlSuggestionResolution["Rejected"] = "REJECTED";
})(HitlSuggestionResolution || (HitlSuggestionResolution = {}));
/** Enum that represents operations for hosted employer attribute */
export var HostedEmployerAttributesUpdateSetOperationType;
(function (HostedEmployerAttributesUpdateSetOperationType) {
    HostedEmployerAttributesUpdateSetOperationType["Add"] = "ADD";
})(HostedEmployerAttributesUpdateSetOperationType || (HostedEmployerAttributesUpdateSetOperationType = {}));
export var HostedFunnelAction;
(function (HostedFunnelAction) {
    HostedFunnelAction["Applies"] = "APPLIES";
    HostedFunnelAction["Clicks"] = "CLICKS";
    HostedFunnelAction["Impressions"] = "IMPRESSIONS";
    HostedFunnelAction["InsufficientData"] = "INSUFFICIENT_DATA";
    HostedFunnelAction["NoAction"] = "NO_ACTION";
})(HostedFunnelAction || (HostedFunnelAction = {}));
export var HostedFunnelReward;
(function (HostedFunnelReward) {
    HostedFunnelReward["ClickThrough"] = "CLICK_THROUGH";
    HostedFunnelReward["NoThanks"] = "NO_THANKS";
})(HostedFunnelReward || (HostedFunnelReward = {}));
export var HostedInterviewReferenceInputType;
(function (HostedInterviewReferenceInputType) {
    HostedInterviewReferenceInputType["PhoneRelayCallSid"] = "PHONE_RELAY_CALL_SID";
    HostedInterviewReferenceInputType["PhoneRelaySessionSid"] = "PHONE_RELAY_SESSION_SID";
    HostedInterviewReferenceInputType["VirtualEventId"] = "VIRTUAL_EVENT_ID";
    HostedInterviewReferenceInputType["VirtualRsvpId"] = "VIRTUAL_RSVP_ID";
})(HostedInterviewReferenceInputType || (HostedInterviewReferenceInputType = {}));
/** The possible exclude options for HostedJobMessagingTagResult. */
export var HostedJobPostExcludeOption;
(function (HostedJobPostExcludeOption) {
    HostedJobPostExcludeOption["All"] = "ALL";
    HostedJobPostExcludeOption["Appeal"] = "APPEAL";
})(HostedJobPostExcludeOption || (HostedJobPostExcludeOption = {}));
/** The status of a hosted job post. */
export var HostedJobPostStatus;
(function (HostedJobPostStatus) {
    HostedJobPostStatus["Active"] = "ACTIVE";
    HostedJobPostStatus["Deleted"] = "DELETED";
    HostedJobPostStatus["Paused"] = "PAUSED";
})(HostedJobPostStatus || (HostedJobPostStatus = {}));
/** The possible visibility levels. */
export var HostedJobPostVisibility;
(function (HostedJobPostVisibility) {
    HostedJobPostVisibility["Hidden"] = "HIDDEN";
    /** Available in job search results */
    HostedJobPostVisibility["Organic"] = "ORGANIC";
    /** Requires sponsorship to be visible in job search results */
    HostedJobPostVisibility["SponsoredOnly"] = "SPONSORED_ONLY";
    HostedJobPostVisibility["Unknown"] = "UNKNOWN";
    HostedJobPostVisibility["Unrestricted"] = "UNRESTRICTED";
})(HostedJobPostVisibility || (HostedJobPostVisibility = {}));
/** Ordering fields */
export var HostedJobPostsSortField;
(function (HostedJobPostsSortField) {
    /** @deprecated No longer supported */
    HostedJobPostsSortField["AdvertisingLocation"] = "ADVERTISING_LOCATION";
    HostedJobPostsSortField["CreatedBy"] = "CREATED_BY";
    HostedJobPostsSortField["DateCreated"] = "DATE_CREATED";
    HostedJobPostsSortField["Status"] = "STATUS";
    HostedJobPostsSortField["Title"] = "TITLE";
})(HostedJobPostsSortField || (HostedJobPostsSortField = {}));
/**
 * User preference for hosted job prefilling in AutoApply.
 * Using an enum allows for future states without breaking changes.
 */
export var HostedJobPrefillPreference;
(function (HostedJobPrefillPreference) {
    /** User has opted in to hosted job prefilling */
    HostedJobPrefillPreference["OptIn"] = "OPT_IN";
    /** User has opted out of hosted job prefilling (default behavior due to legal requirement) */
    HostedJobPrefillPreference["OptOut"] = "OPT_OUT";
})(HostedJobPrefillPreference || (HostedJobPrefillPreference = {}));
/** Specifies the possible values for a hosted job status. */
export var HostedJobStatus;
(function (HostedJobStatus) {
    HostedJobStatus["Active"] = "ACTIVE";
    HostedJobStatus["Closed"] = "CLOSED";
    HostedJobStatus["Paused"] = "PAUSED";
    HostedJobStatus["Unknown"] = "UNKNOWN";
})(HostedJobStatus || (HostedJobStatus = {}));
export var I2AChannel;
(function (I2AChannel) {
    I2AChannel["AndroidPush"] = "ANDROID_PUSH";
    I2AChannel["Email"] = "EMAIL";
    I2AChannel["IosPush"] = "IOS_PUSH";
    I2AChannel["Line"] = "LINE";
    I2AChannel["Unknown"] = "UNKNOWN";
})(I2AChannel || (I2AChannel = {}));
export var I2AProduct;
(function (I2AProduct) {
    I2AProduct["GlassdoorI2A"] = "GLASSDOOR_I2A";
    I2AProduct["SmbI2A"] = "SMB_I2A";
    I2AProduct["SmbI2AMultijob"] = "SMB_I2A_MULTIJOB";
    I2AProduct["SmbInstantMatch"] = "SMB_INSTANT_MATCH";
    I2AProduct["Unknown"] = "UNKNOWN";
})(I2AProduct || (I2AProduct = {}));
export var I2AProductSubvariant;
(function (I2AProductSubvariant) {
    I2AProductSubvariant["Indeedplus"] = "INDEEDPLUS";
    I2AProductSubvariant["None"] = "NONE";
    I2AProductSubvariant["Optin"] = "OPTIN";
    I2AProductSubvariant["Reactivation"] = "REACTIVATION";
    I2AProductSubvariant["Resumeless"] = "RESUMELESS";
    I2AProductSubvariant["Unknown"] = "UNKNOWN";
})(I2AProductSubvariant || (I2AProductSubvariant = {}));
export var I2AProductType;
(function (I2AProductType) {
    I2AProductType["Autosourcer"] = "AUTOSOURCER";
    I2AProductType["Jobmatch"] = "JOBMATCH";
    I2AProductType["Jobsourcer"] = "JOBSOURCER";
    I2AProductType["Multijob"] = "MULTIJOB";
    I2AProductType["Unknown"] = "UNKNOWN";
})(I2AProductType || (I2AProductType = {}));
export var IhpScreenerQuestionAnswer;
(function (IhpScreenerQuestionAnswer) {
    IhpScreenerQuestionAnswer["No"] = "No";
    IhpScreenerQuestionAnswer["Yes"] = "Yes";
})(IhpScreenerQuestionAnswer || (IhpScreenerQuestionAnswer = {}));
/**
 * Indeed Apply token type
 * - API_TOKEN: Used by ATSs to verify the integrity of the payload sent by IndeedApply after apply.
 * - PARTNER_TOKEN: An identifier to uniquely identify a Job Board.
 */
export var IaTokenType;
(function (IaTokenType) {
    /** Used by ATSs to verify the integrity of the payload sent by IndeedApply after apply. */
    IaTokenType["ApiToken"] = "API_TOKEN";
    /** An identifier to uniquely identify a Job Board. */
    IaTokenType["PartnerToken"] = "PARTNER_TOKEN";
})(IaTokenType || (IaTokenType = {}));
export var IdVerificationQueryStatus;
(function (IdVerificationQueryStatus) {
    IdVerificationQueryStatus["Error"] = "ERROR";
    IdVerificationQueryStatus["FeatureDisabled"] = "FEATURE_DISABLED";
    IdVerificationQueryStatus["NoData"] = "NO_DATA";
    IdVerificationQueryStatus["Success"] = "SUCCESS";
})(IdVerificationQueryStatus || (IdVerificationQueryStatus = {}));
/** Identification Source */
export var IdentificationSource;
(function (IdentificationSource) {
    IdentificationSource["Ehs"] = "EHS";
    IdentificationSource["MarketingModal"] = "MARKETING_MODAL";
    IdentificationSource["Other"] = "OTHER";
})(IdentificationSource || (IdentificationSource = {}));
/** Identified Company */
export var IdentifiedCompany;
(function (IdentifiedCompany) {
    IdentifiedCompany["Other"] = "OTHER";
    IdentifiedCompany["Walmart"] = "WALMART";
})(IdentifiedCompany || (IdentifiedCompany = {}));
/** Stub enum definition for IdentityContextAuthIdentifier (defined in smart-apply-onegraph-api). */
export var IdentityContextAuthIdentifier;
(function (IdentityContextAuthIdentifier) {
    IdentityContextAuthIdentifier["Email"] = "EMAIL";
    IdentityContextAuthIdentifier["Phone"] = "PHONE";
})(IdentityContextAuthIdentifier || (IdentityContextAuthIdentifier = {}));
export var IdentityVerificationResult;
(function (IdentityVerificationResult) {
    IdentityVerificationResult["NotVerified"] = "NOT_VERIFIED";
    IdentityVerificationResult["Verified"] = "VERIFIED";
})(IdentityVerificationResult || (IdentityVerificationResult = {}));
/** IDR preview v2 generation status. */
export var IdrPreviewMetadataStatus;
(function (IdrPreviewMetadataStatus) {
    /** Preview generation finished successfully. */
    IdrPreviewMetadataStatus["Complete"] = "COMPLETE";
    /** Preview generation failed. See errorCode and errorMessage on the response payload. */
    IdrPreviewMetadataStatus["Failed"] = "FAILED";
    /** Preview generation is still running. Poll until the status changes. */
    IdrPreviewMetadataStatus["InProgress"] = "IN_PROGRESS";
})(IdrPreviewMetadataStatus || (IdrPreviewMetadataStatus = {}));
/** Enum to represent the hosting status of a job */
export var IhpHostedStatus;
(function (IhpHostedStatus) {
    IhpHostedStatus["External"] = "EXTERNAL";
    IhpHostedStatus["Hosted"] = "HOSTED";
})(IhpHostedStatus || (IhpHostedStatus = {}));
/**
 * Asset categories supported by the image upload pipeline. Determines which
 * dimension bounds, aspect ratio, format allowlist, and resized variants apply
 * at confirm time.
 */
export var ImageAsset;
(function (ImageAsset) {
    /** Header / banner image. 49:10 aspect ratio, 1960–7840 px width. Produces a 1960×400 resized variant. */
    ImageAsset["HeaderImage"] = "HEADER_IMAGE";
    /** Square employer logo. 1:1 aspect ratio, 256–4096 px on each axis. Produces a 256×256 resized variant. */
    ImageAsset["SquareLogo"] = "SQUARE_LOGO";
})(ImageAsset || (ImageAsset = {}));
/** Enumeration of image availability values */
export var ImageAvailability;
(function (ImageAvailability) {
    ImageAvailability["Permanent"] = "PERMANENT";
    ImageAvailability["Temp"] = "TEMP";
})(ImageAvailability || (ImageAvailability = {}));
/** Enumeration of image type values */
export var ImageType;
(function (ImageType) {
    ImageType["Bs_300x250Image"] = "BS_300x250_IMAGE";
    ImageType["Bs_300x600Image"] = "BS_300x600_IMAGE";
    ImageType["Bs_320x50Image"] = "BS_320x50_IMAGE";
    ImageType["Bs_728x90Image"] = "BS_728x90_IMAGE";
    ImageType["Bs_1080x1080Image"] = "BS_1080x1080_IMAGE";
    ImageType["Bs_1080x1920Image"] = "BS_1080x1920_IMAGE";
    ImageType["Bs_2000x1047Image"] = "BS_2000x1047_IMAGE";
    ImageType["CsHeaderImage"] = "CS_HEADER_IMAGE";
    ImageType["HeaderImage"] = "HEADER_IMAGE";
    ImageType["HphBannerImage"] = "HPH_BANNER_IMAGE";
    ImageType["SquareLogo"] = "SQUARE_LOGO";
})(ImageType || (ImageType = {}));
/** Importance level of a criterion */
export var Importance;
(function (Importance) {
    Importance["Preferred"] = "PREFERRED";
    Importance["Required"] = "REQUIRED";
    Importance["Unspecified"] = "UNSPECIFIED";
})(Importance || (Importance = {}));
/** Various link priorities for an InAppNotificationCtaLink */
export var InAppNotificationCtaLinkPriority;
(function (InAppNotificationCtaLinkPriority) {
    /** CTA link is clickable on the in-app notification card itself */
    InAppNotificationCtaLinkPriority["Background"] = "BACKGROUND";
    /** CTA link is clickable via the Indeed Primary styled button on the in-app notification card */
    InAppNotificationCtaLinkPriority["Primary"] = "PRIMARY";
    /** CTA link is clickable via the Indeed Secondary styled button on the in-app notification card */
    InAppNotificationCtaLinkPriority["Secondary"] = "SECONDARY";
    /** CTA link is clickable via the Indeed Tertiary styled button on the in-app notification card */
    InAppNotificationCtaLinkPriority["Tertiary"] = "TERTIARY";
    /** CTA link is clickable via the Indeed Text styled button on the in-app notification card */
    InAppNotificationCtaLinkPriority["Text"] = "TEXT";
})(InAppNotificationCtaLinkPriority || (InAppNotificationCtaLinkPriority = {}));
/** Link targets for an InAppNotificationCtaLink */
export var InAppNotificationCtaLinkTarget;
(function (InAppNotificationCtaLinkTarget) {
    /** Open CTA link in a new tab */
    InAppNotificationCtaLinkTarget["Blank"] = "BLANK";
    /** Trigger a direct action via CTA link (no active campaign usage in yet) */
    InAppNotificationCtaLinkTarget["Direct"] = "DIRECT";
    /** Trigger a download action via CTA link (no active campaign usage in yet) */
    InAppNotificationCtaLinkTarget["Download"] = "DOWNLOAD";
    /** Open CTA link in the same tab */
    InAppNotificationCtaLinkTarget["Self"] = "SELF";
})(InAppNotificationCtaLinkTarget || (InAppNotificationCtaLinkTarget = {}));
/** Icon to represent an InAppNotification */
export var InAppNotificationIcon;
(function (InAppNotificationIcon) {
    InAppNotificationIcon["Analytics"] = "ANALYTICS";
    InAppNotificationIcon["Ban"] = "BAN";
    InAppNotificationIcon["Billing"] = "BILLING";
    InAppNotificationIcon["Calendar"] = "CALENDAR";
    InAppNotificationIcon["Campaigns"] = "CAMPAIGNS";
    InAppNotificationIcon["Candidates"] = "CANDIDATES";
    InAppNotificationIcon["Chat"] = "CHAT";
    InAppNotificationIcon["Check"] = "CHECK";
    InAppNotificationIcon["Clock"] = "CLOCK";
    InAppNotificationIcon["Company"] = "COMPANY";
    InAppNotificationIcon["Discover"] = "DISCOVER";
    InAppNotificationIcon["FileImage"] = "FILE_IMAGE";
    InAppNotificationIcon["HomeInterview"] = "HOME_INTERVIEW";
    InAppNotificationIcon["Interview"] = "INTERVIEW";
    InAppNotificationIcon["Jobs"] = "JOBS";
    InAppNotificationIcon["Lock"] = "LOCK";
    InAppNotificationIcon["PersonSearch"] = "PERSON_SEARCH";
    InAppNotificationIcon["Resources"] = "RESOURCES";
    InAppNotificationIcon["Responsive"] = "RESPONSIVE";
    InAppNotificationIcon["Warning"] = "WARNING";
})(InAppNotificationIcon || (InAppNotificationIcon = {}));
/** Input for the InAppNotificationRecipientType enum */
export var InAppNotificationRecipientType;
(function (InAppNotificationRecipientType) {
    /** The in-app notification recipient type is a console user */
    InAppNotificationRecipientType["ConsolePlatform"] = "CONSOLE_PLATFORM";
    /** The in-app notification recipient type is an employer */
    InAppNotificationRecipientType["Employer"] = "EMPLOYER";
    /** The in-app notification recipient type is a jobseeker */
    InAppNotificationRecipientType["Jobseeker"] = "JOBSEEKER";
})(InAppNotificationRecipientType || (InAppNotificationRecipientType = {}));
/** State of an InAppNotification */
export var InAppNotificationState;
(function (InAppNotificationState) {
    /** InAppNotification is no longer visible to the user */
    InAppNotificationState["Hidden"] = "HIDDEN";
    /** InAppNotification has been interacted with or marked as read by the user */
    InAppNotificationState["Read"] = "READ";
    /**
     * InAppNotification has been displayed to the user in the in-app notification area,
     * but has not yet been interacted with
     */
    InAppNotificationState["Unread"] = "UNREAD";
    /**
     * InAppNotification content has not yet been shown to the user in the in-app notification
     * area
     */
    InAppNotificationState["Unseen"] = "UNSEEN";
})(InAppNotificationState || (InAppNotificationState = {}));
/** Reason why a credential is in progress */
export var InProgressReason;
(function (InProgressReason) {
    /** Currently obtaining this credential */
    InProgressReason["CurrentlyObtaining"] = "CURRENTLY_OBTAINING";
    /** Different reason (with custom description) */
    InProgressReason["DifferentReason"] = "DIFFERENT_REASON";
    /** Graduating from a related program */
    InProgressReason["GraduatingFromProgram"] = "GRADUATING_FROM_PROGRAM";
})(InProgressReason || (InProgressReason = {}));
/** The type of a inbound created resource */
export var InboundCandidateSyncCreatedResourceKind;
(function (InboundCandidateSyncCreatedResourceKind) {
    /** A candidate journey reference from the UTaP platform */
    InboundCandidateSyncCreatedResourceKind["CandidateJourney"] = "CANDIDATE_JOURNEY";
    /** A candidate submission in the UTaP platform */
    InboundCandidateSyncCreatedResourceKind["CandidateSubmission"] = "CANDIDATE_SUBMISSION";
    /** A candidate UUID from the UTaP platform */
    InboundCandidateSyncCreatedResourceKind["CandidateUuid"] = "CANDIDATE_UUID";
    /** A qualification answer set in the IQP platform */
    InboundCandidateSyncCreatedResourceKind["IqpAnswers"] = "IQP_ANSWERS";
    /** A qualification question set in the IQP platform */
    InboundCandidateSyncCreatedResourceKind["IqpQuestionSet"] = "IQP_QUESTION_SET";
    /** A job seeker account key */
    InboundCandidateSyncCreatedResourceKind["JsAccountKey"] = "JS_ACCOUNT_KEY";
    /** A candidate journey that was updated with a normalized disposition */
    InboundCandidateSyncCreatedResourceKind["NormalizedDisposition"] = "NORMALIZED_DISPOSITION";
    /** A candidate submission that had a raw ATS disposition saved to Signal Back */
    InboundCandidateSyncCreatedResourceKind["RawDisposition"] = "RAW_DISPOSITION";
})(InboundCandidateSyncCreatedResourceKind || (InboundCandidateSyncCreatedResourceKind = {}));
/** The type of a inbound created resource */
export var InboundCandidateSyncCreatedResourceKindInput;
(function (InboundCandidateSyncCreatedResourceKindInput) {
    /** A candidate journey reference from the UTaP platform */
    InboundCandidateSyncCreatedResourceKindInput["CandidateJourney"] = "CANDIDATE_JOURNEY";
    /** A candidate submission in the UTaP platform */
    InboundCandidateSyncCreatedResourceKindInput["CandidateSubmission"] = "CANDIDATE_SUBMISSION";
    /** A candidate UUID from the UTaP platform */
    InboundCandidateSyncCreatedResourceKindInput["CandidateUuid"] = "CANDIDATE_UUID";
    /** A qualification answer set in the IQP platform */
    InboundCandidateSyncCreatedResourceKindInput["IqpAnswers"] = "IQP_ANSWERS";
    /** A qualification question set in the IQP platform */
    InboundCandidateSyncCreatedResourceKindInput["IqpQuestionSet"] = "IQP_QUESTION_SET";
    /** A job seeker account key */
    InboundCandidateSyncCreatedResourceKindInput["JsAccountKey"] = "JS_ACCOUNT_KEY";
    /** A candidate journey that was updated with a normalized disposition */
    InboundCandidateSyncCreatedResourceKindInput["NormalizedDisposition"] = "NORMALIZED_DISPOSITION";
    /** A candidate submission that had a raw ATS disposition saved to Signal Back */
    InboundCandidateSyncCreatedResourceKindInput["RawDisposition"] = "RAW_DISPOSITION";
})(InboundCandidateSyncCreatedResourceKindInput || (InboundCandidateSyncCreatedResourceKindInput = {}));
/** Error codes that may be encountered during Inbound Candidate Sync */
export var InboundCandidateSyncError;
(function (InboundCandidateSyncError) {
    /**
     * Data provided to Indeed did not match data available in the ATS (some data was excluded, truncated, or modified
     * when provided to Indeed for publishing)
     */
    InboundCandidateSyncError["AllAtsFieldsNotImported"] = "ALL_ATS_FIELDS_NOT_IMPORTED";
    /**
     * Not all files from the ATS could be stored on Indeed
     * Typically, this means more than one resume and cover letter were present, since only one of each can be saved
     */
    InboundCandidateSyncError["AllFilesNotImported"] = "ALL_FILES_NOT_IMPORTED";
    /**
     * One or more questions or answers were not imported to Indeed. This could be due to a question being flagged as
     * collecting demographic data, or the question type being unsupported.
     */
    InboundCandidateSyncError["AllQuestionsAnswersNotImported"] = "ALL_QUESTIONS_ANSWERS_NOT_IMPORTED";
    /** A permissions error occurred while transferring the candidate/application */
    InboundCandidateSyncError["Authorization"] = "AUTHORIZATION";
    /**
     * Some portions of the candidate/application were discarded due to being in an unknown/unsupported format that could
     * not be converted to Indeed data
     */
    InboundCandidateSyncError["Deserialization"] = "DESERIALIZATION";
    /** The candidate/application in the ATS/CRM was missing data required for transfer to Indeed */
    InboundCandidateSyncError["InvalidProfile"] = "INVALID_PROFILE";
    /** The email address of the Jobseeker is invalid. */
    InboundCandidateSyncError["PeripheralIdentityInvalidEmail"] = "PERIPHERAL_IDENTITY_INVALID_EMAIL";
    /** A peripheral identity could not be created or retrieved for the Jobseeker. */
    InboundCandidateSyncError["PeripheralIdentityNotCreated"] = "PERIPHERAL_IDENTITY_NOT_CREATED";
    /** Some prerequisite of import candidate or application publishing failed */
    InboundCandidateSyncError["Precondition"] = "PRECONDITION";
    /** Publishing a candidate submission to UCP failed */
    InboundCandidateSyncError["PublishingCandidateSubmission"] = "PUBLISHING_CANDIDATE_SUBMISSION";
    /** The application's normalized disposition data could not be synced to Indeed */
    InboundCandidateSyncError["PublishingNormalizedDisposition"] = "PUBLISHING_NORMALIZED_DISPOSITION";
    /** The candidate/application's question and/or answer data failed to sync to Indeed */
    InboundCandidateSyncError["PublishingQuestionAnswers"] = "PUBLISHING_QUESTION_ANSWERS";
    /** The application's disposition data (as defined by the ATS/CRM) failed to sync to Indeed */
    InboundCandidateSyncError["PublishingRawDisposition"] = "PUBLISHING_RAW_DISPOSITION";
    /** Resume parsing or one of its subtasks (e.g. model conversion) failed */
    InboundCandidateSyncError["ResumeParsing"] = "RESUME_PARSING";
    /** An unrecognized/unclassified error */
    InboundCandidateSyncError["Unknown"] = "UNKNOWN";
    /** Virus scanning a file flagged it as potentially unsafe, causing it to be discarded */
    InboundCandidateSyncError["VirusScanFailed"] = "VIRUS_SCAN_FAILED";
    /** Virus scanning was not run / failed to complete for a file, causing it to be discarded */
    InboundCandidateSyncError["VirusScanNotCompleted"] = "VIRUS_SCAN_NOT_COMPLETED";
})(InboundCandidateSyncError || (InboundCandidateSyncError = {}));
/** External location kinds supported by inbound candidate sync */
export var InboundCandidateSyncExternalAtsLocationKind;
(function (InboundCandidateSyncExternalAtsLocationKind) {
    /** A reference to a requisition (or requisition equivalent) in the external ats */
    InboundCandidateSyncExternalAtsLocationKind["Requisition"] = "REQUISITION";
    /** A reference to an EJID */
    InboundCandidateSyncExternalAtsLocationKind["SourcedPosting"] = "SOURCED_POSTING";
    /** A reference to a talent pool (or talent pool equivalent) in the external ats */
    InboundCandidateSyncExternalAtsLocationKind["TalentPool"] = "TALENT_POOL";
})(InboundCandidateSyncExternalAtsLocationKind || (InboundCandidateSyncExternalAtsLocationKind = {}));
/** Input for external location kinds supported by inbound candidate sync */
export var InboundCandidateSyncExternalAtsLocationKindInput;
(function (InboundCandidateSyncExternalAtsLocationKindInput) {
    /** A reference to a requisition (or requisition equivalent) in the external ats */
    InboundCandidateSyncExternalAtsLocationKindInput["Requisition"] = "REQUISITION";
    /** A reference to an EJID */
    InboundCandidateSyncExternalAtsLocationKindInput["SourcedPosting"] = "SOURCED_POSTING";
    /** A reference to a talent pool (or talent pool equivalent) in the external ats */
    InboundCandidateSyncExternalAtsLocationKindInput["TalentPool"] = "TALENT_POOL";
})(InboundCandidateSyncExternalAtsLocationKindInput || (InboundCandidateSyncExternalAtsLocationKindInput = {}));
/** Reason an inbound candidate sync result was generated */
export var InboundCandidateSyncReason;
(function (InboundCandidateSyncReason) {
    /** An unexpected/unrecognized driver type */
    InboundCandidateSyncReason["Indeterminate"] = "INDETERMINATE";
    /**
     * Initial ingest of a candidate/application.
     * The data is not associated with an Indeed job, and may later be copied to create job-associated data
     */
    InboundCandidateSyncReason["InitialIngest"] = "INITIAL_INGEST";
    /**
     * Association of a candidate/application with an Indeed job during initial ingestion.
     * The data is created from the same process & time as INITIAL_INGEST (not a copy of INITIAL_INGEST)
     */
    InboundCandidateSyncReason["Pipeline"] = "PIPELINE";
    /**
     * Association of a candidate/application with an Indeed job after initial ingestion.
     * The data is copied from an INITIAL_INGEST when a new pipeline is created
     */
    InboundCandidateSyncReason["PipelineBackfill"] = "PIPELINE_BACKFILL";
})(InboundCandidateSyncReason || (InboundCandidateSyncReason = {}));
/** Reason an inbound candidate sync result was generated */
export var InboundCandidateSyncReasonInput;
(function (InboundCandidateSyncReasonInput) {
    /**
     * Initial ingest of a candidate/application.
     * The data is not associated with an Indeed job, and may later be copied to create job-associated data
     */
    InboundCandidateSyncReasonInput["InitialIngest"] = "INITIAL_INGEST";
    /**
     * Association of a candidate/application with an Indeed job during initial ingestion.
     * The data is created from the same process & time as INITIAL_INGEST (not a copy of INITIAL_INGEST)
     */
    InboundCandidateSyncReasonInput["Pipeline"] = "PIPELINE";
    /**
     * Association of a candidate/application with an Indeed job after initial ingestion.
     * The data is copied from an INITIAL_INGEST when a new pipeline is created
     */
    InboundCandidateSyncReasonInput["PipelineBackfill"] = "PIPELINE_BACKFILL";
})(InboundCandidateSyncReasonInput || (InboundCandidateSyncReasonInput = {}));
/** The status of attempting to transfer a candidate/application from the ATS/CRM to Indeed */
export var InboundCandidateSyncStatus;
(function (InboundCandidateSyncStatus) {
    /** The candidate/application was queued for deletion on Indeed */
    InboundCandidateSyncStatus["Deleted"] = "DELETED";
    /** None of the supported candidate/application data was successfully transferred from the ATS/CRM to Indeed. */
    InboundCandidateSyncStatus["Failure"] = "FAILURE";
    /**
     * Portions of the candidate/application data were successfully transferred from the ATS/CRM to Indeed.  Other portions
     * of the data were unable to transfer due to (e.g.) conversion failures.  See the 'errors' field of
     * 'InboundCandidateSyncResult' for information about what failures occurred
     */
    InboundCandidateSyncStatus["PartialSuccess"] = "PARTIAL_SUCCESS";
    /** The candidate/application was successfully transferred from the ATS/CRM to Indeed with all supported data */
    InboundCandidateSyncStatus["Success"] = "SUCCESS";
    /**
     * The exact status of the transfer is unavailable.  May occur in edge cases where other data about the transfer is
     * available, but the status is not
     */
    InboundCandidateSyncStatus["Unknown"] = "UNKNOWN";
})(InboundCandidateSyncStatus || (InboundCandidateSyncStatus = {}));
/** The status of attempting to transfer a candidate/application from the ATS/CRM to Indeed */
export var InboundCandidateSyncStatusInput;
(function (InboundCandidateSyncStatusInput) {
    /** The candidate/application was queued for deletion on Indeed */
    InboundCandidateSyncStatusInput["Deleted"] = "DELETED";
    /** None of the supported candidate/application data was successfully transferred from the ATS/CRM to Indeed. */
    InboundCandidateSyncStatusInput["Failure"] = "FAILURE";
    /**
     * Portions of the candidate/application data were successfully transferred from the ATS/CRM to Indeed.  Other portions
     * of the data were unable to transfer due to (e.g.) conversion failures.  See the 'errors' field of
     * 'InboundCandidateSyncResult' for information about what failures occurred
     */
    InboundCandidateSyncStatusInput["PartialSuccess"] = "PARTIAL_SUCCESS";
    /** The candidate/application was successfully transferred from the ATS/CRM to Indeed with all supported data */
    InboundCandidateSyncStatusInput["Success"] = "SUCCESS";
})(InboundCandidateSyncStatusInput || (InboundCandidateSyncStatusInput = {}));
/** Enum representation of supported inbound sync types */
export var InboundCandidateSyncType;
(function (InboundCandidateSyncType) {
    /** Indicates application sync progress is being tracked */
    InboundCandidateSyncType["Applications"] = "APPLICATIONS";
    /** Indicates candied profile sync progress is being tracked */
    InboundCandidateSyncType["Candidates"] = "CANDIDATES";
    /** Default sync type that's set when deserialization errors occur */
    InboundCandidateSyncType["Unknown"] = "UNKNOWN";
})(InboundCandidateSyncType || (InboundCandidateSyncType = {}));
/** Enum representation of supported inbound sync types */
export var InboundCandidateSyncTypeInput;
(function (InboundCandidateSyncTypeInput) {
    /** Indicates application sync progress is being tracked */
    InboundCandidateSyncTypeInput["Applications"] = "APPLICATIONS";
    /** Indicates candied profile sync progress is being tracked */
    InboundCandidateSyncTypeInput["Candidates"] = "CANDIDATES";
})(InboundCandidateSyncTypeInput || (InboundCandidateSyncTypeInput = {}));
export var IndeedApp;
(function (IndeedApp) {
    IndeedApp["Employer"] = "EMPLOYER";
    IndeedApp["HqmEmployer"] = "HQM_EMPLOYER";
    IndeedApp["HqmJobsearch"] = "HQM_JOBSEARCH";
    IndeedApp["Jobsearch"] = "JOBSEARCH";
    IndeedApp["Jobspotter"] = "JOBSPOTTER";
    IndeedApp["UnknownIndeedApp"] = "UNKNOWN_INDEED_APP";
    IndeedApp["WebDefault"] = "WEB_DEFAULT";
})(IndeedApp || (IndeedApp = {}));
/**  Delivery status  */
export var IndeedApplyAdaDeliveryStatus;
(function (IndeedApplyAdaDeliveryStatus) {
    IndeedApplyAdaDeliveryStatus["Delivered"] = "DELIVERED";
    IndeedApplyAdaDeliveryStatus["NotDelivered"] = "NOT_DELIVERED";
    IndeedApplyAdaDeliveryStatus["PendingDelivery"] = "PENDING_DELIVERY";
})(IndeedApplyAdaDeliveryStatus || (IndeedApplyAdaDeliveryStatus = {}));
export var IndeedApplyCaptchaKeyType;
(function (IndeedApplyCaptchaKeyType) {
    IndeedApplyCaptchaKeyType["InvisibleRecaptchaKey"] = "INVISIBLE_RECAPTCHA_KEY";
    IndeedApplyCaptchaKeyType["PbcRecaptchaKey"] = "PBC_RECAPTCHA_KEY";
    IndeedApplyCaptchaKeyType["VisibleHardRecaptchaKey"] = "VISIBLE_HARD_RECAPTCHA_KEY";
    IndeedApplyCaptchaKeyType["VisibleMediumRecaptchaKey"] = "VISIBLE_MEDIUM_RECAPTCHA_KEY";
    IndeedApplyCaptchaKeyType["VisibleRecaptchaKey"] = "VISIBLE_RECAPTCHA_KEY";
})(IndeedApplyCaptchaKeyType || (IndeedApplyCaptchaKeyType = {}));
/** Resume field requirement values. See [Indeed Resume JSON object fields](https://docs.indeed.com/indeed-apply/application-data#indeed-resume-json-object-fields). */
export var IndeedApplyConfigurationResumeField;
(function (IndeedApplyConfigurationResumeField) {
    IndeedApplyConfigurationResumeField["Certifications"] = "CERTIFICATIONS";
    IndeedApplyConfigurationResumeField["DateOfBirth"] = "DATE_OF_BIRTH";
    IndeedApplyConfigurationResumeField["Education"] = "EDUCATION";
    IndeedApplyConfigurationResumeField["Gender"] = "GENDER";
    IndeedApplyConfigurationResumeField["Languages"] = "LANGUAGES";
    IndeedApplyConfigurationResumeField["Location"] = "LOCATION";
    IndeedApplyConfigurationResumeField["NamePronunciation"] = "NAME_PRONUNCIATION";
    IndeedApplyConfigurationResumeField["Phone"] = "PHONE";
    IndeedApplyConfigurationResumeField["Positions"] = "POSITIONS";
    IndeedApplyConfigurationResumeField["Skills"] = "SKILLS";
})(IndeedApplyConfigurationResumeField || (IndeedApplyConfigurationResumeField = {}));
/** Enum values for destination of RSVP flow */
export var IndeedApplyInterviewRsvpDestinationType;
(function (IndeedApplyInterviewRsvpDestinationType) {
    IndeedApplyInterviewRsvpDestinationType["Cancel"] = "CANCEL";
    IndeedApplyInterviewRsvpDestinationType["Confirm"] = "CONFIRM";
    IndeedApplyInterviewRsvpDestinationType["Reschedule"] = "RESCHEDULE";
    IndeedApplyInterviewRsvpDestinationType["Suggesttime"] = "SUGGESTTIME";
})(IndeedApplyInterviewRsvpDestinationType || (IndeedApplyInterviewRsvpDestinationType = {}));
/** The strictness types for a requirement that can be set by an employer */
export var IndeedApplyJobSeekerRelevanceSqRequirementStrictness;
(function (IndeedApplyJobSeekerRelevanceSqRequirementStrictness) {
    IndeedApplyJobSeekerRelevanceSqRequirementStrictness["Hard"] = "HARD";
    IndeedApplyJobSeekerRelevanceSqRequirementStrictness["Info"] = "INFO";
    IndeedApplyJobSeekerRelevanceSqRequirementStrictness["Multi"] = "MULTI";
    IndeedApplyJobSeekerRelevanceSqRequirementStrictness["Soft"] = "SOFT";
})(IndeedApplyJobSeekerRelevanceSqRequirementStrictness || (IndeedApplyJobSeekerRelevanceSqRequirementStrictness = {}));
/** The types of requirements which can have a mismatch */
export var IndeedApplyJobSeekerRelevanceSqRequirementType;
(function (IndeedApplyJobSeekerRelevanceSqRequirementType) {
    IndeedApplyJobSeekerRelevanceSqRequirementType["Education"] = "EDUCATION";
    IndeedApplyJobSeekerRelevanceSqRequirementType["Experience"] = "EXPERIENCE";
    IndeedApplyJobSeekerRelevanceSqRequirementType["Language"] = "LANGUAGE";
    IndeedApplyJobSeekerRelevanceSqRequirementType["License"] = "LICENSE";
    IndeedApplyJobSeekerRelevanceSqRequirementType["LocalizedEducation"] = "LOCALIZED_EDUCATION";
    IndeedApplyJobSeekerRelevanceSqRequirementType["LocalizedWorkAuthorization"] = "LOCALIZED_WORK_AUTHORIZATION";
    IndeedApplyJobSeekerRelevanceSqRequirementType["Location"] = "LOCATION";
    IndeedApplyJobSeekerRelevanceSqRequirementType["ShiftAvailability"] = "SHIFT_AVAILABILITY";
    IndeedApplyJobSeekerRelevanceSqRequirementType["WillingnessToTravel"] = "WILLINGNESS_TO_TRAVEL";
    IndeedApplyJobSeekerRelevanceSqRequirementType["WorkAuthorization"] = "WORK_AUTHORIZATION";
})(IndeedApplyJobSeekerRelevanceSqRequirementType || (IndeedApplyJobSeekerRelevanceSqRequirementType = {}));
/** Enum for Indeed Apply name format. */
export var IndeedApplyNameFormatType;
(function (IndeedApplyNameFormatType) {
    /** Show separate first and last name fields. */
    IndeedApplyNameFormatType["FirstLastName"] = "FIRST_LAST_NAME";
    /** Show single full name field. */
    IndeedApplyNameFormatType["FullName"] = "FULL_NAME";
})(IndeedApplyNameFormatType || (IndeedApplyNameFormatType = {}));
/** Supported partner job board job seeker authentication methods */
export var IndeedApplyPartnerAuthenticationMethod;
(function (IndeedApplyPartnerAuthenticationMethod) {
    IndeedApplyPartnerAuthenticationMethod["AuthenticationSessionManager"] = "AUTHENTICATION_SESSION_MANAGER";
    IndeedApplyPartnerAuthenticationMethod["None"] = "NONE";
    IndeedApplyPartnerAuthenticationMethod["Passport"] = "PASSPORT";
})(IndeedApplyPartnerAuthenticationMethod || (IndeedApplyPartnerAuthenticationMethod = {}));
/** Indeed Apply Partner Token Type */
export var IndeedApplyPartnerTokenType;
(function (IndeedApplyPartnerTokenType) {
    IndeedApplyPartnerTokenType["Real"] = "REAL";
    IndeedApplyPartnerTokenType["Test"] = "TEST";
})(IndeedApplyPartnerTokenType || (IndeedApplyPartnerTokenType = {}));
/**
 * Indicates whether an employer job was detected as Indeed Apply-enabled.
 *
 * This enum is non-exhaustive and new values will be added from time to time.
 */
export var IndeedApplyStatusEnum;
(function (IndeedApplyStatusEnum) {
    /** Job was detected as Indeed Apply-enabled at policy create/update time. */
    IndeedApplyStatusEnum["IndeedApplyFound"] = "INDEED_APPLY_FOUND";
    /** Job was not detected as Indeed Apply-enabled at policy create/update time. */
    IndeedApplyStatusEnum["IndeedApplyNotFound"] = "INDEED_APPLY_NOT_FOUND";
})(IndeedApplyStatusEnum || (IndeedApplyStatusEnum = {}));
/** Status of IndeedApplySync */
export var IndeedApplySyncStatus;
(function (IndeedApplySyncStatus) {
    /** The link is working properly and data can flow through it */
    IndeedApplySyncStatus["Active"] = "ACTIVE";
    /** The link requires additional configuration in order to activate Indeed Apply Sync */
    IndeedApplySyncStatus["ConfigurationRequired"] = "CONFIGURATION_REQUIRED";
    /** The link has been deleted */
    IndeedApplySyncStatus["Deleted"] = "DELETED";
    /** The link is disabled. Data cannot flow through it */
    IndeedApplySyncStatus["Disabled"] = "DISABLED";
    /** The link is in an unknown state */
    IndeedApplySyncStatus["Indeterminate"] = "INDETERMINATE";
    /** Waiting on Agg to update the feed */
    IndeedApplySyncStatus["PendingAggReview"] = "PENDING_AGG_REVIEW";
    /** The link is pending to be deleted after it completes any pending work */
    IndeedApplySyncStatus["PendingDelete"] = "PENDING_DELETE";
    /** The link will be disabled after completes any pending work */
    IndeedApplySyncStatus["PendingDisable"] = "PENDING_DISABLE";
    /** Waiting on IndeedApplySync to create the request to Agg */
    IndeedApplySyncStatus["PendingIasReview"] = "PENDING_IAS_REVIEW";
})(IndeedApplySyncStatus || (IndeedApplySyncStatus = {}));
export var IndeedAssistantAiModelApiType;
(function (IndeedAssistantAiModelApiType) {
    /** Open AI Models */
    IndeedAssistantAiModelApiType["ChatCompletions"] = "ChatCompletions";
    /** Bedrock or Claude Models */
    IndeedAssistantAiModelApiType["Messages"] = "Messages";
    /** AI4Indeed specific model, used for IQL related questions */
    IndeedAssistantAiModelApiType["Spock"] = "Spock";
})(IndeedAssistantAiModelApiType || (IndeedAssistantAiModelApiType = {}));
export var IndeedAssistantPermission;
(function (IndeedAssistantPermission) {
    IndeedAssistantPermission["CreateItem"] = "CREATE_ITEM";
    IndeedAssistantPermission["CreateTool"] = "CREATE_TOOL";
    IndeedAssistantPermission["DeleteTool"] = "DELETE_TOOL";
    IndeedAssistantPermission["ManageRoles"] = "MANAGE_ROLES";
    IndeedAssistantPermission["ManageUser"] = "MANAGE_USER";
    IndeedAssistantPermission["UpdateItem"] = "UPDATE_ITEM";
    IndeedAssistantPermission["UpdateTool"] = "UPDATE_TOOL";
    IndeedAssistantPermission["UseTools"] = "USE_TOOLS";
    IndeedAssistantPermission["ViewItem"] = "VIEW_ITEM";
})(IndeedAssistantPermission || (IndeedAssistantPermission = {}));
/** Supported Indeed disposition statuses. */
export var IndeedDispositionStatus;
(function (IndeedDispositionStatus) {
    /** Pre-hire assessment. Can include skills tests, take-home assignments, and other methods. */
    IndeedDispositionStatus["AssessQualifications"] = "ASSESS_QUALIFICATIONS";
    /** Background check in progress. */
    IndeedDispositionStatus["BackgroundCheck"] = "BACKGROUND_CHECK";
    /** Candidate contacted by phone or email. `CONTACTED` does not include rejections. */
    IndeedDispositionStatus["Contacted"] = "CONTACTED";
    /**
     * Use this disposition status only for application delivery failure, not for the application disposition.
     *
     * If a duplicate application exists and delivery fails asynchronously, the ATS returns HTTP `200 OK` and reports this status through the Disposition Sync API.
     */
    IndeedDispositionStatus["DroppedDuplicate"] = "DROPPED_DUPLICATE";
    /**
     * Use this disposition status only for application delivery failure, not for the application disposition.
     *
     * If the application is flagged as fraud or spam and delivery fails asynchronously, the ATS returns HTTP `200 OK` and reports this status through the Disposition Sync API.
     */
    IndeedDispositionStatus["DroppedFraudSpam"] = "DROPPED_FRAUD_SPAM";
    /**
     * Use this disposition status only for application delivery failure, not for the application disposition.
     *
     * If the job is expired or no longer available and delivery fails asynchronously, the ATS returns HTTP `200 OK` and reports this status through the Disposition Sync API.
     */
    IndeedDispositionStatus["DroppedJobExpired"] = "DROPPED_JOB_EXPIRED";
    /**
     * Use this disposition status only for application delivery failure, not for the application disposition.
     *
     * If delivery fails asynchronously for any other reason, the ATS returns HTTP `200 OK` and reports this status through the Disposition Sync API.
     */
    IndeedDispositionStatus["DroppedOther"] = "DROPPED_OTHER";
    /** Required. Candidate accepted a job offer. */
    IndeedDispositionStatus["Hired"] = "HIRED";
    /** Application incomplete. */
    IndeedDispositionStatus["Incomplete"] = "INCOMPLETE";
    /** Candidate is interviewing. Can span multiple interviews. */
    IndeedDispositionStatus["Interview"] = "INTERVIEW";
    /** Job is closed. */
    IndeedDispositionStatus["JobClosed"] = "JOB_CLOSED";
    /** The job is inactive and no longer accepting applications. */
    IndeedDispositionStatus["JobInactive"] = "JOB_INACTIVE";
    /** Recruiter liked, favorited, or shortlisted the application. */
    IndeedDispositionStatus["Liked"] = "LIKED";
    /** Required. ATS received a new job application. */
    IndeedDispositionStatus["New"] = "NEW";
    /** Required. Candidate not selected. */
    IndeedDispositionStatus["NotSelected"] = "NOT_SELECTED";
    /** Candidate declined the offer. */
    IndeedDispositionStatus["OfferDeclined"] = "OFFER_DECLINED";
    /** Candidate received a job offer. */
    IndeedDispositionStatus["OfferMade"] = "OFFER_MADE";
    /** Applicant onboarded. */
    IndeedDispositionStatus["Onboarded"] = "ONBOARDED";
    /** Applicant passed pre-hire screening. Maps to `SCREEN` status. */
    IndeedDispositionStatus["PositivelyScreened"] = "POSITIVELY_SCREENED";
    /** Application under review. */
    IndeedDispositionStatus["Review"] = "REVIEW";
    /** Pre-hire screening. Can include phone screening and other methods. */
    IndeedDispositionStatus["Screen"] = "SCREEN";
    /** Use this status when no other status fits. */
    IndeedDispositionStatus["UnableToMap"] = "UNABLE_TO_MAP";
    /** Pre-hire eligibility. Can include license verification, drug test, and other methods. */
    IndeedDispositionStatus["VerifyEligibility"] = "VERIFY_ELIGIBILITY";
    /** Candidate withdrew application. */
    IndeedDispositionStatus["Withdrawn"] = "WITHDRAWN";
})(IndeedDispositionStatus || (IndeedDispositionStatus = {}));
/** Indeed features you can enable for an employer. */
export var IndeedFeatureNameInput;
(function (IndeedFeatureNameInput) {
    /** `RetrieveSourcedCandidates.AutomatedTransfers` feature. */
    IndeedFeatureNameInput["RetrieveSourcedCandidatesAuto"] = "RETRIEVE_SOURCED_CANDIDATES_AUTO";
    /** `RetrieveSourcedCandidates.OneClick` feature. */
    IndeedFeatureNameInput["RetrieveSourcedCandidatesClick"] = "RETRIEVE_SOURCED_CANDIDATES_CLICK";
    /** `SendApplications` feature. */
    IndeedFeatureNameInput["SendApplications"] = "SEND_APPLICATIONS";
})(IndeedFeatureNameInput || (IndeedFeatureNameInput = {}));
/** Feature status. */
export var IndeedFeatureStatus;
(function (IndeedFeatureStatus) {
    /** Feature is disabled. */
    IndeedFeatureStatus["Disabled"] = "DISABLED";
    /** Feature is enabled. */
    IndeedFeatureStatus["Enabled"] = "ENABLED";
    /** ATS does not support this feature. */
    IndeedFeatureStatus["NotAllowed"] = "NOT_ALLOWED";
})(IndeedFeatureStatus || (IndeedFeatureStatus = {}));
/** Feature status. */
export var IndeedFeatureStatusInput;
(function (IndeedFeatureStatusInput) {
    /** Feature is disabled. */
    IndeedFeatureStatusInput["Disabled"] = "DISABLED";
    /** Feature is enabled. */
    IndeedFeatureStatusInput["Enabled"] = "ENABLED";
})(IndeedFeatureStatusInput || (IndeedFeatureStatusInput = {}));
/** Education degree, e.g., BACHELORS, MASTERS. */
export var IndeedPlusCandidateEducationDegree;
(function (IndeedPlusCandidateEducationDegree) {
    IndeedPlusCandidateEducationDegree["Associates"] = "ASSOCIATES";
    IndeedPlusCandidateEducationDegree["Bachelors"] = "BACHELORS";
    IndeedPlusCandidateEducationDegree["Diploma"] = "DIPLOMA";
    IndeedPlusCandidateEducationDegree["Doctorate"] = "DOCTORATE";
    IndeedPlusCandidateEducationDegree["Foundation"] = "FOUNDATION";
    IndeedPlusCandidateEducationDegree["HighSchool"] = "HIGH_SCHOOL";
    IndeedPlusCandidateEducationDegree["JuniorHighSchool"] = "JUNIOR_HIGH_SCHOOL";
    IndeedPlusCandidateEducationDegree["Masters"] = "MASTERS";
})(IndeedPlusCandidateEducationDegree || (IndeedPlusCandidateEducationDegree = {}));
/** Month type, e.g. JANUARY. Month type of NOT_SPECIFIED is used to update month to null. */
export var IndeedPlusCandidateMonthType;
(function (IndeedPlusCandidateMonthType) {
    IndeedPlusCandidateMonthType["April"] = "APRIL";
    IndeedPlusCandidateMonthType["August"] = "AUGUST";
    IndeedPlusCandidateMonthType["December"] = "DECEMBER";
    IndeedPlusCandidateMonthType["February"] = "FEBRUARY";
    IndeedPlusCandidateMonthType["January"] = "JANUARY";
    IndeedPlusCandidateMonthType["July"] = "JULY";
    IndeedPlusCandidateMonthType["June"] = "JUNE";
    IndeedPlusCandidateMonthType["March"] = "MARCH";
    IndeedPlusCandidateMonthType["May"] = "MAY";
    IndeedPlusCandidateMonthType["NotSpecified"] = "NOT_SPECIFIED";
    IndeedPlusCandidateMonthType["November"] = "NOVEMBER";
    IndeedPlusCandidateMonthType["October"] = "OCTOBER";
    IndeedPlusCandidateMonthType["September"] = "SEPTEMBER";
})(IndeedPlusCandidateMonthType || (IndeedPlusCandidateMonthType = {}));
/** Candidate's resume state. For example, PUBLIC or HIDDEN. */
export var IndeedPlusCandidateResumeState;
(function (IndeedPlusCandidateResumeState) {
    IndeedPlusCandidateResumeState["Deleted"] = "DELETED";
    IndeedPlusCandidateResumeState["Hidden"] = "HIDDEN";
    IndeedPlusCandidateResumeState["Public"] = "PUBLIC";
})(IndeedPlusCandidateResumeState || (IndeedPlusCandidateResumeState = {}));
/** Candidate's resume type. For example, INDEED_RESUME. */
export var IndeedPlusCandidateResumeType;
(function (IndeedPlusCandidateResumeType) {
    IndeedPlusCandidateResumeType["IndeedResume"] = "INDEED_RESUME";
    IndeedPlusCandidateResumeType["Parsed"] = "PARSED";
    IndeedPlusCandidateResumeType["Recruit"] = "RECRUIT";
    IndeedPlusCandidateResumeType["Unknown"] = "UNKNOWN";
})(IndeedPlusCandidateResumeType || (IndeedPlusCandidateResumeType = {}));
export var IndeedPlusPartnerConversationEventType;
(function (IndeedPlusPartnerConversationEventType) {
    IndeedPlusPartnerConversationEventType["Message"] = "MESSAGE";
})(IndeedPlusPartnerConversationEventType || (IndeedPlusPartnerConversationEventType = {}));
/** IndeedPlus Partner message content type */
export var IndeedPlusPartnerMessageContentType;
(function (IndeedPlusPartnerMessageContentType) {
    IndeedPlusPartnerMessageContentType["Html"] = "HTML";
})(IndeedPlusPartnerMessageContentType || (IndeedPlusPartnerMessageContentType = {}));
/** Represents how an ATS-specific remote type value maps to Indeed's remote work classification */
export var IndeedRemoteTypeMapping;
(function (IndeedRemoteTypeMapping) {
    /** This remote type value should not be mapped to an Indeed remote type */
    IndeedRemoteTypeMapping["DoNotMap"] = "DO_NOT_MAP";
    /** The job is fully remote and open to applicants across the entire country */
    IndeedRemoteTypeMapping["FullyRemoteCountryWide"] = "FULLY_REMOTE_COUNTRY_WIDE";
    /** The job is fully remote but restricted to applicants within a specific state or region */
    IndeedRemoteTypeMapping["FullyRemoteStateWide"] = "FULLY_REMOTE_STATE_WIDE";
    /** The job requires a mix of on-site and remote work */
    IndeedRemoteTypeMapping["HybridRemote"] = "HYBRID_REMOTE";
})(IndeedRemoteTypeMapping || (IndeedRemoteTypeMapping = {}));
/** Location types in Locationdb, eg, CITY, ADMIN4 */
export var IndiaLocationSuggestionType;
(function (IndiaLocationSuggestionType) {
    IndiaLocationSuggestionType["Admin3"] = "ADMIN3";
    IndiaLocationSuggestionType["Admin4"] = "ADMIN4";
    IndiaLocationSuggestionType["City"] = "CITY";
})(IndiaLocationSuggestionType || (IndiaLocationSuggestionType = {}));
export var InferredImportance;
(function (InferredImportance) {
    InferredImportance["Preferred"] = "PREFERRED";
    InferredImportance["Required"] = "REQUIRED";
})(InferredImportance || (InferredImportance = {}));
export var InferredMinimumPaySource;
(function (InferredMinimumPaySource) {
    InferredMinimumPaySource["Niffler"] = "NIFFLER";
    InferredMinimumPaySource["NonInferredPay"] = "NON_INFERRED_PAY";
    InferredMinimumPaySource["SearchQuery"] = "SEARCH_QUERY";
})(InferredMinimumPaySource || (InferredMinimumPaySource = {}));
/** Visual style variants for info bar elements. */
export var InfoBarStyle;
(function (InfoBarStyle) {
    /** Critical/error bar (typically red) */
    InfoBarStyle["Critical"] = "CRITICAL";
    /** Informational bar (typically blue) */
    InfoBarStyle["Info"] = "INFO";
    /** Neutral style with minimal background */
    InfoBarStyle["Neutral"] = "NEUTRAL";
    /** Neutral style with filled background */
    InfoBarStyle["NeutralFill"] = "NEUTRAL_FILL";
    /** Success bar (typically green) */
    InfoBarStyle["Success"] = "SUCCESS";
    /** Warning bar (typically yellow/orange) */
    InfoBarStyle["Warning"] = "WARNING";
})(InfoBarStyle || (InfoBarStyle = {}));
export var InitiateEmployerVerificationError;
(function (InitiateEmployerVerificationError) {
    InitiateEmployerVerificationError["AlreadyVerified"] = "ALREADY_VERIFIED";
    InitiateEmployerVerificationError["InitiateLimitReached"] = "INITIATE_LIMIT_REACHED";
    InitiateEmployerVerificationError["SessionExpired"] = "SESSION_EXPIRED";
})(InitiateEmployerVerificationError || (InitiateEmployerVerificationError = {}));
/** Representation of Insertion Order Status */
export var InsertionOrderStatus;
(function (InsertionOrderStatus) {
    InsertionOrderStatus["Active"] = "ACTIVE";
    InsertionOrderStatus["Canceled"] = "CANCELED";
    InsertionOrderStatus["Completed"] = "COMPLETED";
    InsertionOrderStatus["Created"] = "CREATED";
    InsertionOrderStatus["Paused"] = "PAUSED";
    InsertionOrderStatus["Signed"] = "SIGNED";
    InsertionOrderStatus["Stopped"] = "STOPPED";
})(InsertionOrderStatus || (InsertionOrderStatus = {}));
/**  What type of failure was reported when performing insight lookup  */
export var InsightFailedLookupStatus;
(function (InsightFailedLookupStatus) {
    /**  The requested country is not currently supported for insights data  */
    InsightFailedLookupStatus["CountryNotSupported"] = "COUNTRY_NOT_SUPPORTED";
    /**  Failed to normalize the provided location  */
    InsightFailedLookupStatus["FailedToNormalizeLocation"] = "FAILED_TO_NORMALIZE_LOCATION";
    /**  Failed to normalize the provided job title  */
    InsightFailedLookupStatus["FailedToNormalizeTitle"] = "FAILED_TO_NORMALIZE_TITLE";
    /**  Failed to normalize both the provided job title and location  */
    InsightFailedLookupStatus["FailedToNormalizeTitleAndLocation"] = "FAILED_TO_NORMALIZE_TITLE_AND_LOCATION";
    /**  No insights data was found for the given search criteria  */
    InsightFailedLookupStatus["NoInsightsFound"] = "NO_INSIGHTS_FOUND";
})(InsightFailedLookupStatus || (InsightFailedLookupStatus = {}));
/**  The hosting type attributed to an insight  */
export var InsightHostingType;
(function (InsightHostingType) {
    InsightHostingType["Hosted"] = "HOSTED";
    InsightHostingType["Indexed"] = "INDEXED";
})(InsightHostingType || (InsightHostingType = {}));
/**  What type of search the algorithm expanded by when generating insights.  */
export var InsightMatchedLevelType;
(function (InsightMatchedLevelType) {
    /**  Algorithm expanded to the country level.  */
    InsightMatchedLevelType["CountryWide"] = "COUNTRY_WIDE";
    /**  Algorithm did not expand due to finding an exact match.  */
    InsightMatchedLevelType["ExactMatch"] = "EXACT_MATCH";
    /**  Algorithm expanded to multiple locations.  */
    InsightMatchedLevelType["ExpandedLocations"] = "EXPANDED_LOCATIONS";
    /**  Algorithm expanded to multiple locations and multiple similar norm titles.  */
    InsightMatchedLevelType["ExpandedLocationsAndTitles"] = "EXPANDED_LOCATIONS_AND_TITLES";
    /**  Algorithm expanded by multiple similar norm titles.  */
    InsightMatchedLevelType["ExpandedTitles"] = "EXPANDED_TITLES";
    /**  Algorithm expanded to the state level.  */
    InsightMatchedLevelType["StateWide"] = "STATE_WIDE";
})(InsightMatchedLevelType || (InsightMatchedLevelType = {}));
/**  Percentile breakdown of Insights data.  */
export var InsightPercentile;
(function (InsightPercentile) {
    /**  25th percentile   */
    InsightPercentile["P_25"] = "P_25";
    /**  50th percentile   */
    InsightPercentile["P_50"] = "P_50";
    /**  75th percentile   */
    InsightPercentile["P_75"] = "P_75";
    /**  90th percentile   */
    InsightPercentile["P_90"] = "P_90";
    /**  99th percentile  */
    InsightPercentile["P_99"] = "P_99";
})(InsightPercentile || (InsightPercentile = {}));
/**  Traffic type attributed to the insight. COMBINED is both SPONSORED and ORGANIC traffic together.  */
export var InsightTrafficType;
(function (InsightTrafficType) {
    InsightTrafficType["Combined"] = "COMBINED";
    InsightTrafficType["Organic"] = "ORGANIC";
    InsightTrafficType["Sponsored"] = "SPONSORED";
})(InsightTrafficType || (InsightTrafficType = {}));
/**  insights match types  */
export var InsightsMatchType;
(function (InsightsMatchType) {
    InsightsMatchType["CountryWide"] = "COUNTRY_WIDE";
    InsightsMatchType["ExactMatch"] = "EXACT_MATCH";
    InsightsMatchType["ExpandedLocations"] = "EXPANDED_LOCATIONS";
    InsightsMatchType["ExpandedLocationsAndTitles"] = "EXPANDED_LOCATIONS_AND_TITLES";
    InsightsMatchType["ExpandedTitles"] = "EXPANDED_TITLES";
    InsightsMatchType["StateWide"] = "STATE_WIDE";
})(InsightsMatchType || (InsightsMatchType = {}));
/**  insights available percentiles list  */
export var InsightsPercentile;
(function (InsightsPercentile) {
    InsightsPercentile["P25"] = "P25";
    InsightsPercentile["P50"] = "P50";
    InsightsPercentile["P75"] = "P75";
    InsightsPercentile["P90"] = "P90";
    InsightsPercentile["P99"] = "P99";
})(InsightsPercentile || (InsightsPercentile = {}));
/** Status of an agent instruction update */
export var InstructionUpdateStatus;
(function (InstructionUpdateStatus) {
    InstructionUpdateStatus["Failed"] = "FAILED";
    InstructionUpdateStatus["Success"] = "SUCCESS";
})(InstructionUpdateStatus || (InstructionUpdateStatus = {}));
/** Number of hires needed */
export var IntHiresNeeded;
(function (IntHiresNeeded) {
    IntHiresNeeded["Eight"] = "EIGHT";
    IntHiresNeeded["Empty"] = "EMPTY";
    IntHiresNeeded["Five"] = "FIVE";
    IntHiresNeeded["Four"] = "FOUR";
    IntHiresNeeded["Nine"] = "NINE";
    IntHiresNeeded["One"] = "ONE";
    IntHiresNeeded["RecurringHire"] = "RECURRING_HIRE";
    IntHiresNeeded["Seven"] = "SEVEN";
    IntHiresNeeded["Six"] = "SIX";
    IntHiresNeeded["Ten"] = "TEN";
    IntHiresNeeded["TenPlus"] = "TEN_PLUS";
    IntHiresNeeded["Three"] = "THREE";
    IntHiresNeeded["Two"] = "TWO";
})(IntHiresNeeded || (IntHiresNeeded = {}));
export var IntegrationBannerKind;
(function (IntegrationBannerKind) {
    /**
     * Issued to prompt Workday integrations using the legacy ISU auth method to migrate
     * to the new Refresh Token + Client Secret authentication method
     */
    IntegrationBannerKind["WorkdayAuthMigration"] = "WORKDAY_AUTH_MIGRATION";
    /** Issued when a workflow that is not complete is cancelled or uninstalled */
    IntegrationBannerKind["WorkflowCancelling"] = "WORKFLOW_CANCELLING";
    /** Issued when the workflow is marked completed */
    IntegrationBannerKind["WorkflowComplete"] = "WORKFLOW_COMPLETE";
    /** Issued when a workflow is deleted */
    IntegrationBannerKind["WorkflowDeleted"] = "WORKFLOW_DELETED";
    /** Issued when the first step in a workflow has been marked complete */
    IntegrationBannerKind["WorkflowInprogress"] = "WORKFLOW_INPROGRESS";
    /** Issued when a workflow review period starts */
    IntegrationBannerKind["WorkflowUnderReview"] = "WORKFLOW_UNDER_REVIEW";
    /** Issued when a completed workflow is cancelled or uninstalled */
    IntegrationBannerKind["WorkflowUninstalling"] = "WORKFLOW_UNINSTALLING";
})(IntegrationBannerKind || (IntegrationBannerKind = {}));
/** enums for api status */
export var IntegrationHubApiStatus;
(function (IntegrationHubApiStatus) {
    IntegrationHubApiStatus["Error"] = "ERROR";
    IntegrationHubApiStatus["Ok"] = "OK";
})(IntegrationHubApiStatus || (IntegrationHubApiStatus = {}));
/**  All states a pre-checklist can be in  */
export var IntegrationHubPreChecklistStatus;
(function (IntegrationHubPreChecklistStatus) {
    IntegrationHubPreChecklistStatus["Completed"] = "COMPLETED";
    IntegrationHubPreChecklistStatus["Started"] = "STARTED";
})(IntegrationHubPreChecklistStatus || (IntegrationHubPreChecklistStatus = {}));
/**  All states a pre-checklist step can be in  */
export var IntegrationHubPreChecklistStepStatus;
(function (IntegrationHubPreChecklistStepStatus) {
    IntegrationHubPreChecklistStepStatus["Completed"] = "COMPLETED";
    IntegrationHubPreChecklistStepStatus["Pending"] = "PENDING";
})(IntegrationHubPreChecklistStepStatus || (IntegrationHubPreChecklistStepStatus = {}));
/**  All states a workflow can be in  */
export var IntegrationHubWorkflowStatusKind;
(function (IntegrationHubWorkflowStatusKind) {
    IntegrationHubWorkflowStatusKind["Cancelled"] = "CANCELLED";
    IntegrationHubWorkflowStatusKind["Complete"] = "COMPLETE";
    IntegrationHubWorkflowStatusKind["Started"] = "STARTED";
    IntegrationHubWorkflowStatusKind["UnderReview"] = "UNDER_REVIEW";
    IntegrationHubWorkflowStatusKind["Uninstalled"] = "UNINSTALLED";
})(IntegrationHubWorkflowStatusKind || (IntegrationHubWorkflowStatusKind = {}));
/**  All states a step can be in  */
export var IntegrationHubWorkflowStepStatusKind;
(function (IntegrationHubWorkflowStepStatusKind) {
    IntegrationHubWorkflowStepStatusKind["Complete"] = "COMPLETE";
    IntegrationHubWorkflowStepStatusKind["Incomplete"] = "INCOMPLETE";
    IntegrationHubWorkflowStepStatusKind["NotStarted"] = "NOT_STARTED";
    IntegrationHubWorkflowStepStatusKind["Skipped"] = "SKIPPED";
})(IntegrationHubWorkflowStepStatusKind || (IntegrationHubWorkflowStepStatusKind = {}));
/** Integration identifier enumeration */
export var IntegrationId;
(function (IntegrationId) {
    /** On-demand license verification integration */
    IntegrationId["OnDemandLicenseVerification"] = "ON_DEMAND_LICENSE_VERIFICATION";
    /** Persona integration for identity verification */
    IntegrationId["PersonaIntegration"] = "PERSONA_INTEGRATION";
    /** Temporary on-demand license verification integration */
    IntegrationId["TemporaryOnDemandLicenseVerification"] = "TEMPORARY_ON_DEMAND_LICENSE_VERIFICATION";
    /** Third-party verification integration */
    IntegrationId["ThirdPartyVerification"] = "THIRD_PARTY_VERIFICATION";
    /** Verifiable integration for license verification */
    IntegrationId["VerifiableIntegration"] = "VERIFIABLE_INTEGRATION";
})(IntegrationId || (IntegrationId = {}));
export var IntegrationInteractionKind;
(function (IntegrationInteractionKind) {
    IntegrationInteractionKind["Dismissal"] = "DISMISSAL";
    IntegrationInteractionKind["Impression"] = "IMPRESSION";
    IntegrationInteractionKind["PrimaryCta"] = "PRIMARY_CTA";
})(IntegrationInteractionKind || (IntegrationInteractionKind = {}));
/** Different source to identify the ad source */
export var IntegrationNotificationKind;
(function (IntegrationNotificationKind) {
    IntegrationNotificationKind["CampaignsPage"] = "CAMPAIGNS_PAGE";
    IntegrationNotificationKind["IhHomepage"] = "IH_HOMEPAGE";
    /** Indeed Apply promo banner shown on the Jobs page to boost IA Sync adoption. */
    IntegrationNotificationKind["IndeedApplyPromo"] = "INDEED_APPLY_PROMO";
    IntegrationNotificationKind["JobsPage"] = "JOBS_PAGE";
    IntegrationNotificationKind["SmartSourcingPage"] = "SMART_SOURCING_PAGE";
})(IntegrationNotificationKind || (IntegrationNotificationKind = {}));
/** Status of an ATS integration */
export var IntegrationStatus;
(function (IntegrationStatus) {
    /** Integration is active and working */
    IntegrationStatus["Active"] = "ACTIVE";
    /** Integration has been deleted */
    IntegrationStatus["Deleted"] = "DELETED";
    /** Integration is temporarily inactive */
    IntegrationStatus["Inactive"] = "INACTIVE";
    /** Integration credentials or permissions are invalid */
    IntegrationStatus["Invalid"] = "INVALID";
    /** Status is unspecified */
    IntegrationStatus["Unspecified"] = "UNSPECIFIED";
})(IntegrationStatus || (IntegrationStatus = {}));
export var IntegrationSupportType;
(function (IntegrationSupportType) {
    IntegrationSupportType["ExistingIntegration"] = "EXISTING_INTEGRATION";
    IntegrationSupportType["InformationRequest"] = "INFORMATION_REQUEST";
    IntegrationSupportType["IntegrationNotWorking"] = "INTEGRATION_NOT_WORKING";
    IntegrationSupportType["NewIntegration"] = "NEW_INTEGRATION";
})(IntegrationSupportType || (IntegrationSupportType = {}));
/** All states a step can be in */
export var IntegrationSyncFeatureKind;
(function (IntegrationSyncFeatureKind) {
    IntegrationSyncFeatureKind["CandidateInbound"] = "CANDIDATE_INBOUND";
    IntegrationSyncFeatureKind["DispositionMappingInbound"] = "DISPOSITION_MAPPING_INBOUND";
    IntegrationSyncFeatureKind["DispositionMappingOutbound"] = "DISPOSITION_MAPPING_OUTBOUND";
    IntegrationSyncFeatureKind["EeoInbound"] = "EEO_INBOUND";
    IntegrationSyncFeatureKind["EeoOutbound"] = "EEO_OUTBOUND";
    IntegrationSyncFeatureKind["IndeedApplyInbound"] = "INDEED_APPLY_INBOUND";
    IntegrationSyncFeatureKind["IndeedApplyOptIn"] = "INDEED_APPLY_OPT_IN";
    IntegrationSyncFeatureKind["IndeedApplyOptOut"] = "INDEED_APPLY_OPT_OUT";
    IntegrationSyncFeatureKind["IndeedApplyOutbound"] = "INDEED_APPLY_OUTBOUND";
    IntegrationSyncFeatureKind["ScreenerAnswersOutbound"] = "SCREENER_ANSWERS_OUTBOUND";
    IntegrationSyncFeatureKind["ScreenerQuestionsInbound"] = "SCREENER_QUESTIONS_INBOUND";
    IntegrationSyncFeatureKind["SmartsourcingOutbound"] = "SMARTSOURCING_OUTBOUND";
    IntegrationSyncFeatureKind["SponsoredJobsIntegration"] = "SPONSORED_JOBS_INTEGRATION";
})(IntegrationSyncFeatureKind || (IntegrationSyncFeatureKind = {}));
/** Category of integration tools */
export var IntegrationToolCategory;
(function (IntegrationToolCategory) {
    /** Assessment/Testing platforms */
    IntegrationToolCategory["Assessment"] = "ASSESSMENT";
    /** Applicant Tracking System */
    IntegrationToolCategory["Ats"] = "ATS";
    /** Human Resources Information System */
    IntegrationToolCategory["Hris"] = "HRIS";
    /** Learning Management System */
    IntegrationToolCategory["Lms"] = "LMS";
})(IntegrationToolCategory || (IntegrationToolCategory = {}));
/** Intended visibility ceiling for a single-source API feed. */
export var IntendedVisibility;
(function (IntendedVisibility) {
    /** Up to JA/organic visibility: the feed should carry all of the client's active jobs. */
    IntendedVisibility["Organic"] = "ORGANIC";
    /** Up to Sponsored-Only visibility: the feed may carry fewer than all active jobs. */
    IntendedVisibility["SponsoredOnly"] = "SPONSORED_ONLY";
})(IntendedVisibility || (IntendedVisibility = {}));
/**
 * actions specific to products that need to distinguish between
 * arrival (when a person showed) vs. joining (when a person
 * is able to start a specific interview connection).
 *
 * In a happy path where the jobseeker and interviewer
 * connect in a hosted video interview, all of the following
 * InterviewConnectionActions are expected: JOBSEEKER_ARRIVED,
 * JOBSEEKER_JOINED, INTERVIEWER_ARRIVED, INTERVIEWER_JOINED,
 * CONNECTION_STARTED, JOBSEEKER_LEFT, INTERVIEWER_LEFT,
 * CONNECTION_ENDED
 */
export var InterviewConnectionAction;
(function (InterviewConnectionAction) {
    /** interview ended without a connection */
    InterviewConnectionAction["ConnectionAttemptEnded"] = "CONNECTION_ATTEMPT_ENDED";
    /**
     * the connection ended, this should always result
     * In the connection duration being updated and will almost always be
     * accompanied by another action (e.g. JOBSEEKER_LEFT or INTERVIEWER_LEFT)
     */
    InterviewConnectionAction["ConnectionEnded"] = "CONNECTION_ENDED";
    /**
     * the connection started, this will almost always
     * be accompanied by another action (e.g. JOBSEEKER_JOINED or
     * INTERVIEWER_JOINED)
     */
    InterviewConnectionAction["ConnectionStarted"] = "CONNECTION_STARTED";
    /**
     * DEFAULT should never be used, but is required to ensure a known
     * value exists to identify breaking changes in our
     * protobuf schema
     */
    InterviewConnectionAction["Default"] = "DEFAULT";
    /**
     * INTERVIEWER_ARRIVED represents the action of a interviewer
     * arriving to the interview location, but they may not be able to
     * connect with the jobseeker for the specific interview yet.
     * In hosted video, this is when the interviewer
     * has entered the lobby, but has not entered the convo room related
     * to the ICR's related IMP interview.
     * In IRL events, this is when the interviewer arrives to the event,
     * but before they have spoken with this jobseeker (wait time).
     */
    InterviewConnectionAction["InterviewerArrived"] = "INTERVIEWER_ARRIVED";
    /**
     * the employer joined the interview - note that for hosted video
     * interviews, this is not the same thing as the employer arriving
     */
    InterviewConnectionAction["InterviewerJoined"] = "INTERVIEWER_JOINED";
    /** the employer left the interview */
    InterviewConnectionAction["InterviewerLeft"] = "INTERVIEWER_LEFT";
    /**
     * JOBSEEKER_ARRIVED represents the action of a jobseeker
     * arriving to the interview location, but they may not be able to
     * connect with an interviewer yet.
     * In hosted video, this is when the jobseeker has entered the lobby,
     * but has not entered a convo room. In IRL events,
     * this is when the jobseeker arrives to the event, but before they
     * have spoken with an interviewer (wait time).
     */
    InterviewConnectionAction["JobseekerArrived"] = "JOBSEEKER_ARRIVED";
    /**
     * the jobseeker joined the interview - note that for hosted
     * interviews, this is not the same thing as the jobseeker arriving
     */
    InterviewConnectionAction["JobseekerJoined"] = "JOBSEEKER_JOINED";
    /** the jobseeker left the interview */
    InterviewConnectionAction["JobseekerLeft"] = "JOBSEEKER_LEFT";
})(InterviewConnectionAction || (InterviewConnectionAction = {}));
export var InterviewConnectionRecordStatus;
(function (InterviewConnectionRecordStatus) {
    /**
     * The employer and jobseeker have reported conflicting show data.
     * See the interviewConnectionActions enum for granular reports.
     */
    InterviewConnectionRecordStatus["ConflictingInformation"] = "CONFLICTING_INFORMATION";
    /**
     * DEFAULT should never be used, but is required
     * to ensure a known value exists to identify breaking changes in
     * our protobufs
     */
    InterviewConnectionRecordStatus["Default"] = "DEFAULT";
    /** The interview has ended, and the jobseeker showed, but all interviewers were no-shows. */
    InterviewConnectionRecordStatus["EmployerNoShow"] = "EMPLOYER_NO_SHOW";
    /**
     * The interview was completed, and the jobseeker connected
     * with at least one interviewer.
     */
    InterviewConnectionRecordStatus["Interviewed"] = "INTERVIEWED";
    /**
     * The interview is in progress, and the jobseeker is currently
     * connecting with an interviewer.
     */
    InterviewConnectionRecordStatus["Interviewing"] = "INTERVIEWING";
    /**
     * The interview has ended, and the interviewer showed, but the
     * jobseeker no showed.
     */
    InterviewConnectionRecordStatus["JobseekerNoShow"] = "JOBSEEKER_NO_SHOW";
    /**
     * The interview has ended, and both parties showed, but did not
     * connect.
     */
    InterviewConnectionRecordStatus["MissedConnection"] = "MISSED_CONNECTION";
    /** The interview has ended, and neither party showed. */
    InterviewConnectionRecordStatus["MutualNoShow"] = "MUTUAL_NO_SHOW";
    /** Neither jobseeker nor any interviewers have reported show data */
    InterviewConnectionRecordStatus["NoInformation"] = "NO_INFORMATION";
    /**
     * Only one of the employer(s) or jobseeker has reported show data.
     * See the interviewConnectionActions enum for granular reports.
     */
    InterviewConnectionRecordStatus["OnePartyReported"] = "ONE_PARTY_REPORTED";
    /**
     * The interview is in progress, and at least one participant has
     * joined, but the jobseeker has not connected with an interviewer
     * yet.
     */
    InterviewConnectionRecordStatus["Pending"] = "PENDING";
})(InterviewConnectionRecordStatus || (InterviewConnectionRecordStatus = {}));
export var InterviewDifficulty;
(function (InterviewDifficulty) {
    InterviewDifficulty["Easy"] = "EASY";
    InterviewDifficulty["Hard"] = "HARD";
    InterviewDifficulty["InsufficientData"] = "INSUFFICIENT_DATA";
    InterviewDifficulty["Medium"] = "MEDIUM";
})(InterviewDifficulty || (InterviewDifficulty = {}));
export var InterviewExperience;
(function (InterviewExperience) {
    InterviewExperience["Average"] = "AVERAGE";
    InterviewExperience["Excellent"] = "EXCELLENT";
    InterviewExperience["InsufficientData"] = "INSUFFICIENT_DATA";
    InterviewExperience["Poor"] = "POOR";
})(InterviewExperience || (InterviewExperience = {}));
/** Types of source events */
export var InterviewIntentSourceEventName;
(function (InterviewIntentSourceEventName) {
    InterviewIntentSourceEventName["CallbackRelay"] = "CALLBACK_RELAY";
    InterviewIntentSourceEventName["ClickToCall"] = "CLICK_TO_CALL";
    InterviewIntentSourceEventName["DirectToInterview"] = "DIRECT_TO_INTERVIEW";
    InterviewIntentSourceEventName["EmployerManualInvite"] = "EMPLOYER_MANUAL_INVITE";
    InterviewIntentSourceEventName["JobseekerInitiated"] = "JOBSEEKER_INITIATED";
    InterviewIntentSourceEventName["UntrackedPhone"] = "UNTRACKED_PHONE";
})(InterviewIntentSourceEventName || (InterviewIntentSourceEventName = {}));
/** Types of source products */
export var InterviewIntentSourceProductName;
(function (InterviewIntentSourceProductName) {
    InterviewIntentSourceProductName["CmiInternalAts"] = "CMI_INTERNAL_ATS";
    InterviewIntentSourceProductName["ExternalAts"] = "EXTERNAL_ATS";
    InterviewIntentSourceProductName["Flex"] = "FLEX";
    InterviewIntentSourceProductName["Hire"] = "HIRE";
    InterviewIntentSourceProductName["IndeedApply"] = "INDEED_APPLY";
    InterviewIntentSourceProductName["IndeedHiringPlatform"] = "INDEED_HIRING_PLATFORM";
    InterviewIntentSourceProductName["InstantMatch"] = "INSTANT_MATCH";
    InterviewIntentSourceProductName["InternalAts"] = "INTERNAL_ATS";
    InterviewIntentSourceProductName["Interview"] = "INTERVIEW";
    InterviewIntentSourceProductName["InterviewNow"] = "INTERVIEW_NOW";
    InterviewIntentSourceProductName["ResumeSearch"] = "RESUME_SEARCH";
    InterviewIntentSourceProductName["VirtualInterviewPlatform"] = "VIRTUAL_INTERVIEW_PLATFORM";
})(InterviewIntentSourceProductName || (InterviewIntentSourceProductName = {}));
/** A enum that represents various representations of an interview's type */
export var InterviewIntentType;
(function (InterviewIntentType) {
    InterviewIntentType["HostedPhone"] = "HOSTED_PHONE";
    InterviewIntentType["HostedVideo"] = "HOSTED_VIDEO";
    InterviewIntentType["InPerson"] = "IN_PERSON";
    InterviewIntentType["ThirdPartyPhone"] = "THIRD_PARTY_PHONE";
    InterviewIntentType["ThirdPartyVideo"] = "THIRD_PARTY_VIDEO";
})(InterviewIntentType || (InterviewIntentType = {}));
/** The status of the appointment */
export var InterviewLobbyAppointmentStatus;
(function (InterviewLobbyAppointmentStatus) {
    InterviewLobbyAppointmentStatus["AllowedInRoom"] = "ALLOWED_IN_ROOM";
    InterviewLobbyAppointmentStatus["Cancelled"] = "CANCELLED";
    InterviewLobbyAppointmentStatus["CheckedIn"] = "CHECKED_IN";
    InterviewLobbyAppointmentStatus["Interviewed"] = "INTERVIEWED";
    InterviewLobbyAppointmentStatus["Interviewing"] = "INTERVIEWING";
    InterviewLobbyAppointmentStatus["NotInterviewed"] = "NOT_INTERVIEWED";
    InterviewLobbyAppointmentStatus["ReturnedToLobby"] = "RETURNED_TO_LOBBY";
    InterviewLobbyAppointmentStatus["Scheduled"] = "SCHEDULED";
    InterviewLobbyAppointmentStatus["Unknown"] = "UNKNOWN";
    InterviewLobbyAppointmentStatus["WaitingForCall"] = "WAITING_FOR_CALL";
    InterviewLobbyAppointmentStatus["WaitingInRoom"] = "WAITING_IN_ROOM";
})(InterviewLobbyAppointmentStatus || (InterviewLobbyAppointmentStatus = {}));
/** The status of a group of appointments */
export var InterviewLobbyAppointmentStatusGroup;
(function (InterviewLobbyAppointmentStatusGroup) {
    InterviewLobbyAppointmentStatusGroup["All"] = "ALL";
    InterviewLobbyAppointmentStatusGroup["FutureScheduled"] = "FUTURE_SCHEDULED";
    InterviewLobbyAppointmentStatusGroup["Interviewed"] = "INTERVIEWED";
    InterviewLobbyAppointmentStatusGroup["Interviewing"] = "INTERVIEWING";
    InterviewLobbyAppointmentStatusGroup["PastStartScheduled"] = "PAST_START_SCHEDULED";
    InterviewLobbyAppointmentStatusGroup["RunningLate"] = "RUNNING_LATE";
    InterviewLobbyAppointmentStatusGroup["Scheduled"] = "SCHEDULED";
    InterviewLobbyAppointmentStatusGroup["ScheduledNotInterviewed"] = "SCHEDULED_NOT_INTERVIEWED";
    InterviewLobbyAppointmentStatusGroup["WaitedNotInterviewed"] = "WAITED_NOT_INTERVIEWED";
    InterviewLobbyAppointmentStatusGroup["WaitingToInterview"] = "WAITING_TO_INTERVIEW";
})(InterviewLobbyAppointmentStatusGroup || (InterviewLobbyAppointmentStatusGroup = {}));
/** Log entry enum of possible event actions */
export var InterviewLobbyAuditLogAction;
(function (InterviewLobbyAuditLogAction) {
    InterviewLobbyAuditLogAction["Ended"] = "ENDED";
    InterviewLobbyAuditLogAction["Restarted"] = "RESTARTED";
})(InterviewLobbyAuditLogAction || (InterviewLobbyAuditLogAction = {}));
/** Current status of the Event */
export var InterviewLobbyEventStatus;
(function (InterviewLobbyEventStatus) {
    InterviewLobbyEventStatus["Archived"] = "ARCHIVED";
    InterviewLobbyEventStatus["Cancelled"] = "CANCELLED";
    InterviewLobbyEventStatus["Ended"] = "ENDED";
    InterviewLobbyEventStatus["Scheduled"] = "SCHEDULED";
    InterviewLobbyEventStatus["Started"] = "STARTED";
    InterviewLobbyEventStatus["Unknown"] = "UNKNOWN";
})(InterviewLobbyEventStatus || (InterviewLobbyEventStatus = {}));
/** Possible event types, used to determine jobseeker experience */
export var InterviewLobbyEventType;
(function (InterviewLobbyEventType) {
    InterviewLobbyEventType["Queued"] = "QUEUED";
    InterviewLobbyEventType["Single"] = "SINGLE";
})(InterviewLobbyEventType || (InterviewLobbyEventType = {}));
/** The status of an interviewer within interviewer lobby */
export var InterviewLobbyInterviewerStatus;
(function (InterviewLobbyInterviewerStatus) {
    InterviewLobbyInterviewerStatus["Active"] = "ACTIVE";
    InterviewLobbyInterviewerStatus["Inactive"] = "INACTIVE";
})(InterviewLobbyInterviewerStatus || (InterviewLobbyInterviewerStatus = {}));
/** The status of the interviewer lobby */
export var InterviewLobbyStatus;
(function (InterviewLobbyStatus) {
    InterviewLobbyStatus["Closed"] = "CLOSED";
    InterviewLobbyStatus["Open"] = "OPEN";
})(InterviewLobbyStatus || (InterviewLobbyStatus = {}));
/** The type of the user that performs certain actions */
export var InterviewLobbyUserType;
(function (InterviewLobbyUserType) {
    InterviewLobbyUserType["Employer"] = "EMPLOYER";
    InterviewLobbyUserType["JobSeeker"] = "JOB_SEEKER";
})(InterviewLobbyUserType || (InterviewLobbyUserType = {}));
/**   members to be used in building filters for interview measures  */
export var InterviewMeasureFilterMember;
(function (InterviewMeasureFilterMember) {
    InterviewMeasureFilterMember["AttendeesCount"] = "ATTENDEES_COUNT";
    InterviewMeasureFilterMember["AvgInterviewTime"] = "AVG_INTERVIEW_TIME";
    InterviewMeasureFilterMember["CompletedInterviewsCount"] = "COMPLETED_INTERVIEWS_COUNT";
    InterviewMeasureFilterMember["InterviewRate"] = "INTERVIEW_RATE";
    InterviewMeasureFilterMember["PositiveOutcomeRate"] = "POSITIVE_OUTCOME_RATE";
    InterviewMeasureFilterMember["ScheduledInterviewsCount"] = "SCHEDULED_INTERVIEWS_COUNT";
    InterviewMeasureFilterMember["SumMaybeDisposition"] = "SUM_MAYBE_DISPOSITION";
    InterviewMeasureFilterMember["SumNoDisposition"] = "SUM_NO_DISPOSITION";
    InterviewMeasureFilterMember["SumPositiveOutcome"] = "SUM_POSITIVE_OUTCOME";
    InterviewMeasureFilterMember["SumSpendLocal"] = "SUM_SPEND_LOCAL";
    InterviewMeasureFilterMember["SumYesDisposition"] = "SUM_YES_DISPOSITION";
})(InterviewMeasureFilterMember || (InterviewMeasureFilterMember = {}));
/** Context in which an interview activity occurred */
export var InterviewNowInterviewActivityContext;
(function (InterviewNowInterviewActivityContext) {
    InterviewNowInterviewActivityContext["CurrentInterview"] = "CURRENT_INTERVIEW";
    InterviewNowInterviewActivityContext["OtherInterview"] = "OTHER_INTERVIEW";
    InterviewNowInterviewActivityContext["Session"] = "SESSION";
})(InterviewNowInterviewActivityContext || (InterviewNowInterviewActivityContext = {}));
/** Types of activities that can occur during an Interview Now interview */
export var InterviewNowInterviewActivityType;
(function (InterviewNowInterviewActivityType) {
    InterviewNowInterviewActivityType["EmployerJoinedInterview"] = "EMPLOYER_JOINED_INTERVIEW";
    InterviewNowInterviewActivityType["ResumeDownloaded"] = "RESUME_DOWNLOADED";
    InterviewNowInterviewActivityType["ScreeningAnswersViewed"] = "SCREENING_ANSWERS_VIEWED";
    InterviewNowInterviewActivityType["SessionReviewed"] = "SESSION_REVIEWED";
})(InterviewNowInterviewActivityType || (InterviewNowInterviewActivityType = {}));
/** Entity types for Interview Now questions */
export var InterviewNowQuestionEntityType;
(function (InterviewNowQuestionEntityType) {
    InterviewNowQuestionEntityType["Indexedjob"] = "INDEXEDJOB";
    InterviewNowQuestionEntityType["Job"] = "JOB";
})(InterviewNowQuestionEntityType || (InterviewNowQuestionEntityType = {}));
/** Match type for question qualification criteria */
export var InterviewNowQuestionMatchType;
(function (InterviewNowQuestionMatchType) {
    /** Match if all of the provided values match */
    InterviewNowQuestionMatchType["All"] = "ALL";
    /** Match if any of the provided values match */
    InterviewNowQuestionMatchType["Any"] = "ANY";
})(InterviewNowQuestionMatchType || (InterviewNowQuestionMatchType = {}));
/** Types of actions that can be taken on an interview now session */
export var InterviewNowSessionActionType;
(function (InterviewNowSessionActionType) {
    InterviewNowSessionActionType["DownloadResume"] = "DOWNLOAD_RESUME";
    InterviewNowSessionActionType["EmployerMessage"] = "EMPLOYER_MESSAGE";
    InterviewNowSessionActionType["JoinInterview"] = "JOIN_INTERVIEW";
    InterviewNowSessionActionType["ViewScreeningAnswers"] = "VIEW_SCREENING_ANSWERS";
    InterviewNowSessionActionType["ViewSessionViewPage"] = "VIEW_SESSION_VIEW_PAGE";
})(InterviewNowSessionActionType || (InterviewNowSessionActionType = {}));
export var InterviewNowSessionEndedReason;
(function (InterviewNowSessionEndedReason) {
    InterviewNowSessionEndedReason["AutoEndDegraded"] = "AUTO_END_DEGRADED";
    InterviewNowSessionEndedReason["AutoEndExpired"] = "AUTO_END_EXPIRED";
    InterviewNowSessionEndedReason["AutoEndHeartbeat"] = "AUTO_END_HEARTBEAT";
    InterviewNowSessionEndedReason["AutoEndIdle"] = "AUTO_END_IDLE";
    InterviewNowSessionEndedReason["EmployerEnd"] = "EMPLOYER_END";
    InterviewNowSessionEndedReason["EmployerPause"] = "EMPLOYER_PAUSE";
    InterviewNowSessionEndedReason["Unknown"] = "UNKNOWN";
})(InterviewNowSessionEndedReason || (InterviewNowSessionEndedReason = {}));
export var InterviewNowSessionState;
(function (InterviewNowSessionState) {
    InterviewNowSessionState["Created"] = "CREATED";
    InterviewNowSessionState["Ended"] = "ENDED";
    InterviewNowSessionState["Started"] = "STARTED";
})(InterviewNowSessionState || (InterviewNowSessionState = {}));
/**  Interview queries order by fields  */
export var InterviewOrderByField;
(function (InterviewOrderByField) {
    InterviewOrderByField["ActivityDate"] = "ACTIVITY_DATE";
    InterviewOrderByField["AttendeesCount"] = "ATTENDEES_COUNT";
    InterviewOrderByField["AvgInterviewTime"] = "AVG_INTERVIEW_TIME";
    InterviewOrderByField["CompletedInterviewsCount"] = "COMPLETED_INTERVIEWS_COUNT";
    InterviewOrderByField["EvaluatedInterviewsCount"] = "EVALUATED_INTERVIEWS_COUNT";
    InterviewOrderByField["EventBudget"] = "EVENT_BUDGET";
    InterviewOrderByField["EventFirstDate"] = "EVENT_FIRST_DATE";
    InterviewOrderByField["EventLastDate"] = "EVENT_LAST_DATE";
    InterviewOrderByField["EventTitle"] = "EVENT_TITLE";
    InterviewOrderByField["InterviewerEmail"] = "INTERVIEWER_EMAIL";
    InterviewOrderByField["InterviewRate"] = "INTERVIEW_RATE";
    InterviewOrderByField["JobCity"] = "JOB_CITY";
    InterviewOrderByField["JobCountry"] = "JOB_COUNTRY";
    InterviewOrderByField["JobNormTitleCategory"] = "JOB_NORM_TITLE_CATEGORY";
    InterviewOrderByField["JobRegionName"] = "JOB_REGION_NAME";
    InterviewOrderByField["JobTitle"] = "JOB_TITLE";
    InterviewOrderByField["PositiveOutcomeRate"] = "POSITIVE_OUTCOME_RATE";
    InterviewOrderByField["RsvpStarts"] = "RSVP_STARTS";
    InterviewOrderByField["ScheduledInterviewsCount"] = "SCHEDULED_INTERVIEWS_COUNT";
    InterviewOrderByField["SumMaybeDisposition"] = "SUM_MAYBE_DISPOSITION";
    InterviewOrderByField["SumNoDisposition"] = "SUM_NO_DISPOSITION";
    InterviewOrderByField["SumPositiveOutcome"] = "SUM_POSITIVE_OUTCOME";
    InterviewOrderByField["SumSpendLocal"] = "SUM_SPEND_LOCAL";
    InterviewOrderByField["SumYesDisposition"] = "SUM_YES_DISPOSITION";
})(InterviewOrderByField || (InterviewOrderByField = {}));
export var InterviewProcessLength;
(function (InterviewProcessLength) {
    InterviewProcessLength["ADayOrTwo"] = "A_DAY_OR_TWO";
    InterviewProcessLength["AMonth"] = "A_MONTH";
    InterviewProcessLength["AWeek"] = "A_WEEK";
    InterviewProcessLength["InsufficientData"] = "INSUFFICIENT_DATA";
    InterviewProcessLength["MoreThanOneMonth"] = "MORE_THAN_ONE_MONTH";
    InterviewProcessLength["TwoWeeks"] = "TWO_WEEKS";
})(InterviewProcessLength || (InterviewProcessLength = {}));
export var InterviewRatingChoice;
(function (InterviewRatingChoice) {
    InterviewRatingChoice["Maybe"] = "MAYBE";
    InterviewRatingChoice["No"] = "NO";
    InterviewRatingChoice["Yes"] = "YES";
})(InterviewRatingChoice || (InterviewRatingChoice = {}));
export var InterviewRoomConnectionType;
(function (InterviewRoomConnectionType) {
    InterviewRoomConnectionType["Phone"] = "PHONE";
    InterviewRoomConnectionType["Video"] = "VIDEO";
})(InterviewRoomConnectionType || (InterviewRoomConnectionType = {}));
export var InterviewRoomDisposition;
(function (InterviewRoomDisposition) {
    InterviewRoomDisposition["Maybe"] = "MAYBE";
    InterviewRoomDisposition["No"] = "NO";
    InterviewRoomDisposition["Skip"] = "SKIP";
    InterviewRoomDisposition["Yes"] = "YES";
})(InterviewRoomDisposition || (InterviewRoomDisposition = {}));
export var InterviewRoomErrorType;
(function (InterviewRoomErrorType) {
    InterviewRoomErrorType["NotSupported"] = "NOT_SUPPORTED";
    InterviewRoomErrorType["ParticipantError"] = "PARTICIPANT_ERROR";
})(InterviewRoomErrorType || (InterviewRoomErrorType = {}));
export var InterviewRoomParticipantAuthType;
(function (InterviewRoomParticipantAuthType) {
    InterviewRoomParticipantAuthType["AccountId"] = "ACCOUNT_ID";
    InterviewRoomParticipantAuthType["Email"] = "EMAIL";
    InterviewRoomParticipantAuthType["None"] = "NONE";
    InterviewRoomParticipantAuthType["Passport"] = "PASSPORT";
})(InterviewRoomParticipantAuthType || (InterviewRoomParticipantAuthType = {}));
export var InterviewRoomParticipantStatusType;
(function (InterviewRoomParticipantStatusType) {
    InterviewRoomParticipantStatusType["ClosedRoom"] = "CLOSED_ROOM";
    InterviewRoomParticipantStatusType["Connected"] = "CONNECTED";
    InterviewRoomParticipantStatusType["Connecting"] = "CONNECTING";
    InterviewRoomParticipantStatusType["Created"] = "CREATED";
    InterviewRoomParticipantStatusType["Disconnected"] = "DISCONNECTED";
    InterviewRoomParticipantStatusType["Error"] = "ERROR";
    InterviewRoomParticipantStatusType["NotSupported"] = "NOT_SUPPORTED";
    InterviewRoomParticipantStatusType["Unauthorized"] = "UNAUTHORIZED";
})(InterviewRoomParticipantStatusType || (InterviewRoomParticipantStatusType = {}));
export var InterviewRoomParticipantType;
(function (InterviewRoomParticipantType) {
    InterviewRoomParticipantType["Attendee"] = "ATTENDEE";
    InterviewRoomParticipantType["Guest"] = "GUEST";
    InterviewRoomParticipantType["Host"] = "HOST";
})(InterviewRoomParticipantType || (InterviewRoomParticipantType = {}));
export var InterviewRoomQualityReasonType;
(function (InterviewRoomQualityReasonType) {
    InterviewRoomQualityReasonType["OthersMuted"] = "OTHERS_MUTED";
    InterviewRoomQualityReasonType["OthersNoVideo"] = "OTHERS_NO_VIDEO";
    InterviewRoomQualityReasonType["PoorAudioQuality"] = "POOR_AUDIO_QUALITY";
    InterviewRoomQualityReasonType["PoorVideoQuality"] = "POOR_VIDEO_QUALITY";
    InterviewRoomQualityReasonType["SelfMuted"] = "SELF_MUTED";
    InterviewRoomQualityReasonType["SelfNoVideo"] = "SELF_NO_VIDEO";
})(InterviewRoomQualityReasonType || (InterviewRoomQualityReasonType = {}));
export var InterviewRoomQualityType;
(function (InterviewRoomQualityType) {
    InterviewRoomQualityType["Bad"] = "BAD";
    InterviewRoomQualityType["Good"] = "GOOD";
})(InterviewRoomQualityType || (InterviewRoomQualityType = {}));
export var InterviewRoomRecordingStatus;
(function (InterviewRoomRecordingStatus) {
    InterviewRoomRecordingStatus["Complete"] = "COMPLETE";
    InterviewRoomRecordingStatus["Expired"] = "EXPIRED";
    InterviewRoomRecordingStatus["Failed"] = "FAILED";
    InterviewRoomRecordingStatus["Started"] = "STARTED";
})(InterviewRoomRecordingStatus || (InterviewRoomRecordingStatus = {}));
export var InterviewRoomVideoProviderType;
(function (InterviewRoomVideoProviderType) {
    InterviewRoomVideoProviderType["Daily"] = "DAILY";
    InterviewRoomVideoProviderType["Twilio"] = "TWILIO";
})(InterviewRoomVideoProviderType || (InterviewRoomVideoProviderType = {}));
export var InterviewSortOrder;
(function (InterviewSortOrder) {
    /** The interview sort order enum defaults to ascending if none is chosen by client */
    InterviewSortOrder["Ascending"] = "ASCENDING";
    InterviewSortOrder["Descending"] = "DESCENDING";
})(InterviewSortOrder || (InterviewSortOrder = {}));
export var InterviewStatus;
(function (InterviewStatus) {
    InterviewStatus["EmployerCancelled"] = "EMPLOYER_CANCELLED";
    InterviewStatus["JobseekerCancelled"] = "JOBSEEKER_CANCELLED";
    InterviewStatus["JobseekerDeclined"] = "JOBSEEKER_DECLINED";
    InterviewStatus["JobseekerRequestNewTimes"] = "JOBSEEKER_REQUEST_NEW_TIMES";
    InterviewStatus["JobseekerRescheduleRequested"] = "JOBSEEKER_RESCHEDULE_REQUESTED";
    InterviewStatus["Requested"] = "REQUESTED";
    InterviewStatus["Scheduled"] = "SCHEDULED";
})(InterviewStatus || (InterviewStatus = {}));
export var InterviewTemplateSortField;
(function (InterviewTemplateSortField) {
    /** The date when the template was last modified */
    InterviewTemplateSortField["LastModified"] = "LAST_MODIFIED";
})(InterviewTemplateSortField || (InterviewTemplateSortField = {}));
export var InterviewTemplateSortOrder;
(function (InterviewTemplateSortOrder) {
    /** The interview template sort order enum defaults to descending if none is chosen by client */
    InterviewTemplateSortOrder["Ascending"] = "ASCENDING";
    InterviewTemplateSortOrder["Descending"] = "DESCENDING";
})(InterviewTemplateSortOrder || (InterviewTemplateSortOrder = {}));
/** Defines the possible request type for an invitation to join the group */
export var InviteChildEmployerHierarchyNodeRequestType;
(function (InviteChildEmployerHierarchyNodeRequestType) {
    InviteChildEmployerHierarchyNodeRequestType["Employer"] = "EMPLOYER";
    /** @deprecated USER request type is used for employer-sign-flow only */
    InviteChildEmployerHierarchyNodeRequestType["User"] = "USER";
})(InviteChildEmployerHierarchyNodeRequestType || (InviteChildEmployerHierarchyNodeRequestType = {}));
/** Status of a job invitation */
export var InviteStatus;
(function (InviteStatus) {
    InviteStatus["Declined"] = "DECLINED";
    InviteStatus["Initiated"] = "INITIATED";
    InviteStatus["Interested"] = "INTERESTED";
})(InviteStatus || (InviteStatus = {}));
/** Type of job invitation */
export var InviteType;
(function (InviteType) {
    InviteType["Email"] = "EMAIL";
    InviteType["Interview"] = "INTERVIEW";
})(InviteType || (InviteType = {}));
/** Defines the possible Invitation status for a given invited group */
export var InvitedEmployerStatus;
(function (InvitedEmployerStatus) {
    InvitedEmployerStatus["Accepted"] = "ACCEPTED";
    InvitedEmployerStatus["Declined"] = "DECLINED";
    InvitedEmployerStatus["Error"] = "ERROR";
    InvitedEmployerStatus["Expired"] = "EXPIRED";
    InvitedEmployerStatus["Queued"] = "QUEUED";
    InvitedEmployerStatus["Sent"] = "SENT";
})(InvitedEmployerStatus || (InvitedEmployerStatus = {}));
export var InvoiceCreationFilter;
(function (InvoiceCreationFilter) {
    InvoiceCreationFilter["Over_120Days"] = "OVER_120_DAYS";
})(InvoiceCreationFilter || (InvoiceCreationFilter = {}));
/** Invoice line item type - indicates the source/type of the line item */
export var InvoiceLineItemType;
(function (InvoiceLineItemType) {
    /** Hire commission fee (cannot be deleted) */
    InvoiceLineItemType["HireCommission"] = "HIRE_COMMISSION";
    /** Initial deposit deduction (cannot be deleted) */
    InvoiceLineItemType["InitialDeposit"] = "INITIAL_DEPOSIT";
    /** Other/manually added line item (can be deleted) */
    InvoiceLineItemType["Other"] = "OTHER";
    /** Platform fee (cannot be deleted) */
    InvoiceLineItemType["PlatformFee"] = "PLATFORM_FEE";
})(InvoiceLineItemType || (InvoiceLineItemType = {}));
export var InvoicePaymentStatus;
(function (InvoicePaymentStatus) {
    InvoicePaymentStatus["Credited"] = "CREDITED";
    InvoicePaymentStatus["Paid"] = "PAID";
    InvoicePaymentStatus["PartiallyPaid"] = "PARTIALLY_PAID";
    InvoicePaymentStatus["Unknown"] = "UNKNOWN";
    InvoicePaymentStatus["Unpaid"] = "UNPAID";
})(InvoicePaymentStatus || (InvoicePaymentStatus = {}));
/** The payment status of the invoice */
export var InvoiceRecordPaymentStatus;
(function (InvoiceRecordPaymentStatus) {
    InvoiceRecordPaymentStatus["Credited"] = "CREDITED";
    InvoiceRecordPaymentStatus["Paid"] = "PAID";
    InvoiceRecordPaymentStatus["PartiallyPaid"] = "PARTIALLY_PAID";
    InvoiceRecordPaymentStatus["Unknown"] = "UNKNOWN";
    InvoiceRecordPaymentStatus["Unpaid"] = "UNPAID";
})(InvoiceRecordPaymentStatus || (InvoiceRecordPaymentStatus = {}));
/** Invoices status */
export var InvoiceRecordStatus;
(function (InvoiceRecordStatus) {
    InvoiceRecordStatus["Closed"] = "CLOSED";
    InvoiceRecordStatus["Open"] = "OPEN";
})(InvoiceRecordStatus || (InvoiceRecordStatus = {}));
/** State of the invoice */
export var InvoiceState;
(function (InvoiceState) {
    InvoiceState["AdcardDisabled"] = "ADCARD_DISABLED";
    InvoiceState["AdcardMissing"] = "ADCARD_MISSING";
    InvoiceState["CurrencyMismatch"] = "CURRENCY_MISMATCH";
    InvoiceState["InvoiceServiceInternalError"] = "INVOICE_SERVICE_INTERNAL_ERROR";
    InvoiceState["Pending"] = "PENDING";
    InvoiceState["Success"] = "SUCCESS";
    InvoiceState["UnknownError"] = "UNKNOWN_ERROR";
})(InvoiceState || (InvoiceState = {}));
/** Represents the invoice status */
export var InvoiceStatus;
(function (InvoiceStatus) {
    InvoiceStatus["All"] = "ALL";
    InvoiceStatus["Paid"] = "PAID";
    InvoiceStatus["Unpaid"] = "UNPAID";
})(InvoiceStatus || (InvoiceStatus = {}));
export var InvoiceStatusEnum;
(function (InvoiceStatusEnum) {
    InvoiceStatusEnum["Cancelled"] = "CANCELLED";
    InvoiceStatusEnum["Created"] = "CREATED";
    InvoiceStatusEnum["Overdue"] = "OVERDUE";
    InvoiceStatusEnum["Paid"] = "PAID";
    InvoiceStatusEnum["Partial"] = "PARTIAL";
    InvoiceStatusEnum["Sent"] = "SENT";
    InvoiceStatusEnum["Viewed"] = "VIEWED";
})(InvoiceStatusEnum || (InvoiceStatusEnum = {}));
/** Invoice's trigger */
export var InvoiceTrigger;
(function (InvoiceTrigger) {
    InvoiceTrigger["BillingCycle"] = "BILLING_CYCLE";
    InvoiceTrigger["BillingThreshold"] = "BILLING_THRESHOLD";
    InvoiceTrigger["EndOfMonth"] = "END_OF_MONTH";
})(InvoiceTrigger || (InvoiceTrigger = {}));
/** Question categories for Apply */
export var IqpApplyQuestionCategory;
(function (IqpApplyQuestionCategory) {
    IqpApplyQuestionCategory["Demographic"] = "DEMOGRAPHIC";
    IqpApplyQuestionCategory["Qualification"] = "QUALIFICATION";
    IqpApplyQuestionCategory["Screener"] = "SCREENER";
    IqpApplyQuestionCategory["Unknown"] = "UNKNOWN";
})(IqpApplyQuestionCategory || (IqpApplyQuestionCategory = {}));
/** Entity type for an IQP question set. Unrecognized upstream values map to UNKNOWN. */
export var IqpQuestionEntityType;
(function (IqpQuestionEntityType) {
    IqpQuestionEntityType["Aigennexuscredentialsq"] = "AIGENNEXUSCREDENTIALSQ";
    IqpQuestionEntityType["Aigennexussq"] = "AIGENNEXUSSQ";
    IqpQuestionEntityType["AiInterview"] = "AI_INTERVIEW";
    IqpQuestionEntityType["AtsApplication"] = "ATS_APPLICATION";
    IqpQuestionEntityType["Credential"] = "CREDENTIAL";
    /** @deprecated No longer supported */
    IqpQuestionEntityType["DraftJob"] = "DRAFT_JOB";
    IqpQuestionEntityType["EvaluateWorkflow"] = "EVALUATE_WORKFLOW";
    IqpQuestionEntityType["IasIntegration"] = "IAS_INTEGRATION";
    IqpQuestionEntityType["Indexedjob"] = "INDEXEDJOB";
    IqpQuestionEntityType["Job"] = "JOB";
    IqpQuestionEntityType["Manualnexussq"] = "MANUALNEXUSSQ";
    IqpQuestionEntityType["Odverification"] = "ODVERIFICATION";
    IqpQuestionEntityType["Passthrough"] = "PASSTHROUGH";
    IqpQuestionEntityType["Unknown"] = "UNKNOWN";
    IqpQuestionEntityType["Verification"] = "VERIFICATION";
})(IqpQuestionEntityType || (IqpQuestionEntityType = {}));
/** Question types */
export var IqpQuestionType;
(function (IqpQuestionType) {
    IqpQuestionType["Date"] = "DATE";
    IqpQuestionType["File"] = "FILE";
    IqpQuestionType["Hierarchical"] = "HIERARCHICAL";
    IqpQuestionType["Information"] = "INFORMATION";
    IqpQuestionType["Multifield"] = "MULTIFIELD";
    IqpQuestionType["Multiselect"] = "MULTISELECT";
    IqpQuestionType["Pagebreak"] = "PAGEBREAK";
    IqpQuestionType["QuestionBank"] = "QUESTION_BANK";
    IqpQuestionType["Select"] = "SELECT";
    IqpQuestionType["Text"] = "TEXT";
    IqpQuestionType["Textarea"] = "TEXTAREA";
    IqpQuestionType["Unknown"] = "UNKNOWN";
})(IqpQuestionType || (IqpQuestionType = {}));
/** User-defined question match types */
export var IqpUserDefinedQuestionMatchType;
(function (IqpUserDefinedQuestionMatchType) {
    IqpUserDefinedQuestionMatchType["All"] = "ALL";
    IqpUserDefinedQuestionMatchType["Any"] = "ANY";
    IqpUserDefinedQuestionMatchType["Unknown"] = "UNKNOWN";
})(IqpUserDefinedQuestionMatchType || (IqpUserDefinedQuestionMatchType = {}));
/** User-defined question requirement types */
export var IqpUserDefinedQuestionQualificationType;
(function (IqpUserDefinedQuestionQualificationType) {
    IqpUserDefinedQuestionQualificationType["Knockout"] = "KNOCKOUT";
    IqpUserDefinedQuestionQualificationType["Nonblocking"] = "NONBLOCKING";
    IqpUserDefinedQuestionQualificationType["Unknown"] = "UNKNOWN";
})(IqpUserDefinedQuestionQualificationType || (IqpUserDefinedQuestionQualificationType = {}));
export var IsOptedInToAutoPay;
(function (IsOptedInToAutoPay) {
    IsOptedInToAutoPay["NotEnabled"] = "NOT_ENABLED";
    IsOptedInToAutoPay["SystemEnabled"] = "SYSTEM_ENABLED";
    IsOptedInToAutoPay["UserEnabled"] = "USER_ENABLED";
})(IsOptedInToAutoPay || (IsOptedInToAutoPay = {}));
export var IsPredictedToExecuteReason;
(function (IsPredictedToExecuteReason) {
    IsPredictedToExecuteReason["ConversationExists"] = "CONVERSATION_EXISTS";
    IsPredictedToExecuteReason["Other"] = "OTHER";
    IsPredictedToExecuteReason["SourcedCandidate"] = "SOURCED_CANDIDATE";
})(IsPredictedToExecuteReason || (IsPredictedToExecuteReason = {}));
export var IsTrustedBrowserFlagEvent;
(function (IsTrustedBrowserFlagEvent) {
    IsTrustedBrowserFlagEvent["ApplyNowButton"] = "APPLY_NOW_BUTTON";
    IsTrustedBrowserFlagEvent["ContactPageContinueButton"] = "CONTACT_PAGE_CONTINUE_BUTTON";
    IsTrustedBrowserFlagEvent["ResumePageContinueButton"] = "RESUME_PAGE_CONTINUE_BUTTON";
})(IsTrustedBrowserFlagEvent || (IsTrustedBrowserFlagEvent = {}));
/**
 * Japan bounded pay type — narrowed subset of JapanPayType for pay forms
 * where the upper end must be known (excludes STARTING_AMOUNT). Used by
 * fixed overtime pay and probation overtime/base pay.
 */
export var JapanBoundedPayType;
(function (JapanBoundedPayType) {
    JapanBoundedPayType["ExactAmount"] = "EXACT_AMOUNT";
    JapanBoundedPayType["Range"] = "RANGE";
})(JapanBoundedPayType || (JapanBoundedPayType = {}));
/** Create from template flows for Japan. */
export var JapanCreateFromTemplateFlow;
(function (JapanCreateFromTemplateFlow) {
    JapanCreateFromTemplateFlow["JapanEditPublishedJob"] = "JAPAN_EDIT_PUBLISHED_JOB";
    JapanCreateFromTemplateFlow["JapanJobpostingReusepriorjob"] = "JAPAN_JOBPOSTING_REUSEPRIORJOB";
})(JapanCreateFromTemplateFlow || (JapanCreateFromTemplateFlow = {}));
/** What the user selected on the duplicate-job-title page. */
export var JapanDuplicateJobUserIntentType;
(function (JapanDuplicateJobUserIntentType) {
    JapanDuplicateJobUserIntentType["Continue"] = "CONTINUE";
    JapanDuplicateJobUserIntentType["Edit"] = "EDIT";
    JapanDuplicateJobUserIntentType["Sponsor"] = "SPONSOR";
})(JapanDuplicateJobUserIntentType || (JapanDuplicateJobUserIntentType = {}));
/** Japan effort unit. */
export var JapanEffortUnit;
(function (JapanEffortUnit) {
    JapanEffortUnit["Hour"] = "HOUR";
})(JapanEffortUnit || (JapanEffortUnit = {}));
/** Japan application email error codes. */
export var JapanJobPostingFormApplicationEmailValidationErrorCode;
(function (JapanJobPostingFormApplicationEmailValidationErrorCode) {
    JapanJobPostingFormApplicationEmailValidationErrorCode["None"] = "NONE";
})(JapanJobPostingFormApplicationEmailValidationErrorCode || (JapanJobPostingFormApplicationEmailValidationErrorCode = {}));
/** Japan application phone error codes. */
export var JapanJobPostingFormApplicationPhoneValidationErrorCode;
(function (JapanJobPostingFormApplicationPhoneValidationErrorCode) {
    JapanJobPostingFormApplicationPhoneValidationErrorCode["None"] = "NONE";
})(JapanJobPostingFormApplicationPhoneValidationErrorCode || (JapanJobPostingFormApplicationPhoneValidationErrorCode = {}));
/** Japan auto sourcer enabled error codes. */
export var JapanJobPostingFormAutoSourcerEnabledValidationErrorCode;
(function (JapanJobPostingFormAutoSourcerEnabledValidationErrorCode) {
    JapanJobPostingFormAutoSourcerEnabledValidationErrorCode["None"] = "NONE";
})(JapanJobPostingFormAutoSourcerEnabledValidationErrorCode || (JapanJobPostingFormAutoSourcerEnabledValidationErrorCode = {}));
/** Japan job description error codes. */
export var JapanJobPostingFormDescriptionValidationErrorCode;
(function (JapanJobPostingFormDescriptionValidationErrorCode) {
    JapanJobPostingFormDescriptionValidationErrorCode["BenefitsUnsupportedCharacters"] = "BENEFITS_UNSUPPORTED_CHARACTERS";
    JapanJobPostingFormDescriptionValidationErrorCode["CommuteInfoUnsupportedCharacters"] = "COMMUTE_INFO_UNSUPPORTED_CHARACTERS";
    JapanJobPostingFormDescriptionValidationErrorCode["EmployerMessageUnsupportedCharacters"] = "EMPLOYER_MESSAGE_UNSUPPORTED_CHARACTERS";
    JapanJobPostingFormDescriptionValidationErrorCode["HolidaysUnsupportedCharacters"] = "HOLIDAYS_UNSUPPORTED_CHARACTERS";
    JapanJobPostingFormDescriptionValidationErrorCode["JobDescriptionMissingValue"] = "JOB_DESCRIPTION_MISSING_VALUE";
    JapanJobPostingFormDescriptionValidationErrorCode["JobDescriptionUnsupportedCharacters"] = "JOB_DESCRIPTION_UNSUPPORTED_CHARACTERS";
    JapanJobPostingFormDescriptionValidationErrorCode["OtherUnsupportedCharacters"] = "OTHER_UNSUPPORTED_CHARACTERS";
    JapanJobPostingFormDescriptionValidationErrorCode["PayContentRequiredForCommission"] = "PAY_CONTENT_REQUIRED_FOR_COMMISSION";
    JapanJobPostingFormDescriptionValidationErrorCode["PayContentUnsupportedCharacters"] = "PAY_CONTENT_UNSUPPORTED_CHARACTERS";
    JapanJobPostingFormDescriptionValidationErrorCode["QualificationUnsupportedCharacters"] = "QUALIFICATION_UNSUPPORTED_CHARACTERS";
    JapanJobPostingFormDescriptionValidationErrorCode["ShiftUnsupportedCharacters"] = "SHIFT_UNSUPPORTED_CHARACTERS";
    JapanJobPostingFormDescriptionValidationErrorCode["WorkLocationUnsupportedCharacters"] = "WORK_LOCATION_UNSUPPORTED_CHARACTERS";
})(JapanJobPostingFormDescriptionValidationErrorCode || (JapanJobPostingFormDescriptionValidationErrorCode = {}));
/** Japan duplicate-job user-intent error codes. */
export var JapanJobPostingFormDuplicateJobUserIntentValidationErrorCode;
(function (JapanJobPostingFormDuplicateJobUserIntentValidationErrorCode) {
    JapanJobPostingFormDuplicateJobUserIntentValidationErrorCode["None"] = "NONE";
})(JapanJobPostingFormDuplicateJobUserIntentValidationErrorCode || (JapanJobPostingFormDuplicateJobUserIntentValidationErrorCode = {}));
export var JapanJobPostingFormEditFunnelStep;
(function (JapanJobPostingFormEditFunnelStep) {
    JapanJobPostingFormEditFunnelStep["JapanJobPublished"] = "JAPAN_JOB_PUBLISHED";
    JapanJobPostingFormEditFunnelStep["JapanReviewSheet"] = "JAPAN_REVIEW_SHEET";
    JapanJobPostingFormEditFunnelStep["Unknown"] = "UNKNOWN";
})(JapanJobPostingFormEditFunnelStep || (JapanJobPostingFormEditFunnelStep = {}));
/** Funnel type for the Japan job posting form. */
export var JapanJobPostingFormFunnelType;
(function (JapanJobPostingFormFunnelType) {
    JapanJobPostingFormFunnelType["JapanEdit"] = "JAPAN_EDIT";
    JapanJobPostingFormFunnelType["JapanFromScratch"] = "JAPAN_FROM_SCRATCH";
    JapanJobPostingFormFunnelType["JapanOneClick"] = "JAPAN_ONE_CLICK";
    JapanJobPostingFormFunnelType["JapanReuse"] = "JAPAN_REUSE";
})(JapanJobPostingFormFunnelType || (JapanJobPostingFormFunnelType = {}));
/** Bucketed counts for Japan number of hires. */
export var JapanJobPostingFormHiresNeededCount;
(function (JapanJobPostingFormHiresNeededCount) {
    JapanJobPostingFormHiresNeededCount["Eight"] = "EIGHT";
    JapanJobPostingFormHiresNeededCount["Five"] = "FIVE";
    JapanJobPostingFormHiresNeededCount["Four"] = "FOUR";
    JapanJobPostingFormHiresNeededCount["Nine"] = "NINE";
    JapanJobPostingFormHiresNeededCount["One"] = "ONE";
    JapanJobPostingFormHiresNeededCount["RecurringHire"] = "RECURRING_HIRE";
    JapanJobPostingFormHiresNeededCount["Seven"] = "SEVEN";
    JapanJobPostingFormHiresNeededCount["Six"] = "SIX";
    JapanJobPostingFormHiresNeededCount["Ten"] = "TEN";
    JapanJobPostingFormHiresNeededCount["TenPlus"] = "TEN_PLUS";
    JapanJobPostingFormHiresNeededCount["Three"] = "THREE";
    JapanJobPostingFormHiresNeededCount["Two"] = "TWO";
})(JapanJobPostingFormHiresNeededCount || (JapanJobPostingFormHiresNeededCount = {}));
/** Japan hires needed error codes. */
export var JapanJobPostingFormHiresNeededValidationErrorCode;
(function (JapanJobPostingFormHiresNeededValidationErrorCode) {
    JapanJobPostingFormHiresNeededValidationErrorCode["None"] = "NONE";
})(JapanJobPostingFormHiresNeededValidationErrorCode || (JapanJobPostingFormHiresNeededValidationErrorCode = {}));
/** Japan job company name error codes. */
export var JapanJobPostingFormJobCompanyNameValidationErrorCode;
(function (JapanJobPostingFormJobCompanyNameValidationErrorCode) {
    JapanJobPostingFormJobCompanyNameValidationErrorCode["JobCompanyNameUnsupportedCharacters"] = "JOB_COMPANY_NAME_UNSUPPORTED_CHARACTERS";
})(JapanJobPostingFormJobCompanyNameValidationErrorCode || (JapanJobPostingFormJobCompanyNameValidationErrorCode = {}));
/** Japan jobLocale error codes */
export var JapanJobPostingFormJobLocaleValidationErrorCode;
(function (JapanJobPostingFormJobLocaleValidationErrorCode) {
    JapanJobPostingFormJobLocaleValidationErrorCode["JobLocaleMissingCountry"] = "JOB_LOCALE_MISSING_COUNTRY";
    JapanJobPostingFormJobLocaleValidationErrorCode["JobLocaleMissingLanguage"] = "JOB_LOCALE_MISSING_LANGUAGE";
})(JapanJobPostingFormJobLocaleValidationErrorCode || (JapanJobPostingFormJobLocaleValidationErrorCode = {}));
/** Japan job photos error codes. Validation is optional for this field; NONE is a placeholder so the enum is non-empty. */
export var JapanJobPostingFormJobPhotosValidationErrorCode;
(function (JapanJobPostingFormJobPhotosValidationErrorCode) {
    JapanJobPostingFormJobPhotosValidationErrorCode["None"] = "NONE";
})(JapanJobPostingFormJobPhotosValidationErrorCode || (JapanJobPostingFormJobPhotosValidationErrorCode = {}));
/** Japan job tags error codes. */
export var JapanJobPostingFormJobTagsValidationErrorCode;
(function (JapanJobPostingFormJobTagsValidationErrorCode) {
    JapanJobPostingFormJobTagsValidationErrorCode["None"] = "NONE";
})(JapanJobPostingFormJobTagsValidationErrorCode || (JapanJobPostingFormJobTagsValidationErrorCode = {}));
/** Japan job type error codes. */
export var JapanJobPostingFormJobTypeValidationErrorCode;
(function (JapanJobPostingFormJobTypeValidationErrorCode) {
    JapanJobPostingFormJobTypeValidationErrorCode["JobTypeMissingSelection"] = "JOB_TYPE_MISSING_SELECTION";
})(JapanJobPostingFormJobTypeValidationErrorCode || (JapanJobPostingFormJobTypeValidationErrorCode = {}));
/** Japan job location error codes. */
export var JapanJobPostingFormLocationValidationErrorCode;
(function (JapanJobPostingFormLocationValidationErrorCode) {
    JapanJobPostingFormLocationValidationErrorCode["PostalCodeInvalid"] = "POSTAL_CODE_INVALID";
})(JapanJobPostingFormLocationValidationErrorCode || (JapanJobPostingFormLocationValidationErrorCode = {}));
export var JapanJobPostingFormMainFunnelStep;
(function (JapanJobPostingFormMainFunnelStep) {
    JapanJobPostingFormMainFunnelStep["JapanApplicationSettingsSheet"] = "JAPAN_APPLICATION_SETTINGS_SHEET";
    JapanJobPostingFormMainFunnelStep["JapanBasicSheet"] = "JAPAN_BASIC_SHEET";
    JapanJobPostingFormMainFunnelStep["JapanDescriptionSheet"] = "JAPAN_DESCRIPTION_SHEET";
    JapanJobPostingFormMainFunnelStep["JapanDetailsSheet"] = "JAPAN_DETAILS_SHEET";
    JapanJobPostingFormMainFunnelStep["JapanDuplicateTitleWarningSheet"] = "JAPAN_DUPLICATE_TITLE_WARNING_SHEET";
    JapanJobPostingFormMainFunnelStep["JapanJobPublished"] = "JAPAN_JOB_PUBLISHED";
    JapanJobPostingFormMainFunnelStep["JapanReviewSheet"] = "JAPAN_REVIEW_SHEET";
    JapanJobPostingFormMainFunnelStep["Unknown"] = "UNKNOWN";
})(JapanJobPostingFormMainFunnelStep || (JapanJobPostingFormMainFunnelStep = {}));
/** Japan occupation category error codes. */
export var JapanJobPostingFormOccupationCategoryValidationErrorCode;
(function (JapanJobPostingFormOccupationCategoryValidationErrorCode) {
    JapanJobPostingFormOccupationCategoryValidationErrorCode["OccupationCategoryMissingSelection"] = "OCCUPATION_CATEGORY_MISSING_SELECTION";
})(JapanJobPostingFormOccupationCategoryValidationErrorCode || (JapanJobPostingFormOccupationCategoryValidationErrorCode = {}));
export var JapanJobPostingFormOneClickFunnelStep;
(function (JapanJobPostingFormOneClickFunnelStep) {
    JapanJobPostingFormOneClickFunnelStep["JapanBasicSheet"] = "JAPAN_BASIC_SHEET";
    JapanJobPostingFormOneClickFunnelStep["JapanDescriptionSheet"] = "JAPAN_DESCRIPTION_SHEET";
    JapanJobPostingFormOneClickFunnelStep["JapanDuplicateTitleWarningSheet"] = "JAPAN_DUPLICATE_TITLE_WARNING_SHEET";
    JapanJobPostingFormOneClickFunnelStep["JapanJobPublished"] = "JAPAN_JOB_PUBLISHED";
    JapanJobPostingFormOneClickFunnelStep["JapanRecommendationsLoadingSheet"] = "JAPAN_RECOMMENDATIONS_LOADING_SHEET";
    JapanJobPostingFormOneClickFunnelStep["JapanReviewSheet"] = "JAPAN_REVIEW_SHEET";
    JapanJobPostingFormOneClickFunnelStep["Unknown"] = "UNKNOWN";
})(JapanJobPostingFormOneClickFunnelStep || (JapanJobPostingFormOneClickFunnelStep = {}));
/** Japan one-click opt-in error codes. */
export var JapanJobPostingFormOneClickOptInValidationErrorCode;
(function (JapanJobPostingFormOneClickOptInValidationErrorCode) {
    JapanJobPostingFormOneClickOptInValidationErrorCode["None"] = "NONE";
})(JapanJobPostingFormOneClickOptInValidationErrorCode || (JapanJobPostingFormOneClickOptInValidationErrorCode = {}));
/** Japan overtime error codes. */
export var JapanJobPostingFormOvertimeValidationErrorCode;
(function (JapanJobPostingFormOvertimeValidationErrorCode) {
    /**
     * Fired when effort.hour or effort.minute is populated but
     * extraOvertimePayConsent is not true. The employer must consent that
     * overtime worked beyond the covered hours will be paid in addition.
     */
    JapanJobPostingFormOvertimeValidationErrorCode["OvertimeConsentRequiredWithEffort"] = "OVERTIME_CONSENT_REQUIRED_WITH_EFFORT";
    /** Fired when hasOvertime is true and effort.hour is missing. */
    JapanJobPostingFormOvertimeValidationErrorCode["OvertimeEffortHourRequired"] = "OVERTIME_EFFORT_HOUR_REQUIRED";
    /**
     * Fired when compensation.type is RANGE and minimum is greater than or
     * equal to maximum.
     */
    JapanJobPostingFormOvertimeValidationErrorCode["OvertimeInvalidRange"] = "OVERTIME_INVALID_RANGE";
    /** Fired when compensation.type is RANGE and compensation.maximum is missing. */
    JapanJobPostingFormOvertimeValidationErrorCode["OvertimeMaximumRequired"] = "OVERTIME_MAXIMUM_REQUIRED";
    /**
     * Fired when hasOvertime is true and compensation.minimum is missing.
     * Required for both EXACT_AMOUNT and RANGE compensation types.
     */
    JapanJobPostingFormOvertimeValidationErrorCode["OvertimeMinimumRequired"] = "OVERTIME_MINIMUM_REQUIRED";
    /**
     * Fired when hasOvertime is true and the synced pay.period is HOUR.
     * Fixed overtime pay is incompatible with an hourly base salary.
     */
    JapanJobPostingFormOvertimeValidationErrorCode["OvertimeNotAllowedWithHourlyPay"] = "OVERTIME_NOT_ALLOWED_WITH_HOURLY_PAY";
    /** Fired when hasOvertime is true and compensation.type is missing. */
    JapanJobPostingFormOvertimeValidationErrorCode["OvertimePayTypeRequired"] = "OVERTIME_PAY_TYPE_REQUIRED";
})(JapanJobPostingFormOvertimeValidationErrorCode || (JapanJobPostingFormOvertimeValidationErrorCode = {}));
/** Japan pay error codes. */
export var JapanJobPostingFormPayValidationErrorCode;
(function (JapanJobPostingFormPayValidationErrorCode) {
    JapanJobPostingFormPayValidationErrorCode["PayIncompleteRange"] = "PAY_INCOMPLETE_RANGE";
    JapanJobPostingFormPayValidationErrorCode["PayInvalidRange"] = "PAY_INVALID_RANGE";
    JapanJobPostingFormPayValidationErrorCode["PayMaximumZeroValueInRange"] = "PAY_MAXIMUM_ZERO_VALUE_IN_RANGE";
    JapanJobPostingFormPayValidationErrorCode["PayMinimumZeroValueInRange"] = "PAY_MINIMUM_ZERO_VALUE_IN_RANGE";
})(JapanJobPostingFormPayValidationErrorCode || (JapanJobPostingFormPayValidationErrorCode = {}));
/** Japan placement business error codes. */
export var JapanJobPostingFormPlacementBusinessValidationErrorCode;
(function (JapanJobPostingFormPlacementBusinessValidationErrorCode) {
    JapanJobPostingFormPlacementBusinessValidationErrorCode["None"] = "NONE";
})(JapanJobPostingFormPlacementBusinessValidationErrorCode || (JapanJobPostingFormPlacementBusinessValidationErrorCode = {}));
/** Japan probation error codes. */
export var JapanJobPostingFormProbationValidationErrorCode;
(function (JapanJobPostingFormProbationValidationErrorCode) {
    /**
     * Fired when basePay.period requires working hours (anything but HOUR or MONTH) but
     * effort.baseEffort.hour is missing. HOUR pay disables effort; MONTH pay makes it optional.
     */
    JapanJobPostingFormProbationValidationErrorCode["ProbationBaseEffortHourRequired"] = "PROBATION_BASE_EFFORT_HOUR_REQUIRED";
    /** Fired when basePay.type is RANGE but only one of minimum or maximum is set. */
    JapanJobPostingFormProbationValidationErrorCode["ProbationBasePayIncompleteRange"] = "PROBATION_BASE_PAY_INCOMPLETE_RANGE";
    /** Fired when basePay.type is RANGE and minimum is greater than or equal to maximum. */
    JapanJobPostingFormProbationValidationErrorCode["ProbationBasePayInvalidRange"] = "PROBATION_BASE_PAY_INVALID_RANGE";
    /** Fired when basePay.period is set but basePay.type is missing. */
    JapanJobPostingFormProbationValidationErrorCode["ProbationBasePayTypeRequired"] = "PROBATION_BASE_PAY_TYPE_REQUIRED";
    /** Fired when hasProbationPeriod is true but duration.value or duration.type is missing. */
    JapanJobPostingFormProbationValidationErrorCode["ProbationDurationRequired"] = "PROBATION_DURATION_REQUIRED";
    /**
     * Fired when duration.value is outside the valid range for its type: 1–30 for DAY,
     * 1–12 for WEEK or MONTH.
     */
    JapanJobPostingFormProbationValidationErrorCode["ProbationDurationValueOutOfRange"] = "PROBATION_DURATION_VALUE_OUT_OF_RANGE";
    /**
     * Fired when pay.overtimePay.hasOvertime is true but effort.overtimeEffort.extraOvertimePayConsent
     * is not true. The employer must consent to paying additional overtime beyond the covered hours.
     */
    JapanJobPostingFormProbationValidationErrorCode["ProbationExtraOvertimePayConsentRequired"] = "PROBATION_EXTRA_OVERTIME_PAY_CONSENT_REQUIRED";
    /**
     * Fired when basePay.period is anything other than HOUR but pay.overtimePay.hasOvertime
     * is null. The employer must explicitly opt into or out of fixed overtime pay.
     */
    JapanJobPostingFormProbationValidationErrorCode["ProbationHasOvertimeRequired"] = "PROBATION_HAS_OVERTIME_REQUIRED";
    /**
     * Fired when hasProbationPeriod is null. The employer must explicitly declare whether or
     * not the job has a probation period.
     */
    JapanJobPostingFormProbationValidationErrorCode["ProbationHasProbationPeriodRequired"] = "PROBATION_HAS_PROBATION_PERIOD_REQUIRED";
    /** Fired when pay.overtimePay.hasOvertime is true but effort.overtimeEffort.hour is missing. */
    JapanJobPostingFormProbationValidationErrorCode["ProbationOvertimeEffortHourRequired"] = "PROBATION_OVERTIME_EFFORT_HOUR_REQUIRED";
    /** Fired when pay.overtimePay.type is RANGE but only one of minimum or maximum is set. */
    JapanJobPostingFormProbationValidationErrorCode["ProbationOvertimePayIncompleteRange"] = "PROBATION_OVERTIME_PAY_INCOMPLETE_RANGE";
    /** Fired when pay.overtimePay.type is RANGE and minimum is greater than or equal to maximum. */
    JapanJobPostingFormProbationValidationErrorCode["ProbationOvertimePayInvalidRange"] = "PROBATION_OVERTIME_PAY_INVALID_RANGE";
    /** Fired when pay.overtimePay.hasOvertime is true but pay.overtimePay.minimum is missing. */
    JapanJobPostingFormProbationValidationErrorCode["ProbationOvertimePayMinimumRequired"] = "PROBATION_OVERTIME_PAY_MINIMUM_REQUIRED";
    /** Fired when pay.overtimePay is set with a period but overtimePay.type is missing. */
    JapanJobPostingFormProbationValidationErrorCode["ProbationOvertimePayTypeRequired"] = "PROBATION_OVERTIME_PAY_TYPE_REQUIRED";
})(JapanJobPostingFormProbationValidationErrorCode || (JapanJobPostingFormProbationValidationErrorCode = {}));
/** Japan resume error codes. */
export var JapanJobPostingFormResumeValidationErrorCode;
(function (JapanJobPostingFormResumeValidationErrorCode) {
    JapanJobPostingFormResumeValidationErrorCode["ResumeFieldsNotAllowedWhenRequired"] = "RESUME_FIELDS_NOT_ALLOWED_WHEN_REQUIRED";
})(JapanJobPostingFormResumeValidationErrorCode || (JapanJobPostingFormResumeValidationErrorCode = {}));
/** Japan social insurance error codes. */
export var JapanJobPostingFormSocialInsuranceValidationErrorCode;
(function (JapanJobPostingFormSocialInsuranceValidationErrorCode) {
    JapanJobPostingFormSocialInsuranceValidationErrorCode["SocialInsuranceOptOutNotAllowed"] = "SOCIAL_INSURANCE_OPT_OUT_NOT_ALLOWED";
    JapanJobPostingFormSocialInsuranceValidationErrorCode["SocialInsuranceOptOutRequired"] = "SOCIAL_INSURANCE_OPT_OUT_REQUIRED";
    JapanJobPostingFormSocialInsuranceValidationErrorCode["SocialInsuranceReasonNotAllowed"] = "SOCIAL_INSURANCE_REASON_NOT_ALLOWED";
    JapanJobPostingFormSocialInsuranceValidationErrorCode["SocialInsuranceReasonRequired"] = "SOCIAL_INSURANCE_REASON_REQUIRED";
})(JapanJobPostingFormSocialInsuranceValidationErrorCode || (JapanJobPostingFormSocialInsuranceValidationErrorCode = {}));
/** Japan job subtitle error codes. */
export var JapanJobPostingFormSubtitleValidationErrorCode;
(function (JapanJobPostingFormSubtitleValidationErrorCode) {
    JapanJobPostingFormSubtitleValidationErrorCode["JobSubtitleTooLong"] = "JOB_SUBTITLE_TOO_LONG";
    JapanJobPostingFormSubtitleValidationErrorCode["JobSubtitleUnsupportedCharacters"] = "JOB_SUBTITLE_UNSUPPORTED_CHARACTERS";
})(JapanJobPostingFormSubtitleValidationErrorCode || (JapanJobPostingFormSubtitleValidationErrorCode = {}));
/** Japan job title error codes. */
export var JapanJobPostingFormTitleValidationErrorCode;
(function (JapanJobPostingFormTitleValidationErrorCode) {
    JapanJobPostingFormTitleValidationErrorCode["JobTitleMissingValue"] = "JOB_TITLE_MISSING_VALUE";
    JapanJobPostingFormTitleValidationErrorCode["JobTitleTooLong"] = "JOB_TITLE_TOO_LONG";
    JapanJobPostingFormTitleValidationErrorCode["JobTitleUnsupportedCharacters"] = "JOB_TITLE_UNSUPPORTED_CHARACTERS";
})(JapanJobPostingFormTitleValidationErrorCode || (JapanJobPostingFormTitleValidationErrorCode = {}));
/** Japan working hours error codes. */
export var JapanJobPostingFormWorkingHoursValidationErrorCode;
(function (JapanJobPostingFormWorkingHoursValidationErrorCode) {
    JapanJobPostingFormWorkingHoursValidationErrorCode["None"] = "NONE";
})(JapanJobPostingFormWorkingHoursValidationErrorCode || (JapanJobPostingFormWorkingHoursValidationErrorCode = {}));
/** Japan working style error codes. */
export var JapanJobPostingFormWorkingStyleValidationErrorCode;
(function (JapanJobPostingFormWorkingStyleValidationErrorCode) {
    JapanJobPostingFormWorkingStyleValidationErrorCode["None"] = "NONE";
})(JapanJobPostingFormWorkingStyleValidationErrorCode || (JapanJobPostingFormWorkingStyleValidationErrorCode = {}));
/** Japan job tag keys. Stored on draftjob as a comma-delimited string under attributes.cmiJobTags. */
export var JapanJobTagKey;
(function (JapanJobTagKey) {
    JapanJobTagKey["CommAl"] = "COMM_AL";
    /** 5 minutes from station */
    JapanJobTagKey["FiveMinFromSt"] = "FIVE_MIN_FROM_ST";
    JapanJobTagKey["FlexShift"] = "FLEX_SHIFT";
    JapanJobTagKey["FullRemote"] = "FULL_REMOTE";
    JapanJobTagKey["FullTime"] = "FULL_TIME";
    JapanJobTagKey["NoOvertime"] = "NO_OVERTIME";
    /** 1 day a week */
    JapanJobTagKey["OneDaWeek"] = "ONE_DA_WEEK";
    JapanJobTagKey["OpRaise"] = "OP_RAISE";
    JapanJobTagKey["RemoteOk"] = "REMOTE_OK";
    JapanJobTagKey["RightAway"] = "RIGHT_AWAY";
    /** 2 to 3 days a week */
    JapanJobTagKey["TwoToThreeDaWeek"] = "TWO_TO_THREE_DA_WEEK";
    /** @deprecated Legacy tag — retained for read compatibility with existing draftjobs. */
    JapanJobTagKey["Urgent"] = "URGENT";
})(JapanJobTagKey || (JapanJobTagKey = {}));
/** Japan job type enum. */
export var JapanJobType;
(function (JapanJobType) {
    JapanJobType["Commission"] = "COMMISSION";
    JapanJobType["Contract"] = "CONTRACT";
    JapanJobType["Custom_1"] = "CUSTOM_1";
    JapanJobType["FullTime"] = "FULL_TIME";
    JapanJobType["Internship"] = "INTERNSHIP";
    JapanJobType["NewGrad"] = "NEW_GRAD";
    JapanJobType["PartTime"] = "PART_TIME";
    JapanJobType["Subcontract"] = "SUBCONTRACT";
    JapanJobType["Temporary"] = "TEMPORARY";
    JapanJobType["Volunteer"] = "VOLUNTEER";
})(JapanJobType || (JapanJobType = {}));
/**
 * Japan pay interval — the recurring intervals at which fixed overtime,
 * probation effort/pay, and working hours can attach. Synced with pay.period
 * — a narrowed subset of JapanPayPeriod (excludes HOUR, YEAR, COMMISSION).
 */
export var JapanPayInterval;
(function (JapanPayInterval) {
    JapanPayInterval["Day"] = "DAY";
    JapanPayInterval["Month"] = "MONTH";
    JapanPayInterval["Week"] = "WEEK";
})(JapanPayInterval || (JapanPayInterval = {}));
/** Japan salary period. */
export var JapanPayPeriod;
(function (JapanPayPeriod) {
    JapanPayPeriod["Commission"] = "COMMISSION";
    JapanPayPeriod["Day"] = "DAY";
    JapanPayPeriod["Hour"] = "HOUR";
    JapanPayPeriod["Month"] = "MONTH";
    JapanPayPeriod["Week"] = "WEEK";
    JapanPayPeriod["Year"] = "YEAR";
})(JapanPayPeriod || (JapanPayPeriod = {}));
/** Japan pay input type. */
export var JapanPayType;
(function (JapanPayType) {
    JapanPayType["ExactAmount"] = "EXACT_AMOUNT";
    JapanPayType["Range"] = "RANGE";
    JapanPayType["StartingAmount"] = "STARTING_AMOUNT";
})(JapanPayType || (JapanPayType = {}));
/** Japan probation duration unit. */
export var JapanProbationDurationType;
(function (JapanProbationDurationType) {
    JapanProbationDurationType["Day"] = "DAY";
    JapanProbationDurationType["Month"] = "MONTH";
    JapanProbationDurationType["Week"] = "WEEK";
})(JapanProbationDurationType || (JapanProbationDurationType = {}));
/**
 * Fields a Japan seeker is asked for when a resume is not required.
 * Stored on draftjob as a comma-delimited string under attributes.resumeFieldsRequired (e.g. "skills,education").
 */
export var JapanResumeFieldsRequiredType;
(function (JapanResumeFieldsRequiredType) {
    JapanResumeFieldsRequiredType["Certifications"] = "CERTIFICATIONS";
    JapanResumeFieldsRequiredType["DateOfBirth"] = "DATE_OF_BIRTH";
    JapanResumeFieldsRequiredType["Education"] = "EDUCATION";
    JapanResumeFieldsRequiredType["Gender"] = "GENDER";
    JapanResumeFieldsRequiredType["Location"] = "LOCATION";
    JapanResumeFieldsRequiredType["NamePronunciation"] = "NAME_PRONUNCIATION";
    JapanResumeFieldsRequiredType["Phone"] = "PHONE";
    JapanResumeFieldsRequiredType["Positions"] = "POSITIONS";
    JapanResumeFieldsRequiredType["Skills"] = "SKILLS";
})(JapanResumeFieldsRequiredType || (JapanResumeFieldsRequiredType = {}));
export var JobApplicationDeliveryStatus;
(function (JobApplicationDeliveryStatus) {
    JobApplicationDeliveryStatus["Delivered"] = "DELIVERED";
    JobApplicationDeliveryStatus["NotDelivered"] = "NOT_DELIVERED";
    JobApplicationDeliveryStatus["PendingDelivery"] = "PENDING_DELIVERY";
})(JobApplicationDeliveryStatus || (JobApplicationDeliveryStatus = {}));
export var JobApplicationEmployerIntegrationDeliveryType;
(function (JobApplicationEmployerIntegrationDeliveryType) {
    /** Deliver application via email */
    JobApplicationEmployerIntegrationDeliveryType["Email"] = "EMAIL";
    /** Deliver application via HTTP POST */
    JobApplicationEmployerIntegrationDeliveryType["Post"] = "POST";
})(JobApplicationEmployerIntegrationDeliveryType || (JobApplicationEmployerIntegrationDeliveryType = {}));
/** Match strategy for qualification criteria. */
export var JobApplicationQualificationMatchType;
(function (JobApplicationQualificationMatchType) {
    /** Applicant's answer must match all of the provided values. */
    JobApplicationQualificationMatchType["All"] = "ALL";
    /** Applicant's answer must match any of the provided values. */
    JobApplicationQualificationMatchType["Any"] = "ANY";
})(JobApplicationQualificationMatchType || (JobApplicationQualificationMatchType = {}));
/** Qualification type indicating the effect on job application flow. */
export var JobApplicationQualificationType;
(function (JobApplicationQualificationType) {
    /** Applicant is blocked from proceeding if they don't meet criteria. */
    JobApplicationQualificationType["Knockout"] = "KNOCKOUT";
    /** Applicant can proceed regardless of meeting criteria. */
    JobApplicationQualificationType["NonBlocking"] = "NON_BLOCKING";
})(JobApplicationQualificationType || (JobApplicationQualificationType = {}));
/** Outcome reported via the reportActivity mutation. */
export var JobApplicationReportActivityOutcome;
(function (JobApplicationReportActivityOutcome) {
    /** The activity was abandoned. */
    JobApplicationReportActivityOutcome["Abandon"] = "ABANDON";
    /** The activity has concluded. */
    JobApplicationReportActivityOutcome["Complete"] = "COMPLETE";
})(JobApplicationReportActivityOutcome || (JobApplicationReportActivityOutcome = {}));
/**
 * Attribute source to be used in input.
 *
 * When ANY is used, any attribute source can be matched.
 */
export var JobAttributeSource;
(function (JobAttributeSource) {
    JobAttributeSource["Any"] = "ANY";
    JobAttributeSource["Employer"] = "EMPLOYER";
    JobAttributeSource["Extracted"] = "EXTRACTED";
})(JobAttributeSource || (JobAttributeSource = {}));
/** Normalized Trust & Safety moderation status. */
export var JobAuditStatusEnum;
(function (JobAuditStatusEnum) {
    /** Job has failed moderation or is blocked. */
    JobAuditStatusEnum["Failed"] = "FAILED";
    /** Job is still being reviewed; no final status yet. */
    JobAuditStatusEnum["InReview"] = "IN_REVIEW";
    /** Job has passed moderation and is visible. */
    JobAuditStatusEnum["Passed"] = "PASSED";
    /** Status could not be determined (upstream error or missing data). */
    JobAuditStatusEnum["Unknown"] = "UNKNOWN";
})(JobAuditStatusEnum || (JobAuditStatusEnum = {}));
export var JobAuditSummaryStatusEnum;
(function (JobAuditSummaryStatusEnum) {
    JobAuditSummaryStatusEnum["Failed"] = "FAILED";
    JobAuditSummaryStatusEnum["Inactive"] = "INACTIVE";
    JobAuditSummaryStatusEnum["InReview"] = "IN_REVIEW";
    JobAuditSummaryStatusEnum["Passed"] = "PASSED";
    JobAuditSummaryStatusEnum["Unknown"] = "UNKNOWN";
})(JobAuditSummaryStatusEnum || (JobAuditSummaryStatusEnum = {}));
/**
 * Which phase of the per-job automation cleanup pipeline produced a
 * `JobAutomationCleanupFailureDetail`. The per-job automation cleanup is the
 * sibling of the rule-side cleanup: it strips 3P license verification off the
 * *materialized* automation that an enrolled smart-screening job carries, which
 * the rule-side `updateRule` does not touch.
 */
export var JobAutomationCleanupFailureStage;
(function (JobAutomationCleanupFailureStage) {
    /**
     * `patchAutomation` succeeded but persisting the `LICENSE_REMOVED` audit event
     * threw afterwards. The automation IS patched; the audit row is missing.
     * Re-running is safe (a job with no remaining 3P entries is skipped) but will
     * not back-fill the missing audit.
     */
    JobAutomationCleanupFailureStage["Audit"] = "AUDIT";
    /**
     * The `findNexusAutomations` query failed for this advertiser's job set, so
     * no automations were processed and NWCS state was not modified. Safe to
     * re-run.
     */
    JobAutomationCleanupFailureStage["Fetch"] = "FETCH";
    /**
     * A per-job failure: the `patchAutomation` mutation itself failed. NWCS state
     * for this job's automation was not modified. Safe to re-run for just this
     * job.
     */
    JobAutomationCleanupFailureStage["Patch"] = "PATCH";
})(JobAutomationCleanupFailureStage || (JobAutomationCleanupFailureStage = {}));
/**
 * Quality assessment for benchmark matching (decoupled from Insights API match levels).
 * Uses Job prefix to prevent naming conflicts in OneGraph federation.
 */
export var JobBenchmarkMatchQuality;
(function (JobBenchmarkMatchQuality) {
    /** High confidence match (mapped from EXACT_MATCH) */
    JobBenchmarkMatchQuality["HighConfidence"] = "HIGH_CONFIDENCE";
    /** Insufficient match quality (unknown values or missing data) */
    JobBenchmarkMatchQuality["Insufficient"] = "INSUFFICIENT";
    /** Low confidence match (mapped from STATE_WIDE, COUNTRY_WIDE) */
    JobBenchmarkMatchQuality["LowConfidence"] = "LOW_CONFIDENCE";
    /** Medium confidence match (mapped from EXPANDED_LOCATIONS, EXPANDED_LOCATIONS_AND_TITLES, EXPANDED_TITLES) */
    JobBenchmarkMatchQuality["MediumConfidence"] = "MEDIUM_CONFIDENCE";
})(JobBenchmarkMatchQuality || (JobBenchmarkMatchQuality = {}));
export var JobBidStatusEnum;
(function (JobBidStatusEnum) {
    JobBidStatusEnum["Accepted"] = "ACCEPTED";
    JobBidStatusEnum["Declined"] = "DECLINED";
    JobBidStatusEnum["New"] = "NEW";
    JobBidStatusEnum["Read"] = "READ";
    /** Bid was rejected by an admin. */
    JobBidStatusEnum["RejectedByAdmin"] = "REJECTED_BY_ADMIN";
})(JobBidStatusEnum || (JobBidStatusEnum = {}));
export var JobBoardClientName;
(function (JobBoardClientName) {
    JobBoardClientName["JobBoardSerpAarp"] = "JobBoardSerpAarp";
    JobBoardClientName["JobBoardSerpBillionStrong"] = "JobBoardSerpBillionStrong";
    JobBoardClientName["JobBoardSerpCgfns"] = "JobBoardSerpCgfns";
    JobBoardClientName["JobBoardSerpCisco"] = "JobBoardSerpCisco";
    JobBoardClientName["JobBoardSerpConstruction"] = "JobBoardSerpConstruction";
    JobBoardClientName["JobBoardSerpCpaCanada"] = "JobBoardSerpCpaCanada";
    JobBoardClientName["JobBoardSerpEducation"] = "JobBoardSerpEducation";
    JobBoardClientName["JobBoardSerpEintrachtFrankfurt"] = "JobBoardSerpEintrachtFrankfurt";
    JobBoardClientName["JobBoardSerpFoodAndBeverage"] = "JobBoardSerpFoodAndBeverage";
    JobBoardClientName["JobBoardSerpHealthcare"] = "JobBoardSerpHealthcare";
    JobBoardClientName["JobBoardSerpJobSearchAcademy"] = "JobBoardSerpJobSearchAcademy";
    JobBoardClientName["JobBoardSerpRetail"] = "JobBoardSerpRetail";
    JobBoardClientName["JobBoardSerpSales"] = "JobBoardSerpSales";
    JobBoardClientName["JobBoardSerpStudentsGrads"] = "JobBoardSerpStudentsGrads";
    JobBoardClientName["JobBoardSerpUdacityDatascience"] = "JobBoardSerpUdacityDatascience";
    JobBoardClientName["JobBoardSerpUdacityProgramming"] = "JobBoardSerpUdacityProgramming";
    JobBoardClientName["JobBoardSerpUdemy"] = "JobBoardSerpUdemy";
    JobBoardClientName["JobBoardSerpWorkWellbeing"] = "JobBoardSerpWorkWellbeing";
})(JobBoardClientName || (JobBoardClientName = {}));
/**   members to be used in building filters for measures  */
export var JobCampaignComparisonMeasureFilterMember;
(function (JobCampaignComparisonMeasureFilterMember) {
    JobCampaignComparisonMeasureFilterMember["CombinedApplyRate"] = "COMBINED_APPLY_RATE";
    JobCampaignComparisonMeasureFilterMember["CombinedAvgAcr"] = "COMBINED_AVG_ACR";
    JobCampaignComparisonMeasureFilterMember["CombinedAvgAsr"] = "COMBINED_AVG_ASR";
    JobCampaignComparisonMeasureFilterMember["CombinedAvgCpa"] = "COMBINED_AVG_CPA";
    JobCampaignComparisonMeasureFilterMember["CombinedAvgCpas"] = "COMBINED_AVG_CPAS";
    JobCampaignComparisonMeasureFilterMember["CombinedAvgCpc"] = "COMBINED_AVG_CPC";
    JobCampaignComparisonMeasureFilterMember["CombinedAvgCtr"] = "COMBINED_AVG_CTR";
    JobCampaignComparisonMeasureFilterMember["CombinedSumApplies"] = "COMBINED_SUM_APPLIES";
    JobCampaignComparisonMeasureFilterMember["CombinedSumApplyStarts"] = "COMBINED_SUM_APPLY_STARTS";
    JobCampaignComparisonMeasureFilterMember["CombinedSumClicks"] = "COMBINED_SUM_CLICKS";
    JobCampaignComparisonMeasureFilterMember["CombinedSumCostLocal"] = "COMBINED_SUM_COST_LOCAL";
    JobCampaignComparisonMeasureFilterMember["CombinedSumImpressions"] = "COMBINED_SUM_IMPRESSIONS";
    JobCampaignComparisonMeasureFilterMember["OrganicApplyRate"] = "ORGANIC_APPLY_RATE";
    JobCampaignComparisonMeasureFilterMember["OrganicAvgAcr"] = "ORGANIC_AVG_ACR";
    JobCampaignComparisonMeasureFilterMember["OrganicAvgAsr"] = "ORGANIC_AVG_ASR";
    JobCampaignComparisonMeasureFilterMember["OrganicAvgCpa"] = "ORGANIC_AVG_CPA";
    JobCampaignComparisonMeasureFilterMember["OrganicAvgCpas"] = "ORGANIC_AVG_CPAS";
    JobCampaignComparisonMeasureFilterMember["OrganicAvgCpc"] = "ORGANIC_AVG_CPC";
    JobCampaignComparisonMeasureFilterMember["OrganicAvgCtr"] = "ORGANIC_AVG_CTR";
    JobCampaignComparisonMeasureFilterMember["OrganicSumApplies"] = "ORGANIC_SUM_APPLIES";
    JobCampaignComparisonMeasureFilterMember["OrganicSumApplyStarts"] = "ORGANIC_SUM_APPLY_STARTS";
    JobCampaignComparisonMeasureFilterMember["OrganicSumClicks"] = "ORGANIC_SUM_CLICKS";
    JobCampaignComparisonMeasureFilterMember["OrganicSumCostLocal"] = "ORGANIC_SUM_COST_LOCAL";
    JobCampaignComparisonMeasureFilterMember["OrganicSumImpressions"] = "ORGANIC_SUM_IMPRESSIONS";
    JobCampaignComparisonMeasureFilterMember["SponsoredApplyRate"] = "SPONSORED_APPLY_RATE";
    JobCampaignComparisonMeasureFilterMember["SponsoredAvgAcr"] = "SPONSORED_AVG_ACR";
    JobCampaignComparisonMeasureFilterMember["SponsoredAvgAsr"] = "SPONSORED_AVG_ASR";
    JobCampaignComparisonMeasureFilterMember["SponsoredAvgCpa"] = "SPONSORED_AVG_CPA";
    JobCampaignComparisonMeasureFilterMember["SponsoredAvgCpas"] = "SPONSORED_AVG_CPAS";
    JobCampaignComparisonMeasureFilterMember["SponsoredAvgCpc"] = "SPONSORED_AVG_CPC";
    JobCampaignComparisonMeasureFilterMember["SponsoredAvgCtr"] = "SPONSORED_AVG_CTR";
    JobCampaignComparisonMeasureFilterMember["SponsoredSumApplies"] = "SPONSORED_SUM_APPLIES";
    JobCampaignComparisonMeasureFilterMember["SponsoredSumApplyStarts"] = "SPONSORED_SUM_APPLY_STARTS";
    JobCampaignComparisonMeasureFilterMember["SponsoredSumClicks"] = "SPONSORED_SUM_CLICKS";
    JobCampaignComparisonMeasureFilterMember["SponsoredSumCostLocal"] = "SPONSORED_SUM_COST_LOCAL";
    JobCampaignComparisonMeasureFilterMember["SponsoredSumImpressions"] = "SPONSORED_SUM_IMPRESSIONS";
})(JobCampaignComparisonMeasureFilterMember || (JobCampaignComparisonMeasureFilterMember = {}));
/**  Jobs and campaigns comparison order by fields  */
export var JobCampaignComparisonOrderByField;
(function (JobCampaignComparisonOrderByField) {
    JobCampaignComparisonOrderByField["ActivityDate"] = "ACTIVITY_DATE";
    JobCampaignComparisonOrderByField["AdvertisementId"] = "ADVERTISEMENT_ID";
    JobCampaignComparisonOrderByField["AdName"] = "AD_NAME";
    JobCampaignComparisonOrderByField["CampaignStatus"] = "CAMPAIGN_STATUS";
    JobCampaignComparisonOrderByField["City"] = "CITY";
    JobCampaignComparisonOrderByField["CombinedApplyRate"] = "COMBINED_APPLY_RATE";
    JobCampaignComparisonOrderByField["CombinedAvgAcr"] = "COMBINED_AVG_ACR";
    JobCampaignComparisonOrderByField["CombinedAvgAsr"] = "COMBINED_AVG_ASR";
    JobCampaignComparisonOrderByField["CombinedAvgCpa"] = "COMBINED_AVG_CPA";
    JobCampaignComparisonOrderByField["CombinedAvgCpas"] = "COMBINED_AVG_CPAS";
    JobCampaignComparisonOrderByField["CombinedAvgCpc"] = "COMBINED_AVG_CPC";
    JobCampaignComparisonOrderByField["CombinedAvgCtr"] = "COMBINED_AVG_CTR";
    JobCampaignComparisonOrderByField["CombinedSumApplies"] = "COMBINED_SUM_APPLIES";
    JobCampaignComparisonOrderByField["CombinedSumApplyStarts"] = "COMBINED_SUM_APPLY_STARTS";
    JobCampaignComparisonOrderByField["CombinedSumClicks"] = "COMBINED_SUM_CLICKS";
    JobCampaignComparisonOrderByField["CombinedSumCostLocal"] = "COMBINED_SUM_COST_LOCAL";
    JobCampaignComparisonOrderByField["CombinedSumImpressions"] = "COMBINED_SUM_IMPRESSIONS";
    JobCampaignComparisonOrderByField["CountryFullname"] = "COUNTRY_FULLNAME";
    JobCampaignComparisonOrderByField["FirstIndexedDate"] = "FIRST_INDEXED_DATE";
    JobCampaignComparisonOrderByField["JobCompanyName"] = "JOB_COMPANY_NAME";
    JobCampaignComparisonOrderByField["JobReferenceNumber"] = "JOB_REFERENCE_NUMBER";
    JobCampaignComparisonOrderByField["JobUrl"] = "JOB_URL";
    JobCampaignComparisonOrderByField["LastModifiedDate"] = "LAST_MODIFIED_DATE";
    JobCampaignComparisonOrderByField["NormTitle"] = "NORM_TITLE";
    JobCampaignComparisonOrderByField["NormTitleCategory"] = "NORM_TITLE_CATEGORY";
    JobCampaignComparisonOrderByField["OrganicApplyRate"] = "ORGANIC_APPLY_RATE";
    JobCampaignComparisonOrderByField["OrganicAvgAcr"] = "ORGANIC_AVG_ACR";
    JobCampaignComparisonOrderByField["OrganicAvgAsr"] = "ORGANIC_AVG_ASR";
    JobCampaignComparisonOrderByField["OrganicAvgCpa"] = "ORGANIC_AVG_CPA";
    JobCampaignComparisonOrderByField["OrganicAvgCpas"] = "ORGANIC_AVG_CPAS";
    JobCampaignComparisonOrderByField["OrganicAvgCpc"] = "ORGANIC_AVG_CPC";
    JobCampaignComparisonOrderByField["OrganicAvgCtr"] = "ORGANIC_AVG_CTR";
    JobCampaignComparisonOrderByField["OrganicSumApplies"] = "ORGANIC_SUM_APPLIES";
    JobCampaignComparisonOrderByField["OrganicSumApplyStarts"] = "ORGANIC_SUM_APPLY_STARTS";
    JobCampaignComparisonOrderByField["OrganicSumClicks"] = "ORGANIC_SUM_CLICKS";
    JobCampaignComparisonOrderByField["OrganicSumCostLocal"] = "ORGANIC_SUM_COST_LOCAL";
    JobCampaignComparisonOrderByField["OrganicSumImpressions"] = "ORGANIC_SUM_IMPRESSIONS";
    JobCampaignComparisonOrderByField["RegionFullname"] = "REGION_FULLNAME";
    JobCampaignComparisonOrderByField["SourceWebsite"] = "SOURCE_WEBSITE";
    JobCampaignComparisonOrderByField["SponsoredApplyRate"] = "SPONSORED_APPLY_RATE";
    JobCampaignComparisonOrderByField["SponsoredAvgAcr"] = "SPONSORED_AVG_ACR";
    JobCampaignComparisonOrderByField["SponsoredAvgAsr"] = "SPONSORED_AVG_ASR";
    JobCampaignComparisonOrderByField["SponsoredAvgCpa"] = "SPONSORED_AVG_CPA";
    JobCampaignComparisonOrderByField["SponsoredAvgCpas"] = "SPONSORED_AVG_CPAS";
    JobCampaignComparisonOrderByField["SponsoredAvgCpc"] = "SPONSORED_AVG_CPC";
    JobCampaignComparisonOrderByField["SponsoredAvgCtr"] = "SPONSORED_AVG_CTR";
    JobCampaignComparisonOrderByField["SponsoredSumApplies"] = "SPONSORED_SUM_APPLIES";
    JobCampaignComparisonOrderByField["SponsoredSumApplyStarts"] = "SPONSORED_SUM_APPLY_STARTS";
    JobCampaignComparisonOrderByField["SponsoredSumClicks"] = "SPONSORED_SUM_CLICKS";
    JobCampaignComparisonOrderByField["SponsoredSumCostLocal"] = "SPONSORED_SUM_COST_LOCAL";
    JobCampaignComparisonOrderByField["SponsoredSumImpressions"] = "SPONSORED_SUM_IMPRESSIONS";
    JobCampaignComparisonOrderByField["Title"] = "TITLE";
})(JobCampaignComparisonOrderByField || (JobCampaignComparisonOrderByField = {}));
/**  Possible viewBy dimensions for Job Campaign Analytics Counts  */
export var JobCampaignCounts;
(function (JobCampaignCounts) {
    JobCampaignCounts["City"] = "CITY";
    JobCampaignCounts["Company"] = "COMPANY";
    JobCampaignCounts["Country"] = "COUNTRY";
    JobCampaignCounts["JobReferenceNumber"] = "JOB_REFERENCE_NUMBER";
    JobCampaignCounts["NormTitle"] = "NORM_TITLE";
    JobCampaignCounts["NormTitleCategory"] = "NORM_TITLE_CATEGORY";
    JobCampaignCounts["Region"] = "REGION";
})(JobCampaignCounts || (JobCampaignCounts = {}));
/**   members to be used in building filters for extra dimensions  */
export var JobCampaignExtraDimensionFilterMember;
(function (JobCampaignExtraDimensionFilterMember) {
    JobCampaignExtraDimensionFilterMember["FirstIndexedDate"] = "FIRST_INDEXED_DATE";
})(JobCampaignExtraDimensionFilterMember || (JobCampaignExtraDimensionFilterMember = {}));
/**   members to be used in building filters for measures  */
export var JobCampaignMeasureFilterMember;
(function (JobCampaignMeasureFilterMember) {
    JobCampaignMeasureFilterMember["ApplyRate"] = "APPLY_RATE";
    JobCampaignMeasureFilterMember["AvgAcr"] = "AVG_ACR";
    JobCampaignMeasureFilterMember["AvgApplyPerJob"] = "AVG_APPLY_PER_JOB";
    JobCampaignMeasureFilterMember["AvgApplyStartPerJob"] = "AVG_APPLY_START_PER_JOB";
    JobCampaignMeasureFilterMember["AvgAsr"] = "AVG_ASR";
    JobCampaignMeasureFilterMember["AvgClicksPerJob"] = "AVG_CLICKS_PER_JOB";
    JobCampaignMeasureFilterMember["AvgCpa"] = "AVG_CPA";
    JobCampaignMeasureFilterMember["AvgCpas"] = "AVG_CPAS";
    JobCampaignMeasureFilterMember["AvgCpc"] = "AVG_CPC";
    JobCampaignMeasureFilterMember["AvgCtr"] = "AVG_CTR";
    JobCampaignMeasureFilterMember["AvgSpendPerJob"] = "AVG_SPEND_PER_JOB";
    JobCampaignMeasureFilterMember["SumApplies"] = "SUM_APPLIES";
    JobCampaignMeasureFilterMember["SumApplyStarts"] = "SUM_APPLY_STARTS";
    JobCampaignMeasureFilterMember["SumClicks"] = "SUM_CLICKS";
    JobCampaignMeasureFilterMember["SumCostLocal"] = "SUM_COST_LOCAL";
    JobCampaignMeasureFilterMember["SumImpressions"] = "SUM_IMPRESSIONS";
})(JobCampaignMeasureFilterMember || (JobCampaignMeasureFilterMember = {}));
/**  Jobs and campaigns order by fields  */
export var JobCampaignOrderByField;
(function (JobCampaignOrderByField) {
    JobCampaignOrderByField["Acr"] = "ACR";
    JobCampaignOrderByField["ActivityDate"] = "ACTIVITY_DATE";
    JobCampaignOrderByField["Admin1"] = "ADMIN1";
    JobCampaignOrderByField["Admin2"] = "ADMIN2";
    JobCampaignOrderByField["Admin3"] = "ADMIN3";
    JobCampaignOrderByField["Admin4"] = "ADMIN4";
    JobCampaignOrderByField["AdName"] = "AD_NAME";
    JobCampaignOrderByField["ApplyRate"] = "APPLY_RATE";
    JobCampaignOrderByField["Asr"] = "ASR";
    JobCampaignOrderByField["CampaignStatus"] = "CAMPAIGN_STATUS";
    JobCampaignOrderByField["City"] = "CITY";
    JobCampaignOrderByField["Country"] = "COUNTRY";
    JobCampaignOrderByField["CountryFullname"] = "COUNTRY_FULLNAME";
    JobCampaignOrderByField["Cpa"] = "CPA";
    JobCampaignOrderByField["Cpas"] = "CPAS";
    JobCampaignOrderByField["Cpc"] = "CPC";
    JobCampaignOrderByField["Ctr"] = "CTR";
    JobCampaignOrderByField["DeviceType"] = "DEVICE_TYPE";
    JobCampaignOrderByField["FirstIndexedDate"] = "FIRST_INDEXED_DATE";
    JobCampaignOrderByField["JobCompanyName"] = "JOB_COMPANY_NAME";
    JobCampaignOrderByField["JobReferenceNumber"] = "JOB_REFERENCE_NUMBER";
    JobCampaignOrderByField["JobUrl"] = "JOB_URL";
    JobCampaignOrderByField["LastModifiedDate"] = "LAST_MODIFIED_DATE";
    JobCampaignOrderByField["NormTitle"] = "NORM_TITLE";
    JobCampaignOrderByField["NormTitleCategory"] = "NORM_TITLE_CATEGORY";
    JobCampaignOrderByField["Region"] = "REGION";
    JobCampaignOrderByField["RegionFullname"] = "REGION_FULLNAME";
    JobCampaignOrderByField["SourceWebsite"] = "SOURCE_WEBSITE";
    JobCampaignOrderByField["SumApplies"] = "SUM_APPLIES";
    JobCampaignOrderByField["SumApplyStarts"] = "SUM_APPLY_STARTS";
    JobCampaignOrderByField["SumClicks"] = "SUM_CLICKS";
    JobCampaignOrderByField["SumCostLocal"] = "SUM_COST_LOCAL";
    JobCampaignOrderByField["SumImpressions"] = "SUM_IMPRESSIONS";
    JobCampaignOrderByField["Title"] = "TITLE";
})(JobCampaignOrderByField || (JobCampaignOrderByField = {}));
/** Groups on which performance can be aggregated. */
export var JobCampaignPerformancesConnectionGroupInput;
(function (JobCampaignPerformancesConnectionGroupInput) {
    /**
     * Performance aggregated on campaign.
     * Campaign identifiers will be present in response payload.
     */
    JobCampaignPerformancesConnectionGroupInput["Campaign"] = "CAMPAIGN";
    /** Performance aggregated on channel. */
    JobCampaignPerformancesConnectionGroupInput["Channel"] = "CHANNEL";
    /** Performance aggregated on device. */
    JobCampaignPerformancesConnectionGroupInput["Device"] = "DEVICE";
    /** Performance aggregated on traffic. */
    JobCampaignPerformancesConnectionGroupInput["Traffic"] = "TRAFFIC";
})(JobCampaignPerformancesConnectionGroupInput || (JobCampaignPerformancesConnectionGroupInput = {}));
/**
 * Sort criteria for performance.
 * Aggregated time in ascending or descending order.
 * May be helpful for the day level metrics.
 */
export var JobCampaignPerformancesConnectionSortInput;
(function (JobCampaignPerformancesConnectionSortInput) {
    /** DateTime ascending order. */
    JobCampaignPerformancesConnectionSortInput["TimeAsc"] = "TIME_ASC";
    /** DateTime descending order. */
    JobCampaignPerformancesConnectionSortInput["TimeDesc"] = "TIME_DESC";
})(JobCampaignPerformancesConnectionSortInput || (JobCampaignPerformancesConnectionSortInput = {}));
export var JobClickType;
(function (JobClickType) {
    JobClickType["ApplyStart"] = "APPLY_START";
    JobClickType["Unknown"] = "UNKNOWN";
    JobClickType["Unsubscribe"] = "UNSUBSCRIBE";
    JobClickType["Viewjob"] = "VIEWJOB";
})(JobClickType || (JobClickType = {}));
/** Name format options for name pronunciation fields */
export var JobContextStandardFieldNameFormat;
(function (JobContextStandardFieldNameFormat) {
    JobContextStandardFieldNameFormat["FirstLastName"] = "FIRST_LAST_NAME";
    JobContextStandardFieldNameFormat["FullName"] = "FULL_NAME";
})(JobContextStandardFieldNameFormat || (JobContextStandardFieldNameFormat = {}));
/** Field requirement level for job application fields */
export var JobContextStandardFieldRequirement;
(function (JobContextStandardFieldRequirement) {
    JobContextStandardFieldRequirement["Hidden"] = "HIDDEN";
    JobContextStandardFieldRequirement["Optional"] = "OPTIONAL";
    JobContextStandardFieldRequirement["Required"] = "REQUIRED";
})(JobContextStandardFieldRequirement || (JobContextStandardFieldRequirement = {}));
/**
 * For a given pairing of jobs, JobCopyType denotes that type of copy between the request job and the copied job
 * Full definition can be found here: https://docs.google.com/document/d/1ubfjXB2c_OPuoIP7qnH2cRF7r9y5_XlH-vFvjL_j27k/edit#heading=h.f8t70hc12nof
 */
export var JobCopyType;
(function (JobCopyType) {
    /** The request job is a copy of another job that is currently "live" */
    JobCopyType["Duplicate"] = "DUPLICATE";
    /** The request job is a copy of another job that has not gone through the aggregation process yet. ie. the copied job was created very recently */
    JobCopyType["PreAggregationCopy"] = "PRE_AGGREGATION_COPY";
    /** The request job is a copy of another job that is no longer "live" */
    JobCopyType["Repost"] = "REPOST";
    /** copy type could not be determined */
    JobCopyType["Unknown"] = "UNKNOWN";
})(JobCopyType || (JobCopyType = {}));
/** Job data source. */
export var JobDataSource;
(function (JobDataSource) {
    JobDataSource["DocService"] = "DOC_SERVICE";
    JobDataSource["EmployerJobApi"] = "EMPLOYER_JOB_API";
    JobDataSource["RequestInput"] = "REQUEST_INPUT";
})(JobDataSource || (JobDataSource = {}));
/** Variants of the JobDescriptionEligibility optimization */
export var JobDescriptionEligibilityOptimizationVariant;
(function (JobDescriptionEligibilityOptimizationVariant) {
    /** @deprecated Job Description Eligibility Optimization is deprecated */
    JobDescriptionEligibilityOptimizationVariant["JobDescriptionEligibilityOptimizationVariantDefault"] = "JOB_DESCRIPTION_ELIGIBILITY_OPTIMIZATION_VARIANT_DEFAULT";
})(JobDescriptionEligibilityOptimizationVariant || (JobDescriptionEligibilityOptimizationVariant = {}));
/** Variants of the JobDescription optimization */
export var JobDescriptionOptimizationVariant;
(function (JobDescriptionOptimizationVariant) {
    JobDescriptionOptimizationVariant["JobDescriptionOptimizationVariantDefault"] = "JOB_DESCRIPTION_OPTIMIZATION_VARIANT_DEFAULT";
})(JobDescriptionOptimizationVariant || (JobDescriptionOptimizationVariant = {}));
export var JobDescriptionSectionTypes;
(function (JobDescriptionSectionTypes) {
    JobDescriptionSectionTypes["Qualifications"] = "QUALIFICATIONS";
    JobDescriptionSectionTypes["Responsibilities"] = "RESPONSIBILITIES";
    JobDescriptionSectionTypes["Summary"] = "SUMMARY";
})(JobDescriptionSectionTypes || (JobDescriptionSectionTypes = {}));
/** Variants of the JobDescription sections optimization */
export var JobDescriptionSectionsOptimizationVariant;
(function (JobDescriptionSectionsOptimizationVariant) {
    JobDescriptionSectionsOptimizationVariant["JobDescriptionSectionsOptimizationVariantDefault"] = "JOB_DESCRIPTION_SECTIONS_OPTIMIZATION_VARIANT_DEFAULT";
    JobDescriptionSectionsOptimizationVariant["JobDescriptionSectionsOptimizationVariantPositiveConnection"] = "JOB_DESCRIPTION_SECTIONS_OPTIMIZATION_VARIANT_POSITIVE_CONNECTION";
})(JobDescriptionSectionsOptimizationVariant || (JobDescriptionSectionsOptimizationVariant = {}));
/**  Possible device types in JobCampaignDetailsInput  */
export var JobDeviceType;
(function (JobDeviceType) {
    JobDeviceType["Desktop"] = "DESKTOP";
    JobDeviceType["Mobile"] = "MOBILE";
})(JobDeviceType || (JobDeviceType = {}));
/**
 * Overall diagnosis result for a job's performance.
 * Uses Job prefix to prevent naming conflicts in OneGraph federation.
 */
export var JobDiagnosisResult;
(function (JobDiagnosisResult) {
    /** Not enough data available to make a diagnosis */
    JobDiagnosisResult["InsufficientData"] = "INSUFFICIENT_DATA";
    /** No aggregate job ID found for this job */
    JobDiagnosisResult["NoAggJobId"] = "NO_AGG_JOB_ID";
    /** Job is performing well within normal ranges */
    JobDiagnosisResult["PerformingWell"] = "PERFORMING_WELL";
    /** Job is too new to make a diagnosis */
    JobDiagnosisResult["TooNew"] = "TOO_NEW";
    /** Job is underperforming compared to similar jobs */
    JobDiagnosisResult["Underperforming"] = "UNDERPERFORMING";
})(JobDiagnosisResult || (JobDiagnosisResult = {}));
/**
 * Percentile thresholds for job diagnosis comparison (decoupled from Insights API).
 * Uses Job prefix to prevent naming conflicts in OneGraph federation.
 */
export var JobDiagnosisThreshold;
(function (JobDiagnosisThreshold) {
    /** 25th percentile */
    JobDiagnosisThreshold["P_25"] = "P_25";
    /** 50th percentile (median) */
    JobDiagnosisThreshold["P_50"] = "P_50";
    /** 75th percentile */
    JobDiagnosisThreshold["P_75"] = "P_75";
    /** 85th percentile */
    JobDiagnosisThreshold["P_85"] = "P_85";
    /** 90th percentile */
    JobDiagnosisThreshold["P_90"] = "P_90";
    /** 99th percentile */
    JobDiagnosisThreshold["P_99"] = "P_99";
})(JobDiagnosisThreshold || (JobDiagnosisThreshold = {}));
/**
 * Time window used for job performance diagnosis.
 * Uses Job prefix to prevent naming conflicts in OneGraph federation.
 */
export var JobDiagnosisTimeWindow;
(function (JobDiagnosisTimeWindow) {
    /** One day of performance data */
    JobDiagnosisTimeWindow["OneDay"] = "ONE_DAY";
    /** Thirty days of performance data */
    JobDiagnosisTimeWindow["ThirtyDays"] = "THIRTY_DAYS";
    /** Three days of performance data */
    JobDiagnosisTimeWindow["ThreeDays"] = "THREE_DAYS";
})(JobDiagnosisTimeWindow || (JobDiagnosisTimeWindow = {}));
/** Enum of job exporting source */
export var JobExportingSource;
(function (JobExportingSource) {
    JobExportingSource["External"] = "EXTERNAL";
    JobExportingSource["Hosted"] = "HOSTED";
})(JobExportingSource || (JobExportingSource = {}));
/** Job posting source/feed type. */
export var JobFeedType;
(function (JobFeedType) {
    /** Jobs sourced from the internet. */
    JobFeedType["CrawledFromWeb"] = "CRAWLED_FROM_WEB";
    /** Jobs created directly on Indeed. */
    JobFeedType["CreatedOnIndeed"] = "CREATED_ON_INDEED";
    /** Jobs from XML feeds or Job Sync API. */
    JobFeedType["IntegratedFromPartner"] = "INTEGRATED_FROM_PARTNER";
    /** Unknown or unclassified feed type. Includes jobs without immediate source data. */
    JobFeedType["Unknown"] = "UNKNOWN";
})(JobFeedType || (JobFeedType = {}));
/**
 * Job funnel stages for performance analysis.
 * Uses Job prefix to prevent naming conflicts in OneGraph federation.
 */
export var JobFunnelStage;
(function (JobFunnelStage) {
    /** Completed applications */
    JobFunnelStage["Applications"] = "APPLICATIONS";
    /** Apply starts on the job */
    JobFunnelStage["ApplyStarts"] = "APPLY_STARTS";
    /** Clicks on the job */
    JobFunnelStage["Clicks"] = "CLICKS";
    /** Job impressions (views) */
    JobFunnelStage["Impressions"] = "IMPRESSIONS";
})(JobFunnelStage || (JobFunnelStage = {}));
/**
 * Indicates if a job has a probation period.
 * `UNKNOWN` if not known, otherwise:
 * `YES` if the job explicitly has a probation period
 * `NO` if the job explicitly does not have a probation period
 */
export var JobHasProbationPeriod;
(function (JobHasProbationPeriod) {
    JobHasProbationPeriod["No"] = "NO";
    JobHasProbationPeriod["Unknown"] = "UNKNOWN";
    JobHasProbationPeriod["Yes"] = "YES";
})(JobHasProbationPeriod || (JobHasProbationPeriod = {}));
export var JobHasProbationaryPeriod;
(function (JobHasProbationaryPeriod) {
    JobHasProbationaryPeriod["No"] = "NO";
    JobHasProbationaryPeriod["Unknown"] = "UNKNOWN";
    JobHasProbationaryPeriod["Yes"] = "YES";
})(JobHasProbationaryPeriod || (JobHasProbationaryPeriod = {}));
/**  Job hosting type  */
export var JobHostingType;
(function (JobHostingType) {
    JobHostingType["Combined"] = "COMBINED";
    JobHostingType["Hosted"] = "HOSTED";
    JobHostingType["Indexed"] = "INDEXED";
})(JobHostingType || (JobHostingType = {}));
/** Defines selectable types of job identifier */
export var JobIdentifierType;
(function (JobIdentifierType) {
    JobIdentifierType["JobReferenceNumber"] = "JobReferenceNumber";
    JobIdentifierType["JobResultTrackingKey"] = "JobResultTrackingKey";
})(JobIdentifierType || (JobIdentifierType = {}));
/** Scope in which Indeed Apply is supported. */
export var JobIndeedApplyScope;
(function (JobIndeedApplyScope) {
    /** Indeed Apply is available for desktop platforms */
    JobIndeedApplyScope["Desktop"] = "DESKTOP";
    /** Indeed Apply is available for mobile platforms */
    JobIndeedApplyScope["Mobile"] = "MOBILE";
})(JobIndeedApplyScope || (JobIndeedApplyScope = {}));
/**  Percentile breakdown of Insights data.  */
export var JobInsightPercentile;
(function (JobInsightPercentile) {
    /**  25th percentile   */
    JobInsightPercentile["P_25"] = "P_25";
    /**  50th percentile   */
    JobInsightPercentile["P_50"] = "P_50";
    /**  75th percentile   */
    JobInsightPercentile["P_75"] = "P_75";
    /**  85th percentile   */
    JobInsightPercentile["P_85"] = "P_85";
    /**  90th percentile   */
    JobInsightPercentile["P_90"] = "P_90";
    /**  99th percentile  */
    JobInsightPercentile["P_99"] = "P_99";
})(JobInsightPercentile || (JobInsightPercentile = {}));
/**  Traffic type attributed to the insight. COMBINED is both SPONSORED and ORGANIC traffic together.  */
export var JobInsightTrafficType;
(function (JobInsightTrafficType) {
    JobInsightTrafficType["Combined"] = "COMBINED";
    JobInsightTrafficType["Organic"] = "ORGANIC";
    JobInsightTrafficType["Sponsored"] = "SPONSORED";
})(JobInsightTrafficType || (JobInsightTrafficType = {}));
/** Processing/visibility lifecycle of a job, from the Job Audit service. ACTIVE means the job is live. */
export var JobLifecycleStatusEnum;
(function (JobLifecycleStatusEnum) {
    JobLifecycleStatusEnum["Active"] = "ACTIVE";
    JobLifecycleStatusEnum["Inactive"] = "INACTIVE";
    JobLifecycleStatusEnum["Pending"] = "PENDING";
    JobLifecycleStatusEnum["Unknown"] = "UNKNOWN";
})(JobLifecycleStatusEnum || (JobLifecycleStatusEnum = {}));
/**
 * Defines the granularity at which budget expectations are tracked and enforced.
 *
 * This enum is non-exhaustive and new values will be added from time to time.
 */
export var JobMonetizationPolicyEnforcementGrouping;
(function (JobMonetizationPolicyEnforcementGrouping) {
    /**
     * Each individual employer job has its own expectation, the one defined in the policy.
     * Eg. If budget cap is 100$, each job gets 100$ cap across the given campaigns
     */
    JobMonetizationPolicyEnforcementGrouping["PerEmployerJob"] = "PER_EMPLOYER_JOB";
})(JobMonetizationPolicyEnforcementGrouping || (JobMonetizationPolicyEnforcementGrouping = {}));
/**
 * Defines the recurring period for budget and outcome caps.
 *
 * This enum is non-exhaustive and new values will be added from time to time.
 */
export var JobMonetizationPolicyRecurringUnit;
(function (JobMonetizationPolicyRecurringUnit) {
    JobMonetizationPolicyRecurringUnit["Lifetime"] = "LIFETIME";
    JobMonetizationPolicyRecurringUnit["Monthly"] = "MONTHLY";
    JobMonetizationPolicyRecurringUnit["Weekly"] = "WEEKLY";
})(JobMonetizationPolicyRecurringUnit || (JobMonetizationPolicyRecurringUnit = {}));
/**
 * Status of the job monetization policy.
 *
 * This enum is non-exhaustive and new values will be added from time to time.
 */
export var JobMonetizationPolicyStatus;
(function (JobMonetizationPolicyStatus) {
    JobMonetizationPolicyStatus["Active"] = "ACTIVE";
    JobMonetizationPolicyStatus["Deleted"] = "DELETED";
})(JobMonetizationPolicyStatus || (JobMonetizationPolicyStatus = {}));
/** Enum of job mutation type */
export var JobMutationType;
(function (JobMutationType) {
    JobMutationType["Create"] = "CREATE";
    JobMutationType["Update"] = "UPDATE";
    /** Update an external job, e.g indexed job */
    JobMutationType["UpdateExternal"] = "UPDATE_EXTERNAL";
})(JobMutationType || (JobMutationType = {}));
/** Name of available jobs to run */
export var JobName;
(function (JobName) {
    JobName["CompensationHealingJob"] = "COMPENSATION_HEALING_JOB";
    JobName["PromotionItemsJob"] = "PROMOTION_ITEMS_JOB";
    JobName["PromotionUsesFetcherJob"] = "PROMOTION_USES_FETCHER_JOB";
    JobName["PromotionUsesSynchronizerJob"] = "PROMOTION_USES_SYNCHRONIZER_JOB";
})(JobName || (JobName = {}));
/**
 * Occupation source to be used in input
 *
 * When ANY is used, any attribute source can be matched.
 */
export var JobOccupationSource;
(function (JobOccupationSource) {
    JobOccupationSource["Any"] = "ANY";
    JobOccupationSource["Employer"] = "EMPLOYER";
    JobOccupationSource["Extracted"] = "EXTRACTED";
})(JobOccupationSource || (JobOccupationSource = {}));
/** The job optimization type */
export var JobOptOptimizationType;
(function (JobOptOptimizationType) {
    /** @deprecated Add company description optimization is deprecated */
    JobOptOptimizationType["AddCompanyDescription"] = "ADD_COMPANY_DESCRIPTION";
    /** @deprecated Assessment optimization is deprecated */
    JobOptOptimizationType["Assessment"] = "ASSESSMENT";
    JobOptOptimizationType["Benefit"] = "BENEFIT";
    /** @deprecated CPO sponsorship optimization is deprecated */
    JobOptOptimizationType["CpoSponsorship"] = "CPO_SPONSORSHIP";
    JobOptOptimizationType["EducationRequirement"] = "EDUCATION_REQUIREMENT";
    JobOptOptimizationType["EducationRequirementV2"] = "EDUCATION_REQUIREMENT_V2";
    JobOptOptimizationType["ExistsBenefits"] = "EXISTS_BENEFITS";
    JobOptOptimizationType["ExistsExpectedHireDate"] = "EXISTS_EXPECTED_HIRE_DATE";
    JobOptOptimizationType["ExistsJobType"] = "EXISTS_JOB_TYPE";
    JobOptOptimizationType["ExistsLicenseCertifications"] = "EXISTS_LICENSE_CERTIFICATIONS";
    JobOptOptimizationType["ExistsNumberOfHires"] = "EXISTS_NUMBER_OF_HIRES";
    JobOptOptimizationType["ExistsOccupation"] = "EXISTS_OCCUPATION";
    JobOptOptimizationType["ExistsProperWordLength"] = "EXISTS_PROPER_WORD_LENGTH";
    JobOptOptimizationType["ExistsSalary"] = "EXISTS_SALARY";
    JobOptOptimizationType["ExistsShift"] = "EXISTS_SHIFT";
    JobOptOptimizationType["ExistsSkills"] = "EXISTS_SKILLS";
    JobOptOptimizationType["ExistsSpecificLocation"] = "EXISTS_SPECIFIC_LOCATION";
    /** @deprecated Gender decoder optimization is deprecated */
    JobOptOptimizationType["GenderDecoder"] = "GENDER_DECODER";
    JobOptOptimizationType["InclusiveHiringStatement"] = "INCLUSIVE_HIRING_STATEMENT";
    JobOptOptimizationType["JobDescription"] = "JOB_DESCRIPTION";
    /** @deprecated JOB_DESCRIPTION_OPT_ELIGIBILITY optimization is deprecated */
    JobOptOptimizationType["JobDescriptionOptEligibility"] = "JOB_DESCRIPTION_OPT_ELIGIBILITY";
    JobOptOptimizationType["JobDescriptionSectionsQualifications"] = "JOB_DESCRIPTION_SECTIONS_QUALIFICATIONS";
    JobOptOptimizationType["JobDescriptionSectionsResponsibilities"] = "JOB_DESCRIPTION_SECTIONS_RESPONSIBILITIES";
    JobOptOptimizationType["JobDescriptionSectionsSummary"] = "JOB_DESCRIPTION_SECTIONS_SUMMARY";
    JobOptOptimizationType["NormTitle"] = "NORM_TITLE";
    /** @deprecated I2A optimization is deprecated */
    JobOptOptimizationType["PersonalizedI2A"] = "PERSONALIZED_I2A";
    JobOptOptimizationType["Qualifications"] = "QUALIFICATIONS";
    /** @deprecated Qualification_Calibration optimization is deprecated */
    JobOptOptimizationType["QualificationCalibration"] = "QUALIFICATION_CALIBRATION";
    JobOptOptimizationType["QualRecCertification"] = "QUAL_REC_CERTIFICATION";
    JobOptOptimizationType["QualRecEducation"] = "QUAL_REC_EDUCATION";
    JobOptOptimizationType["QualRecLicense"] = "QUAL_REC_LICENSE";
    JobOptOptimizationType["QualRecSkill"] = "QUAL_REC_SKILL";
    JobOptOptimizationType["SalaryOpt"] = "SALARY_OPT";
    /** @deprecated Scalable segment classes optimization is deprecated */
    JobOptOptimizationType["ScalableSegmentClasses"] = "SCALABLE_SEGMENT_CLASSES";
    JobOptOptimizationType["Schedules"] = "SCHEDULES";
    /** @deprecated Skill V1 optimization is deprecated */
    JobOptOptimizationType["SkillRequirement"] = "SKILL_REQUIREMENT";
    JobOptOptimizationType["SkillV2Requirement"] = "SKILL_V2_REQUIREMENT";
    /** @deprecated Sponsorship optimization is deprecated */
    JobOptOptimizationType["Sponsorship"] = "SPONSORSHIP";
    /** @deprecated Urgent hire optimization is deprecated */
    JobOptOptimizationType["UrgentHire"] = "URGENT_HIRE";
})(JobOptOptimizationType || (JobOptOptimizationType = {}));
/** Enum describing the calibration source for the qualification */
export var JobOptimizationQualificationCalibrationSource;
(function (JobOptimizationQualificationCalibrationSource) {
    JobOptimizationQualificationCalibrationSource["CalibrationSourceBothPosNegCandidates"] = "CALIBRATION_SOURCE_BOTH_POS_NEG_CANDIDATES";
    JobOptimizationQualificationCalibrationSource["CalibrationSourceOnlyNegativeCandidates"] = "CALIBRATION_SOURCE_ONLY_NEGATIVE_CANDIDATES";
    JobOptimizationQualificationCalibrationSource["CalibrationSourceUnknown"] = "CALIBRATION_SOURCE_UNKNOWN";
})(JobOptimizationQualificationCalibrationSource || (JobOptimizationQualificationCalibrationSource = {}));
/** Enum describing the type of qualification */
export var JobOptimizationQualificationCategory;
(function (JobOptimizationQualificationCategory) {
    JobOptimizationQualificationCategory["JobOptimizationQualificationCategoryCertification"] = "JOB_OPTIMIZATION_QUALIFICATION_CATEGORY_CERTIFICATION";
    JobOptimizationQualificationCategory["JobOptimizationQualificationCategoryEducation"] = "JOB_OPTIMIZATION_QUALIFICATION_CATEGORY_EDUCATION";
    JobOptimizationQualificationCategory["JobOptimizationQualificationCategoryLicense"] = "JOB_OPTIMIZATION_QUALIFICATION_CATEGORY_LICENSE";
    JobOptimizationQualificationCategory["JobOptimizationQualificationCategorySkill"] = "JOB_OPTIMIZATION_QUALIFICATION_CATEGORY_SKILL";
    JobOptimizationQualificationCategory["JobOptimizationQualificationCategoryUnspecified"] = "JOB_OPTIMIZATION_QUALIFICATION_CATEGORY_UNSPECIFIED";
})(JobOptimizationQualificationCategory || (JobOptimizationQualificationCategory = {}));
/** Enum describing the recommendation source of qualification */
export var JobOptimizationQualificationRecommendationSource;
(function (JobOptimizationQualificationRecommendationSource) {
    JobOptimizationQualificationRecommendationSource["RecDefault"] = "REC_DEFAULT";
    JobOptimizationQualificationRecommendationSource["RecExtracted"] = "REC_EXTRACTED";
    JobOptimizationQualificationRecommendationSource["RecInstantMatch"] = "REC_INSTANT_MATCH";
    JobOptimizationQualificationRecommendationSource["RecLlmRequirementStrength"] = "REC_LLM_REQUIREMENT_STRENGTH";
    JobOptimizationQualificationRecommendationSource["RecOccupationCorrelation"] = "REC_OCCUPATION_CORRELATION";
    JobOptimizationQualificationRecommendationSource["RecOccupationDefault"] = "REC_OCCUPATION_DEFAULT";
    JobOptimizationQualificationRecommendationSource["RecOccupationRelation"] = "REC_OCCUPATION_RELATION";
    JobOptimizationQualificationRecommendationSource["RecRequirementStrength"] = "REC_REQUIREMENT_STRENGTH";
    JobOptimizationQualificationRecommendationSource["RecSegmentConfigurationService"] = "REC_SEGMENT_CONFIGURATION_SERVICE";
    JobOptimizationQualificationRecommendationSource["RecUnknown"] = "REC_UNKNOWN";
})(JobOptimizationQualificationRecommendationSource || (JobOptimizationQualificationRecommendationSource = {}));
/** Enum describing the type of "reason" why the optimization is beneficial */
export var JobOptimizationReasonType;
(function (JobOptimizationReasonType) {
    JobOptimizationReasonType["Applies"] = "APPLIES";
    JobOptimizationReasonType["JobSeekers"] = "JOB_SEEKERS";
    JobOptimizationReasonType["PositiveConnectionLikelihood"] = "POSITIVE_CONNECTION_LIKELIHOOD";
})(JobOptimizationReasonType || (JobOptimizationReasonType = {}));
export var JobOrderSourceEnum;
(function (JobOrderSourceEnum) {
    JobOrderSourceEnum["Created"] = "CREATED";
    JobOrderSourceEnum["Imported"] = "IMPORTED";
})(JobOrderSourceEnum || (JobOrderSourceEnum = {}));
export var JobOrderStatusEnum;
(function (JobOrderStatusEnum) {
    JobOrderStatusEnum["Active"] = "ACTIVE";
    JobOrderStatusEnum["Closed"] = "CLOSED";
    JobOrderStatusEnum["Created"] = "CREATED";
    JobOrderStatusEnum["Launching"] = "LAUNCHING";
    JobOrderStatusEnum["Open"] = "OPEN";
    JobOrderStatusEnum["PendingPayment"] = "PENDING_PAYMENT";
    /** Job order was rejected by an admin during review. */
    JobOrderStatusEnum["RejectedByAdmin"] = "REJECTED_BY_ADMIN";
})(JobOrderStatusEnum || (JobOrderStatusEnum = {}));
/**  Jobs and campaigns order by fields  */
export var JobPerformanceAndInsightsOrderByField;
(function (JobPerformanceAndInsightsOrderByField) {
    JobPerformanceAndInsightsOrderByField["Acr"] = "ACR";
    JobPerformanceAndInsightsOrderByField["AcrP25"] = "ACR_P25";
    JobPerformanceAndInsightsOrderByField["AcrP50"] = "ACR_P50";
    JobPerformanceAndInsightsOrderByField["AcrP75"] = "ACR_P75";
    JobPerformanceAndInsightsOrderByField["AcrP90"] = "ACR_P90";
    JobPerformanceAndInsightsOrderByField["AppliesP25"] = "APPLIES_P25";
    JobPerformanceAndInsightsOrderByField["AppliesP50"] = "APPLIES_P50";
    JobPerformanceAndInsightsOrderByField["AppliesP75"] = "APPLIES_P75";
    JobPerformanceAndInsightsOrderByField["AppliesP90"] = "APPLIES_P90";
    JobPerformanceAndInsightsOrderByField["ApplyRate"] = "APPLY_RATE";
    JobPerformanceAndInsightsOrderByField["ApplyStartP25"] = "APPLY_START_P25";
    JobPerformanceAndInsightsOrderByField["ApplyStartP50"] = "APPLY_START_P50";
    JobPerformanceAndInsightsOrderByField["ApplyStartP75"] = "APPLY_START_P75";
    JobPerformanceAndInsightsOrderByField["ApplyStartP90"] = "APPLY_START_P90";
    JobPerformanceAndInsightsOrderByField["Asr"] = "ASR";
    JobPerformanceAndInsightsOrderByField["AsrP25"] = "ASR_P25";
    JobPerformanceAndInsightsOrderByField["AsrP50"] = "ASR_P50";
    JobPerformanceAndInsightsOrderByField["AsrP75"] = "ASR_P75";
    JobPerformanceAndInsightsOrderByField["AsrP90"] = "ASR_P90";
    JobPerformanceAndInsightsOrderByField["City"] = "CITY";
    JobPerformanceAndInsightsOrderByField["ClicksP25"] = "CLICKS_P25";
    JobPerformanceAndInsightsOrderByField["ClicksP50"] = "CLICKS_P50";
    JobPerformanceAndInsightsOrderByField["ClicksP75"] = "CLICKS_P75";
    JobPerformanceAndInsightsOrderByField["ClicksP90"] = "CLICKS_P90";
    JobPerformanceAndInsightsOrderByField["CostP25"] = "COST_P25";
    JobPerformanceAndInsightsOrderByField["CostP50"] = "COST_P50";
    JobPerformanceAndInsightsOrderByField["CostP75"] = "COST_P75";
    JobPerformanceAndInsightsOrderByField["CostP90"] = "COST_P90";
    JobPerformanceAndInsightsOrderByField["CountryFullname"] = "COUNTRY_FULLNAME";
    JobPerformanceAndInsightsOrderByField["Cpa"] = "CPA";
    JobPerformanceAndInsightsOrderByField["Cpas"] = "CPAS";
    JobPerformanceAndInsightsOrderByField["Cpc"] = "CPC";
    JobPerformanceAndInsightsOrderByField["Ctr"] = "CTR";
    JobPerformanceAndInsightsOrderByField["CtrP25"] = "CTR_P25";
    JobPerformanceAndInsightsOrderByField["CtrP50"] = "CTR_P50";
    JobPerformanceAndInsightsOrderByField["CtrP75"] = "CTR_P75";
    JobPerformanceAndInsightsOrderByField["CtrP90"] = "CTR_P90";
    JobPerformanceAndInsightsOrderByField["FirstIndexedDate"] = "FIRST_INDEXED_DATE";
    JobPerformanceAndInsightsOrderByField["ImpressionP25"] = "IMPRESSION_P25";
    JobPerformanceAndInsightsOrderByField["ImpressionP50"] = "IMPRESSION_P50";
    JobPerformanceAndInsightsOrderByField["ImpressionP75"] = "IMPRESSION_P75";
    JobPerformanceAndInsightsOrderByField["ImpressionP90"] = "IMPRESSION_P90";
    JobPerformanceAndInsightsOrderByField["JobCompanyName"] = "JOB_COMPANY_NAME";
    JobPerformanceAndInsightsOrderByField["JobReferenceNumber"] = "JOB_REFERENCE_NUMBER";
    JobPerformanceAndInsightsOrderByField["LastModifiedDate"] = "LAST_MODIFIED_DATE";
    JobPerformanceAndInsightsOrderByField["NearestApplies"] = "NEAREST_APPLIES";
    JobPerformanceAndInsightsOrderByField["NearestApplyStarts"] = "NEAREST_APPLY_STARTS";
    JobPerformanceAndInsightsOrderByField["NearestClicks"] = "NEAREST_CLICKS";
    JobPerformanceAndInsightsOrderByField["NearestCost"] = "NEAREST_COST";
    JobPerformanceAndInsightsOrderByField["NearestImpression"] = "NEAREST_IMPRESSION";
    JobPerformanceAndInsightsOrderByField["NormTitle"] = "NORM_TITLE";
    JobPerformanceAndInsightsOrderByField["NormTitleCategory"] = "NORM_TITLE_CATEGORY";
    JobPerformanceAndInsightsOrderByField["RegionFullname"] = "REGION_FULLNAME";
    JobPerformanceAndInsightsOrderByField["SumApplies"] = "SUM_APPLIES";
    JobPerformanceAndInsightsOrderByField["SumApplyStarts"] = "SUM_APPLY_STARTS";
    JobPerformanceAndInsightsOrderByField["SumClicks"] = "SUM_CLICKS";
    JobPerformanceAndInsightsOrderByField["SumCostLocal"] = "SUM_COST_LOCAL";
    JobPerformanceAndInsightsOrderByField["SumImpressions"] = "SUM_IMPRESSIONS";
    JobPerformanceAndInsightsOrderByField["Title"] = "TITLE";
})(JobPerformanceAndInsightsOrderByField || (JobPerformanceAndInsightsOrderByField = {}));
/** Status of the call to action for a job posting. */
export var JobPostCallToActionStatus;
(function (JobPostCallToActionStatus) {
    /** The job posting has expired and is no longer searchable on Indeed. */
    JobPostCallToActionStatus["Expired"] = "EXPIRED";
    /** The job posting requires sponsorship to be searchable on Indeed. */
    JobPostCallToActionStatus["NeedsSponsorship"] = "NEEDS_SPONSORSHIP";
    /** The job posting is not searchable on Indeed for an unspecified reason. */
    JobPostCallToActionStatus["NotSearchable"] = "NOT_SEARCHABLE";
    /** The job posting is active and searchable on Indeed. */
    JobPostCallToActionStatus["Searchable"] = "SEARCHABLE";
})(JobPostCallToActionStatus || (JobPostCallToActionStatus = {}));
/** Lifecycle statuses in Indeed. */
export var JobPostLifecycleStatus;
(function (JobPostLifecycleStatus) {
    /**  The job has been processed.  */
    JobPostLifecycleStatus["Active"] = "ACTIVE";
    /**  The job is no longer active.  */
    JobPostLifecycleStatus["Inactive"] = "INACTIVE";
    /**  The job is still processing.  */
    JobPostLifecycleStatus["Pending"] = "PENDING";
})(JobPostLifecycleStatus || (JobPostLifecycleStatus = {}));
/** The job post's origin */
export var JobPostOrigin;
(function (JobPostOrigin) {
    JobPostOrigin["Claimed"] = "CLAIMED";
    JobPostOrigin["Hosted"] = "HOSTED";
    JobPostOrigin["Unclaimed"] = "UNCLAIMED";
})(JobPostOrigin || (JobPostOrigin = {}));
/** Visibility status of a job post. */
export var JobPostVisibilityLevel;
(function (JobPostVisibilityLevel) {
    /**  Requires sponsorship to be visible in search  */
    JobPostVisibilityLevel["Hidden"] = "HIDDEN";
    /**  Highest-level of visibility  */
    JobPostVisibilityLevel["Organic"] = "ORGANIC";
    /**  Available in organic search  */
    JobPostVisibilityLevel["SponsoredOnly"] = "SPONSORED_ONLY";
    /**  Nowhere  */
    JobPostVisibilityLevel["Unknown"] = "UNKNOWN";
    JobPostVisibilityLevel["Unrestricted"] = "UNRESTRICTED";
})(JobPostVisibilityLevel || (JobPostVisibilityLevel = {}));
/** Accommodations Contact Info error codes */
export var JobPostingFormAccommodationsContactInfoValidationErrorCode;
(function (JobPostingFormAccommodationsContactInfoValidationErrorCode) {
    JobPostingFormAccommodationsContactInfoValidationErrorCode["AccommodationsContactInfoEmailInvalidFormat"] = "ACCOMMODATIONS_CONTACT_INFO_EMAIL_INVALID_FORMAT";
    JobPostingFormAccommodationsContactInfoValidationErrorCode["AccommodationsContactInfoEmailTooLong"] = "ACCOMMODATIONS_CONTACT_INFO_EMAIL_TOO_LONG";
    JobPostingFormAccommodationsContactInfoValidationErrorCode["AccommodationsContactInfoPhoneNumberInvalidFormat"] = "ACCOMMODATIONS_CONTACT_INFO_PHONE_NUMBER_INVALID_FORMAT";
    JobPostingFormAccommodationsContactInfoValidationErrorCode["AccommodationsContactInfoPhoneNumberTooLong"] = "ACCOMMODATIONS_CONTACT_INFO_PHONE_NUMBER_TOO_LONG";
    JobPostingFormAccommodationsContactInfoValidationErrorCode["AccommodationsContactInfoUrlInvalidFormat"] = "ACCOMMODATIONS_CONTACT_INFO_URL_INVALID_FORMAT";
    JobPostingFormAccommodationsContactInfoValidationErrorCode["AccommodationsContactInfoUrlTooLong"] = "ACCOMMODATIONS_CONTACT_INFO_URL_TOO_LONG";
})(JobPostingFormAccommodationsContactInfoValidationErrorCode || (JobPostingFormAccommodationsContactInfoValidationErrorCode = {}));
/** Advertising location type enum */
export var JobPostingFormAdvertisingLocationType;
(function (JobPostingFormAdvertisingLocationType) {
    JobPostingFormAdvertisingLocationType["MultipleLocations"] = "MULTIPLE_LOCATIONS";
    JobPostingFormAdvertisingLocationType["Nationwide"] = "NATIONWIDE";
    JobPostingFormAdvertisingLocationType["OneCity"] = "ONE_CITY";
    JobPostingFormAdvertisingLocationType["Statewide"] = "STATEWIDE";
})(JobPostingFormAdvertisingLocationType || (JobPostingFormAdvertisingLocationType = {}));
/** ApplicationSettings error codes */
export var JobPostingFormApplicationSettingsValidationErrorCode;
(function (JobPostingFormApplicationSettingsValidationErrorCode) {
    JobPostingFormApplicationSettingsValidationErrorCode["ApplicationSettingsApplyMethodIneligible"] = "APPLICATION_SETTINGS_APPLY_METHOD_INELIGIBLE";
    JobPostingFormApplicationSettingsValidationErrorCode["ApplicationSettingsEmailInvalidFormat"] = "APPLICATION_SETTINGS_EMAIL_INVALID_FORMAT";
    JobPostingFormApplicationSettingsValidationErrorCode["ApplicationSettingsEmailMissing"] = "APPLICATION_SETTINGS_EMAIL_MISSING";
    JobPostingFormApplicationSettingsValidationErrorCode["ApplicationSettingsEmailRestrictedDomain"] = "APPLICATION_SETTINGS_EMAIL_RESTRICTED_DOMAIN";
    JobPostingFormApplicationSettingsValidationErrorCode["ApplicationSettingsEmailTooLong"] = "APPLICATION_SETTINGS_EMAIL_TOO_LONG";
    JobPostingFormApplicationSettingsValidationErrorCode["ApplicationSettingsWebsiteInvalidFormat"] = "APPLICATION_SETTINGS_WEBSITE_INVALID_FORMAT";
    JobPostingFormApplicationSettingsValidationErrorCode["ApplicationSettingsWebsiteMissing"] = "APPLICATION_SETTINGS_WEBSITE_MISSING";
    JobPostingFormApplicationSettingsValidationErrorCode["ApplicationSettingsWebsiteTooLong"] = "APPLICATION_SETTINGS_WEBSITE_TOO_LONG";
})(JobPostingFormApplicationSettingsValidationErrorCode || (JobPostingFormApplicationSettingsValidationErrorCode = {}));
export var JobPostingFormApplyMethod;
(function (JobPostingFormApplyMethod) {
    JobPostingFormApplyMethod["Email"] = "EMAIL";
    JobPostingFormApplyMethod["Website"] = "WEBSITE";
})(JobPostingFormApplyMethod || (JobPostingFormApplyMethod = {}));
/** AutojobPrompt error codes. */
export var JobPostingFormAutojobPromptValidationErrorCode;
(function (JobPostingFormAutojobPromptValidationErrorCode) {
    JobPostingFormAutojobPromptValidationErrorCode["AutojobPromptInvalidKeyword"] = "AUTOJOB_PROMPT_INVALID_KEYWORD";
})(JobPostingFormAutojobPromptValidationErrorCode || (JobPostingFormAutojobPromptValidationErrorCode = {}));
/** Benefits error codes. */
export var JobPostingFormBenefitsValidationErrorCode;
(function (JobPostingFormBenefitsValidationErrorCode) {
    JobPostingFormBenefitsValidationErrorCode["BenefitsMissingSelection"] = "BENEFITS_MISSING_SELECTION";
})(JobPostingFormBenefitsValidationErrorCode || (JobPostingFormBenefitsValidationErrorCode = {}));
/** Budget plan type */
export var JobPostingFormBudgetPlan;
(function (JobPostingFormBudgetPlan) {
    JobPostingFormBudgetPlan["Daily"] = "DAILY";
    JobPostingFormBudgetPlan["Free"] = "FREE";
    JobPostingFormBudgetPlan["Monthly"] = "MONTHLY";
})(JobPostingFormBudgetPlan || (JobPostingFormBudgetPlan = {}));
/** Reason to change job company name */
export var JobPostingFormCompanyNameChangeReason;
(function (JobPostingFormCompanyNameChangeReason) {
    JobPostingFormCompanyNameChangeReason["Confidential"] = "CONFIDENTIAL";
    JobPostingFormCompanyNameChangeReason["MultipleBusinesses"] = "MULTIPLE_BUSINESSES";
    JobPostingFormCompanyNameChangeReason["NameIncorrect"] = "NAME_INCORRECT";
    JobPostingFormCompanyNameChangeReason["Other"] = "OTHER";
    JobPostingFormCompanyNameChangeReason["PostingOnBehalf"] = "POSTING_ON_BEHALF";
    JobPostingFormCompanyNameChangeReason["UseEmployerCompanyName"] = "USE_EMPLOYER_COMPANY_NAME";
})(JobPostingFormCompanyNameChangeReason || (JobPostingFormCompanyNameChangeReason = {}));
/** Contract Length type enum */
export var JobPostingFormContractLengthType;
(function (JobPostingFormContractLengthType) {
    JobPostingFormContractLengthType["Days"] = "DAYS";
    JobPostingFormContractLengthType["Months"] = "MONTHS";
    JobPostingFormContractLengthType["Weeks"] = "WEEKS";
})(JobPostingFormContractLengthType || (JobPostingFormContractLengthType = {}));
/** Contract Length error codes */
export var JobPostingFormContractLengthValidationErrorCode;
(function (JobPostingFormContractLengthValidationErrorCode) {
    JobPostingFormContractLengthValidationErrorCode["ContractLengthInvalidFormat"] = "CONTRACT_LENGTH_INVALID_FORMAT";
    JobPostingFormContractLengthValidationErrorCode["ContractLengthInvalidRange"] = "CONTRACT_LENGTH_INVALID_RANGE";
    JobPostingFormContractLengthValidationErrorCode["ContractLengthValueMustBeGreaterThanZero"] = "CONTRACT_LENGTH_VALUE_MUST_BE_GREATER_THAN_ZERO";
})(JobPostingFormContractLengthValidationErrorCode || (JobPostingFormContractLengthValidationErrorCode = {}));
/** Description error codes */
export var JobPostingFormDescriptionValidationErrorCode;
(function (JobPostingFormDescriptionValidationErrorCode) {
    JobPostingFormDescriptionValidationErrorCode["DescriptionTooLong"] = "DESCRIPTION_TOO_LONG";
    JobPostingFormDescriptionValidationErrorCode["DescriptionTooShort"] = "DESCRIPTION_TOO_SHORT";
    JobPostingFormDescriptionValidationErrorCode["DescriptionUnsupportedCharacters"] = "DESCRIPTION_UNSUPPORTED_CHARACTERS";
})(JobPostingFormDescriptionValidationErrorCode || (JobPostingFormDescriptionValidationErrorCode = {}));
export var JobPostingFormDuplicateJobUserIntent;
(function (JobPostingFormDuplicateJobUserIntent) {
    JobPostingFormDuplicateJobUserIntent["Continue"] = "CONTINUE";
    JobPostingFormDuplicateJobUserIntent["Edit"] = "EDIT";
    JobPostingFormDuplicateJobUserIntent["Sponsor"] = "SPONSOR";
})(JobPostingFormDuplicateJobUserIntent || (JobPostingFormDuplicateJobUserIntent = {}));
export var JobPostingFormEditFunnelStep;
(function (JobPostingFormEditFunnelStep) {
    JobPostingFormEditFunnelStep["JobPublished"] = "JOB_PUBLISHED";
    JobPostingFormEditFunnelStep["RedirectToLegacy"] = "REDIRECT_TO_LEGACY";
    JobPostingFormEditFunnelStep["ReviewSheet"] = "REVIEW_SHEET";
    JobPostingFormEditFunnelStep["Unknown"] = "UNKNOWN";
})(JobPostingFormEditFunnelStep || (JobPostingFormEditFunnelStep = {}));
export var JobPostingFormExpectedHireDateType;
(function (JobPostingFormExpectedHireDateType) {
    JobPostingFormExpectedHireDateType["FourPlusWeeks"] = "FOUR_PLUS_WEEKS";
    JobPostingFormExpectedHireDateType["FourWeeks"] = "FOUR_WEEKS";
    JobPostingFormExpectedHireDateType["OneWeek"] = "ONE_WEEK";
    JobPostingFormExpectedHireDateType["ThreeDays"] = "THREE_DAYS";
    JobPostingFormExpectedHireDateType["TwoWeeks"] = "TWO_WEEKS";
})(JobPostingFormExpectedHireDateType || (JobPostingFormExpectedHireDateType = {}));
export var JobPostingFormExpectedHireDateValidationErrorCode;
(function (JobPostingFormExpectedHireDateValidationErrorCode) {
    JobPostingFormExpectedHireDateValidationErrorCode["ExpectedHireDateMissing"] = "EXPECTED_HIRE_DATE_MISSING";
})(JobPostingFormExpectedHireDateValidationErrorCode || (JobPostingFormExpectedHireDateValidationErrorCode = {}));
/** Job form fields. */
export var JobPostingFormFieldName;
(function (JobPostingFormFieldName) {
    JobPostingFormFieldName["AccommodationsContactInfo"] = "ACCOMMODATIONS_CONTACT_INFO";
    JobPostingFormFieldName["ApplicationSettings"] = "APPLICATION_SETTINGS";
    JobPostingFormFieldName["AutojobPrompt"] = "AUTOJOB_PROMPT";
    JobPostingFormFieldName["Benefits"] = "BENEFITS";
    JobPostingFormFieldName["ContractLength"] = "CONTRACT_LENGTH";
    JobPostingFormFieldName["Description"] = "DESCRIPTION";
    JobPostingFormFieldName["ExpectedHireDate"] = "EXPECTED_HIRE_DATE";
    JobPostingFormFieldName["FirstPageBoost"] = "FIRST_PAGE_BOOST";
    JobPostingFormFieldName["HiresNeeded"] = "HIRES_NEEDED";
    JobPostingFormFieldName["JobCompanyName"] = "JOB_COMPANY_NAME";
    JobPostingFormFieldName["JobType"] = "JOB_TYPE";
    JobPostingFormFieldName["Locale"] = "LOCALE";
    JobPostingFormFieldName["Location"] = "LOCATION";
    JobPostingFormFieldName["MultiLocationAdvertising"] = "MULTI_LOCATION_ADVERTISING";
    JobPostingFormFieldName["Occupation"] = "OCCUPATION";
    JobPostingFormFieldName["Pay"] = "PAY";
    JobPostingFormFieldName["Qualifications"] = "QUALIFICATIONS";
    JobPostingFormFieldName["RelocationOptions"] = "RELOCATION_OPTIONS";
    JobPostingFormFieldName["Title"] = "TITLE";
    JobPostingFormFieldName["TpiaIntegration"] = "TPIA_INTEGRATION";
    JobPostingFormFieldName["WorkingHours"] = "WORKING_HOURS";
})(JobPostingFormFieldName || (JobPostingFormFieldName = {}));
/** Field source enum indicating where the field data originates from */
export var JobPostingFormFieldSource;
(function (JobPostingFormFieldSource) {
    JobPostingFormFieldSource["ExternalAts"] = "EXTERNAL_ATS";
    JobPostingFormFieldSource["IndeedAts"] = "INDEED_ATS";
})(JobPostingFormFieldSource || (JobPostingFormFieldSource = {}));
export var JobPostingFormFunnelTransitionType;
(function (JobPostingFormFunnelTransitionType) {
    JobPostingFormFunnelTransitionType["Next"] = "NEXT";
    JobPostingFormFunnelTransitionType["PersistOnly"] = "PERSIST_ONLY";
    JobPostingFormFunnelTransitionType["Previous"] = "PREVIOUS";
    JobPostingFormFunnelTransitionType["RedirectToLegacy"] = "REDIRECT_TO_LEGACY";
})(JobPostingFormFunnelTransitionType || (JobPostingFormFunnelTransitionType = {}));
export var JobPostingFormFunnelType;
(function (JobPostingFormFunnelType) {
    JobPostingFormFunnelType["Edit"] = "EDIT";
    JobPostingFormFunnelType["FromScratch"] = "FROM_SCRATCH";
    JobPostingFormFunnelType["HiringEvents"] = "HIRING_EVENTS";
    /** @deprecated Use FROM_SCRATCH instead. MAIN values still exist in DynamoDB and needs to be read correctly. */
    JobPostingFormFunnelType["Main"] = "MAIN";
    JobPostingFormFunnelType["Mobile"] = "MOBILE";
    JobPostingFormFunnelType["Reuse"] = "REUSE";
})(JobPostingFormFunnelType || (JobPostingFormFunnelType = {}));
/** HiresNeeded error codes */
export var JobPostingFormHiresNeededValidationErrorCode;
(function (JobPostingFormHiresNeededValidationErrorCode) {
    JobPostingFormHiresNeededValidationErrorCode["HiresNeededMissingValue"] = "HIRES_NEEDED_MISSING_VALUE";
    JobPostingFormHiresNeededValidationErrorCode["HiresNeededValueTooLarge"] = "HIRES_NEEDED_VALUE_TOO_LARGE";
    JobPostingFormHiresNeededValidationErrorCode["HiresNeededValueTooSmall"] = "HIRES_NEEDED_VALUE_TOO_SMALL";
})(JobPostingFormHiresNeededValidationErrorCode || (JobPostingFormHiresNeededValidationErrorCode = {}));
/** JobCompanyName error codes */
export var JobPostingFormJobCompanyNameValidationErrorCode;
(function (JobPostingFormJobCompanyNameValidationErrorCode) {
    JobPostingFormJobCompanyNameValidationErrorCode["CompanyNameChangeReasonMissingCustomReason"] = "COMPANY_NAME_CHANGE_REASON_MISSING_CUSTOM_REASON";
    JobPostingFormJobCompanyNameValidationErrorCode["CompanyNameChangeReasonMissingValue"] = "COMPANY_NAME_CHANGE_REASON_MISSING_VALUE";
    JobPostingFormJobCompanyNameValidationErrorCode["CompanyNameMissingValue"] = "COMPANY_NAME_MISSING_VALUE";
    JobPostingFormJobCompanyNameValidationErrorCode["CompanyNameTooLong"] = "COMPANY_NAME_TOO_LONG";
})(JobPostingFormJobCompanyNameValidationErrorCode || (JobPostingFormJobCompanyNameValidationErrorCode = {}));
/** JobLocale error codes */
export var JobPostingFormJobLocaleValidationErrorCode;
(function (JobPostingFormJobLocaleValidationErrorCode) {
    JobPostingFormJobLocaleValidationErrorCode["JobLocaleMissingCountry"] = "JOB_LOCALE_MISSING_COUNTRY";
    JobPostingFormJobLocaleValidationErrorCode["JobLocaleMissingLanguage"] = "JOB_LOCALE_MISSING_LANGUAGE";
})(JobPostingFormJobLocaleValidationErrorCode || (JobPostingFormJobLocaleValidationErrorCode = {}));
/** Job origin enum indicating the source of the job posting */
export var JobPostingFormJobOrigin;
(function (JobPostingFormJobOrigin) {
    JobPostingFormJobOrigin["Claimed"] = "CLAIMED";
    JobPostingFormJobOrigin["Hosted"] = "HOSTED";
    JobPostingFormJobOrigin["Unclaimed"] = "UNCLAIMED";
})(JobPostingFormJobOrigin || (JobPostingFormJobOrigin = {}));
/** JobType error codes */
export var JobPostingFormJobTypeValidationErrorCode;
(function (JobPostingFormJobTypeValidationErrorCode) {
    JobPostingFormJobTypeValidationErrorCode["JobTypeMissingSelection"] = "JOB_TYPE_MISSING_SELECTION";
})(JobPostingFormJobTypeValidationErrorCode || (JobPostingFormJobTypeValidationErrorCode = {}));
/** Location error codes */
export var JobPostingFormLocationValidationErrorCode;
(function (JobPostingFormLocationValidationErrorCode) {
    JobPostingFormLocationValidationErrorCode["LocationMissingType"] = "LOCATION_MISSING_TYPE";
    JobPostingFormLocationValidationErrorCode["LocationMissingValue"] = "LOCATION_MISSING_VALUE";
})(JobPostingFormLocationValidationErrorCode || (JobPostingFormLocationValidationErrorCode = {}));
export var JobPostingFormMainFunnelStep;
(function (JobPostingFormMainFunnelStep) {
    JobPostingFormMainFunnelStep["ApplicationSettingsSheet"] = "APPLICATION_SETTINGS_SHEET";
    JobPostingFormMainFunnelStep["BasicSheet"] = "BASIC_SHEET";
    JobPostingFormMainFunnelStep["CompensationDetailsSheet"] = "COMPENSATION_DETAILS_SHEET";
    JobPostingFormMainFunnelStep["DescriptionSheet"] = "DESCRIPTION_SHEET";
    JobPostingFormMainFunnelStep["DetailsSheet"] = "DETAILS_SHEET";
    JobPostingFormMainFunnelStep["HiringGoalsSheet"] = "HIRING_GOALS_SHEET";
    JobPostingFormMainFunnelStep["JobPublished"] = "JOB_PUBLISHED";
    JobPostingFormMainFunnelStep["QualificationsSheet"] = "QUALIFICATIONS_SHEET";
    JobPostingFormMainFunnelStep["RedirectToLegacy"] = "REDIRECT_TO_LEGACY";
    JobPostingFormMainFunnelStep["ReviewSheet"] = "REVIEW_SHEET";
    JobPostingFormMainFunnelStep["Unknown"] = "UNKNOWN";
})(JobPostingFormMainFunnelStep || (JobPostingFormMainFunnelStep = {}));
export var JobPostingFormMobileFunnelStep;
(function (JobPostingFormMobileFunnelStep) {
    JobPostingFormMobileFunnelStep["BenefitsMobileSheet"] = "BENEFITS_MOBILE_SHEET";
    JobPostingFormMobileFunnelStep["GettingStartedMobileSheet"] = "GETTING_STARTED_MOBILE_SHEET";
    JobPostingFormMobileFunnelStep["HiresNeededMobileSheet"] = "HIRES_NEEDED_MOBILE_SHEET";
    JobPostingFormMobileFunnelStep["HiringTimelineMobileSheet"] = "HIRING_TIMELINE_MOBILE_SHEET";
    JobPostingFormMobileFunnelStep["JobDescriptionMobileSheet"] = "JOB_DESCRIPTION_MOBILE_SHEET";
    JobPostingFormMobileFunnelStep["JobDetailsMobileSheet"] = "JOB_DETAILS_MOBILE_SHEET";
    JobPostingFormMobileFunnelStep["JobPublished"] = "JOB_PUBLISHED";
    JobPostingFormMobileFunnelStep["LocationMobileSheet"] = "LOCATION_MOBILE_SHEET";
    JobPostingFormMobileFunnelStep["LocationTypeMobileSheet"] = "LOCATION_TYPE_MOBILE_SHEET";
    JobPostingFormMobileFunnelStep["PayMobileSheet"] = "PAY_MOBILE_SHEET";
    JobPostingFormMobileFunnelStep["RedirectToLegacy"] = "REDIRECT_TO_LEGACY";
    JobPostingFormMobileFunnelStep["ReviewMobileSheet"] = "REVIEW_MOBILE_SHEET";
    JobPostingFormMobileFunnelStep["Unknown"] = "UNKNOWN";
})(JobPostingFormMobileFunnelStep || (JobPostingFormMobileFunnelStep = {}));
/** Most granular location enum */
export var JobPostingFormMostGranularLocation;
(function (JobPostingFormMostGranularLocation) {
    JobPostingFormMostGranularLocation["City"] = "CITY";
    JobPostingFormMostGranularLocation["Nationwide"] = "NATIONWIDE";
    JobPostingFormMostGranularLocation["State"] = "STATE";
    JobPostingFormMostGranularLocation["Street"] = "STREET";
})(JobPostingFormMostGranularLocation || (JobPostingFormMostGranularLocation = {}));
/** Occupation error codes */
export var JobPostingFormOccupationValidationErrorCode;
(function (JobPostingFormOccupationValidationErrorCode) {
    JobPostingFormOccupationValidationErrorCode["JobOccupationCustomLabelTooLong"] = "JOB_OCCUPATION_CUSTOM_LABEL_TOO_LONG";
    JobPostingFormOccupationValidationErrorCode["JobOccupationCustomLabelTooShort"] = "JOB_OCCUPATION_CUSTOM_LABEL_TOO_SHORT";
})(JobPostingFormOccupationValidationErrorCode || (JobPostingFormOccupationValidationErrorCode = {}));
/** Compensation type specifying what the pay represents. */
export var JobPostingFormPayCompensationType;
(function (JobPostingFormPayCompensationType) {
    /** The pay is explicitly specified as base pay only. */
    JobPostingFormPayCompensationType["BasePay"] = "BASE_PAY";
    /** The pay represents projected total compensation (including bonuses, equity, etc.). */
    JobPostingFormPayCompensationType["ProjectedTotalComp"] = "PROJECTED_TOTAL_COMP";
})(JobPostingFormPayCompensationType || (JobPostingFormPayCompensationType = {}));
/** Pay input type. */
export var JobPostingFormPayType;
(function (JobPostingFormPayType) {
    JobPostingFormPayType["ExactAmount"] = "EXACT_AMOUNT";
    JobPostingFormPayType["MaximumAmount"] = "MAXIMUM_AMOUNT";
    JobPostingFormPayType["Range"] = "RANGE";
    JobPostingFormPayType["StartingAmount"] = "STARTING_AMOUNT";
})(JobPostingFormPayType || (JobPostingFormPayType = {}));
/** Pay error codes */
export var JobPostingFormPayValidationErrorCode;
(function (JobPostingFormPayValidationErrorCode) {
    JobPostingFormPayValidationErrorCode["PayBelowMinimumWage"] = "PAY_BELOW_MINIMUM_WAGE";
    JobPostingFormPayValidationErrorCode["PayFixedOvertimeWithoutSalary"] = "PAY_FIXED_OVERTIME_WITHOUT_SALARY";
    JobPostingFormPayValidationErrorCode["PayIncompleteRange"] = "PAY_INCOMPLETE_RANGE";
    JobPostingFormPayValidationErrorCode["PayInvalidRange"] = "PAY_INVALID_RANGE";
    JobPostingFormPayValidationErrorCode["PayMaximumInvalidFormat"] = "PAY_MAXIMUM_INVALID_FORMAT";
    JobPostingFormPayValidationErrorCode["PayMaximumValueTooLarge"] = "PAY_MAXIMUM_VALUE_TOO_LARGE";
    JobPostingFormPayValidationErrorCode["PayMaximumZeroValue"] = "PAY_MAXIMUM_ZERO_VALUE";
    JobPostingFormPayValidationErrorCode["PayMaximumZeroValueInRange"] = "PAY_MAXIMUM_ZERO_VALUE_IN_RANGE";
    JobPostingFormPayValidationErrorCode["PayMinimumInvalidFormat"] = "PAY_MINIMUM_INVALID_FORMAT";
    JobPostingFormPayValidationErrorCode["PayMinimumValueTooLarge"] = "PAY_MINIMUM_VALUE_TOO_LARGE";
    JobPostingFormPayValidationErrorCode["PayMinimumZeroValue"] = "PAY_MINIMUM_ZERO_VALUE";
    JobPostingFormPayValidationErrorCode["PayMinimumZeroValueInRange"] = "PAY_MINIMUM_ZERO_VALUE_IN_RANGE";
    JobPostingFormPayValidationErrorCode["PayMissingRequiredReviewJob"] = "PAY_MISSING_REQUIRED_REVIEW_JOB";
    JobPostingFormPayValidationErrorCode["PayMissingRequiredWithConsent"] = "PAY_MISSING_REQUIRED_WITH_CONSENT";
    JobPostingFormPayValidationErrorCode["PayRequiredSalaryForJobType"] = "PAY_REQUIRED_SALARY_FOR_JOB_TYPE";
})(JobPostingFormPayValidationErrorCode || (JobPostingFormPayValidationErrorCode = {}));
/** Relocation Options error codes */
export var JobPostingFormRelocationOptionsValidationErrorCode;
(function (JobPostingFormRelocationOptionsValidationErrorCode) {
    JobPostingFormRelocationOptionsValidationErrorCode["None"] = "NONE";
})(JobPostingFormRelocationOptionsValidationErrorCode || (JobPostingFormRelocationOptionsValidationErrorCode = {}));
export var JobPostingFormReuseFunnelStep;
(function (JobPostingFormReuseFunnelStep) {
    JobPostingFormReuseFunnelStep["JobPublished"] = "JOB_PUBLISHED";
    JobPostingFormReuseFunnelStep["RedirectToLegacy"] = "REDIRECT_TO_LEGACY";
    JobPostingFormReuseFunnelStep["ReuseTemplate"] = "REUSE_TEMPLATE";
    JobPostingFormReuseFunnelStep["ReviewSheet"] = "REVIEW_SHEET";
    JobPostingFormReuseFunnelStep["Unknown"] = "UNKNOWN";
})(JobPostingFormReuseFunnelStep || (JobPostingFormReuseFunnelStep = {}));
/** Location Role Type */
export var JobPostingFormRoleLocationType;
(function (JobPostingFormRoleLocationType) {
    JobPostingFormRoleLocationType["HybridRemote"] = "HYBRID_REMOTE";
    JobPostingFormRoleLocationType["MultipleLocations"] = "MULTIPLE_LOCATIONS";
    JobPostingFormRoleLocationType["OneLocation"] = "ONE_LOCATION";
    JobPostingFormRoleLocationType["OnTheRoad"] = "ON_THE_ROAD";
    JobPostingFormRoleLocationType["PreciseOrGeneral"] = "PRECISE_OR_GENERAL";
    JobPostingFormRoleLocationType["RemoteWorkFromHome"] = "REMOTE_WORK_FROM_HOME";
})(JobPostingFormRoleLocationType || (JobPostingFormRoleLocationType = {}));
/** Title error codes */
export var JobPostingFormTitleValidationErrorCode;
(function (JobPostingFormTitleValidationErrorCode) {
    JobPostingFormTitleValidationErrorCode["JobTitleMissingValue"] = "JOB_TITLE_MISSING_VALUE";
    JobPostingFormTitleValidationErrorCode["JobTitleTooLong"] = "JOB_TITLE_TOO_LONG";
    JobPostingFormTitleValidationErrorCode["JobTitleUnsupportedCharacters"] = "JOB_TITLE_UNSUPPORTED_CHARACTERS";
})(JobPostingFormTitleValidationErrorCode || (JobPostingFormTitleValidationErrorCode = {}));
/** TPIA Integration validation error codes. */
export var JobPostingFormTpiaIntegrationValidationErrorCode;
(function (JobPostingFormTpiaIntegrationValidationErrorCode) {
    /**
     * One or more email addresses have invalid format.
     * All email addresses must be valid email format.
     */
    JobPostingFormTpiaIntegrationValidationErrorCode["TpiaEmailsInvalidFormat"] = "TPIA_EMAILS_INVALID_FORMAT";
    /**
     * Emails are required when enrollmentRequest is OPT_IN.
     * At least one valid email address must be provided for enrollment notifications.
     */
    JobPostingFormTpiaIntegrationValidationErrorCode["TpiaEmailsRequiredForOptIn"] = "TPIA_EMAILS_REQUIRED_FOR_OPT_IN";
})(JobPostingFormTpiaIntegrationValidationErrorCode || (JobPostingFormTpiaIntegrationValidationErrorCode = {}));
export var JobPostingFormTransitionSheetOverride;
(function (JobPostingFormTransitionSheetOverride) {
    JobPostingFormTransitionSheetOverride["ApplicationSettingsSheet"] = "APPLICATION_SETTINGS_SHEET";
    JobPostingFormTransitionSheetOverride["BasicSheet"] = "BASIC_SHEET";
    JobPostingFormTransitionSheetOverride["BenefitsMobileSheet"] = "BENEFITS_MOBILE_SHEET";
    JobPostingFormTransitionSheetOverride["CompensationDetailsSheet"] = "COMPENSATION_DETAILS_SHEET";
    JobPostingFormTransitionSheetOverride["DescriptionSheet"] = "DESCRIPTION_SHEET";
    JobPostingFormTransitionSheetOverride["DetailsSheet"] = "DETAILS_SHEET";
    JobPostingFormTransitionSheetOverride["GettingStartedMobileSheet"] = "GETTING_STARTED_MOBILE_SHEET";
    JobPostingFormTransitionSheetOverride["HiresNeededMobileSheet"] = "HIRES_NEEDED_MOBILE_SHEET";
    JobPostingFormTransitionSheetOverride["HiringGoalsSheet"] = "HIRING_GOALS_SHEET";
    JobPostingFormTransitionSheetOverride["HiringTimelineMobileSheet"] = "HIRING_TIMELINE_MOBILE_SHEET";
    JobPostingFormTransitionSheetOverride["JobDescriptionMobileSheet"] = "JOB_DESCRIPTION_MOBILE_SHEET";
    JobPostingFormTransitionSheetOverride["JobDetailsMobileSheet"] = "JOB_DETAILS_MOBILE_SHEET";
    JobPostingFormTransitionSheetOverride["LocationMobileSheet"] = "LOCATION_MOBILE_SHEET";
    JobPostingFormTransitionSheetOverride["LocationTypeMobileSheet"] = "LOCATION_TYPE_MOBILE_SHEET";
    JobPostingFormTransitionSheetOverride["PayMobileSheet"] = "PAY_MOBILE_SHEET";
    JobPostingFormTransitionSheetOverride["QualificationsSheet"] = "QUALIFICATIONS_SHEET";
    JobPostingFormTransitionSheetOverride["ReviewMobileSheet"] = "REVIEW_MOBILE_SHEET";
    JobPostingFormTransitionSheetOverride["ReviewSheet"] = "REVIEW_SHEET";
})(JobPostingFormTransitionSheetOverride || (JobPostingFormTransitionSheetOverride = {}));
/** Work location type enum */
export var JobPostingFormWorkLocationType;
(function (JobPostingFormWorkLocationType) {
    JobPostingFormWorkLocationType["ExactLocation"] = "EXACT_LOCATION";
    JobPostingFormWorkLocationType["MultiOrNoLocation"] = "MULTI_OR_NO_LOCATION";
    JobPostingFormWorkLocationType["OneMileRadius"] = "ONE_MILE_RADIUS";
})(JobPostingFormWorkLocationType || (JobPostingFormWorkLocationType = {}));
/** Working Hours range type. */
export var JobPostingFormWorkingHoursRangeType;
(function (JobPostingFormWorkingHoursRangeType) {
    /** Fixed working hours */
    JobPostingFormWorkingHoursRangeType["FixedHours"] = "FIXED_HOURS";
    /** Maximum working hours */
    JobPostingFormWorkingHoursRangeType["Maximum"] = "MAXIMUM";
    /** Minimum working hours */
    JobPostingFormWorkingHoursRangeType["Minimum"] = "MINIMUM";
    /** Working hours range */
    JobPostingFormWorkingHoursRangeType["Range"] = "RANGE";
})(JobPostingFormWorkingHoursRangeType || (JobPostingFormWorkingHoursRangeType = {}));
/** WorkingHours error codes */
export var JobPostingFormWorkingHoursValidationErrorCode;
(function (JobPostingFormWorkingHoursValidationErrorCode) {
    JobPostingFormWorkingHoursValidationErrorCode["WorkingHoursIncompleteRange"] = "WORKING_HOURS_INCOMPLETE_RANGE";
    JobPostingFormWorkingHoursValidationErrorCode["WorkingHoursMaxExceedsMaxAllowed"] = "WORKING_HOURS_MAX_EXCEEDS_MAX_ALLOWED";
    JobPostingFormWorkingHoursValidationErrorCode["WorkingHoursMaxNegativeValue"] = "WORKING_HOURS_MAX_NEGATIVE_VALUE";
    JobPostingFormWorkingHoursValidationErrorCode["WorkingHoursMaxTooManyDecimalPlaces"] = "WORKING_HOURS_MAX_TOO_MANY_DECIMAL_PLACES";
    JobPostingFormWorkingHoursValidationErrorCode["WorkingHoursMinExceedsMaxAllowed"] = "WORKING_HOURS_MIN_EXCEEDS_MAX_ALLOWED";
    JobPostingFormWorkingHoursValidationErrorCode["WorkingHoursMinGreaterThanMax"] = "WORKING_HOURS_MIN_GREATER_THAN_MAX";
    JobPostingFormWorkingHoursValidationErrorCode["WorkingHoursMinNegativeValue"] = "WORKING_HOURS_MIN_NEGATIVE_VALUE";
    JobPostingFormWorkingHoursValidationErrorCode["WorkingHoursMinTooManyDecimalPlaces"] = "WORKING_HOURS_MIN_TOO_MANY_DECIMAL_PLACES";
})(JobPostingFormWorkingHoursValidationErrorCode || (JobPostingFormWorkingHoursValidationErrorCode = {}));
export var JobPricingModel;
(function (JobPricingModel) {
    JobPricingModel["Ppc"] = "PPC";
})(JobPricingModel || (JobPricingModel = {}));
/** Job requirements */
export var JobRequirement;
(function (JobRequirement) {
    /** Hidden on the application form. */
    JobRequirement["No"] = "NO";
    /** Optional field on the application form. Job seekers can skip. */
    JobRequirement["Optional"] = "OPTIONAL";
    /** Required field on the application form. */
    JobRequirement["Yes"] = "YES";
})(JobRequirement || (JobRequirement = {}));
export var JobRequirementCategory;
(function (JobRequirementCategory) {
    JobRequirementCategory["Certificate"] = "CERTIFICATE";
    JobRequirementCategory["Credential"] = "CREDENTIAL";
    JobRequirementCategory["Education"] = "EDUCATION";
    JobRequirementCategory["License"] = "LICENSE";
    JobRequirementCategory["Skill"] = "SKILL";
})(JobRequirementCategory || (JobRequirementCategory = {}));
/**  Enum that corresponds to the options available when selecting job requirements  */
export var JobRequirementType;
(function (JobRequirementType) {
    JobRequirementType["MustHave"] = "MUST_HAVE";
    JobRequirementType["NiceToHave"] = "NICE_TO_HAVE";
})(JobRequirementType || (JobRequirementType = {}));
/** Salary period for the job. */
export var JobSalaryPeriod;
(function (JobSalaryPeriod) {
    JobSalaryPeriod["Day"] = "DAY";
    JobSalaryPeriod["Hour"] = "HOUR";
    JobSalaryPeriod["Mile"] = "MILE";
    JobSalaryPeriod["Month"] = "MONTH";
    JobSalaryPeriod["Week"] = "WEEK";
    JobSalaryPeriod["Year"] = "YEAR";
})(JobSalaryPeriod || (JobSalaryPeriod = {}));
/** The job's salary range type */
export var JobSalaryRangeType;
(function (JobSalaryRangeType) {
    JobSalaryRangeType["ExactRate"] = "EXACT_RATE";
    JobSalaryRangeType["Range"] = "RANGE";
    JobSalaryRangeType["StartingAt"] = "STARTING_AT";
    JobSalaryRangeType["UpTo"] = "UP_TO";
})(JobSalaryRangeType || (JobSalaryRangeType = {}));
export var JobSearchDistanceUnit;
(function (JobSearchDistanceUnit) {
    JobSearchDistanceUnit["Kilometers"] = "KILOMETERS";
    JobSearchDistanceUnit["Miles"] = "MILES";
})(JobSearchDistanceUnit || (JobSearchDistanceUnit = {}));
export var JobSearchFilterOperation;
(function (JobSearchFilterOperation) {
    JobSearchFilterOperation["And"] = "AND";
    JobSearchFilterOperation["Or"] = "OR";
})(JobSearchFilterOperation || (JobSearchFilterOperation = {}));
export var JobSearchIncludeSponsoredResults;
(function (JobSearchIncludeSponsoredResults) {
    /**
     * Request returning only sponsored jobs.
     *
     * **Caveat**: This value is trying the best effort to return only sponsored jobs. Results could possibly contain
     * organic jobs. Clients must be able to handle organic jobs in the results. This will be fixed in JRS-1163.
     */
    JobSearchIncludeSponsoredResults["All"] = "ALL";
    /** Return a mix of organic and sponsored jobs in the results. */
    JobSearchIncludeSponsoredResults["Mixed"] = "MIXED";
    /** Do not return any sponsored job. */
    JobSearchIncludeSponsoredResults["None"] = "NONE";
})(JobSearchIncludeSponsoredResults || (JobSearchIncludeSponsoredResults = {}));
export var JobSearchKeywordFilterMatch;
(function (JobSearchKeywordFilterMatch) {
    JobSearchKeywordFilterMatch["Must"] = "MUST";
    JobSearchKeywordFilterMatch["MustNot"] = "MUST_NOT";
})(JobSearchKeywordFilterMatch || (JobSearchKeywordFilterMatch = {}));
export var JobSearchKeywordFilterOperation;
(function (JobSearchKeywordFilterOperation) {
    JobSearchKeywordFilterOperation["And"] = "AND";
    JobSearchKeywordFilterOperation["Or"] = "OR";
})(JobSearchKeywordFilterOperation || (JobSearchKeywordFilterOperation = {}));
export var JobSearchOriginType;
(function (JobSearchOriginType) {
    /** This request is generated programmatically, for example providing additional recommendations. */
    JobSearchOriginType["Generated"] = "GENERATED";
    /** This request is generated by a user action, such as a what-where interface or refine-by. */
    JobSearchOriginType["UserInput"] = "USER_INPUT";
})(JobSearchOriginType || (JobSearchOriginType = {}));
export var JobSearchResultGroupByRelation;
(function (JobSearchResultGroupByRelation) {
    /**
     * Group by employer and location and count unique titles.
     * Other differences, such as shift, are ignored.
     */
    JobSearchResultGroupByRelation["EmployerLocation"] = "EMPLOYER_LOCATION";
    /**
     * Group by employer and title and count unique locations.
     * Other differences, such as shift, are ignored.
     */
    JobSearchResultGroupByRelation["EmployerTitle"] = "EMPLOYER_TITLE";
    /**
     * Disable grouping.
     * For jobSearch typically used when setting `grouping.key` to show all job positions regardless of unique company, location, and title.
     */
    JobSearchResultGroupByRelation["None"] = "NONE";
    /** Group by defaulted to IDX. Grouping controlled by idxsimilarjobtst */
    JobSearchResultGroupByRelation["Recommended"] = "RECOMMENDED";
    /** Group by title, company, and location. */
    JobSearchResultGroupByRelation["TitleCompanyLocation"] = "TITLE_COMPANY_LOCATION";
})(JobSearchResultGroupByRelation || (JobSearchResultGroupByRelation = {}));
export var JobSearchSortOrder;
(function (JobSearchSortOrder) {
    /** Sorts jobs by their application due date in an ascending order. If two jobs have the same application due date, they are sorted by relevance. */
    JobSearchSortOrder["ApplicationDueDate"] = "APPLICATION_DUE_DATE";
    /**
     * Most recently published jobs first. When a single search result contains jobs with equivalent publish dates (see
     * dateOnIndeed) these jobs are sorted by relevance.
     *
     * Sorting by relevance takes effect when jobs are
     * - less than or equal to 6 hours : are considered equal
     * - less than 1 day               : are sorted by 6 hour buckets
     * - less than 1 week              : are sorted by day
     * - greater than 1 week           : are sorted by week
     */
    JobSearchSortOrder["Date"] = "DATE";
    /** Most relevant jobs based on search criteria and user personalization */
    JobSearchSortOrder["Relevance"] = "RELEVANCE";
    /** Sorts jobs by their shift start time. When shift start time is not available, relevance will be used to sort jobs. */
    JobSearchSortOrder["ShiftStart"] = "SHIFT_START";
})(JobSearchSortOrder || (JobSearchSortOrder = {}));
export var JobSeekerAssessmentPassingScoreType;
(function (JobSeekerAssessmentPassingScoreType) {
    JobSeekerAssessmentPassingScoreType["Failed"] = "FAILED";
    JobSeekerAssessmentPassingScoreType["NotApplicable"] = "NOT_APPLICABLE";
    JobSeekerAssessmentPassingScoreType["Passed"] = "PASSED";
    JobSeekerAssessmentPassingScoreType["UnknownPassingScoreType"] = "UNKNOWN_PASSING_SCORE_TYPE";
})(JobSeekerAssessmentPassingScoreType || (JobSeekerAssessmentPassingScoreType = {}));
export var JobSeekerCertificationType;
(function (JobSeekerCertificationType) {
    JobSeekerCertificationType["AccountingLicenseCertification"] = "ACCOUNTING_LICENSE_CERTIFICATION";
    JobSeekerCertificationType["DriversLicenseCertification"] = "DRIVERS_LICENSE_CERTIFICATION";
    JobSeekerCertificationType["Endorsements"] = "ENDORSEMENTS";
    JobSeekerCertificationType["NursesLicenseCertification"] = "NURSES_LICENSE_CERTIFICATION";
    JobSeekerCertificationType["TitleAndExpirationDate"] = "TITLE_AND_EXPIRATION_DATE";
    JobSeekerCertificationType["UnknownCertificationType"] = "UNKNOWN_CERTIFICATION_TYPE";
})(JobSeekerCertificationType || (JobSeekerCertificationType = {}));
export var JobSeekerDocumentEventType;
(function (JobSeekerDocumentEventType) {
    /** Jobseeker accepted/signed the disclosure document. */
    JobSeekerDocumentEventType["DisclosureAccepted"] = "DISCLOSURE_ACCEPTED";
    /** Jobseeker was shown the disclosure document. */
    JobSeekerDocumentEventType["DisclosureShown"] = "DISCLOSURE_SHOWN";
})(JobSeekerDocumentEventType || (JobSeekerDocumentEventType = {}));
export var JobSeekerHighQualityMarketplaceOptInStatus;
(function (JobSeekerHighQualityMarketplaceOptInStatus) {
    JobSeekerHighQualityMarketplaceOptInStatus["Declined"] = "DECLINED";
    JobSeekerHighQualityMarketplaceOptInStatus["ExitedFlow"] = "EXITED_FLOW";
    JobSeekerHighQualityMarketplaceOptInStatus["OptedIn"] = "OPTED_IN";
})(JobSeekerHighQualityMarketplaceOptInStatus || (JobSeekerHighQualityMarketplaceOptInStatus = {}));
export var JobSeekerJobEventClientType;
(function (JobSeekerJobEventClientType) {
    JobSeekerJobEventClientType["Ita"] = "ITA";
    JobSeekerJobEventClientType["Mobile"] = "MOBILE";
    JobSeekerJobEventClientType["UnknownClient"] = "UNKNOWN_CLIENT";
    JobSeekerJobEventClientType["Web"] = "WEB";
})(JobSeekerJobEventClientType || (JobSeekerJobEventClientType = {}));
export var JobSeekerJobSearchCriteriaExperienceLevel;
(function (JobSeekerJobSearchCriteriaExperienceLevel) {
    JobSeekerJobSearchCriteriaExperienceLevel["EntryLevel"] = "ENTRY_LEVEL";
    JobSeekerJobSearchCriteriaExperienceLevel["MidLevel"] = "MID_LEVEL";
    JobSeekerJobSearchCriteriaExperienceLevel["SeniorLevel"] = "SENIOR_LEVEL";
    JobSeekerJobSearchCriteriaExperienceLevel["UnknownExperienceLevel"] = "UNKNOWN_EXPERIENCE_LEVEL";
})(JobSeekerJobSearchCriteriaExperienceLevel || (JobSeekerJobSearchCriteriaExperienceLevel = {}));
export var JobSeekerJobSearchCriteriaRecordType;
(function (JobSeekerJobSearchCriteriaRecordType) {
    JobSeekerJobSearchCriteriaRecordType["RecentSearch"] = "RECENT_SEARCH";
    JobSeekerJobSearchCriteriaRecordType["SavedSearch"] = "SAVED_SEARCH";
    JobSeekerJobSearchCriteriaRecordType["UnknownSearchRecordType"] = "UNKNOWN_SEARCH_RECORD_TYPE";
})(JobSeekerJobSearchCriteriaRecordType || (JobSeekerJobSearchCriteriaRecordType = {}));
export var JobSeekerJobSearchEventRecordOpType;
(function (JobSeekerJobSearchEventRecordOpType) {
    JobSeekerJobSearchEventRecordOpType["AddSearchRecord"] = "ADD_SEARCH_RECORD";
    JobSeekerJobSearchEventRecordOpType["DelSearchRecord"] = "DEL_SEARCH_RECORD";
    JobSeekerJobSearchEventRecordOpType["UnknownSearchRecordOpType"] = "UNKNOWN_SEARCH_RECORD_OP_TYPE";
})(JobSeekerJobSearchEventRecordOpType || (JobSeekerJobSearchEventRecordOpType = {}));
export var JobSeekerLicenseType;
(function (JobSeekerLicenseType) {
    JobSeekerLicenseType["AccountingLicense"] = "ACCOUNTING_LICENSE";
    JobSeekerLicenseType["DriversLicense"] = "DRIVERS_LICENSE";
    JobSeekerLicenseType["NursesLicense"] = "NURSES_LICENSE";
    JobSeekerLicenseType["UnknownLicenseType"] = "UNKNOWN_LICENSE_TYPE";
})(JobSeekerLicenseType || (JobSeekerLicenseType = {}));
/** The status of an action */
export var JobSeekerNextBestActionStatusEnum;
(function (JobSeekerNextBestActionStatusEnum) {
    JobSeekerNextBestActionStatusEnum["Completed"] = "COMPLETED";
    JobSeekerNextBestActionStatusEnum["Expired"] = "EXPIRED";
    JobSeekerNextBestActionStatusEnum["Paused"] = "PAUSED";
    JobSeekerNextBestActionStatusEnum["Pending"] = "PENDING";
})(JobSeekerNextBestActionStatusEnum || (JobSeekerNextBestActionStatusEnum = {}));
export var JobSeekerPortraitIdType;
(function (JobSeekerPortraitIdType) {
    JobSeekerPortraitIdType["AccountId"] = "ACCOUNT_ID";
    JobSeekerPortraitIdType["Ctk"] = "CTK";
})(JobSeekerPortraitIdType || (JobSeekerPortraitIdType = {}));
export var JobSeekerPortraitLatLngPrecisionType;
(function (JobSeekerPortraitLatLngPrecisionType) {
    JobSeekerPortraitLatLngPrecisionType["Address"] = "ADDRESS";
    JobSeekerPortraitLatLngPrecisionType["Admin1"] = "ADMIN1";
    JobSeekerPortraitLatLngPrecisionType["Admin2"] = "ADMIN2";
    JobSeekerPortraitLatLngPrecisionType["Admin3"] = "ADMIN3";
    JobSeekerPortraitLatLngPrecisionType["Admin4"] = "ADMIN4";
    JobSeekerPortraitLatLngPrecisionType["City"] = "CITY";
    JobSeekerPortraitLatLngPrecisionType["Country"] = "COUNTRY";
    JobSeekerPortraitLatLngPrecisionType["None"] = "NONE";
    JobSeekerPortraitLatLngPrecisionType["Place"] = "PLACE";
    JobSeekerPortraitLatLngPrecisionType["Postal"] = "POSTAL";
    JobSeekerPortraitLatLngPrecisionType["Station"] = "STATION";
    JobSeekerPortraitLatLngPrecisionType["Zipcode"] = "ZIPCODE";
})(JobSeekerPortraitLatLngPrecisionType || (JobSeekerPortraitLatLngPrecisionType = {}));
export var JobSeekerProStatus;
(function (JobSeekerProStatus) {
    /** JS is eligible to enable pro features */
    JobSeekerProStatus["Eligible"] = "ELIGIBLE";
    /** JS has enabled pro features */
    JobSeekerProStatus["Enabled"] = "ENABLED";
    /** JS is not eligible to enable pro features */
    JobSeekerProStatus["Ineligible"] = "INELIGIBLE";
})(JobSeekerProStatus || (JobSeekerProStatus = {}));
/** A Job Seeker's assessment completion status */
export var JobSeekerProfileAssignmentCompleteStatus;
(function (JobSeekerProfileAssignmentCompleteStatus) {
    JobSeekerProfileAssignmentCompleteStatus["Complete"] = "COMPLETE";
    JobSeekerProfileAssignmentCompleteStatus["Incomplete"] = "INCOMPLETE";
})(JobSeekerProfileAssignmentCompleteStatus || (JobSeekerProfileAssignmentCompleteStatus = {}));
/** A Job Seeker's assessment confirmation modal status */
export var JobSeekerProfileAssignmentConfirmationModalStatus;
(function (JobSeekerProfileAssignmentConfirmationModalStatus) {
    JobSeekerProfileAssignmentConfirmationModalStatus["Acknowledged"] = "ACKNOWLEDGED";
    JobSeekerProfileAssignmentConfirmationModalStatus["Dismissed"] = "DISMISSED";
    JobSeekerProfileAssignmentConfirmationModalStatus["Display"] = "DISPLAY";
})(JobSeekerProfileAssignmentConfirmationModalStatus || (JobSeekerProfileAssignmentConfirmationModalStatus = {}));
/**
 * Enum for context in which the user will be presented question fields. More details about each context can be found at
 * https://wiki.indeed.com/pages/viewpage.action?pageId=640782839#PDCS(PersonalizedDataCollectionServiceDaemon)-Clients.
 */
export var JobSeekerProfileContextSource;
(function (JobSeekerProfileContextSource) {
    /** Glassdoor Lightweight Data Collection tool that will be shown on multiple GlassDoor surfaces */
    JobSeekerProfileContextSource["GlassdoorLdc"] = "GLASSDOOR_LDC";
    /**
     * Indeed Apply Segment Questions allows job seekers to add relevant qualifications to their resume before applying
     * to a job.
     */
    JobSeekerProfileContextSource["IndeedApplyMoc"] = "INDEED_APPLY_MOC";
    /**
     * Indeed Apply Segment Questions allows job seekers to add relevant qualifications to their resume before applying
     * to a job.
     */
    JobSeekerProfileContextSource["IndeedApplySegmentQuestions"] = "INDEED_APPLY_SEGMENT_QUESTIONS";
    /** Indeed Apply Yellow Light Questions are interventions for low quality job applications. */
    JobSeekerProfileContextSource["IndeedApplyYlq"] = "INDEED_APPLY_YLQ";
    /** Job Seeker Mobile App Onboarding is the experience for a job seeker after installing the mobile app. */
    JobSeekerProfileContextSource["JsmaOnboarding"] = "JSMA_ONBOARDING";
    /** Profile micro content card shown on multiple page sources aka surfaces. */
    JobSeekerProfileContextSource["Microcontent"] = "MICROCONTENT";
    /** Job Seeker Onboarding is the experience for a job seeker after creating a new profile. */
    JobSeekerProfileContextSource["ProfileOnboarding"] = "PROFILE_ONBOARDING";
    /** Resume builder */
    JobSeekerProfileContextSource["ResumeBuilder"] = "RESUME_BUILDER";
    /** This is the value of the surface when we query the list of eligible questions, for the purpose of blocking VJP if the JS is not yet a high quality profile */
    JobSeekerProfileContextSource["VjpGating"] = "VJP_GATING";
})(JobSeekerProfileContextSource || (JobSeekerProfileContextSource = {}));
/** A Job Seeker's employment eligibility */
export var JobSeekerProfileEmploymentEligibility;
(function (JobSeekerProfileEmploymentEligibility) {
    JobSeekerProfileEmploymentEligibility["Eligible"] = "ELIGIBLE";
    JobSeekerProfileEmploymentEligibility["Ineligible"] = "INELIGIBLE";
    JobSeekerProfileEmploymentEligibility["Unknown"] = "UNKNOWN";
    JobSeekerProfileEmploymentEligibility["WithSponsorship"] = "WITH_SPONSORSHIP";
})(JobSeekerProfileEmploymentEligibility || (JobSeekerProfileEmploymentEligibility = {}));
/** Type of file uploaded by a job seeker */
export var JobSeekerProfileFileType;
(function (JobSeekerProfileFileType) {
    JobSeekerProfileFileType["CoverLetter"] = "COVER_LETTER";
    JobSeekerProfileFileType["CredentialDocument"] = "CREDENTIAL_DOCUMENT";
    JobSeekerProfileFileType["ProfilePhoto"] = "PROFILE_PHOTO";
    JobSeekerProfileFileType["Resume"] = "RESUME";
    JobSeekerProfileFileType["ResumeConverted"] = "RESUME_CONVERTED";
})(JobSeekerProfileFileType || (JobSeekerProfileFileType = {}));
/** A Job Seeker's fraud metadata state. */
export var JobSeekerProfileFraudMetadataState;
(function (JobSeekerProfileFraudMetadataState) {
    JobSeekerProfileFraudMetadataState["IsFraud"] = "IS_FRAUD";
    JobSeekerProfileFraudMetadataState["IsLegit"] = "IS_LEGIT";
})(JobSeekerProfileFraudMetadataState || (JobSeekerProfileFraudMetadataState = {}));
/** A location geocode precision for example COUNTRY, CITY. */
export var JobSeekerProfileGeocodePrecision;
(function (JobSeekerProfileGeocodePrecision) {
    JobSeekerProfileGeocodePrecision["Address"] = "ADDRESS";
    JobSeekerProfileGeocodePrecision["Admin1"] = "ADMIN1";
    JobSeekerProfileGeocodePrecision["Admin2"] = "ADMIN2";
    JobSeekerProfileGeocodePrecision["Admin3"] = "ADMIN3";
    JobSeekerProfileGeocodePrecision["Admin4"] = "ADMIN4";
    JobSeekerProfileGeocodePrecision["City"] = "CITY";
    JobSeekerProfileGeocodePrecision["Country"] = "COUNTRY";
    JobSeekerProfileGeocodePrecision["Postal"] = "POSTAL";
})(JobSeekerProfileGeocodePrecision || (JobSeekerProfileGeocodePrecision = {}));
/** A job seeker's merge status for the Glassdoor One Account One Profile feature */
export var JobSeekerProfileGlassdoorMergeStatus;
(function (JobSeekerProfileGlassdoorMergeStatus) {
    JobSeekerProfileGlassdoorMergeStatus["Merged"] = "MERGED";
    JobSeekerProfileGlassdoorMergeStatus["NotApplicable"] = "NOT_APPLICABLE";
    JobSeekerProfileGlassdoorMergeStatus["Reviewed"] = "REVIEWED";
})(JobSeekerProfileGlassdoorMergeStatus || (JobSeekerProfileGlassdoorMergeStatus = {}));
/** Citizenship type of this job seeker */
export var JobSeekerProfileInternationalCitizenship;
(function (JobSeekerProfileInternationalCitizenship) {
    JobSeekerProfileInternationalCitizenship["Citizen"] = "CITIZEN";
    JobSeekerProfileInternationalCitizenship["Filipino"] = "FILIPINO";
    JobSeekerProfileInternationalCitizenship["NoneOfTheAbove"] = "NONE_OF_THE_ABOVE";
    JobSeekerProfileInternationalCitizenship["NonFilipino"] = "NON_FILIPINO";
    JobSeekerProfileInternationalCitizenship["NotCitizenNoWorkPermit"] = "NOT_CITIZEN_NO_WORK_PERMIT";
    JobSeekerProfileInternationalCitizenship["NotCitizenWithWorkPermit"] = "NOT_CITIZEN_WITH_WORK_PERMIT";
    JobSeekerProfileInternationalCitizenship["SgNational"] = "SG_NATIONAL";
    JobSeekerProfileInternationalCitizenship["SgPermanentResident"] = "SG_PERMANENT_RESIDENT";
})(JobSeekerProfileInternationalCitizenship || (JobSeekerProfileInternationalCitizenship = {}));
/** Types of disabilities this job seeker wants to include in their resume */
export var JobSeekerProfileInternationalDisability;
(function (JobSeekerProfileInternationalDisability) {
    JobSeekerProfileInternationalDisability["Cognitive"] = "COGNITIVE";
    JobSeekerProfileInternationalDisability["Multiple"] = "MULTIPLE";
    JobSeekerProfileInternationalDisability["No"] = "NO";
    JobSeekerProfileInternationalDisability["Other"] = "OTHER";
    JobSeekerProfileInternationalDisability["Physical"] = "PHYSICAL";
    JobSeekerProfileInternationalDisability["Speech"] = "SPEECH";
    JobSeekerProfileInternationalDisability["Vision"] = "VISION";
    JobSeekerProfileInternationalDisability["Yes"] = "YES";
})(JobSeekerProfileInternationalDisability || (JobSeekerProfileInternationalDisability = {}));
/** A job seeker's driver's license listed in their resume */
export var JobSeekerProfileInternationalDriversLicense;
(function (JobSeekerProfileInternationalDriversLicense) {
    JobSeekerProfileInternationalDriversLicense["A"] = "A";
    JobSeekerProfileInternationalDriversLicense["A1"] = "A1";
    JobSeekerProfileInternationalDriversLicense["A2"] = "A2";
    JobSeekerProfileInternationalDriversLicense["Adr"] = "ADR";
    JobSeekerProfileInternationalDriversLicense["AdrCisternas"] = "ADR_CISTERNAS";
    JobSeekerProfileInternationalDriversLicense["AdrExplosivos"] = "ADR_EXPLOSIVOS";
    JobSeekerProfileInternationalDriversLicense["AdrRadioactivas"] = "ADR_RADIOACTIVAS";
    JobSeekerProfileInternationalDriversLicense["AgricultureVehicles"] = "AGRICULTURE_VEHICLES";
    JobSeekerProfileInternationalDriversLicense["Am"] = "AM";
    JobSeekerProfileInternationalDriversLicense["B"] = "B";
    JobSeekerProfileInternationalDriversLicense["B1"] = "B1";
    JobSeekerProfileInternationalDriversLicense["Be"] = "BE";
    JobSeekerProfileInternationalDriversLicense["Buses"] = "BUSES";
    JobSeekerProfileInternationalDriversLicense["BAuto"] = "B_AUTO";
    JobSeekerProfileInternationalDriversLicense["BPlusE"] = "B_PLUS_E";
    JobSeekerProfileInternationalDriversLicense["C"] = "C";
    JobSeekerProfileInternationalDriversLicense["C1"] = "C1";
    JobSeekerProfileInternationalDriversLicense["C1E"] = "C1E";
    JobSeekerProfileInternationalDriversLicense["C1PlusE"] = "C1_PLUS_E";
    JobSeekerProfileInternationalDriversLicense["Cap"] = "CAP";
    JobSeekerProfileInternationalDriversLicense["CargoOrTrucks"] = "CARGO_OR_TRUCKS";
    JobSeekerProfileInternationalDriversLicense["Cars"] = "CARS";
    JobSeekerProfileInternationalDriversLicense["Ce"] = "CE";
    JobSeekerProfileInternationalDriversLicense["Cfp"] = "CFP";
    JobSeekerProfileInternationalDriversLicense["Cqc"] = "CQC";
    JobSeekerProfileInternationalDriversLicense["CPlusE"] = "C_PLUS_E";
    JobSeekerProfileInternationalDriversLicense["D"] = "D";
    JobSeekerProfileInternationalDriversLicense["D1"] = "D1";
    JobSeekerProfileInternationalDriversLicense["D1E"] = "D1E";
    JobSeekerProfileInternationalDriversLicense["D1PlusE"] = "D1_PLUS_E";
    JobSeekerProfileInternationalDriversLicense["De"] = "DE";
    JobSeekerProfileInternationalDriversLicense["DPlusE"] = "D_PLUS_E";
    JobSeekerProfileInternationalDriversLicense["E"] = "E";
    JobSeekerProfileInternationalDriversLicense["F"] = "F";
    JobSeekerProfileInternationalDriversLicense["G"] = "G";
    JobSeekerProfileInternationalDriversLicense["H"] = "H";
    JobSeekerProfileInternationalDriversLicense["IndustrialVehicles"] = "INDUSTRIAL_VEHICLES";
    JobSeekerProfileInternationalDriversLicense["InternationalDriversLicense"] = "INTERNATIONAL_DRIVERS_LICENSE";
    JobSeekerProfileInternationalDriversLicense["K"] = "K";
    JobSeekerProfileInternationalDriversLicense["LargeVehicles"] = "LARGE_VEHICLES";
    JobSeekerProfileInternationalDriversLicense["Lcm"] = "LCM";
    JobSeekerProfileInternationalDriversLicense["LightVehicles"] = "LIGHT_VEHICLES";
    JobSeekerProfileInternationalDriversLicense["Lva"] = "LVA";
    JobSeekerProfileInternationalDriversLicense["MediumVehicles"] = "MEDIUM_VEHICLES";
    JobSeekerProfileInternationalDriversLicense["Minibuses"] = "MINIBUSES";
    JobSeekerProfileInternationalDriversLicense["Mopeds"] = "MOPEDS";
    JobSeekerProfileInternationalDriversLicense["Motorcycles"] = "MOTORCYCLES";
    JobSeekerProfileInternationalDriversLicense["No"] = "NO";
    JobSeekerProfileInternationalDriversLicense["None"] = "NONE";
    JobSeekerProfileInternationalDriversLicense["Other"] = "OTHER";
    JobSeekerProfileInternationalDriversLicense["P"] = "P";
    JobSeekerProfileInternationalDriversLicense["Q"] = "Q";
    JobSeekerProfileInternationalDriversLicense["RegularDriversLicense"] = "REGULAR_DRIVERS_LICENSE";
    JobSeekerProfileInternationalDriversLicense["T"] = "T";
    JobSeekerProfileInternationalDriversLicense["Tb"] = "TB";
    JobSeekerProfileInternationalDriversLicense["Tm"] = "TM";
    JobSeekerProfileInternationalDriversLicense["Truckkort"] = "Truckkort";
    JobSeekerProfileInternationalDriversLicense["Yes"] = "YES";
})(JobSeekerProfileInternationalDriversLicense || (JobSeekerProfileInternationalDriversLicense = {}));
/** Describes the eligibility for employment of this job seeker */
export var JobSeekerProfileInternationalEmploymentEligibility;
(function (JobSeekerProfileInternationalEmploymentEligibility) {
    JobSeekerProfileInternationalEmploymentEligibility["Citizen"] = "CITIZEN";
    JobSeekerProfileInternationalEmploymentEligibility["EmploymentPass"] = "EMPLOYMENT_PASS";
    JobSeekerProfileInternationalEmploymentEligibility["No"] = "NO";
    JobSeekerProfileInternationalEmploymentEligibility["Other"] = "OTHER";
    JobSeekerProfileInternationalEmploymentEligibility["Sponsorship"] = "SPONSORSHIP";
    JobSeekerProfileInternationalEmploymentEligibility["TrainingEmploymentPass"] = "TRAINING_EMPLOYMENT_PASS";
    JobSeekerProfileInternationalEmploymentEligibility["Yes"] = "YES";
})(JobSeekerProfileInternationalEmploymentEligibility || (JobSeekerProfileInternationalEmploymentEligibility = {}));
/** A list of country codes used to denote employment eligibility */
export var JobSeekerProfileInternationalEmploymentEligibilityMultiCountries;
(function (JobSeekerProfileInternationalEmploymentEligibilityMultiCountries) {
    JobSeekerProfileInternationalEmploymentEligibilityMultiCountries["Ad"] = "AD";
    JobSeekerProfileInternationalEmploymentEligibilityMultiCountries["Ae"] = "AE";
    JobSeekerProfileInternationalEmploymentEligibilityMultiCountries["Af"] = "AF";
    JobSeekerProfileInternationalEmploymentEligibilityMultiCountries["Ag"] = "AG";
    JobSeekerProfileInternationalEmploymentEligibilityMultiCountries["Ai"] = "AI";
    JobSeekerProfileInternationalEmploymentEligibilityMultiCountries["Al"] = "AL";
    JobSeekerProfileInternationalEmploymentEligibilityMultiCountries["Am"] = "AM";
    JobSeekerProfileInternationalEmploymentEligibilityMultiCountries["An"] = "AN";
    JobSeekerProfileInternationalEmploymentEligibilityMultiCountries["Ao"] = "AO";
    JobSeekerProfileInternationalEmploymentEligibilityMultiCountries["Aq"] = "AQ";
    JobSeekerProfileInternationalEmploymentEligibilityMultiCountries["Ar"] = "AR";
    JobSeekerProfileInternationalEmploymentEligibilityMultiCountries["As"] = "AS";
    JobSeekerProfileInternationalEmploymentEligibilityMultiCountries["At"] = "AT";
    JobSeekerProfileInternationalEmploymentEligibilityMultiCountries["Au"] = "AU";
    JobSeekerProfileInternationalEmploymentEligibilityMultiCountries["Aw"] = "AW";
    JobSeekerProfileInternationalEmploymentEligibilityMultiCountries["Ax"] = "AX";
    JobSeekerProfileInternationalEmploymentEligibilityMultiCountries["Az"] = "AZ";
    JobSeekerProfileInternationalEmploymentEligibilityMultiCountries["Ba"] = "BA";
    JobSeekerProfileInternationalEmploymentEligibilityMultiCountries["Bb"] = "BB";
    JobSeekerProfileInternationalEmploymentEligibilityMultiCountries["Bd"] = "BD";
    JobSeekerProfileInternationalEmploymentEligibilityMultiCountries["Be"] = "BE";
    JobSeekerProfileInternationalEmploymentEligibilityMultiCountries["Bf"] = "BF";
    JobSeekerProfileInternationalEmploymentEligibilityMultiCountries["Bg"] = "BG";
    JobSeekerProfileInternationalEmploymentEligibilityMultiCountries["Bh"] = "BH";
    JobSeekerProfileInternationalEmploymentEligibilityMultiCountries["Bi"] = "BI";
    JobSeekerProfileInternationalEmploymentEligibilityMultiCountries["Bj"] = "BJ";
    JobSeekerProfileInternationalEmploymentEligibilityMultiCountries["Bl"] = "BL";
    JobSeekerProfileInternationalEmploymentEligibilityMultiCountries["Bm"] = "BM";
    JobSeekerProfileInternationalEmploymentEligibilityMultiCountries["Bn"] = "BN";
    JobSeekerProfileInternationalEmploymentEligibilityMultiCountries["Bo"] = "BO";
    JobSeekerProfileInternationalEmploymentEligibilityMultiCountries["Bq"] = "BQ";
    JobSeekerProfileInternationalEmploymentEligibilityMultiCountries["Br"] = "BR";
    JobSeekerProfileInternationalEmploymentEligibilityMultiCountries["Bs"] = "BS";
    JobSeekerProfileInternationalEmploymentEligibilityMultiCountries["Bt"] = "BT";
    JobSeekerProfileInternationalEmploymentEligibilityMultiCountries["Bv"] = "BV";
    JobSeekerProfileInternationalEmploymentEligibilityMultiCountries["Bw"] = "BW";
    JobSeekerProfileInternationalEmploymentEligibilityMultiCountries["By"] = "BY";
    JobSeekerProfileInternationalEmploymentEligibilityMultiCountries["Bz"] = "BZ";
    JobSeekerProfileInternationalEmploymentEligibilityMultiCountries["Ca"] = "CA";
    JobSeekerProfileInternationalEmploymentEligibilityMultiCountries["Cc"] = "CC";
    JobSeekerProfileInternationalEmploymentEligibilityMultiCountries["Cd"] = "CD";
    JobSeekerProfileInternationalEmploymentEligibilityMultiCountries["Cf"] = "CF";
    JobSeekerProfileInternationalEmploymentEligibilityMultiCountries["Cg"] = "CG";
    JobSeekerProfileInternationalEmploymentEligibilityMultiCountries["Ch"] = "CH";
    JobSeekerProfileInternationalEmploymentEligibilityMultiCountries["Ci"] = "CI";
    JobSeekerProfileInternationalEmploymentEligibilityMultiCountries["Ck"] = "CK";
    JobSeekerProfileInternationalEmploymentEligibilityMultiCountries["Cl"] = "CL";
    JobSeekerProfileInternationalEmploymentEligibilityMultiCountries["Cm"] = "CM";
    JobSeekerProfileInternationalEmploymentEligibilityMultiCountries["Cn"] = "CN";
    JobSeekerProfileInternationalEmploymentEligibilityMultiCountries["Co"] = "CO";
    JobSeekerProfileInternationalEmploymentEligibilityMultiCountries["Cr"] = "CR";
    JobSeekerProfileInternationalEmploymentEligibilityMultiCountries["Cu"] = "CU";
    JobSeekerProfileInternationalEmploymentEligibilityMultiCountries["Cv"] = "CV";
    JobSeekerProfileInternationalEmploymentEligibilityMultiCountries["Cw"] = "CW";
    JobSeekerProfileInternationalEmploymentEligibilityMultiCountries["Cx"] = "CX";
    JobSeekerProfileInternationalEmploymentEligibilityMultiCountries["Cy"] = "CY";
    JobSeekerProfileInternationalEmploymentEligibilityMultiCountries["Cz"] = "CZ";
    JobSeekerProfileInternationalEmploymentEligibilityMultiCountries["De"] = "DE";
    JobSeekerProfileInternationalEmploymentEligibilityMultiCountries["Dj"] = "DJ";
    JobSeekerProfileInternationalEmploymentEligibilityMultiCountries["Dk"] = "DK";
    JobSeekerProfileInternationalEmploymentEligibilityMultiCountries["Dm"] = "DM";
    JobSeekerProfileInternationalEmploymentEligibilityMultiCountries["Do"] = "DO";
    JobSeekerProfileInternationalEmploymentEligibilityMultiCountries["Dz"] = "DZ";
    JobSeekerProfileInternationalEmploymentEligibilityMultiCountries["Ec"] = "EC";
    JobSeekerProfileInternationalEmploymentEligibilityMultiCountries["Ee"] = "EE";
    JobSeekerProfileInternationalEmploymentEligibilityMultiCountries["Eg"] = "EG";
    JobSeekerProfileInternationalEmploymentEligibilityMultiCountries["Eh"] = "EH";
    JobSeekerProfileInternationalEmploymentEligibilityMultiCountries["Er"] = "ER";
    JobSeekerProfileInternationalEmploymentEligibilityMultiCountries["Es"] = "ES";
    JobSeekerProfileInternationalEmploymentEligibilityMultiCountries["Et"] = "ET";
    JobSeekerProfileInternationalEmploymentEligibilityMultiCountries["Fi"] = "FI";
    JobSeekerProfileInternationalEmploymentEligibilityMultiCountries["Fj"] = "FJ";
    JobSeekerProfileInternationalEmploymentEligibilityMultiCountries["Fk"] = "FK";
    JobSeekerProfileInternationalEmploymentEligibilityMultiCountries["Fm"] = "FM";
    JobSeekerProfileInternationalEmploymentEligibilityMultiCountries["Fo"] = "FO";
    JobSeekerProfileInternationalEmploymentEligibilityMultiCountries["Fr"] = "FR";
    JobSeekerProfileInternationalEmploymentEligibilityMultiCountries["Ga"] = "GA";
    JobSeekerProfileInternationalEmploymentEligibilityMultiCountries["Gb"] = "GB";
    JobSeekerProfileInternationalEmploymentEligibilityMultiCountries["Gd"] = "GD";
    JobSeekerProfileInternationalEmploymentEligibilityMultiCountries["Ge"] = "GE";
    JobSeekerProfileInternationalEmploymentEligibilityMultiCountries["Gf"] = "GF";
    JobSeekerProfileInternationalEmploymentEligibilityMultiCountries["Gg"] = "GG";
    JobSeekerProfileInternationalEmploymentEligibilityMultiCountries["Gh"] = "GH";
    JobSeekerProfileInternationalEmploymentEligibilityMultiCountries["Gi"] = "GI";
    JobSeekerProfileInternationalEmploymentEligibilityMultiCountries["Gl"] = "GL";
    JobSeekerProfileInternationalEmploymentEligibilityMultiCountries["Gm"] = "GM";
    JobSeekerProfileInternationalEmploymentEligibilityMultiCountries["Gn"] = "GN";
    JobSeekerProfileInternationalEmploymentEligibilityMultiCountries["Gp"] = "GP";
    JobSeekerProfileInternationalEmploymentEligibilityMultiCountries["Gq"] = "GQ";
    JobSeekerProfileInternationalEmploymentEligibilityMultiCountries["Gr"] = "GR";
    JobSeekerProfileInternationalEmploymentEligibilityMultiCountries["Gs"] = "GS";
    JobSeekerProfileInternationalEmploymentEligibilityMultiCountries["Gt"] = "GT";
    JobSeekerProfileInternationalEmploymentEligibilityMultiCountries["Gu"] = "GU";
    JobSeekerProfileInternationalEmploymentEligibilityMultiCountries["Gw"] = "GW";
    JobSeekerProfileInternationalEmploymentEligibilityMultiCountries["Gy"] = "GY";
    JobSeekerProfileInternationalEmploymentEligibilityMultiCountries["Hk"] = "HK";
    JobSeekerProfileInternationalEmploymentEligibilityMultiCountries["Hm"] = "HM";
    JobSeekerProfileInternationalEmploymentEligibilityMultiCountries["Hn"] = "HN";
    JobSeekerProfileInternationalEmploymentEligibilityMultiCountries["Hr"] = "HR";
    JobSeekerProfileInternationalEmploymentEligibilityMultiCountries["Ht"] = "HT";
    JobSeekerProfileInternationalEmploymentEligibilityMultiCountries["Hu"] = "HU";
    JobSeekerProfileInternationalEmploymentEligibilityMultiCountries["Id"] = "ID";
    JobSeekerProfileInternationalEmploymentEligibilityMultiCountries["Ie"] = "IE";
    JobSeekerProfileInternationalEmploymentEligibilityMultiCountries["Il"] = "IL";
    JobSeekerProfileInternationalEmploymentEligibilityMultiCountries["Im"] = "IM";
    JobSeekerProfileInternationalEmploymentEligibilityMultiCountries["In"] = "IN";
    JobSeekerProfileInternationalEmploymentEligibilityMultiCountries["Io"] = "IO";
    JobSeekerProfileInternationalEmploymentEligibilityMultiCountries["Iq"] = "IQ";
    JobSeekerProfileInternationalEmploymentEligibilityMultiCountries["Ir"] = "IR";
    JobSeekerProfileInternationalEmploymentEligibilityMultiCountries["Is"] = "IS";
    JobSeekerProfileInternationalEmploymentEligibilityMultiCountries["It"] = "IT";
    JobSeekerProfileInternationalEmploymentEligibilityMultiCountries["Je"] = "JE";
    JobSeekerProfileInternationalEmploymentEligibilityMultiCountries["Jm"] = "JM";
    JobSeekerProfileInternationalEmploymentEligibilityMultiCountries["Jo"] = "JO";
    JobSeekerProfileInternationalEmploymentEligibilityMultiCountries["Jp"] = "JP";
    JobSeekerProfileInternationalEmploymentEligibilityMultiCountries["Ke"] = "KE";
    JobSeekerProfileInternationalEmploymentEligibilityMultiCountries["Kg"] = "KG";
    JobSeekerProfileInternationalEmploymentEligibilityMultiCountries["Kh"] = "KH";
    JobSeekerProfileInternationalEmploymentEligibilityMultiCountries["Ki"] = "KI";
    JobSeekerProfileInternationalEmploymentEligibilityMultiCountries["Km"] = "KM";
    JobSeekerProfileInternationalEmploymentEligibilityMultiCountries["Kn"] = "KN";
    JobSeekerProfileInternationalEmploymentEligibilityMultiCountries["Kp"] = "KP";
    JobSeekerProfileInternationalEmploymentEligibilityMultiCountries["Kr"] = "KR";
    JobSeekerProfileInternationalEmploymentEligibilityMultiCountries["Kw"] = "KW";
    JobSeekerProfileInternationalEmploymentEligibilityMultiCountries["Ky"] = "KY";
    JobSeekerProfileInternationalEmploymentEligibilityMultiCountries["Kz"] = "KZ";
    JobSeekerProfileInternationalEmploymentEligibilityMultiCountries["La"] = "LA";
    JobSeekerProfileInternationalEmploymentEligibilityMultiCountries["Lb"] = "LB";
    JobSeekerProfileInternationalEmploymentEligibilityMultiCountries["Lc"] = "LC";
    JobSeekerProfileInternationalEmploymentEligibilityMultiCountries["Li"] = "LI";
    JobSeekerProfileInternationalEmploymentEligibilityMultiCountries["Lk"] = "LK";
    JobSeekerProfileInternationalEmploymentEligibilityMultiCountries["Lr"] = "LR";
    JobSeekerProfileInternationalEmploymentEligibilityMultiCountries["Ls"] = "LS";
    JobSeekerProfileInternationalEmploymentEligibilityMultiCountries["Lt"] = "LT";
    JobSeekerProfileInternationalEmploymentEligibilityMultiCountries["Lu"] = "LU";
    JobSeekerProfileInternationalEmploymentEligibilityMultiCountries["Lv"] = "LV";
    JobSeekerProfileInternationalEmploymentEligibilityMultiCountries["Ly"] = "LY";
    JobSeekerProfileInternationalEmploymentEligibilityMultiCountries["Ma"] = "MA";
    JobSeekerProfileInternationalEmploymentEligibilityMultiCountries["Mc"] = "MC";
    JobSeekerProfileInternationalEmploymentEligibilityMultiCountries["Md"] = "MD";
    JobSeekerProfileInternationalEmploymentEligibilityMultiCountries["Me"] = "ME";
    JobSeekerProfileInternationalEmploymentEligibilityMultiCountries["Mf"] = "MF";
    JobSeekerProfileInternationalEmploymentEligibilityMultiCountries["Mg"] = "MG";
    JobSeekerProfileInternationalEmploymentEligibilityMultiCountries["Mh"] = "MH";
    JobSeekerProfileInternationalEmploymentEligibilityMultiCountries["Mk"] = "MK";
    JobSeekerProfileInternationalEmploymentEligibilityMultiCountries["Ml"] = "ML";
    JobSeekerProfileInternationalEmploymentEligibilityMultiCountries["Mm"] = "MM";
    JobSeekerProfileInternationalEmploymentEligibilityMultiCountries["Mn"] = "MN";
    JobSeekerProfileInternationalEmploymentEligibilityMultiCountries["Mo"] = "MO";
    JobSeekerProfileInternationalEmploymentEligibilityMultiCountries["Mp"] = "MP";
    JobSeekerProfileInternationalEmploymentEligibilityMultiCountries["Mq"] = "MQ";
    JobSeekerProfileInternationalEmploymentEligibilityMultiCountries["Mr"] = "MR";
    JobSeekerProfileInternationalEmploymentEligibilityMultiCountries["Ms"] = "MS";
    JobSeekerProfileInternationalEmploymentEligibilityMultiCountries["Mt"] = "MT";
    JobSeekerProfileInternationalEmploymentEligibilityMultiCountries["Mu"] = "MU";
    JobSeekerProfileInternationalEmploymentEligibilityMultiCountries["Mv"] = "MV";
    JobSeekerProfileInternationalEmploymentEligibilityMultiCountries["Mw"] = "MW";
    JobSeekerProfileInternationalEmploymentEligibilityMultiCountries["Mx"] = "MX";
    JobSeekerProfileInternationalEmploymentEligibilityMultiCountries["My"] = "MY";
    JobSeekerProfileInternationalEmploymentEligibilityMultiCountries["Mz"] = "MZ";
    JobSeekerProfileInternationalEmploymentEligibilityMultiCountries["Na"] = "NA";
    JobSeekerProfileInternationalEmploymentEligibilityMultiCountries["Nc"] = "NC";
    JobSeekerProfileInternationalEmploymentEligibilityMultiCountries["Ne"] = "NE";
    JobSeekerProfileInternationalEmploymentEligibilityMultiCountries["Nf"] = "NF";
    JobSeekerProfileInternationalEmploymentEligibilityMultiCountries["Ng"] = "NG";
    JobSeekerProfileInternationalEmploymentEligibilityMultiCountries["Ni"] = "NI";
    JobSeekerProfileInternationalEmploymentEligibilityMultiCountries["Nl"] = "NL";
    JobSeekerProfileInternationalEmploymentEligibilityMultiCountries["No"] = "NO";
    JobSeekerProfileInternationalEmploymentEligibilityMultiCountries["Np"] = "NP";
    JobSeekerProfileInternationalEmploymentEligibilityMultiCountries["Nr"] = "NR";
    JobSeekerProfileInternationalEmploymentEligibilityMultiCountries["Nu"] = "NU";
    JobSeekerProfileInternationalEmploymentEligibilityMultiCountries["Nz"] = "NZ";
    JobSeekerProfileInternationalEmploymentEligibilityMultiCountries["Om"] = "OM";
    JobSeekerProfileInternationalEmploymentEligibilityMultiCountries["Pa"] = "PA";
    JobSeekerProfileInternationalEmploymentEligibilityMultiCountries["Pe"] = "PE";
    JobSeekerProfileInternationalEmploymentEligibilityMultiCountries["Pf"] = "PF";
    JobSeekerProfileInternationalEmploymentEligibilityMultiCountries["Pg"] = "PG";
    JobSeekerProfileInternationalEmploymentEligibilityMultiCountries["Ph"] = "PH";
    JobSeekerProfileInternationalEmploymentEligibilityMultiCountries["Pk"] = "PK";
    JobSeekerProfileInternationalEmploymentEligibilityMultiCountries["Pl"] = "PL";
    JobSeekerProfileInternationalEmploymentEligibilityMultiCountries["Pm"] = "PM";
    JobSeekerProfileInternationalEmploymentEligibilityMultiCountries["Pn"] = "PN";
    JobSeekerProfileInternationalEmploymentEligibilityMultiCountries["Pr"] = "PR";
    JobSeekerProfileInternationalEmploymentEligibilityMultiCountries["Ps"] = "PS";
    JobSeekerProfileInternationalEmploymentEligibilityMultiCountries["Pt"] = "PT";
    JobSeekerProfileInternationalEmploymentEligibilityMultiCountries["Pw"] = "PW";
    JobSeekerProfileInternationalEmploymentEligibilityMultiCountries["Py"] = "PY";
    JobSeekerProfileInternationalEmploymentEligibilityMultiCountries["Qa"] = "QA";
    JobSeekerProfileInternationalEmploymentEligibilityMultiCountries["Re"] = "RE";
    JobSeekerProfileInternationalEmploymentEligibilityMultiCountries["Ro"] = "RO";
    JobSeekerProfileInternationalEmploymentEligibilityMultiCountries["Rs"] = "RS";
    JobSeekerProfileInternationalEmploymentEligibilityMultiCountries["Ru"] = "RU";
    JobSeekerProfileInternationalEmploymentEligibilityMultiCountries["Rw"] = "RW";
    JobSeekerProfileInternationalEmploymentEligibilityMultiCountries["Sa"] = "SA";
    JobSeekerProfileInternationalEmploymentEligibilityMultiCountries["Sb"] = "SB";
    JobSeekerProfileInternationalEmploymentEligibilityMultiCountries["Sc"] = "SC";
    JobSeekerProfileInternationalEmploymentEligibilityMultiCountries["Sd"] = "SD";
    JobSeekerProfileInternationalEmploymentEligibilityMultiCountries["Se"] = "SE";
    JobSeekerProfileInternationalEmploymentEligibilityMultiCountries["Sg"] = "SG";
    JobSeekerProfileInternationalEmploymentEligibilityMultiCountries["Sh"] = "SH";
    JobSeekerProfileInternationalEmploymentEligibilityMultiCountries["Si"] = "SI";
    JobSeekerProfileInternationalEmploymentEligibilityMultiCountries["Sj"] = "SJ";
    JobSeekerProfileInternationalEmploymentEligibilityMultiCountries["Sk"] = "SK";
    JobSeekerProfileInternationalEmploymentEligibilityMultiCountries["Sl"] = "SL";
    JobSeekerProfileInternationalEmploymentEligibilityMultiCountries["Sm"] = "SM";
    JobSeekerProfileInternationalEmploymentEligibilityMultiCountries["Sn"] = "SN";
    JobSeekerProfileInternationalEmploymentEligibilityMultiCountries["So"] = "SO";
    JobSeekerProfileInternationalEmploymentEligibilityMultiCountries["Sr"] = "SR";
    JobSeekerProfileInternationalEmploymentEligibilityMultiCountries["Ss"] = "SS";
    JobSeekerProfileInternationalEmploymentEligibilityMultiCountries["St"] = "ST";
    JobSeekerProfileInternationalEmploymentEligibilityMultiCountries["Sv"] = "SV";
    JobSeekerProfileInternationalEmploymentEligibilityMultiCountries["Sx"] = "SX";
    JobSeekerProfileInternationalEmploymentEligibilityMultiCountries["Sy"] = "SY";
    JobSeekerProfileInternationalEmploymentEligibilityMultiCountries["Sz"] = "SZ";
    JobSeekerProfileInternationalEmploymentEligibilityMultiCountries["Tc"] = "TC";
    JobSeekerProfileInternationalEmploymentEligibilityMultiCountries["Td"] = "TD";
    JobSeekerProfileInternationalEmploymentEligibilityMultiCountries["Tf"] = "TF";
    JobSeekerProfileInternationalEmploymentEligibilityMultiCountries["Tg"] = "TG";
    JobSeekerProfileInternationalEmploymentEligibilityMultiCountries["Th"] = "TH";
    JobSeekerProfileInternationalEmploymentEligibilityMultiCountries["Tj"] = "TJ";
    JobSeekerProfileInternationalEmploymentEligibilityMultiCountries["Tk"] = "TK";
    JobSeekerProfileInternationalEmploymentEligibilityMultiCountries["Tl"] = "TL";
    JobSeekerProfileInternationalEmploymentEligibilityMultiCountries["Tm"] = "TM";
    JobSeekerProfileInternationalEmploymentEligibilityMultiCountries["Tn"] = "TN";
    JobSeekerProfileInternationalEmploymentEligibilityMultiCountries["To"] = "TO";
    JobSeekerProfileInternationalEmploymentEligibilityMultiCountries["Tr"] = "TR";
    JobSeekerProfileInternationalEmploymentEligibilityMultiCountries["Tt"] = "TT";
    JobSeekerProfileInternationalEmploymentEligibilityMultiCountries["Tv"] = "TV";
    JobSeekerProfileInternationalEmploymentEligibilityMultiCountries["Tw"] = "TW";
    JobSeekerProfileInternationalEmploymentEligibilityMultiCountries["Tz"] = "TZ";
    JobSeekerProfileInternationalEmploymentEligibilityMultiCountries["Ua"] = "UA";
    JobSeekerProfileInternationalEmploymentEligibilityMultiCountries["Ug"] = "UG";
    JobSeekerProfileInternationalEmploymentEligibilityMultiCountries["Um"] = "UM";
    JobSeekerProfileInternationalEmploymentEligibilityMultiCountries["Us"] = "US";
    JobSeekerProfileInternationalEmploymentEligibilityMultiCountries["Uy"] = "UY";
    JobSeekerProfileInternationalEmploymentEligibilityMultiCountries["Uz"] = "UZ";
    JobSeekerProfileInternationalEmploymentEligibilityMultiCountries["Va"] = "VA";
    JobSeekerProfileInternationalEmploymentEligibilityMultiCountries["Vc"] = "VC";
    JobSeekerProfileInternationalEmploymentEligibilityMultiCountries["Ve"] = "VE";
    JobSeekerProfileInternationalEmploymentEligibilityMultiCountries["Vg"] = "VG";
    JobSeekerProfileInternationalEmploymentEligibilityMultiCountries["Vi"] = "VI";
    JobSeekerProfileInternationalEmploymentEligibilityMultiCountries["Vn"] = "VN";
    JobSeekerProfileInternationalEmploymentEligibilityMultiCountries["Vu"] = "VU";
    JobSeekerProfileInternationalEmploymentEligibilityMultiCountries["Wf"] = "WF";
    JobSeekerProfileInternationalEmploymentEligibilityMultiCountries["Ws"] = "WS";
    JobSeekerProfileInternationalEmploymentEligibilityMultiCountries["Ye"] = "YE";
    JobSeekerProfileInternationalEmploymentEligibilityMultiCountries["Yt"] = "YT";
    JobSeekerProfileInternationalEmploymentEligibilityMultiCountries["Za"] = "ZA";
    JobSeekerProfileInternationalEmploymentEligibilityMultiCountries["Zm"] = "ZM";
    JobSeekerProfileInternationalEmploymentEligibilityMultiCountries["Zw"] = "ZW";
})(JobSeekerProfileInternationalEmploymentEligibilityMultiCountries || (JobSeekerProfileInternationalEmploymentEligibilityMultiCountries = {}));
/** Employment status of a job seeker listed in their resume */
export var JobSeekerProfileInternationalEmploymentStatus;
(function (JobSeekerProfileInternationalEmploymentStatus) {
    JobSeekerProfileInternationalEmploymentStatus["No"] = "NO";
    JobSeekerProfileInternationalEmploymentStatus["Yes"] = "YES";
})(JobSeekerProfileInternationalEmploymentStatus || (JobSeekerProfileInternationalEmploymentStatus = {}));
/** Employment support status of a job seeker listed in their resume */
export var JobSeekerProfileInternationalEmploymentSupportStatus;
(function (JobSeekerProfileInternationalEmploymentSupportStatus) {
    JobSeekerProfileInternationalEmploymentSupportStatus["Applicable"] = "APPLICABLE";
    JobSeekerProfileInternationalEmploymentSupportStatus["NotApplicable"] = "NOT_APPLICABLE";
})(JobSeekerProfileInternationalEmploymentSupportStatus || (JobSeekerProfileInternationalEmploymentSupportStatus = {}));
/** Ethnicity of the job seeker included in the resume */
export var JobSeekerProfileInternationalEthnicity;
(function (JobSeekerProfileInternationalEthnicity) {
    JobSeekerProfileInternationalEthnicity["African"] = "AFRICAN";
    JobSeekerProfileInternationalEthnicity["Asian"] = "ASIAN";
    JobSeekerProfileInternationalEthnicity["Coloured"] = "COLOURED";
    JobSeekerProfileInternationalEthnicity["Indian"] = "INDIAN";
    JobSeekerProfileInternationalEthnicity["White"] = "WHITE";
})(JobSeekerProfileInternationalEthnicity || (JobSeekerProfileInternationalEthnicity = {}));
export var JobSeekerProfileInternationalEuropeanUnionWorkPermit;
(function (JobSeekerProfileInternationalEuropeanUnionWorkPermit) {
    JobSeekerProfileInternationalEuropeanUnionWorkPermit["No"] = "NO";
    JobSeekerProfileInternationalEuropeanUnionWorkPermit["Yes"] = "YES";
})(JobSeekerProfileInternationalEuropeanUnionWorkPermit || (JobSeekerProfileInternationalEuropeanUnionWorkPermit = {}));
/** Gender of the job seeker listed in their resume */
export var JobSeekerProfileInternationalGender;
(function (JobSeekerProfileInternationalGender) {
    JobSeekerProfileInternationalGender["Female"] = "FEMALE";
    JobSeekerProfileInternationalGender["Male"] = "MALE";
    JobSeekerProfileInternationalGender["None"] = "NONE";
})(JobSeekerProfileInternationalGender || (JobSeekerProfileInternationalGender = {}));
/** Highest career level of a job seeker listed in their resume */
export var JobSeekerProfileInternationalHighestCareerLevel;
(function (JobSeekerProfileInternationalHighestCareerLevel) {
    JobSeekerProfileInternationalHighestCareerLevel["Executive"] = "EXECUTIVE";
    JobSeekerProfileInternationalHighestCareerLevel["Experienced"] = "EXPERIENCED";
    JobSeekerProfileInternationalHighestCareerLevel["NewGrad"] = "NEW_GRAD";
    JobSeekerProfileInternationalHighestCareerLevel["NoExperience"] = "NO_EXPERIENCE";
    JobSeekerProfileInternationalHighestCareerLevel["Student"] = "STUDENT";
})(JobSeekerProfileInternationalHighestCareerLevel || (JobSeekerProfileInternationalHighestCareerLevel = {}));
/** A job seeker's highest level of education listed in their resume */
export var JobSeekerProfileInternationalHighestLevelOfEducation;
(function (JobSeekerProfileInternationalHighestLevelOfEducation) {
    JobSeekerProfileInternationalHighestLevelOfEducation["Eight"] = "EIGHT";
    JobSeekerProfileInternationalHighestLevelOfEducation["Eighteen"] = "EIGHTEEN";
    JobSeekerProfileInternationalHighestLevelOfEducation["Eleven"] = "ELEVEN";
    JobSeekerProfileInternationalHighestLevelOfEducation["Fifteen"] = "FIFTEEN";
    JobSeekerProfileInternationalHighestLevelOfEducation["Five"] = "FIVE";
    JobSeekerProfileInternationalHighestLevelOfEducation["Four"] = "FOUR";
    JobSeekerProfileInternationalHighestLevelOfEducation["Fourteen"] = "FOURTEEN";
    JobSeekerProfileInternationalHighestLevelOfEducation["Nine"] = "NINE";
    JobSeekerProfileInternationalHighestLevelOfEducation["Nineteen"] = "NINETEEN";
    JobSeekerProfileInternationalHighestLevelOfEducation["Seven"] = "SEVEN";
    JobSeekerProfileInternationalHighestLevelOfEducation["Seventeen"] = "SEVENTEEN";
    JobSeekerProfileInternationalHighestLevelOfEducation["Six"] = "SIX";
    JobSeekerProfileInternationalHighestLevelOfEducation["Sixteen"] = "SIXTEEN";
    JobSeekerProfileInternationalHighestLevelOfEducation["Ten"] = "TEN";
    JobSeekerProfileInternationalHighestLevelOfEducation["Thirteen"] = "THIRTEEN";
    JobSeekerProfileInternationalHighestLevelOfEducation["Twelve"] = "TWELVE";
    JobSeekerProfileInternationalHighestLevelOfEducation["Twenty"] = "TWENTY";
    JobSeekerProfileInternationalHighestLevelOfEducation["TwentyFive"] = "TWENTY_FIVE";
    JobSeekerProfileInternationalHighestLevelOfEducation["TwentyFour"] = "TWENTY_FOUR";
    JobSeekerProfileInternationalHighestLevelOfEducation["TwentyOne"] = "TWENTY_ONE";
    JobSeekerProfileInternationalHighestLevelOfEducation["TwentySeven"] = "TWENTY_SEVEN";
    JobSeekerProfileInternationalHighestLevelOfEducation["TwentySix"] = "TWENTY_SIX";
    JobSeekerProfileInternationalHighestLevelOfEducation["TwentyThree"] = "TWENTY_THREE";
    JobSeekerProfileInternationalHighestLevelOfEducation["TwentyTwo"] = "TWENTY_TWO";
    JobSeekerProfileInternationalHighestLevelOfEducation["Zero"] = "ZERO";
})(JobSeekerProfileInternationalHighestLevelOfEducation || (JobSeekerProfileInternationalHighestLevelOfEducation = {}));
/** A job seeker's industry listed in their resume */
export var JobSeekerProfileInternationalIndustry;
(function (JobSeekerProfileInternationalIndustry) {
    JobSeekerProfileInternationalIndustry["Accounting"] = "ACCOUNTING";
    JobSeekerProfileInternationalIndustry["AdministrativeAssistance"] = "ADMINISTRATIVE_ASSISTANCE";
    JobSeekerProfileInternationalIndustry["AdvertisingPrMrEventManagement"] = "ADVERTISING_PR_MR_EVENT_MANAGEMENT";
    JobSeekerProfileInternationalIndustry["AerospaceAndAviation"] = "AEROSPACE_AND_AVIATION";
    JobSeekerProfileInternationalIndustry["AgricultureAndForestry"] = "AGRICULTURE_AND_FORESTRY";
    JobSeekerProfileInternationalIndustry["Analytics"] = "ANALYTICS";
    JobSeekerProfileInternationalIndustry["Architecture"] = "ARCHITECTURE";
    JobSeekerProfileInternationalIndustry["ArchitectureInteriorDesign"] = "ARCHITECTURE_INTERIOR_DESIGN";
    JobSeekerProfileInternationalIndustry["ArtsAndEntertainment"] = "ARTS_AND_ENTERTAINMENT";
    JobSeekerProfileInternationalIndustry["AutomobileAutoAnciliary"] = "AUTOMOBILE_AUTO_ANCILIARY";
    JobSeekerProfileInternationalIndustry["Automotive"] = "AUTOMOTIVE";
    JobSeekerProfileInternationalIndustry["BankingAndFinance"] = "BANKING_AND_FINANCE";
    JobSeekerProfileInternationalIndustry["BeautyAndWellness"] = "BEAUTY_AND_WELLNESS";
    JobSeekerProfileInternationalIndustry["BusinessOperations"] = "BUSINESS_OPERATIONS";
    JobSeekerProfileInternationalIndustry["CallCenter"] = "CALL_CENTER";
    JobSeekerProfileInternationalIndustry["ChemicalEngineering"] = "CHEMICAL_ENGINEERING";
    JobSeekerProfileInternationalIndustry["Childcare"] = "CHILDCARE";
    JobSeekerProfileInternationalIndustry["CivilEngineering"] = "CIVIL_ENGINEERING";
    JobSeekerProfileInternationalIndustry["CleaningAndSanitation"] = "CLEANING_AND_SANITATION";
    JobSeekerProfileInternationalIndustry["CommunityAndSocialService"] = "COMMUNITY_AND_SOCIAL_SERVICE";
    JobSeekerProfileInternationalIndustry["Construction"] = "CONSTRUCTION";
    JobSeekerProfileInternationalIndustry["CustomerService"] = "CUSTOMER_SERVICE";
    JobSeekerProfileInternationalIndustry["Dental"] = "DENTAL";
    JobSeekerProfileInternationalIndustry["EducationAndInstruction"] = "EDUCATION_AND_INSTRUCTION";
    JobSeekerProfileInternationalIndustry["ElectricalEngineering"] = "ELECTRICAL_ENGINEERING";
    JobSeekerProfileInternationalIndustry["ExportImport"] = "EXPORT_IMPORT";
    JobSeekerProfileInternationalIndustry["FoodPreparationAndService"] = "FOOD_PREPARATION_AND_SERVICE";
    JobSeekerProfileInternationalIndustry["GovernmentDefence"] = "GOVERNMENT_DEFENCE";
    JobSeekerProfileInternationalIndustry["Healthcare"] = "HEALTHCARE";
    JobSeekerProfileInternationalIndustry["HospitalityAndTourism"] = "HOSPITALITY_AND_TOURISM";
    JobSeekerProfileInternationalIndustry["HumanResources"] = "HUMAN_RESOURCES";
    JobSeekerProfileInternationalIndustry["IndustrialEngineering"] = "INDUSTRIAL_ENGINEERING";
    JobSeekerProfileInternationalIndustry["InformationDesignAndDocumentation"] = "INFORMATION_DESIGN_AND_DOCUMENTATION";
    JobSeekerProfileInternationalIndustry["InstallationAndMaintenance"] = "INSTALLATION_AND_MAINTENANCE";
    JobSeekerProfileInternationalIndustry["Insurance"] = "INSURANCE";
    JobSeekerProfileInternationalIndustry["InternetEcommerce"] = "INTERNET_ECOMMERCE";
    JobSeekerProfileInternationalIndustry["ItHardwareAndNetworking"] = "IT_HARDWARE_AND_NETWORKING";
    JobSeekerProfileInternationalIndustry["ItOperationsAndHelpdesk"] = "IT_OPERATIONS_AND_HELPDESK";
    JobSeekerProfileInternationalIndustry["KpoResearchAnalytics"] = "KPO_RESEARCH_ANALYTICS";
    JobSeekerProfileInternationalIndustry["Laboratory"] = "LABORATORY";
    JobSeekerProfileInternationalIndustry["Legal"] = "LEGAL";
    JobSeekerProfileInternationalIndustry["Library"] = "LIBRARY";
    JobSeekerProfileInternationalIndustry["LoadingAndStocking"] = "LOADING_AND_STOCKING";
    JobSeekerProfileInternationalIndustry["LogisticSupport"] = "LOGISTIC_SUPPORT";
    JobSeekerProfileInternationalIndustry["Management"] = "MANAGEMENT";
    JobSeekerProfileInternationalIndustry["Marketing"] = "MARKETING";
    JobSeekerProfileInternationalIndustry["Mathematics"] = "MATHEMATICS";
    JobSeekerProfileInternationalIndustry["MechanicalEngineering"] = "MECHANICAL_ENGINEERING";
    JobSeekerProfileInternationalIndustry["MediaAndCommunications"] = "MEDIA_AND_COMMUNICATIONS";
    JobSeekerProfileInternationalIndustry["MedicalInformation"] = "MEDICAL_INFORMATION";
    JobSeekerProfileInternationalIndustry["MedicalTechnician"] = "MEDICAL_TECHNICIAN";
    JobSeekerProfileInternationalIndustry["MedicalTherapy"] = "MEDICAL_THERAPY";
    JobSeekerProfileInternationalIndustry["Militaire"] = "MILITAIRE";
    JobSeekerProfileInternationalIndustry["MiningAndOil"] = "MINING_AND_OIL";
    JobSeekerProfileInternationalIndustry["NgoSocialServicesRegulatorsIndustryAssociations"] = "NGO_SOCIAL_SERVICES_REGULATORS_INDUSTRY_ASSOCIATIONS";
    JobSeekerProfileInternationalIndustry["Nursing"] = "NURSING";
    JobSeekerProfileInternationalIndustry["OilAndGasEnergyPowerInfrastructure"] = "OIL_AND_GAS_ENERGY_POWER_INFRASTRUCTURE";
    JobSeekerProfileInternationalIndustry["Other"] = "OTHER";
    JobSeekerProfileInternationalIndustry["PersonalCareAndHomeHealth"] = "PERSONAL_CARE_AND_HOME_HEALTH";
    JobSeekerProfileInternationalIndustry["Pharmacy"] = "PHARMACY";
    JobSeekerProfileInternationalIndustry["PhysiciansAndSurgeons"] = "PHYSICIANS_AND_SURGEONS";
    JobSeekerProfileInternationalIndustry["PhysicianAssistants"] = "PHYSICIAN_ASSISTANTS";
    JobSeekerProfileInternationalIndustry["ProductionAndManufacturing"] = "PRODUCTION_AND_MANUFACTURING";
    JobSeekerProfileInternationalIndustry["ProjectManagement"] = "PROJECT_MANAGEMENT";
    JobSeekerProfileInternationalIndustry["Publishing"] = "PUBLISHING";
    JobSeekerProfileInternationalIndustry["QualityAssurance"] = "QUALITY_ASSURANCE";
    JobSeekerProfileInternationalIndustry["RealEstate"] = "REAL_ESTATE";
    JobSeekerProfileInternationalIndustry["Retail"] = "RETAIL";
    JobSeekerProfileInternationalIndustry["Sales"] = "SALES";
    JobSeekerProfileInternationalIndustry["ScientificResearchAndDevelopment"] = "SCIENTIFIC_RESEARCH_AND_DEVELOPMENT";
    JobSeekerProfileInternationalIndustry["SecurityAndPublicSafety"] = "SECURITY_AND_PUBLIC_SAFETY";
    JobSeekerProfileInternationalIndustry["SocialScience"] = "SOCIAL_SCIENCE";
    JobSeekerProfileInternationalIndustry["SoftwareDevelopment"] = "SOFTWARE_DEVELOPMENT";
    JobSeekerProfileInternationalIndustry["Sports"] = "SPORTS";
    JobSeekerProfileInternationalIndustry["StrategyManagementConsultingFirms"] = "STRATEGY_MANAGEMENT_CONSULTING_FIRMS";
    JobSeekerProfileInternationalIndustry["Technology"] = "TECHNOLOGY";
    JobSeekerProfileInternationalIndustry["TransportationServices"] = "TRANSPORTATION_SERVICES";
    JobSeekerProfileInternationalIndustry["TravelAirlinesRailways"] = "TRAVEL_AIRLINES_RAILWAYS";
    JobSeekerProfileInternationalIndustry["Tyres"] = "TYRES";
    JobSeekerProfileInternationalIndustry["Veterinary"] = "VETERINARY";
    JobSeekerProfileInternationalIndustry["WaterTreatmentWasteManagement"] = "WATER_TREATMENT_WASTE_MANAGEMENT";
})(JobSeekerProfileInternationalIndustry || (JobSeekerProfileInternationalIndustry = {}));
/** National Youths Service Corps (NYSC) status of a job seeker listed in their resume */
export var JobSeekerProfileInternationalNyscStatus;
(function (JobSeekerProfileInternationalNyscStatus) {
    JobSeekerProfileInternationalNyscStatus["Completed"] = "COMPLETED";
    JobSeekerProfileInternationalNyscStatus["NotApplicable"] = "NOT_APPLICABLE";
    JobSeekerProfileInternationalNyscStatus["Ongoing"] = "ONGOING";
})(JobSeekerProfileInternationalNyscStatus || (JobSeekerProfileInternationalNyscStatus = {}));
/** Veteran status of a job seeker listed in their resume */
export var JobSeekerProfileInternationalVeteranStatus;
(function (JobSeekerProfileInternationalVeteranStatus) {
    JobSeekerProfileInternationalVeteranStatus["Applicable"] = "APPLICABLE";
    JobSeekerProfileInternationalVeteranStatus["NotApplicable"] = "NOT_APPLICABLE";
})(JobSeekerProfileInternationalVeteranStatus || (JobSeekerProfileInternationalVeteranStatus = {}));
/** Describes if the job seeker is willing to travel for a job */
export var JobSeekerProfileInternationalWillingToTravel;
(function (JobSeekerProfileInternationalWillingToTravel) {
    JobSeekerProfileInternationalWillingToTravel["DependsOnOpportunity"] = "DEPENDS_ON_OPPORTUNITY";
    JobSeekerProfileInternationalWillingToTravel["No"] = "NO";
    JobSeekerProfileInternationalWillingToTravel["Yes"] = "YES";
})(JobSeekerProfileInternationalWillingToTravel || (JobSeekerProfileInternationalWillingToTravel = {}));
/** Latest job seeker applied resume type. */
export var JobSeekerProfileLatestAppliedResumeType;
(function (JobSeekerProfileLatestAppliedResumeType) {
    JobSeekerProfileLatestAppliedResumeType["IndeedResume"] = "INDEED_RESUME";
    JobSeekerProfileLatestAppliedResumeType["SavedFileResume"] = "SAVED_FILE_RESUME";
    JobSeekerProfileLatestAppliedResumeType["TailoredResume"] = "TAILORED_RESUME";
})(JobSeekerProfileLatestAppliedResumeType || (JobSeekerProfileLatestAppliedResumeType = {}));
/** A Job Seeker's license type, for example ACCOUNTING_LICENSE, DRIVERS_LICENSE or NURSES_LICENSE */
export var JobSeekerProfileLicenseType;
(function (JobSeekerProfileLicenseType) {
    JobSeekerProfileLicenseType["AccountingLicense"] = "ACCOUNTING_LICENSE";
    JobSeekerProfileLicenseType["DriversLicense"] = "DRIVERS_LICENSE";
    JobSeekerProfileLicenseType["NursesLicense"] = "NURSES_LICENSE";
    JobSeekerProfileLicenseType["Unknown"] = "UNKNOWN";
})(JobSeekerProfileLicenseType || (JobSeekerProfileLicenseType = {}));
/** Month type, e.g. JANUARY. Month type of NOT_SPECIFIED is used to update month to null. */
export var JobSeekerProfileMonthType;
(function (JobSeekerProfileMonthType) {
    JobSeekerProfileMonthType["April"] = "APRIL";
    JobSeekerProfileMonthType["August"] = "AUGUST";
    JobSeekerProfileMonthType["December"] = "DECEMBER";
    JobSeekerProfileMonthType["February"] = "FEBRUARY";
    JobSeekerProfileMonthType["January"] = "JANUARY";
    JobSeekerProfileMonthType["July"] = "JULY";
    JobSeekerProfileMonthType["June"] = "JUNE";
    JobSeekerProfileMonthType["March"] = "MARCH";
    JobSeekerProfileMonthType["May"] = "MAY";
    JobSeekerProfileMonthType["NotSpecified"] = "NOT_SPECIFIED";
    JobSeekerProfileMonthType["November"] = "NOVEMBER";
    JobSeekerProfileMonthType["October"] = "OCTOBER";
    JobSeekerProfileMonthType["September"] = "SEPTEMBER";
})(JobSeekerProfileMonthType || (JobSeekerProfileMonthType = {}));
/** The moderation status for the profile photo */
export var JobSeekerProfilePhotoModerationStatus;
(function (JobSeekerProfilePhotoModerationStatus) {
    /** The moderation process for this file is currently in progress */
    JobSeekerProfilePhotoModerationStatus["InProgress"] = "IN_PROGRESS";
    /** The moderation process for this file has failed after multiple retries */
    JobSeekerProfilePhotoModerationStatus["ModerationFailed"] = "MODERATION_FAILED";
    /** The file has passed moderation */
    JobSeekerProfilePhotoModerationStatus["Passed"] = "PASSED";
    /** The file got rejected during moderation */
    JobSeekerProfilePhotoModerationStatus["Rejected"] = "REJECTED";
    /** The moderation status is not yet available */
    JobSeekerProfilePhotoModerationStatus["Unavailable"] = "UNAVAILABLE";
})(JobSeekerProfilePhotoModerationStatus || (JobSeekerProfilePhotoModerationStatus = {}));
/** A Job Seeker's profile photo state, for example PUBLIC or PRIVATE. */
export var JobSeekerProfilePhotoState;
(function (JobSeekerProfilePhotoState) {
    JobSeekerProfilePhotoState["Private"] = "PRIVATE";
    JobSeekerProfilePhotoState["Public"] = "PUBLIC";
})(JobSeekerProfilePhotoState || (JobSeekerProfilePhotoState = {}));
/** Enum for Job Seeker Profile Question Action */
export var JobSeekerProfileQuestionAction;
(function (JobSeekerProfileQuestionAction) {
    /** Possible types of user actions with a question */
    JobSeekerProfileQuestionAction["Answer"] = "ANSWER";
    JobSeekerProfileQuestionAction["Skip"] = "SKIP";
})(JobSeekerProfileQuestionAction || (JobSeekerProfileQuestionAction = {}));
/** Enum for Job Seeker Profile Question Attribute Source */
export var JobSeekerProfileQuestionAttributeSource;
(function (JobSeekerProfileQuestionAttributeSource) {
    /** Employer consider this attribute to be a "must have" for a job. */
    JobSeekerProfileQuestionAttributeSource["MustHaves"] = "MUST_HAVES";
    /** Employer consider this attribute to be a "nice to have" for a job. */
    JobSeekerProfileQuestionAttributeSource["NiceToHaves"] = "NICE_TO_HAVES";
    /** An attribute related to a job segment or occupation. */
    JobSeekerProfileQuestionAttributeSource["SegmentAttributes"] = "SEGMENT_ATTRIBUTES";
    /** An attribute related to a job segment or occupation. in CROWTAXO flow. */
    JobSeekerProfileQuestionAttributeSource["SegmentCrowtaxoAttributes"] = "SEGMENT_CROWTAXO_ATTRIBUTES";
    /** An attribute related to a job segment or occupation in MOC flow. */
    JobSeekerProfileQuestionAttributeSource["SegmentMocAttributes"] = "SEGMENT_MOC_ATTRIBUTES";
})(JobSeekerProfileQuestionAttributeSource || (JobSeekerProfileQuestionAttributeSource = {}));
/** Enum for Job Seeker Profile Question Generation Source */
export var JobSeekerProfileQuestionGenerationSource;
(function (JobSeekerProfileQuestionGenerationSource) {
    /** Attributes ordered by job attach rate for an occupation using attribute order service */
    JobSeekerProfileQuestionGenerationSource["AttributeOrderingService"] = "ATTRIBUTE_ORDERING_SERVICE";
    /** Attributes ordered by frequency on multi job surfaces like homepage and job search */
    JobSeekerProfileQuestionGenerationSource["CintelSurfaceDerived"] = "CINTEL_SURFACE_DERIVED";
    /** Attributes for experimental questions for NEW fields in the profile which do not exist (see: CINTEL-224) */
    JobSeekerProfileQuestionGenerationSource["CiExperimentalNew"] = "CI_EXPERIMENTAL_NEW";
    /** Default questions are generic questions about the jobseeker such as their desired job title or what degree they have. */
    JobSeekerProfileQuestionGenerationSource["DefaultQuestions"] = "DEFAULT_QUESTIONS";
    /** Attributes that the jobseeker may have if they possess the previously asked qualification */
    JobSeekerProfileQuestionGenerationSource["HighConfidenceDeduction"] = "HIGH_CONFIDENCE_DEDUCTION";
    /** Currently, the model does generate qualification questions, but they are not presented to the job seeker because the required attributes are not filled for now. */
    JobSeekerProfileQuestionGenerationSource["PdcsDataScienceModels"] = "PDCS_DATA_SCIENCE_MODELS";
    /** Attributes ordered by segment configuration platform for an occupation */
    JobSeekerProfileQuestionGenerationSource["SegmentConfigPlatform"] = "SEGMENT_CONFIG_PLATFORM";
    /** Attributes ordered by segment configuration platform getLeversExperiment an occupation with CROWTAXO */
    JobSeekerProfileQuestionGenerationSource["SegmentConfigPlatformCrowtaxo"] = "SEGMENT_CONFIG_PLATFORM_CROWTAXO";
    /** Attributes ordered by segment configuration platform getLeversExperiment an occupation with MOC (Minimum Occupation Criteria) */
    JobSeekerProfileQuestionGenerationSource["SegmentConfigPlatformMoc"] = "SEGMENT_CONFIG_PLATFORM_MOC";
})(JobSeekerProfileQuestionGenerationSource || (JobSeekerProfileQuestionGenerationSource = {}));
/** Enum for Job Seeker Profile Question Name */
export var JobSeekerProfileQuestionName;
(function (JobSeekerProfileQuestionName) {
    JobSeekerProfileQuestionName["Certification"] = "CERTIFICATION";
    JobSeekerProfileQuestionName["CommuteRelocate"] = "COMMUTE_RELOCATE";
    /** Used for crowtaxo questions. */
    JobSeekerProfileQuestionName["Crowtaxo"] = "CROWTAXO";
    JobSeekerProfileQuestionName["CurrentLocation"] = "CURRENT_LOCATION";
    JobSeekerProfileQuestionName["Debug"] = "DEBUG";
    JobSeekerProfileQuestionName["DegreeSelect"] = "DEGREE_SELECT";
    JobSeekerProfileQuestionName["DesiredJobTitle"] = "DESIRED_JOB_TITLE";
    JobSeekerProfileQuestionName["DesiredJobType"] = "DESIRED_JOB_TYPE";
    JobSeekerProfileQuestionName["DesiredMinimumPay"] = "DESIRED_MINIMUM_PAY";
    JobSeekerProfileQuestionName["DesiredOccupation"] = "DESIRED_OCCUPATION";
    JobSeekerProfileQuestionName["DesiredShift"] = "DESIRED_SHIFT";
    JobSeekerProfileQuestionName["Email"] = "EMAIL";
    /** Used for experimental questions (see: CINTEL-224) */
    JobSeekerProfileQuestionName["Experimental"] = "EXPERIMENTAL";
    JobSeekerProfileQuestionName["FieldOfStudy"] = "FIELD_OF_STUDY";
    /**
     * Used for high confidence deduction question. Contains qualifications that the job seeker may have if they answered
     * 'Yes' to the the previously asked qualification
     */
    JobSeekerProfileQuestionName["HcdQualification"] = "HCD_QUALIFICATION";
    JobSeekerProfileQuestionName["Intent"] = "INTENT";
    JobSeekerProfileQuestionName["Language"] = "LANGUAGE";
    JobSeekerProfileQuestionName["License"] = "LICENSE";
    /** The location question used by profile onboarding while other surfaces use CURRENT_LOCATION. */
    JobSeekerProfileQuestionName["Location"] = "LOCATION";
    /** A job seeker's desired max commute time in minutes. */
    JobSeekerProfileQuestionName["MaxCommuteTime"] = "MAX_COMMUTE_TIME";
    /**
     * Used for Minimum Occupation Criteria "MOC" question that asks if a job seeker has one of the top qualfication
     * attributes for an occupation.
     */
    JobSeekerProfileQuestionName["MocQualification"] = "MOC_QUALIFICATION";
    JobSeekerProfileQuestionName["MostRecentJobTitle"] = "MOST_RECENT_JOB_TITLE";
    JobSeekerProfileQuestionName["Name"] = "NAME";
    JobSeekerProfileQuestionName["ReadyToWork"] = "READY_TO_WORK";
    /** Promo card for Recruit Agent.  It's only available for job seekers in Japan. */
    JobSeekerProfileQuestionName["RecruitAgentPromo"] = "RECRUIT_AGENT_PROMO";
    /** Promo card for Rikunabi New Grad.  It's only available for job seekers in Japan. */
    JobSeekerProfileQuestionName["RecruitNewGradPromo"] = "RECRUIT_NEW_GRAD_PROMO";
    JobSeekerProfileQuestionName["Remote"] = "REMOTE";
    /**
     * Question that captures degree level and enrollment status, writing to Resume Education.
     * Only available for job seekers in Japan.
     */
    JobSeekerProfileQuestionName["ResumeEducation"] = "RESUME_EDUCATION";
    /** Used for scoutable privacy question. It's only available for job seekers in Japan */
    JobSeekerProfileQuestionName["ScoutPrivacy"] = "SCOUT_PRIVACY";
    JobSeekerProfileQuestionName["SegmentPreference"] = "SEGMENT_PREFERENCE";
    JobSeekerProfileQuestionName["ShiftOrSchedule"] = "SHIFT_OR_SCHEDULE";
    JobSeekerProfileQuestionName["Skills"] = "SKILLS";
    JobSeekerProfileQuestionName["Unknown"] = "UNKNOWN";
    JobSeekerProfileQuestionName["ViewJobSkills"] = "VIEW_JOB_SKILLS";
})(JobSeekerProfileQuestionName || (JobSeekerProfileQuestionName = {}));
/** Enum for Job Seeker Profile Question Status */
export var JobSeekerProfileQuestionStatus;
(function (JobSeekerProfileQuestionStatus) {
    /** JS has answered the question with NEGATIVE sentiment in the past */
    JobSeekerProfileQuestionStatus["Negative"] = "NEGATIVE";
    /** JS has the qualification in resume or answered the question with POSITIVE sentiment in the past */
    JobSeekerProfileQuestionStatus["Positive"] = "POSITIVE";
    /** JS has either skipped the question or it was auto-skipped */
    JobSeekerProfileQuestionStatus["Skipped"] = "SKIPPED";
})(JobSeekerProfileQuestionStatus || (JobSeekerProfileQuestionStatus = {}));
/** Enum for Job Seeker Profile Question Type */
export var JobSeekerProfileQuestionType;
(function (JobSeekerProfileQuestionType) {
    JobSeekerProfileQuestionType["ContactInfo"] = "CONTACT_INFO";
    JobSeekerProfileQuestionType["Preference"] = "PREFERENCE";
    JobSeekerProfileQuestionType["Qualification"] = "QUALIFICATION";
    JobSeekerProfileQuestionType["Resume"] = "RESUME";
})(JobSeekerProfileQuestionType || (JobSeekerProfileQuestionType = {}));
export var JobSeekerProfileReadStrategy;
(function (JobSeekerProfileReadStrategy) {
    /** Slower data retrieval, but queries the primary partition for up-to-date data as of the time of query. */
    JobSeekerProfileReadStrategy["Consistent"] = "CONSISTENT";
    /** Faster data retrieval, but it might not be up to date if writes haven't been propagated to the queried partition. */
    JobSeekerProfileReadStrategy["EventuallyConsistent"] = "EVENTUALLY_CONSISTENT";
})(JobSeekerProfileReadStrategy || (JobSeekerProfileReadStrategy = {}));
/** A Job Seeker's resume career level, for example EXPERIENCED. */
export var JobSeekerProfileResumeCareerLevel;
(function (JobSeekerProfileResumeCareerLevel) {
    JobSeekerProfileResumeCareerLevel["Experienced"] = "EXPERIENCED";
    JobSeekerProfileResumeCareerLevel["Fresher"] = "FRESHER";
    JobSeekerProfileResumeCareerLevel["NotSpecified"] = "NOT_SPECIFIED";
})(JobSeekerProfileResumeCareerLevel || (JobSeekerProfileResumeCareerLevel = {}));
/** A Job Seeker's resume state, for example PUBLIC or HIDDEN. */
export var JobSeekerProfileResumeConversionType;
(function (JobSeekerProfileResumeConversionType) {
    JobSeekerProfileResumeConversionType["Pdf"] = "PDF";
    JobSeekerProfileResumeConversionType["PdfEmailPhoneNameRedacted"] = "PDF_EMAIL_PHONE_NAME_REDACTED";
    JobSeekerProfileResumeConversionType["PdfEmailPhoneRedacted"] = "PDF_EMAIL_PHONE_REDACTED";
})(JobSeekerProfileResumeConversionType || (JobSeekerProfileResumeConversionType = {}));
/** The supported file formats for exporting Indeed resumes */
export var JobSeekerProfileResumeExportFileFormat;
(function (JobSeekerProfileResumeExportFileFormat) {
    JobSeekerProfileResumeExportFileFormat["Html"] = "HTML";
    JobSeekerProfileResumeExportFileFormat["Json"] = "JSON";
    JobSeekerProfileResumeExportFileFormat["Pdf"] = "PDF";
    JobSeekerProfileResumeExportFileFormat["Txt"] = "TXT";
})(JobSeekerProfileResumeExportFileFormat || (JobSeekerProfileResumeExportFileFormat = {}));
export var JobSeekerProfileResumePersonalDetailType;
(function (JobSeekerProfileResumePersonalDetailType) {
    JobSeekerProfileResumePersonalDetailType["Citizenship"] = "CITIZENSHIP";
    JobSeekerProfileResumePersonalDetailType["DateOfBirth"] = "DATE_OF_BIRTH";
    JobSeekerProfileResumePersonalDetailType["Disability"] = "DISABILITY";
    JobSeekerProfileResumePersonalDetailType["DriversLicense"] = "DRIVERS_LICENSE";
    JobSeekerProfileResumePersonalDetailType["EducationDescription"] = "EDUCATION_DESCRIPTION";
    JobSeekerProfileResumePersonalDetailType["EmploymentEligibility"] = "EMPLOYMENT_ELIGIBILITY";
    JobSeekerProfileResumePersonalDetailType["EmploymentEligibilityMultiCountries"] = "EMPLOYMENT_ELIGIBILITY_MULTI_COUNTRIES";
    JobSeekerProfileResumePersonalDetailType["EmploymentStatus"] = "EMPLOYMENT_STATUS";
    JobSeekerProfileResumePersonalDetailType["EmploymentSupportStatus"] = "EMPLOYMENT_SUPPORT_STATUS";
    JobSeekerProfileResumePersonalDetailType["Ethnicity"] = "ETHNICITY";
    JobSeekerProfileResumePersonalDetailType["EuropeanUnionWorkPermit"] = "EUROPEAN_UNION_WORK_PERMIT";
    JobSeekerProfileResumePersonalDetailType["FirstNameFurigana"] = "FIRST_NAME_FURIGANA";
    JobSeekerProfileResumePersonalDetailType["Gender"] = "GENDER";
    JobSeekerProfileResumePersonalDetailType["HighestCareerLevel"] = "HIGHEST_CAREER_LEVEL";
    JobSeekerProfileResumePersonalDetailType["HighestLevelOfEducation"] = "HIGHEST_LEVEL_OF_EDUCATION";
    JobSeekerProfileResumePersonalDetailType["HobbiesAndInterests"] = "HOBBIES_AND_INTERESTS";
    JobSeekerProfileResumePersonalDetailType["Idp"] = "IDP";
    JobSeekerProfileResumePersonalDetailType["IdNumber"] = "ID_NUMBER";
    JobSeekerProfileResumePersonalDetailType["Industry"] = "INDUSTRY";
    JobSeekerProfileResumePersonalDetailType["LastNameFurigana"] = "LAST_NAME_FURIGANA";
    JobSeekerProfileResumePersonalDetailType["NyscStatus"] = "NYSC_STATUS";
    JobSeekerProfileResumePersonalDetailType["TotalYearsOfExperience"] = "TOTAL_YEARS_OF_EXPERIENCE";
    JobSeekerProfileResumePersonalDetailType["VeteranStatus"] = "VETERAN_STATUS";
    JobSeekerProfileResumePersonalDetailType["WillingToTravel"] = "WILLING_TO_TRAVEL";
})(JobSeekerProfileResumePersonalDetailType || (JobSeekerProfileResumePersonalDetailType = {}));
/** A Job Seeker's resume source, for example DOCUMENT_UPLOAD or INDEED_APPLY. */
export var JobSeekerProfileResumeSource;
(function (JobSeekerProfileResumeSource) {
    JobSeekerProfileResumeSource["BasicProfileOnly"] = "BASIC_PROFILE_ONLY";
    JobSeekerProfileResumeSource["BasicProfileUpload"] = "BASIC_PROFILE_UPLOAD";
    JobSeekerProfileResumeSource["BlankTemplate"] = "BLANK_TEMPLATE";
    JobSeekerProfileResumeSource["DocumentUpload"] = "DOCUMENT_UPLOAD";
    JobSeekerProfileResumeSource["DropboxUpload"] = "DROPBOX_UPLOAD";
    JobSeekerProfileResumeSource["Duplicate"] = "DUPLICATE";
    JobSeekerProfileResumeSource["FacebookProfile"] = "FACEBOOK_PROFILE";
    JobSeekerProfileResumeSource["GoogleDoc"] = "GOOGLE_DOC";
    JobSeekerProfileResumeSource["IndeedApply"] = "INDEED_APPLY";
    JobSeekerProfileResumeSource["LinkedinProfile"] = "LINKEDIN_PROFILE";
    JobSeekerProfileResumeSource["MessagingApp"] = "MESSAGING_APP";
    JobSeekerProfileResumeSource["MicroContent"] = "MICRO_CONTENT";
    JobSeekerProfileResumeSource["MicroContentCarousel"] = "MICRO_CONTENT_CAROUSEL";
    JobSeekerProfileResumeSource["MicroContentJp"] = "MICRO_CONTENT_JP";
    JobSeekerProfileResumeSource["NativeCreate"] = "NATIVE_CREATE";
    JobSeekerProfileResumeSource["NativeUpload"] = "NATIVE_UPLOAD";
    JobSeekerProfileResumeSource["Owain"] = "OWAIN";
    JobSeekerProfileResumeSource["Resumecom"] = "RESUMECOM";
    JobSeekerProfileResumeSource["UniversalResume"] = "UNIVERSAL_RESUME";
    JobSeekerProfileResumeSource["Unknown"] = "UNKNOWN";
})(JobSeekerProfileResumeSource || (JobSeekerProfileResumeSource = {}));
/** A Job Seeker's resume state, for example PUBLIC or HIDDEN. */
export var JobSeekerProfileResumeState;
(function (JobSeekerProfileResumeState) {
    JobSeekerProfileResumeState["Deleted"] = "DELETED";
    JobSeekerProfileResumeState["Hidden"] = "HIDDEN";
    JobSeekerProfileResumeState["Public"] = "PUBLIC";
})(JobSeekerProfileResumeState || (JobSeekerProfileResumeState = {}));
/** A Job Seeker's resume type, for example INDEED_RESUME or PARSED_RESUME. */
export var JobSeekerProfileResumeType;
(function (JobSeekerProfileResumeType) {
    JobSeekerProfileResumeType["Glassdoor"] = "GLASSDOOR";
    JobSeekerProfileResumeType["IndeedResume"] = "INDEED_RESUME";
    JobSeekerProfileResumeType["Parsed"] = "PARSED";
    JobSeekerProfileResumeType["Recruit"] = "RECRUIT";
    JobSeekerProfileResumeType["Resumecom"] = "RESUMECOM";
    JobSeekerProfileResumeType["Simplyhired"] = "SIMPLYHIRED";
})(JobSeekerProfileResumeType || (JobSeekerProfileResumeType = {}));
/** Job seeker profile salary types indicating pay frequency */
export var JobSeekerProfileSalaryType;
(function (JobSeekerProfileSalaryType) {
    JobSeekerProfileSalaryType["Biweekly"] = "BIWEEKLY";
    JobSeekerProfileSalaryType["Daily"] = "DAILY";
    JobSeekerProfileSalaryType["Hourly"] = "HOURLY";
    JobSeekerProfileSalaryType["Monthly"] = "MONTHLY";
    JobSeekerProfileSalaryType["Weekly"] = "WEEKLY";
    JobSeekerProfileSalaryType["Yearly"] = "YEARLY";
})(JobSeekerProfileSalaryType || (JobSeekerProfileSalaryType = {}));
/** A Job Seeker's privacy sourcing election. */
export var JobSeekerProfileSourcingElection;
(function (JobSeekerProfileSourcingElection) {
    JobSeekerProfileSourcingElection["OptIn"] = "OPT_IN";
    JobSeekerProfileSourcingElection["OptOut"] = "OPT_OUT";
    JobSeekerProfileSourcingElection["Unspecified"] = "UNSPECIFIED";
})(JobSeekerProfileSourcingElection || (JobSeekerProfileSourcingElection = {}));
export var JobSeekerProfileStructuredDataDataCategory;
(function (JobSeekerProfileStructuredDataDataCategory) {
    /** Flag for containing only candidate related data, like screener questions. */
    JobSeekerProfileStructuredDataDataCategory["Candidate"] = "CANDIDATE";
    /** Flag for containing only normalized data that is explicitly confirmed by user. */
    JobSeekerProfileStructuredDataDataCategory["ConfirmedByUser"] = "CONFIRMED_BY_USER";
    /**
     * Flag for containing only normalized data extracted from the resume.
     * @deprecated Extracted resume data will soon be removed as a source from JSSD, please consume from MDP's jsdpMultiResumeExtractedQualificationFeature instead. Send a message to #mdp-jobseeker-data-foundation-help if you have any questions.
     */
    JobSeekerProfileStructuredDataDataCategory["ExtractedFromResume"] = "EXTRACTED_FROM_RESUME";
    /** Flag for containing only normalized data inferred from the user's activities. */
    JobSeekerProfileStructuredDataDataCategory["InferredFromUserActivity"] = "INFERRED_FROM_USER_ACTIVITY";
})(JobSeekerProfileStructuredDataDataCategory || (JobSeekerProfileStructuredDataDataCategory = {}));
export var JobSeekerProfileStructuredDataFactSourceEnum;
(function (JobSeekerProfileStructuredDataFactSourceEnum) {
    JobSeekerProfileStructuredDataFactSourceEnum["Profile"] = "PROFILE";
    JobSeekerProfileStructuredDataFactSourceEnum["ScreenerQuestion"] = "SCREENER_QUESTION";
})(JobSeekerProfileStructuredDataFactSourceEnum || (JobSeekerProfileStructuredDataFactSourceEnum = {}));
export var JobSeekerProfileStructuredDataJobTypeEnum;
(function (JobSeekerProfileStructuredDataJobTypeEnum) {
    JobSeekerProfileStructuredDataJobTypeEnum["Apprenticeship"] = "APPRENTICESHIP";
    JobSeekerProfileStructuredDataJobTypeEnum["Casual"] = "CASUAL";
    JobSeekerProfileStructuredDataJobTypeEnum["Commission"] = "COMMISSION";
    JobSeekerProfileStructuredDataJobTypeEnum["Contract"] = "CONTRACT";
    JobSeekerProfileStructuredDataJobTypeEnum["Custom_1"] = "CUSTOM_1";
    JobSeekerProfileStructuredDataJobTypeEnum["FlyinFlyout"] = "FLYIN_FLYOUT";
    JobSeekerProfileStructuredDataJobTypeEnum["Fulltime"] = "FULLTIME";
    JobSeekerProfileStructuredDataJobTypeEnum["Internship"] = "INTERNSHIP";
    JobSeekerProfileStructuredDataJobTypeEnum["NewGrad"] = "NEW_GRAD";
    JobSeekerProfileStructuredDataJobTypeEnum["Nonprofit"] = "NONPROFIT";
    JobSeekerProfileStructuredDataJobTypeEnum["Parttime"] = "PARTTIME";
    JobSeekerProfileStructuredDataJobTypeEnum["Permanent"] = "PERMANENT";
    JobSeekerProfileStructuredDataJobTypeEnum["Recruiter"] = "RECRUITER";
    JobSeekerProfileStructuredDataJobTypeEnum["Spam"] = "SPAM";
    JobSeekerProfileStructuredDataJobTypeEnum["Subcontract"] = "SUBCONTRACT";
    JobSeekerProfileStructuredDataJobTypeEnum["Telecommute"] = "TELECOMMUTE";
    JobSeekerProfileStructuredDataJobTypeEnum["Temporary"] = "TEMPORARY";
    JobSeekerProfileStructuredDataJobTypeEnum["Unknown"] = "UNKNOWN";
    JobSeekerProfileStructuredDataJobTypeEnum["Volunteer"] = "VOLUNTEER";
})(JobSeekerProfileStructuredDataJobTypeEnum || (JobSeekerProfileStructuredDataJobTypeEnum = {}));
export var JobSeekerProfileStructuredDataLatLngPrecision;
(function (JobSeekerProfileStructuredDataLatLngPrecision) {
    JobSeekerProfileStructuredDataLatLngPrecision["Admin1"] = "ADMIN1";
    JobSeekerProfileStructuredDataLatLngPrecision["Admin2"] = "ADMIN2";
    JobSeekerProfileStructuredDataLatLngPrecision["Admin3"] = "ADMIN3";
    JobSeekerProfileStructuredDataLatLngPrecision["Admin4"] = "ADMIN4";
    JobSeekerProfileStructuredDataLatLngPrecision["City"] = "CITY";
    JobSeekerProfileStructuredDataLatLngPrecision["Country"] = "COUNTRY";
    JobSeekerProfileStructuredDataLatLngPrecision["Place"] = "PLACE";
    JobSeekerProfileStructuredDataLatLngPrecision["Station"] = "STATION";
    JobSeekerProfileStructuredDataLatLngPrecision["Unknown"] = "UNKNOWN";
    JobSeekerProfileStructuredDataLatLngPrecision["Zipcode"] = "ZIPCODE";
})(JobSeekerProfileStructuredDataLatLngPrecision || (JobSeekerProfileStructuredDataLatLngPrecision = {}));
export var JobSeekerProfileStructuredDataSalaryType;
(function (JobSeekerProfileStructuredDataSalaryType) {
    /** @deprecated Biweekly salary type will soon be removed, please use another salary type */
    JobSeekerProfileStructuredDataSalaryType["Biweekly"] = "BIWEEKLY";
    JobSeekerProfileStructuredDataSalaryType["Daily"] = "DAILY";
    JobSeekerProfileStructuredDataSalaryType["Hourly"] = "HOURLY";
    JobSeekerProfileStructuredDataSalaryType["Monthly"] = "MONTHLY";
    JobSeekerProfileStructuredDataSalaryType["Weekly"] = "WEEKLY";
    JobSeekerProfileStructuredDataSalaryType["Yearly"] = "YEARLY";
})(JobSeekerProfileStructuredDataSalaryType || (JobSeekerProfileStructuredDataSalaryType = {}));
export var JobSeekerProfileStructuredDataSentiment;
(function (JobSeekerProfileStructuredDataSentiment) {
    JobSeekerProfileStructuredDataSentiment["Negative"] = "NEGATIVE";
    JobSeekerProfileStructuredDataSentiment["Positive"] = "POSITIVE";
})(JobSeekerProfileStructuredDataSentiment || (JobSeekerProfileStructuredDataSentiment = {}));
/** If Job Seeker Premium subscription is an auto-renewed subscription. */
export var JobSeekerProfileSubscriptionAutoRenewStatus;
(function (JobSeekerProfileSubscriptionAutoRenewStatus) {
    JobSeekerProfileSubscriptionAutoRenewStatus["Disabled"] = "DISABLED";
    JobSeekerProfileSubscriptionAutoRenewStatus["Enabled"] = "ENABLED";
})(JobSeekerProfileSubscriptionAutoRenewStatus || (JobSeekerProfileSubscriptionAutoRenewStatus = {}));
/** Status of Job Seeker Premium subscription based on subscribe, renewal and refund events. */
export var JobSeekerProfileSubscriptionStatus;
(function (JobSeekerProfileSubscriptionStatus) {
    JobSeekerProfileSubscriptionStatus["BillingRetryPeriod"] = "BILLING_RETRY_PERIOD";
    JobSeekerProfileSubscriptionStatus["Expired"] = "EXPIRED";
    JobSeekerProfileSubscriptionStatus["GracePeriod"] = "GRACE_PERIOD";
    JobSeekerProfileSubscriptionStatus["None"] = "NONE";
    JobSeekerProfileSubscriptionStatus["Revoked"] = "REVOKED";
    JobSeekerProfileSubscriptionStatus["Subscribed"] = "SUBSCRIBED";
})(JobSeekerProfileSubscriptionStatus || (JobSeekerProfileSubscriptionStatus = {}));
/** Job Seeker Premium subscription tier. */
export var JobSeekerProfileSubscriptionTier;
(function (JobSeekerProfileSubscriptionTier) {
    JobSeekerProfileSubscriptionTier["None"] = "NONE";
    JobSeekerProfileSubscriptionTier["Tier1"] = "TIER1";
})(JobSeekerProfileSubscriptionTier || (JobSeekerProfileSubscriptionTier = {}));
/** Time unit like Years, Months. */
export var JobSeekerProfileTypeUnit;
(function (JobSeekerProfileTypeUnit) {
    JobSeekerProfileTypeUnit["Days"] = "Days";
    JobSeekerProfileTypeUnit["Months"] = "Months";
    JobSeekerProfileTypeUnit["Weeks"] = "Weeks";
    JobSeekerProfileTypeUnit["Years"] = "Years";
})(JobSeekerProfileTypeUnit || (JobSeekerProfileTypeUnit = {}));
export var JobSeekerSalaryType;
(function (JobSeekerSalaryType) {
    JobSeekerSalaryType["Biweekly"] = "BIWEEKLY";
    JobSeekerSalaryType["Daily"] = "DAILY";
    JobSeekerSalaryType["Gig"] = "GIG";
    JobSeekerSalaryType["Hourly"] = "HOURLY";
    JobSeekerSalaryType["Monthly"] = "MONTHLY";
    JobSeekerSalaryType["None"] = "NONE";
    JobSeekerSalaryType["Quarterly"] = "QUARTERLY";
    JobSeekerSalaryType["Semianually"] = "SEMIANUALLY";
    JobSeekerSalaryType["Weekly"] = "WEEKLY";
    JobSeekerSalaryType["Yearly"] = "YEARLY";
})(JobSeekerSalaryType || (JobSeekerSalaryType = {}));
export var JobSeekerSentiment;
(function (JobSeekerSentiment) {
    /** Negative preference */
    JobSeekerSentiment["Negative"] = "NEGATIVE";
    /** Positive preference */
    JobSeekerSentiment["Positive"] = "POSITIVE";
})(JobSeekerSentiment || (JobSeekerSentiment = {}));
export var JobSeekerUserModelFeatureType;
(function (JobSeekerUserModelFeatureType) {
    JobSeekerUserModelFeatureType["Certification"] = "CERTIFICATION";
    JobSeekerUserModelFeatureType["DormancyModel"] = "DORMANCY_MODEL";
    JobSeekerUserModelFeatureType["JobTitle"] = "JOB_TITLE";
    JobSeekerUserModelFeatureType["License"] = "LICENSE";
    JobSeekerUserModelFeatureType["LocationGeo4"] = "LOCATION_GEO4";
    JobSeekerUserModelFeatureType["Occupation"] = "OCCUPATION";
    JobSeekerUserModelFeatureType["Salary"] = "SALARY";
    JobSeekerUserModelFeatureType["Skill"] = "SKILL";
    JobSeekerUserModelFeatureType["UnknownFeature"] = "UNKNOWN_FEATURE";
})(JobSeekerUserModelFeatureType || (JobSeekerUserModelFeatureType = {}));
/**
 * Different job selection mechanism during campaign creation.
 *
 * This enum is non-exhaustive and new values will be added from time to time.
 */
export var JobSelectionType;
(function (JobSelectionType) {
    JobSelectionType["JobList"] = "JOB_LIST";
    JobSelectionType["Query"] = "QUERY";
    JobSelectionType["Rule"] = "RULE";
    JobSelectionType["StaticJobList"] = "STATIC_JOB_LIST";
})(JobSelectionType || (JobSelectionType = {}));
export var JobSourceType;
(function (JobSourceType) {
    JobSourceType["Aggregator"] = "AGGREGATOR";
    JobSourceType["Employer"] = "EMPLOYER";
    JobSourceType["JobBoard"] = "JOB_BOARD";
    JobSourceType["Recruiter"] = "RECRUITER";
})(JobSourceType || (JobSourceType = {}));
/**  Job sponsoring event type  */
export var JobSponsoringType;
(function (JobSponsoringType) {
    JobSponsoringType["Combined"] = "COMBINED";
    JobSponsoringType["Organic"] = "ORGANIC";
    JobSponsoringType["Sponsored"] = "SPONSORED";
})(JobSponsoringType || (JobSponsoringType = {}));
/**  Possible job status types in JobCampaignDetailsInput  */
export var JobStatusType;
(function (JobStatusType) {
    JobStatusType["Active"] = "ACTIVE";
    JobStatusType["Inactive"] = "INACTIVE";
})(JobStatusType || (JobStatusType = {}));
export var JobToCampaignLookupStrategy;
(function (JobToCampaignLookupStrategy) {
    /**
     * 30-60 minutes delayed campaigns lookup for campaigns fulfilling one of the conditions.
     * Returns campaigns that have at lease one type of spending eligibility
     */
    JobToCampaignLookupStrategy["Delayed"] = "DELAYED";
    /**
     * Sub-minute delayed campaigns lookup.
     * Returns campaigns that are at least active.
     */
    JobToCampaignLookupStrategy["Instant"] = "INSTANT";
    /**
     * Same as INSTANT, but if job data is unavailable, it will fall back to Hosted Jobs Platform.
     * The fallback is only available for hosted jobs. For indexed jobs, it is equivalent to INSTANT.
     */
    JobToCampaignLookupStrategy["InstantWithFallback"] = "INSTANT_WITH_FALLBACK";
    /**
     * Real time campaigns lookup with job group id.
     * Only partial campaign data can be available with this strategy.
     */
    JobToCampaignLookupStrategy["JobGroup"] = "JOB_GROUP";
})(JobToCampaignLookupStrategy || (JobToCampaignLookupStrategy = {}));
/** All available job types. */
export var JobType;
(function (JobType) {
    JobType["Apprenticeship"] = "APPRENTICESHIP";
    JobType["Casual"] = "CASUAL";
    JobType["Commission"] = "COMMISSION";
    JobType["Contract"] = "CONTRACT";
    /** @deprecated Unsupported */
    JobType["Custom_1"] = "CUSTOM_1";
    JobType["FlyinFlyout"] = "FLYIN_FLYOUT";
    JobType["FullTime"] = "FULL_TIME";
    JobType["Internship"] = "INTERNSHIP";
    JobType["NewGrad"] = "NEW_GRAD";
    /** @deprecated Unsupported */
    JobType["Nonprofit"] = "NONPROFIT";
    /** @deprecated Unsupported */
    JobType["Other"] = "OTHER";
    JobType["PartTime"] = "PART_TIME";
    JobType["Permanent"] = "PERMANENT";
    JobType["Recruiter"] = "RECRUITER";
    /** @deprecated Unsupported */
    JobType["Spam"] = "SPAM";
    JobType["Subcontract"] = "SUBCONTRACT";
    /** @deprecated Unsupported */
    JobType["Telecommute"] = "TELECOMMUTE";
    JobType["Temporary"] = "TEMPORARY";
    JobType["Volunteer"] = "VOLUNTEER";
})(JobType || (JobType = {}));
export var JobUpdateEventType;
(function (JobUpdateEventType) {
    JobUpdateEventType["Deleted"] = "DELETED";
    JobUpdateEventType["New"] = "NEW";
    JobUpdateEventType["Updated"] = "UPDATED";
})(JobUpdateEventType || (JobUpdateEventType = {}));
export var JobUpdateStatus;
(function (JobUpdateStatus) {
    JobUpdateStatus["Active"] = "ACTIVE";
    JobUpdateStatus["Inactive"] = "INACTIVE";
})(JobUpdateStatus || (JobUpdateStatus = {}));
/**
 * The period that applies to the work effort.
 * For example, for period of a MONTH, effort can be expressed as hours
 * worked per month.
 */
export var JobWorkEffortPeriod;
(function (JobWorkEffortPeriod) {
    JobWorkEffortPeriod["Day"] = "DAY";
    JobWorkEffortPeriod["Month"] = "MONTH";
    JobWorkEffortPeriod["Week"] = "WEEK";
    JobWorkEffortPeriod["Year"] = "YEAR";
})(JobWorkEffortPeriod || (JobWorkEffortPeriod = {}));
/**
 * The unit of work effort.
 * HOUR is the only valid unit for now.
 */
export var JobWorkEffortUnit;
(function (JobWorkEffortUnit) {
    JobWorkEffortUnit["Hour"] = "HOUR";
})(JobWorkEffortUnit || (JobWorkEffortUnit = {}));
export var JobseekerIdentityVerificationStatus;
(function (JobseekerIdentityVerificationStatus) {
    JobseekerIdentityVerificationStatus["Rejected"] = "REJECTED";
    JobseekerIdentityVerificationStatus["Verified"] = "VERIFIED";
})(JobseekerIdentityVerificationStatus || (JobseekerIdentityVerificationStatus = {}));
export var JobseekerIdentityVerificationType;
(function (JobseekerIdentityVerificationType) {
    JobseekerIdentityVerificationType["Cdl"] = "CDL";
    JobseekerIdentityVerificationType["Identity"] = "IDENTITY";
})(JobseekerIdentityVerificationType || (JobseekerIdentityVerificationType = {}));
/** The status of a jobseeker's session convo room  */
export var JobseekerInterviewNowRoomStatus;
(function (JobseekerInterviewNowRoomStatus) {
    JobseekerInterviewNowRoomStatus["Active"] = "ACTIVE";
    JobseekerInterviewNowRoomStatus["Inactive"] = "INACTIVE";
})(JobseekerInterviewNowRoomStatus || (JobseekerInterviewNowRoomStatus = {}));
/** This enum maps to the JobseekerInterviewLocationInfo union in the JobseekerInterviewLocationInfoInput object */
export var JobseekerLocationInfoType;
(function (JobseekerLocationInfoType) {
    JobseekerLocationInfoType["JobseekerInterviewPhoneLocationInfo"] = "JOBSEEKER_INTERVIEW_PHONE_LOCATION_INFO";
    JobseekerLocationInfoType["JobseekerInterviewPhysicalLocationInfo"] = "JOBSEEKER_INTERVIEW_PHYSICAL_LOCATION_INFO";
    JobseekerLocationInfoType["JobseekerInterviewThirdPartyVideoLocationInfo"] = "JOBSEEKER_INTERVIEW_THIRD_PARTY_VIDEO_LOCATION_INFO";
})(JobseekerLocationInfoType || (JobseekerLocationInfoType = {}));
/** Action types */
export var JoinDcaGroupAction;
(function (JoinDcaGroupAction) {
    JoinDcaGroupAction["JoinedGroup"] = "JOINED_GROUP";
    JoinDcaGroupAction["NoAction"] = "NO_ACTION";
    JoinDcaGroupAction["RequestSent"] = "REQUEST_SENT";
})(JoinDcaGroupAction || (JoinDcaGroupAction = {}));
/** The job post's apply method type */
export var JostPostApplyMethodType;
(function (JostPostApplyMethodType) {
    JostPostApplyMethodType["Email"] = "EMAIL";
    JostPostApplyMethodType["InPerson"] = "IN_PERSON";
    JostPostApplyMethodType["Tpia"] = "TPIA";
    JostPostApplyMethodType["Website"] = "WEBSITE";
})(JostPostApplyMethodType || (JostPostApplyMethodType = {}));
export var JsEmailsPushesEventType;
(function (JsEmailsPushesEventType) {
    JsEmailsPushesEventType["JsEmailsPushes"] = "JS_EMAILS_PUSHES";
})(JsEmailsPushesEventType || (JsEmailsPushesEventType = {}));
export var JsInterviewPrepCareerStage;
(function (JsInterviewPrepCareerStage) {
    /** For jobseekers transitioning from one career field to another */
    JsInterviewPrepCareerStage["CareerSwitcher"] = "CAREER_SWITCHER";
    /** For jobseekers with experience in their field */
    JsInterviewPrepCareerStage["ExperiencedProfessional"] = "EXPERIENCED_PROFESSIONAL";
    /** For jobseekers who are recent graduates or new to the workforce */
    JsInterviewPrepCareerStage["RecentGraduate"] = "RECENT_GRADUATE";
})(JsInterviewPrepCareerStage || (JsInterviewPrepCareerStage = {}));
export var JsInterviewPrepFeedbackPriorityTag;
(function (JsInterviewPrepFeedbackPriorityTag) {
    /** When the user's response is acceptable but has a clear, substantive gap */
    JsInterviewPrepFeedbackPriorityTag["CouldBeImproved"] = "COULD_BE_IMPROVED";
    /** When the user's response is a deal-breaker */
    JsInterviewPrepFeedbackPriorityTag["NeedsImprovement"] = "NEEDS_IMPROVEMENT";
    /** No priority tag for this feedback */
    JsInterviewPrepFeedbackPriorityTag["None"] = "NONE";
    /** When the user's response substantively answers the question */
    JsInterviewPrepFeedbackPriorityTag["StrongAnswer"] = "STRONG_ANSWER";
})(JsInterviewPrepFeedbackPriorityTag || (JsInterviewPrepFeedbackPriorityTag = {}));
export var JsInterviewPrepFeedbackStatus;
(function (JsInterviewPrepFeedbackStatus) {
    /** The evaluation has completed and the feedback can be shown */
    JsInterviewPrepFeedbackStatus["Complete"] = "COMPLETE";
    /** There was a problem evaluating the feedback and it will never complete */
    JsInterviewPrepFeedbackStatus["Failed"] = "FAILED";
    /** The evaluation is in progress and the feedback is not yet available */
    JsInterviewPrepFeedbackStatus["Processing"] = "PROCESSING";
})(JsInterviewPrepFeedbackStatus || (JsInterviewPrepFeedbackStatus = {}));
export var JsInterviewPrepInputType;
(function (JsInterviewPrepInputType) {
    /** The jobseeker will speak to a realtime voice agent proxied by this service to OpenAI. */
    JsInterviewPrepInputType["Realtime"] = "REALTIME";
    /** The jobseeker will type their answers to the agent's questions. */
    JsInterviewPrepInputType["Text"] = "TEXT";
    /** The jobseeker will speak to answer the agent's questions.  The default option. */
    JsInterviewPrepInputType["Voice"] = "VOICE";
})(JsInterviewPrepInputType || (JsInterviewPrepInputType = {}));
export var JsInterviewPrepInterviewLength;
(function (JsInterviewPrepInterviewLength) {
    /** An in-depth session similar to a real interview. */
    JsInterviewPrepInterviewLength["Long"] = "LONG";
    /** A balanced session with a mix of questions. */
    JsInterviewPrepInterviewLength["Medium"] = "MEDIUM";
    /** A light session with just a few questions. */
    JsInterviewPrepInterviewLength["Short"] = "SHORT";
})(JsInterviewPrepInterviewLength || (JsInterviewPrepInterviewLength = {}));
export var JsInterviewPrepQuestionCategory;
(function (JsInterviewPrepQuestionCategory) {
    JsInterviewPrepQuestionCategory["Background"] = "BACKGROUND";
    JsInterviewPrepQuestionCategory["JobSpecific"] = "JOB_SPECIFIC";
    JsInterviewPrepQuestionCategory["Saved"] = "SAVED";
    JsInterviewPrepQuestionCategory["Situational"] = "SITUATIONAL";
})(JsInterviewPrepQuestionCategory || (JsInterviewPrepQuestionCategory = {}));
export var JsInterviewPrepQuestionSource;
(function (JsInterviewPrepQuestionSource) {
    /** The default questions */
    JsInterviewPrepQuestionSource["Default"] = "DEFAULT";
    /** The question comes from Glassdoor */
    JsInterviewPrepQuestionSource["Glassdoor"] = "GLASSDOOR";
})(JsInterviewPrepQuestionSource || (JsInterviewPrepQuestionSource = {}));
export var JsInterviewPrepQuestionStatus;
(function (JsInterviewPrepQuestionStatus) {
    /** The evaluation for this question was completed successfully */
    JsInterviewPrepQuestionStatus["Complete"] = "COMPLETE";
    /** There was an issue generating the feedback for this question */
    JsInterviewPrepQuestionStatus["Failed"] = "FAILED";
    /** The user was not asked this question e.g. because of a technical issue or they exited the interview early */
    JsInterviewPrepQuestionStatus["NotAsked"] = "NOT_ASKED";
    /** No feedback was generated e.g. insufficient content to evaluate */
    JsInterviewPrepQuestionStatus["NoFeedback"] = "NO_FEEDBACK";
    /** The jobseeker chose to skip the question */
    JsInterviewPrepQuestionStatus["Skipped"] = "SKIPPED";
})(JsInterviewPrepQuestionStatus || (JsInterviewPrepQuestionStatus = {}));
export var JsInterviewPrepResumeImprovementStatus;
(function (JsInterviewPrepResumeImprovementStatus) {
    /** The jobseeker has already approved this edit to their resume */
    JsInterviewPrepResumeImprovementStatus["Approved"] = "APPROVED";
    /** The jobseeker has not yet made a decision on this improvement */
    JsInterviewPrepResumeImprovementStatus["Pending"] = "PENDING";
    /** The jobseeker has rejected this edit to their resume */
    JsInterviewPrepResumeImprovementStatus["Rejected"] = "REJECTED";
})(JsInterviewPrepResumeImprovementStatus || (JsInterviewPrepResumeImprovementStatus = {}));
export var JsInterviewPrepResumeImprovementsStatus;
(function (JsInterviewPrepResumeImprovementsStatus) {
    /** The pipeline completed and there are improvements for the jobseeker to review */
    JsInterviewPrepResumeImprovementsStatus["Complete"] = "COMPLETE";
    /** The generation failed for a technical reason and should be retried or the error triaged */
    JsInterviewPrepResumeImprovementsStatus["Error"] = "ERROR";
    /** No improvements could be made either because of missing data or because the resume is already complete. */
    JsInterviewPrepResumeImprovementsStatus["Failed"] = "FAILED";
    /** The pipeline is running and improvements are not yet available */
    JsInterviewPrepResumeImprovementsStatus["Processing"] = "PROCESSING";
})(JsInterviewPrepResumeImprovementsStatus || (JsInterviewPrepResumeImprovementsStatus = {}));
export var JsInterviewPrepType;
(function (JsInterviewPrepType) {
    JsInterviewPrepType["MockInterview"] = "MOCK_INTERVIEW";
    JsInterviewPrepType["QuestionPractice"] = "QUESTION_PRACTICE";
})(JsInterviewPrepType || (JsInterviewPrepType = {}));
export var JsOnboardingEventType;
(function (JsOnboardingEventType) {
    JsOnboardingEventType["Completed"] = "COMPLETED";
    JsOnboardingEventType["Started"] = "STARTED";
})(JsOnboardingEventType || (JsOnboardingEventType = {}));
export var JsOnboardingFlowType;
(function (JsOnboardingFlowType) {
    JsOnboardingFlowType["Crowtaxo"] = "CROWTAXO";
    JsOnboardingFlowType["Default"] = "DEFAULT";
    JsOnboardingFlowType["DefaultJp"] = "DEFAULT_JP";
    JsOnboardingFlowType["Generalist"] = "GENERALIST";
})(JsOnboardingFlowType || (JsOnboardingFlowType = {}));
export var JsProPremiumAccessStatus;
(function (JsProPremiumAccessStatus) {
    JsProPremiumAccessStatus["Disabled"] = "DISABLED";
    JsProPremiumAccessStatus["Enabled"] = "ENABLED";
})(JsProPremiumAccessStatus || (JsProPremiumAccessStatus = {}));
export var JsProPremiumBranding;
(function (JsProPremiumBranding) {
    /** @deprecated sunset earned jobseekerPro */
    JsProPremiumBranding["JsPremium"] = "JS_PREMIUM";
    /** @deprecated sunset earned jobseekerPro */
    JsProPremiumBranding["JsPro"] = "JS_PRO";
    JsProPremiumBranding["None"] = "NONE";
})(JsProPremiumBranding || (JsProPremiumBranding = {}));
export var JsResumeCoachRecommendationsStatus;
(function (JsResumeCoachRecommendationsStatus) {
    /** The recommendations have been generated and can be shown */
    JsResumeCoachRecommendationsStatus["Complete"] = "COMPLETE";
    /** There was a problem generating the recommendations and they will never complete */
    JsResumeCoachRecommendationsStatus["Failed"] = "FAILED";
    /** The recommendations are being generated and are not yet available */
    JsResumeCoachRecommendationsStatus["Processing"] = "PROCESSING";
})(JsResumeCoachRecommendationsStatus || (JsResumeCoachRecommendationsStatus = {}));
export var JsResumeCoachSections;
(function (JsResumeCoachSections) {
    /** Work experience section from a jobseekers profile */
    JsResumeCoachSections["WorkExperience"] = "WORK_EXPERIENCE";
})(JsResumeCoachSections || (JsResumeCoachSections = {}));
export var JsSentInteropEventType;
(function (JsSentInteropEventType) {
    JsSentInteropEventType["JobseekerSentInterop"] = "JOBSEEKER_SENT_INTEROP";
})(JsSentInteropEventType || (JsSentInteropEventType = {}));
export var JsSubscriptionAccessTier;
(function (JsSubscriptionAccessTier) {
    JsSubscriptionAccessTier["Freemium"] = "FREEMIUM";
    JsSubscriptionAccessTier["FreeTrial"] = "FREE_TRIAL";
    JsSubscriptionAccessTier["PaidSubscription"] = "PAID_SUBSCRIPTION";
})(JsSubscriptionAccessTier || (JsSubscriptionAccessTier = {}));
export var LlmFeedbackReason;
(function (LlmFeedbackReason) {
    LlmFeedbackReason["Custom_1"] = "CUSTOM_1";
    LlmFeedbackReason["Custom_2"] = "CUSTOM_2";
    LlmFeedbackReason["Custom_3"] = "CUSTOM_3";
    LlmFeedbackReason["Custom_4"] = "CUSTOM_4";
    LlmFeedbackReason["Custom_5"] = "CUSTOM_5";
    LlmFeedbackReason["Custom_6"] = "CUSTOM_6";
    LlmFeedbackReason["Custom_7"] = "CUSTOM_7";
    LlmFeedbackReason["Custom_8"] = "CUSTOM_8";
    LlmFeedbackReason["Custom_9"] = "CUSTOM_9";
    LlmFeedbackReason["Custom_10"] = "CUSTOM_10";
    LlmFeedbackReason["Negative"] = "NEGATIVE";
    LlmFeedbackReason["NegativeInaccurate"] = "NEGATIVE_INACCURATE";
    LlmFeedbackReason["NegativeIrrelevant"] = "NEGATIVE_IRRELEVANT";
    LlmFeedbackReason["NegativeOther"] = "NEGATIVE_OTHER";
    LlmFeedbackReason["NegativeToxic"] = "NEGATIVE_TOXIC";
    LlmFeedbackReason["NegativeUnhelpful"] = "NEGATIVE_UNHELPFUL";
    LlmFeedbackReason["Positive"] = "POSITIVE";
    LlmFeedbackReason["PositiveAccurate"] = "POSITIVE_ACCURATE";
    LlmFeedbackReason["PositiveHelpful"] = "POSITIVE_HELPFUL";
    LlmFeedbackReason["PositiveOther"] = "POSITIVE_OTHER";
    LlmFeedbackReason["PositiveRelevant"] = "POSITIVE_RELEVANT";
    LlmFeedbackReason["PositiveStraightforward"] = "POSITIVE_STRAIGHTFORWARD";
})(LlmFeedbackReason || (LlmFeedbackReason = {}));
/** Enum representing different approaches for LLM outreach messaging */
export var LlmOutreachApproach;
(function (LlmOutreachApproach) {
    LlmOutreachApproach["Brief"] = "BRIEF";
    LlmOutreachApproach["MatchFocused"] = "MATCH_FOCUSED";
    LlmOutreachApproach["SellTheRole"] = "SELL_THE_ROLE";
})(LlmOutreachApproach || (LlmOutreachApproach = {}));
export var LatLngPrecision;
(function (LatLngPrecision) {
    LatLngPrecision["Address"] = "ADDRESS";
    LatLngPrecision["Admin1"] = "ADMIN1";
    LatLngPrecision["Admin2"] = "ADMIN2";
    LatLngPrecision["Admin3"] = "ADMIN3";
    LatLngPrecision["Admin4"] = "ADMIN4";
    LatLngPrecision["City"] = "CITY";
    LatLngPrecision["Country"] = "COUNTRY";
    LatLngPrecision["Postal"] = "POSTAL";
    LatLngPrecision["UnknownLatLngPrecision"] = "UNKNOWN_LAT_LNG_PRECISION";
})(LatLngPrecision || (LatLngPrecision = {}));
export var LegalEntityTypeEnum;
(function (LegalEntityTypeEnum) {
    LegalEntityTypeEnum["Individual"] = "INDIVIDUAL";
    LegalEntityTypeEnum["Organization"] = "ORGANIZATION";
    LegalEntityTypeEnum["SoleProprietorship"] = "SOLE_PROPRIETORSHIP";
    LegalEntityTypeEnum["Trust"] = "TRUST";
})(LegalEntityTypeEnum || (LegalEntityTypeEnum = {}));
export var LexiConversationClosedReason;
(function (LexiConversationClosedReason) {
    LexiConversationClosedReason["AutoFeedbackProvided"] = "AUTO_FEEDBACK_PROVIDED";
    LexiConversationClosedReason["AutoNewConversationStarted"] = "AUTO_NEW_CONVERSATION_STARTED";
    LexiConversationClosedReason["AutoNightlyCronJob"] = "AUTO_NIGHTLY_CRON_JOB";
    LexiConversationClosedReason["AutoWorkerMessageLimit"] = "AUTO_WORKER_MESSAGE_LIMIT";
    LexiConversationClosedReason["SfConversation"] = "SF_CONVERSATION";
})(LexiConversationClosedReason || (LexiConversationClosedReason = {}));
export var LexiConversationInputClosedReason;
(function (LexiConversationInputClosedReason) {
    LexiConversationInputClosedReason["SfConversation"] = "SF_CONVERSATION";
})(LexiConversationInputClosedReason || (LexiConversationInputClosedReason = {}));
export var LexiConversationMessageSender;
(function (LexiConversationMessageSender) {
    /** The LLM sent the message */
    LexiConversationMessageSender["Assistant"] = "ASSISTANT";
    /** The user sent the message */
    LexiConversationMessageSender["User"] = "USER";
})(LexiConversationMessageSender || (LexiConversationMessageSender = {}));
export var LexiConversationStatus;
(function (LexiConversationStatus) {
    /** The conversation is closed */
    LexiConversationStatus["Closed"] = "CLOSED";
    /** The conversation is open */
    LexiConversationStatus["Open"] = "OPEN";
})(LexiConversationStatus || (LexiConversationStatus = {}));
/** Status of Lexi Document */
export var LexiDocumentStatus;
(function (LexiDocumentStatus) {
    LexiDocumentStatus["Completed"] = "COMPLETED";
    LexiDocumentStatus["Deleted"] = "DELETED";
    LexiDocumentStatus["Failed"] = "FAILED";
    LexiDocumentStatus["PendingUpload"] = "PENDING_UPLOAD";
})(LexiDocumentStatus || (LexiDocumentStatus = {}));
export var LexiFeedbackReaction;
(function (LexiFeedbackReaction) {
    /** The worker is unhappy with the conversation */
    LexiFeedbackReaction["Negative"] = "NEGATIVE";
    /** The worker is happy with the conversation */
    LexiFeedbackReaction["Positive"] = "POSITIVE";
})(LexiFeedbackReaction || (LexiFeedbackReaction = {}));
export var LicensePreParseResult;
(function (LicensePreParseResult) {
    LicensePreParseResult["HaveContent"] = "HAVE_CONTENT";
    LicensePreParseResult["NoLicense"] = "NO_LICENSE";
    LicensePreParseResult["SkippedVerification"] = "SKIPPED_VERIFICATION";
    LicensePreParseResult["UnableToVerify"] = "UNABLE_TO_VERIFY";
})(LicensePreParseResult || (LicensePreParseResult = {}));
/**
 * Identifies the data source for a license/credential report.
 * CRAVE R1 credentials come from screener question answers (SCREENER),
 * legacy licenses come from OneGraph qualification verification (QUALIFICATION).
 */
export var LicenseSource;
(function (LicenseSource) {
    /**
     * CRAVE third-party verification documents flow
     * Used when the job was configured with a third-party-eligible license. The jobseeker
     * may have verified through a third party or uploaded a file — see
     * CraveVerificationDetails.verificationMethod to distinguish.
     */
    LicenseSource["CraveVerification"] = "CRAVE_VERIFICATION";
    LicenseSource["Qualification"] = "QUALIFICATION";
    LicenseSource["Screener"] = "SCREENER";
})(LicenseSource || (LicenseSource = {}));
/** Available Evaluate license types that can be screened */
export var LicenseType;
(function (LicenseType) {
    LicenseType["Cdl"] = "CDL";
    LicenseType["CertifiedNursingAssistant"] = "CERTIFIED_NURSING_ASSISTANT";
    LicenseType["DriversLicense"] = "DRIVERS_LICENSE";
    LicenseType["LicensedNursePractitioner"] = "LICENSED_NURSE_PRACTITIONER";
    LicenseType["LicensedPracticalNurse"] = "LICENSED_PRACTICAL_NURSE";
    LicenseType["LicensedVocationalNurse"] = "LICENSED_VOCATIONAL_NURSE";
    LicenseType["Other"] = "OTHER";
    LicenseType["RegisteredNurse"] = "REGISTERED_NURSE";
})(LicenseType || (LicenseType = {}));
/** Line app message type */
export var LineMessageType;
(function (LineMessageType) {
    LineMessageType["Flex"] = "FLEX";
})(LineMessageType || (LineMessageType = {}));
/**
 * Linked click event key type, for async case, client need to pass the uuidv4 which client used for generating click billable event
 * tracking key, for sync case pass the click billable event tracking key generated from recordBillableEvent response.
 */
export var LinkedClickEventKeyType;
(function (LinkedClickEventKeyType) {
    LinkedClickEventKeyType["BillableEventTrackingKey"] = "BILLABLE_EVENT_TRACKING_KEY";
    LinkedClickEventKeyType["UuidV4"] = "UUID_V4";
})(LinkedClickEventKeyType || (LinkedClickEventKeyType = {}));
/** State of a list stepper item indicating its progress. */
export var ListStepperItemState;
(function (ListStepperItemState) {
    /** Item is currently active/in progress */
    ListStepperItemState["Active"] = "ACTIVE";
    /** Item has been completed */
    ListStepperItemState["Completed"] = "COMPLETED";
    /** Item is upcoming/not yet started */
    ListStepperItemState["Upcoming"] = "UPCOMING";
})(ListStepperItemState || (ListStepperItemState = {}));
/** List type of SSO connection */
export var ListType;
(function (ListType) {
    ListType["OptIn"] = "OPT_IN";
    ListType["OptOut"] = "OPT_OUT";
})(ListType || (ListType = {}));
/** Status that matches the rsvp status */
export var LobbyAppointmentStatus;
(function (LobbyAppointmentStatus) {
    LobbyAppointmentStatus["AllowedInRoom"] = "ALLOWED_IN_ROOM";
    LobbyAppointmentStatus["CheckedIn"] = "CHECKED_IN";
    LobbyAppointmentStatus["Declined"] = "DECLINED";
    LobbyAppointmentStatus["EmployerCancelled"] = "EMPLOYER_CANCELLED";
    LobbyAppointmentStatus["Interviewed"] = "INTERVIEWED";
    LobbyAppointmentStatus["Interviewing"] = "INTERVIEWING";
    LobbyAppointmentStatus["JobseekerCancelled"] = "JOBSEEKER_CANCELLED";
    LobbyAppointmentStatus["NotInterviewed"] = "NOT_INTERVIEWED";
    LobbyAppointmentStatus["ReadyForCall"] = "READY_FOR_CALL";
    LobbyAppointmentStatus["Requeued"] = "REQUEUED";
    LobbyAppointmentStatus["Rsvped"] = "RSVPED";
    LobbyAppointmentStatus["Unknown"] = "UNKNOWN";
    LobbyAppointmentStatus["WaitingInRoom"] = "WAITING_IN_ROOM";
})(LobbyAppointmentStatus || (LobbyAppointmentStatus = {}));
/** Change actions captured in the audit log */
export var LobbyAuditLogAction;
(function (LobbyAuditLogAction) {
    LobbyAuditLogAction["Ended"] = "ENDED";
    LobbyAuditLogAction["Restarted"] = "RESTARTED";
})(LobbyAuditLogAction || (LobbyAuditLogAction = {}));
/** Lobby event type which controls logic and workflows */
export var LobbyEventType;
(function (LobbyEventType) {
    LobbyEventType["Queued"] = "QUEUED";
    LobbyEventType["Single"] = "SINGLE";
})(LobbyEventType || (LobbyEventType = {}));
/** Interviewer status for the lobby event */
export var LobbyInterviewerStatus;
(function (LobbyInterviewerStatus) {
    LobbyInterviewerStatus["Active"] = "ACTIVE";
    LobbyInterviewerStatus["Inactive"] = "INACTIVE";
})(LobbyInterviewerStatus || (LobbyInterviewerStatus = {}));
/** The status of the lobby event */
export var LobbyStatus;
(function (LobbyStatus) {
    LobbyStatus["Archived"] = "ARCHIVED";
    LobbyStatus["Canceled"] = "CANCELED";
    LobbyStatus["Ended"] = "ENDED";
    LobbyStatus["Scheduled"] = "SCHEDULED";
    LobbyStatus["Started"] = "STARTED";
    LobbyStatus["Unknown"] = "UNKNOWN";
})(LobbyStatus || (LobbyStatus = {}));
/** The type of the user that performs certain actions */
export var LobbyUserType;
(function (LobbyUserType) {
    /** Indicates that the user was performed by an employer */
    LobbyUserType["Employer"] = "EMPLOYER";
    /** Indicates that the user was performed by a job seeker */
    LobbyUserType["JobSeeker"] = "JOB_SEEKER";
})(LobbyUserType || (LobbyUserType = {}));
export var LocationAutocompleteSource;
(function (LocationAutocompleteSource) {
    LocationAutocompleteSource["GeocoderFallback"] = "GEOCODER_FALLBACK";
    LocationAutocompleteSource["Precisely"] = "PRECISELY";
})(LocationAutocompleteSource || (LocationAutocompleteSource = {}));
/** Since unions are not allowed in inputs, this is an enum that maps to the LocationInfo union in the return object */
export var LocationInfoType;
(function (LocationInfoType) {
    LocationInfoType["EmployerInterviewHostedAudioLocationInfo"] = "EMPLOYER_INTERVIEW_HOSTED_AUDIO_LOCATION_INFO";
    LocationInfoType["EmployerInterviewHostedVideoLocationInfo"] = "EMPLOYER_INTERVIEW_HOSTED_VIDEO_LOCATION_INFO";
    LocationInfoType["EmployerInterviewPhoneLocationInfo"] = "EMPLOYER_INTERVIEW_PHONE_LOCATION_INFO";
    LocationInfoType["EmployerInterviewPhoneRelayLocationInfo"] = "EMPLOYER_INTERVIEW_PHONE_RELAY_LOCATION_INFO";
    LocationInfoType["EmployerInterviewPhysicalLocationInfo"] = "EMPLOYER_INTERVIEW_PHYSICAL_LOCATION_INFO";
    LocationInfoType["EmployerInterviewThirdPartyVideoLocationInfo"] = "EMPLOYER_INTERVIEW_THIRD_PARTY_VIDEO_LOCATION_INFO";
    LocationInfoType["EmployerInterviewUntrackedPhoneLocationInfo"] = "EMPLOYER_INTERVIEW_UNTRACKED_PHONE_LOCATION_INFO";
})(LocationInfoType || (LocationInfoType = {}));
/** The different types that a location in the hierarchy can be. */
export var LocationType;
(function (LocationType) {
    LocationType["Admin1"] = "ADMIN1";
    LocationType["Admin2"] = "ADMIN2";
    LocationType["Admin3"] = "ADMIN3";
    LocationType["Admin4"] = "ADMIN4";
    LocationType["Airport"] = "AIRPORT";
    LocationType["City"] = "CITY";
    LocationType["Country"] = "COUNTRY";
    LocationType["Misc"] = "MISC";
    LocationType["PostalCode"] = "POSTAL_CODE";
    LocationType["PostalPlace"] = "POSTAL_PLACE";
    LocationType["PreciseLocation"] = "PRECISE_LOCATION";
    LocationType["Station"] = "STATION";
    LocationType["Water"] = "WATER";
})(LocationType || (LocationType = {}));
/** Enumeration of possible conversation lock reasons. DEPRECATED */
export var LockReason;
(function (LockReason) {
    LockReason["BroadcastIneligible"] = "BROADCAST_INELIGIBLE";
    LockReason["DeprecatedProduct"] = "DEPRECATED_PRODUCT";
    LockReason["ImsNotMigrated"] = "IMS_NOT_MIGRATED";
})(LockReason || (LockReason = {}));
/** Data type to be fetched from backend service and logged. */
export var LogDataType;
(function (LogDataType) {
    /** Fetch JQO Score and Log. */
    LogDataType["JqoScore"] = "JQO_SCORE";
})(LogDataType || (LogDataType = {}));
export var LogEventType;
(function (LogEventType) {
    LogEventType["Answered"] = "ANSWERED";
    LogEventType["Rendered"] = "RENDERED";
})(LogEventType || (LogEventType = {}));
export var MocStatus;
(function (MocStatus) {
    MocStatus["MocInsufficientJsData"] = "MOC_INSUFFICIENT_JS_DATA";
    MocStatus["MocMet"] = "MOC_MET";
    MocStatus["MocNotApplicable"] = "MOC_NOT_APPLICABLE";
    MocStatus["MocNotYetDefined"] = "MOC_NOT_YET_DEFINED";
    MocStatus["MocUnmet"] = "MOC_UNMET";
})(MocStatus || (MocStatus = {}));
/** MRP hires needed copied from IntHiresNeeded, will be deprecated when we add a job data source */
export var MrpHiresNeeded;
(function (MrpHiresNeeded) {
    MrpHiresNeeded["Eight"] = "EIGHT";
    MrpHiresNeeded["Empty"] = "EMPTY";
    MrpHiresNeeded["Five"] = "FIVE";
    MrpHiresNeeded["Four"] = "FOUR";
    MrpHiresNeeded["Nine"] = "NINE";
    MrpHiresNeeded["One"] = "ONE";
    MrpHiresNeeded["RecurringHire"] = "RECURRING_HIRE";
    MrpHiresNeeded["Seven"] = "SEVEN";
    MrpHiresNeeded["Six"] = "SIX";
    MrpHiresNeeded["Ten"] = "TEN";
    MrpHiresNeeded["TenPlus"] = "TEN_PLUS";
    MrpHiresNeeded["Three"] = "THREE";
    MrpHiresNeeded["Two"] = "TWO";
})(MrpHiresNeeded || (MrpHiresNeeded = {}));
/** MRP job salary period copied from JobSalaryPeriod, will be deprecated when we add a job data source */
export var MrpJobSalaryPeriod;
(function (MrpJobSalaryPeriod) {
    MrpJobSalaryPeriod["Day"] = "DAY";
    MrpJobSalaryPeriod["Hour"] = "HOUR";
    MrpJobSalaryPeriod["Ignore"] = "IGNORE";
    MrpJobSalaryPeriod["Mile"] = "MILE";
    MrpJobSalaryPeriod["Month"] = "MONTH";
    MrpJobSalaryPeriod["Week"] = "WEEK";
    MrpJobSalaryPeriod["Year"] = "YEAR";
})(MrpJobSalaryPeriod || (MrpJobSalaryPeriod = {}));
/** Job segments adopted from elephant-i2a */
export var MrpJobSegment;
(function (MrpJobSegment) {
    /** Job was posted today */
    MrpJobSegment["Day0"] = "DAY0";
    MrpJobSegment["Ignore"] = "IGNORE";
    /** Job was not posted today */
    MrpJobSegment["PostDay0"] = "POST_DAY0";
    MrpJobSegment["Reactivate"] = "REACTIVATE";
    /** Job engagement is originating from SMB resume */
    MrpJobSegment["Smbrez"] = "SMBREZ";
    MrpJobSegment["Unknown"] = "UNKNOWN";
})(MrpJobSegment || (MrpJobSegment = {}));
/** MRP job type copied from JobType, will be deprecated when we add a job data source */
export var MrpJobType;
(function (MrpJobType) {
    MrpJobType["Apprenticeship"] = "APPRENTICESHIP";
    MrpJobType["Casual"] = "CASUAL";
    MrpJobType["Commission"] = "COMMISSION";
    MrpJobType["Contract"] = "CONTRACT";
    /** @deprecated Unsupported */
    MrpJobType["Custom_1"] = "CUSTOM_1";
    MrpJobType["FlyinFlyout"] = "FLYIN_FLYOUT";
    MrpJobType["FullTime"] = "FULL_TIME";
    MrpJobType["Internship"] = "INTERNSHIP";
    MrpJobType["NewGrad"] = "NEW_GRAD";
    /** @deprecated Unsupported */
    MrpJobType["Nonprofit"] = "NONPROFIT";
    /** @deprecated Unsupported */
    MrpJobType["Other"] = "OTHER";
    MrpJobType["PartTime"] = "PART_TIME";
    MrpJobType["Permanent"] = "PERMANENT";
    MrpJobType["Recruiter"] = "RECRUITER";
    /** @deprecated Unsupported */
    MrpJobType["Spam"] = "SPAM";
    MrpJobType["Subcontract"] = "SUBCONTRACT";
    /** @deprecated Unsupported */
    MrpJobType["Telecommute"] = "TELECOMMUTE";
    MrpJobType["Temporary"] = "TEMPORARY";
    MrpJobType["Volunteer"] = "VOLUNTEER";
})(MrpJobType || (MrpJobType = {}));
/** Development status of a manifest, controlling which environments it is loaded in. */
export var ManifestStatus;
(function (ManifestStatus) {
    /** Loads in all environments (local, QA, PROD). */
    ManifestStatus["Active"] = "ACTIVE";
    /** Loads only in local environment. */
    ManifestStatus["InDevelopment"] = "IN_DEVELOPMENT";
    /** Loads in local and QA environments only. */
    ManifestStatus["ReadyForQa"] = "READY_FOR_QA";
})(ManifestStatus || (ManifestStatus = {}));
/** The purpose of a manual review batch, distinguishing the original calibration flow from shortlist batches */
export var ManualReviewBatchPurpose;
(function (ManualReviewBatchPurpose) {
    /** The original manual-review/calibration batch */
    ManualReviewBatchPurpose["Calibration"] = "CALIBRATION";
    /** A shortlist batch generated for the HITL shortlist concept */
    ManualReviewBatchPurpose["Shortlist"] = "SHORTLIST";
})(ManualReviewBatchPurpose || (ManualReviewBatchPurpose = {}));
/** Represents the state of a manual review batch */
export var ManualReviewBatchState;
(function (ManualReviewBatchState) {
    /** Deep Sourcing has been triggered and we are waiting for candidates */
    ManualReviewBatchState["Fetching"] = "FETCHING";
    /** Outreaches are currently being sent for this batch */
    ManualReviewBatchState["Processing"] = "PROCESSING";
    /** The batch has candidates and is ready for review */
    ManualReviewBatchState["Ready"] = "READY";
    /** The batch is in FETCHING state but has been waiting for more than 5 minutes */
    ManualReviewBatchState["TimedOut"] = "TIMED_OUT";
})(ManualReviewBatchState || (ManualReviewBatchState = {}));
/** Represents the review state of a candidate in a manual review batch */
export var ManualReviewCandidateState;
(function (ManualReviewCandidateState) {
    /** Candidate is included and will receive outreach if batch is approved */
    ManualReviewCandidateState["Included"] = "INCLUDED";
    /** Candidate was rejected by the reviewer and will not receive outreach */
    ManualReviewCandidateState["Rejected"] = "REJECTED";
    /** Candidate was explicitly saved/kept by the reviewer during single-candidate review */
    ManualReviewCandidateState["Saved"] = "SAVED";
})(ManualReviewCandidateState || (ManualReviewCandidateState = {}));
/**  Granularity of which map item to correspond data with  */
export var MapGranularity;
(function (MapGranularity) {
    MapGranularity["Admin1"] = "ADMIN1";
    MapGranularity["Admin2"] = "ADMIN2";
    MapGranularity["City"] = "CITY";
})(MapGranularity || (MapGranularity = {}));
export var MatchComparisonEngineInterestedParty;
(function (MatchComparisonEngineInterestedParty) {
    MatchComparisonEngineInterestedParty["Job"] = "JOB";
    MatchComparisonEngineInterestedParty["JobSeeker"] = "JOB_SEEKER";
})(MatchComparisonEngineInterestedParty || (MatchComparisonEngineInterestedParty = {}));
export var MatchComparisonEngineMatchType;
(function (MatchComparisonEngineMatchType) {
    MatchComparisonEngineMatchType["JobOnly"] = "JOB_ONLY";
    MatchComparisonEngineMatchType["JsOnly"] = "JS_ONLY";
    MatchComparisonEngineMatchType["Match"] = "MATCH";
    MatchComparisonEngineMatchType["Mismatch"] = "MISMATCH";
})(MatchComparisonEngineMatchType || (MatchComparisonEngineMatchType = {}));
export var MatchComparisonEngineProvenance;
(function (MatchComparisonEngineProvenance) {
    MatchComparisonEngineProvenance["BehavioralInferred"] = "BEHAVIORAL_INFERRED";
    MatchComparisonEngineProvenance["Confirmed"] = "CONFIRMED";
    MatchComparisonEngineProvenance["Extracted"] = "EXTRACTED";
    MatchComparisonEngineProvenance["HighConfidenceDeducedFromConfirmed"] = "HIGH_CONFIDENCE_DEDUCED_FROM_CONFIRMED";
    MatchComparisonEngineProvenance["HighConfidenceDeducedFromExtracted"] = "HIGH_CONFIDENCE_DEDUCED_FROM_EXTRACTED";
    MatchComparisonEngineProvenance["NotPresent"] = "NOT_PRESENT";
})(MatchComparisonEngineProvenance || (MatchComparisonEngineProvenance = {}));
export var MatchComparisonEngineRequirementStrength;
(function (MatchComparisonEngineRequirementStrength) {
    MatchComparisonEngineRequirementStrength["MustHaveJobRequirement"] = "MUST_HAVE_JOB_REQUIREMENT";
    MatchComparisonEngineRequirementStrength["MustHaveSq"] = "MUST_HAVE_SQ";
    MatchComparisonEngineRequirementStrength["NiceToHaveJobRequirement"] = "NICE_TO_HAVE_JOB_REQUIREMENT";
    MatchComparisonEngineRequirementStrength["NiceToHaveSq"] = "NICE_TO_HAVE_SQ";
    MatchComparisonEngineRequirementStrength["None"] = "NONE";
})(MatchComparisonEngineRequirementStrength || (MatchComparisonEngineRequirementStrength = {}));
export var MatchComparisonEngineTrafficLightSignal;
(function (MatchComparisonEngineTrafficLightSignal) {
    MatchComparisonEngineTrafficLightSignal["Green"] = "GREEN";
    MatchComparisonEngineTrafficLightSignal["Red"] = "RED";
    MatchComparisonEngineTrafficLightSignal["Yellow"] = "YELLOW";
})(MatchComparisonEngineTrafficLightSignal || (MatchComparisonEngineTrafficLightSignal = {}));
/** Importance levels for match criteria. */
export var MatchCriterionImportance;
(function (MatchCriterionImportance) {
    MatchCriterionImportance["Ignore"] = "IGNORE";
    MatchCriterionImportance["Preferred"] = "PREFERRED";
    MatchCriterionImportance["Required"] = "REQUIRED";
})(MatchCriterionImportance || (MatchCriterionImportance = {}));
/** Enum of the possible sources of match explanation data */
export var MatchExplanationSource;
(function (MatchExplanationSource) {
    MatchExplanationSource["JobRequirement"] = "JOB_REQUIREMENT";
    MatchExplanationSource["JobScreenerQuestion"] = "JOB_SCREENER_QUESTION";
    MatchExplanationSource["JsProfile"] = "JS_PROFILE";
    MatchExplanationSource["JsResume"] = "JS_RESUME";
    MatchExplanationSource["JsScreenerQuestionAnswer"] = "JS_SCREENER_QUESTION_ANSWER";
    MatchExplanationSource["JsSkillConnect"] = "JS_SKILL_CONNECT";
})(MatchExplanationSource || (MatchExplanationSource = {}));
/** Enum to determine if a match explanation source pertains to jobseeker attributes or job attributes. */
export var MatchExplanationSourceType;
(function (MatchExplanationSourceType) {
    MatchExplanationSourceType["Job"] = "JOB";
    MatchExplanationSourceType["Jobseeker"] = "JOBSEEKER";
})(MatchExplanationSourceType || (MatchExplanationSourceType = {}));
/** Distance units for location boundaries. */
export var MatchFeatureDistanceUnit;
(function (MatchFeatureDistanceUnit) {
    MatchFeatureDistanceUnit["Kilometers"] = "KILOMETERS";
    MatchFeatureDistanceUnit["Miles"] = "MILES";
})(MatchFeatureDistanceUnit || (MatchFeatureDistanceUnit = {}));
/** Location types for match features. */
export var MatchFeatureLocationType;
(function (MatchFeatureLocationType) {
    MatchFeatureLocationType["Admin1"] = "ADMIN1";
    MatchFeatureLocationType["Admin2"] = "ADMIN2";
    MatchFeatureLocationType["Admin3"] = "ADMIN3";
    MatchFeatureLocationType["Admin4"] = "ADMIN4";
    MatchFeatureLocationType["Admin5"] = "ADMIN5";
    MatchFeatureLocationType["Admin6"] = "ADMIN6";
    MatchFeatureLocationType["Airport"] = "AIRPORT";
    MatchFeatureLocationType["City"] = "CITY";
    MatchFeatureLocationType["Country"] = "COUNTRY";
    MatchFeatureLocationType["Misc"] = "MISC";
    MatchFeatureLocationType["PostalCode"] = "POSTAL_CODE";
    MatchFeatureLocationType["PostalPlace"] = "POSTAL_PLACE";
    MatchFeatureLocationType["PreciseLocation"] = "PRECISE_LOCATION";
    MatchFeatureLocationType["Station"] = "STATION";
    MatchFeatureLocationType["Water"] = "WATER";
    MatchFeatureLocationType["Zipcode"] = "ZIPCODE";
})(MatchFeatureLocationType || (MatchFeatureLocationType = {}));
/** Operator types for match features. */
export var MatchFeatureOperatorType;
(function (MatchFeatureOperatorType) {
    MatchFeatureOperatorType["Eq"] = "EQ";
    MatchFeatureOperatorType["Gt"] = "GT";
    MatchFeatureOperatorType["Gte"] = "GTE";
    MatchFeatureOperatorType["Lt"] = "LT";
    MatchFeatureOperatorType["Lte"] = "LTE";
    MatchFeatureOperatorType["Neq"] = "NEQ";
})(MatchFeatureOperatorType || (MatchFeatureOperatorType = {}));
/** Operator for combining child nodes in a match feature tree. */
export var MatchFeatureTreeOperator;
(function (MatchFeatureTreeOperator) {
    MatchFeatureTreeOperator["And"] = "AND";
    MatchFeatureTreeOperator["In"] = "IN";
    MatchFeatureTreeOperator["Or"] = "OR";
})(MatchFeatureTreeOperator || (MatchFeatureTreeOperator = {}));
/**
 * Match feature types for candidate matching.
 * NOTE TO RCP DEVELOPERS AND LLMs - ADD TO THIS LIST JUDICIOUSLY,
 * THESE ALLOW CLIENTS DIRECT ACCESS TO FILTERING!
 */
export var MatchFeatureType;
(function (MatchFeatureType) {
    MatchFeatureType["AvailableImmediately"] = "AVAILABLE_IMMEDIATELY";
    MatchFeatureType["Certification"] = "CERTIFICATION";
    MatchFeatureType["Company"] = "COMPANY";
    MatchFeatureType["ContactMethod"] = "CONTACT_METHOD";
    MatchFeatureType["DislikedByEmployer"] = "DISLIKED_BY_EMPLOYER";
    MatchFeatureType["EducationLevel"] = "EDUCATION_LEVEL";
    MatchFeatureType["ExcludeExperienceWithEmployer"] = "EXCLUDE_EXPERIENCE_WITH_EMPLOYER";
    MatchFeatureType["ExperienceLevel"] = "EXPERIENCE_LEVEL";
    MatchFeatureType["HiringStatus"] = "HIRING_STATUS";
    MatchFeatureType["JobTitle"] = "JOB_TITLE";
    MatchFeatureType["JobType"] = "JOB_TYPE";
    MatchFeatureType["Language"] = "LANGUAGE";
    MatchFeatureType["LastActive"] = "LAST_ACTIVE";
    MatchFeatureType["LastApplied"] = "LAST_APPLIED";
    MatchFeatureType["LastContacted"] = "LAST_CONTACTED";
    MatchFeatureType["License"] = "LICENSE";
    MatchFeatureType["Location"] = "LOCATION";
    MatchFeatureType["MaxResumeAge"] = "MAX_RESUME_AGE";
    MatchFeatureType["MeetsJobMinimumRequirements"] = "MEETS_JOB_MINIMUM_REQUIREMENTS";
    MatchFeatureType["MilitaryService"] = "MILITARY_SERVICE";
    MatchFeatureType["MonthsAtCurrentJob"] = "MONTHS_AT_CURRENT_JOB";
    MatchFeatureType["MonthsOfExperience"] = "MONTHS_OF_EXPERIENCE";
    MatchFeatureType["Pay"] = "PAY";
    MatchFeatureType["Relocation"] = "RELOCATION";
    MatchFeatureType["SecurityClearance"] = "SECURITY_CLEARANCE";
    MatchFeatureType["SelfReportedCredentialStatus"] = "SELF_REPORTED_CREDENTIAL_STATUS";
    MatchFeatureType["Skill"] = "SKILL";
    MatchFeatureType["SourceCreationDate"] = "SOURCE_CREATION_DATE";
    MatchFeatureType["WorkAuthorization"] = "WORK_AUTHORIZATION";
})(MatchFeatureType || (MatchFeatureType = {}));
export var MatchFitLabel;
(function (MatchFitLabel) {
    MatchFitLabel["ModerateMatch"] = "MODERATE_MATCH";
    MatchFitLabel["NoMatch"] = "NO_MATCH";
    MatchFitLabel["StrongMatch"] = "STRONG_MATCH";
    MatchFitLabel["TopMatch"] = "TOP_MATCH";
    MatchFitLabel["Unknown"] = "UNKNOWN";
    MatchFitLabel["WeakMatch"] = "WEAK_MATCH";
})(MatchFitLabel || (MatchFitLabel = {}));
/** The type of pipeline component that produced a metadata entry. */
export var MatchMetadataComponentType;
(function (MatchMetadataComponentType) {
    MatchMetadataComponentType["Ranker"] = "RANKER";
})(MatchMetadataComponentType || (MatchMetadataComponentType = {}));
/** TODO: Provide description on this enum. */
export var MatchPayloadStatusCode;
(function (MatchPayloadStatusCode) {
    MatchPayloadStatusCode["Success"] = "SUCCESS";
})(MatchPayloadStatusCode || (MatchPayloadStatusCode = {}));
export var MatchProfileDocumentChangeType;
(function (MatchProfileDocumentChangeType) {
    MatchProfileDocumentChangeType["Added"] = "ADDED";
    MatchProfileDocumentChangeType["Changed"] = "CHANGED";
    MatchProfileDocumentChangeType["Moderated"] = "MODERATED";
    MatchProfileDocumentChangeType["Removed"] = "REMOVED";
})(MatchProfileDocumentChangeType || (MatchProfileDocumentChangeType = {}));
export var MatchProfileDocumentCriteriaSource;
(function (MatchProfileDocumentCriteriaSource) {
    MatchProfileDocumentCriteriaSource["MatchCriteria"] = "MATCH_CRITERIA";
    MatchProfileDocumentCriteriaSource["ScreeningCriteria"] = "SCREENING_CRITERIA";
})(MatchProfileDocumentCriteriaSource || (MatchProfileDocumentCriteriaSource = {}));
/** Enum for match strategy. */
export var MatchStrategy;
(function (MatchStrategy) {
    /** Answer must match all provided values. */
    MatchStrategy["All"] = "ALL";
    /** Answer can match any provided value. */
    MatchStrategy["Any"] = "ANY";
})(MatchStrategy || (MatchStrategy = {}));
/** An enum of the possible types (pos/negative etc) of matches between a job / jobseeker match. */
export var MatchType;
(function (MatchType) {
    MatchType["CandidateJourney"] = "CANDIDATE_JOURNEY";
    MatchType["CandidateSubmission"] = "CANDIDATE_SUBMISSION";
    MatchType["JobSeeker"] = "JOB_SEEKER";
    /** It's a mismatch */
    MatchType["Negative"] = "NEGATIVE";
    /** The information available does not indicate either a match or a mismatch */
    MatchType["Neutral"] = "NEUTRAL";
    /** It's a match */
    MatchType["Positive"] = "POSITIVE";
    /** We don't have enough information */
    MatchType["Unknown"] = "UNKNOWN";
})(MatchType || (MatchType = {}));
/**  What type of search the algorithm expanded by when generating insights.  */
export var MatchedLevelType;
(function (MatchedLevelType) {
    /**  Algorithm expanded to the country level.  */
    MatchedLevelType["CountryWide"] = "COUNTRY_WIDE";
    /**  Algorithm did not expand due to finding an exact match.  */
    MatchedLevelType["ExactMatch"] = "EXACT_MATCH";
    /**  Algorithm expanded to multiple locations.  */
    MatchedLevelType["ExpandedLocations"] = "EXPANDED_LOCATIONS";
    /**  Algorithm expanded to multiple locations and multiple similar norm titles.  */
    MatchedLevelType["ExpandedLocationsAndTitles"] = "EXPANDED_LOCATIONS_AND_TITLES";
    /**  Algorithm expanded by multiple similar norm titles.  */
    MatchedLevelType["ExpandedTitles"] = "EXPANDED_TITLES";
    /**  Algorithm expanded to the state level.  */
    MatchedLevelType["StateWide"] = "STATE_WIDE";
})(MatchedLevelType || (MatchedLevelType = {}));
export var McpTransport;
(function (McpTransport) {
    /** SSE (deprecated) */
    McpTransport["Sse"] = "SSE";
    /** STREAMABLE_HTTP */
    McpTransport["StreamableHttp"] = "STREAMABLE_HTTP";
})(McpTransport || (McpTransport = {}));
export var MdpActivityType;
(function (MdpActivityType) {
    MdpActivityType["Disliked"] = "DISLIKED";
    MdpActivityType["EmployerRelevanceSurvey"] = "EMPLOYER_RELEVANCE_SURVEY";
    MdpActivityType["Invited"] = "INVITED";
    MdpActivityType["Liked"] = "LIKED";
    MdpActivityType["UnknownActivityType"] = "UNKNOWN_ACTIVITY_TYPE";
})(MdpActivityType || (MdpActivityType = {}));
export var MdpAttributeSource;
(function (MdpAttributeSource) {
    MdpAttributeSource["Deduced"] = "DEDUCED";
    MdpAttributeSource["Employer"] = "EMPLOYER";
    MdpAttributeSource["Extracted"] = "EXTRACTED";
    MdpAttributeSource["ExtractedCrowtagMatchTag"] = "EXTRACTED_CROWTAG_MATCH_TAG";
    MdpAttributeSource["ExtractedCrowtagOqvtTag"] = "EXTRACTED_CROWTAG_OQVT_TAG";
    MdpAttributeSource["HighRecall"] = "HIGH_RECALL";
    MdpAttributeSource["NotApplicableOrUnknown"] = "NOT_APPLICABLE_OR_UNKNOWN";
    MdpAttributeSource["UnknownAttributeSource"] = "UNKNOWN_ATTRIBUTE_SOURCE";
})(MdpAttributeSource || (MdpAttributeSource = {}));
export var MdpAutoRenewStatus;
(function (MdpAutoRenewStatus) {
    MdpAutoRenewStatus["Disabled"] = "DISABLED";
    MdpAutoRenewStatus["Enabled"] = "ENABLED";
    MdpAutoRenewStatus["UnknownAutoRenewStatus"] = "UNKNOWN_AUTO_RENEW_STATUS";
})(MdpAutoRenewStatus || (MdpAutoRenewStatus = {}));
export var MdpBarrierStatus;
(function (MdpBarrierStatus) {
    MdpBarrierStatus["DoesNotMeetCriteria"] = "DOES_NOT_MEET_CRITERIA";
    MdpBarrierStatus["MeetsCriteria"] = "MEETS_CRITERIA";
    MdpBarrierStatus["UnknownStatus"] = "UNKNOWN_STATUS";
})(MdpBarrierStatus || (MdpBarrierStatus = {}));
export var MdpBrand;
(function (MdpBrand) {
    MdpBrand["Airwork"] = "AIRWORK";
    MdpBrand["Birumentenshokunavi"] = "BIRUMENTENSHOKUNAVI";
    MdpBrand["Careesma"] = "CAREESMA";
    MdpBrand["Domonet"] = "DOMONET";
    MdpBrand["Dstarnet"] = "DSTARNET";
    MdpBrand["Engineerjobs"] = "ENGINEERJOBS";
    MdpBrand["Froma"] = "FROMA";
    MdpBrand["Gatenshoku"] = "GATENSHOKU";
    MdpBrand["Gigajob"] = "GIGAJOB";
    MdpBrand["Glassdoor"] = "GLASSDOOR";
    MdpBrand["Hatalike"] = "HATALIKE";
    MdpBrand["Indeed"] = "INDEED";
    MdpBrand["Jimoty"] = "JIMOTY";
    MdpBrand["Kyujinascom"] = "KYUJINASCOM";
    MdpBrand["Kyujinbox"] = "KYUJINBOX";
    MdpBrand["Kyujinjournal"] = "KYUJINJOURNAL";
    MdpBrand["Qiitacareers"] = "QIITACAREERS";
    MdpBrand["Ragsite"] = "RAGSITE";
    MdpBrand["Rikunabihaken"] = "RIKUNABIHAKEN";
    MdpBrand["Rikunabinewgrad"] = "RIKUNABINEWGRAD";
    MdpBrand["Rikunabinext"] = "RIKUNABINEXT";
    MdpBrand["Seniorkyujinnavi"] = "SENIORKYUJINNAVI";
    MdpBrand["Shufukita"] = "SHUFUKITA";
    MdpBrand["Simplyhired"] = "SIMPLYHIRED";
    MdpBrand["Torabayu"] = "TORABAYU";
    MdpBrand["Townwork"] = "TOWNWORK";
    MdpBrand["UnknownBrand"] = "UNKNOWN_BRAND";
    MdpBrand["Verticallogistics"] = "VERTICALLOGISTICS";
    MdpBrand["Verticalspotjob"] = "VERTICALSPOTJOB";
    MdpBrand["Workopolis"] = "WORKOPOLIS";
    MdpBrand["Wowjobs"] = "WOWJOBS";
})(MdpBrand || (MdpBrand = {}));
export var MdpCatalogEntityDataAvailabilityOption;
(function (MdpCatalogEntityDataAvailabilityOption) {
    MdpCatalogEntityDataAvailabilityOption["OfflineAvailable"] = "OFFLINE_AVAILABLE";
    MdpCatalogEntityDataAvailabilityOption["OnlineAvailable"] = "ONLINE_AVAILABLE";
    MdpCatalogEntityDataAvailabilityOption["OnlineIntegrationAvailable"] = "ONLINE_INTEGRATION_AVAILABLE";
})(MdpCatalogEntityDataAvailabilityOption || (MdpCatalogEntityDataAvailabilityOption = {}));
export var MdpCatalogEntityDomainOption;
(function (MdpCatalogEntityDomainOption) {
    MdpCatalogEntityDomainOption["CandidateSubmission"] = "CANDIDATE_SUBMISSION";
    MdpCatalogEntityDomainOption["Employer"] = "EMPLOYER";
    MdpCatalogEntityDomainOption["IntentProfile"] = "INTENT_PROFILE";
    MdpCatalogEntityDomainOption["Job"] = "JOB";
    MdpCatalogEntityDomainOption["JobSeeker"] = "JOB_SEEKER";
    MdpCatalogEntityDomainOption["None"] = "NONE";
})(MdpCatalogEntityDomainOption || (MdpCatalogEntityDomainOption = {}));
export var MdpCatalogEntityMaturityOption;
(function (MdpCatalogEntityMaturityOption) {
    MdpCatalogEntityMaturityOption["ProdStable"] = "PROD_STABLE";
    MdpCatalogEntityMaturityOption["ProdUnmanagedSlo"] = "PROD_UNMANAGED_SLO";
})(MdpCatalogEntityMaturityOption || (MdpCatalogEntityMaturityOption = {}));
export var MdpCatalogEntityTypeOption;
(function (MdpCatalogEntityTypeOption) {
    MdpCatalogEntityTypeOption["AggregatedEnhancedEvent"] = "AGGREGATED_ENHANCED_EVENT";
    MdpCatalogEntityTypeOption["EnhancedEvent"] = "ENHANCED_EVENT";
    MdpCatalogEntityTypeOption["FeatureGroup"] = "FEATURE_GROUP";
    MdpCatalogEntityTypeOption["RawEvent"] = "RAW_EVENT";
})(MdpCatalogEntityTypeOption || (MdpCatalogEntityTypeOption = {}));
export var MdpClientType;
(function (MdpClientType) {
    MdpClientType["Mobile"] = "MOBILE";
    MdpClientType["UnknownClientType"] = "UNKNOWN_CLIENT_TYPE";
    MdpClientType["Web"] = "WEB";
})(MdpClientType || (MdpClientType = {}));
export var MdpContentPageType;
(function (MdpContentPageType) {
    MdpContentPageType["CareerGuide"] = "CAREER_GUIDE";
    MdpContentPageType["CareerPage"] = "CAREER_PAGE";
    MdpContentPageType["CompanyJobs"] = "COMPANY_JOBS";
    MdpContentPageType["Review"] = "REVIEW";
    MdpContentPageType["Salary"] = "SALARY";
    MdpContentPageType["UnknownPageType"] = "UNKNOWN_PAGE_TYPE";
})(MdpContentPageType || (MdpContentPageType = {}));
export var MdpCoreJobDataAttributeSource;
(function (MdpCoreJobDataAttributeSource) {
    MdpCoreJobDataAttributeSource["Employer"] = "EMPLOYER";
    MdpCoreJobDataAttributeSource["Extracted"] = "EXTRACTED";
    MdpCoreJobDataAttributeSource["RequirementModel"] = "REQUIREMENT_MODEL";
    MdpCoreJobDataAttributeSource["UnknownCoreJobDataAttributeSource"] = "UNKNOWN_CORE_JOB_DATA_ATTRIBUTE_SOURCE";
})(MdpCoreJobDataAttributeSource || (MdpCoreJobDataAttributeSource = {}));
export var MdpCoreJobDataRequirementLevel;
(function (MdpCoreJobDataRequirementLevel) {
    MdpCoreJobDataRequirementLevel["Optional"] = "OPTIONAL";
    MdpCoreJobDataRequirementLevel["Required"] = "REQUIRED";
    MdpCoreJobDataRequirementLevel["UnknownCoreJobDataRequirementLevel"] = "UNKNOWN_CORE_JOB_DATA_REQUIREMENT_LEVEL";
})(MdpCoreJobDataRequirementLevel || (MdpCoreJobDataRequirementLevel = {}));
export var MdpCriterionCategory;
(function (MdpCriterionCategory) {
    MdpCriterionCategory["AnyCompany"] = "ANY_COMPANY";
    MdpCriterionCategory["AvailableImmediately"] = "AVAILABLE_IMMEDIATELY";
    MdpCriterionCategory["AvgMonthsPerJob"] = "AVG_MONTHS_PER_JOB";
    MdpCriterionCategory["Certification"] = "CERTIFICATION";
    MdpCriterionCategory["CurrentCompany"] = "CURRENT_COMPANY";
    MdpCriterionCategory["EducationLevel"] = "EDUCATION_LEVEL";
    MdpCriterionCategory["JobTitle"] = "JOB_TITLE";
    MdpCriterionCategory["License"] = "LICENSE";
    MdpCriterionCategory["Location"] = "LOCATION";
    MdpCriterionCategory["LocationRadiusMiles"] = "LOCATION_RADIUS_MILES";
    MdpCriterionCategory["Moe"] = "MOE";
    MdpCriterionCategory["MonthsAtCurrentJob"] = "MONTHS_AT_CURRENT_JOB";
    MdpCriterionCategory["Other"] = "OTHER";
    MdpCriterionCategory["Skill"] = "SKILL";
    MdpCriterionCategory["UnknownCriterionCategory"] = "UNKNOWN_CRITERION_CATEGORY";
})(MdpCriterionCategory || (MdpCriterionCategory = {}));
export var MdpCriterionImportance;
(function (MdpCriterionImportance) {
    MdpCriterionImportance["Preferred"] = "PREFERRED";
    MdpCriterionImportance["Required"] = "REQUIRED";
    MdpCriterionImportance["UnknownCriterionImportance"] = "UNKNOWN_CRITERION_IMPORTANCE";
})(MdpCriterionImportance || (MdpCriterionImportance = {}));
export var MdpCriterionNormalizedValueType;
(function (MdpCriterionNormalizedValueType) {
    MdpCriterionNormalizedValueType["CrowtaxoSuid"] = "CROWTAXO_SUID";
    MdpCriterionNormalizedValueType["FccId"] = "FCC_ID";
    MdpCriterionNormalizedValueType["OccupationSuid"] = "OCCUPATION_SUID";
    MdpCriterionNormalizedValueType["RawValue"] = "RAW_VALUE";
    MdpCriterionNormalizedValueType["Suid"] = "SUID";
    MdpCriterionNormalizedValueType["UnknownCriterionNormalizedValueType"] = "UNKNOWN_CRITERION_NORMALIZED_VALUE_TYPE";
})(MdpCriterionNormalizedValueType || (MdpCriterionNormalizedValueType = {}));
export var MdpCriterionOperator;
(function (MdpCriterionOperator) {
    MdpCriterionOperator["Eq"] = "EQ";
    MdpCriterionOperator["Exclude"] = "EXCLUDE";
    MdpCriterionOperator["Gte"] = "GTE";
    MdpCriterionOperator["Lte"] = "LTE";
    MdpCriterionOperator["Neq"] = "NEQ";
    MdpCriterionOperator["UnknownCriterionOperator"] = "UNKNOWN_CRITERION_OPERATOR";
})(MdpCriterionOperator || (MdpCriterionOperator = {}));
export var MdpDocumentSectionType;
(function (MdpDocumentSectionType) {
    MdpDocumentSectionType["JobDescription"] = "JOB_DESCRIPTION";
    MdpDocumentSectionType["JobDradisRemoteTag"] = "JOB_DRADIS_REMOTE_TAG";
    MdpDocumentSectionType["JobLocation"] = "JOB_LOCATION";
    MdpDocumentSectionType["JobMetadataCategory"] = "JOB_METADATA_CATEGORY";
    MdpDocumentSectionType["JobMetadataEducation"] = "JOB_METADATA_EDUCATION";
    MdpDocumentSectionType["JobMetadataExperience"] = "JOB_METADATA_EXPERIENCE";
    MdpDocumentSectionType["JobMetadataJobtype"] = "JOB_METADATA_JOBTYPE";
    MdpDocumentSectionType["JobMetadataSpecificCategory"] = "JOB_METADATA_SPECIFIC_CATEGORY";
    MdpDocumentSectionType["JobTagBenefits"] = "JOB_TAG_BENEFITS";
    MdpDocumentSectionType["JobTagRawLocation"] = "JOB_TAG_RAW_LOCATION";
    MdpDocumentSectionType["JobTagRawTitle"] = "JOB_TAG_RAW_TITLE";
    MdpDocumentSectionType["JobTagRemoteType"] = "JOB_TAG_REMOTE_TYPE";
    MdpDocumentSectionType["JobTagWorkEnvironment"] = "JOB_TAG_WORK_ENVIRONMENT";
    MdpDocumentSectionType["JobTagWorkSchedule"] = "JOB_TAG_WORK_SCHEDULE";
    MdpDocumentSectionType["JobTitle"] = "JOB_TITLE";
    MdpDocumentSectionType["ResumeAdditionalInfo"] = "RESUME_ADDITIONAL_INFO";
    MdpDocumentSectionType["ResumeAssessments"] = "RESUME_ASSESSMENTS";
    MdpDocumentSectionType["ResumeAssociations"] = "RESUME_ASSOCIATIONS";
    MdpDocumentSectionType["ResumeAwards"] = "RESUME_AWARDS";
    MdpDocumentSectionType["ResumeCertifications"] = "RESUME_CERTIFICATIONS";
    MdpDocumentSectionType["ResumeEducation"] = "RESUME_EDUCATION";
    MdpDocumentSectionType["ResumeExperience"] = "RESUME_EXPERIENCE";
    MdpDocumentSectionType["ResumeLicenses"] = "RESUME_LICENSES";
    MdpDocumentSectionType["ResumeLinks"] = "RESUME_LINKS";
    MdpDocumentSectionType["ResumeMilitaryService"] = "RESUME_MILITARY_SERVICE";
    MdpDocumentSectionType["ResumePatents"] = "RESUME_PATENTS";
    MdpDocumentSectionType["ResumePublications"] = "RESUME_PUBLICATIONS";
    MdpDocumentSectionType["ResumeSkill"] = "RESUME_SKILL";
    MdpDocumentSectionType["ResumeSummary"] = "RESUME_SUMMARY";
    MdpDocumentSectionType["ResumeTitle"] = "RESUME_TITLE";
    MdpDocumentSectionType["UnknownDocumentSectionType"] = "UNKNOWN_DOCUMENT_SECTION_TYPE";
})(MdpDocumentSectionType || (MdpDocumentSectionType = {}));
export var MdpDocumentationQualityRating;
(function (MdpDocumentationQualityRating) {
    MdpDocumentationQualityRating["Excellent"] = "EXCELLENT";
    MdpDocumentationQualityRating["Fair"] = "FAIR";
    MdpDocumentationQualityRating["Good"] = "GOOD";
    MdpDocumentationQualityRating["Poor"] = "POOR";
})(MdpDocumentationQualityRating || (MdpDocumentationQualityRating = {}));
export var MdpElephantSuidCategory;
(function (MdpElephantSuidCategory) {
    MdpElephantSuidCategory["Benefit"] = "BENEFIT";
    MdpElephantSuidCategory["Certification"] = "CERTIFICATION";
    MdpElephantSuidCategory["FieldsOfStudy"] = "FIELDS_OF_STUDY";
    MdpElephantSuidCategory["License"] = "LICENSE";
    MdpElephantSuidCategory["Shift"] = "SHIFT";
    MdpElephantSuidCategory["Skill"] = "SKILL";
    MdpElephantSuidCategory["UnknownElephantSuidCategory"] = "UNKNOWN_ELEPHANT_SUID_CATEGORY";
})(MdpElephantSuidCategory || (MdpElephantSuidCategory = {}));
export var MdpEmployerLatLngPrecision;
(function (MdpEmployerLatLngPrecision) {
    MdpEmployerLatLngPrecision["Address"] = "ADDRESS";
    MdpEmployerLatLngPrecision["Admin1"] = "ADMIN1";
    MdpEmployerLatLngPrecision["Admin2"] = "ADMIN2";
    MdpEmployerLatLngPrecision["Admin3"] = "ADMIN3";
    MdpEmployerLatLngPrecision["Admin4"] = "ADMIN4";
    MdpEmployerLatLngPrecision["City"] = "CITY";
    MdpEmployerLatLngPrecision["Country"] = "COUNTRY";
    MdpEmployerLatLngPrecision["Place"] = "PLACE";
    MdpEmployerLatLngPrecision["Station"] = "STATION";
    MdpEmployerLatLngPrecision["UnknownLatLngPrecision"] = "UNKNOWN_LAT_LNG_PRECISION";
    MdpEmployerLatLngPrecision["Zipcode"] = "ZIPCODE";
})(MdpEmployerLatLngPrecision || (MdpEmployerLatLngPrecision = {}));
export var MdpEmployerSentiment;
(function (MdpEmployerSentiment) {
    MdpEmployerSentiment["Negative"] = "NEGATIVE";
    MdpEmployerSentiment["Neutral"] = "NEUTRAL";
    MdpEmployerSentiment["Positive"] = "POSITIVE";
    MdpEmployerSentiment["UnknownSentiment"] = "UNKNOWN_SENTIMENT";
})(MdpEmployerSentiment || (MdpEmployerSentiment = {}));
export var MdpEmploymentEligibilityType;
(function (MdpEmploymentEligibilityType) {
    MdpEmploymentEligibilityType["Eligible"] = "ELIGIBLE";
    MdpEmploymentEligibilityType["Ineligible"] = "INELIGIBLE";
    MdpEmploymentEligibilityType["UnknownEligibilityType"] = "UNKNOWN_ELIGIBILITY_TYPE";
    MdpEmploymentEligibilityType["WithSponsorship"] = "WITH_SPONSORSHIP";
})(MdpEmploymentEligibilityType || (MdpEmploymentEligibilityType = {}));
export var MdpEngagementState;
(function (MdpEngagementState) {
    MdpEngagementState["Active"] = "ACTIVE";
    MdpEngagementState["AtRisk"] = "AT_RISK";
    MdpEngagementState["Inactive"] = "INACTIVE";
    MdpEngagementState["New"] = "NEW";
    MdpEngagementState["UnknownState"] = "UNKNOWN_STATE";
})(MdpEngagementState || (MdpEngagementState = {}));
export var MdpEntityIdType;
(function (MdpEntityIdType) {
    MdpEntityIdType["AccountId"] = "ACCOUNT_ID";
    MdpEntityIdType["AdvertiserId"] = "ADVERTISER_ID";
    MdpEntityIdType["AggJobId"] = "AGG_JOB_ID";
    MdpEntityIdType["CandidateSubmissionId"] = "CANDIDATE_SUBMISSION_ID";
    MdpEntityIdType["Ctk"] = "CTK";
    MdpEntityIdType["EmployerAccountId"] = "EMPLOYER_ACCOUNT_ID";
    MdpEntityIdType["EmployerJobId"] = "EMPLOYER_JOB_ID";
    MdpEntityIdType["IntentProfileId"] = "INTENT_PROFILE_ID";
    MdpEntityIdType["SourceId"] = "SOURCE_ID";
    MdpEntityIdType["UnknownEntityIdType"] = "UNKNOWN_ENTITY_ID_TYPE";
})(MdpEntityIdType || (MdpEntityIdType = {}));
export var MdpExampleSurfaceTypeV2;
(function (MdpExampleSurfaceTypeV2) {
    MdpExampleSurfaceTypeV2["IndeedV2"] = "INDEED_V2";
    MdpExampleSurfaceTypeV2["OtherV2"] = "OTHER_V2";
    MdpExampleSurfaceTypeV2["UnknownSurfaceTypeV2"] = "UNKNOWN_SURFACE_TYPE_V2";
})(MdpExampleSurfaceTypeV2 || (MdpExampleSurfaceTypeV2 = {}));
export var MdpExampleSurfaceTypeV3;
(function (MdpExampleSurfaceTypeV3) {
    MdpExampleSurfaceTypeV3["IndeedV3"] = "INDEED_V3";
    MdpExampleSurfaceTypeV3["OtherV3"] = "OTHER_V3";
    MdpExampleSurfaceTypeV3["UnknownSurfaceTypeV3"] = "UNKNOWN_SURFACE_TYPE_V3";
})(MdpExampleSurfaceTypeV3 || (MdpExampleSurfaceTypeV3 = {}));
export var MdpFactSource;
(function (MdpFactSource) {
    MdpFactSource["Profile"] = "PROFILE";
    MdpFactSource["ScreenerQuestion"] = "SCREENER_QUESTION";
    MdpFactSource["UnknownFactSource"] = "UNKNOWN_FACT_SOURCE";
})(MdpFactSource || (MdpFactSource = {}));
export var MdpFeatureGroupPublishFailedItemStatusCode;
(function (MdpFeatureGroupPublishFailedItemStatusCode) {
    MdpFeatureGroupPublishFailedItemStatusCode["InternalFailure"] = "INTERNAL_FAILURE";
    MdpFeatureGroupPublishFailedItemStatusCode["RetryableFailure"] = "RETRYABLE_FAILURE";
    MdpFeatureGroupPublishFailedItemStatusCode["UnknownStatus"] = "UNKNOWN_STATUS";
    MdpFeatureGroupPublishFailedItemStatusCode["ValidationFailure"] = "VALIDATION_FAILURE";
})(MdpFeatureGroupPublishFailedItemStatusCode || (MdpFeatureGroupPublishFailedItemStatusCode = {}));
export var MdpI2aChannel;
(function (MdpI2aChannel) {
    MdpI2aChannel["AndroidPush"] = "ANDROID_PUSH";
    MdpI2aChannel["Email"] = "EMAIL";
    MdpI2aChannel["IosPush"] = "IOS_PUSH";
    MdpI2aChannel["Line"] = "LINE";
    MdpI2aChannel["MobilePush"] = "MOBILE_PUSH";
    MdpI2aChannel["NotificationCenter"] = "NOTIFICATION_CENTER";
    MdpI2aChannel["UnknownI2AChannel"] = "UNKNOWN_I2A_CHANNEL";
    MdpI2aChannel["Whatsapp"] = "WHATSAPP";
})(MdpI2aChannel || (MdpI2aChannel = {}));
export var MdpI2aProduct;
(function (MdpI2aProduct) {
    MdpI2aProduct["GlassdoorI2A"] = "GLASSDOOR_I2A";
    MdpI2aProduct["SmbI2A"] = "SMB_I2A";
    MdpI2aProduct["SmbI2AMultijob"] = "SMB_I2A_MULTIJOB";
    MdpI2aProduct["SmbInstantMatch"] = "SMB_INSTANT_MATCH";
    MdpI2aProduct["UnknownI2AProduct"] = "UNKNOWN_I2A_PRODUCT";
})(MdpI2aProduct || (MdpI2aProduct = {}));
export var MdpI2aProductSubvariant;
(function (MdpI2aProductSubvariant) {
    MdpI2aProductSubvariant["Indeedplus"] = "INDEEDPLUS";
    MdpI2aProductSubvariant["None"] = "NONE";
    MdpI2aProductSubvariant["Optin"] = "OPTIN";
    MdpI2aProductSubvariant["Reactivation"] = "REACTIVATION";
    MdpI2aProductSubvariant["Resumeless"] = "RESUMELESS";
    MdpI2aProductSubvariant["UnknownI2AProductSubvariant"] = "UNKNOWN_I2A_PRODUCT_SUBVARIANT";
})(MdpI2aProductSubvariant || (MdpI2aProductSubvariant = {}));
export var MdpI2aProductType;
(function (MdpI2aProductType) {
    MdpI2aProductType["Autosourcer"] = "AUTOSOURCER";
    MdpI2aProductType["Jobmatch"] = "JOBMATCH";
    MdpI2aProductType["Jobsourcer"] = "JOBSOURCER";
    MdpI2aProductType["Multijob"] = "MULTIJOB";
    MdpI2aProductType["UnknownI2AProductType"] = "UNKNOWN_I2A_PRODUCT_TYPE";
})(MdpI2aProductType || (MdpI2aProductType = {}));
export var MdpIndeedPreferredResumeSource;
(function (MdpIndeedPreferredResumeSource) {
    MdpIndeedPreferredResumeSource["FileResumePreferred"] = "FILE_RESUME_PREFERRED";
    MdpIndeedPreferredResumeSource["IndeedResumePreferred"] = "INDEED_RESUME_PREFERRED";
    MdpIndeedPreferredResumeSource["UnknownPreferredResumeSource"] = "UNKNOWN_PREFERRED_RESUME_SOURCE";
})(MdpIndeedPreferredResumeSource || (MdpIndeedPreferredResumeSource = {}));
export var MdpInferenceCategory;
(function (MdpInferenceCategory) {
    MdpInferenceCategory["Background"] = "BACKGROUND";
    MdpInferenceCategory["Desire"] = "DESIRE";
    MdpInferenceCategory["UnknownInferenceCategory"] = "UNKNOWN_INFERENCE_CATEGORY";
})(MdpInferenceCategory || (MdpInferenceCategory = {}));
export var MdpJobPaySource;
(function (MdpJobPaySource) {
    MdpJobPaySource["Employer"] = "EMPLOYER";
    MdpJobPaySource["Extracted"] = "EXTRACTED";
    MdpJobPaySource["ExtractionOverride"] = "EXTRACTION_OVERRIDE";
    MdpJobPaySource["Inferred"] = "INFERRED";
    MdpJobPaySource["UnknownJobPaySource"] = "UNKNOWN_JOB_PAY_SOURCE";
})(MdpJobPaySource || (MdpJobPaySource = {}));
export var MdpJobPayUnit;
(function (MdpJobPayUnit) {
    MdpJobPayUnit["Childbirth"] = "CHILDBIRTH";
    MdpJobPayUnit["Class"] = "CLASS";
    MdpJobPayUnit["Contact"] = "CONTACT";
    MdpJobPayUnit["ContactHour"] = "CONTACT_HOUR";
    MdpJobPayUnit["CreditHour"] = "CREDIT_HOUR";
    MdpJobPayUnit["Daily"] = "DAILY";
    MdpJobPayUnit["Delivery"] = "DELIVERY";
    MdpJobPayUnit["Event"] = "EVENT";
    MdpJobPayUnit["FlightHour"] = "FLIGHT_HOUR";
    MdpJobPayUnit["Game"] = "GAME";
    MdpJobPayUnit["Gig"] = "GIG";
    MdpJobPayUnit["Hourly"] = "HOURLY";
    MdpJobPayUnit["Kilometer"] = "KILOMETER";
    MdpJobPayUnit["Lesson"] = "LESSON";
    MdpJobPayUnit["Mile"] = "MILE";
    MdpJobPayUnit["Monthly"] = "MONTHLY";
    MdpJobPayUnit["Occasion"] = "OCCASION";
    MdpJobPayUnit["Occurrence"] = "OCCURRENCE";
    MdpJobPayUnit["Order"] = "ORDER";
    MdpJobPayUnit["Point"] = "POINT";
    MdpJobPayUnit["Quarterly"] = "QUARTERLY";
    MdpJobPayUnit["Referral"] = "REFERRAL";
    MdpJobPayUnit["Sale"] = "SALE";
    MdpJobPayUnit["Session"] = "SESSION";
    MdpJobPayUnit["Shift"] = "SHIFT";
    MdpJobPayUnit["Student"] = "STUDENT";
    MdpJobPayUnit["Trip"] = "TRIP";
    MdpJobPayUnit["UnknownJobPayUnit"] = "UNKNOWN_JOB_PAY_UNIT";
    MdpJobPayUnit["Weekly"] = "WEEKLY";
    MdpJobPayUnit["Yearly"] = "YEARLY";
})(MdpJobPayUnit || (MdpJobPayUnit = {}));
export var MdpJobSeekerActivityLevel;
(function (MdpJobSeekerActivityLevel) {
    MdpJobSeekerActivityLevel["Active"] = "ACTIVE";
    MdpJobSeekerActivityLevel["AtRisk"] = "AT_RISK";
    MdpJobSeekerActivityLevel["Current"] = "CURRENT";
    MdpJobSeekerActivityLevel["Engaged"] = "ENGAGED";
    MdpJobSeekerActivityLevel["Inactive"] = "INACTIVE";
    MdpJobSeekerActivityLevel["New"] = "NEW";
    MdpJobSeekerActivityLevel["Reactivated"] = "REACTIVATED";
    MdpJobSeekerActivityLevel["UnknownActivityLevel"] = "UNKNOWN_ACTIVITY_LEVEL";
})(MdpJobSeekerActivityLevel || (MdpJobSeekerActivityLevel = {}));
export var MdpJobSeekerIdType;
(function (MdpJobSeekerIdType) {
    MdpJobSeekerIdType["AccountId"] = "ACCOUNT_ID";
    MdpJobSeekerIdType["Ctk"] = "CTK";
})(MdpJobSeekerIdType || (MdpJobSeekerIdType = {}));
export var MdpJobSeekerJobTitleSource;
(function (MdpJobSeekerJobTitleSource) {
    MdpJobSeekerJobTitleSource["Explicit"] = "EXPLICIT";
    MdpJobSeekerJobTitleSource["ExplicitDesired"] = "EXPLICIT_DESIRED";
    MdpJobSeekerJobTitleSource["ExplicitWorkHistory"] = "EXPLICIT_WORK_HISTORY";
    MdpJobSeekerJobTitleSource["Extracted"] = "EXTRACTED";
    MdpJobSeekerJobTitleSource["ExtractedResumePrimary"] = "EXTRACTED_RESUME_PRIMARY";
    MdpJobSeekerJobTitleSource["ExtractedResumePrimaryLatest"] = "EXTRACTED_RESUME_PRIMARY_LATEST";
    MdpJobSeekerJobTitleSource["UnknownJobTitleSource"] = "UNKNOWN_JOB_TITLE_SOURCE";
})(MdpJobSeekerJobTitleSource || (MdpJobSeekerJobTitleSource = {}));
export var MdpJobSeekerPaySource;
(function (MdpJobSeekerPaySource) {
    MdpJobSeekerPaySource["Explicit"] = "EXPLICIT";
    MdpJobSeekerPaySource["Inferred"] = "INFERRED";
    MdpJobSeekerPaySource["UnknownJobSeekerPaySource"] = "UNKNOWN_JOB_SEEKER_PAY_SOURCE";
})(MdpJobSeekerPaySource || (MdpJobSeekerPaySource = {}));
export var MdpJobSeekerPayUnitOfWork;
(function (MdpJobSeekerPayUnitOfWork) {
    MdpJobSeekerPayUnitOfWork["Daily"] = "DAILY";
    MdpJobSeekerPayUnitOfWork["Hourly"] = "HOURLY";
    MdpJobSeekerPayUnitOfWork["Monthly"] = "MONTHLY";
    MdpJobSeekerPayUnitOfWork["Quarterly"] = "QUARTERLY";
    MdpJobSeekerPayUnitOfWork["UnknownJobSeekerPayUnitOfWork"] = "UNKNOWN_JOB_SEEKER_PAY_UNIT_OF_WORK";
    MdpJobSeekerPayUnitOfWork["Weekly"] = "WEEKLY";
    MdpJobSeekerPayUnitOfWork["Yearly"] = "YEARLY";
})(MdpJobSeekerPayUnitOfWork || (MdpJobSeekerPayUnitOfWork = {}));
export var MdpJobState;
(function (MdpJobState) {
    MdpJobState["Archived"] = "ARCHIVED";
    MdpJobState["Expired"] = "EXPIRED";
    MdpJobState["Unexpired"] = "UNEXPIRED";
    MdpJobState["UnknownJobState"] = "UNKNOWN_JOB_STATE";
    MdpJobState["Unspecified"] = "UNSPECIFIED";
})(MdpJobState || (MdpJobState = {}));
export var MdpJobType;
(function (MdpJobType) {
    MdpJobType["Apprenticeship"] = "APPRENTICESHIP";
    MdpJobType["Casual"] = "CASUAL";
    MdpJobType["Commission"] = "COMMISSION";
    MdpJobType["Contract"] = "CONTRACT";
    MdpJobType["Custom_1"] = "CUSTOM_1";
    MdpJobType["FlyinFlyout"] = "FLYIN_FLYOUT";
    MdpJobType["Fulltime"] = "FULLTIME";
    MdpJobType["Internship"] = "INTERNSHIP";
    MdpJobType["NewGrad"] = "NEW_GRAD";
    MdpJobType["Nonprofit"] = "NONPROFIT";
    MdpJobType["Parttime"] = "PARTTIME";
    MdpJobType["Permanent"] = "PERMANENT";
    MdpJobType["Spam"] = "SPAM";
    MdpJobType["Subcontract"] = "SUBCONTRACT";
    MdpJobType["Telecommute"] = "TELECOMMUTE";
    MdpJobType["Temporary"] = "TEMPORARY";
    MdpJobType["UnknownJobType"] = "UNKNOWN_JOB_TYPE";
    MdpJobType["Volunteer"] = "VOLUNTEER";
})(MdpJobType || (MdpJobType = {}));
export var MdpKeywordFilterMatch;
(function (MdpKeywordFilterMatch) {
    MdpKeywordFilterMatch["Must"] = "MUST";
    MdpKeywordFilterMatch["MustNot"] = "MUST_NOT";
    MdpKeywordFilterMatch["UnknownKeywordFilterMatch"] = "UNKNOWN_KEYWORD_FILTER_MATCH";
})(MdpKeywordFilterMatch || (MdpKeywordFilterMatch = {}));
export var MdpKeywordFilterOperation;
(function (MdpKeywordFilterOperation) {
    MdpKeywordFilterOperation["And"] = "AND";
    MdpKeywordFilterOperation["Or"] = "OR";
    MdpKeywordFilterOperation["UnknownKeywordFilterOperation"] = "UNKNOWN_KEYWORD_FILTER_OPERATION";
})(MdpKeywordFilterOperation || (MdpKeywordFilterOperation = {}));
export var MdpLatLngPrecision;
(function (MdpLatLngPrecision) {
    MdpLatLngPrecision["Address"] = "ADDRESS";
    MdpLatLngPrecision["Admin1"] = "ADMIN1";
    MdpLatLngPrecision["Admin2"] = "ADMIN2";
    MdpLatLngPrecision["Admin3"] = "ADMIN3";
    MdpLatLngPrecision["Admin4"] = "ADMIN4";
    MdpLatLngPrecision["City"] = "CITY";
    MdpLatLngPrecision["Country"] = "COUNTRY";
    MdpLatLngPrecision["Place"] = "PLACE";
    MdpLatLngPrecision["Postal"] = "POSTAL";
    MdpLatLngPrecision["Station"] = "STATION";
    MdpLatLngPrecision["UnknownLatLngPrecision"] = "UNKNOWN_LAT_LNG_PRECISION";
    MdpLatLngPrecision["Zipcode"] = "ZIPCODE";
})(MdpLatLngPrecision || (MdpLatLngPrecision = {}));
export var MdpLocationType;
(function (MdpLocationType) {
    MdpLocationType["Admin1"] = "ADMIN1";
    MdpLocationType["Admin2"] = "ADMIN2";
    MdpLocationType["Admin3"] = "ADMIN3";
    MdpLocationType["Admin4"] = "ADMIN4";
    MdpLocationType["Airport"] = "AIRPORT";
    MdpLocationType["City"] = "CITY";
    MdpLocationType["Country"] = "COUNTRY";
    MdpLocationType["Misc"] = "MISC";
    MdpLocationType["PostalCode"] = "POSTAL_CODE";
    MdpLocationType["PostalPlace"] = "POSTAL_PLACE";
    MdpLocationType["PreciseLocation"] = "PRECISE_LOCATION";
    MdpLocationType["Station"] = "STATION";
    MdpLocationType["UnknownLocationType"] = "UNKNOWN_LOCATION_TYPE";
    MdpLocationType["Water"] = "WATER";
})(MdpLocationType || (MdpLocationType = {}));
export var MdpMdpFeatureEvolutionFakeTestEnum;
(function (MdpMdpFeatureEvolutionFakeTestEnum) {
    MdpMdpFeatureEvolutionFakeTestEnum["EnumOne"] = "ENUM_ONE";
    MdpMdpFeatureEvolutionFakeTestEnum["EnumTwo"] = "ENUM_TWO";
    MdpMdpFeatureEvolutionFakeTestEnum["UnknownEnum"] = "UNKNOWN_ENUM";
})(MdpMdpFeatureEvolutionFakeTestEnum || (MdpMdpFeatureEvolutionFakeTestEnum = {}));
export var MdpMetaEntityCustomPropertyType;
(function (MdpMetaEntityCustomPropertyType) {
    MdpMetaEntityCustomPropertyType["Boolean"] = "BOOLEAN";
    MdpMetaEntityCustomPropertyType["Double"] = "DOUBLE";
    MdpMetaEntityCustomPropertyType["Integer"] = "INTEGER";
    MdpMetaEntityCustomPropertyType["Long"] = "LONG";
    MdpMetaEntityCustomPropertyType["String"] = "STRING";
    MdpMetaEntityCustomPropertyType["StringList"] = "STRING_LIST";
    MdpMetaEntityCustomPropertyType["Unknown"] = "UNKNOWN";
})(MdpMetaEntityCustomPropertyType || (MdpMetaEntityCustomPropertyType = {}));
export var MdpMetaEntityDerivedPropertiesOfflineSnapshotFrequency;
(function (MdpMetaEntityDerivedPropertiesOfflineSnapshotFrequency) {
    MdpMetaEntityDerivedPropertiesOfflineSnapshotFrequency["Daily"] = "DAILY";
    MdpMetaEntityDerivedPropertiesOfflineSnapshotFrequency["Weekly"] = "WEEKLY";
})(MdpMetaEntityDerivedPropertiesOfflineSnapshotFrequency || (MdpMetaEntityDerivedPropertiesOfflineSnapshotFrequency = {}));
export var MdpMetaEntityInfoDomain;
(function (MdpMetaEntityInfoDomain) {
    MdpMetaEntityInfoDomain["CandidateSubmission"] = "CANDIDATE_SUBMISSION";
    MdpMetaEntityInfoDomain["Employer"] = "EMPLOYER";
    MdpMetaEntityInfoDomain["IntentProfile"] = "INTENT_PROFILE";
    MdpMetaEntityInfoDomain["Job"] = "JOB";
    MdpMetaEntityInfoDomain["JobSeeker"] = "JOB_SEEKER";
})(MdpMetaEntityInfoDomain || (MdpMetaEntityInfoDomain = {}));
export var MdpMetaEntityInfoStatus;
(function (MdpMetaEntityInfoStatus) {
    MdpMetaEntityInfoStatus["Active"] = "ACTIVE";
    MdpMetaEntityInfoStatus["Archived"] = "ARCHIVED";
    MdpMetaEntityInfoStatus["Deprecated"] = "DEPRECATED";
})(MdpMetaEntityInfoStatus || (MdpMetaEntityInfoStatus = {}));
export var MdpMetaEntityMaturity;
(function (MdpMetaEntityMaturity) {
    /** @deprecated Use MdpMetaEntityProductionReadinessMaturity instead */
    MdpMetaEntityMaturity["ProdStable"] = "PROD_STABLE";
    /** @deprecated Use MdpMetaEntityProductionReadinessMaturity instead */
    MdpMetaEntityMaturity["ProdUnmanagedSlo"] = "PROD_UNMANAGED_SLO";
})(MdpMetaEntityMaturity || (MdpMetaEntityMaturity = {}));
export var MdpMetaEntityOfflineStoreSyncerDeploy;
(function (MdpMetaEntityOfflineStoreSyncerDeploy) {
    MdpMetaEntityOfflineStoreSyncerDeploy["FlinkEmr"] = "FLINK_EMR";
    MdpMetaEntityOfflineStoreSyncerDeploy["FlinkK8S"] = "FLINK_K8S";
    MdpMetaEntityOfflineStoreSyncerDeploy["SparkEmr"] = "SPARK_EMR";
})(MdpMetaEntityOfflineStoreSyncerDeploy || (MdpMetaEntityOfflineStoreSyncerDeploy = {}));
export var MdpMetaEntityProductionReadinessMaturity;
(function (MdpMetaEntityProductionReadinessMaturity) {
    MdpMetaEntityProductionReadinessMaturity["ProdStable"] = "PROD_STABLE";
    MdpMetaEntityProductionReadinessMaturity["ProdUnmanagedSlo"] = "PROD_UNMANAGED_SLO";
})(MdpMetaEntityProductionReadinessMaturity || (MdpMetaEntityProductionReadinessMaturity = {}));
export var MdpMetaEntityProductionReadinessPriority;
(function (MdpMetaEntityProductionReadinessPriority) {
    MdpMetaEntityProductionReadinessPriority["High"] = "HIGH";
    MdpMetaEntityProductionReadinessPriority["Low"] = "LOW";
    MdpMetaEntityProductionReadinessPriority["NotReviewed"] = "NOT_REVIEWED";
    /** @deprecated Migration has been finished. This field should no longer be used */
    MdpMetaEntityProductionReadinessPriority["PreMigration"] = "PRE_MIGRATION";
})(MdpMetaEntityProductionReadinessPriority || (MdpMetaEntityProductionReadinessPriority = {}));
export var MdpMetaEntityProductionReadinessSloPercentile;
(function (MdpMetaEntityProductionReadinessSloPercentile) {
    MdpMetaEntityProductionReadinessSloPercentile["P90"] = "P90";
    MdpMetaEntityProductionReadinessSloPercentile["P99"] = "P99";
    MdpMetaEntityProductionReadinessSloPercentile["P999"] = "P999";
})(MdpMetaEntityProductionReadinessSloPercentile || (MdpMetaEntityProductionReadinessSloPercentile = {}));
export var MdpMetaEntitySchemaType;
(function (MdpMetaEntitySchemaType) {
    /** Whose stream is in avro schema and generated by catalog */
    MdpMetaEntitySchemaType["Avro"] = "AVRO";
    /** Whose avro is manually registered to confluent schema */
    MdpMetaEntitySchemaType["LegacyAvro"] = "LEGACY_AVRO";
    /** Whose avro is manually registered to confluent schema and converted to catalog avro in the converter before being synced to the offline syncer */
    MdpMetaEntitySchemaType["LegacyAvroConvertToCatalogAvro"] = "LEGACY_AVRO_CONVERT_TO_CATALOG_AVRO";
    /** Whose stream is proto and hardcoded in offline syncer code */
    MdpMetaEntitySchemaType["LegacyProto"] = "LEGACY_PROTO";
    /** Whose proto is converted to avro in the MDP Avro Stream Converter before synced to offline store */
    MdpMetaEntitySchemaType["LegacyProtoConvertToAvro"] = "LEGACY_PROTO_CONVERT_TO_AVRO";
})(MdpMetaEntitySchemaType || (MdpMetaEntitySchemaType = {}));
export var MdpMetaEntityStreamCluster;
(function (MdpMetaEntityStreamCluster) {
    MdpMetaEntityStreamCluster["Default"] = "DEFAULT";
})(MdpMetaEntityStreamCluster || (MdpMetaEntityStreamCluster = {}));
export var MdpMetaEntityStreamType;
(function (MdpMetaEntityStreamType) {
    /** Topics are auto-created and manage thru Catalog Pipeline */
    MdpMetaEntityStreamType["CatalogManaged"] = "CATALOG_MANAGED";
    /** Managed by Terraform repository outside of Catalog Repository */
    MdpMetaEntityStreamType["TerraformManaged"] = "TERRAFORM_MANAGED";
})(MdpMetaEntityStreamType || (MdpMetaEntityStreamType = {}));
/** Types of MetaEntity */
export var MdpMetaEntityType;
(function (MdpMetaEntityType) {
    MdpMetaEntityType["AggregatedEnhancedEvent"] = "AGGREGATED_ENHANCED_EVENT";
    MdpMetaEntityType["EnhancedEvent"] = "ENHANCED_EVENT";
    MdpMetaEntityType["FeatureGroup"] = "FEATURE_GROUP";
    MdpMetaEntityType["RawEvent"] = "RAW_EVENT";
})(MdpMetaEntityType || (MdpMetaEntityType = {}));
export var MdpMetadataServiceAttributeRequirementLevel;
(function (MdpMetadataServiceAttributeRequirementLevel) {
    MdpMetadataServiceAttributeRequirementLevel["Optional"] = "OPTIONAL";
    MdpMetadataServiceAttributeRequirementLevel["Required"] = "REQUIRED";
    MdpMetadataServiceAttributeRequirementLevel["UnknownJobMetadataTaxonomyAttributeRequirementLevel"] = "UNKNOWN_JOB_METADATA_TAXONOMY_ATTRIBUTE_REQUIREMENT_LEVEL";
})(MdpMetadataServiceAttributeRequirementLevel || (MdpMetadataServiceAttributeRequirementLevel = {}));
export var MdpMetadataServiceAttributeSource;
(function (MdpMetadataServiceAttributeSource) {
    MdpMetadataServiceAttributeSource["Deduced"] = "DEDUCED";
    MdpMetadataServiceAttributeSource["Employer"] = "EMPLOYER";
    MdpMetadataServiceAttributeSource["EmployerAccepted"] = "EMPLOYER_ACCEPTED";
    MdpMetadataServiceAttributeSource["EmployerDeduced"] = "EMPLOYER_DEDUCED";
    MdpMetadataServiceAttributeSource["EmployerRejected"] = "EMPLOYER_REJECTED";
    MdpMetadataServiceAttributeSource["Extracted"] = "EXTRACTED";
    MdpMetadataServiceAttributeSource["ExtractedCrowtagMatchTag"] = "EXTRACTED_CROWTAG_MATCH_TAG";
    MdpMetadataServiceAttributeSource["ExtractedCrowtagOqvtTag"] = "EXTRACTED_CROWTAG_OQVT_TAG";
    MdpMetadataServiceAttributeSource["ExtractedDeduced"] = "EXTRACTED_DEDUCED";
    MdpMetadataServiceAttributeSource["HighRecall"] = "HIGH_RECALL";
    MdpMetadataServiceAttributeSource["IndeedTag"] = "INDEED_TAG";
    MdpMetadataServiceAttributeSource["Jobseeker"] = "JOBSEEKER";
    MdpMetadataServiceAttributeSource["NerModel"] = "NER_MODEL";
    MdpMetadataServiceAttributeSource["NotApplicableOrUnknown"] = "NOT_APPLICABLE_OR_UNKNOWN";
    MdpMetadataServiceAttributeSource["RequirementModel"] = "REQUIREMENT_MODEL";
    MdpMetadataServiceAttributeSource["SeniorityModel"] = "SENIORITY_MODEL";
    MdpMetadataServiceAttributeSource["UnknownJobMetadataAttributeSource"] = "UNKNOWN_JOB_METADATA_ATTRIBUTE_SOURCE";
})(MdpMetadataServiceAttributeSource || (MdpMetadataServiceAttributeSource = {}));
export var MdpModerationLevel;
(function (MdpModerationLevel) {
    MdpModerationLevel["Blocked"] = "BLOCKED";
    MdpModerationLevel["Default"] = "DEFAULT";
    MdpModerationLevel["ElevatedRisk"] = "ELEVATED_RISK";
    MdpModerationLevel["UnknownModerationLevel"] = "UNKNOWN_MODERATION_LEVEL";
})(MdpModerationLevel || (MdpModerationLevel = {}));
export var MdpMultiResumeUpdateEventReason;
(function (MdpMultiResumeUpdateEventReason) {
    MdpMultiResumeUpdateEventReason["Bootstrap"] = "BOOTSTRAP";
    MdpMultiResumeUpdateEventReason["LatestApplyResumeTypeUpdate"] = "LATEST_APPLY_RESUME_TYPE_UPDATE";
    MdpMultiResumeUpdateEventReason["ResumeUpdate"] = "RESUME_UPDATE";
    MdpMultiResumeUpdateEventReason["StaleFeature"] = "STALE_FEATURE";
    MdpMultiResumeUpdateEventReason["UnknownReason"] = "UNKNOWN_REASON";
})(MdpMultiResumeUpdateEventReason || (MdpMultiResumeUpdateEventReason = {}));
/** The kind of input a feature builder declares for a source */
export var MdpOnDemandComputeSourceType;
(function (MdpOnDemandComputeSourceType) {
    MdpOnDemandComputeSourceType["AggregationList"] = "AGGREGATION_LIST";
    MdpOnDemandComputeSourceType["Last"] = "LAST";
    MdpOnDemandComputeSourceType["Lookup"] = "LOOKUP";
    MdpOnDemandComputeSourceType["Trigger"] = "TRIGGER";
})(MdpOnDemandComputeSourceType || (MdpOnDemandComputeSourceType = {}));
export var MdpOperationType;
(function (MdpOperationType) {
    MdpOperationType["AppendToExistingFieldsOrInsert"] = "APPEND_TO_EXISTING_FIELDS_OR_INSERT";
    MdpOperationType["Delete"] = "DELETE";
    MdpOperationType["UnknownOperationType"] = "UNKNOWN_OPERATION_TYPE";
    MdpOperationType["Upsert"] = "UPSERT";
})(MdpOperationType || (MdpOperationType = {}));
export var MdpPayConfidence;
(function (MdpPayConfidence) {
    MdpPayConfidence["High"] = "HIGH";
    MdpPayConfidence["Low"] = "LOW";
    MdpPayConfidence["Medium"] = "MEDIUM";
    MdpPayConfidence["UnknownPayConfidence"] = "UNKNOWN_PAY_CONFIDENCE";
})(MdpPayConfidence || (MdpPayConfidence = {}));
export var MdpPreferenceType;
(function (MdpPreferenceType) {
    MdpPreferenceType["Attribute"] = "ATTRIBUTE";
    MdpPreferenceType["JobType"] = "JOB_TYPE";
    MdpPreferenceType["Shift"] = "SHIFT";
    MdpPreferenceType["UnknownPreferenceType"] = "UNKNOWN_PREFERENCE_TYPE";
})(MdpPreferenceType || (MdpPreferenceType = {}));
export var MdpProvenance;
(function (MdpProvenance) {
    MdpProvenance["Candidate"] = "CANDIDATE";
    MdpProvenance["ResumeExtracted"] = "RESUME_EXTRACTED";
    MdpProvenance["UnknownProvenance"] = "UNKNOWN_PROVENANCE";
    MdpProvenance["UserSubmitted"] = "USER_SUBMITTED";
})(MdpProvenance || (MdpProvenance = {}));
export var MdpQualificationCertificationType;
(function (MdpQualificationCertificationType) {
    MdpQualificationCertificationType["AccountingLicenseCertification"] = "ACCOUNTING_LICENSE_CERTIFICATION";
    MdpQualificationCertificationType["DriversLicenseCertification"] = "DRIVERS_LICENSE_CERTIFICATION";
    MdpQualificationCertificationType["Endorsements"] = "ENDORSEMENTS";
    MdpQualificationCertificationType["NursesLicenseCertification"] = "NURSES_LICENSE_CERTIFICATION";
    MdpQualificationCertificationType["TitleAndExpirationDate"] = "TITLE_AND_EXPIRATION_DATE";
    MdpQualificationCertificationType["UnknownCertificationType"] = "UNKNOWN_CERTIFICATION_TYPE";
})(MdpQualificationCertificationType || (MdpQualificationCertificationType = {}));
export var MdpQualificationLicenseType;
(function (MdpQualificationLicenseType) {
    MdpQualificationLicenseType["AccountingLicense"] = "ACCOUNTING_LICENSE";
    MdpQualificationLicenseType["DriversLicense"] = "DRIVERS_LICENSE";
    MdpQualificationLicenseType["NursesLicense"] = "NURSES_LICENSE";
    MdpQualificationLicenseType["UnknownLicenseType"] = "UNKNOWN_LICENSE_TYPE";
})(MdpQualificationLicenseType || (MdpQualificationLicenseType = {}));
export var MdpRelocationType;
(function (MdpRelocationType) {
    MdpRelocationType["Anywhere"] = "ANYWHERE";
    MdpRelocationType["NearMe"] = "NEAR_ME";
    MdpRelocationType["SpecificLocations"] = "SPECIFIC_LOCATIONS";
    MdpRelocationType["UnknownStatus"] = "UNKNOWN_STATUS";
})(MdpRelocationType || (MdpRelocationType = {}));
export var MdpReporterType;
(function (MdpReporterType) {
    MdpReporterType["Employer"] = "EMPLOYER";
    MdpReporterType["IndeedHireHiringSpecialist"] = "INDEED_HIRE_HIRING_SPECIALIST";
    MdpReporterType["Jobseeker"] = "JOBSEEKER";
    MdpReporterType["UnknownReporter"] = "UNKNOWN_REPORTER";
})(MdpReporterType || (MdpReporterType = {}));
export var MdpResumeCareerLevel;
(function (MdpResumeCareerLevel) {
    MdpResumeCareerLevel["Experienced"] = "EXPERIENCED";
    MdpResumeCareerLevel["Fresher"] = "FRESHER";
    MdpResumeCareerLevel["NotSpecified"] = "NOT_SPECIFIED";
    MdpResumeCareerLevel["UnknownCareerLevel"] = "UNKNOWN_CAREER_LEVEL";
})(MdpResumeCareerLevel || (MdpResumeCareerLevel = {}));
export var MdpResumeCertificationType;
(function (MdpResumeCertificationType) {
    MdpResumeCertificationType["AccountingLicense"] = "ACCOUNTING_LICENSE";
    MdpResumeCertificationType["DriversLicense"] = "DRIVERS_LICENSE";
    MdpResumeCertificationType["Endorsements"] = "ENDORSEMENTS";
    MdpResumeCertificationType["NursesLicense"] = "NURSES_LICENSE";
    MdpResumeCertificationType["TitleAndExpirationDate"] = "TITLE_AND_EXPIRATION_DATE";
    MdpResumeCertificationType["UnknownCertificationType"] = "UNKNOWN_CERTIFICATION_TYPE";
})(MdpResumeCertificationType || (MdpResumeCertificationType = {}));
export var MdpResumeEmploymentEligibility;
(function (MdpResumeEmploymentEligibility) {
    MdpResumeEmploymentEligibility["Eligible"] = "ELIGIBLE";
    MdpResumeEmploymentEligibility["Ineligible"] = "INELIGIBLE";
    MdpResumeEmploymentEligibility["UnknownEmploymentEligibility"] = "UNKNOWN_EMPLOYMENT_ELIGIBILITY";
    MdpResumeEmploymentEligibility["WithSponsorship"] = "WITH_SPONSORSHIP";
})(MdpResumeEmploymentEligibility || (MdpResumeEmploymentEligibility = {}));
export var MdpResumeEmploymentStatus;
(function (MdpResumeEmploymentStatus) {
    MdpResumeEmploymentStatus["EmpNo"] = "EMP_NO";
    MdpResumeEmploymentStatus["EmpYes"] = "EMP_YES";
    MdpResumeEmploymentStatus["UnknownEmploymentStatus"] = "UNKNOWN_EMPLOYMENT_STATUS";
})(MdpResumeEmploymentStatus || (MdpResumeEmploymentStatus = {}));
export var MdpResumeEmploymentSupportStatus;
(function (MdpResumeEmploymentSupportStatus) {
    MdpResumeEmploymentSupportStatus["SupportApplicable"] = "SUPPORT_APPLICABLE";
    MdpResumeEmploymentSupportStatus["SupportNotApplicable"] = "SUPPORT_NOT_APPLICABLE";
    MdpResumeEmploymentSupportStatus["UnknownEmploymentSupportStatus"] = "UNKNOWN_EMPLOYMENT_SUPPORT_STATUS";
})(MdpResumeEmploymentSupportStatus || (MdpResumeEmploymentSupportStatus = {}));
export var MdpResumeEuropeanUnionWorkPermit;
(function (MdpResumeEuropeanUnionWorkPermit) {
    MdpResumeEuropeanUnionWorkPermit["EuNo"] = "EU_NO";
    MdpResumeEuropeanUnionWorkPermit["EuYes"] = "EU_YES";
    MdpResumeEuropeanUnionWorkPermit["UnknownEuropeanUnionWorkPermit"] = "UNKNOWN_EUROPEAN_UNION_WORK_PERMIT";
})(MdpResumeEuropeanUnionWorkPermit || (MdpResumeEuropeanUnionWorkPermit = {}));
export var MdpResumeGender;
(function (MdpResumeGender) {
    MdpResumeGender["Female"] = "FEMALE";
    MdpResumeGender["GenderNone"] = "GENDER_NONE";
    MdpResumeGender["Male"] = "MALE";
    MdpResumeGender["UnknownGender"] = "UNKNOWN_GENDER";
})(MdpResumeGender || (MdpResumeGender = {}));
export var MdpResumeGeocodePrecision;
(function (MdpResumeGeocodePrecision) {
    MdpResumeGeocodePrecision["Address"] = "ADDRESS";
    MdpResumeGeocodePrecision["Admin1"] = "ADMIN1";
    MdpResumeGeocodePrecision["Admin2"] = "ADMIN2";
    MdpResumeGeocodePrecision["Admin3"] = "ADMIN3";
    MdpResumeGeocodePrecision["Admin4"] = "ADMIN4";
    MdpResumeGeocodePrecision["City"] = "CITY";
    MdpResumeGeocodePrecision["Country"] = "COUNTRY";
    MdpResumeGeocodePrecision["Postal"] = "POSTAL";
    MdpResumeGeocodePrecision["UnknownGeocodePrecision"] = "UNKNOWN_GEOCODE_PRECISION";
})(MdpResumeGeocodePrecision || (MdpResumeGeocodePrecision = {}));
export var MdpResumeHighestCareerLevel;
(function (MdpResumeHighestCareerLevel) {
    MdpResumeHighestCareerLevel["Executive"] = "EXECUTIVE";
    MdpResumeHighestCareerLevel["HclExperienced"] = "HCL_EXPERIENCED";
    MdpResumeHighestCareerLevel["HclNewGrad"] = "HCL_NEW_GRAD";
    MdpResumeHighestCareerLevel["NoExperience"] = "NO_EXPERIENCE";
    MdpResumeHighestCareerLevel["Student"] = "STUDENT";
    MdpResumeHighestCareerLevel["UnknownHighestCareerLevel"] = "UNKNOWN_HIGHEST_CAREER_LEVEL";
})(MdpResumeHighestCareerLevel || (MdpResumeHighestCareerLevel = {}));
export var MdpResumeHighestLevelOfEducation;
(function (MdpResumeHighestLevelOfEducation) {
    MdpResumeHighestLevelOfEducation["Eight"] = "EIGHT";
    MdpResumeHighestLevelOfEducation["Eighteen"] = "EIGHTEEN";
    MdpResumeHighestLevelOfEducation["Eleven"] = "ELEVEN";
    MdpResumeHighestLevelOfEducation["Fifteen"] = "FIFTEEN";
    MdpResumeHighestLevelOfEducation["Five"] = "FIVE";
    MdpResumeHighestLevelOfEducation["Four"] = "FOUR";
    MdpResumeHighestLevelOfEducation["Fourteen"] = "FOURTEEN";
    MdpResumeHighestLevelOfEducation["Nine"] = "NINE";
    MdpResumeHighestLevelOfEducation["Nineteen"] = "NINETEEN";
    MdpResumeHighestLevelOfEducation["Seven"] = "SEVEN";
    MdpResumeHighestLevelOfEducation["Seventeen"] = "SEVENTEEN";
    MdpResumeHighestLevelOfEducation["Six"] = "SIX";
    MdpResumeHighestLevelOfEducation["Sixteen"] = "SIXTEEN";
    MdpResumeHighestLevelOfEducation["Ten"] = "TEN";
    MdpResumeHighestLevelOfEducation["Thirteen"] = "THIRTEEN";
    MdpResumeHighestLevelOfEducation["Twelve"] = "TWELVE";
    MdpResumeHighestLevelOfEducation["Twenty"] = "TWENTY";
    MdpResumeHighestLevelOfEducation["TwentyFive"] = "TWENTY_FIVE";
    MdpResumeHighestLevelOfEducation["TwentyFour"] = "TWENTY_FOUR";
    MdpResumeHighestLevelOfEducation["TwentyOne"] = "TWENTY_ONE";
    MdpResumeHighestLevelOfEducation["TwentySeven"] = "TWENTY_SEVEN";
    MdpResumeHighestLevelOfEducation["TwentySix"] = "TWENTY_SIX";
    MdpResumeHighestLevelOfEducation["TwentyThree"] = "TWENTY_THREE";
    MdpResumeHighestLevelOfEducation["TwentyTwo"] = "TWENTY_TWO";
    MdpResumeHighestLevelOfEducation["UnknownHighestLevelOfEducation"] = "UNKNOWN_HIGHEST_LEVEL_OF_EDUCATION";
    MdpResumeHighestLevelOfEducation["Zero"] = "ZERO";
})(MdpResumeHighestLevelOfEducation || (MdpResumeHighestLevelOfEducation = {}));
export var MdpResumeInternationalEmploymentEligibility;
(function (MdpResumeInternationalEmploymentEligibility) {
    MdpResumeInternationalEmploymentEligibility["Citizen"] = "CITIZEN";
    MdpResumeInternationalEmploymentEligibility["EmploymentPass"] = "EMPLOYMENT_PASS";
    MdpResumeInternationalEmploymentEligibility["IntNo"] = "INT_NO";
    MdpResumeInternationalEmploymentEligibility["IntOther"] = "INT_OTHER";
    MdpResumeInternationalEmploymentEligibility["IntYes"] = "INT_YES";
    MdpResumeInternationalEmploymentEligibility["Sponsorship"] = "SPONSORSHIP";
    MdpResumeInternationalEmploymentEligibility["TrainingEmploymentPass"] = "TRAINING_EMPLOYMENT_PASS";
    MdpResumeInternationalEmploymentEligibility["UnknownInternationalEmploymentEligibility"] = "UNKNOWN_INTERNATIONAL_EMPLOYMENT_ELIGIBILITY";
})(MdpResumeInternationalEmploymentEligibility || (MdpResumeInternationalEmploymentEligibility = {}));
export var MdpResumeLicenseType;
(function (MdpResumeLicenseType) {
    MdpResumeLicenseType["LicenseAccountingLicense"] = "LICENSE_ACCOUNTING_LICENSE";
    MdpResumeLicenseType["LicenseDriversLicense"] = "LICENSE_DRIVERS_LICENSE";
    MdpResumeLicenseType["LicenseNursesLicense"] = "LICENSE_NURSES_LICENSE";
    MdpResumeLicenseType["UnknownLicenseType"] = "UNKNOWN_LICENSE_TYPE";
})(MdpResumeLicenseType || (MdpResumeLicenseType = {}));
export var MdpResumeNyscStatus;
(function (MdpResumeNyscStatus) {
    MdpResumeNyscStatus["Completed"] = "COMPLETED";
    MdpResumeNyscStatus["NyscNotApplicable"] = "NYSC_NOT_APPLICABLE";
    MdpResumeNyscStatus["Ongoing"] = "ONGOING";
    MdpResumeNyscStatus["UnknownNyscStatus"] = "UNKNOWN_NYSC_STATUS";
})(MdpResumeNyscStatus || (MdpResumeNyscStatus = {}));
export var MdpResumeRawTextLatestApplyResumeType;
(function (MdpResumeRawTextLatestApplyResumeType) {
    MdpResumeRawTextLatestApplyResumeType["LatestApplyFileResume"] = "LATEST_APPLY_FILE_RESUME";
    MdpResumeRawTextLatestApplyResumeType["LatestApplyFileResumeTailored"] = "LATEST_APPLY_FILE_RESUME_TAILORED";
    MdpResumeRawTextLatestApplyResumeType["LatestApplyIndeedResume"] = "LATEST_APPLY_INDEED_RESUME";
    MdpResumeRawTextLatestApplyResumeType["LatestApplyIndeedResumeTailored"] = "LATEST_APPLY_INDEED_RESUME_TAILORED";
    MdpResumeRawTextLatestApplyResumeType["UnknownLatestApplyResumeType"] = "UNKNOWN_LATEST_APPLY_RESUME_TYPE";
})(MdpResumeRawTextLatestApplyResumeType || (MdpResumeRawTextLatestApplyResumeType = {}));
export var MdpResumeRawTextType;
(function (MdpResumeRawTextType) {
    MdpResumeRawTextType["Glassdoor"] = "GLASSDOOR";
    MdpResumeRawTextType["IndeedResume"] = "INDEED_RESUME";
    MdpResumeRawTextType["Parsed"] = "PARSED";
    MdpResumeRawTextType["Recruit"] = "RECRUIT";
    MdpResumeRawTextType["Resumecom"] = "RESUMECOM";
    MdpResumeRawTextType["Simplyhired"] = "SIMPLYHIRED";
    MdpResumeRawTextType["UnknownResumeType"] = "UNKNOWN_RESUME_TYPE";
})(MdpResumeRawTextType || (MdpResumeRawTextType = {}));
export var MdpResumeSourcingElection;
(function (MdpResumeSourcingElection) {
    MdpResumeSourcingElection["OptIn"] = "OPT_IN";
    MdpResumeSourcingElection["OptOut"] = "OPT_OUT";
    MdpResumeSourcingElection["UnknownSourcingElection"] = "UNKNOWN_SOURCING_ELECTION";
})(MdpResumeSourcingElection || (MdpResumeSourcingElection = {}));
export var MdpResumeTimeUnit;
(function (MdpResumeTimeUnit) {
    MdpResumeTimeUnit["Days"] = "DAYS";
    MdpResumeTimeUnit["Months"] = "MONTHS";
    MdpResumeTimeUnit["UnknownTimeUnit"] = "UNKNOWN_TIME_UNIT";
    MdpResumeTimeUnit["Weeks"] = "WEEKS";
    MdpResumeTimeUnit["Years"] = "YEARS";
})(MdpResumeTimeUnit || (MdpResumeTimeUnit = {}));
export var MdpResumeType;
(function (MdpResumeType) {
    MdpResumeType["Epas"] = "EPAS";
    MdpResumeType["File"] = "FILE";
    MdpResumeType["Glassdoor"] = "GLASSDOOR";
    MdpResumeType["IndeedResume"] = "INDEED_RESUME";
    MdpResumeType["Parsed"] = "PARSED";
    MdpResumeType["Recruit"] = "RECRUIT";
    MdpResumeType["Resumecom"] = "RESUMECOM";
    MdpResumeType["Simplyhired"] = "SIMPLYHIRED";
    MdpResumeType["UnknownResumeType"] = "UNKNOWN_RESUME_TYPE";
})(MdpResumeType || (MdpResumeType = {}));
export var MdpResumeVeteranStatus;
(function (MdpResumeVeteranStatus) {
    MdpResumeVeteranStatus["Applicable"] = "APPLICABLE";
    MdpResumeVeteranStatus["NotApplicable"] = "NOT_APPLICABLE";
    MdpResumeVeteranStatus["UnknownVeteranStatus"] = "UNKNOWN_VETERAN_STATUS";
})(MdpResumeVeteranStatus || (MdpResumeVeteranStatus = {}));
export var MdpResumeWillingToTravel;
(function (MdpResumeWillingToTravel) {
    MdpResumeWillingToTravel["DependsOnOpportunity"] = "DEPENDS_ON_OPPORTUNITY";
    MdpResumeWillingToTravel["TravelNo"] = "TRAVEL_NO";
    MdpResumeWillingToTravel["TravelYes"] = "TRAVEL_YES";
    MdpResumeWillingToTravel["UnknownWillingToTravel"] = "UNKNOWN_WILLING_TO_TRAVEL";
})(MdpResumeWillingToTravel || (MdpResumeWillingToTravel = {}));
export var MdpRole;
(function (MdpRole) {
    MdpRole["Employer"] = "EMPLOYER";
    MdpRole["Jobseeker"] = "JOBSEEKER";
    MdpRole["UnknownRole"] = "UNKNOWN_ROLE";
})(MdpRole || (MdpRole = {}));
export var MdpSalaryType;
(function (MdpSalaryType) {
    MdpSalaryType["Biweekly"] = "BIWEEKLY";
    MdpSalaryType["Daily"] = "DAILY";
    MdpSalaryType["Gig"] = "GIG";
    MdpSalaryType["Hourly"] = "HOURLY";
    MdpSalaryType["Monthly"] = "MONTHLY";
    MdpSalaryType["None"] = "NONE";
    MdpSalaryType["Quarterly"] = "QUARTERLY";
    MdpSalaryType["Semianually"] = "SEMIANUALLY";
    MdpSalaryType["UnknownSalaryType"] = "UNKNOWN_SALARY_TYPE";
    MdpSalaryType["Weekly"] = "WEEKLY";
    MdpSalaryType["Yearly"] = "YEARLY";
})(MdpSalaryType || (MdpSalaryType = {}));
export var MdpSectionType;
(function (MdpSectionType) {
    MdpSectionType["JobDescription"] = "JOB_DESCRIPTION";
    MdpSectionType["JobDradisRemoteTag"] = "JOB_DRADIS_REMOTE_TAG";
    MdpSectionType["JobLocation"] = "JOB_LOCATION";
    MdpSectionType["JobMetadataCategory"] = "JOB_METADATA_CATEGORY";
    MdpSectionType["JobMetadataEducation"] = "JOB_METADATA_EDUCATION";
    MdpSectionType["JobMetadataExperience"] = "JOB_METADATA_EXPERIENCE";
    MdpSectionType["JobMetadataJobtype"] = "JOB_METADATA_JOBTYPE";
    MdpSectionType["JobTagRawLocation"] = "JOB_TAG_RAW_LOCATION";
    MdpSectionType["JobTagRawTitle"] = "JOB_TAG_RAW_TITLE";
    MdpSectionType["JobTagRemoteType"] = "JOB_TAG_REMOTE_TYPE";
    MdpSectionType["JobTitle"] = "JOB_TITLE";
    MdpSectionType["ResumeAdditionalInfo"] = "RESUME_ADDITIONAL_INFO";
    MdpSectionType["ResumeAssessments"] = "RESUME_ASSESSMENTS";
    MdpSectionType["ResumeAssociations"] = "RESUME_ASSOCIATIONS";
    MdpSectionType["ResumeAwards"] = "RESUME_AWARDS";
    MdpSectionType["ResumeCertifications"] = "RESUME_CERTIFICATIONS";
    MdpSectionType["ResumeEducation"] = "RESUME_EDUCATION";
    MdpSectionType["ResumeExperience"] = "RESUME_EXPERIENCE";
    MdpSectionType["ResumeLicenses"] = "RESUME_LICENSES";
    MdpSectionType["ResumeLinks"] = "RESUME_LINKS";
    MdpSectionType["ResumeMilitaryService"] = "RESUME_MILITARY_SERVICE";
    MdpSectionType["ResumePatents"] = "RESUME_PATENTS";
    MdpSectionType["ResumePublications"] = "RESUME_PUBLICATIONS";
    MdpSectionType["ResumeSkill"] = "RESUME_SKILL";
    MdpSectionType["ResumeSummary"] = "RESUME_SUMMARY";
    MdpSectionType["ResumeTitle"] = "RESUME_TITLE";
    MdpSectionType["UnknownDocumentSectionType"] = "UNKNOWN_DOCUMENT_SECTION_TYPE";
})(MdpSectionType || (MdpSectionType = {}));
export var MdpSentiment;
(function (MdpSentiment) {
    MdpSentiment["Negative"] = "NEGATIVE";
    MdpSentiment["Positive"] = "POSITIVE";
    MdpSentiment["UnknownSentiment"] = "UNKNOWN_SENTIMENT";
})(MdpSentiment || (MdpSentiment = {}));
export var MdpSharedResumeType;
(function (MdpSharedResumeType) {
    MdpSharedResumeType["Epas"] = "EPAS";
    MdpSharedResumeType["File"] = "FILE";
    MdpSharedResumeType["Glassdoor"] = "GLASSDOOR";
    MdpSharedResumeType["IndeedResume"] = "INDEED_RESUME";
    MdpSharedResumeType["Parsed"] = "PARSED";
    MdpSharedResumeType["Recruit"] = "RECRUIT";
    MdpSharedResumeType["Resumecom"] = "RESUMECOM";
    MdpSharedResumeType["Simplyhired"] = "SIMPLYHIRED";
    MdpSharedResumeType["UnknownResumeType"] = "UNKNOWN_RESUME_TYPE";
})(MdpSharedResumeType || (MdpSharedResumeType = {}));
export var MdpSource;
(function (MdpSource) {
    MdpSource["BasicProfileOnly"] = "BASIC_PROFILE_ONLY";
    MdpSource["BasicProfileUpload"] = "BASIC_PROFILE_UPLOAD";
    MdpSource["BlankTemplate"] = "BLANK_TEMPLATE";
    MdpSource["DocumentUpload"] = "DOCUMENT_UPLOAD";
    MdpSource["DropboxUpload"] = "DROPBOX_UPLOAD";
    MdpSource["Duplicate"] = "DUPLICATE";
    MdpSource["FacebookProfile"] = "FACEBOOK_PROFILE";
    MdpSource["GoogleDoc"] = "GOOGLE_DOC";
    MdpSource["IndeedApply"] = "INDEED_APPLY";
    MdpSource["LinkedinProfile"] = "LINKEDIN_PROFILE";
    MdpSource["MessagingApp"] = "MESSAGING_APP";
    MdpSource["MicroContent"] = "MICRO_CONTENT";
    MdpSource["MicroContentCarousel"] = "MICRO_CONTENT_CAROUSEL";
    MdpSource["MicroContentJp"] = "MICRO_CONTENT_JP";
    MdpSource["NativeCreate"] = "NATIVE_CREATE";
    MdpSource["NativeUpload"] = "NATIVE_UPLOAD";
    MdpSource["Owain"] = "OWAIN";
    MdpSource["Resumecom"] = "RESUMECOM";
    MdpSource["UniversalResume"] = "UNIVERSAL_RESUME";
    MdpSource["UnknownSource"] = "UNKNOWN_SOURCE";
})(MdpSource || (MdpSource = {}));
export var MdpSourceType;
(function (MdpSourceType) {
    MdpSourceType["Explicit"] = "EXPLICIT";
    MdpSourceType["Inferred"] = "INFERRED";
    MdpSourceType["UnknownSourceType"] = "UNKNOWN_SOURCE_TYPE";
})(MdpSourceType || (MdpSourceType = {}));
export var MdpState;
(function (MdpState) {
    MdpState["Deleted"] = "DELETED";
    MdpState["Hidden"] = "HIDDEN";
    MdpState["Public"] = "PUBLIC";
    MdpState["UnknownState"] = "UNKNOWN_STATE";
})(MdpState || (MdpState = {}));
export var MdpStatus;
(function (MdpStatus) {
    MdpStatus["Active"] = "ACTIVE";
    MdpStatus["Inactive"] = "INACTIVE";
    MdpStatus["Sanitized"] = "SANITIZED";
    MdpStatus["UnknownStatus"] = "UNKNOWN_STATUS";
})(MdpStatus || (MdpStatus = {}));
export var MdpSubscriptionStatus;
(function (MdpSubscriptionStatus) {
    MdpSubscriptionStatus["BillingRetryPeriod"] = "BILLING_RETRY_PERIOD";
    MdpSubscriptionStatus["Expired"] = "EXPIRED";
    MdpSubscriptionStatus["GracePeriod"] = "GRACE_PERIOD";
    MdpSubscriptionStatus["NoneSubscriptionStatus"] = "NONE_SUBSCRIPTION_STATUS";
    MdpSubscriptionStatus["Revoked"] = "REVOKED";
    MdpSubscriptionStatus["Subscribed"] = "SUBSCRIBED";
    MdpSubscriptionStatus["UnknownSubscriptionStatus"] = "UNKNOWN_SUBSCRIPTION_STATUS";
})(MdpSubscriptionStatus || (MdpSubscriptionStatus = {}));
export var MdpSubscriptionTier;
(function (MdpSubscriptionTier) {
    MdpSubscriptionTier["NoneSubscriptionTier"] = "NONE_SUBSCRIPTION_TIER";
    MdpSubscriptionTier["Tier1"] = "TIER1";
    MdpSubscriptionTier["UnknownSubscriptionTier"] = "UNKNOWN_SUBSCRIPTION_TIER";
})(MdpSubscriptionTier || (MdpSubscriptionTier = {}));
export var MdpTimeUnit;
(function (MdpTimeUnit) {
    MdpTimeUnit["Day"] = "DAY";
    MdpTimeUnit["Month"] = "MONTH";
    MdpTimeUnit["UnknownTimeUnit"] = "UNKNOWN_TIME_UNIT";
    MdpTimeUnit["Week"] = "WEEK";
    MdpTimeUnit["Year"] = "YEAR";
})(MdpTimeUnit || (MdpTimeUnit = {}));
export var MdpWorkWellbeingDimension;
(function (MdpWorkWellbeingDimension) {
    MdpWorkWellbeingDimension["Achievement"] = "ACHIEVEMENT";
    MdpWorkWellbeingDimension["Appreciation"] = "APPRECIATION";
    MdpWorkWellbeingDimension["Belonging"] = "BELONGING";
    MdpWorkWellbeingDimension["Compensation"] = "COMPENSATION";
    MdpWorkWellbeingDimension["Energy"] = "ENERGY";
    MdpWorkWellbeingDimension["Flexibility"] = "FLEXIBILITY";
    MdpWorkWellbeingDimension["Happiness"] = "HAPPINESS";
    MdpWorkWellbeingDimension["Inclusion"] = "INCLUSION";
    MdpWorkWellbeingDimension["Learning"] = "LEARNING";
    MdpWorkWellbeingDimension["Management"] = "MANAGEMENT";
    MdpWorkWellbeingDimension["Overall"] = "OVERALL";
    MdpWorkWellbeingDimension["Purpose"] = "PURPOSE";
    MdpWorkWellbeingDimension["Satisfaction"] = "SATISFACTION";
    MdpWorkWellbeingDimension["StressFree"] = "STRESS_FREE";
    MdpWorkWellbeingDimension["Support"] = "SUPPORT";
    MdpWorkWellbeingDimension["Trust"] = "TRUST";
    MdpWorkWellbeingDimension["UnknownWorkWellbeingDimension"] = "UNKNOWN_WORK_WELLBEING_DIMENSION";
})(MdpWorkWellbeingDimension || (MdpWorkWellbeingDimension = {}));
export var MdpWorkWellbeingDimensionRatingLabel;
(function (MdpWorkWellbeingDimensionRatingLabel) {
    MdpWorkWellbeingDimensionRatingLabel["Excellent"] = "EXCELLENT";
    MdpWorkWellbeingDimensionRatingLabel["Fair"] = "FAIR";
    MdpWorkWellbeingDimensionRatingLabel["Good"] = "GOOD";
    MdpWorkWellbeingDimensionRatingLabel["Great"] = "GREAT";
    MdpWorkWellbeingDimensionRatingLabel["Poor"] = "POOR";
    MdpWorkWellbeingDimensionRatingLabel["UnknownWorkWellbeingDimensionRatingLabel"] = "UNKNOWN_WORK_WELLBEING_DIMENSION_RATING_LABEL";
})(MdpWorkWellbeingDimensionRatingLabel || (MdpWorkWellbeingDimensionRatingLabel = {}));
/** API response codes, following standard GraphQL codes. See [Common GraphQL error codes](/getstarted/troubleshoot-graphql-errors#common-graphql-error-codes). */
export var MdsResponseCode;
(function (MdsResponseCode) {
    /** An input parameter is invalid. This error code applies to input validation performed beyond the standard GraphQL client and server libraries non-null and type checking. */
    MdsResponseCode["BadUserInput"] = "BAD_USER_INPUT";
    /** Valid authentication credentials are present but are insufficient to perform the associated operation. This error code is the GraphQL equivalent of the HTTP [`403 Forbidden`](https://developer.mozilla.org/docs/Web/HTTP/Status/403) status code. */
    MdsResponseCode["Forbidden"] = "FORBIDDEN";
    /** The server encountered an unexpected failure and did not provide a response. */
    MdsResponseCode["InternalServerError"] = "INTERNAL_SERVER_ERROR";
    /** The operation completed. If the GraphQL response contains an `errors` array, an error occurred. */
    MdsResponseCode["Ok"] = "OK";
    /** The response contains part of a successful response due to one or more failures. */
    MdsResponseCode["PartialSuccess"] = "PARTIAL_SUCCESS";
    /** The query exceeded the allowed complexity for a single request. */
    MdsResponseCode["QueryTooComplex"] = "QUERY_TOO_COMPLEX";
    /** The request lacked sufficient authentication credentials for the operation. The operation was not attempted. This error code is the GraphQL equivalent of the HTTP [`401 Unauthorized`](https://developer.mozilla.org/docs/Web/HTTP/Status/401) status code. */
    MdsResponseCode["Unauthenticated"] = "UNAUTHENTICATED";
})(MdsResponseCode || (MdsResponseCode = {}));
/**  Operators to be used in building filters for measures  */
export var MeasureFilterOperator;
(function (MeasureFilterOperator) {
    MeasureFilterOperator["Between"] = "BETWEEN";
    MeasureFilterOperator["Eq"] = "EQ";
    MeasureFilterOperator["Gt"] = "GT";
    MeasureFilterOperator["Gte"] = "GTE";
    MeasureFilterOperator["Lt"] = "LT";
    MeasureFilterOperator["Lte"] = "LTE";
    MeasureFilterOperator["Ne"] = "NE";
})(MeasureFilterOperator || (MeasureFilterOperator = {}));
export var MessageContentFormat;
(function (MessageContentFormat) {
    MessageContentFormat["Html"] = "HTML";
    MessageContentFormat["Plain"] = "PLAIN";
})(MessageContentFormat || (MessageContentFormat = {}));
/** A list of actions that can be performed on a template */
export var MessageTemplateAction;
(function (MessageTemplateAction) {
    MessageTemplateAction["Create"] = "CREATE";
    MessageTemplateAction["Edit"] = "EDIT";
    MessageTemplateAction["Usage"] = "USAGE";
})(MessageTemplateAction || (MessageTemplateAction = {}));
/** A list of reasons for why an error could have occurred */
export var MessageTemplateErrorReason;
(function (MessageTemplateErrorReason) {
    MessageTemplateErrorReason["BadUserInput"] = "BAD_USER_INPUT";
    MessageTemplateErrorReason["DuplicateKey"] = "DUPLICATE_KEY";
    MessageTemplateErrorReason["InternalError"] = "INTERNAL_ERROR";
    MessageTemplateErrorReason["NotFound"] = "NOT_FOUND";
    MessageTemplateErrorReason["PermissionDenied"] = "PERMISSION_DENIED";
})(MessageTemplateErrorReason || (MessageTemplateErrorReason = {}));
export var MetadataCatalogDataAssetFieldSort;
(function (MetadataCatalogDataAssetFieldSort) {
    /** Sort by description */
    MetadataCatalogDataAssetFieldSort["DescriptionAsc"] = "DESCRIPTION_ASC";
    /** Sort by description in descending order */
    MetadataCatalogDataAssetFieldSort["DescriptionDesc"] = "DESCRIPTION_DESC";
    /** Sort by lifecycle status */
    MetadataCatalogDataAssetFieldSort["LifecycleStatusAsc"] = "LIFECYCLE_STATUS_ASC";
    /** Sort by lifecycle status in descending order */
    MetadataCatalogDataAssetFieldSort["LifecycleStatusDesc"] = "LIFECYCLE_STATUS_DESC";
    /** Sort by name */
    MetadataCatalogDataAssetFieldSort["NameAsc"] = "NAME_ASC";
    /** Sort by name in descending order */
    MetadataCatalogDataAssetFieldSort["NameDesc"] = "NAME_DESC";
})(MetadataCatalogDataAssetFieldSort || (MetadataCatalogDataAssetFieldSort = {}));
/** Lifecycle stage options for data assets, representing the product/feature maturity lifecycle */
export var MetadataCatalogDataAssetLifecycleStage;
(function (MetadataCatalogDataAssetLifecycleStage) {
    /** No longer supported and planned for decommission; stakeholders are migrating to new solutions */
    MetadataCatalogDataAssetLifecycleStage["Deprecated"] = "DEPRECATED";
    /** Engineering team independently tests the product/feature; select users may assist */
    MetadataCatalogDataAssetLifecycleStage["EarlyAccessRelease"] = "EARLY_ACCESS_RELEASE";
    /** Asset has no lifecycle stage set; used for facet bucketing of unset values, not as a settable stage */
    MetadataCatalogDataAssetLifecycleStage["Empty"] = "EMPTY";
    /** Product/feature is available to all stakeholders with agreed SLAs */
    MetadataCatalogDataAssetLifecycleStage["FullSupportRelease"] = "FULL_SUPPORT_RELEASE";
    /** Engineering team delivers initial product features incrementally */
    MetadataCatalogDataAssetLifecycleStage["InitialDevelopment"] = "INITIAL_DEVELOPMENT";
    /** Engineering team engages with stakeholders to align on requirements and user stories */
    MetadataCatalogDataAssetLifecycleStage["InDiscovery"] = "IN_DISCOVERY";
    /** Limited users test for functional requirements; team has committed to progress */
    MetadataCatalogDataAssetLifecycleStage["LimitedSupportRelease"] = "LIMITED_SUPPORT_RELEASE";
    /** Generally available but only maintenance, security, and bug fixes are ongoing; no new features */
    MetadataCatalogDataAssetLifecycleStage["MaintenanceMode"] = "MAINTENANCE_MODE";
    /** No longer supported and not accessible to stakeholders; ready for or already decommissioned */
    MetadataCatalogDataAssetLifecycleStage["Unavailable"] = "UNAVAILABLE";
})(MetadataCatalogDataAssetLifecycleStage || (MetadataCatalogDataAssetLifecycleStage = {}));
/** Lifecycle status options for data assets and fields */
export var MetadataCatalogDataAssetLifecycleStatus;
(function (MetadataCatalogDataAssetLifecycleStatus) {
    /** Asset is approved for use */
    MetadataCatalogDataAssetLifecycleStatus["Approved"] = "APPROVED";
    /** Asset is no longer recommended for use */
    MetadataCatalogDataAssetLifecycleStatus["Deprecated"] = "DEPRECATED";
    /** Asset has no lifecycle status */
    MetadataCatalogDataAssetLifecycleStatus["Empty"] = "EMPTY";
    /** Asset is maintained but may be replaced */
    MetadataCatalogDataAssetLifecycleStatus["Legacy"] = "LEGACY";
    /** Asset is still being developed */
    MetadataCatalogDataAssetLifecycleStatus["WorkInProgress"] = "WORK_IN_PROGRESS";
})(MetadataCatalogDataAssetLifecycleStatus || (MetadataCatalogDataAssetLifecycleStatus = {}));
/** Lifecycle status options for data assets and fields */
export var MetadataCatalogDataAssetLifecycleStatusFilter;
(function (MetadataCatalogDataAssetLifecycleStatusFilter) {
    /** Asset is approved for use */
    MetadataCatalogDataAssetLifecycleStatusFilter["Approved"] = "APPROVED";
    /** Asset is no longer recommended for use */
    MetadataCatalogDataAssetLifecycleStatusFilter["Deprecated"] = "DEPRECATED";
    /** No Lifecycle Status */
    MetadataCatalogDataAssetLifecycleStatusFilter["Empty"] = "EMPTY";
    /** Asset is maintained but may be replaced */
    MetadataCatalogDataAssetLifecycleStatusFilter["Legacy"] = "LEGACY";
    /** Asset is still being developed */
    MetadataCatalogDataAssetLifecycleStatusFilter["WorkInProgress"] = "WORK_IN_PROGRESS";
})(MetadataCatalogDataAssetLifecycleStatusFilter || (MetadataCatalogDataAssetLifecycleStatusFilter = {}));
/** Notice severity tags for data assets */
export var MetadataCatalogDataAssetNoticeSeverityTag;
(function (MetadataCatalogDataAssetNoticeSeverityTag) {
    /** No notices */
    MetadataCatalogDataAssetNoticeSeverityTag["Empty"] = "EMPTY";
    /** Has impacting notices */
    MetadataCatalogDataAssetNoticeSeverityTag["Impacting"] = "IMPACTING";
    /** Has informative notices */
    MetadataCatalogDataAssetNoticeSeverityTag["Informative"] = "INFORMATIVE";
})(MetadataCatalogDataAssetNoticeSeverityTag || (MetadataCatalogDataAssetNoticeSeverityTag = {}));
export var MetadataCatalogSearchField;
(function (MetadataCatalogSearchField) {
    MetadataCatalogSearchField["DataManifest"] = "DATA_MANIFEST";
    MetadataCatalogSearchField["Description"] = "DESCRIPTION";
    MetadataCatalogSearchField["FieldDescription"] = "FIELD_DESCRIPTION";
    MetadataCatalogSearchField["FieldName"] = "FIELD_NAME";
    MetadataCatalogSearchField["Irn"] = "IRN";
    MetadataCatalogSearchField["MetricsDescription"] = "METRICS_DESCRIPTION";
    MetadataCatalogSearchField["Name"] = "NAME";
})(MetadataCatalogSearchField || (MetadataCatalogSearchField = {}));
export var MetadataTaxonomyDocumentSectionType;
(function (MetadataTaxonomyDocumentSectionType) {
    /** Job description section of the job posting. */
    MetadataTaxonomyDocumentSectionType["JobDescription"] = "JOB_DESCRIPTION";
    /** Job location section of the job posting. */
    MetadataTaxonomyDocumentSectionType["JobLocation"] = "JOB_LOCATION";
    /** Job title section of the job posting. */
    MetadataTaxonomyDocumentSectionType["JobTitle"] = "JOB_TITLE";
    /** API could not identify the section of the job posting. */
    MetadataTaxonomyDocumentSectionType["Unknown"] = "UNKNOWN";
})(MetadataTaxonomyDocumentSectionType || (MetadataTaxonomyDocumentSectionType = {}));
/** Media types */
export var MimeType;
(function (MimeType) {
    MimeType["TextCsv"] = "TEXT_CSV";
})(MimeType || (MimeType = {}));
/** Experiment status values */
export var MinBudgetExperimentStatus;
(function (MinBudgetExperimentStatus) {
    MinBudgetExperimentStatus["Active"] = "ACTIVE";
    MinBudgetExperimentStatus["Inactive"] = "INACTIVE";
})(MinBudgetExperimentStatus || (MinBudgetExperimentStatus = {}));
/** Identifier for each minimally complete condition */
export var MinimallyCompleteCriteria;
(function (MinimallyCompleteCriteria) {
    /** Whether the profile contains any credential(s) */
    MinimallyCompleteCriteria["Credential"] = "CREDENTIAL";
    /** Whether the profile contains both first and last name */
    MinimallyCompleteCriteria["FirstLastName"] = "FIRST_LAST_NAME";
    /** Whether the profile contains precise location */
    MinimallyCompleteCriteria["Location"] = "LOCATION";
    /** Whether the profile contains minimum desired pay */
    MinimallyCompleteCriteria["MinPay"] = "MIN_PAY";
    /** Whether the profile resume contains minimum required word count */
    MinimallyCompleteCriteria["MinWordCount"] = "MIN_WORD_COUNT";
    /** Whether the profile contains occupation (user reported or extracted) */
    MinimallyCompleteCriteria["Occupation"] = "OCCUPATION";
    /** Whether the profile contains skill(s) */
    MinimallyCompleteCriteria["Skill"] = "SKILL";
    /** Whether the profile is eligible for sourcing */
    MinimallyCompleteCriteria["SourcingEligible"] = "SOURCING_ELIGIBLE";
})(MinimallyCompleteCriteria || (MinimallyCompleteCriteria = {}));
/** The location's minimum granularity */
export var MinimumGranularity;
(function (MinimumGranularity) {
    MinimumGranularity["Admin1"] = "ADMIN1";
    MinimumGranularity["Admin2"] = "ADMIN2";
    MinimumGranularity["Admin3"] = "ADMIN3";
    MinimumGranularity["Admin4"] = "ADMIN4";
    MinimumGranularity["City"] = "CITY";
    MinimumGranularity["Country"] = "COUNTRY";
})(MinimumGranularity || (MinimumGranularity = {}));
/** Defines the possible account type for a given group */
export var MirroredEmployerHierarchyGroupType;
(function (MirroredEmployerHierarchyGroupType) {
    MirroredEmployerHierarchyGroupType["Any"] = "ANY";
    MirroredEmployerHierarchyGroupType["Franchisee"] = "FRANCHISEE";
    MirroredEmployerHierarchyGroupType["Hiring"] = "HIRING";
    MirroredEmployerHierarchyGroupType["None"] = "NONE";
    MirroredEmployerHierarchyGroupType["NonHiring"] = "NON_HIRING";
})(MirroredEmployerHierarchyGroupType || (MirroredEmployerHierarchyGroupType = {}));
export var MitigationAction;
(function (MitigationAction) {
    MitigationAction["None"] = "NONE";
    MitigationAction["RecaptchaEasy"] = "RECAPTCHA_EASY";
    MitigationAction["RecaptchaHard"] = "RECAPTCHA_HARD";
    MitigationAction["RecaptchaMedium"] = "RECAPTCHA_MEDIUM";
    MitigationAction["Turnstile"] = "TURNSTILE";
})(MitigationAction || (MitigationAction = {}));
/**
 * The user's preferred method of country selection for proctor group determination.
 * Select by IP Address, or select by the user's country setting
 */
export var MobileAppCountrySelectionMethod;
(function (MobileAppCountrySelectionMethod) {
    MobileAppCountrySelectionMethod["CountrySetting"] = "COUNTRY_SETTING";
    MobileAppCountrySelectionMethod["Ip"] = "IP";
})(MobileAppCountrySelectionMethod || (MobileAppCountrySelectionMethod = {}));
/** Mobile device OS name */
export var MobileAppPlatform;
(function (MobileAppPlatform) {
    MobileAppPlatform["Android"] = "ANDROID";
    MobileAppPlatform["Ios"] = "IOS";
    MobileAppPlatform["Windows"] = "WINDOWS";
})(MobileAppPlatform || (MobileAppPlatform = {}));
/** The type of payload value for a test allocation */
export var MobileAppProctorPayloadType;
(function (MobileAppProctorPayloadType) {
    MobileAppProctorPayloadType["DoubleArray"] = "DOUBLE_ARRAY";
    MobileAppProctorPayloadType["DoubleValue"] = "DOUBLE_VALUE";
    MobileAppProctorPayloadType["Json"] = "JSON";
    MobileAppProctorPayloadType["LongArray"] = "LONG_ARRAY";
    MobileAppProctorPayloadType["LongValue"] = "LONG_VALUE";
    MobileAppProctorPayloadType["Map"] = "MAP";
    MobileAppProctorPayloadType["StringArray"] = "STRING_ARRAY";
    MobileAppProctorPayloadType["StringValue"] = "STRING_VALUE";
})(MobileAppProctorPayloadType || (MobileAppProctorPayloadType = {}));
/**
 * For PAC Internal use
 *
 * Which tab of the add-user modal was used to invite user
 */
export var ModalTabType;
(function (ModalTabType) {
    /** Custom or All Options */
    ModalTabType["Custom"] = "CUSTOM";
    /** Default or Currently Used */
    ModalTabType["Default"] = "DEFAULT";
})(ModalTabType || (ModalTabType = {}));
/** Moderation level enumeration */
export var ModerationLevel;
(function (ModerationLevel) {
    /** Confirmed fraud account. It should be blocked. */
    ModerationLevel["Blocked"] = "BLOCKED";
    /** The default level for accounts. */
    ModerationLevel["Default"] = "DEFAULT";
    /** The job seeker has elevated risk. Reach out to Trust + Safety for more details as the semantics here may depend on the feature. */
    ModerationLevel["ElevatedRisk"] = "ELEVATED_RISK";
})(ModerationLevel || (ModerationLevel = {}));
export var ModerationLevelStatus;
(function (ModerationLevelStatus) {
    ModerationLevelStatus["Error"] = "ERROR";
    ModerationLevelStatus["NoData"] = "NO_DATA";
    ModerationLevelStatus["Success"] = "SUCCESS";
})(ModerationLevelStatus || (ModerationLevelStatus = {}));
export var ModerationState;
(function (ModerationState) {
    ModerationState["Flagged"] = "FLAGGED";
    ModerationState["None"] = "NONE";
    ModerationState["NoResults"] = "NO_RESULTS";
})(ModerationState || (ModerationState = {}));
/** Enumeration of possible moderation statuses. */
export var ModerationStatus;
(function (ModerationStatus) {
    ModerationStatus["Allowed"] = "ALLOWED";
    ModerationStatus["Disabled"] = "DISABLED";
    ModerationStatus["Paused"] = "PAUSED";
})(ModerationStatus || (ModerationStatus = {}));
/**
 * Error codes for ModifyOfferStatus failures.
 * Extendable if new failure scenarios appear.
 */
export var ModifyOfferStatusErrorCode;
(function (ModifyOfferStatusErrorCode) {
    ModifyOfferStatusErrorCode["InternalError"] = "INTERNAL_ERROR";
    ModifyOfferStatusErrorCode["InvalidAction"] = "INVALID_ACTION";
    ModifyOfferStatusErrorCode["JobseekerNotFound"] = "JOBSEEKER_NOT_FOUND";
    ModifyOfferStatusErrorCode["NoChange"] = "NO_CHANGE";
    ModifyOfferStatusErrorCode["Unauthorized"] = "UNAUTHORIZED";
})(ModifyOfferStatusErrorCode || (ModifyOfferStatusErrorCode = {}));
/** Represents the type of JobID input */
export var MonAgentSponsorshipRecJobIdType;
(function (MonAgentSponsorshipRecJobIdType) {
    /** The jobId input is of type JOB_ID */
    MonAgentSponsorshipRecJobIdType["JobId"] = "JOB_ID";
    /** The jobId input is op type JOB_KEY */
    MonAgentSponsorshipRecJobIdType["JobKey"] = "JOB_KEY";
})(MonAgentSponsorshipRecJobIdType || (MonAgentSponsorshipRecJobIdType = {}));
/**
 * Defines the supported action types for a Monetization Rule.
 *
 * This enum is non-exhaustive and new values will be added from time to time.
 */
export var MonRuleActionType;
(function (MonRuleActionType) {
    /**
     * The following fields should be set in the value JSON:
     * 1. value: the amountLocal
     * 2. currency: the currency code for the amount
     * 3. recurringUnit: the recurring duration e.g  ONETIME, MONTHLY
     */
    MonRuleActionType["BudgetCap"] = "BUDGET_CAP";
    /**
     * The following fields should be set in the value JSON:
     * 1. value: the max number of outcomes
     * 2. recurringUnit: the recurring duration e.g  ONETIME, MONTHLY
     */
    MonRuleActionType["OutcomeApplyCap"] = "OUTCOME_APPLY_CAP";
    /**
     * The following fields should be set in the value JSON:
     * 1. value: the max number of outcomes.
     * 2. recurringUnit: the recurring duration e.g  ONETIME, MONTHLY
     */
    MonRuleActionType["OutcomeStartedApplyCap"] = "OUTCOME_STARTED_APPLY_CAP";
    /**
     * The following fields should be set in the value JSON:
     * 1. value: the max number of outcomes.
     * 2. recurringUnit: the recurring duration e.g  ONETIME, MONTHLY
     */
    MonRuleActionType["OutcomeStartedApplyTarget"] = "OUTCOME_STARTED_APPLY_TARGET";
    /**
     * The following fields should be set in the value JSON:
     * 1. value: set to true or false
     */
    MonRuleActionType["Priority"] = "PRIORITY";
    /**
     * The following fields should be set in the value JSON:
     * 1. value: set to true or false
     */
    MonRuleActionType["Sponsored"] = "SPONSORED";
})(MonRuleActionType || (MonRuleActionType = {}));
/**
 * Defines the entity type to which a monetization rule can belong to.
 *
 * This enum is non-exhaustive and new values will be added from time to time.
 */
export var MonRuleEntityType;
(function (MonRuleEntityType) {
    MonRuleEntityType["CampaignType"] = "CAMPAIGN_TYPE";
})(MonRuleEntityType || (MonRuleEntityType = {}));
/**
 * Supported Field Names in Rule Condition.
 *
 * This enum is non-exhaustive and new values will be added from time to time.
 */
export var MonRuleExpressionFieldName;
(function (MonRuleExpressionFieldName) {
    MonRuleExpressionFieldName["AdminCode_1"] = "ADMIN_CODE_1";
    MonRuleExpressionFieldName["City"] = "CITY";
    MonRuleExpressionFieldName["Company"] = "COMPANY";
    MonRuleExpressionFieldName["Country"] = "COUNTRY";
    MonRuleExpressionFieldName["Description"] = "DESCRIPTION";
    MonRuleExpressionFieldName["DisplayJobNormTitle"] = "DISPLAY_JOB_NORM_TITLE";
    MonRuleExpressionFieldName["DisplayNormTitleCategory"] = "DISPLAY_NORM_TITLE_CATEGORY";
    MonRuleExpressionFieldName["JobAge"] = "JOB_AGE";
    MonRuleExpressionFieldName["JobCategoryMetadata"] = "JOB_CATEGORY_METADATA";
    MonRuleExpressionFieldName["RefNum"] = "REF_NUM";
    MonRuleExpressionFieldName["Title"] = "TITLE";
    MonRuleExpressionFieldName["Zip"] = "ZIP";
})(MonRuleExpressionFieldName || (MonRuleExpressionFieldName = {}));
/**
 * Supported Query Operators in Rule Condition.
 *
 * This enum is non-exhaustive and new values will be added from time to time.
 */
export var MonRuleExpressionQueryOperator;
(function (MonRuleExpressionQueryOperator) {
    MonRuleExpressionQueryOperator["Contains"] = "CONTAINS";
    MonRuleExpressionQueryOperator["DoesNotContain"] = "DOES_NOT_CONTAIN";
    MonRuleExpressionQueryOperator["Is"] = "IS";
    MonRuleExpressionQueryOperator["IsGreaterThanOrEqual"] = "IS_GREATER_THAN_OR_EQUAL";
    MonRuleExpressionQueryOperator["IsLessThan"] = "IS_LESS_THAN";
    MonRuleExpressionQueryOperator["IsNot"] = "IS_NOT";
})(MonRuleExpressionQueryOperator || (MonRuleExpressionQueryOperator = {}));
export var MonitorType;
(function (MonitorType) {
    MonitorType["Continuity"] = "CONTINUITY";
    MonitorType["RowCount"] = "ROW_COUNT";
})(MonitorType || (MonitorType = {}));
export var Month;
(function (Month) {
    Month["April"] = "APRIL";
    Month["August"] = "AUGUST";
    Month["December"] = "DECEMBER";
    Month["February"] = "FEBRUARY";
    Month["January"] = "JANUARY";
    Month["July"] = "JULY";
    Month["June"] = "JUNE";
    Month["March"] = "MARCH";
    Month["May"] = "MAY";
    Month["November"] = "NOVEMBER";
    Month["October"] = "OCTOBER";
    Month["September"] = "SEPTEMBER";
    Month["Unset"] = "UNSET";
})(Month || (Month = {}));
export var MosaicOptOutTrackingKeyType;
(function (MosaicOptOutTrackingKeyType) {
    MosaicOptOutTrackingKeyType["Homepage"] = "HOMEPAGE";
})(MosaicOptOutTrackingKeyType || (MosaicOptOutTrackingKeyType = {}));
/** Hires needed validation error codes for multi-location job entries. */
export var MultiLocationHiresNeededValidationErrorCode;
(function (MultiLocationHiresNeededValidationErrorCode) {
    MultiLocationHiresNeededValidationErrorCode["HiresNeededMissingValue"] = "HIRES_NEEDED_MISSING_VALUE";
    MultiLocationHiresNeededValidationErrorCode["HiresNeededValueTooLarge"] = "HIRES_NEEDED_VALUE_TOO_LARGE";
    MultiLocationHiresNeededValidationErrorCode["HiresNeededValueTooSmall"] = "HIRES_NEEDED_VALUE_TOO_SMALL";
})(MultiLocationHiresNeededValidationErrorCode || (MultiLocationHiresNeededValidationErrorCode = {}));
/** Funnel type for the multi-location job posting form. */
export var MultiLocationJobPostingFormFunnelType;
(function (MultiLocationJobPostingFormFunnelType) {
    MultiLocationJobPostingFormFunnelType["MultiLocation"] = "MULTI_LOCATION";
})(MultiLocationJobPostingFormFunnelType || (MultiLocationJobPostingFormFunnelType = {}));
/** Location validation error codes for multi-location job entries. */
export var MultiLocationLocationValidationErrorCode;
(function (MultiLocationLocationValidationErrorCode) {
    MultiLocationLocationValidationErrorCode["LocationMissingValue"] = "LOCATION_MISSING_VALUE";
})(MultiLocationLocationValidationErrorCode || (MultiLocationLocationValidationErrorCode = {}));
/**
 * Granularity enum for a multi-location job's address resolution.
 * CITY — location is resolved to city level.
 * STREET — location is resolved to street level.
 */
export var MultiLocationMostGranularLocation;
(function (MultiLocationMostGranularLocation) {
    MultiLocationMostGranularLocation["City"] = "CITY";
    MultiLocationMostGranularLocation["Street"] = "STREET";
})(MultiLocationMostGranularLocation || (MultiLocationMostGranularLocation = {}));
/** Per-job publish status. */
export var MultiLocationPublishStatus;
(function (MultiLocationPublishStatus) {
    MultiLocationPublishStatus["Failed"] = "FAILED";
    MultiLocationPublishStatus["Success"] = "SUCCESS";
})(MultiLocationPublishStatus || (MultiLocationPublishStatus = {}));
export var MyJobsInvitedJobsSort;
(function (MyJobsInvitedJobsSort) {
    MyJobsInvitedJobsSort["SentAtAsc"] = "SENT_AT_ASC";
    MyJobsInvitedJobsSort["SentAtDesc"] = "SENT_AT_DESC";
})(MyJobsInvitedJobsSort || (MyJobsInvitedJobsSort = {}));
export var MyJobsInvitedJobsWithCtaSort;
(function (MyJobsInvitedJobsWithCtaSort) {
    MyJobsInvitedJobsWithCtaSort["SentAtRanking"] = "SENT_AT_RANKING";
})(MyJobsInvitedJobsWithCtaSort || (MyJobsInvitedJobsWithCtaSort = {}));
export var MyJobsStatusesSort;
(function (MyJobsStatusesSort) {
    MyJobsStatusesSort["UserJobStatusTimestampDesc"] = "USER_JOB_STATUS_TIMESTAMP_DESC";
})(MyJobsStatusesSort || (MyJobsStatusesSort = {}));
/** MySQL cluster-level permissions (granted on *.*) */
export var MysqlClusterLevelPermission;
(function (MysqlClusterLevelPermission) {
    MysqlClusterLevelPermission["Execute"] = "EXECUTE";
    MysqlClusterLevelPermission["ReplicationClient"] = "REPLICATION_CLIENT";
    MysqlClusterLevelPermission["ReplicationSlave"] = "REPLICATION_SLAVE";
    MysqlClusterLevelPermission["Trigger"] = "TRIGGER";
})(MysqlClusterLevelPermission || (MysqlClusterLevelPermission = {}));
/** MySQL schema-level permissions (granted on database_name.*) */
export var MysqlSchemaLevelPermission;
(function (MysqlSchemaLevelPermission) {
    MysqlSchemaLevelPermission["Create"] = "CREATE";
    MysqlSchemaLevelPermission["Index"] = "INDEX";
    MysqlSchemaLevelPermission["LockTables"] = "LOCK_TABLES";
})(MysqlSchemaLevelPermission || (MysqlSchemaLevelPermission = {}));
/** Specifies which type of name field is being anonymized. */
export var NameFieldType;
(function (NameFieldType) {
    NameFieldType["FirstName"] = "FIRST_NAME";
    NameFieldType["LastName"] = "LAST_NAME";
})(NameFieldType || (NameFieldType = {}));
/** enum for targetedDevicePlatform */
export var NativePushTargetedDevicePlatform;
(function (NativePushTargetedDevicePlatform) {
    /** Send to Android platform only */
    NativePushTargetedDevicePlatform["AndroidOnly"] = "ANDROID_ONLY";
    /** Send to both iOS and Android platform */
    NativePushTargetedDevicePlatform["IosAndAndroid"] = "IOS_AND_ANDROID";
    /** Send to iOS platform only */
    NativePushTargetedDevicePlatform["IosOnly"] = "IOS_ONLY";
})(NativePushTargetedDevicePlatform || (NativePushTargetedDevicePlatform = {}));
export var NavigationCategoryId;
(function (NavigationCategoryId) {
    NavigationCategoryId["AboutYou"] = "ABOUT_YOU";
    NavigationCategoryId["Account"] = "ACCOUNT";
    NavigationCategoryId["Legal"] = "LEGAL";
    NavigationCategoryId["Options"] = "OPTIONS";
    NavigationCategoryId["Resources"] = "RESOURCES";
})(NavigationCategoryId || (NavigationCategoryId = {}));
export var NavigationItemId;
(function (NavigationItemId) {
    NavigationItemId["AccessibilityAtIndeed"] = "ACCESSIBILITY_AT_INDEED";
    NavigationItemId["AccountView"] = "ACCOUNT_VIEW";
    NavigationItemId["Ace"] = "ACE";
    NavigationItemId["AceSseClient"] = "ACE_SSE_CLIENT";
    NavigationItemId["AdsTransparency"] = "ADS_TRANSPARENCY";
    NavigationItemId["AntiSlaveryStatement"] = "ANTI_SLAVERY_STATEMENT";
    NavigationItemId["CareerAdvice"] = "CAREER_ADVICE";
    NavigationItemId["Ccpa"] = "CCPA";
    NavigationItemId["ChangeCountries"] = "CHANGE_COUNTRIES";
    NavigationItemId["CompanyReviews"] = "COMPANY_REVIEWS";
    NavigationItemId["ContactInformation"] = "CONTACT_INFORMATION";
    NavigationItemId["Cookies"] = "COOKIES";
    NavigationItemId["Cpra"] = "CPRA";
    NavigationItemId["Credentials"] = "CREDENTIALS";
    NavigationItemId["DsaOnlineSafety"] = "DSA_ONLINE_SAFETY";
    NavigationItemId["DsaReporting"] = "DSA_REPORTING";
    NavigationItemId["FindJobs"] = "FIND_JOBS";
    NavigationItemId["FindSalaries"] = "FIND_SALARIES";
    NavigationItemId["HelpCenter"] = "HELP_CENTER";
    NavigationItemId["HideJobsWithTheseDetails"] = "HIDE_JOBS_WITH_THESE_DETAILS";
    NavigationItemId["IndeedForEmployers"] = "INDEED_FOR_EMPLOYERS";
    NavigationItemId["JobPreferences"] = "JOB_PREFERENCES";
    NavigationItemId["Messages"] = "MESSAGES";
    NavigationItemId["MyDemographics"] = "MY_DEMOGRAPHICS";
    NavigationItemId["MyJobs"] = "MY_JOBS";
    NavigationItemId["MyReviews"] = "MY_REVIEWS";
    NavigationItemId["MySubscriptions"] = "MY_SUBSCRIPTIONS";
    NavigationItemId["NonPersonalizedExperience"] = "NON_PERSONALIZED_EXPERIENCE";
    NavigationItemId["Notifications"] = "NOTIFICATIONS";
    /** @deprecated This item has been unpublished. */
    NavigationItemId["ParticipateInOurSalarySurvey"] = "PARTICIPATE_IN_OUR_SALARY_SURVEY";
    NavigationItemId["Pathfinder"] = "PATHFINDER";
    NavigationItemId["PersonalizedExperience"] = "PERSONALIZED_EXPERIENCE";
    NavigationItemId["PhoneCollectVerify"] = "PHONE_COLLECT_VERIFY";
    NavigationItemId["Privacy"] = "PRIVACY";
    NavigationItemId["PrivacyAndAdChoices"] = "PRIVACY_AND_AD_CHOICES";
    NavigationItemId["PrivacyCenter"] = "PRIVACY_CENTER";
    NavigationItemId["Profile"] = "PROFILE";
    NavigationItemId["ProfileMatchingData"] = "PROFILE_MATCHING_DATA";
    NavigationItemId["ReadyToWork"] = "READY_TO_WORK";
    NavigationItemId["Register"] = "REGISTER";
    NavigationItemId["Resume"] = "RESUME";
    /** @deprecated This item has been unpublished. */
    NavigationItemId["ResumeHelp"] = "RESUME_HELP";
    NavigationItemId["ReviewCompaniesYouWorkedFor"] = "REVIEW_COMPANIES_YOU_WORKED_FOR";
    NavigationItemId["ReviewYourCertificationPrograms"] = "REVIEW_YOUR_CERTIFICATION_PROGRAMS";
    NavigationItemId["SavedApplications"] = "SAVED_APPLICATIONS";
    NavigationItemId["SavedJobs"] = "SAVED_JOBS";
    NavigationItemId["Search"] = "SEARCH";
    NavigationItemId["SecondaryLogoFindJobs"] = "SECONDARY_LOGO_FIND_JOBS";
    NavigationItemId["Settings"] = "SETTINGS";
    NavigationItemId["SignIn"] = "SIGN_IN";
    NavigationItemId["SignOut"] = "SIGN_OUT";
    NavigationItemId["SupportContact"] = "SUPPORT_CONTACT";
    NavigationItemId["Terms"] = "TERMS";
})(NavigationItemId || (NavigationItemId = {}));
/** Specifies a particular navigation variant, i.e. Employer, Jobseeker, Jobseeker mobile app */
export var NavigationMenuVariant;
(function (NavigationMenuVariant) {
    NavigationMenuVariant["JobseekerMobileApp"] = "JOBSEEKER_MOBILE_APP";
})(NavigationMenuVariant || (NavigationMenuVariant = {}));
export var NextPageMessage;
(function (NextPageMessage) {
    NextPageMessage["ExpiredOrClosed"] = "EXPIRED_OR_CLOSED";
    NextPageMessage["NotVideoRoom"] = "NOT_VIDEO_ROOM";
    NextPageMessage["SingleInterview"] = "SINGLE_INTERVIEW";
    NextPageMessage["Unauthorized"] = "UNAUTHORIZED";
})(NextPageMessage || (NextPageMessage = {}));
/** ATS candidate filtering behavior for Nexus ATS sync. */
export var NexusAtsFilterSetting;
(function (NexusAtsFilterSetting) {
    /** Send every candidate to the ATS without applying dealbreaker or score filtering. */
    NexusAtsFilterSetting["SendAllCandidates"] = "SEND_ALL_CANDIDATES";
    /** Send candidates unless they failed a dealbreaker question. */
    NexusAtsFilterSetting["SendPassedDealBreakers"] = "SEND_PASSED_DEAL_BREAKERS";
    /** Send candidates only when they passed dealbreaker checks and meet the score threshold. */
    NexusAtsFilterSetting["SendPassedDealBreakersAndScore"] = "SEND_PASSED_DEAL_BREAKERS_AND_SCORE";
})(NexusAtsFilterSetting || (NexusAtsFilterSetting = {}));
export var NexusAutomationIdType;
(function (NexusAutomationIdType) {
    NexusAutomationIdType["EmployerJobId"] = "EMPLOYER_JOB_ID";
})(NexusAutomationIdType || (NexusAutomationIdType = {}));
/** Nexus Automation Presets Type */
export var NexusAutomationPresetType;
(function (NexusAutomationPresetType) {
    NexusAutomationPresetType["ScreeningCriteria"] = "SCREENING_CRITERIA";
})(NexusAutomationPresetType || (NexusAutomationPresetType = {}));
/** Trigger type for candidate automation */
export var NexusCandidateAutomationTriggerType;
(function (NexusCandidateAutomationTriggerType) {
    NexusCandidateAutomationTriggerType["NexusPostApplyTrigger"] = "NEXUS_POST_APPLY_TRIGGER";
    NexusCandidateAutomationTriggerType["NexusPostApplyTriggerWithScore"] = "NEXUS_POST_APPLY_TRIGGER_WITH_SCORE";
})(NexusCandidateAutomationTriggerType || (NexusCandidateAutomationTriggerType = {}));
/** Outcome of the Nexus onboarding flow. Drives which page the client renders. */
export var NexusOnboardingOutcome;
(function (NexusOnboardingOutcome) {
    /**
     * Generic terminal error. Either the user is not on the advertiser and cannot be auto-added
     * (no matching domain policy / wrong domain), or an unexpected system error occurred.
     * No Request Access option is offered.
     */
    NexusOnboardingOutcome["ErrorGeneric"] = "ERROR_GENERIC";
    /**
     * User is on the advertiser but lacks the permissions/domain required. Client should render
     * the Request Access page (requesting Nexus_View + FGP on the requested jobId), including
     * copy explaining how an admin can set up a domain access policy.
     */
    NexusOnboardingOutcome["RequestAccess"] = "REQUEST_ACCESS";
    /** User is authorized for this job; client should redirect to Nexus Hub. */
    NexusOnboardingOutcome["ShowNexusHub"] = "SHOW_NEXUS_HUB";
})(NexusOnboardingOutcome || (NexusOnboardingOutcome = {}));
/** Enum representing the different Nexus product groups */
export var NexusProductGroup;
(function (NexusProductGroup) {
    /** Standard Nexus product offering */
    NexusProductGroup["Nexus"] = "NEXUS";
    /** Specialized Nexus product offering for Sponsored jobs */
    NexusProductGroup["SponsoredJobNexus"] = "SPONSORED_JOB_NEXUS";
})(NexusProductGroup || (NexusProductGroup = {}));
/**
 * Enum representing the product tag for Nexus automations.
 * Used when creating new automations via createIfMissing.
 */
export var NexusProductTag;
(function (NexusProductTag) {
    /** Standard Nexus product */
    NexusProductTag["Nexus"] = "NEXUS";
    /** Sponsored Job Nexus product */
    NexusProductTag["SponsoredJobNexus"] = "SPONSORED_JOB_NEXUS";
})(NexusProductTag || (NexusProductTag = {}));
export var NexusQualificationMatchType;
(function (NexusQualificationMatchType) {
    NexusQualificationMatchType["All"] = "ALL";
    NexusQualificationMatchType["Any"] = "ANY";
})(NexusQualificationMatchType || (NexusQualificationMatchType = {}));
export var NexusQualificationQuestionType;
(function (NexusQualificationQuestionType) {
    NexusQualificationQuestionType["File"] = "FILE";
    NexusQualificationQuestionType["Multiselect"] = "MULTISELECT";
    NexusQualificationQuestionType["Select"] = "SELECT";
    NexusQualificationQuestionType["Text"] = "TEXT";
})(NexusQualificationQuestionType || (NexusQualificationQuestionType = {}));
export var NexusQualificationType;
(function (NexusQualificationType) {
    NexusQualificationType["Knockout"] = "KNOCKOUT";
    NexusQualificationType["Nonblocking"] = "NONBLOCKING";
})(NexusQualificationType || (NexusQualificationType = {}));
/** Lifecycle status for the nexus screening config setup. */
export var NexusScreeningConfigStatus;
(function (NexusScreeningConfigStatus) {
    NexusScreeningConfigStatus["Failure"] = "FAILURE";
    NexusScreeningConfigStatus["Pending"] = "PENDING";
    NexusScreeningConfigStatus["Processing"] = "PROCESSING";
    NexusScreeningConfigStatus["Success"] = "SUCCESS";
})(NexusScreeningConfigStatus || (NexusScreeningConfigStatus = {}));
/**
 * A step type within the nexus screening config. Mirrors the calibrations-service
 * proto step type, subject to the Java client's current mapping.
 */
export var NexusScreeningStepType;
(function (NexusScreeningStepType) {
    /** An AI Interview (AIR) question step. */
    NexusScreeningStepType["AiInterview"] = "AI_INTERVIEW";
    /** A Credential (Phase 2) step. */
    NexusScreeningStepType["Credential"] = "CREDENTIAL";
    /** A Nexus Screener (Phase 2) step. */
    NexusScreeningStepType["NexusScreener"] = "NEXUS_SCREENER";
    /** Any step type the calibrations Java client does not individually map yet. */
    NexusScreeningStepType["Unspecified"] = "UNSPECIFIED";
})(NexusScreeningStepType || (NexusScreeningStepType = {}));
/** Variants of the NormTitle optimization */
export var NormTitleOptimizationVariant;
(function (NormTitleOptimizationVariant) {
    /** @deprecated This variant was removed. Routes to the default (Positive Connection) path. */
    NormTitleOptimizationVariant["NormTitleOptimizationVariantCandidatePool"] = "NORM_TITLE_OPTIMIZATION_VARIANT_CANDIDATE_POOL";
    NormTitleOptimizationVariant["NormTitleOptimizationVariantDefault"] = "NORM_TITLE_OPTIMIZATION_VARIANT_DEFAULT";
    /** @deprecated Behaves identically to LLM_WITHOUT_RATIONALE (LLM path, no rationale). */
    NormTitleOptimizationVariant["NormTitleOptimizationVariantLlmVariant"] = "NORM_TITLE_OPTIMIZATION_VARIANT_LLM_VARIANT";
    NormTitleOptimizationVariant["NormTitleOptimizationVariantLlmWithoutRationaleVariant"] = "NORM_TITLE_OPTIMIZATION_VARIANT_LLM_WITHOUT_RATIONALE_VARIANT";
    /** @deprecated Equivalent to the default; routes to the Positive Connection path. */
    NormTitleOptimizationVariant["NormTitleOptimizationVariantPositiveConnection"] = "NORM_TITLE_OPTIMIZATION_VARIANT_POSITIVE_CONNECTION";
})(NormTitleOptimizationVariant || (NormTitleOptimizationVariant = {}));
export var NoticeSeverity;
(function (NoticeSeverity) {
    NoticeSeverity["Impacting"] = "IMPACTING";
    NoticeSeverity["Informative"] = "INFORMATIVE";
})(NoticeSeverity || (NoticeSeverity = {}));
export var NoticeStatus;
(function (NoticeStatus) {
    NoticeStatus["Active"] = "ACTIVE";
    NoticeStatus["Resolved"] = "RESOLVED";
})(NoticeStatus || (NoticeStatus = {}));
/** Notification status labels */
export var NotificationStatus;
(function (NotificationStatus) {
    NotificationStatus["NoNotification"] = "NO_NOTIFICATION";
    NotificationStatus["OptionalPhoneCollection"] = "OPTIONAL_PHONE_COLLECTION";
    NotificationStatus["VerificationPending"] = "VERIFICATION_PENDING";
    NotificationStatus["VerificationRequired"] = "VERIFICATION_REQUIRED";
})(NotificationStatus || (NotificationStatus = {}));
/** OAuth Client review status, this matches with the result returned from IdentityService */
export var OAuthClientReviewStatus;
(function (OAuthClientReviewStatus) {
    OAuthClientReviewStatus["Approved"] = "APPROVED";
    OAuthClientReviewStatus["Cancelled"] = "CANCELLED";
    OAuthClientReviewStatus["EditPending"] = "EDIT_PENDING";
    OAuthClientReviewStatus["EditRejected"] = "EDIT_REJECTED";
    OAuthClientReviewStatus["Pending"] = "PENDING";
    OAuthClientReviewStatus["Rejected"] = "REJECTED";
    OAuthClientReviewStatus["Unneeded"] = "UNNEEDED";
})(OAuthClientReviewStatus || (OAuthClientReviewStatus = {}));
export var OAuthCondition;
(function (OAuthCondition) {
    OAuthCondition["AccountAccessTokenRequired"] = "ACCOUNT_ACCESS_TOKEN_REQUIRED";
    OAuthCondition["AccountOrSubaccountCampaignReportReadScopeRequired"] = "ACCOUNT_OR_SUBACCOUNT_CAMPAIGN_REPORT_READ_SCOPE_REQUIRED";
    OAuthCondition["AccountOrSubaccountReadScopeRequired"] = "ACCOUNT_OR_SUBACCOUNT_READ_SCOPE_REQUIRED";
    OAuthCondition["EmployerAccessTokenOrOrganicTrafficReadScopeRequired"] = "EMPLOYER_ACCESS_TOKEN_OR_ORGANIC_TRAFFIC_READ_SCOPE_REQUIRED";
    OAuthCondition["EmployerAccessTokenRequired"] = "EMPLOYER_ACCESS_TOKEN_REQUIRED";
})(OAuthCondition || (OAuthCondition = {}));
/**
 * OAuth Grant types
 * - TWO_LEGGED_OAUTH: Client Credentials OAuth flow
 * - THREE_LEGGED_OAUTH: Authorization Code OAuth flow
 */
export var OAuthGrantType;
(function (OAuthGrantType) {
    /**
     * Authorization Code OAuth flow
     *
     * Also used for public clients, which uses the PKCE Authorization Code flow.
     */
    OAuthGrantType["ThreeLeggedOauth"] = "THREE_LEGGED_OAUTH";
    /** Client Credentials OAuth flow */
    OAuthGrantType["TwoLeggedOauth"] = "TWO_LEGGED_OAUTH";
})(OAuthGrantType || (OAuthGrantType = {}));
export var OAuthMethods;
(function (OAuthMethods) {
    OAuthMethods["OauthThreeLegged"] = "OAUTH_THREE_LEGGED";
    OAuthMethods["OauthTwoLegged"] = "OAUTH_TWO_LEGGED";
})(OAuthMethods || (OAuthMethods = {}));
export var OAuthScopes;
(function (OAuthScopes) {
    OAuthScopes["AccountRead"] = "ACCOUNT_READ";
    OAuthScopes["AccountReadWrite"] = "ACCOUNT_READ_WRITE";
    OAuthScopes["CampaignRead"] = "CAMPAIGN_READ";
    OAuthScopes["CampaignReadWrite"] = "CAMPAIGN_READ_WRITE";
    OAuthScopes["CampaignReportRead"] = "CAMPAIGN_REPORT_READ";
    OAuthScopes["EmployerAccess"] = "EMPLOYER_ACCESS";
    OAuthScopes["SubaccountCampaignReportRead"] = "SUBACCOUNT_CAMPAIGN_REPORT_READ";
    OAuthScopes["SubaccountRead"] = "SUBACCOUNT_READ";
    OAuthScopes["SubaccountReadWrite"] = "SUBACCOUNT_READ_WRITE";
})(OAuthScopes || (OAuthScopes = {}));
/** Metadata Taxonomy Occupation Option input, MOST_LIKELY and TOP_LEVEL are deprecated, please use MOST_SPECIFIC */
export var OccupationOptionInput;
(function (OccupationOptionInput) {
    OccupationOptionInput["MostLikely"] = "MOST_LIKELY";
    OccupationOptionInput["MostSpecific"] = "MOST_SPECIFIC";
    OccupationOptionInput["TopLevel"] = "TOP_LEVEL";
    OccupationOptionInput["WithAncestors"] = "WITH_ANCESTORS";
})(OccupationOptionInput || (OccupationOptionInput = {}));
export var OfferDiscountType;
(function (OfferDiscountType) {
    OfferDiscountType["FreeTrial"] = "FREE_TRIAL";
})(OfferDiscountType || (OfferDiscountType = {}));
/** Supported actions for modifying offer status. */
export var OfferStatusAction;
(function (OfferStatusAction) {
    OfferStatusAction["Read"] = "READ";
    OfferStatusAction["Unread"] = "UNREAD";
})(OfferStatusAction || (OfferStatusAction = {}));
/** Tier levels for pricing offer packages */
export var OfferTier;
(function (OfferTier) {
    OfferTier["Basic"] = "BASIC";
    OfferTier["Expedited"] = "EXPEDITED";
    OfferTier["Premium"] = "PREMIUM";
    OfferTier["PremiumPlus"] = "PREMIUM_PLUS";
    OfferTier["Standard"] = "STANDARD";
})(OfferTier || (OfferTier = {}));
export var OffsiteDeviceIdEnum;
(function (OffsiteDeviceIdEnum) {
    OffsiteDeviceIdEnum["Aaid"] = "AAID";
    OffsiteDeviceIdEnum["Idfa"] = "IDFA";
})(OffsiteDeviceIdEnum || (OffsiteDeviceIdEnum = {}));
/** The type of account to fetch the online status for */
export var OnlineStatusAccountType;
(function (OnlineStatusAccountType) {
    /** Represents an employer account, this means one individual account acting as part of an employer */
    OnlineStatusAccountType["Employer"] = "EMPLOYER";
    /** Represents a job seeker */
    OnlineStatusAccountType["Jobseeker"] = "JOBSEEKER";
})(OnlineStatusAccountType || (OnlineStatusAccountType = {}));
/** Signal types */
export var OnlineStatusSignalType;
(function (OnlineStatusSignalType) {
    OnlineStatusSignalType["Background"] = "BACKGROUND";
    OnlineStatusSignalType["Foreground"] = "FOREGROUND";
})(OnlineStatusSignalType || (OnlineStatusSignalType = {}));
/**
 * GlassdoorEpApiLog schema.
 * GraphQL Schema Basics: https://www.apollographql.com/docs/apollo-server/schema/schema/
 * Indeed API Recommendations: https://go.indeed.com/api-recommendations
 */
export var OperationStatus;
(function (OperationStatus) {
    OperationStatus["Error"] = "ERROR";
    OperationStatus["Success"] = "SUCCESS";
})(OperationStatus || (OperationStatus = {}));
/**
 * Job optimization label,
 * please see https://link.indeed.tech/R2WGC8 for more information
 */
export var OptimizationLabel;
(function (OptimizationLabel) {
    OptimizationLabel["AppliesMinus"] = "APPLIES_MINUS";
    OptimizationLabel["AppliesPlus"] = "APPLIES_PLUS";
    OptimizationLabel["ApplyStartsMinus"] = "APPLY_STARTS_MINUS";
    OptimizationLabel["ApplyStartsPlus"] = "APPLY_STARTS_PLUS";
    OptimizationLabel["ClicksMinus"] = "CLICKS_MINUS";
    OptimizationLabel["ClicksPlus"] = "CLICKS_PLUS";
    OptimizationLabel["ImpressionsMinus"] = "IMPRESSIONS_MINUS";
    OptimizationLabel["ImpressionsPlus"] = "IMPRESSIONS_PLUS";
    OptimizationLabel["PoMinus"] = "PO_MINUS";
    OptimizationLabel["PoPlus"] = "PO_PLUS";
})(OptimizationLabel || (OptimizationLabel = {}));
/** The job optimization type. Currently this will only hold a single type, but can be expanded in the future. */
export var OptimizationType;
(function (OptimizationType) {
    OptimizationType["JobDescription"] = "JOB_DESCRIPTION";
})(OptimizationType || (OptimizationType = {}));
export var OrchestrationSearchQueryType;
(function (OrchestrationSearchQueryType) {
    OrchestrationSearchQueryType["Boolean"] = "BOOLEAN";
    OrchestrationSearchQueryType["NaturalLanguage"] = "NATURAL_LANGUAGE";
})(OrchestrationSearchQueryType || (OrchestrationSearchQueryType = {}));
export var OrderBy;
(function (OrderBy) {
    OrderBy["CreatedAt"] = "CREATED_AT";
    OrderBy["UpdatedAt"] = "UPDATED_AT";
})(OrderBy || (OrderBy = {}));
/** Sort direction */
export var OrderDirection;
(function (OrderDirection) {
    OrderDirection["Asc"] = "ASC";
    OrderDirection["Desc"] = "DESC";
})(OrderDirection || (OrderDirection = {}));
export var Ordering;
(function (Ordering) {
    Ordering["After"] = "AFTER";
    Ordering["Before"] = "BEFORE";
    Ordering["End"] = "END";
    Ordering["Next"] = "NEXT";
    Ordering["Previous"] = "PREVIOUS";
    Ordering["Start"] = "START";
})(Ordering || (Ordering = {}));
export var OutboundCandidateSyncError;
(function (OutboundCandidateSyncError) {
    /** The ExternalAtsLink configuration is invalid */
    OutboundCandidateSyncError["ConfigurationInvalid"] = "CONFIGURATION_INVALID";
    /** The credentials associated with the ExternalAtsLink configuration failed authentication */
    OutboundCandidateSyncError["ConfigurationInvalidCredentials"] = "CONFIGURATION_INVALID_CREDENTIALS";
    /** The ExternalAtsLink configuration refers to an entity that does not exist in the External ATS */
    OutboundCandidateSyncError["ConfigurationInvalidReference"] = "CONFIGURATION_INVALID_REFERENCE";
    /** The credentials associated with the ExternalAtsLink did not have required permissions */
    OutboundCandidateSyncError["ConfigurationUnauthorized"] = "CONFIGURATION_UNAUTHORIZED";
    /** An unexpected runtime error occurred */
    OutboundCandidateSyncError["RuntimeUnexpectedError"] = "RUNTIME_UNEXPECTED_ERROR";
    /** An error not defined by this enum has occurred */
    OutboundCandidateSyncError["UndefinedError"] = "UNDEFINED_ERROR";
})(OutboundCandidateSyncError || (OutboundCandidateSyncError = {}));
/** The status of attempting to transfer a candidate/application to the ATS/CRM to Indeed */
export var OutboundCandidateSyncStatus;
(function (OutboundCandidateSyncStatus) {
    /** Export for the specified resource has completed unsuccessfully */
    OutboundCandidateSyncStatus["CompletedFailure"] = "COMPLETED_FAILURE";
    /** Export for the specified resources has completed, but the outcome was unable to be determined */
    OutboundCandidateSyncStatus["CompletedIndeterminate"] = "COMPLETED_INDETERMINATE";
    /** Export for the specified resource has completed successfully */
    OutboundCandidateSyncStatus["CompletedSuccess"] = "COMPLETED_SUCCESS";
    /** Export for the specified resources has been deferred */
    OutboundCandidateSyncStatus["Deferred"] = "DEFERRED";
    /** Unable to determine export status for the specified resource */
    OutboundCandidateSyncStatus["Indeterminate"] = "INDETERMINATE";
    /** Export for the specified resource has been queued */
    OutboundCandidateSyncStatus["Queued"] = "QUEUED";
    /** Export for the specified resources has resumed */
    OutboundCandidateSyncStatus["Resumed"] = "RESUMED";
    /** Export for the specified resource has been started */
    OutboundCandidateSyncStatus["Started"] = "STARTED";
})(OutboundCandidateSyncStatus || (OutboundCandidateSyncStatus = {}));
/**
 * The category of outcome tracked by an outcome cap (e.g. applies, interviews).
 *
 * This enum is non-exhaustive and new values will be added from time to time.
 */
export var OutcomeCapTypeEnum;
(function (OutcomeCapTypeEnum) {
    /** Cap on the number of applications received. */
    OutcomeCapTypeEnum["Apply"] = "APPLY";
})(OutcomeCapTypeEnum || (OutcomeCapTypeEnum = {}));
/**
 * The types of job outcomes that OutcomeEstimates can provide estimates for.
 *
 * Please consult #me-employer-offer-t3 before selecting an option.
 *
 * Benchmarking vs non-benchmarking vs day-N types:
 * - Use non-benchmarking types when you don't want to compare different tiers or budgets.
 *   Supports prediction durations up to 120 days.
 * - Use BENCHMARKING_* types when comparing different tiers; this model is better at tier differentiation.
 *   High and low ranges are the 25th and 75th percentiles. Supports prediction durations up to 120 days.
 * - Use *_DAY_N types when the job has already been active for N days and you want to predict future outcomes from that point forward.
 *   Supports prediction durations up to 31 days.
 */
export var OutcomeEstimatesOutcomeType;
(function (OutcomeEstimatesOutcomeType) {
    /** Estimate of completed applies (non-benchmarking). */
    OutcomeEstimatesOutcomeType["Applies"] = "APPLIES";
    /** Estimate of apply starts (non-benchmarking). */
    OutcomeEstimatesOutcomeType["ApplyStarts"] = "APPLY_STARTS";
    /**
     * Predicts future apply starts when the job has already been active for N days.
     * Supports prediction durations up to 31 days only (other outcome types support up to 120 days).
     */
    OutcomeEstimatesOutcomeType["ApplyStartsDayN"] = "APPLY_STARTS_DAY_N";
    /** Benchmarking estimate of completed applies. Use when comparing across tiers. */
    OutcomeEstimatesOutcomeType["BenchmarkingApplies"] = "BENCHMARKING_APPLIES";
    /** Benchmarking estimate of apply starts. Use when comparing across tiers. */
    OutcomeEstimatesOutcomeType["BenchmarkingApplyStarts"] = "BENCHMARKING_APPLY_STARTS";
    /** Benchmarking estimate of clicks. Use when comparing across tiers. */
    OutcomeEstimatesOutcomeType["BenchmarkingClicks"] = "BENCHMARKING_CLICKS";
    /** Benchmarking estimate of impressions. Use when comparing across tiers. */
    OutcomeEstimatesOutcomeType["BenchmarkingImpressions"] = "BENCHMARKING_IMPRESSIONS";
    /** Estimate of clicks (non-benchmarking). */
    OutcomeEstimatesOutcomeType["Clicks"] = "CLICKS";
    /** Estimate of RSVPs (non-benchmarking). */
    OutcomeEstimatesOutcomeType["Rsvps"] = "RSVPS";
    /** Estimate of shows (non-benchmarking). */
    OutcomeEstimatesOutcomeType["Shows"] = "SHOWS";
})(OutcomeEstimatesOutcomeType || (OutcomeEstimatesOutcomeType = {}));
/** Variants of the OutcomeSponsor optimization */
export var OutcomeSponsorOptimizationVariant;
(function (OutcomeSponsorOptimizationVariant) {
    /** @deprecated This optimization variant is deprecated */
    OutcomeSponsorOptimizationVariant["OutcomeSponsorOptimizationVariantDefault"] = "OUTCOME_SPONSOR_OPTIMIZATION_VARIANT_DEFAULT";
})(OutcomeSponsorOptimizationVariant || (OutcomeSponsorOptimizationVariant = {}));
/** This field shows why outreach isn't eligible */
export var OutreachEligibilityReasonInput;
(function (OutreachEligibilityReasonInput) {
    /**
     * The job is a "Free to Post" job, which means the employer can view candidates, but is not allowed to invite them until
     * they change their job sponsorship plan
     */
    OutreachEligibilityReasonInput["FtpJob"] = "FTP_JOB";
    /** The job has hit its lifetime limit of 200 invites */
    OutreachEligibilityReasonInput["JobLim"] = "JOB_LIM";
    /** The employer job is a PPC job, and the employer has hit their monthly limit of 30 invites across all of their PPC jobs */
    OutreachEligibilityReasonInput["PpcLimit"] = "PPC_LIMIT";
})(OutreachEligibilityReasonInput || (OutreachEligibilityReasonInput = {}));
/**
 * How the AI Sourcing worker runs a job. Legacy/unset configs resolve to FULL_AUTOMATION for
 * backward compatibility.
 */
export var OutreachMode;
(function (OutreachMode) {
    /** Worker sends outreaches automatically without human review (default, legacy behavior). */
    OutreachMode["FullAutomation"] = "FULL_AUTOMATION";
    /** Worker surfaces a shortlist for human-in-the-loop review before outreach. */
    OutreachMode["Shortlist"] = "SHORTLIST";
})(OutreachMode || (OutreachMode = {}));
/**
 * Enum representing the time window in which AI Sourcing outreaches may be sent (ASO-3948).
 * Null on a config means the user has not explicitly chosen; the effective default is resolved
 * downstream from the experiment bucket.
 */
export var OutreachSchedule;
(function (OutreachSchedule) {
    /** Send around the clock, ignoring the business-hours window. */
    OutreachSchedule["Always"] = "ALWAYS";
    /** Only send during the default business-hours window. */
    OutreachSchedule["BusinessHours"] = "BUSINESS_HOURS";
})(OutreachSchedule || (OutreachSchedule = {}));
export var Override;
(function (Override) {
    Override["AttachPlaceholders"] = "ATTACH_PLACEHOLDERS";
    Override["Insert"] = "INSERT";
    Override["Move"] = "MOVE";
    Override["Remove"] = "REMOVE";
    Override["Reorder"] = "REORDER";
})(Override || (Override = {}));
/**
 * User rating for insights quality.
 * Simple binary rating for clear A/B test metrics.
 */
export var PiInsightRating;
(function (PiInsightRating) {
    /** User found insights not helpful or inaccurate */
    PiInsightRating["Dislike"] = "DISLIKE";
    /** User found insights helpful and accurate */
    PiInsightRating["Like"] = "LIKE";
})(PiInsightRating || (PiInsightRating = {}));
/** Source of insights data for Product Intelligence */
export var PiInsightsSource;
(function (PiInsightsSource) {
    /** Freshly generated by agent */
    PiInsightsSource["Agent"] = "AGENT";
    /** Retrieved from cache */
    PiInsightsSource["Cache"] = "CACHE";
})(PiInsightsSource || (PiInsightsSource = {}));
/** Data consistency level */
export var PacAuthorizationConsistency;
(function (PacAuthorizationConsistency) {
    /** DEFAULT: Whatever is in the cache. Minimizes latency */
    PacAuthorizationConsistency["Default"] = "DEFAULT";
    /** FULLY_CONSISTENT: Bypass cache. Likely greater latency */
    PacAuthorizationConsistency["FullyConsistent"] = "FULLY_CONSISTENT";
    /** TOKEN: Data must be at least as fresh as the consistency_token */
    PacAuthorizationConsistency["Token"] = "TOKEN";
})(PacAuthorizationConsistency || (PacAuthorizationConsistency = {}));
export var PacAuthorizationErrorCode;
(function (PacAuthorizationErrorCode) {
    PacAuthorizationErrorCode["BadUserInput"] = "BAD_USER_INPUT";
    PacAuthorizationErrorCode["Forbidden"] = "FORBIDDEN";
    PacAuthorizationErrorCode["InternalServerError"] = "INTERNAL_SERVER_ERROR";
})(PacAuthorizationErrorCode || (PacAuthorizationErrorCode = {}));
export var PackageBudgetType;
(function (PackageBudgetType) {
    PackageBudgetType["Daily"] = "DAILY";
    PackageBudgetType["Monthly"] = "MONTHLY";
})(PackageBudgetType || (PackageBudgetType = {}));
export var PackageCategory;
(function (PackageCategory) {
    PackageCategory["Enhanced"] = "ENHANCED";
    PackageCategory["EnhancedBrandedJobs"] = "ENHANCED_BRANDED_JOBS";
    PackageCategory["EnhancedBrandedJobsMoc"] = "ENHANCED_BRANDED_JOBS_MOC";
    PackageCategory["EnhancedBrandedJobsSpecialtyNetwork"] = "ENHANCED_BRANDED_JOBS_SPECIALTY_NETWORK";
    PackageCategory["EnhancedMoc"] = "ENHANCED_MOC";
    PackageCategory["EnhancedMocSpecialtyNetwork"] = "ENHANCED_MOC_SPECIALTY_NETWORK";
    PackageCategory["EnhancedNone"] = "ENHANCED_NONE";
    PackageCategory["EnhancedSpecialtyNetwork"] = "ENHANCED_SPECIALTY_NETWORK";
})(PackageCategory || (PackageCategory = {}));
/** Features available on a Premium Package */
export var PackageConfigurationFeature;
(function (PackageConfigurationFeature) {
    PackageConfigurationFeature["AiRecruiterInterviews"] = "AI_RECRUITER_INTERVIEWS";
    PackageConfigurationFeature["AiSourcing"] = "AI_SOURCING";
    PackageConfigurationFeature["AiTools"] = "AI_TOOLS";
    PackageConfigurationFeature["AutosrcPlusLite"] = "AUTOSRC_PLUS_LITE";
    PackageConfigurationFeature["AutoInviteMatches"] = "AUTO_INVITE_MATCHES";
    PackageConfigurationFeature["Brand"] = "BRAND";
    PackageConfigurationFeature["CandidateSummaries"] = "CANDIDATE_SUMMARIES";
    PackageConfigurationFeature["HiringCriteria"] = "HIRING_CRITERIA";
    PackageConfigurationFeature["IdVerification"] = "ID_VERIFICATION";
    PackageConfigurationFeature["Im"] = "IM";
    PackageConfigurationFeature["InterviewOnDemand"] = "INTERVIEW_ON_DEMAND";
    PackageConfigurationFeature["LicenseVerification"] = "LICENSE_VERIFICATION";
    PackageConfigurationFeature["LineBoostLite"] = "LINE_BOOST_LITE";
    PackageConfigurationFeature["Loc"] = "LOC";
    PackageConfigurationFeature["MatchCriteria"] = "MATCH_CRITERIA";
    PackageConfigurationFeature["Moc"] = "MOC";
    PackageConfigurationFeature["MultiLocAdvertising"] = "MULTI_LOC_ADVERTISING";
    PackageConfigurationFeature["RecruitingAssistant"] = "RECRUITING_ASSISTANT";
    PackageConfigurationFeature["Relocation"] = "RELOCATION";
    PackageConfigurationFeature["ScoreAutomations"] = "SCORE_AUTOMATIONS";
    PackageConfigurationFeature["ScreenerQuestions"] = "SCREENER_QUESTIONS";
    PackageConfigurationFeature["SmartScores"] = "SMART_SCORES";
    PackageConfigurationFeature["SmartScreening"] = "SMART_SCREENING";
    PackageConfigurationFeature["SmsComms"] = "SMS_COMMS";
    PackageConfigurationFeature["SpecialtyNetwork"] = "SPECIALTY_NETWORK";
    PackageConfigurationFeature["StitchedRanking"] = "STITCHED_RANKING";
    PackageConfigurationFeature["StitchedRankingLite"] = "STITCHED_RANKING_LITE";
    PackageConfigurationFeature["TargetingPlus"] = "TARGETING_PLUS";
    PackageConfigurationFeature["Urgent"] = "URGENT";
})(PackageConfigurationFeature || (PackageConfigurationFeature = {}));
export var PackageFeature;
(function (PackageFeature) {
    PackageFeature["AutosrcPlusLite"] = "AUTOSRC_PLUS_LITE";
    PackageFeature["Brand"] = "BRAND";
    PackageFeature["ExtendedCommute"] = "EXTENDED_COMMUTE";
    PackageFeature["FeaturedJobCard"] = "FEATURED_JOB_CARD";
    PackageFeature["Im"] = "IM";
    PackageFeature["LineBoostLite"] = "LINE_BOOST_LITE";
    PackageFeature["Loc"] = "LOC";
    PackageFeature["Moc"] = "MOC";
    PackageFeature["MultiLocAdvertising"] = "MULTI_LOC_ADVERTISING";
    PackageFeature["Relocation"] = "RELOCATION";
    PackageFeature["Specialty"] = "SPECIALTY";
    PackageFeature["StitchedRanking"] = "STITCHED_RANKING";
    PackageFeature["StitchedRankingLite"] = "STITCHED_RANKING_LITE";
    PackageFeature["TargetingPlus"] = "TARGETING_PLUS";
    PackageFeature["Urgent"] = "URGENT";
})(PackageFeature || (PackageFeature = {}));
export var PackageTier;
(function (PackageTier) {
    PackageTier["NotSponsored"] = "NOT_SPONSORED";
    PackageTier["Premium"] = "PREMIUM";
    PackageTier["Standard"] = "STANDARD";
})(PackageTier || (PackageTier = {}));
export var PackagingCampaignType;
(function (PackagingCampaignType) {
    PackagingCampaignType["Individual"] = "INDIVIDUAL";
    PackagingCampaignType["Scaled"] = "SCALED";
})(PackagingCampaignType || (PackagingCampaignType = {}));
export var PackagingCategory;
(function (PackagingCategory) {
    PackagingCategory["PerformanceDisplay"] = "PERFORMANCE_DISPLAY";
    PackagingCategory["Tech"] = "TECH";
    PackagingCategory["TechCanada"] = "TECH_CANADA";
    PackagingCategory["TechIndia"] = "TECH_INDIA";
})(PackagingCategory || (PackagingCategory = {}));
export var PackagingDataClaimTier;
(function (PackagingDataClaimTier) {
    PackagingDataClaimTier["Free"] = "FREE";
    PackagingDataClaimTier["LegacyPremium"] = "LEGACY_PREMIUM";
    PackagingDataClaimTier["Premium"] = "PREMIUM";
    PackagingDataClaimTier["PremiumPlus"] = "PREMIUM_PLUS";
    PackagingDataClaimTier["Standard"] = "STANDARD";
})(PackagingDataClaimTier || (PackagingDataClaimTier = {}));
export var PackagingEnrollmentStatus;
(function (PackagingEnrollmentStatus) {
    PackagingEnrollmentStatus["Enrolled"] = "ENROLLED";
    PackagingEnrollmentStatus["NotEnrolled"] = "NOT_ENROLLED";
})(PackagingEnrollmentStatus || (PackagingEnrollmentStatus = {}));
/**
 * An enum for distance units to ensure consistency across features
 * that use a radius, such as location-based targeting.
 */
export var PackagingFeatureDistanceUnit;
(function (PackagingFeatureDistanceUnit) {
    /** Represents the metric unit of distance. */
    PackagingFeatureDistanceUnit["Kilometer"] = "KILOMETER";
    /** Represents the imperial unit of distance. */
    PackagingFeatureDistanceUnit["Mile"] = "MILE";
})(PackagingFeatureDistanceUnit || (PackagingFeatureDistanceUnit = {}));
export var PackagingPackageType;
(function (PackagingPackageType) {
    PackagingPackageType["PerformanceDisplay"] = "PERFORMANCE_DISPLAY";
    PackagingPackageType["Tech"] = "TECH";
})(PackagingPackageType || (PackagingPackageType = {}));
export var PackagingPricingType;
(function (PackagingPricingType) {
    PackagingPricingType["Ppc"] = "PPC";
    PackagingPricingType["Ppsa"] = "PPSA";
})(PackagingPricingType || (PackagingPricingType = {}));
/** Represents the smart sourcing data claim template type */
export var PageContextInput;
(function (PageContextInput) {
    /** The LLM template for MATCHED_CANDIDATES */
    PageContextInput["MatchedCandidates"] = "MATCHED_CANDIDATES";
    /** The LLM template for SEARCH */
    PageContextInput["Search"] = "SEARCH";
})(PageContextInput || (PageContextInput = {}));
/** Defines selectable types for return tracking key origins */
export var PageloadTrackingKeyOrigin;
(function (PageloadTrackingKeyOrigin) {
    PageloadTrackingKeyOrigin["Homepage"] = "HOMEPAGE";
    PageloadTrackingKeyOrigin["SerpDesktop"] = "SERP_DESKTOP";
    PageloadTrackingKeyOrigin["SerpMobile"] = "SERP_MOBILE";
    PageloadTrackingKeyOrigin["ViewjobDesktop"] = "VIEWJOB_DESKTOP";
    PageloadTrackingKeyOrigin["ViewjobMobile"] = "VIEWJOB_MOBILE";
})(PageloadTrackingKeyOrigin || (PageloadTrackingKeyOrigin = {}));
/** Month type, e.g. JANUARY. Month type of NOT_SPECIFIED is used to update month to null. */
export var PartialJobSeekerProfileMonthType;
(function (PartialJobSeekerProfileMonthType) {
    PartialJobSeekerProfileMonthType["April"] = "APRIL";
    PartialJobSeekerProfileMonthType["August"] = "AUGUST";
    PartialJobSeekerProfileMonthType["December"] = "DECEMBER";
    PartialJobSeekerProfileMonthType["February"] = "FEBRUARY";
    PartialJobSeekerProfileMonthType["January"] = "JANUARY";
    PartialJobSeekerProfileMonthType["July"] = "JULY";
    PartialJobSeekerProfileMonthType["June"] = "JUNE";
    PartialJobSeekerProfileMonthType["March"] = "MARCH";
    PartialJobSeekerProfileMonthType["May"] = "MAY";
    PartialJobSeekerProfileMonthType["NotSpecified"] = "NOT_SPECIFIED";
    PartialJobSeekerProfileMonthType["November"] = "NOVEMBER";
    PartialJobSeekerProfileMonthType["October"] = "OCTOBER";
    PartialJobSeekerProfileMonthType["September"] = "SEPTEMBER";
})(PartialJobSeekerProfileMonthType || (PartialJobSeekerProfileMonthType = {}));
/** A Job Seeker's resume state, for example PUBLIC or HIDDEN. */
export var PartialJobSeekerProfileResumeState;
(function (PartialJobSeekerProfileResumeState) {
    PartialJobSeekerProfileResumeState["Deleted"] = "DELETED";
    PartialJobSeekerProfileResumeState["Hidden"] = "HIDDEN";
    PartialJobSeekerProfileResumeState["Public"] = "PUBLIC";
})(PartialJobSeekerProfileResumeState || (PartialJobSeekerProfileResumeState = {}));
/** A Job Seeker's resume type, for example INDEED_RESUME or PARSED_RESUME. */
export var PartialJobSeekerProfileResumeType;
(function (PartialJobSeekerProfileResumeType) {
    PartialJobSeekerProfileResumeType["Glassdoor"] = "GLASSDOOR";
    PartialJobSeekerProfileResumeType["IndeedResume"] = "INDEED_RESUME";
    PartialJobSeekerProfileResumeType["Parsed"] = "PARSED";
    PartialJobSeekerProfileResumeType["Recruit"] = "RECRUIT";
    PartialJobSeekerProfileResumeType["Resumecom"] = "RESUMECOM";
    PartialJobSeekerProfileResumeType["Simplyhired"] = "SIMPLYHIRED";
})(PartialJobSeekerProfileResumeType || (PartialJobSeekerProfileResumeType = {}));
/** Enumeration of access permission level types for conversation participants */
export var ParticipantAccessLevel;
(function (ParticipantAccessLevel) {
    /** Participant has limited access to candidate info, and is only allowed to correspond through email */
    ParticipantAccessLevel["EmailOnly"] = "EMAIL_ONLY";
    /** Participant has full access to candidate info, can correspond through both email and messaging systems */
    ParticipantAccessLevel["FullAccess"] = "FULL_ACCESS";
    /** Participant has no access to candidate info, should not be allowed to correspond */
    ParticipantAccessLevel["NoAccess"] = "NO_ACCESS";
})(ParticipantAccessLevel || (ParticipantAccessLevel = {}));
export var ParticipantCapability;
(function (ParticipantCapability) {
    /** Can add participants to the conversation */
    ParticipantCapability["ParticipantAdd"] = "PARTICIPANT_ADD";
    /** Can remove participants from the conversation */
    ParticipantCapability["ParticipantRemove"] = "PARTICIPANT_REMOVE";
    /** Can see the conversation exists, its metadata, and the participant list */
    ParticipantCapability["ReadConversation"] = "READ_CONVERSATION";
    /** Can read messages within the conversation */
    ParticipantCapability["ReadMessages"] = "READ_MESSAGES";
    /** Can post messages to the conversation */
    ParticipantCapability["SendMessages"] = "SEND_MESSAGES";
})(ParticipantCapability || (ParticipantCapability = {}));
/** Enumeration of possible reasons a participant wasn't added */
export var ParticipantErrorReason;
(function (ParticipantErrorReason) {
    ParticipantErrorReason["BroadcastAdvertiserIdMalformed"] = "BROADCAST_ADVERTISER_ID_MALFORMED";
    ParticipantErrorReason["BroadcastAdvertiserNotInActiveBroadcastGroup"] = "BROADCAST_ADVERTISER_NOT_IN_ACTIVE_BROADCAST_GROUP";
    ParticipantErrorReason["BroadcastEmployerNotAllowed"] = "BROADCAST_EMPLOYER_NOT_ALLOWED";
    ParticipantErrorReason["BroadcastHasUnknown"] = "BROADCAST_HAS_UNKNOWN";
    ParticipantErrorReason["BroadcastHasUuid"] = "BROADCAST_HAS_UUID";
    ParticipantErrorReason["BroadcastMoreThanOneNonJobseeker"] = "BROADCAST_MORE_THAN_ONE_NON_JOBSEEKER";
    ParticipantErrorReason["BroadcastNonJobseekerHasNoAccount"] = "BROADCAST_NON_JOBSEEKER_HAS_NO_ACCOUNT";
    ParticipantErrorReason["BroadcastNotEnoughParticipants"] = "BROADCAST_NOT_ENOUGH_PARTICIPANTS";
    ParticipantErrorReason["BroadcastNotOneJobseeker"] = "BROADCAST_NOT_ONE_JOBSEEKER";
    ParticipantErrorReason["BroadcastNoAdvertiser"] = "BROADCAST_NO_ADVERTISER";
    ParticipantErrorReason["BroadcastNoConversation"] = "BROADCAST_NO_CONVERSATION";
    ParticipantErrorReason["BroadcastNoEmployer"] = "BROADCAST_NO_EMPLOYER";
    ParticipantErrorReason["Other"] = "OTHER";
    ParticipantErrorReason["ParticipantManagementJobseekerSender"] = "PARTICIPANT_MANAGEMENT_JOBSEEKER_SENDER";
    ParticipantErrorReason["ParticipantManagementMaxNumParticipantsExceeded"] = "PARTICIPANT_MANAGEMENT_MAX_NUM_PARTICIPANTS_EXCEEDED";
    ParticipantErrorReason["ParticipantManagementRecipientIneligible"] = "PARTICIPANT_MANAGEMENT_RECIPIENT_INELIGIBLE";
    ParticipantErrorReason["ParticipantManagementSenderIneligible"] = "PARTICIPANT_MANAGEMENT_SENDER_INELIGIBLE";
})(ParticipantErrorReason || (ParticipantErrorReason = {}));
/** Enumeration of possible participant sources (i.e. the surface from which a participant was added) */
export var ParticipantSource;
(function (ParticipantSource) {
    ParticipantSource["JobPosting"] = "JOB_POSTING";
    ParticipantSource["ParticipantManagement"] = "PARTICIPANT_MANAGEMENT";
    ParticipantSource["Unknown"] = "UNKNOWN";
})(ParticipantSource || (ParticipantSource = {}));
/** Granularity for time interval calculations */
export var PartitionGranularity;
(function (PartitionGranularity) {
    PartitionGranularity["Daily"] = "DAILY";
    PartitionGranularity["Hourly"] = "HOURLY";
    PartitionGranularity["Monthly"] = "MONTHLY";
    PartitionGranularity["Yearly"] = "YEARLY";
})(PartitionGranularity || (PartitionGranularity = {}));
/** Defined app identifiers for partner applications. */
export var PartnerAppIdentifierTypes;
(function (PartnerAppIdentifierTypes) {
    PartnerAppIdentifierTypes["AllowedSourceName"] = "ALLOWED_SOURCE_NAME";
    PartnerAppIdentifierTypes["CandidateSyncName"] = "CANDIDATE_SYNC_NAME";
    PartnerAppIdentifierTypes["DispositionSyncName"] = "DISPOSITION_SYNC_NAME";
    PartnerAppIdentifierTypes["EmployerIdType"] = "EMPLOYER_ID_TYPE";
    PartnerAppIdentifierTypes["JobFeedId"] = "JOB_FEED_ID";
    PartnerAppIdentifierTypes["OneGraphClientName"] = "ONE_GRAPH_CLIENT_NAME";
    PartnerAppIdentifierTypes["SponsorshipAtsKey"] = "SPONSORSHIP_ATS_KEY";
})(PartnerAppIdentifierTypes || (PartnerAppIdentifierTypes = {}));
/** Intended usage of a partner app being provisioned */
export var PartnerAppPurpose;
(function (PartnerAppPurpose) {
    PartnerAppPurpose["Production"] = "PRODUCTION";
    PartnerAppPurpose["Test"] = "TEST";
})(PartnerAppPurpose || (PartnerAppPurpose = {}));
/** This indicates the provisioning status of app-service. */
export var PartnerAppServiceProvisioningStatus;
(function (PartnerAppServiceProvisioningStatus) {
    /** Provisioning has finished */
    PartnerAppServiceProvisioningStatus["Completed"] = "COMPLETED";
    /** Provisioning is in progress. */
    PartnerAppServiceProvisioningStatus["InProgress"] = "IN_PROGRESS";
    /** Service doesn't require provisioning. */
    PartnerAppServiceProvisioningStatus["NotEligible"] = "NOT_ELIGIBLE";
})(PartnerAppServiceProvisioningStatus || (PartnerAppServiceProvisioningStatus = {}));
/**
 * This indicates the review status of a PartnerApp's service.
 *
 * Some services have a review process associated with them, before they are usable by the client.
 */
export var PartnerAppServiceReviewStatus;
(function (PartnerAppServiceReviewStatus) {
    PartnerAppServiceReviewStatus["Approved"] = "APPROVED";
    /** Service approval has been requested and review is in progress. */
    PartnerAppServiceReviewStatus["InProgress"] = "IN_PROGRESS";
    /** Service doesn't require any review process. */
    PartnerAppServiceReviewStatus["NotEligible"] = "NOT_ELIGIBLE";
    /** Service requires approval, but no review has been requested yet. */
    PartnerAppServiceReviewStatus["NotStarted"] = "NOT_STARTED";
    PartnerAppServiceReviewStatus["Rejected"] = "REJECTED";
})(PartnerAppServiceReviewStatus || (PartnerAppServiceReviewStatus = {}));
/** Enumerates the different capabilities of a partner. */
export var PartnerCapability;
(function (PartnerCapability) {
    /** The ability to self service create a production App from the Console */
    PartnerCapability["CreateProductionApp"] = "CREATE_PRODUCTION_APP";
    /** The ability to self service create a sandbox App from the Console */
    PartnerCapability["CreateSandboxApp"] = "CREATE_SANDBOX_APP";
    /** The ability to enable sponsorship service on an app */
    PartnerCapability["EnableSponsorshipService"] = "ENABLE_SPONSORSHIP_SERVICE";
})(PartnerCapability || (PartnerCapability = {}));
export var PartnerIntegrationStatus;
(function (PartnerIntegrationStatus) {
    PartnerIntegrationStatus["Active"] = "ACTIVE";
    PartnerIntegrationStatus["NotActive"] = "NOT_ACTIVE";
})(PartnerIntegrationStatus || (PartnerIntegrationStatus = {}));
/** Review status of a partner. */
export var PartnerReviewStatus;
(function (PartnerReviewStatus) {
    PartnerReviewStatus["Approved"] = "APPROVED";
    /** Partner vetting status */
    PartnerReviewStatus["InProgress"] = "IN_PROGRESS";
    PartnerReviewStatus["Rejected"] = "REJECTED";
})(PartnerReviewStatus || (PartnerReviewStatus = {}));
/** The offset position mode for a subscription seek. */
export var PartnerWebhookSeekMode;
(function (PartnerWebhookSeekMode) {
    /** Reposition to the earliest available offset on the target topic. */
    PartnerWebhookSeekMode["Earliest"] = "EARLIEST";
    /** Reposition to the latest offset, skipping all pending events. */
    PartnerWebhookSeekMode["Latest"] = "LATEST";
    /** Reposition to the offset nearest to the given targetTimestamp. */
    PartnerWebhookSeekMode["Timestamp"] = "TIMESTAMP";
})(PartnerWebhookSeekMode || (PartnerWebhookSeekMode = {}));
/** The pipeline stage targeted by a subscription seek. */
export var PartnerWebhookSeekScope;
(function (PartnerWebhookSeekScope) {
    /** Target the delivery stage on the per-subscription topic. */
    PartnerWebhookSeekScope["Delivery"] = "DELIVERY";
    /** Target the routing stage on the shared source topic. */
    PartnerWebhookSeekScope["Routing"] = "ROUTING";
})(PartnerWebhookSeekScope || (PartnerWebhookSeekScope = {}));
/** The current state of a subscription seek record. */
export var PartnerWebhookSeekStatus;
(function (PartnerWebhookSeekStatus) {
    /** The seek completed successfully and isActive has been restored. */
    PartnerWebhookSeekStatus["Complete"] = "COMPLETE";
    /** The seek exhausted its retry budget or encountered a terminal error. */
    PartnerWebhookSeekStatus["Failed"] = "FAILED";
    /** The seek has been accepted and is waiting to be processed. */
    PartnerWebhookSeekStatus["InProgress"] = "IN_PROGRESS";
})(PartnerWebhookSeekStatus || (PartnerWebhookSeekStatus = {}));
/** The operational status of a webhook subscription. */
export var PartnerWebhookStatus;
(function (PartnerWebhookStatus) {
    /** The subscription is active and processing events normally. */
    PartnerWebhookStatus["Active"] = "ACTIVE";
    /** The subscription is paused and not processing events. */
    PartnerWebhookStatus["Paused"] = "PAUSED";
    /**
     * A seek (offset reset) is currently in progress for this subscription.
     * Takes precedence over ACTIVE and PAUSED while the seek is running.
     */
    PartnerWebhookStatus["SeekInProgress"] = "SEEK_IN_PROGRESS";
})(PartnerWebhookStatus || (PartnerWebhookStatus = {}));
/** Sorting options for webhook results. */
export var PartnerWebhooksSort;
(function (PartnerWebhooksSort) {
    /** Sort by creation date in ascending order (oldest first). */
    PartnerWebhooksSort["CreatedAtAsc"] = "CREATED_AT_ASC";
    /** Sort by creation date in descending order (newest first). */
    PartnerWebhooksSort["CreatedAtDesc"] = "CREATED_AT_DESC";
    /** Sort alphabetically by event type in ascending order (A-Z). */
    PartnerWebhooksSort["EventTypeAsc"] = "EVENT_TYPE_ASC";
    /** Sort alphabetically by event type in descending order (Z-A). */
    PartnerWebhooksSort["EventTypeDesc"] = "EVENT_TYPE_DESC";
    /** Sort alphabetically by webhook name in ascending order (A-Z). */
    PartnerWebhooksSort["NameAsc"] = "NAME_ASC";
    /** Sort alphabetically by webhook name in descending order (Z-A). */
    PartnerWebhooksSort["NameDesc"] = "NAME_DESC";
})(PartnerWebhooksSort || (PartnerWebhooksSort = {}));
/** Partnership program of the partner being provisioned */
export var PartnershipProgram;
(function (PartnershipProgram) {
    PartnershipProgram["IndeedPlus"] = "INDEED_PLUS";
    PartnershipProgram["Interop"] = "INTEROP";
    PartnershipProgram["None"] = "NONE";
})(PartnershipProgram || (PartnershipProgram = {}));
export var PassportJobseekerVerificationOption;
(function (PassportJobseekerVerificationOption) {
    PassportJobseekerVerificationOption["GovernmentId"] = "GOVERNMENT_ID";
    PassportJobseekerVerificationOption["IdentityMatch"] = "IDENTITY_MATCH";
})(PassportJobseekerVerificationOption || (PassportJobseekerVerificationOption = {}));
export var PassportJobseekerVerificationOptionStatus;
(function (PassportJobseekerVerificationOptionStatus) {
    PassportJobseekerVerificationOptionStatus["Failure"] = "FAILURE";
    PassportJobseekerVerificationOptionStatus["Success"] = "SUCCESS";
})(PassportJobseekerVerificationOptionStatus || (PassportJobseekerVerificationOptionStatus = {}));
export var PassportJobseekerVerificationVendor;
(function (PassportJobseekerVerificationVendor) {
    PassportJobseekerVerificationVendor["Persona"] = "PERSONA";
    PassportJobseekerVerificationVendor["Twilio"] = "TWILIO";
})(PassportJobseekerVerificationVendor || (PassportJobseekerVerificationVendor = {}));
/** The type of phone a user verified their number with, if identifiable */
export var PassportPhoneType;
(function (PassportPhoneType) {
    PassportPhoneType["Landline"] = "LANDLINE";
    PassportPhoneType["Mobile"] = "MOBILE";
    PassportPhoneType["Unknown"] = "UNKNOWN";
    PassportPhoneType["Voip"] = "VOIP";
})(PassportPhoneType || (PassportPhoneType = {}));
/** The methodology used to verify the user's phone */
export var PassportPhoneVerificationModality;
(function (PassportPhoneVerificationModality) {
    PassportPhoneVerificationModality["Call"] = "CALL";
    PassportPhoneVerificationModality["Sms"] = "SMS";
    PassportPhoneVerificationModality["Unknown"] = "UNKNOWN";
})(PassportPhoneVerificationModality || (PassportPhoneVerificationModality = {}));
/** Operation for patching a set */
export var PatchSetOperationBatchEditType;
(function (PatchSetOperationBatchEditType) {
    PatchSetOperationBatchEditType["Add"] = "ADD";
    PatchSetOperationBatchEditType["Remove"] = "REMOVE";
})(PatchSetOperationBatchEditType || (PatchSetOperationBatchEditType = {}));
/** Operation for patching a set */
export var PatchSetOperationType;
(function (PatchSetOperationType) {
    PatchSetOperationType["Add"] = "ADD";
    PatchSetOperationType["Remove"] = "REMOVE";
})(PatchSetOperationType || (PatchSetOperationType = {}));
/** The category of a career timeline action */
export var PathfinderCareerTimelineActionType;
(function (PathfinderCareerTimelineActionType) {
    PathfinderCareerTimelineActionType["Application"] = "APPLICATION";
    PathfinderCareerTimelineActionType["Credential"] = "CREDENTIAL";
    PathfinderCareerTimelineActionType["Experience"] = "EXPERIENCE";
    PathfinderCareerTimelineActionType["JobSearch"] = "JOB_SEARCH";
    PathfinderCareerTimelineActionType["Learning"] = "LEARNING";
    PathfinderCareerTimelineActionType["Networking"] = "NETWORKING";
    PathfinderCareerTimelineActionType["Other"] = "OTHER";
    PathfinderCareerTimelineActionType["Portfolio"] = "PORTFOLIO";
})(PathfinderCareerTimelineActionType || (PathfinderCareerTimelineActionType = {}));
/** The unit a career timeline duration is measured in */
export var PathfinderCareerTimelineDurationUnit;
(function (PathfinderCareerTimelineDurationUnit) {
    PathfinderCareerTimelineDurationUnit["Months"] = "MONTHS";
    PathfinderCareerTimelineDurationUnit["Weeks"] = "WEEKS";
    PathfinderCareerTimelineDurationUnit["Years"] = "YEARS";
})(PathfinderCareerTimelineDurationUnit || (PathfinderCareerTimelineDurationUnit = {}));
/** Category of a mind map node. Closed set today; may be extended as new use cases emerge. */
export var PathfinderMindMapNodeType;
(function (PathfinderMindMapNodeType) {
    /** A field or sector. */
    PathfinderMindMapNodeType["Industry"] = "INDUSTRY";
    /** A career checkpoint or achievement. */
    PathfinderMindMapNodeType["Milestone"] = "MILESTONE";
    /** A job title or position. */
    PathfinderMindMapNodeType["Role"] = "ROLE";
    /** The single top-level entry point for the account's mind map (always titled \"Goals\"). */
    PathfinderMindMapNodeType["Root"] = "ROOT";
    /** A technical or soft skill. */
    PathfinderMindMapNodeType["Skill"] = "SKILL";
})(PathfinderMindMapNodeType || (PathfinderMindMapNodeType = {}));
/** The proficiency level of an enhanced skill */
export var PathfinderSkillProficiency;
(function (PathfinderSkillProficiency) {
    PathfinderSkillProficiency["BelowRequirements"] = "BELOW_REQUIREMENTS";
    PathfinderSkillProficiency["ContextMissing"] = "CONTEXT_MISSING";
    PathfinderSkillProficiency["Exceeds"] = "EXCEEDS";
    PathfinderSkillProficiency["Meets"] = "MEETS";
    PathfinderSkillProficiency["NotFound"] = "NOT_FOUND";
})(PathfinderSkillProficiency || (PathfinderSkillProficiency = {}));
/** The proficiency level of the skills group */
export var PathfinderSkillsGroupLevel;
(function (PathfinderSkillsGroupLevel) {
    PathfinderSkillsGroupLevel["Entry"] = "Entry";
    PathfinderSkillsGroupLevel["Executive"] = "Executive";
    PathfinderSkillsGroupLevel["Mid"] = "Mid";
    PathfinderSkillsGroupLevel["Senior"] = "Senior";
})(PathfinderSkillsGroupLevel || (PathfinderSkillsGroupLevel = {}));
/** The user's sentiment toward a specific suggestion */
export var PathfinderSuggestionSentiment;
(function (PathfinderSuggestionSentiment) {
    /** The user dislikes this suggestion */
    PathfinderSuggestionSentiment["Negative"] = "NEGATIVE";
    /** The default value */
    PathfinderSuggestionSentiment["Neutral"] = "NEUTRAL";
    /** The user likes this suggestion */
    PathfinderSuggestionSentiment["Positive"] = "POSITIVE";
})(PathfinderSuggestionSentiment || (PathfinderSuggestionSentiment = {}));
/** Where in Pathfinder's career suggestion workflow a user currently is */
export var PathfinderWorkflowState;
(function (PathfinderWorkflowState) {
    /** Currently taking the career quiz */
    PathfinderWorkflowState["CareerQuiz"] = "CareerQuiz";
    /** Has existing career suggestions */
    PathfinderWorkflowState["HasSuggestions"] = "HasSuggestions";
    /** User isn't eligible to use Pathfinder */
    PathfinderWorkflowState["NotAvailable"] = "NotAvailable";
    /** Eligible but hasn't used Pathfinder before, start the workflow at the beginning */
    PathfinderWorkflowState["NotStarted"] = "NotStarted";
    /** Currently reviewing skills groups */
    PathfinderWorkflowState["SkillsGroups"] = "SkillsGroups";
})(PathfinderWorkflowState || (PathfinderWorkflowState = {}));
/** Reason why the sourcing agent was paused */
export var PauseReason;
(function (PauseReason) {
    /** Agent was paused because the apply goal was reached */
    PauseReason["ApplyGoalReached"] = "APPLY_GOAL_REACHED";
    PauseReason["JobNotPosted"] = "JOB_NOT_POSTED";
    PauseReason["NoContactsLeft"] = "NO_CONTACTS_LEFT";
    PauseReason["OutreachLimitReached"] = "OUTREACH_LIMIT_REACHED";
    /** Agent was resumed after being paused */
    PauseReason["Resumed"] = "RESUMED";
})(PauseReason || (PauseReason = {}));
/** The pay period for a salary */
export var PayPeriod;
(function (PayPeriod) {
    PayPeriod["Biweekly"] = "BIWEEKLY";
    PayPeriod["Daily"] = "DAILY";
    PayPeriod["Gig"] = "GIG";
    PayPeriod["Hourly"] = "HOURLY";
    PayPeriod["Monthly"] = "MONTHLY";
    PayPeriod["None"] = "NONE";
    PayPeriod["Quarterly"] = "QUARTERLY";
    PayPeriod["Semianually"] = "SEMIANUALLY";
    PayPeriod["Weekly"] = "WEEKLY";
    PayPeriod["Yearly"] = "YEARLY";
})(PayPeriod || (PayPeriod = {}));
/** Often used together with a pay amount range to indicate pay such as $15/hour, $40K/year, etc */
export var PayTimeUnit;
(function (PayTimeUnit) {
    PayTimeUnit["Daily"] = "DAILY";
    PayTimeUnit["Hourly"] = "HOURLY";
    PayTimeUnit["Monthly"] = "MONTHLY";
    PayTimeUnit["None"] = "NONE";
    PayTimeUnit["Quarterly"] = "QUARTERLY";
    PayTimeUnit["Weekly"] = "WEEKLY";
    PayTimeUnit["Yearly"] = "YEARLY";
})(PayTimeUnit || (PayTimeUnit = {}));
export var PaymentConfirmationTypeEnum;
(function (PaymentConfirmationTypeEnum) {
    PaymentConfirmationTypeEnum["FullHireInvoice"] = "FULL_HIRE_INVOICE";
    PaymentConfirmationTypeEnum["InitialDeposit"] = "INITIAL_DEPOSIT";
})(PaymentConfirmationTypeEnum || (PaymentConfirmationTypeEnum = {}));
/**
 * Stages a payment progresses through after an employer pays a hire invoice via
 * Adyen Checkout. Funds move through a four-stage pipeline before they land in
 * the recruiter agency's bank account.
 */
export var PaymentTrackingStage;
(function (PaymentTrackingStage) {
    /** Terminal failure of any stage in the pipeline (e.g. FAILED / RETURNED / BLOCKED payouts). */
    PaymentTrackingStage["Failed"] = "FAILED";
    /** Stage 1: Employer initiated the payment for the placement fee. */
    PaymentTrackingStage["PaymentMade"] = "PAYMENT_MADE";
    /** Stage 2: Funds have been deposited into the recruiter's Adyen account. */
    PaymentTrackingStage["PaymentReceived"] = "PAYMENT_RECEIVED";
    /** Stage 4: Placement fee has been deposited into the recruiter's bank account. */
    PaymentTrackingStage["TransferCompleted"] = "TRANSFER_COMPLETED";
    /** Stage 3: Transfer of placement fee from Adyen account to bank has been initiated. */
    PaymentTrackingStage["TransferInitiated"] = "TRANSFER_INITIATED";
})(PaymentTrackingStage || (PaymentTrackingStage = {}));
export var PaymentType;
(function (PaymentType) {
    PaymentType["Ach"] = "ACH";
    PaymentType["Check"] = "CHECK";
    PaymentType["Eft"] = "EFT";
    PaymentType["Sepa"] = "SEPA";
    PaymentType["Wire"] = "WIRE";
})(PaymentType || (PaymentType = {}));
export var PayrollBankAccountAllocationType;
(function (PayrollBankAccountAllocationType) {
    PayrollBankAccountAllocationType["Fixed"] = "FIXED";
    PayrollBankAccountAllocationType["Percentage"] = "PERCENTAGE";
})(PayrollBankAccountAllocationType || (PayrollBankAccountAllocationType = {}));
export var PayrollBankAccountType;
(function (PayrollBankAccountType) {
    PayrollBankAccountType["Checking"] = "CHECKING";
    PayrollBankAccountType["Savings"] = "SAVINGS";
})(PayrollBankAccountType || (PayrollBankAccountType = {}));
export var PayrollWorkerStatus;
(function (PayrollWorkerStatus) {
    PayrollWorkerStatus["Active"] = "ACTIVE";
    PayrollWorkerStatus["NotRegistered"] = "NOT_REGISTERED";
    PayrollWorkerStatus["Onboarded"] = "ONBOARDED";
    PayrollWorkerStatus["OnboardedError"] = "ONBOARDED_ERROR";
    PayrollWorkerStatus["Registered"] = "REGISTERED";
    PayrollWorkerStatus["StartedOnboarding"] = "STARTED_ONBOARDING";
    PayrollWorkerStatus["Terminated"] = "TERMINATED";
})(PayrollWorkerStatus || (PayrollWorkerStatus = {}));
/** Status of a pending bank info request. */
export var PendingBankInfoRequestStatus;
(function (PendingBankInfoRequestStatus) {
    /** Client has successfully submitted their banking information */
    PendingBankInfoRequestStatus["Completed"] = "COMPLETED";
    /** Refund pipeline failed after client submitted banking information */
    PendingBankInfoRequestStatus["Error"] = "ERROR";
    /** Request has expired without client submission */
    PendingBankInfoRequestStatus["Expired"] = "EXPIRED";
    /** Request is active and awaiting client submission */
    PendingBankInfoRequestStatus["Pending"] = "PENDING";
    /** Request was superseded by a resend (old token is no longer valid) */
    PendingBankInfoRequestStatus["Resent"] = "RESENT";
})(PendingBankInfoRequestStatus || (PendingBankInfoRequestStatus = {}));
/**  Possible result types in PerformingJobsResultType  */
export var PerformingJobsResultType;
(function (PerformingJobsResultType) {
    PerformingJobsResultType["HighestAvgCostPerApply"] = "HighestAvgCostPerApply";
    PerformingJobsResultType["HighestAvgCostPerApplyStart"] = "HighestAvgCostPerApplyStart";
    PerformingJobsResultType["HighestAvgCostPerClick"] = "HighestAvgCostPerClick";
    PerformingJobsResultType["LowestAvgCostPerApply"] = "LowestAvgCostPerApply";
    PerformingJobsResultType["LowestAvgCostPerApplyStart"] = "LowestAvgCostPerApplyStart";
    PerformingJobsResultType["LowestAvgCostPerClick"] = "LowestAvgCostPerClick";
    PerformingJobsResultType["Summary"] = "Summary";
})(PerformingJobsResultType || (PerformingJobsResultType = {}));
/** List type of Peripheral IDs that are supported by the endpoint */
export var PeripheralIdType;
(function (PeripheralIdType) {
    PeripheralIdType["Glassdoor"] = "GLASSDOOR";
})(PeripheralIdType || (PeripheralIdType = {}));
export var PermissionAccessLevel;
(function (PermissionAccessLevel) {
    PermissionAccessLevel["Read"] = "READ";
    PermissionAccessLevel["Write"] = "WRITE";
})(PermissionAccessLevel || (PermissionAccessLevel = {}));
/** Status of the correction attempt */
export var PermissionCorrectionStatus;
(function (PermissionCorrectionStatus) {
    /** Did not apply changes but will apply changes if dry run is set to false */
    PermissionCorrectionStatus["DryrunSuccess"] = "DRYRUN_SUCCESS";
    /** Correction encountered an error */
    PermissionCorrectionStatus["Error"] = "ERROR";
    /** No correction needed for given input */
    PermissionCorrectionStatus["NoChange"] = "NO_CHANGE";
    /** Correction applied successfully */
    PermissionCorrectionStatus["Success"] = "SUCCESS";
})(PermissionCorrectionStatus || (PermissionCorrectionStatus = {}));
/** The source of truth of a user's permissions */
export var PermissionSource;
(function (PermissionSource) {
    PermissionSource["Fim"] = "FIM";
    PermissionSource["Pac"] = "PAC";
})(PermissionSource || (PermissionSource = {}));
/** Whether grants from this source may be modified in the PAC admin portal (tblpie_sources.source_policy). */
export var PermissionSourcePolicy;
(function (PermissionSourcePolicy) {
    PermissionSourcePolicy["Locked"] = "LOCKED";
    PermissionSourcePolicy["Managed"] = "MANAGED";
})(PermissionSourcePolicy || (PermissionSourcePolicy = {}));
/** Lifecycle status of a registered permission source (tblpie_sources.status). */
export var PermissionSourceStatus;
(function (PermissionSourceStatus) {
    PermissionSourceStatus["Active"] = "ACTIVE";
    PermissionSourceStatus["Deregistered"] = "DEREGISTERED";
})(PermissionSourceStatus || (PermissionSourceStatus = {}));
/** Defines the possible permission source types (tblpie_sources.source_type). */
export var PermissionSourceType;
(function (PermissionSourceType) {
    PermissionSourceType["AtsSync"] = "ATS_SYNC";
    PermissionSourceType["Fim"] = "FIM";
    PermissionSourceType["NexusCsp"] = "NEXUS_CSP";
    PermissionSourceType["Pac"] = "PAC";
    PermissionSourceType["Unknown"] = "UNKNOWN";
})(PermissionSourceType || (PermissionSourceType = {}));
/** Specific permission backend to use when checking the current user's permissions or granting a recipient new permissions */
export var PermissionType;
(function (PermissionType) {
    /** Verifies user has an active Resume Search Subscription assigned to them with the specified entitlement */
    PermissionType["Entitlement"] = "ENTITLEMENT";
    /** Verifies permissions either at the advertiser level via Compact Permissions or at the object level via FGP */
    PermissionType["Fgp"] = "FGP";
    /** Verifies user is an Owner or Collaborator of a Resume Search Project (aka Violet) */
    PermissionType["Project"] = "PROJECT";
})(PermissionType || (PermissionType = {}));
export var PermissionsType;
(function (PermissionsType) {
    PermissionsType["Schema"] = "SCHEMA";
    PermissionsType["Table"] = "TABLE";
})(PermissionsType || (PermissionsType = {}));
/** Origin of a participant's persona data. */
export var PersonaSource;
(function (PersonaSource) {
    /** identity service */
    PersonaSource["Ciam"] = "CIAM";
    /** dradis */
    PersonaSource["Dradis"] = "DRADIS";
    /** sourced from the email itself */
    PersonaSource["Email"] = "EMAIL";
    /** provided to us by Indeed Apply */
    PersonaSource["IndeedApply"] = "INDEED_APPLY";
    PersonaSource["Other"] = "OTHER";
    /** jobseeker owned profile */
    PersonaSource["Profile"] = "PROFILE";
    /** Candidate submission */
    PersonaSource["Ucp"] = "UCP";
})(PersonaSource || (PersonaSource = {}));
/** Variants of the PersonalizedI2A optimization */
export var PersonalizedI2AOptimizationVariant;
(function (PersonalizedI2AOptimizationVariant) {
    /** @deprecated I2A optimization is deprecated */
    PersonalizedI2AOptimizationVariant["PersonalizedI2AOptimizationVariantDefault"] = "PERSONALIZED_I2A_OPTIMIZATION_VARIANT_DEFAULT";
})(PersonalizedI2AOptimizationVariant || (PersonalizedI2AOptimizationVariant = {}));
/** Valid scopes for a given phone number */
export var PhoneScope;
(function (PhoneScope) {
    /** Phone number can be used to sign into account */
    PhoneScope["Auth"] = "AUTH";
})(PhoneScope || (PhoneScope = {}));
/** Enum representing different types of PII entities */
export var PiiEntitiesInput;
(function (PiiEntitiesInput) {
    PiiEntitiesInput["CreditCard"] = "CREDIT_CARD";
    PiiEntitiesInput["Crypto"] = "CRYPTO";
    PiiEntitiesInput["EmailAddress"] = "EMAIL_ADDRESS";
    PiiEntitiesInput["IbanCode"] = "IBAN_CODE";
    PiiEntitiesInput["IpAddress"] = "IP_ADDRESS";
    PiiEntitiesInput["Location"] = "LOCATION";
    PiiEntitiesInput["MedicalLicense"] = "MEDICAL_LICENSE";
    PiiEntitiesInput["Person"] = "PERSON";
    PiiEntitiesInput["Phone"] = "PHONE";
    PiiEntitiesInput["StreetAddress"] = "STREET_ADDRESS";
    PiiEntitiesInput["Url"] = "URL";
    PiiEntitiesInput["UsBankNumber"] = "US_BANK_NUMBER";
    PiiEntitiesInput["UsDriverLicense"] = "US_DRIVER_LICENSE";
    PiiEntitiesInput["UsItin"] = "US_ITIN";
    PiiEntitiesInput["UsPassport"] = "US_PASSPORT";
    PiiEntitiesInput["UsSsn"] = "US_SSN";
})(PiiEntitiesInput || (PiiEntitiesInput = {}));
/** Enumeration of placement types */
export var PlacementType;
(function (PlacementType) {
    PlacementType["All"] = "ALL";
    PlacementType["OffsiteAll"] = "OFFSITE_ALL";
    PlacementType["OffsiteBeeswax"] = "OFFSITE_BEESWAX";
    PlacementType["OffsiteFacebook"] = "OFFSITE_FACEBOOK";
    PlacementType["OffsiteGoogle"] = "OFFSITE_GOOGLE";
    PlacementType["OnsiteAll"] = "ONSITE_ALL";
})(PlacementType || (PlacementType = {}));
export var Platform;
(function (Platform) {
    Platform["Android"] = "ANDROID";
    Platform["Ios"] = "IOS";
    Platform["UnknownPlatform"] = "UNKNOWN_PLATFORM";
    Platform["Web"] = "WEB";
})(Platform || (Platform = {}));
/** Indicates the scope at which a policy applies. */
export var PolicyScope;
(function (PolicyScope) {
    /** Policy applies at the individual email domain level. */
    PolicyScope["Domain"] = "DOMAIN";
    /** Policy applies at the employer organization level. */
    PolicyScope["Org"] = "ORG";
})(PolicyScope || (PolicyScope = {}));
/** Universe of job postings to include. */
export var PostingType;
(function (PostingType) {
    PostingType["New"] = "NEW";
    PostingType["Total"] = "TOTAL";
})(PostingType || (PostingType = {}));
/** Input types for screener questions */
export var PredefinedQualificationQuestionInputDataType;
(function (PredefinedQualificationQuestionInputDataType) {
    /**
     * An input that accepts integers. In Nigma/Indeed Apply, this is represented using a text box with an added
     * constraint that only number values can be input.
     */
    PredefinedQualificationQuestionInputDataType["Integer"] = "INTEGER";
    /** Corresponds to a list of choices. The user should select one or more of the choices. */
    PredefinedQualificationQuestionInputDataType["MultiSelect"] = "MULTI_SELECT";
    /** Corresponds to a list of choices. The user should select exactly one of the choices. */
    PredefinedQualificationQuestionInputDataType["SingleSelect"] = "SINGLE_SELECT";
    /** Corresponds to a free-form text input. */
    PredefinedQualificationQuestionInputDataType["Text"] = "TEXT";
    /** Corresponds to a large free-form text input. */
    PredefinedQualificationQuestionInputDataType["TextArea"] = "TEXT_AREA";
    PredefinedQualificationQuestionInputDataType["Unknown"] = "UNKNOWN";
})(PredefinedQualificationQuestionInputDataType || (PredefinedQualificationQuestionInputDataType = {}));
/** Question requirement types */
export var PredefinedQualificationQuestionRequirementType;
(function (PredefinedQualificationQuestionRequirementType) {
    PredefinedQualificationQuestionRequirementType["AllOf"] = "ALL_OF";
    PredefinedQualificationQuestionRequirementType["AnyOf"] = "ANY_OF";
    PredefinedQualificationQuestionRequirementType["Boolean"] = "BOOLEAN";
    PredefinedQualificationQuestionRequirementType["Max"] = "MAX";
    PredefinedQualificationQuestionRequirementType["Min"] = "MIN";
})(PredefinedQualificationQuestionRequirementType || (PredefinedQualificationQuestionRequirementType = {}));
/** Autocomplete dictionary input type */
export var PredefinedQualificationQuestionTextInputAutocompleteDictionary;
(function (PredefinedQualificationQuestionTextInputAutocompleteDictionary) {
    PredefinedQualificationQuestionTextInputAutocompleteDictionary["Certifications"] = "CERTIFICATIONS";
    PredefinedQualificationQuestionTextInputAutocompleteDictionary["Languages"] = "LANGUAGES";
    PredefinedQualificationQuestionTextInputAutocompleteDictionary["Skills"] = "SKILLS";
    PredefinedQualificationQuestionTextInputAutocompleteDictionary["Unknown"] = "UNKNOWN";
})(PredefinedQualificationQuestionTextInputAutocompleteDictionary || (PredefinedQualificationQuestionTextInputAutocompleteDictionary = {}));
export var PreferencesFetchStatus;
(function (PreferencesFetchStatus) {
    /** JSRCH-13037: Failed to fetch user preferences from structured-data service. */
    PreferencesFetchStatus["Failure"] = "FAILURE";
    /** JSRCH-13037: this happeend when user given invalid account id. */
    PreferencesFetchStatus["Skipped"] = "SKIPPED";
    /** JSRCH-13037: Successful to fetch user preferences from structured-data service without any errors. */
    PreferencesFetchStatus["Success"] = "SUCCESS";
    PreferencesFetchStatus["Unknown"] = "UNKNOWN";
})(PreferencesFetchStatus || (PreferencesFetchStatus = {}));
export var PreferredResumeTemplateType;
(function (PreferredResumeTemplateType) {
    PreferredResumeTemplateType["Aurora"] = "AURORA";
    PreferredResumeTemplateType["Dawn"] = "DAWN";
    PreferredResumeTemplateType["Default"] = "DEFAULT";
    PreferredResumeTemplateType["Klassisch"] = "KLASSISCH";
})(PreferredResumeTemplateType || (PreferredResumeTemplateType = {}));
export var PreviewFileType;
(function (PreviewFileType) {
    PreviewFileType["Csv"] = "CSV";
    PreviewFileType["Json"] = "JSON";
})(PreviewFileType || (PreviewFileType = {}));
export var ProcessingStatus;
(function (ProcessingStatus) {
    ProcessingStatus["Idle"] = "IDLE";
    ProcessingStatus["Processing"] = "PROCESSING";
})(ProcessingStatus || (ProcessingStatus = {}));
/** Current product of the Subscription */
export var Product;
(function (Product) {
    Product["Bundle"] = "BUNDLE";
    Product["Cmpp"] = "CMPP";
    Product["CmppEp"] = "CMPP_EP";
    Product["CmppEpGlobal"] = "CMPP_EP_GLOBAL";
    Product["Cs"] = "CS";
    Product["Ebhp"] = "EBHP";
    Product["Ebhplus"] = "EBHPLUS";
    Product["Ep"] = "EP";
    Product["EpGlobal"] = "EP_GLOBAL";
    Product["Na"] = "NA";
    Product["Ri"] = "RI";
    Product["Sp"] = "SP";
})(Product || (Product = {}));
export var ProductEntitlementAction;
(function (ProductEntitlementAction) {
    ProductEntitlementAction["JobseekerIdVerify"] = "JOBSEEKER_ID_VERIFY";
    ProductEntitlementAction["JobseekerLicenseVerify"] = "JOBSEEKER_LICENSE_VERIFY";
    ProductEntitlementAction["JobNexusEnroll"] = "JOB_NEXUS_ENROLL";
    ProductEntitlementAction["NexusHub"] = "NEXUS_HUB";
})(ProductEntitlementAction || (ProductEntitlementAction = {}));
export var ProductEntitlementActionReason;
(function (ProductEntitlementActionReason) {
    /** The limit has been exhausted for the entitlement action */
    ProductEntitlementActionReason["LimitReached"] = "LIMIT_REACHED";
    /** there is no capacity configured for the entitlement action. indicates verifications were not purchased with the entitlement */
    ProductEntitlementActionReason["NoCapacityConfigured"] = "NO_CAPACITY_CONFIGURED";
    /** the actor does not have the necessary permissions to perform the entitlement action */
    ProductEntitlementActionReason["ResourcePermissionDenied"] = "RESOURCE_PERMISSION_DENIED";
})(ProductEntitlementActionReason || (ProductEntitlementActionReason = {}));
export var ProductEntitlementResourceType;
(function (ProductEntitlementResourceType) {
    ProductEntitlementResourceType["EmployerJob"] = "EMPLOYER_JOB";
    ProductEntitlementResourceType["Jobseeker"] = "JOBSEEKER";
})(ProductEntitlementResourceType || (ProductEntitlementResourceType = {}));
/** This is not complete list of ProductName we can modify it in future if required. */
export var ProductName;
(function (ProductName) {
    ProductName["Empty"] = "EMPTY";
    ProductName["IndeedHire"] = "INDEED_HIRE";
    ProductName["IndeedHiringEvents"] = "INDEED_HIRING_EVENTS";
    ProductName["ItaApply"] = "ITA_APPLY";
    ProductName["SponsoredJobs"] = "SPONSORED_JOBS";
})(ProductName || (ProductName = {}));
/** Enum representing the product surface where the AutoInvite configuration is initiated */
export var ProductSurface;
(function (ProductSurface) {
    ProductSurface["PremiumPlus"] = "PREMIUM_PLUS";
    ProductSurface["SmartSourcing"] = "SMART_SOURCING";
})(ProductSurface || (ProductSurface = {}));
export var ProfileContextLatestAppliedResumeType;
(function (ProfileContextLatestAppliedResumeType) {
    ProfileContextLatestAppliedResumeType["IndeedResume"] = "INDEED_RESUME";
    ProfileContextLatestAppliedResumeType["SavedFileResume"] = "SAVED_FILE_RESUME";
    ProfileContextLatestAppliedResumeType["TailoredResume"] = "TAILORED_RESUME";
})(ProfileContextLatestAppliedResumeType || (ProfileContextLatestAppliedResumeType = {}));
export var ProfileHighlightSetting;
(function (ProfileHighlightSetting) {
    /** Use basic keyword highlighting */
    ProfileHighlightSetting["Basic"] = "BASIC";
    /** Do not highlight parts of the resume/profile */
    ProfileHighlightSetting["Disabled"] = "DISABLED";
    /** Use AI-powered highlighting */
    ProfileHighlightSetting["Smart"] = "SMART";
})(ProfileHighlightSetting || (ProfileHighlightSetting = {}));
/**
 * The possible status of the progress bar. It is possible for a status to be skipped.
 * MUST be kept in order of progression for validation.
 */
export var ProgressBarStatus;
(function (ProgressBarStatus) {
    ProgressBarStatus["Claimed"] = "CLAIMED";
    ProgressBarStatus["Messaged"] = "MESSAGED";
    ProgressBarStatus["Reviewed"] = "REVIEWED";
    ProgressBarStatus["Searched"] = "SEARCHED";
})(ProgressBarStatus || (ProgressBarStatus = {}));
export var ProjectRecommendationActivity;
(function (ProjectRecommendationActivity) {
    ProjectRecommendationActivity["Contact"] = "CONTACT";
    ProjectRecommendationActivity["LinkedJobs"] = "LINKED_JOBS";
    ProjectRecommendationActivity["PositiveResponse"] = "POSITIVE_RESPONSE";
    ProjectRecommendationActivity["Save"] = "SAVE";
})(ProjectRecommendationActivity || (ProjectRecommendationActivity = {}));
export var ProjectState;
(function (ProjectState) {
    /** All projects */
    ProjectState["All"] = "ALL";
    /** Archived projects */
    ProjectState["Archived"] = "ARCHIVED";
    /** The current user's favorite projects */
    ProjectState["Favorites"] = "FAVORITES";
    /** Get the projects that have new responses to review */
    ProjectState["NeedsReview"] = "NEEDS_REVIEW";
})(ProjectState || (ProjectState = {}));
export var ProjectsSortOption;
(function (ProjectsSortOption) {
    ProjectsSortOption["DateAsc"] = "DATE_ASC";
    ProjectsSortOption["DateDesc"] = "DATE_DESC";
    ProjectsSortOption["NameAsc"] = "NAME_ASC";
    ProjectsSortOption["NameDesc"] = "NAME_DESC";
    ProjectsSortOption["SizeAsc"] = "SIZE_ASC";
    ProjectsSortOption["SizeDesc"] = "SIZE_DESC";
})(ProjectsSortOption || (ProjectsSortOption = {}));
/** An enum for a job seeker/candidate's prominent group */
export var ProminentGroup;
(function (ProminentGroup) {
    ProminentGroup["Disqualified"] = "DISQUALIFIED";
    ProminentGroup["Qualified"] = "QUALIFIED";
})(ProminentGroup || (ProminentGroup = {}));
/** Defines the recurring duration of the budget for single job campaigns. */
export var ProposalCampaignBudgetDuration;
(function (ProposalCampaignBudgetDuration) {
    /** Budget is calculated as average daily. */
    ProposalCampaignBudgetDuration["AvgDaily"] = "AVG_DAILY";
    /** Budget is refreshed monthly. */
    ProposalCampaignBudgetDuration["Monthly"] = "MONTHLY";
})(ProposalCampaignBudgetDuration || (ProposalCampaignBudgetDuration = {}));
/** Tier level for sponsored job advertisements */
export var ProposalSponsorshipTier;
(function (ProposalSponsorshipTier) {
    /**
     * Default tier for hosted campaigns when no tier is explicitly provided.
     * Only valid for hosted campaigns.
     */
    ProposalSponsorshipTier["Basic"] = "BASIC";
    ProposalSponsorshipTier["CustomPremium"] = "CUSTOM_PREMIUM";
    ProposalSponsorshipTier["CustomPremiumPlus"] = "CUSTOM_PREMIUM_PLUS";
    ProposalSponsorshipTier["CustomStandard"] = "CUSTOM_STANDARD";
    ProposalSponsorshipTier["Enhanced"] = "ENHANCED";
    ProposalSponsorshipTier["LegacyPremium"] = "LEGACY_PREMIUM";
    /**
     * Default tier for source campaigns when no tier is explicitly provided.
     * Only valid for source campaigns.
     */
    ProposalSponsorshipTier["NonTiered"] = "NON_TIERED";
    ProposalSponsorshipTier["Premium"] = "PREMIUM";
    ProposalSponsorshipTier["PremiumPlus"] = "PREMIUM_PLUS";
    ProposalSponsorshipTier["Standard"] = "STANDARD";
})(ProposalSponsorshipTier || (ProposalSponsorshipTier = {}));
/** Current status of a proposal in its lifecycle */
export var ProposalStatus;
(function (ProposalStatus) {
    /** Proposal has been accepted by the advertiser */
    ProposalStatus["Accepted"] = "ACCEPTED";
    /** Proposal has been successfully completed */
    ProposalStatus["Completed"] = "COMPLETED";
    /** Proposal has been received and is awaiting activation */
    ProposalStatus["Created"] = "CREATED";
    /** Proposal has been deleted */
    ProposalStatus["Deleted"] = "DELETED";
    /** Proposal has expired without action */
    ProposalStatus["Expired"] = "EXPIRED";
    /** Proposal processing has failed */
    ProposalStatus["Failed"] = "FAILED";
    /** Proposal is awaiting review or action */
    ProposalStatus["Pending"] = "PENDING";
    /** Proposal has been rejected by the advertiser */
    ProposalStatus["Rejected"] = "REJECTED";
})(ProposalStatus || (ProposalStatus = {}));
export var Provenance;
(function (Provenance) {
    Provenance["InferredFromUserActivity"] = "INFERRED_FROM_USER_ACTIVITY";
    Provenance["ResumeExtracted"] = "RESUME_EXTRACTED";
    Provenance["SubmittedByUser"] = "SUBMITTED_BY_USER";
    Provenance["UnknownProvenance"] = "UNKNOWN_PROVENANCE";
})(Provenance || (Provenance = {}));
/** Provisioning group for Indeed Apply Partner */
export var ProvisioningGroup;
(function (ProvisioningGroup) {
    ProvisioningGroup["Applywithindeed"] = "APPLYWITHINDEED";
    ProvisioningGroup["Offcap"] = "OFFCAP";
})(ProvisioningGroup || (ProvisioningGroup = {}));
export var PtoscOptionsMode;
(function (PtoscOptionsMode) {
    PtoscOptionsMode["Advanced"] = "ADVANCED";
    PtoscOptionsMode["Default"] = "DEFAULT";
})(PtoscOptionsMode || (PtoscOptionsMode = {}));
/** Enum representing the category of time worked or clocked */
export var PunchCode;
(function (PunchCode) {
    PunchCode["Berv"] = "BERV";
    PunchCode["Break"] = "BREAK";
    PunchCode["Hols"] = "HOLS";
    PunchCode["Jury"] = "JURY";
    PunchCode["Meal"] = "MEAL";
    PunchCode["Reg"] = "REG";
    PunchCode["Sick"] = "SICK";
    PunchCode["Timeoff"] = "TIMEOFF";
    PunchCode["Train"] = "TRAIN";
})(PunchCode || (PunchCode = {}));
export var PurchaseType;
(function (PurchaseType) {
    PurchaseType["New"] = "NEW";
    PurchaseType["Recurring"] = "RECURRING";
})(PurchaseType || (PurchaseType = {}));
export var PushCredentialsDeviceType;
(function (PushCredentialsDeviceType) {
    PushCredentialsDeviceType["Computer"] = "COMPUTER";
    PushCredentialsDeviceType["Mobile"] = "MOBILE";
    PushCredentialsDeviceType["Tablet"] = "TABLET";
    PushCredentialsDeviceType["UnknownType"] = "UNKNOWN_TYPE";
})(PushCredentialsDeviceType || (PushCredentialsDeviceType = {}));
export var QualRecOptimizationVariant;
(function (QualRecOptimizationVariant) {
    QualRecOptimizationVariant["QualRecOptimizationVariantDefault"] = "QUAL_REC_OPTIMIZATION_VARIANT_DEFAULT";
    QualRecOptimizationVariant["QualRecOptimizationVariantPositiveConnection"] = "QUAL_REC_OPTIMIZATION_VARIANT_POSITIVE_CONNECTION";
})(QualRecOptimizationVariant || (QualRecOptimizationVariant = {}));
export var QualRecQualificationType;
(function (QualRecQualificationType) {
    QualRecQualificationType["QualRecQualificationTypeCertification"] = "QUAL_REC_QUALIFICATION_TYPE_CERTIFICATION";
    QualRecQualificationType["QualRecQualificationTypeEducation"] = "QUAL_REC_QUALIFICATION_TYPE_EDUCATION";
    QualRecQualificationType["QualRecQualificationTypeLicense"] = "QUAL_REC_QUALIFICATION_TYPE_LICENSE";
    QualRecQualificationType["QualRecQualificationTypeSkill"] = "QUAL_REC_QUALIFICATION_TYPE_SKILL";
})(QualRecQualificationType || (QualRecQualificationType = {}));
export var QualificationAnswerDataStatus;
(function (QualificationAnswerDataStatus) {
    QualificationAnswerDataStatus["CandidateDoesNotHave"] = "CANDIDATE_DOES_NOT_HAVE";
    QualificationAnswerDataStatus["DateParsingFailed"] = "DATE_PARSING_FAILED";
    QualificationAnswerDataStatus["FeatureDisabled"] = "FEATURE_DISABLED";
    QualificationAnswerDataStatus["GraphqlErrors"] = "GRAPHQL_ERRORS";
    QualificationAnswerDataStatus["InProgress"] = "IN_PROGRESS";
    QualificationAnswerDataStatus["NotValidVerifiedLicense"] = "NOT_VALID_VERIFIED_LICENSE";
    QualificationAnswerDataStatus["NoData"] = "NO_DATA";
    QualificationAnswerDataStatus["NoIaAppId"] = "NO_IA_APP_ID";
    QualificationAnswerDataStatus["NoVerificationRecord"] = "NO_VERIFICATION_RECORD";
    QualificationAnswerDataStatus["ParsingTextAnswerError"] = "PARSING_TEXT_ANSWER_ERROR";
    QualificationAnswerDataStatus["ProcessingError"] = "PROCESSING_ERROR";
    QualificationAnswerDataStatus["Success"] = "SUCCESS";
    QualificationAnswerDataStatus["SuccessButNotVerified"] = "SUCCESS_BUT_NOT_VERIFIED";
})(QualificationAnswerDataStatus || (QualificationAnswerDataStatus = {}));
/**  Answer entity types  */
export var QualificationAnswerEntityType;
(function (QualificationAnswerEntityType) {
    QualificationAnswerEntityType["AiInterview"] = "AI_INTERVIEW";
    /**
     * Synthetic AnswerSet wrapper used by `evaluateApplication` when assembling
     * QualificationAnswerSets from an ADAO application record. No persisted answer
     * storage uses this entity type.
     */
    QualificationAnswerEntityType["Application"] = "APPLICATION";
    QualificationAnswerEntityType["AtsApplication"] = "ATS_APPLICATION";
    QualificationAnswerEntityType["Candidatesubmission"] = "CANDIDATESUBMISSION";
    QualificationAnswerEntityType["EvaluateCandidate"] = "EVALUATE_CANDIDATE";
    QualificationAnswerEntityType["LegacyCandidate"] = "LEGACY_CANDIDATE";
    QualificationAnswerEntityType["Odverification"] = "ODVERIFICATION";
    QualificationAnswerEntityType["Verification"] = "VERIFICATION";
})(QualificationAnswerEntityType || (QualificationAnswerEntityType = {}));
/** Enum that shows the category of the qualification attributes. Details could be found https://link.indeed.tech/YD44EM */
export var QualificationCategory;
(function (QualificationCategory) {
    /** The qualification was under certification class */
    QualificationCategory["Certification"] = "CERTIFICATION";
    /** The qualification was under education class */
    QualificationCategory["Education"] = "EDUCATION";
    /** The qualification was under educational credential class */
    QualificationCategory["EducationalCredential"] = "EDUCATIONAL_CREDENTIAL";
    /** The qualification was under field of study class */
    QualificationCategory["FieldOfStudy"] = "FIELD_OF_STUDY";
    /** The qualification was under language class */
    QualificationCategory["Language"] = "LANGUAGE";
    /** The qualification was under legal class */
    QualificationCategory["Legal"] = "LEGAL";
    /** The qualification was under licence class */
    QualificationCategory["License"] = "LICENSE";
    /** The qualification was under medical speciality class */
    QualificationCategory["MedicalSpeciality"] = "MEDICAL_SPECIALITY";
    /** The qualification was under qualification class */
    QualificationCategory["Qualification"] = "QUALIFICATION";
    /** The qualification was under security clearance class */
    QualificationCategory["SecurityClearance"] = "SECURITY_CLEARANCE";
    /** The qualification was under skill class */
    QualificationCategory["Skill"] = "SKILL";
})(QualificationCategory || (QualificationCategory = {}));
/** Variants of the Qualification optimization */
export var QualificationOptimizationVariant;
(function (QualificationOptimizationVariant) {
    QualificationOptimizationVariant["QualificationsOptimizationVariantDefault"] = "QUALIFICATIONS_OPTIMIZATION_VARIANT_DEFAULT";
})(QualificationOptimizationVariant || (QualificationOptimizationVariant = {}));
/** Enum that shows the origin category of the qualification attributes. */
export var QualificationOriginCategory;
(function (QualificationOriginCategory) {
    /** The qualification was provided in qualification sheet */
    QualificationOriginCategory["Feedback"] = "FEEDBACK";
    /** The qualification was extracted from Screening Question  */
    QualificationOriginCategory["ScreeningQuestion"] = "SCREENING_QUESTION";
})(QualificationOriginCategory || (QualificationOriginCategory = {}));
/** Question Entity types */
export var QualificationQuestionEntityType;
(function (QualificationQuestionEntityType) {
    QualificationQuestionEntityType["Aigennexuscredentialsq"] = "AIGENNEXUSCREDENTIALSQ";
    QualificationQuestionEntityType["Aigennexussq"] = "AIGENNEXUSSQ";
    QualificationQuestionEntityType["AiInterview"] = "AI_INTERVIEW";
    QualificationQuestionEntityType["AtsApplication"] = "ATS_APPLICATION";
    QualificationQuestionEntityType["Credential"] = "CREDENTIAL";
    /** @deprecated No longer supported */
    QualificationQuestionEntityType["DraftJob"] = "DRAFT_JOB";
    QualificationQuestionEntityType["EvaluateWorkflow"] = "EVALUATE_WORKFLOW";
    QualificationQuestionEntityType["IasIntegration"] = "IAS_INTEGRATION";
    QualificationQuestionEntityType["Indexedjob"] = "INDEXEDJOB";
    QualificationQuestionEntityType["Job"] = "JOB";
    QualificationQuestionEntityType["Manualnexussq"] = "MANUALNEXUSSQ";
    QualificationQuestionEntityType["Odverification"] = "ODVERIFICATION";
    QualificationQuestionEntityType["Passthrough"] = "PASSTHROUGH";
    QualificationQuestionEntityType["Verification"] = "VERIFICATION";
})(QualificationQuestionEntityType || (QualificationQuestionEntityType = {}));
/** Question template types */
export var QualificationQuestionTemplateType;
(function (QualificationQuestionTemplateType) {
    QualificationQuestionTemplateType["Predefined"] = "PREDEFINED";
    QualificationQuestionTemplateType["UserDefined"] = "USER_DEFINED";
})(QualificationQuestionTemplateType || (QualificationQuestionTemplateType = {}));
/** Question types */
export var QualificationQuestionType;
(function (QualificationQuestionType) {
    QualificationQuestionType["Date"] = "DATE";
    QualificationQuestionType["File"] = "FILE";
    QualificationQuestionType["Hierarchical"] = "HIERARCHICAL";
    QualificationQuestionType["Information"] = "INFORMATION";
    QualificationQuestionType["Multifield"] = "MULTIFIELD";
    QualificationQuestionType["Multiselect"] = "MULTISELECT";
    QualificationQuestionType["Pagebreak"] = "PAGEBREAK";
    QualificationQuestionType["QuestionBank"] = "QUESTION_BANK";
    QualificationQuestionType["Select"] = "SELECT";
    QualificationQuestionType["Text"] = "TEXT";
    QualificationQuestionType["Textarea"] = "TEXTAREA";
})(QualificationQuestionType || (QualificationQuestionType = {}));
export var QualificationRecommendationSourceInput;
(function (QualificationRecommendationSourceInput) {
    /** Recommendation source is extracted from the job */
    QualificationRecommendationSourceInput["RecExtracted"] = "REC_EXTRACTED";
    /**
     * Recommendation source is from llm requirement strength
     * @deprecated No longer supported
     */
    QualificationRecommendationSourceInput["RecLlmRequirementStrength"] = "REC_LLM_REQUIREMENT_STRENGTH";
    /** Recommendation source is from correlation ranking list */
    QualificationRecommendationSourceInput["RecOccupationCorrelation"] = "REC_OCCUPATION_CORRELATION";
    /** Recommendation source is from related concept */
    QualificationRecommendationSourceInput["RecOccupationRelation"] = "REC_OCCUPATION_RELATION";
    /** Recommendation source is from requirement strength */
    QualificationRecommendationSourceInput["RecRequirementStrength"] = "REC_REQUIREMENT_STRENGTH";
    /** Recommendation source is with scp attribute categories from segment configuration service */
    QualificationRecommendationSourceInput["RecSegmentConfigurationService"] = "REC_SEGMENT_CONFIGURATION_SERVICE";
})(QualificationRecommendationSourceInput || (QualificationRecommendationSourceInput = {}));
/** Enum that shows the strength of the qualification attributes. */
export var QualificationStrength;
(function (QualificationStrength) {
    /** It means nice to have in the qualification and NON-deal-breaker in the screening question */
    QualificationStrength["Preferred"] = "PREFERRED";
    /** It means must have in the qualification and deal breaker in the screening question */
    QualificationStrength["Required"] = "REQUIRED";
})(QualificationStrength || (QualificationStrength = {}));
/** Supported query source engines */
export var QuerySourceEnum;
(function (QuerySourceEnum) {
    QuerySourceEnum["DuckDb"] = "DUCK_DB";
    QuerySourceEnum["Iql"] = "IQL";
    QuerySourceEnum["Snowflake"] = "SNOWFLAKE";
    QuerySourceEnum["Trino"] = "TRINO";
})(QuerySourceEnum || (QuerySourceEnum = {}));
export var QuestionAttributeSource;
(function (QuestionAttributeSource) {
    /** Employer consider this attribute to be a "must have" for a job. */
    QuestionAttributeSource["MustHaves"] = "MUST_HAVES";
    /** Employer consider this attribute to be a "nice to have" for a job. */
    QuestionAttributeSource["NiceToHaves"] = "NICE_TO_HAVES";
    /** An attribute related to a job segment or occupation. */
    QuestionAttributeSource["SegmentAttributes"] = "SEGMENT_ATTRIBUTES";
    /** An attribute related to a job segment or occupation. in CROWTAXO flow. */
    QuestionAttributeSource["SegmentCrowtaxoAttributes"] = "SEGMENT_CROWTAXO_ATTRIBUTES";
    /** An attribute related to a job segment or occupation in MOC flow. */
    QuestionAttributeSource["SegmentMocAttributes"] = "SEGMENT_MOC_ATTRIBUTES";
})(QuestionAttributeSource || (QuestionAttributeSource = {}));
export var QuestionBankCategory;
(function (QuestionBankCategory) {
    QuestionBankCategory["AiInterview"] = "AI_INTERVIEW";
    QuestionBankCategory["Credential"] = "CREDENTIAL";
    QuestionBankCategory["Crowtag"] = "CROWTAG";
    QuestionBankCategory["Eeo"] = "EEO";
    QuestionBankCategory["KnowledgeCheck"] = "KNOWLEDGE_CHECK";
    QuestionBankCategory["NexusRule"] = "NEXUS_RULE";
    QuestionBankCategory["OccupationalCriteria"] = "OCCUPATIONAL_CRITERIA";
    QuestionBankCategory["Qualification"] = "QUALIFICATION";
})(QuestionBankCategory || (QuestionBankCategory = {}));
/** Represents the display mode of a question */
export var QuestionDisplayMode;
(function (QuestionDisplayMode) {
    /** Question is hidden from the job seeker */
    QuestionDisplayMode["QuestionDisplayModeHidden"] = "QUESTION_DISPLAY_MODE_HIDDEN";
    /** Question is shown but optional for the job seeker to answer */
    QuestionDisplayMode["QuestionDisplayModeOptional"] = "QUESTION_DISPLAY_MODE_OPTIONAL";
    /** Question is shown and required for the job seeker to answer */
    QuestionDisplayMode["QuestionDisplayModeRequired"] = "QUESTION_DISPLAY_MODE_REQUIRED";
    /** Default value to prevent schema drift when the enum is updated in ias-core-service */
    QuestionDisplayMode["QuestionDisplayModeUnspecified"] = "QUESTION_DISPLAY_MODE_UNSPECIFIED";
})(QuestionDisplayMode || (QuestionDisplayMode = {}));
/** Enum for question qualification implication type. */
export var QuestionQualificationImplicationType;
(function (QuestionQualificationImplicationType) {
    /** Applicant proceeds even if answer does not meet qualification. Application is delivered. */
    QuestionQualificationImplicationType["NonBlocking"] = "NON_BLOCKING";
})(QuestionQualificationImplicationType || (QuestionQualificationImplicationType = {}));
/**
 * Namespace identifier for Question Set AddOn configurations.
 *
 * Namespaces allow multiple independent clients to manage AddOn configurations
 * for the same entity without conflict.
 */
export var QuestionSetAddOnNamespace;
(function (QuestionSetAddOnNamespace) {
    QuestionSetAddOnNamespace["InterviewOnDemand"] = "INTERVIEW_ON_DEMAND";
})(QuestionSetAddOnNamespace || (QuestionSetAddOnNamespace = {}));
export var QuestionSource;
(function (QuestionSource) {
    /** Attributes ordered by job attach rate for an occupation using attribute order service */
    QuestionSource["AttributeOrderingService"] = "ATTRIBUTE_ORDERING_SERVICE";
    /** Attributes ordered by frequency on multi job surfaces like homepage and job search */
    QuestionSource["CintelSurfaceDerived"] = "CINTEL_SURFACE_DERIVED";
    /** Attributes for experimental questions for NEW fields in the profile which do not exist (see: CINTEL-224) */
    QuestionSource["CiExperimentalNew"] = "CI_EXPERIMENTAL_NEW";
    /** Default questions can be generic questions or attributes ordered by resume quality service (RQS) generated from a job seeker's resume */
    QuestionSource["DefaultQuestions"] = "DEFAULT_QUESTIONS";
    /** Attributes that the jobseeker may have if they possess the previously asked qualification */
    QuestionSource["HighConfidenceDeduction"] = "HIGH_CONFIDENCE_DEDUCTION";
    /**
     * Attributes ordered by resume quality service (RQS) generated from a job seeker's resume and the type of question
     * ie skills is ordered by the PDCS data science model artifact using the job seeker's most recent occupation.
     */
    QuestionSource["PdcsDataScienceModels"] = "PDCS_DATA_SCIENCE_MODELS";
    /** Attributes ordered by segment configuration platform for an occupation */
    QuestionSource["SegmentConfigPlatform"] = "SEGMENT_CONFIG_PLATFORM";
    /** Attributes ordered by segment configuration platform getLeversExperiment an occupation with CROWTAXO */
    QuestionSource["SegmentConfigPlatformCrowtaxo"] = "SEGMENT_CONFIG_PLATFORM_CROWTAXO";
    /** Attributes ordered by segment configuration platform getLeversExperiment an occupation with MOC (Minimum Occupation Criteria) */
    QuestionSource["SegmentConfigPlatformMoc"] = "SEGMENT_CONFIG_PLATFORM_MOC";
})(QuestionSource || (QuestionSource = {}));
/** Enumeration of supported question types */
export var QuestionType;
(function (QuestionType) {
    QuestionType["MultipleAnswers"] = "MULTIPLE_ANSWERS";
    QuestionType["MultiSelect"] = "MULTI_SELECT";
    QuestionType["Range"] = "RANGE";
    QuestionType["Select"] = "SELECT";
    QuestionType["SingleAnswer"] = "SINGLE_ANSWER";
    QuestionType["Text"] = "TEXT";
    QuestionType["Textarea"] = "TEXTAREA";
    QuestionType["YesNo"] = "YES_NO";
})(QuestionType || (QuestionType = {}));
/** Questions and answers section name */
export var QuestionsAndAnswersSectionName;
(function (QuestionsAndAnswersSectionName) {
    QuestionsAndAnswersSectionName["CredentialQuestionsAndAnswers"] = "CREDENTIAL_QUESTIONS_AND_ANSWERS";
    QuestionsAndAnswersSectionName["DemographicQuestionsAndAnswers"] = "DEMOGRAPHIC_QUESTIONS_AND_ANSWERS";
    QuestionsAndAnswersSectionName["IndeedQualificationQuestionsAndAnswers"] = "INDEED_QUALIFICATION_QUESTIONS_AND_ANSWERS";
    QuestionsAndAnswersSectionName["InterviewQuestionsAndAnswers"] = "INTERVIEW_QUESTIONS_AND_ANSWERS";
    QuestionsAndAnswersSectionName["ScreenerQuestionsAndAnswers"] = "SCREENER_QUESTIONS_AND_ANSWERS";
    QuestionsAndAnswersSectionName["SmartScreeningQuestionsAndAnswers"] = "SMART_SCREENING_QUESTIONS_AND_ANSWERS";
    QuestionsAndAnswersSectionName["UnknownQuestionsAndAnswers"] = "UNKNOWN_QUESTIONS_AND_ANSWERS";
})(QuestionsAndAnswersSectionName || (QuestionsAndAnswersSectionName = {}));
/** Stores Quick Contact feature being turned on or turned off */
export var QuickContactEnableSetting;
(function (QuickContactEnableSetting) {
    QuickContactEnableSetting["Disabled"] = "DISABLED";
    QuickContactEnableSetting["Enabled"] = "ENABLED";
    /** Initial state so we know if a user has never set this before */
    QuickContactEnableSetting["NotSet"] = "NOT_SET";
})(QuickContactEnableSetting || (QuickContactEnableSetting = {}));
/** Kind of difference detected for a field. */
export var RdpFidelityDifferenceType;
(function (RdpFidelityDifferenceType) {
    RdpFidelityDifferenceType["CollectionElementMismatch"] = "COLLECTION_ELEMENT_MISMATCH";
    RdpFidelityDifferenceType["CollectionSizeMismatch"] = "COLLECTION_SIZE_MISMATCH";
    RdpFidelityDifferenceType["MissingInActual"] = "MISSING_IN_ACTUAL";
    RdpFidelityDifferenceType["MissingInExpected"] = "MISSING_IN_EXPECTED";
    RdpFidelityDifferenceType["ValueMismatch"] = "VALUE_MISMATCH";
})(RdpFidelityDifferenceType || (RdpFidelityDifferenceType = {}));
/** Overall outcome of the JSON↔HTML fidelity check. */
export var RdpFidelityResult;
(function (RdpFidelityResult) {
    RdpFidelityResult["Error"] = "ERROR";
    RdpFidelityResult["Failure"] = "FAILURE";
    RdpFidelityResult["Success"] = "SUCCESS";
})(RdpFidelityResult || (RdpFidelityResult = {}));
/** Resume section a fidelity violation belongs to. */
export var RdpFidelitySection;
(function (RdpFidelitySection) {
    RdpFidelitySection["AdditionalInfo"] = "ADDITIONAL_INFO";
    RdpFidelitySection["Awards"] = "AWARDS";
    RdpFidelitySection["BasicInformation"] = "BASIC_INFORMATION";
    RdpFidelitySection["Certifications"] = "CERTIFICATIONS";
    RdpFidelitySection["Education"] = "EDUCATION";
    RdpFidelitySection["Groups"] = "GROUPS";
    RdpFidelitySection["LanguageSkills"] = "LANGUAGE_SKILLS";
    RdpFidelitySection["Licenses"] = "LICENSES";
    RdpFidelitySection["Links"] = "LINKS";
    RdpFidelitySection["MilitaryExperiences"] = "MILITARY_EXPERIENCES";
    RdpFidelitySection["Patents"] = "PATENTS";
    RdpFidelitySection["PrivateInformation"] = "PRIVATE_INFORMATION";
    RdpFidelitySection["Publications"] = "PUBLICATIONS";
    RdpFidelitySection["Skills"] = "SKILLS";
    RdpFidelitySection["WorkExperience"] = "WORK_EXPERIENCE";
})(RdpFidelitySection || (RdpFidelitySection = {}));
/** Which pair of rendered representations were compared to produce a violation. */
export var RdpFidelityType;
(function (RdpFidelityType) {
    RdpFidelityType["JsonToHtml"] = "JSON_TO_HTML";
})(RdpFidelityType || (RdpFidelityType = {}));
/**  Valid units of measurement to use when requesting a radius search.  */
export var RadiiUnit;
(function (RadiiUnit) {
    RadiiUnit["Kilometers"] = "KILOMETERS";
    RadiiUnit["Miles"] = "MILES";
})(RadiiUnit || (RadiiUnit = {}));
/** The type of sourcing subscription contact that was used when the outreach occurred. Currently null for PPA job contacts */
export var RcpEmployerOutreachContactTypeInput;
(function (RcpEmployerOutreachContactTypeInput) {
    /** A free subscription contact */
    RcpEmployerOutreachContactTypeInput["SubFree"] = "SUB_FREE";
    /** A personal subscription contact */
    RcpEmployerOutreachContactTypeInput["SubPersonal"] = "SUB_PERSONAL";
    /** A shared subscription contact */
    RcpEmployerOutreachContactTypeInput["SubShared"] = "SUB_SHARED";
})(RcpEmployerOutreachContactTypeInput || (RcpEmployerOutreachContactTypeInput = {}));
/**
 * Specific reason why an employer might be ineligible to reach out to a recommended candidate
 *
 * After Project Galaxy Phase 1 Monetization, an employer with a FTP/PPC job will become outreach ineligible if they:
 *
 * - Used up their trial subscription (14 days & 20 invites).
 * - Used up their invites as part of their standard/pro subscription (they can also choose to purchase more invites).
 *
 * If we don't change outreach ineligibility reasons right now, we would see that an employer is outreach ineligible due to their job posting type (FTP or PPC) even though it is due to their subscription type.
 *
 * TODO: Change the outreach ineligibility reasons to reflect that it is due to an employer not having the proper Resume Search subscription, instead of the job being FTP or PPC.
 */
export var RcpOutreachIneligibilityReasonInput;
(function (RcpOutreachIneligibilityReasonInput) {
    /**
     * The job is a "Free to Post" job, which means the employer can view candidates, but is not allowed to invite them
     * until they change their job sponsorship plan
     */
    RcpOutreachIneligibilityReasonInput["FtpJob"] = "FTP_JOB";
    /** The job has hit its lifetime limit of 200 invites */
    RcpOutreachIneligibilityReasonInput["JobLim"] = "JOB_LIM";
    /** The employer job is a Pay-Per-Click (PPC) job, and the employer has hit their monthly limit of 30 invites across all of their PPC jobs */
    RcpOutreachIneligibilityReasonInput["PpcLim"] = "PPC_LIM";
})(RcpOutreachIneligibilityReasonInput || (RcpOutreachIneligibilityReasonInput = {}));
/** Options for employer to choose to express their sentiment towards a recommended candidate */
export var RcpTernarySentimentInput;
(function (RcpTernarySentimentInput) {
    RcpTernarySentimentInput["Maybe"] = "MAYBE";
    RcpTernarySentimentInput["No"] = "NO";
    RcpTernarySentimentInput["Yes"] = "YES";
})(RcpTernarySentimentInput || (RcpTernarySentimentInput = {}));
/** Data source preference while fetching hosted job data, primary access requires permission from hosted jobs platform team */
export var ReadStrategy;
(function (ReadStrategy) {
    ReadStrategy["Primary"] = "PRIMARY";
    ReadStrategy["Replica"] = "REPLICA";
})(ReadStrategy || (ReadStrategy = {}));
/**
 * Category of reason for why the user is not allowed to access the given resource.
 * Only applicable when ACTION is BLOCK or CHALLENGE.
 */
export var Reason;
(function (Reason) {
    /** Applicable to the ACCOUNT_MESSAGE_SEND context. The Employer account tier is BLOCK. */
    Reason["AccountDisabled"] = "ACCOUNT_DISABLED";
    /** The advertiser's SHJ status is rejected. Applicable to MESSAGE_INTERACTION */
    Reason["AdvertiserDisabled"] = "ADVERTISER_DISABLED";
    /** The advertiser must wait before performing this action again. */
    Reason["Cooldown"] = "COOLDOWN";
    Reason["FeatureDisabled"] = "FEATURE_DISABLED";
    Reason["InsufficientAuthentication"] = "INSUFFICIENT_AUTHENTICATION";
    /** Applicable to the EXPORT_CANDIDATES and BULK_MESSAGE contexts. */
    Reason["LimitExceeded"] = "LIMIT_EXCEEDED";
    /**
     * The advertiser ID is missing from the request, and the RiskContext is configured to return BLOCK rather than
     * throwing a Bad Request error.
     */
    Reason["MissingAdvertiserId"] = "MISSING_ADVERTISER_ID";
    /** The account is required to verify their phone number. */
    Reason["PhoneVerificationRequired"] = "PHONE_VERIFICATION_REQUIRED";
    Reason["Unknown"] = "UNKNOWN";
    /** The advertiser's SHJ status is enabled and should perform verification. Applicable to EXPORT_CANDIDATES. */
    Reason["VerificationRequired"] = "VERIFICATION_REQUIRED";
})(Reason || (Reason = {}));
/**
 * Enumeration defining the supported reason code classification types.
 * Used to categorize reason codes by their business context and usage.
 */
export var ReasonCodeType;
(function (ReasonCodeType) {
    /** Subscription cancellation workflow reason codes */
    ReasonCodeType["CancelSubscription"] = "CANCEL_SUBSCRIPTION";
    /** Subscription pause workflow reason codes */
    ReasonCodeType["PauseSubscription"] = "PAUSE_SUBSCRIPTION";
    /** Standard refund processing reason codes */
    ReasonCodeType["Refund"] = "REFUND";
    /** Legacy refund codes maintained for backward compatibility */
    ReasonCodeType["RefundLegacy"] = "REFUND_LEGACY";
})(ReasonCodeType || (ReasonCodeType = {}));
/** @deprecated No longer tracked */
export var ReasonForFallback;
(function (ReasonForFallback) {
    /** No intent profile was found for the job */
    ReasonForFallback["EmptyIntentProfile"] = "EMPTY_INTENT_PROFILE";
    /** An error occurred while calling the primary strategy */
    ReasonForFallback["InternalServerError"] = "INTERNAL_SERVER_ERROR";
    /** Request to the primary strategy timed out */
    ReasonForFallback["Timeout"] = "TIMEOUT";
})(ReasonForFallback || (ReasonForFallback = {}));
/** Recipient data store */
export var RecipientDataSource;
(function (RecipientDataSource) {
    RecipientDataSource["Csv"] = "CSV";
    RecipientDataSource["Ishbook"] = "ISHBOOK";
    RecipientDataSource["Presto"] = "PRESTO";
})(RecipientDataSource || (RecipientDataSource = {}));
/** Type of recommendation - determines which action to take and what data structure to expect */
export var RecommendationType;
(function (RecommendationType) {
    /** Recommendation to upgrade from free post to sponsored job for increased visibility */
    RecommendationType["BudgetTierFreepostToSponsor"] = "BUDGET_TIER_FREEPOST_TO_SPONSOR";
    /** Recommendation to upgrade from sponsor tier to premium tier budget */
    RecommendationType["BudgetTierSponsorToPremium"] = "BUDGET_TIER_SPONSOR_TO_PREMIUM";
    /** Recommendation to upgrade from sponsor tier to premium plus tier budget */
    RecommendationType["BudgetTierSponsorToPremiumPlus"] = "BUDGET_TIER_SPONSOR_TO_PREMIUM_PLUS";
    /** Recommendation to upgrade from sponsor tier to standard tier budget */
    RecommendationType["BudgetTierSponsorToStandard"] = "BUDGET_TIER_SPONSOR_TO_STANDARD";
    /** Recommendation to create or optimize company page */
    RecommendationType["CompanyPage"] = "COMPANY_PAGE";
    /** Recommendation to address a declined credit card on the account */
    RecommendationType["CreditCardDeclined"] = "CREDIT_CARD_DECLINED";
    /** Recommendation to enable employer automation features */
    RecommendationType["EmployerAutomations"] = "EMPLOYER_AUTOMATIONS";
    /** Recommendation to add location information to hosted jobs */
    RecommendationType["HostedJobLocation"] = "HOSTED_JOB_LOCATION";
    /** Recommendation to add salary information to hosted jobs */
    RecommendationType["HostedJobSalary"] = "HOSTED_JOB_SALARY";
    /** Recommendation to optimize interview processes */
    RecommendationType["Interview"] = "INTERVIEW";
    /** Recommendation to enable itemized billing for the advertiser */
    RecommendationType["ItemizedBilling"] = "ITEMIZED_BILLING";
    /** Recommendation to sponsor a set of individual jobs, propsed by a rep via Consent reqest */
    RecommendationType["JobSponsorshipConsent"] = "JOB_SPONSORSHIP_CONSENT";
    /** Recommendation to address jobs with no applications */
    RecommendationType["NowhereJob"] = "NOWHERE_JOB";
    /** Recommendation to add screening questions to jobs */
    RecommendationType["ScreenerQuestions"] = "SCREENER_QUESTIONS";
    /** Recommendation to enable smart sourcing features */
    RecommendationType["SmartSourcing"] = "SMART_SOURCING";
    /** Recommendation to sponsor jobs that are hosted on Indeed */
    RecommendationType["SponsorHostedJob"] = "SPONSOR_HOSTED_JOB";
    /** Recommendation to provide TCPA consent for Indeed to contact the advertiser */
    RecommendationType["TcpaConsent"] = "TCPA_CONSENT";
})(RecommendationType || (RecommendationType = {}));
/** Visibility state of a recommendation - controls whether it appears in the Action Center UI */
export var RecommendationVisibility;
(function (RecommendationVisibility) {
    /** Recommendation has been completed */
    RecommendationVisibility["Completed"] = "COMPLETED";
    /** Recommendation has been ignored by the user */
    RecommendationVisibility["Ignored"] = "IGNORED";
    /** Recommendation is visible and actionable */
    RecommendationVisibility["Visible"] = "VISIBLE";
})(RecommendationVisibility || (RecommendationVisibility = {}));
export var RecruiterCandidatePoolStatusEnum;
(function (RecruiterCandidatePoolStatusEnum) {
    RecruiterCandidatePoolStatusEnum["Active"] = "ACTIVE";
    RecruiterCandidatePoolStatusEnum["EngagementExpired"] = "ENGAGEMENT_EXPIRED";
    /** Currently our email template doesn't have a decline button, but this status is kept for design flexibility. */
    RecruiterCandidatePoolStatusEnum["EngagementRefused"] = "ENGAGEMENT_REFUSED";
    RecruiterCandidatePoolStatusEnum["PendingEngagement"] = "PENDING_ENGAGEMENT";
    RecruiterCandidatePoolStatusEnum["Removed"] = "REMOVED";
})(RecruiterCandidatePoolStatusEnum || (RecruiterCandidatePoolStatusEnum = {}));
/** Status of the recruiter↔company relationship. Maintained by a scheduled task based on current bid activity. */
export var RecruiterClientStatusEnum;
(function (RecruiterClientStatusEnum) {
    /** Recruiter has at least one ACCEPTED bid on a job_order whose status is ACTIVE for this employer. Pending bids (NEW / READ) and ACCEPTED bids on pre-launch orders (OPEN / LAUNCHING / PENDING_PAYMENT / CREATED) do NOT count — those are still bidding, not an active engagement. */
    RecruiterClientStatusEnum["Active"] = "ACTIVE";
    /** Recruiter has no ACCEPTED bid on an ACTIVE job_order for this employer right now. */
    RecruiterClientStatusEnum["Inactive"] = "INACTIVE";
})(RecruiterClientStatusEnum || (RecruiterClientStatusEnum = {}));
export var RecruiterInvitationStatusEnum;
(function (RecruiterInvitationStatusEnum) {
    RecruiterInvitationStatusEnum["Accepted"] = "ACCEPTED";
    RecruiterInvitationStatusEnum["Expired"] = "EXPIRED";
    RecruiterInvitationStatusEnum["Pending"] = "PENDING";
})(RecruiterInvitationStatusEnum || (RecruiterInvitationStatusEnum = {}));
/** Predefined categories for filtering job orders from a recruiter's perspective. */
export var RecruiterJobOrderCategory;
(function (RecruiterJobOrderCategory) {
    /** Job orders that are currently active or launching and recruiter has an accepted bid on it. */
    RecruiterJobOrderCategory["Active"] = "ACTIVE";
    /** Job orders that have been closed and recruiter must have a bid on it. */
    RecruiterJobOrderCategory["Closed"] = "CLOSED";
    /** Non-created job orders where the recruiter has a declined bid. */
    RecruiterJobOrderCategory["DeclinedBids"] = "DECLINED_BIDS";
    /** Job orders that are open to bid and recruiter doesn't have a bid on it. */
    RecruiterJobOrderCategory["NewMatches"] = "NEW_MATCHES";
    /** Job orders that are open to bid and recruiter doesn't have an accepted or denied bid on it. */
    RecruiterJobOrderCategory["PendingBids"] = "PENDING_BIDS";
})(RecruiterJobOrderCategory || (RecruiterJobOrderCategory = {}));
/** Represents the consent status for Recruiting Assistant Terms & Conditions. */
export var RecruitingAssistantTocConsentStatus;
(function (RecruitingAssistantTocConsentStatus) {
    /** Employer has denied consent */
    RecruitingAssistantTocConsentStatus["Denied"] = "DENIED";
    /** Employer has granted consent */
    RecruitingAssistantTocConsentStatus["Granted"] = "GRANTED";
    /** Consent status is not specified */
    RecruitingAssistantTocConsentStatus["Unspecified"] = "UNSPECIFIED";
})(RecruitingAssistantTocConsentStatus || (RecruitingAssistantTocConsentStatus = {}));
/** Enum for redact type */
export var RedactType;
(function (RedactType) {
    RedactType["EmailPhoneLinks"] = "EMAIL_PHONE_LINKS";
    RedactType["NameEmail"] = "NAME_EMAIL";
    RedactType["NameEmailPhone"] = "NAME_EMAIL_PHONE";
    RedactType["NameEmailPhoneLinks"] = "NAME_EMAIL_PHONE_LINKS";
})(RedactType || (RedactType = {}));
/** The kind of entity a [ChatReference] points to */
export var ReferenceKind;
(function (ReferenceKind) {
    /** Resolves an aggregated job entity. */
    ReferenceKind["AggJob"] = "AGG_JOB";
    /** Resolves an employer-posted job entity. */
    ReferenceKind["EmployerJob"] = "EMPLOYER_JOB";
    /** Resolves an Indeed Apply entity. */
    ReferenceKind["IndeedApply"] = "INDEED_APPLY";
    /** Resolves the `UcpCandidate` entity. */
    ReferenceKind["UcpCandidate"] = "UCP_CANDIDATE";
    /**
     * Resolves the `CandidateSubmission` entity via the stored id, e.g.:
     *
     * ```
     * query ($nodeId: ID!) {
     *     node(id: $nodeId) {
     *         ... on CandidateSubmission {
     *          id
     *         }
     *     }
     * }
     * ```
     */
    ReferenceKind["UcpCandidateSubmission"] = "UCP_CANDIDATE_SUBMISSION";
})(ReferenceKind || (ReferenceKind = {}));
/** Refresh cadence options for data assets */
export var RefreshCadence;
(function (RefreshCadence) {
    RefreshCadence["Daily"] = "DAILY";
    RefreshCadence["Hourly"] = "HOURLY";
    RefreshCadence["Monthly"] = "MONTHLY";
    RefreshCadence["Other"] = "OTHER";
    RefreshCadence["Weekly"] = "WEEKLY";
})(RefreshCadence || (RefreshCadence = {}));
/** Days of the week for scheduling refresh jobs */
export var RefreshScheduleDay;
(function (RefreshScheduleDay) {
    RefreshScheduleDay["Friday"] = "FRIDAY";
    RefreshScheduleDay["Monday"] = "MONDAY";
    RefreshScheduleDay["Saturday"] = "SATURDAY";
    RefreshScheduleDay["Sunday"] = "SUNDAY";
    RefreshScheduleDay["Thursday"] = "THURSDAY";
    RefreshScheduleDay["Tuesday"] = "TUESDAY";
    RefreshScheduleDay["Wednesday"] = "WEDNESDAY";
})(RefreshScheduleDay || (RefreshScheduleDay = {}));
/** Represents the type of process used to handle a refund request */
export var RefundProcess;
(function (RefundProcess) {
    /** Indicates that the refund is processed automatically without human intervention */
    RefundProcess["Automated"] = "AUTOMATED";
    /** Indicates that the refund is processed manually, requiring human intervention to review and complete the refund */
    RefundProcess["Manual"] = "MANUAL";
    /** Indicates that no process was executed */
    RefundProcess["NotApplicable"] = "NOT_APPLICABLE";
})(RefundProcess || (RefundProcess = {}));
/** The user's regenerate rate limit status */
export var RegenStatus;
(function (RegenStatus) {
    /** The user has exceeded the limit */
    RegenStatus["Error"] = "ERROR";
    /** The user has reached the limit */
    RegenStatus["Limit"] = "LIMIT";
    /** The user is under the limit */
    RegenStatus["Ok"] = "OK";
    /** The user is near the limit */
    RegenStatus["Warn"] = "WARN";
})(RegenStatus || (RegenStatus = {}));
/**  Annual deal rejection reason  */
export var RejectionReason;
(function (RejectionReason) {
    RejectionReason["CompanyName"] = "COMPANY_NAME";
    RejectionReason["DealDate"] = "DEAL_DATE";
    RejectionReason["MonthlyCommitment"] = "MONTHLY_COMMITMENT";
    RejectionReason["Other"] = "OTHER";
})(RejectionReason || (RejectionReason = {}));
/** Enum representing different types of related entities */
export var RelatedEntityIdType;
(function (RelatedEntityIdType) {
    RelatedEntityIdType["EmployerJobId"] = "EMPLOYER_JOB_ID";
})(RelatedEntityIdType || (RelatedEntityIdType = {}));
/** Remote postings share metric type. */
export var RemoteMetric;
(function (RemoteMetric) {
    RemoteMetric["Postings"] = "POSTINGS";
    RemoteMetric["Searches"] = "SEARCHES";
})(RemoteMetric || (RemoteMetric = {}));
/** Enum representing 3 character Month */
export var RenewalMonth;
(function (RenewalMonth) {
    RenewalMonth["Apr"] = "APR";
    RenewalMonth["Aug"] = "AUG";
    RenewalMonth["Dec"] = "DEC";
    RenewalMonth["Feb"] = "FEB";
    RenewalMonth["Jan"] = "JAN";
    RenewalMonth["Jul"] = "JUL";
    RenewalMonth["Jun"] = "JUN";
    RenewalMonth["Mar"] = "MAR";
    RenewalMonth["May"] = "MAY";
    RenewalMonth["Nov"] = "NOV";
    RenewalMonth["Oct"] = "OCT";
    RenewalMonth["Sep"] = "SEP";
})(RenewalMonth || (RenewalMonth = {}));
/** renewal period of a subscription */
export var RenewalPeriod;
(function (RenewalPeriod) {
    RenewalPeriod["Annual"] = "ANNUAL";
    RenewalPeriod["Monthly"] = "MONTHLY";
})(RenewalPeriod || (RenewalPeriod = {}));
/** Reason why the job is being reopened. */
export var ReopenJobReason;
(function (ReopenJobReason) {
    ReopenJobReason["MoreCand"] = "MORE_CAND";
    ReopenJobReason["Other"] = "OTHER";
    ReopenJobReason["Reuse"] = "REUSE";
})(ReopenJobReason || (ReopenJobReason = {}));
/** Enumerates the different file extension of a metric report. */
export var ReportFormat;
(function (ReportFormat) {
    ReportFormat["Csv"] = "CSV";
    ReportFormat["Pdf"] = "PDF";
})(ReportFormat || (ReportFormat = {}));
/** Type of principal (user or group) for permission assignment */
export var ReportPermissionPrincipalType;
(function (ReportPermissionPrincipalType) {
    /** Group identified by group name */
    ReportPermissionPrincipalType["Group"] = "GROUP";
    /** Individual user identified by LDAP name */
    ReportPermissionPrincipalType["User"] = "USER";
})(ReportPermissionPrincipalType || (ReportPermissionPrincipalType = {}));
/** Permission role that can be assigned to users or groups */
export var ReportPermissionRole;
(function (ReportPermissionRole) {
    /** Can modify report definition but cannot change permissions */
    ReportPermissionRole["Editor"] = "EDITOR";
    /** Full control over the report including permission management */
    ReportPermissionRole["Owner"] = "OWNER";
    /** Can only view and execute the report */
    ReportPermissionRole["Reader"] = "READER";
})(ReportPermissionRole || (ReportPermissionRole = {}));
/** Represents the current state of a data report execution */
export var ReportStatus;
(function (ReportStatus) {
    ReportStatus["Cancelled"] = "CANCELLED";
    ReportStatus["Completed"] = "COMPLETED";
    ReportStatus["Failed"] = "FAILED";
    ReportStatus["InProgress"] = "IN_PROGRESS";
    ReportStatus["New"] = "NEW";
    ReportStatus["Queued"] = "QUEUED";
})(ReportStatus || (ReportStatus = {}));
/** enum for report Status */
export var ReportStatusEnum;
(function (ReportStatusEnum) {
    ReportStatusEnum["Completed"] = "COMPLETED";
    ReportStatusEnum["Failed"] = "FAILED";
    ReportStatusEnum["InProgress"] = "IN_PROGRESS";
    ReportStatusEnum["Pending"] = "PENDING";
})(ReportStatusEnum || (ReportStatusEnum = {}));
export var ReportType;
(function (ReportType) {
    ReportType["BillingReport"] = "BILLING_REPORT";
})(ReportType || (ReportType = {}));
export var RequestItemStatusCode;
(function (RequestItemStatusCode) {
    RequestItemStatusCode["InternalFailure"] = "INTERNAL_FAILURE";
    RequestItemStatusCode["RetryableFailure"] = "RETRYABLE_FAILURE";
    RequestItemStatusCode["UnknownStatus"] = "UNKNOWN_STATUS";
    RequestItemStatusCode["ValidationFailure"] = "VALIDATION_FAILURE";
})(RequestItemStatusCode || (RequestItemStatusCode = {}));
/** Enum to consolidate all possible result code */
export var RequestResult;
(function (RequestResult) {
    RequestResult["Error"] = "ERROR";
    RequestResult["Invalid"] = "INVALID";
    RequestResult["Success"] = "SUCCESS";
})(RequestResult || (RequestResult = {}));
/** Enum representing the type of async request in CBS */
export var RequestType;
(function (RequestType) {
    /** Bulk Invoice PDF Download - returns S3 URL for ZIP download */
    RequestType["BulkInvoicePdf"] = "BULK_INVOICE_PDF";
    RequestType["Cancellation"] = "CANCELLATION";
    RequestType["CancellationSync"] = "CANCELLATION_SYNC";
    /** Consolidated Itemized Report - returns S3 URL for CSV download */
    RequestType["Cir"] = "CIR";
    /** Invoices query - returns JSON result data */
    RequestType["Invoices"] = "INVOICES";
    RequestType["Provisioning"] = "PROVISIONING";
    RequestType["ProvisioningSync"] = "PROVISIONING_SYNC";
    /** Share Invoices via email - returns S3 URL for CSV download */
    RequestType["ShareInvoices"] = "SHARE_INVOICES";
    /** Top Spends aggregation query - returns JSON result data */
    RequestType["TopSpends"] = "TOP_SPENDS";
})(RequestType || (RequestType = {}));
/** Possible values of the requirement severity in ScreenerQuestionRequirements and StructuredJobRequirements */
export var RequirementSeverity;
(function (RequirementSeverity) {
    RequirementSeverity["Preferred"] = "PREFERRED";
    RequirementSeverity["Required"] = "REQUIRED";
    RequirementSeverity["Unknown"] = "UNKNOWN";
})(RequirementSeverity || (RequirementSeverity = {}));
/**
 * Mode determining how resolution should be performed for SINGLE_SOURCE jobs.
 * - EVENTUAL: Only jobs that have finished Waldo visibility processing are matched.
 * - IMMEDIATE: Newly created jobs (whose Waldo visibility has not yet been computed but initial_visibility is computed) are also matched, by using Waldo's initial_visibility_nowhere / initial_messagingtag filters
 */
export var ResolutionMode;
(function (ResolutionMode) {
    ResolutionMode["Eventual"] = "EVENTUAL";
    ResolutionMode["Immediate"] = "IMMEDIATE";
})(ResolutionMode || (ResolutionMode = {}));
/**
 * Defines the strategy used for resolving jobs.
 * - SINGLE_SOURCE: Resolve jobs by IDX.
 * - MULTI_SOURCE: Resolves jobs using Waldo with no restrictions on job sources (Used by Online Marketing Campaigns).
 * - RESTRICTED_MULTI_SOURCE: Resolves jobs using Waldo, limited to sources claimed by the advertiser.
 */
export var ResolutionStrategy;
(function (ResolutionStrategy) {
    ResolutionStrategy["MultiSource"] = "MULTI_SOURCE";
    ResolutionStrategy["RestrictedMultiSource"] = "RESTRICTED_MULTI_SOURCE";
    ResolutionStrategy["SingleSource"] = "SINGLE_SOURCE";
})(ResolutionStrategy || (ResolutionStrategy = {}));
/** Supported resource types for Timberlake policies */
export var ResourceType;
(function (ResourceType) {
    /** Task configuration resources */
    ResourceType["TaskConfiguration"] = "TASK_CONFIGURATION";
})(ResourceType || (ResourceType = {}));
/** Result status for a mutation. */
export var ResultStatus;
(function (ResultStatus) {
    ResultStatus["Failed"] = "FAILED";
    ResultStatus["Success"] = "SUCCESS";
})(ResultStatus || (ResultStatus = {}));
export var ResumeCaptchaType;
(function (ResumeCaptchaType) {
    ResumeCaptchaType["Active"] = "ACTIVE";
    ResumeCaptchaType["Bypass"] = "BYPASS";
    ResumeCaptchaType["NoJs"] = "NO_JS";
    ResumeCaptchaType["Passive"] = "PASSIVE";
})(ResumeCaptchaType || (ResumeCaptchaType = {}));
/** The job seeker's reasons for declining the engagement */
export var ResumeEngagementDeclineReason;
(function (ResumeEngagementDeclineReason) {
    /** Company is not a good fit */
    ResumeEngagementDeclineReason["Company"] = "COMPANY";
    /** Industry is not a good fit */
    ResumeEngagementDeclineReason["Industry"] = "INDUSTRY";
    /** Position is not a good fit */
    ResumeEngagementDeclineReason["JobContent"] = "JOB_CONTENT";
    /** Job location is not a good fit */
    ResumeEngagementDeclineReason["Location"] = "LOCATION";
    /** I'm not actively looking for a job */
    ResumeEngagementDeclineReason["NotActivelyLooking"] = "NOT_ACTIVELY_LOOKING";
    /** Other reasons */
    ResumeEngagementDeclineReason["Other"] = "OTHER";
    /** Salary for the job doesn't meet my expectations */
    ResumeEngagementDeclineReason["Salary"] = "SALARY";
    /** Job post appears to be fake/spam */
    ResumeEngagementDeclineReason["Spam"] = "SPAM";
})(ResumeEngagementDeclineReason || (ResumeEngagementDeclineReason = {}));
/** Available user's roles in the Resume Engagement */
export var ResumeEngagementRole;
(function (ResumeEngagementRole) {
    ResumeEngagementRole["Employer"] = "EMPLOYER";
    ResumeEngagementRole["Jobseeker"] = "JOBSEEKER";
})(ResumeEngagementRole || (ResumeEngagementRole = {}));
/** Avaiable statuses of the Resume Engagement */
export var ResumeEngagementStatus;
(function (ResumeEngagementStatus) {
    /** The job seeker responded to the engagement without interest */
    ResumeEngagementStatus["Declined"] = "DECLINED";
    /** The employer initiated the engagement */
    ResumeEngagementStatus["Initiated"] = "INITIATED";
    /** The job seeker responded to the engagement with interest */
    ResumeEngagementStatus["Interested"] = "INTERESTED";
})(ResumeEngagementStatus || (ResumeEngagementStatus = {}));
export var ResumeFileSuggestionStatus;
(function (ResumeFileSuggestionStatus) {
    /** Suggestion workflow was aborted */
    ResumeFileSuggestionStatus["Aborted"] = "ABORTED";
    /** Suggestion workflow was completed successfully */
    ResumeFileSuggestionStatus["Completed"] = "COMPLETED";
    /** Suggestion was dismissed by the user */
    ResumeFileSuggestionStatus["Dismissed"] = "DISMISSED";
    /** Suggestion workflow failed */
    ResumeFileSuggestionStatus["Failed"] = "FAILED";
    /** Suggestion was shown to the user (impression recorded) */
    ResumeFileSuggestionStatus["Impression"] = "IMPRESSION";
})(ResumeFileSuggestionStatus || (ResumeFileSuggestionStatus = {}));
export var ResumeGlowUpSurface;
(function (ResumeGlowUpSurface) {
    ResumeGlowUpSurface["NextStepsDashboard"] = "NEXT_STEPS_DASHBOARD";
    ResumeGlowUpSurface["Onboarding"] = "ONBOARDING";
})(ResumeGlowUpSurface || (ResumeGlowUpSurface = {}));
export var ResumeOriginSmartApplyApplicationState;
(function (ResumeOriginSmartApplyApplicationState) {
    ResumeOriginSmartApplyApplicationState["IndeedProfile"] = "INDEED_PROFILE";
    ResumeOriginSmartApplyApplicationState["NoResume"] = "NO_RESUME";
    ResumeOriginSmartApplyApplicationState["RecruitProfile"] = "RECRUIT_PROFILE";
    ResumeOriginSmartApplyApplicationState["SavedResume"] = "SAVED_RESUME";
    ResumeOriginSmartApplyApplicationState["TailoredResume"] = "TAILORED_RESUME";
    ResumeOriginSmartApplyApplicationState["UserUploaded"] = "USER_UPLOADED";
})(ResumeOriginSmartApplyApplicationState || (ResumeOriginSmartApplyApplicationState = {}));
/** Operations supported by the Resume Parsing Service. */
export var ResumeParsingOperation;
(function (ResumeParsingOperation) {
    /** Parse a resume to extract structured information */
    ResumeParsingOperation["ParseResume"] = "PARSE_RESUME";
})(ResumeParsingOperation || (ResumeParsingOperation = {}));
/**
 * Deprecated: the preferred resume template is now returned as a String on
 * JobSeekerProfileResumeData.preferredResumeTemplate. This enum is retained only for
 * the deprecated SmartApplyResumeDerivedContext.preferredResumeTemplate field.
 */
export var ResumePreferredTemplateType;
(function (ResumePreferredTemplateType) {
    /** @deprecated Use JobSeekerProfileResumeData.preferredResumeTemplate (String) instead. */
    ResumePreferredTemplateType["Aurora"] = "AURORA";
    /** @deprecated Use JobSeekerProfileResumeData.preferredResumeTemplate (String) instead. */
    ResumePreferredTemplateType["Dawn"] = "DAWN";
    /** @deprecated Use JobSeekerProfileResumeData.preferredResumeTemplate (String) instead. */
    ResumePreferredTemplateType["Default"] = "DEFAULT";
})(ResumePreferredTemplateType || (ResumePreferredTemplateType = {}));
export var ResumePrefillType;
(function (ResumePrefillType) {
    /** Prefills the Indeed-generated resume from the user's profile */
    ResumePrefillType["IndeedResume"] = "INDEED_RESUME";
    /** Prefills the resume based on the user's last used resume type */
    ResumePrefillType["LastUsedResume"] = "LAST_USED_RESUME";
    /** Prefills the saved file resume from the user's profile */
    ResumePrefillType["SavedFileResume"] = "SAVED_FILE_RESUME";
})(ResumePrefillType || (ResumePrefillType = {}));
export var ResumeSectionType;
(function (ResumeSectionType) {
    ResumeSectionType["ResumeAdditionalInfo"] = "RESUME_ADDITIONAL_INFO";
    ResumeSectionType["ResumeAssessments"] = "RESUME_ASSESSMENTS";
    ResumeSectionType["ResumeAssociations"] = "RESUME_ASSOCIATIONS";
    ResumeSectionType["ResumeAwards"] = "RESUME_AWARDS";
    ResumeSectionType["ResumeCertifications"] = "RESUME_CERTIFICATIONS";
    ResumeSectionType["ResumeEducation"] = "RESUME_EDUCATION";
    ResumeSectionType["ResumeExperience"] = "RESUME_EXPERIENCE";
    ResumeSectionType["ResumeLicenses"] = "RESUME_LICENSES";
    ResumeSectionType["ResumeLinks"] = "RESUME_LINKS";
    ResumeSectionType["ResumeMilitaryService"] = "RESUME_MILITARY_SERVICE";
    ResumeSectionType["ResumePatents"] = "RESUME_PATENTS";
    ResumeSectionType["ResumePublications"] = "RESUME_PUBLICATIONS";
    ResumeSectionType["ResumeSkill"] = "RESUME_SKILL";
    ResumeSectionType["ResumeSummary"] = "RESUME_SUMMARY";
    ResumeSectionType["ResumeTitle"] = "RESUME_TITLE";
    ResumeSectionType["Unknown"] = "UNKNOWN";
})(ResumeSectionType || (ResumeSectionType = {}));
/** Type of Resume Jobseeker is using */
export var ResumeType;
(function (ResumeType) {
    ResumeType["DraftUploadedResume"] = "DRAFT_UPLOADED_RESUME";
    ResumeType["FileUploadedResume"] = "FILE_UPLOADED_RESUME";
    ResumeType["IndeedResume"] = "INDEED_RESUME";
    ResumeType["NoResume"] = "NO_RESUME";
    ResumeType["SavedFileResume"] = "SAVED_FILE_RESUME";
    ResumeType["Unknown"] = "UNKNOWN";
})(ResumeType || (ResumeType = {}));
export var RetryAbility;
(function (RetryAbility) {
    RetryAbility["NonRetryable"] = "NON_RETRYABLE";
    RetryAbility["Retryable"] = "RETRYABLE";
})(RetryAbility || (RetryAbility = {}));
/**
 * Retry strategies for candidate fit generation with different optimization goals
 * @deprecated This enum is no longer used
 */
export var RetryStrategy;
(function (RetryStrategy) {
    /** Optimized for accuracy with more retries and exponential backoff */
    RetryStrategy["AccuracyOptimized"] = "ACCURACY_OPTIMIZED";
    /** Optimized for low latency with minimal retries and fixed backoff */
    RetryStrategy["LatencyOptimized"] = "LATENCY_OPTIMIZED";
})(RetryStrategy || (RetryStrategy = {}));
export var ReviewBeforeSubmitDraftState;
(function (ReviewBeforeSubmitDraftState) {
    ReviewBeforeSubmitDraftState["Continue"] = "CONTINUE";
    ReviewBeforeSubmitDraftState["Draft"] = "DRAFT";
    ReviewBeforeSubmitDraftState["Prefill"] = "PREFILL";
    ReviewBeforeSubmitDraftState["Preview"] = "PREVIEW";
    ReviewBeforeSubmitDraftState["Submitted"] = "SUBMITTED";
    ReviewBeforeSubmitDraftState["Unknown"] = "UNKNOWN";
})(ReviewBeforeSubmitDraftState || (ReviewBeforeSubmitDraftState = {}));
/** Reviews support set of sort types. This enum contains their ids */
export var ReviewSortType;
(function (ReviewSortType) {
    /** Sort by character length of all text fields: `text`, `title`, `pros`, `cons` */
    ReviewSortType["BodyLength"] = "BODY_LENGTH";
    /** Sort by `compensationAndBenefitsRating` field */
    ReviewSortType["CompensationAndBenefitsRating"] = "COMPENSATION_AND_BENEFITS_RATING";
    /** Sort by `cultureAndValuesRating` field */
    ReviewSortType["CultureAndValuesRating"] = "CULTURE_AND_VALUES_RATING";
    /** Sort by `helpfulCount` field (Number of users who voted review as helpful) */
    ReviewSortType["Helpfulness"] = "HELPFULNESS";
    /** Sort by `jobSecurityAndAdvancementRating` field */
    ReviewSortType["JobSecurityAndAdvancementRating"] = "JOB_SECURITY_AND_ADVANCEMENT_RATING";
    /** Sort by `managementRating` field */
    ReviewSortType["ManagementRating"] = "MANAGEMENT_RATING";
    /** Sort by `overallRating` field */
    ReviewSortType["OverallRating"] = "OVERALL_RATING";
    /** Sort by `dateCreated` field (review submission time) */
    ReviewSortType["ReviewDate"] = "REVIEW_DATE";
    /** Sort by aggregated score of topic rating fields: `compensationAndBenefitsRating`, `cultureAndValuesRating`, `jobSecurityAndAdvancementRating`, `managementRating`, `workLifeBalanceRating` */
    ReviewSortType["TopicRatings"] = "TOPIC_RATINGS";
    /** Sort by `workLifeBalanceRating` field */
    ReviewSortType["WorkAndLifeBalanceRating"] = "WORK_AND_LIFE_BALANCE_RATING";
})(ReviewSortType || (ReviewSortType = {}));
/** Reviews can belong to one or more topics. Enum represents available topics or its absence */
export var ReviewTopic;
(function (ReviewTopic) {
    /** Job Security & Advancement */
    ReviewTopic["AdvancementTopic"] = "ADVANCEMENT_TOPIC";
    /** Pay & Benefits */
    ReviewTopic["BenefitsTopic"] = "BENEFITS_TOPIC";
    /** Culture */
    ReviewTopic["CultureTopic"] = "CULTURE_TOPIC";
    /** Management */
    ReviewTopic["ManagementTopic"] = "MANAGEMENT_TOPIC";
    /** Topic is absent */
    ReviewTopic["NoTopic"] = "NO_TOPIC";
    /** Work-Life Balance */
    ReviewTopic["WorkLifeTopic"] = "WORK_LIFE_TOPIC";
})(ReviewTopic || (ReviewTopic = {}));
/** Resulting action based on the input given */
export var RiskAction;
(function (RiskAction) {
    /** The user is allowed to access the given resource. */
    RiskAction["Allow"] = "ALLOW";
    /** The user is not allowed to access the given resource. */
    RiskAction["Block"] = "BLOCK";
    /** The user is currently not allowed to access the given resource, but may gain access by performing a step-up. */
    RiskAction["Challenge"] = "CHALLENGE";
    /**
     * DEPRECATED: All SKIP responses are now converted to ALLOW, see https://bugs.indeed.com/browse/AFSPLAT-867
     * for more details.
     */
    RiskAction["Skip"] = "SKIP";
})(RiskAction || (RiskAction = {}));
/** Type of risk involved to be queried */
export var RiskContext;
(function (RiskContext) {
    RiskContext["AccountEmailUpdate"] = "ACCOUNT_EMAIL_UPDATE";
    RiskContext["AccountManagePasskey"] = "ACCOUNT_MANAGE_PASSKEY";
    RiskContext["AccountMessageSend"] = "ACCOUNT_MESSAGE_SEND";
    RiskContext["AccountSettings"] = "ACCOUNT_SETTINGS";
    RiskContext["Admin"] = "ADMIN";
    RiskContext["BulkJobEdit"] = "BULK_JOB_EDIT";
    RiskContext["BulkMessage"] = "BULK_MESSAGE";
    RiskContext["CareerScout"] = "CAREER_SCOUT";
    RiskContext["CreateHiringEvents"] = "CREATE_HIRING_EVENTS";
    RiskContext["EmployerConfidentialData"] = "EMPLOYER_CONFIDENTIAL_DATA";
    RiskContext["ExportCandidates"] = "EXPORT_CANDIDATES";
    RiskContext["HostedCandidate"] = "HOSTED_CANDIDATE";
    RiskContext["InterviewLobbyAccess"] = "INTERVIEW_LOBBY_ACCESS";
    RiskContext["JobSeekerConfidentialData"] = "JOB_SEEKER_CONFIDENTIAL_DATA";
    RiskContext["JsApplyStartRateLimit"] = "JS_APPLY_START_RATE_LIMIT";
    RiskContext["JsProPremium"] = "JS_PRO_PREMIUM";
    RiskContext["MessageInteraction"] = "MESSAGE_INTERACTION";
    RiskContext["OneHostCandidates"] = "ONE_HOST_CANDIDATES";
    RiskContext["OneHostMessages"] = "ONE_HOST_MESSAGES";
    RiskContext["OneHostSmartSourcing"] = "ONE_HOST_SMART_SOURCING";
    RiskContext["OriginalApplicationData"] = "ORIGINAL_APPLICATION_DATA";
    RiskContext["ProcessPayment"] = "PROCESS_PAYMENT";
    RiskContext["SecondaryUserInvite"] = "SECONDARY_USER_INVITE";
    RiskContext["SmartSourcingEnabled"] = "SMART_SOURCING_ENABLED";
    RiskContext["SmartSourcingTrialRegistration"] = "SMART_SOURCING_TRIAL_REGISTRATION";
    RiskContext["SmartSourcingTrialResumeView"] = "SMART_SOURCING_TRIAL_RESUME_VIEW";
    RiskContext["TalentScout"] = "TALENT_SCOUT";
})(RiskContext || (RiskContext = {}));
/** Scope at which a role applies. */
export var RoleScope;
(function (RoleScope) {
    /** Role applies at the account/system level. */
    RoleScope["Account"] = "ACCOUNT";
    /** Role applies at the job level. */
    RoleScope["Job"] = "JOB";
})(RoleScope || (RoleScope = {}));
/** Rollout mode for ATS integration */
export var RolloutMode;
(function (RolloutMode) {
    /** Users must explicitly opt-in */
    RolloutMode["OptIn"] = "OPT_IN";
    /** Users are opted-in by default but can opt-out */
    RolloutMode["OptOut"] = "OPT_OUT";
})(RolloutMode || (RolloutMode = {}));
/** Worst-of rolled-up health status for a focal asset, derived from upstream checks. */
export var RollupStatus;
(function (RollupStatus) {
    /** A mix of passing and unknown upstream checks (partial coverage). */
    RollupStatus["Degraded"] = "DEGRADED";
    /** At least one upstream check is failing. */
    RollupStatus["Failed"] = "FAILED";
    /** All upstream checks are passing. */
    RollupStatus["Passed"] = "PASSED";
    /** No upstream check status is available. */
    RollupStatus["Unknown"] = "UNKNOWN";
})(RollupStatus || (RollupStatus = {}));
export var RoomType;
(function (RoomType) {
    RoomType["Phone"] = "PHONE";
    RoomType["Video"] = "VIDEO";
})(RoomType || (RoomType = {}));
/** Enumeration of creative rotation strategies */
export var RotationStrategy;
(function (RotationStrategy) {
    RotationStrategy["Optimized"] = "OPTIMIZED";
    RotationStrategy["Random"] = "RANDOM";
    RotationStrategy["Weighted"] = "WEIGHTED";
})(RotationStrategy || (RotationStrategy = {}));
export var RowCountOperator;
(function (RowCountOperator) {
    RowCountOperator["Anomalous"] = "ANOMALOUS";
    RowCountOperator["EqualTo"] = "EQUAL_TO";
    RowCountOperator["GreaterThan"] = "GREATER_THAN";
    RowCountOperator["GreaterThanOrEqualTo"] = "GREATER_THAN_OR_EQUAL_TO";
    RowCountOperator["LessThan"] = "LESS_THAN";
    RowCountOperator["LessThanOrEqualTo"] = "LESS_THAN_OR_EQUAL_TO";
})(RowCountOperator || (RowCountOperator = {}));
export var RpAccountSourceEnum;
(function (RpAccountSourceEnum) {
    RpAccountSourceEnum["DradisFunnel"] = "DRADIS_FUNNEL";
    RpAccountSourceEnum["Email"] = "EMAIL";
    RpAccountSourceEnum["Invitation"] = "INVITATION";
    RpAccountSourceEnum["Notification"] = "NOTIFICATION";
})(RpAccountSourceEnum || (RpAccountSourceEnum = {}));
export var RpAccountStatusEnum;
(function (RpAccountStatusEnum) {
    RpAccountStatusEnum["Active"] = "ACTIVE";
    RpAccountStatusEnum["Disabled"] = "DISABLED";
})(RpAccountStatusEnum || (RpAccountStatusEnum = {}));
export var RpAccountTypeAuthEnum;
(function (RpAccountTypeAuthEnum) {
    RpAccountTypeAuthEnum["Any"] = "ANY";
    RpAccountTypeAuthEnum["Employer"] = "EMPLOYER";
    RpAccountTypeAuthEnum["Recruiter"] = "RECRUITER";
})(RpAccountTypeAuthEnum || (RpAccountTypeAuthEnum = {}));
/**
 * Example schema.
 *
 * GraphQL Schema Basics: https://www.apollographql.com/docs/apollo-server/schema/schema/
 * Indeed API Recommendations: https://link.indeed.tech/api-recommendations
 *
 * Need help designing your schema? Check out the schema designer tool: https://graphql-schema-designer.sandbox.indeed.net/
 */
export var RpAccountTypeEnum;
(function (RpAccountTypeEnum) {
    RpAccountTypeEnum["Employer"] = "EMPLOYER";
    RpAccountTypeEnum["Recruiter"] = "RECRUITER";
})(RpAccountTypeEnum || (RpAccountTypeEnum = {}));
export var RpAgencyRecruiterSizeEnum;
(function (RpAgencyRecruiterSizeEnum) {
    RpAgencyRecruiterSizeEnum["Size_1_5"] = "SIZE_1_5";
    RpAgencyRecruiterSizeEnum["Size_6_10"] = "SIZE_6_10";
    RpAgencyRecruiterSizeEnum["Size_11_15"] = "SIZE_11_15";
    RpAgencyRecruiterSizeEnum["Size_16_20"] = "SIZE_16_20";
    RpAgencyRecruiterSizeEnum["Size_20More"] = "SIZE_20_MORE";
})(RpAgencyRecruiterSizeEnum || (RpAgencyRecruiterSizeEnum = {}));
export var RpAttributeTypeEnum;
(function (RpAttributeTypeEnum) {
    RpAttributeTypeEnum["AdvertiserIndustries"] = "ADVERTISER_INDUSTRIES";
    RpAttributeTypeEnum["Cities"] = "CITIES";
    RpAttributeTypeEnum["JobOccupations"] = "JOB_OCCUPATIONS";
})(RpAttributeTypeEnum || (RpAttributeTypeEnum = {}));
export var RpRecruiterRoleEnum;
(function (RpRecruiterRoleEnum) {
    RpRecruiterRoleEnum["AgencyManager"] = "AGENCY_MANAGER";
    RpRecruiterRoleEnum["Recruiter"] = "RECRUITER";
})(RpRecruiterRoleEnum || (RpRecruiterRoleEnum = {}));
export var RpRecruiterStatusEnum;
(function (RpRecruiterStatusEnum) {
    RpRecruiterStatusEnum["Active"] = "ACTIVE";
    RpRecruiterStatusEnum["Removed"] = "REMOVED";
})(RpRecruiterStatusEnum || (RpRecruiterStatusEnum = {}));
/**
 * Which phase of the per-rule cleanup pipeline produced a
 * `RuleCleanupFailureDetail`. Used to distinguish "Nexus was never touched"
 * from "Nexus was updated but we couldn't record the audit".
 */
export var RuleCleanupFailureStage;
(function (RuleCleanupFailureStage) {
    /**
     * `updateRule` succeeded but persisting the `LICENSE_REMOVED` audit event
     * threw afterwards. NWCS state for this rule IS updated; the audit row
     * is missing. Re-running is still safe (the planner's SKIP branch
     * catches "already cleaned" rules) but will not back-fill the missing
     * audit — that must be reconstructed from Nexus' own logs if needed.
     */
    RuleCleanupFailureStage["Audit"] = "AUDIT";
    /**
     * The initial `nexusWorkflowConfig.rules(advertiserId)` query failed
     * for this advertiser, so no rules were processed and NWCS state was not
     * modified. Safe to re-run.
     */
    RuleCleanupFailureStage["Fetch"] = "FETCH";
    /**
     * A per-rule failure before any NWCS write committed for this rule —
     * either the planner could not produce a valid plan for the rule, or
     * the `updateRule` mutation itself failed. NWCS state for this rule was
     * not modified (Nexus would have applied the write atomically or not at
     * all). Safe to re-run for just this rule.
     */
    RuleCleanupFailureStage["Update"] = "UPDATE";
})(RuleCleanupFailureStage || (RuleCleanupFailureStage = {}));
/** Attribute types that we support to sync over SSO */
export var SsoAttributeType;
(function (SsoAttributeType) {
    SsoAttributeType["FirstName"] = "FIRST_NAME";
    SsoAttributeType["LastName"] = "LAST_NAME";
    SsoAttributeType["PhoneNumber"] = "PHONE_NUMBER";
})(SsoAttributeType || (SsoAttributeType = {}));
/** Where the salary data comes from. */
export var SalaryDataSource;
(function (SalaryDataSource) {
    /** @deprecated This value is no longer used and will be removed in a future release. */
    SalaryDataSource["JobSeekerDesires"] = "JOB_SEEKER_DESIRES";
    SalaryDataSource["SalaryEstimationService"] = "SALARY_ESTIMATION_SERVICE";
})(SalaryDataSource || (SalaryDataSource = {}));
/** Type of Data Source salary is derived from. Supported data sources are - SALAGs and SES */
export var SalaryDataSourceType;
(function (SalaryDataSourceType) {
    SalaryDataSourceType["Salags"] = "SALAGS";
    SalaryDataSourceType["Ses"] = "SES";
    SalaryDataSourceType["Unknown"] = "UNKNOWN";
})(SalaryDataSourceType || (SalaryDataSourceType = {}));
/** Value to determine how to group salary information */
export var SalaryGroupBy;
(function (SalaryGroupBy) {
    /** Group by employer key */
    SalaryGroupBy["EmployerKey"] = "EMPLOYER_KEY";
    /** Group by job title */
    SalaryGroupBy["JobTitle"] = "JOB_TITLE";
    /** Group by job location */
    SalaryGroupBy["Location"] = "LOCATION";
})(SalaryGroupBy || (SalaryGroupBy = {}));
/** Variants of the Salary optimization */
export var SalaryOptimizationVariant;
(function (SalaryOptimizationVariant) {
    /** @deprecated No longer supported */
    SalaryOptimizationVariant["SalaryOptimizationVariantCandidatePool"] = "SALARY_OPTIMIZATION_VARIANT_CANDIDATE_POOL";
    SalaryOptimizationVariant["SalaryOptimizationVariantDefault"] = "SALARY_OPTIMIZATION_VARIANT_DEFAULT";
})(SalaryOptimizationVariant || (SalaryOptimizationVariant = {}));
export var SalaryPeriodEnum;
(function (SalaryPeriodEnum) {
    SalaryPeriodEnum["Yearly"] = "YEARLY";
})(SalaryPeriodEnum || (SalaryPeriodEnum = {}));
/** Qualifiers indicating if wage is tipped, farm, etc. */
export var SalaryQualifier;
(function (SalaryQualifier) {
    SalaryQualifier["Tipped"] = "TIPPED";
})(SalaryQualifier || (SalaryQualifier = {}));
/** What category the salary range is */
export var SalaryRangeCategory;
(function (SalaryRangeCategory) {
    SalaryRangeCategory["Competitive"] = "COMPETITIVE";
    SalaryRangeCategory["Default"] = "DEFAULT";
    SalaryRangeCategory["Highlight"] = "HIGHLIGHT";
})(SalaryRangeCategory || (SalaryRangeCategory = {}));
export var SalarySortBy;
(function (SalarySortBy) {
    SalarySortBy["Alphabetical"] = "ALPHABETICAL";
    SalarySortBy["AverageSalary"] = "AVERAGE_SALARY";
    SalarySortBy["Count"] = "COUNT";
})(SalarySortBy || (SalarySortBy = {}));
/** Salary types indicating pay frequency */
export var SalaryType;
(function (SalaryType) {
    /** Biweekly */
    SalaryType["Biweekly"] = "BIWEEKLY";
    /** Daily */
    SalaryType["Daily"] = "DAILY";
    /** Hourly */
    SalaryType["Hourly"] = "HOURLY";
    /** Monthly */
    SalaryType["Monthly"] = "MONTHLY";
    /** Weekly */
    SalaryType["Weekly"] = "WEEKLY";
    /** Yearly */
    SalaryType["Yearly"] = "YEARLY";
})(SalaryType || (SalaryType = {}));
/** Identifies if the given file is a live file or an uploaded file */
export var SapDirectory;
(function (SapDirectory) {
    SapDirectory["Live"] = "LIVE";
    SapDirectory["Upload"] = "UPLOAD";
})(SapDirectory || (SapDirectory = {}));
/** The types of files we collect for the SAP integration */
export var SapFileType;
(function (SapFileType) {
    SapFileType["CandidateProfileTemplate"] = "CANDIDATE_PROFILE_TEMPLATE";
    SapFileType["JobApplicationTemplate"] = "JOB_APPLICATION_TEMPLATE";
    SapFileType["JobApplicationTemplateMapping"] = "JOB_APPLICATION_TEMPLATE_MAPPING";
    SapFileType["JobRequisitionMapping"] = "JOB_REQUISITION_MAPPING";
    SapFileType["JobRequisitionTemplate"] = "JOB_REQUISITION_TEMPLATE";
})(SapFileType || (SapFileType = {}));
/** Identifies the severity of a validation result */
export var SapValidationSeverity;
(function (SapValidationSeverity) {
    SapValidationSeverity["Error"] = "ERROR";
    SapValidationSeverity["Warning"] = "WARNING";
})(SapValidationSeverity || (SapValidationSeverity = {}));
/** Identifies the overall validation status */
export var SapValidationStatus;
(function (SapValidationStatus) {
    SapValidationStatus["Error"] = "ERROR";
    SapValidationStatus["Success"] = "SUCCESS";
    SapValidationStatus["Warning"] = "WARNING";
})(SapValidationStatus || (SapValidationStatus = {}));
/** Statues based upon the save template request made */
export var SaveTalentEngagementTemplatePayloadStatus;
(function (SaveTalentEngagementTemplatePayloadStatus) {
    SaveTalentEngagementTemplatePayloadStatus["Created"] = "CREATED";
    SaveTalentEngagementTemplatePayloadStatus["Updated"] = "UPDATED";
})(SaveTalentEngagementTemplatePayloadStatus || (SaveTalentEngagementTemplatePayloadStatus = {}));
export var SaveUtilizationIssuanceResult;
(function (SaveUtilizationIssuanceResult) {
    /** There is already an issuance recorded for the given inputs */
    SaveUtilizationIssuanceResult["DuplicateIssuance"] = "DUPLICATE_ISSUANCE";
    /** A Non-Retryable Exception occurred saving the issuance. Retrying with the same inputs is considered unrecoverable and will result in a failure */
    SaveUtilizationIssuanceResult["NonRetryableException"] = "NON_RETRYABLE_EXCEPTION";
    /** There are no active entitlements that can receive new issuances */
    SaveUtilizationIssuanceResult["NoActiveEntitlements"] = "NO_ACTIVE_ENTITLEMENTS";
    /** A Retryable Exception occurred saving the issuance. Retry with the same inputs */
    SaveUtilizationIssuanceResult["RetryableException"] = "RETRYABLE_EXCEPTION";
    /** Successfully saved issuance */
    SaveUtilizationIssuanceResult["Success"] = "SUCCESS";
})(SaveUtilizationIssuanceResult || (SaveUtilizationIssuanceResult = {}));
/** The valid flags that a SavedJob can have. */
export var SavedJobFlags;
(function (SavedJobFlags) {
    SavedJobFlags["Archived"] = "ARCHIVED";
    SavedJobFlags["Deleted"] = "DELETED";
    SavedJobFlags["NotInterested"] = "NOT_INTERESTED";
})(SavedJobFlags || (SavedJobFlags = {}));
/**
 * The valid states that a SavedJob can have.
 * Note: savedjobsservice has divergent SavedJobState models due to an incomplete migration.
 *  The update mutation converts the VISITED, INTERVIEWING, and OFFERED values to deprecated values
 *  UNSAVED, INTERVIEW, OFFER for convenience.
 */
export var SavedJobState;
(function (SavedJobState) {
    SavedJobState["Applied"] = "APPLIED";
    SavedJobState["Hired"] = "HIRED";
    /** @deprecated Use INTERVIEWING instead */
    SavedJobState["Interview"] = "INTERVIEW";
    SavedJobState["Interviewing"] = "INTERVIEWING";
    /** @deprecated Use OFFERING instead */
    SavedJobState["Offer"] = "OFFER";
    SavedJobState["Offered"] = "OFFERED";
    SavedJobState["Rejected"] = "REJECTED";
    SavedJobState["Saved"] = "SAVED";
    /** @deprecated Use VISITED instead */
    SavedJobState["Unsaved"] = "UNSAVED";
    SavedJobState["Visited"] = "VISITED";
})(SavedJobState || (SavedJobState = {}));
/** The valid fields and order to sort the saved jobs by. */
export var SavedJobsSort;
(function (SavedJobsSort) {
    SavedJobsSort["ArchiveTimeAsc"] = "ARCHIVE_TIME_ASC";
    SavedJobsSort["ArchiveTimeDesc"] = "ARCHIVE_TIME_DESC";
    SavedJobsSort["JobIdAsc"] = "JOB_ID_ASC";
    SavedJobsSort["JobIdDesc"] = "JOB_ID_DESC";
    SavedJobsSort["LastUpdatedTimeAsc"] = "LAST_UPDATED_TIME_ASC";
    SavedJobsSort["LastUpdatedTimeDesc"] = "LAST_UPDATED_TIME_DESC";
    SavedJobsSort["LifecycleAsc"] = "LIFECYCLE_ASC";
    SavedJobsSort["LifecycleDesc"] = "LIFECYCLE_DESC";
    SavedJobsSort["StateChangedTimeAsc"] = "STATE_CHANGED_TIME_ASC";
    SavedJobsSort["StateChangedTimeDesc"] = "STATE_CHANGED_TIME_DESC";
})(SavedJobsSort || (SavedJobsSort = {}));
/** Variants of the ScalableSegmentation optimization */
export var ScalableSegmentationOptimizationVariant;
(function (ScalableSegmentationOptimizationVariant) {
    /** @deprecated Scalable segment classes optimization is deprecated */
    ScalableSegmentationOptimizationVariant["ScalableSegmentationOptimizationVariantAllClasses"] = "SCALABLE_SEGMENTATION_OPTIMIZATION_VARIANT_ALL_CLASSES";
    /** @deprecated Scalable segment classes optimization is deprecated */
    ScalableSegmentationOptimizationVariant["ScalableSegmentationOptimizationVariantDefault"] = "SCALABLE_SEGMENTATION_OPTIMIZATION_VARIANT_DEFAULT";
})(ScalableSegmentationOptimizationVariant || (ScalableSegmentationOptimizationVariant = {}));
/** Variants of the Schedules optimization */
export var SchedulesOptimizationVariant;
(function (SchedulesOptimizationVariant) {
    SchedulesOptimizationVariant["SchedulesOptimizationVariantDefault"] = "SCHEDULES_OPTIMIZATION_VARIANT_DEFAULT";
})(SchedulesOptimizationVariant || (SchedulesOptimizationVariant = {}));
/** Since unions are not allowed in inputs, this is an enum that maps to the EmployerInterviewEmployerSchedule union in the return object */
export var SchedulingDetailsType;
(function (SchedulingDetailsType) {
    SchedulingDetailsType["EmployerCalendar"] = "EMPLOYER_CALENDAR";
    SchedulingDetailsType["EmployerInterviewProposedTimes"] = "EMPLOYER_INTERVIEW_PROPOSED_TIMES";
    SchedulingDetailsType["SchedulingFormat"] = "SCHEDULING_FORMAT";
})(SchedulingDetailsType || (SchedulingDetailsType = {}));
/** Specifies the start interval that a future appointment can be scheduled on. */
export var SchedulingStartInterval;
(function (SchedulingStartInterval) {
    /** Periods start at any time (e.g. 10:00, 10:01, 10:02, etc). */
    SchedulingStartInterval["Minute_1"] = "MINUTE_1";
    /** Periods start at every 5 minute boundary (e.g. 10:00, 10:05, 10:10, etc). */
    SchedulingStartInterval["Minute_5"] = "MINUTE_5";
    /** Periods start at every 10 minute boundary (e.g. 10:00, 10:10, 10:20, etc). */
    SchedulingStartInterval["Minute_10"] = "MINUTE_10";
    /** Periods start at every 15 minute boundary (e.g. 10:00, 10:15, 10:30, etc). */
    SchedulingStartInterval["Minute_15"] = "MINUTE_15";
    /** Periods start at every 20 minute boundary (e.g. 10:00, 10:20, 10:30, etc). */
    SchedulingStartInterval["Minute_20"] = "MINUTE_20";
    /** Periods start at every 30 minute boundary (e.g. 10:00, 10:30, 11:00, etc). */
    SchedulingStartInterval["Minute_30"] = "MINUTE_30";
    /** Periods start at every hour (e.g. 10:00, 11:00, 12:00, etc). */
    SchedulingStartInterval["Minute_60"] = "MINUTE_60";
})(SchedulingStartInterval || (SchedulingStartInterval = {}));
export var ScoutDeepSourcingCriterionMatchStatus;
(function (ScoutDeepSourcingCriterionMatchStatus) {
    ScoutDeepSourcingCriterionMatchStatus["Met"] = "MET";
    ScoutDeepSourcingCriterionMatchStatus["NotMet"] = "NOT_MET";
    ScoutDeepSourcingCriterionMatchStatus["PartiallyMet"] = "PARTIALLY_MET";
    ScoutDeepSourcingCriterionMatchStatus["Unknown"] = "UNKNOWN";
})(ScoutDeepSourcingCriterionMatchStatus || (ScoutDeepSourcingCriterionMatchStatus = {}));
export var ScoutDeepSourcingMatchLabel;
(function (ScoutDeepSourcingMatchLabel) {
    ScoutDeepSourcingMatchLabel["ModerateMatch"] = "MODERATE_MATCH";
    ScoutDeepSourcingMatchLabel["NoMatch"] = "NO_MATCH";
    ScoutDeepSourcingMatchLabel["StrongMatch"] = "STRONG_MATCH";
    ScoutDeepSourcingMatchLabel["TopMatch"] = "TOP_MATCH";
    ScoutDeepSourcingMatchLabel["WeakMatch"] = "WEAK_MATCH";
})(ScoutDeepSourcingMatchLabel || (ScoutDeepSourcingMatchLabel = {}));
export var ScoutDeepSourcingStatus;
(function (ScoutDeepSourcingStatus) {
    ScoutDeepSourcingStatus["Canceled"] = "CANCELED";
    ScoutDeepSourcingStatus["Done"] = "DONE";
    ScoutDeepSourcingStatus["Failed"] = "FAILED";
    ScoutDeepSourcingStatus["NotFound"] = "NOT_FOUND";
    ScoutDeepSourcingStatus["NotStarted"] = "NOT_STARTED";
    ScoutDeepSourcingStatus["Pending"] = "PENDING";
    ScoutDeepSourcingStatus["Working"] = "WORKING";
})(ScoutDeepSourcingStatus || (ScoutDeepSourcingStatus = {}));
export var ScoutEntityReferenceSource;
(function (ScoutEntityReferenceSource) {
    ScoutEntityReferenceSource["SystemDetermined"] = "SYSTEM_DETERMINED";
    ScoutEntityReferenceSource["UserSpecified"] = "USER_SPECIFIED";
})(ScoutEntityReferenceSource || (ScoutEntityReferenceSource = {}));
export var ScoutFeatureVersion;
(function (ScoutFeatureVersion) {
    ScoutFeatureVersion["V0"] = "V0";
    ScoutFeatureVersion["V1"] = "V1";
    ScoutFeatureVersion["V2"] = "V2";
})(ScoutFeatureVersion || (ScoutFeatureVersion = {}));
export var ScoutLlmFeedbackJiraProjectKey;
(function (ScoutLlmFeedbackJiraProjectKey) {
    ScoutLlmFeedbackJiraProjectKey["Aso"] = "ASO";
    ScoutLlmFeedbackJiraProjectKey["Audpla"] = "AUDPLA";
    ScoutLlmFeedbackJiraProjectKey["Empaiauto"] = "EMPAIAUTO";
    ScoutLlmFeedbackJiraProjectKey["Empscout"] = "EMPSCOUT";
    ScoutLlmFeedbackJiraProjectKey["Empscoutfb"] = "EMPSCOUTFB";
})(ScoutLlmFeedbackJiraProjectKey || (ScoutLlmFeedbackJiraProjectKey = {}));
export var ScoutLlmFeedbackReason;
(function (ScoutLlmFeedbackReason) {
    ScoutLlmFeedbackReason["Negative"] = "NEGATIVE";
    ScoutLlmFeedbackReason["NegativeInaccurate"] = "NEGATIVE_INACCURATE";
    ScoutLlmFeedbackReason["NegativeIrrelevant"] = "NEGATIVE_IRRELEVANT";
    ScoutLlmFeedbackReason["NegativeOther"] = "NEGATIVE_OTHER";
    ScoutLlmFeedbackReason["NegativeToxic"] = "NEGATIVE_TOXIC";
    ScoutLlmFeedbackReason["NegativeUnhelpful"] = "NEGATIVE_UNHELPFUL";
    ScoutLlmFeedbackReason["Positive"] = "POSITIVE";
    ScoutLlmFeedbackReason["PositiveAccurate"] = "POSITIVE_ACCURATE";
    ScoutLlmFeedbackReason["PositiveHelpful"] = "POSITIVE_HELPFUL";
    ScoutLlmFeedbackReason["PositiveOther"] = "POSITIVE_OTHER";
    ScoutLlmFeedbackReason["PositiveRelevant"] = "POSITIVE_RELEVANT";
    ScoutLlmFeedbackReason["PositiveStraightforward"] = "POSITIVE_STRAIGHTFORWARD";
})(ScoutLlmFeedbackReason || (ScoutLlmFeedbackReason = {}));
/** Strength level applied to a job requirement or an existing natural language preference in a match profile */
export var ScoutMatchProfileCriterionStrength;
(function (ScoutMatchProfileCriterionStrength) {
    ScoutMatchProfileCriterionStrength["Preferred"] = "PREFERRED";
    ScoutMatchProfileCriterionStrength["Removed"] = "REMOVED";
    ScoutMatchProfileCriterionStrength["Required"] = "REQUIRED";
})(ScoutMatchProfileCriterionStrength || (ScoutMatchProfileCriterionStrength = {}));
export var ScoutMatchProfileIcon;
(function (ScoutMatchProfileIcon) {
    ScoutMatchProfileIcon["AiIndeedScout"] = "AI_INDEED_SCOUT";
    ScoutMatchProfileIcon["AiJoin"] = "AI_JOIN";
    ScoutMatchProfileIcon["Location"] = "LOCATION";
    ScoutMatchProfileIcon["Work"] = "WORK";
})(ScoutMatchProfileIcon || (ScoutMatchProfileIcon = {}));
export var ScoutMatchSummaryIcon;
(function (ScoutMatchSummaryIcon) {
    ScoutMatchSummaryIcon["AiIconNewReleases"] = "AI_ICON_NEW_RELEASES";
    ScoutMatchSummaryIcon["AiJoin"] = "AI_JOIN";
    ScoutMatchSummaryIcon["Check"] = "CHECK";
    ScoutMatchSummaryIcon["License"] = "LICENSE";
    ScoutMatchSummaryIcon["Location"] = "LOCATION";
    ScoutMatchSummaryIcon["Work"] = "WORK";
})(ScoutMatchSummaryIcon || (ScoutMatchSummaryIcon = {}));
/** Role of the Message. this field may be replaced with intent */
export var ScoutMessageRole;
(function (ScoutMessageRole) {
    ScoutMessageRole["Agent"] = "AGENT";
    ScoutMessageRole["Update"] = "UPDATE";
    ScoutMessageRole["User"] = "USER";
})(ScoutMessageRole || (ScoutMessageRole = {}));
export var ScoutNextBestActionCategory;
(function (ScoutNextBestActionCategory) {
    /** Actions related to job applicants */
    ScoutNextBestActionCategory["Applicants"] = "APPLICANTS";
    /** Actions related to building continuity for returning user */
    ScoutNextBestActionCategory["Buildcontinuity"] = "BUILDCONTINUITY";
    /** Actions related to deep sourcing results containing both prospects and applicants */
    ScoutNextBestActionCategory["DeepSourcing"] = "DEEP_SOURCING";
    /** Actions related to job postings */
    ScoutNextBestActionCategory["Jobs"] = "JOBS";
    /** Actions related to candidate outreach */
    ScoutNextBestActionCategory["Outreachsummary"] = "OUTREACHSUMMARY";
    /** Actions related to potential job candidates */
    ScoutNextBestActionCategory["Prospects"] = "PROSPECTS";
})(ScoutNextBestActionCategory || (ScoutNextBestActionCategory = {}));
export var ScoutNextBestActionPageType;
(function (ScoutNextBestActionPageType) {
    /** Page displaying a single candidate */
    ScoutNextBestActionPageType["Candidate"] = "CANDIDATE";
    /** Page displaying a list of candidates */
    ScoutNextBestActionPageType["CandidatesList"] = "CANDIDATES_LIST";
    /** Page displaying a single job */
    ScoutNextBestActionPageType["Job"] = "JOB";
    /** Page displaying a list of jobs */
    ScoutNextBestActionPageType["JobsList"] = "JOBS_LIST";
})(ScoutNextBestActionPageType || (ScoutNextBestActionPageType = {}));
export var ScoutNextBestActionResponseSurface;
(function (ScoutNextBestActionResponseSurface) {
    /** Response is a type of chat interface */
    ScoutNextBestActionResponseSurface["Chat"] = "CHAT";
    /** Response is a type of workflow */
    ScoutNextBestActionResponseSurface["Workflow"] = "WORKFLOW";
})(ScoutNextBestActionResponseSurface || (ScoutNextBestActionResponseSurface = {}));
export var ScoutNextBestActionStatus;
(function (ScoutNextBestActionStatus) {
    /** Action that has been completed */
    ScoutNextBestActionStatus["Completed"] = "COMPLETED";
    /** Newly created action that hasn't been addressed */
    ScoutNextBestActionStatus["New"] = "NEW";
    /** Action that has been rejected or dismissed */
    ScoutNextBestActionStatus["Rejected"] = "REJECTED";
    /** Action that has been snoozed for later */
    ScoutNextBestActionStatus["Snoozed"] = "SNOOZED";
})(ScoutNextBestActionStatus || (ScoutNextBestActionStatus = {}));
export var ScoutNextBestActionSurfaceName;
(function (ScoutNextBestActionSurfaceName) {
    /** Actions displayed on Scout pop-up button */
    ScoutNextBestActionSurfaceName["AskScout"] = "ASK_SCOUT";
    /** Actions displayed in greeting messages */
    ScoutNextBestActionSurfaceName["Greetings"] = "GREETINGS";
    /** Actions displayed as suggestions */
    ScoutNextBestActionSurfaceName["Suggestions"] = "SUGGESTIONS";
    /** Actions displayed in the task list */
    ScoutNextBestActionSurfaceName["Tasklist"] = "TASKLIST";
})(ScoutNextBestActionSurfaceName || (ScoutNextBestActionSurfaceName = {}));
export var ScoutNextBestActionType;
(function (ScoutNextBestActionType) {
    /** Action to trigger for highlighting top applicants */
    ScoutNextBestActionType["ApplicantCardList"] = "APPLICANT_CARD_LIST";
    /** Action for benefit optimization */
    ScoutNextBestActionType["BenefitOptimization"] = "BENEFIT_OPTIMIZATION";
    /** Action for optimizing job budgets */
    ScoutNextBestActionType["BudgetOptimization"] = "BUDGET_OPTIMIZATION";
    /** Action for reviewing deep sourcing results containing both prospects and applicants */
    ScoutNextBestActionType["DeepSourcingResults"] = "DEEP_SOURCING_RESULTS";
    /** Action for optimizing education requirements */
    ScoutNextBestActionType["EducationOptimization"] = "EDUCATION_OPTIMIZATION";
    /** Action for jobs currently in the interviewing stage */
    ScoutNextBestActionType["Interviewing"] = "INTERVIEWING";
    /** Action for optimizing job descriptions */
    ScoutNextBestActionType["JobDescriptionOptimization"] = "JOB_DESCRIPTION_OPTIMIZATION";
    /** Action for moderating job postings */
    ScoutNextBestActionType["JobModeration"] = "JOB_MODERATION";
    /** Action for reviewing job optimization */
    ScoutNextBestActionType["JobOptimization"] = "JOB_OPTIMIZATION";
    /** Action for reviewing job performance */
    ScoutNextBestActionType["JobPerformance"] = "JOB_PERFORMANCE";
    /** Action for learning more about Talent Scout */
    ScoutNextBestActionType["LearnMore"] = "LEARN_MORE";
    /** Action for reviewing new applicants */
    ScoutNextBestActionType["NewApplicant"] = "NEW_APPLICANT";
    /** Action for summarizing outreach activities */
    ScoutNextBestActionType["OutreachSummary"] = "OUTREACH_SUMMARY";
    /** Action for reviewing top prospects */
    ScoutNextBestActionType["ProspectCardList"] = "PROSPECT_CARD_LIST";
    /** Action for viewing job performance metrics */
    ScoutNextBestActionType["SalaryOptimization"] = "SALARY_OPTIMIZATION";
    /** Action for jobs currently in the screening stage */
    ScoutNextBestActionType["Screening"] = "SCREENING";
    /** Action for optimizing job descriptions */
    ScoutNextBestActionType["SkillOptimization"] = "SKILL_OPTIMIZATION";
    /** Action for jobs currently in the sourcing stage */
    ScoutNextBestActionType["Sourcing"] = "SOURCING";
    /** Action for optimizing job titles */
    ScoutNextBestActionType["TitleOptimization"] = "TITLE_OPTIMIZATION";
})(ScoutNextBestActionType || (ScoutNextBestActionType = {}));
/** Semantic page focus indicating what type of page the user is on. */
export var ScoutPageFocus;
(function (ScoutPageFocus) {
    ScoutPageFocus["Account"] = "ACCOUNT";
    ScoutPageFocus["Analytics"] = "ANALYTICS";
    ScoutPageFocus["Billing"] = "BILLING";
    ScoutPageFocus["CustomerSupport"] = "CUSTOMER_SUPPORT";
    ScoutPageFocus["JobManagement"] = "JOB_MANAGEMENT";
    ScoutPageFocus["JobSourcing"] = "JOB_SOURCING";
    ScoutPageFocus["JobView"] = "JOB_VIEW";
    ScoutPageFocus["Login"] = "LOGIN";
    ScoutPageFocus["Projects"] = "PROJECTS";
    ScoutPageFocus["Sourcing"] = "SOURCING";
})(ScoutPageFocus || (ScoutPageFocus = {}));
/** Discriminates how a progress update's `content` should be interpreted by the client. */
export var ScoutProgressMessageKind;
(function (ScoutProgressMessageKind) {
    /**
     * `content` is an orchestrator-generated literal string and should be rendered verbatim,
     * rather than mapped through the client's known progress-message enum.
     */
    ScoutProgressMessageKind["LiteralValue"] = "LITERAL_VALUE";
})(ScoutProgressMessageKind || (ScoutProgressMessageKind = {}));
export var ScoutSelectableGraph;
(function (ScoutSelectableGraph) {
    /** Agentforce Account graph configuration for users bypassing AFSRA risk assessment */
    ScoutSelectableGraph["AgentforceAccount"] = "AGENTFORCE_ACCOUNT";
    /** AI Sourcing / General Match Criteria Edit graph configuration */
    ScoutSelectableGraph["EditingMatchCriteria"] = "EDITING_MATCH_CRITERIA";
    /** AI Screening Match Criteria Edit graph configuration */
    ScoutSelectableGraph["EditingScreeningCriteria"] = "EDITING_SCREENING_CRITERIA";
    /** Baseline Graph */
    ScoutSelectableGraph["Standard"] = "STANDARD";
})(ScoutSelectableGraph || (ScoutSelectableGraph = {}));
/** Scout status. Aligned with escargot ContactStatus */
export var ScoutStatus;
(function (ScoutStatus) {
    ScoutStatus["Created"] = "CREATED";
    ScoutStatus["Declined"] = "DECLINED";
    ScoutStatus["Initiated"] = "INITIATED";
    ScoutStatus["Interested"] = "INTERESTED";
    ScoutStatus["Replied"] = "REPLIED";
    ScoutStatus["Sent"] = "SENT";
    ScoutStatus["Unknown"] = "UNKNOWN";
})(ScoutStatus || (ScoutStatus = {}));
export var ScreenerQuestionContextQuestionFormat;
(function (ScreenerQuestionContextQuestionFormat) {
    ScreenerQuestionContextQuestionFormat["Currency"] = "CURRENCY";
    ScreenerQuestionContextQuestionFormat["Decimal"] = "DECIMAL";
    ScreenerQuestionContextQuestionFormat["Integer"] = "INTEGER";
    ScreenerQuestionContextQuestionFormat["None"] = "NONE";
    ScreenerQuestionContextQuestionFormat["NumericText"] = "NUMERIC_TEXT";
    ScreenerQuestionContextQuestionFormat["Phone"] = "PHONE";
    ScreenerQuestionContextQuestionFormat["Text"] = "TEXT";
})(ScreenerQuestionContextQuestionFormat || (ScreenerQuestionContextQuestionFormat = {}));
/** Input types for screener questions */
export var ScreenerQuestionInputType;
(function (ScreenerQuestionInputType) {
    /**
     * An input that accepts integers. In Nigma/Indeed Apply, this is represented using a text box with an added
     * constraint that only number values can be input.
     */
    ScreenerQuestionInputType["Integer"] = "INTEGER";
    /** Corresponds to a list of choices. The user should select one or more of the choices. */
    ScreenerQuestionInputType["MultiSelect"] = "MULTI_SELECT";
    /** Corresponds to a list of choices. The user should select exactly one of the choices. */
    ScreenerQuestionInputType["SingleSelect"] = "SINGLE_SELECT";
    /** Corresponds to a free-form text input. */
    ScreenerQuestionInputType["Text"] = "TEXT";
    /** Corresponds to a large free-form text input. */
    ScreenerQuestionInputType["TextArea"] = "TEXT_AREA";
    ScreenerQuestionInputType["Unknown"] = "UNKNOWN";
})(ScreenerQuestionInputType || (ScreenerQuestionInputType = {}));
/** Autocomplete dictionary input type */
export var ScreenerQuestionTextInputAutocompleteDictionary;
(function (ScreenerQuestionTextInputAutocompleteDictionary) {
    ScreenerQuestionTextInputAutocompleteDictionary["Certifications"] = "CERTIFICATIONS";
    ScreenerQuestionTextInputAutocompleteDictionary["Languages"] = "LANGUAGES";
    ScreenerQuestionTextInputAutocompleteDictionary["Skills"] = "SKILLS";
    ScreenerQuestionTextInputAutocompleteDictionary["Unknown"] = "UNKNOWN";
})(ScreenerQuestionTextInputAutocompleteDictionary || (ScreenerQuestionTextInputAutocompleteDictionary = {}));
/** Step types supported by Evaluate workflows */
export var ScreenerQuestionType;
(function (ScreenerQuestionType) {
    ScreenerQuestionType["Checkbox"] = "CHECKBOX";
    ScreenerQuestionType["Input"] = "INPUT";
    ScreenerQuestionType["Radio"] = "RADIO";
    ScreenerQuestionType["Select"] = "SELECT";
    ScreenerQuestionType["Usstates"] = "USSTATES";
    ScreenerQuestionType["Yesno"] = "YESNO";
})(ScreenerQuestionType || (ScreenerQuestionType = {}));
export var ScreeningResultStatus;
(function (ScreeningResultStatus) {
    ScreeningResultStatus["Failure"] = "FAILURE";
    ScreeningResultStatus["Incomplete"] = "INCOMPLETE";
    ScreeningResultStatus["ScreeningNotConfigured"] = "SCREENING_NOT_CONFIGURED";
    ScreeningResultStatus["Success"] = "SUCCESS";
    ScreeningResultStatus["Unknown"] = "UNKNOWN";
})(ScreeningResultStatus || (ScreeningResultStatus = {}));
/**
 * Visual background style for sections.
 * Determines the background color and visual treatment of the section.
 */
export var SectionBackgroundStyle;
(function (SectionBackgroundStyle) {
    /**
     * Neutral style with no background (default).
     * Section blends with the main screen background.
     */
    SectionBackgroundStyle["Neutral"] = "NEUTRAL";
    /**
     * Neutral style with filled background.
     * Section displays with a grey/subtle background color for visual separation.
     */
    SectionBackgroundStyle["NeutralFill"] = "NEUTRAL_FILL";
})(SectionBackgroundStyle || (SectionBackgroundStyle = {}));
export var SectionType;
(function (SectionType) {
    SectionType["Certifications"] = "CERTIFICATIONS";
    SectionType["Collections"] = "COLLECTIONS";
    SectionType["ContactInfo"] = "CONTACT_INFO";
    SectionType["Education"] = "EDUCATION";
    SectionType["Skills"] = "SKILLS";
    SectionType["Summary"] = "SUMMARY";
    SectionType["WorkExp"] = "WORK_EXP";
})(SectionType || (SectionType = {}));
/** Segment of the employer */
export var Segment;
(function (Segment) {
    Segment["L"] = "L";
    Segment["M"] = "M";
    Segment["S"] = "S";
    Segment["Xl"] = "XL";
})(Segment || (Segment = {}));
/** Concept types for attributes, occupations, and custom classes */
export var SegmentationConceptType;
(function (SegmentationConceptType) {
    SegmentationConceptType["Attribute"] = "ATTRIBUTE";
    SegmentationConceptType["CustomClass"] = "CUSTOM_CLASS";
    SegmentationConceptType["Occupation"] = "OCCUPATION";
})(SegmentationConceptType || (SegmentationConceptType = {}));
/**
 * Crowtaxo Question Types to render and collect
 * data for a question
 */
export var SegmentationCrowtaxoQuestionType;
(function (SegmentationCrowtaxoQuestionType) {
    SegmentationCrowtaxoQuestionType["Multiselect"] = "MULTISELECT";
    SegmentationCrowtaxoQuestionType["Select"] = "SELECT";
})(SegmentationCrowtaxoQuestionType || (SegmentationCrowtaxoQuestionType = {}));
/** Identifier for the query parameter for each attribute filter on the mobile and desktop SERP */
export var SegmentationFilterQueryParameter;
(function (SegmentationFilterQueryParameter) {
    SegmentationFilterQueryParameter["Taxo_1"] = "TAXO_1";
    SegmentationFilterQueryParameter["Taxo_2"] = "TAXO_2";
    SegmentationFilterQueryParameter["Taxo_3"] = "TAXO_3";
    SegmentationFilterQueryParameter["Taxo_4"] = "TAXO_4";
})(SegmentationFilterQueryParameter || (SegmentationFilterQueryParameter = {}));
/** Taxonomy class types for which a filter dropdown can be configured */
export var SegmentationFilterRefineByType;
(function (SegmentationFilterRefineByType) {
    SegmentationFilterRefineByType["Attribute"] = "ATTRIBUTE";
    SegmentationFilterRefineByType["CompanySectors"] = "COMPANY_SECTORS";
    SegmentationFilterRefineByType["Occupation"] = "OCCUPATION";
})(SegmentationFilterRefineByType || (SegmentationFilterRefineByType = {}));
/** Salary types for which a salary pay period can be configured */
export var SegmentationSalaryType;
(function (SegmentationSalaryType) {
    SegmentationSalaryType["Biweekly"] = "BIWEEKLY";
    SegmentationSalaryType["Daily"] = "DAILY";
    SegmentationSalaryType["Gig"] = "GIG";
    SegmentationSalaryType["Hourly"] = "HOURLY";
    SegmentationSalaryType["Monthly"] = "MONTHLY";
    SegmentationSalaryType["None"] = "NONE";
    SegmentationSalaryType["Quarterly"] = "QUARTERLY";
    SegmentationSalaryType["Semiannually"] = "SEMIANNUALLY";
    SegmentationSalaryType["Weekly"] = "WEEKLY";
    SegmentationSalaryType["Yearly"] = "YEARLY";
})(SegmentationSalaryType || (SegmentationSalaryType = {}));
/** Available keys for sections of Segmented Job Description. */
export var SegmentedSectionKey;
(function (SegmentedSectionKey) {
    SegmentedSectionKey["Benefits"] = "BENEFITS";
    SegmentedSectionKey["CommuteInfo"] = "COMMUTE_INFO";
    SegmentedSectionKey["EmployerMessage"] = "EMPLOYER_MESSAGE";
    SegmentedSectionKey["Holidays"] = "HOLIDAYS";
    SegmentedSectionKey["JobDescription"] = "JOB_DESCRIPTION";
    SegmentedSectionKey["Other"] = "OTHER";
    SegmentedSectionKey["Pay"] = "PAY";
    SegmentedSectionKey["Qualification"] = "QUALIFICATION";
    SegmentedSectionKey["Shift"] = "SHIFT";
    SegmentedSectionKey["WorkLocation"] = "WORK_LOCATION";
})(SegmentedSectionKey || (SegmentedSectionKey = {}));
export var SelectedResumeType;
(function (SelectedResumeType) {
    SelectedResumeType["IndeedResume"] = "INDEED_RESUME";
    SelectedResumeType["SavedFileResume"] = "SAVED_FILE_RESUME";
})(SelectedResumeType || (SelectedResumeType = {}));
export var Sentiment;
(function (Sentiment) {
    Sentiment["Negative"] = "NEGATIVE";
    Sentiment["Positive"] = "POSITIVE";
    Sentiment["Unknown"] = "UNKNOWN";
    Sentiment["UnknownSentiment"] = "UNKNOWN_SENTIMENT";
})(Sentiment || (Sentiment = {}));
export var SerializedSearchFilterMatch;
(function (SerializedSearchFilterMatch) {
    SerializedSearchFilterMatch["Must"] = "MUST";
    SerializedSearchFilterMatch["MustNot"] = "MUST_NOT";
})(SerializedSearchFilterMatch || (SerializedSearchFilterMatch = {}));
export var SerializedSearchFilterMatchType;
(function (SerializedSearchFilterMatchType) {
    SerializedSearchFilterMatchType["Any"] = "ANY";
    /** If the field has multiple keys, all keys must match */
    SerializedSearchFilterMatchType["Exact"] = "EXACT";
})(SerializedSearchFilterMatchType || (SerializedSearchFilterMatchType = {}));
export var SerializedSearchFilterOperation;
(function (SerializedSearchFilterOperation) {
    SerializedSearchFilterOperation["And"] = "AND";
    SerializedSearchFilterOperation["Or"] = "OR";
})(SerializedSearchFilterOperation || (SerializedSearchFilterOperation = {}));
export var SerializedSearchSalaryType;
(function (SerializedSearchSalaryType) {
    SerializedSearchSalaryType["Biweekly"] = "BIWEEKLY";
    SerializedSearchSalaryType["Daily"] = "DAILY";
    SerializedSearchSalaryType["Gig"] = "GIG";
    SerializedSearchSalaryType["Hourly"] = "HOURLY";
    SerializedSearchSalaryType["Monthly"] = "MONTHLY";
    SerializedSearchSalaryType["None"] = "NONE";
    SerializedSearchSalaryType["Quarterly"] = "QUARTERLY";
    SerializedSearchSalaryType["Semianually"] = "SEMIANUALLY";
    SerializedSearchSalaryType["Weekly"] = "WEEKLY";
    SerializedSearchSalaryType["Yearly"] = "YEARLY";
})(SerializedSearchSalaryType || (SerializedSearchSalaryType = {}));
/** IDs for available app services. */
export var ServiceIds;
(function (ServiceIds) {
    ServiceIds["ApiApplyWithIndeed"] = "API_APPLY_WITH_INDEED";
    ServiceIds["ApiCandidateSyncInbound"] = "API_CANDIDATE_SYNC_INBOUND";
    ServiceIds["ApiCandidateSyncOutbound"] = "API_CANDIDATE_SYNC_OUTBOUND";
    ServiceIds["ApiCandidateSyncOutboundSmartScreening"] = "API_CANDIDATE_SYNC_OUTBOUND_SMART_SCREENING";
    ServiceIds["ApiCompanyData"] = "API_COMPANY_DATA";
    ServiceIds["ApiDispositionSync"] = "API_DISPOSITION_SYNC";
    ServiceIds["ApiIndeedInterview"] = "API_INDEED_INTERVIEW";
    ServiceIds["ApiJobPostingMultiSource"] = "API_JOB_POSTING_MULTI_SOURCE";
    ServiceIds["ApiJobPostingSingleSource"] = "API_JOB_POSTING_SINGLE_SOURCE";
    ServiceIds["ApiJobUpdate"] = "API_JOB_UPDATE";
    ServiceIds["ApiMultiChannelMessaging"] = "API_MULTI_CHANNEL_MESSAGING";
    ServiceIds["ApiSponsorship"] = "API_SPONSORSHIP";
    ServiceIds["ApiTbaDisposition"] = "API_TBA_DISPOSITION";
    ServiceIds["JobSponsorshipPlugin"] = "JOB_SPONSORSHIP_PLUGIN";
    ServiceIds["JobVisibilityPlugin"] = "JOB_VISIBILITY_PLUGIN";
    ServiceIds["XmlJobPostingMultiSource"] = "XML_JOB_POSTING_MULTI_SOURCE";
    ServiceIds["XmlJobPostingSingleSource"] = "XML_JOB_POSTING_SINGLE_SOURCE";
})(ServiceIds || (ServiceIds = {}));
/** Product or surface that requests a shadow apply link (extensible enum). */
export var ShadowApplyProduct;
(function (ShadowApplyProduct) {
    /** AI Sourcing and related surfaces. */
    ShadowApplyProduct["AiSourcing"] = "AI_SOURCING";
})(ShadowApplyProduct || (ShadowApplyProduct = {}));
export var ShardFrequency;
(function (ShardFrequency) {
    ShardFrequency["Auto"] = "AUTO";
    ShardFrequency["Daily"] = "DAILY";
    ShardFrequency["Hourly"] = "HOURLY";
    ShardFrequency["Monthly"] = "MONTHLY";
    ShardFrequency["Yearly"] = "YEARLY";
})(ShardFrequency || (ShardFrequency = {}));
/** Shard size options for data assets */
export var ShardSize;
(function (ShardSize) {
    ShardSize["Day"] = "DAY";
    ShardSize["Hour"] = "HOUR";
    ShardSize["Month"] = "MONTH";
    ShardSize["Other"] = "OTHER";
    ShardSize["Week"] = "WEEK";
})(ShardSize || (ShardSize = {}));
/** Enumeration for visible fields in the CSV report */
export var ShareInvoicesField;
(function (ShareInvoicesField) {
    ShareInvoicesField["AdjustmentAmount"] = "ADJUSTMENT_AMOUNT";
    ShareInvoicesField["CompanyName"] = "COMPANY_NAME";
    ShareInvoicesField["Currency"] = "CURRENCY";
    ShareInvoicesField["DealId"] = "DEAL_ID";
    ShareInvoicesField["DiscountAmount"] = "DISCOUNT_AMOUNT";
    ShareInvoicesField["DiscountRate"] = "DISCOUNT_RATE";
    ShareInvoicesField["DueDate"] = "DUE_DATE";
    ShareInvoicesField["EmployerId"] = "EMPLOYER_ID";
    ShareInvoicesField["InvoiceAmount"] = "INVOICE_AMOUNT";
    ShareInvoicesField["InvoiceDate"] = "INVOICE_DATE";
    ShareInvoicesField["InvoiceNumber"] = "INVOICE_NUMBER";
    ShareInvoicesField["IoNumber"] = "IO_NUMBER";
    ShareInvoicesField["OwnerEmail"] = "OWNER_EMAIL";
    ShareInvoicesField["PaymentStatus"] = "PAYMENT_STATUS";
    ShareInvoicesField["PoNumber"] = "PO_NUMBER";
    ShareInvoicesField["ProductName"] = "PRODUCT_NAME";
    ShareInvoicesField["PromotionAmount"] = "PROMOTION_AMOUNT";
    ShareInvoicesField["ServiceAmount"] = "SERVICE_AMOUNT";
    ShareInvoicesField["TaxAmount"] = "TAX_AMOUNT";
})(ShareInvoicesField || (ShareInvoicesField = {}));
/** Enumeration for sorting the invoices dataset when sharing */
export var ShareInvoicesSort;
(function (ShareInvoicesSort) {
    ShareInvoicesSort["AdjustmentAmountAsc"] = "ADJUSTMENT_AMOUNT_ASC";
    ShareInvoicesSort["AdjustmentAmountDesc"] = "ADJUSTMENT_AMOUNT_DESC";
    ShareInvoicesSort["AmountAsc"] = "AMOUNT_ASC";
    ShareInvoicesSort["AmountDesc"] = "AMOUNT_DESC";
    ShareInvoicesSort["CompanyNameAsc"] = "COMPANY_NAME_ASC";
    ShareInvoicesSort["CompanyNameDesc"] = "COMPANY_NAME_DESC";
    ShareInvoicesSort["CurrencyAsc"] = "CURRENCY_ASC";
    ShareInvoicesSort["CurrencyDesc"] = "CURRENCY_DESC";
    ShareInvoicesSort["DiscountAmountAsc"] = "DISCOUNT_AMOUNT_ASC";
    ShareInvoicesSort["DiscountAmountDesc"] = "DISCOUNT_AMOUNT_DESC";
    ShareInvoicesSort["DiscountRateAsc"] = "DISCOUNT_RATE_ASC";
    ShareInvoicesSort["DiscountRateDesc"] = "DISCOUNT_RATE_DESC";
    ShareInvoicesSort["DueDateAsc"] = "DUE_DATE_ASC";
    ShareInvoicesSort["DueDateDesc"] = "DUE_DATE_DESC";
    ShareInvoicesSort["EmployerIdAsc"] = "EMPLOYER_ID_ASC";
    ShareInvoicesSort["EmployerIdDesc"] = "EMPLOYER_ID_DESC";
    ShareInvoicesSort["InvoiceDateAsc"] = "INVOICE_DATE_ASC";
    ShareInvoicesSort["InvoiceDateDesc"] = "INVOICE_DATE_DESC";
    ShareInvoicesSort["InvoiceNumberAsc"] = "INVOICE_NUMBER_ASC";
    ShareInvoicesSort["InvoiceNumberDesc"] = "INVOICE_NUMBER_DESC";
    ShareInvoicesSort["IoNumberAsc"] = "IO_NUMBER_ASC";
    ShareInvoicesSort["IoNumberDesc"] = "IO_NUMBER_DESC";
    ShareInvoicesSort["OwnerEmailAsc"] = "OWNER_EMAIL_ASC";
    ShareInvoicesSort["OwnerEmailDesc"] = "OWNER_EMAIL_DESC";
    ShareInvoicesSort["PaymentStatusAsc"] = "PAYMENT_STATUS_ASC";
    ShareInvoicesSort["PaymentStatusDesc"] = "PAYMENT_STATUS_DESC";
    ShareInvoicesSort["PoNumberAsc"] = "PO_NUMBER_ASC";
    ShareInvoicesSort["PoNumberDesc"] = "PO_NUMBER_DESC";
    ShareInvoicesSort["ProductNameAsc"] = "PRODUCT_NAME_ASC";
    ShareInvoicesSort["ProductNameDesc"] = "PRODUCT_NAME_DESC";
    ShareInvoicesSort["PromotionAmountAsc"] = "PROMOTION_AMOUNT_ASC";
    ShareInvoicesSort["PromotionAmountDesc"] = "PROMOTION_AMOUNT_DESC";
    ShareInvoicesSort["ServiceAmountAsc"] = "SERVICE_AMOUNT_ASC";
    ShareInvoicesSort["ServiceAmountDesc"] = "SERVICE_AMOUNT_DESC";
    ShareInvoicesSort["TaxAmountAsc"] = "TAX_AMOUNT_ASC";
    ShareInvoicesSort["TaxAmountDesc"] = "TAX_AMOUNT_DESC";
})(ShareInvoicesSort || (ShareInvoicesSort = {}));
/** Defines the type of contact limit */
export var SharedContactAccessLevel;
(function (SharedContactAccessLevel) {
    SharedContactAccessLevel["Disabled"] = "DISABLED";
    SharedContactAccessLevel["Limited"] = "LIMITED";
    SharedContactAccessLevel["Unlimited"] = "UNLIMITED";
})(SharedContactAccessLevel || (SharedContactAccessLevel = {}));
export var ShowHostedJobsStatus;
(function (ShowHostedJobsStatus) {
    ShowHostedJobsStatus["Disabled"] = "DISABLED";
    ShowHostedJobsStatus["Enabled"] = "ENABLED";
    ShowHostedJobsStatus["LimitedImpact"] = "LIMITED_IMPACT";
    ShowHostedJobsStatus["MoreInformationRequired"] = "MORE_INFORMATION_REQUIRED";
    ShowHostedJobsStatus["Pending"] = "PENDING";
    ShowHostedJobsStatus["Rejected"] = "REJECTED";
    ShowHostedJobsStatus["Verified"] = "VERIFIED";
    ShowHostedJobsStatus["VerifiedSpononly"] = "VERIFIED_SPONONLY";
})(ShowHostedJobsStatus || (ShowHostedJobsStatus = {}));
export var SignupContext;
(function (SignupContext) {
    SignupContext["AtsPartner"] = "ATS_PARTNER";
    SignupContext["Dradis"] = "DRADIS";
    SignupContext["HostedJobsOpenSignup"] = "HOSTED_JOBS_OPEN_SIGNUP";
    SignupContext["OysterApi"] = "OYSTER_API";
    SignupContext["PartnerIframe"] = "PARTNER_IFRAME";
    SignupContext["PartnerSsoIframe"] = "PARTNER_SSO_IFRAME";
    SignupContext["PartnerTool"] = "PARTNER_TOOL";
    SignupContext["Prime"] = "PRIME";
    SignupContext["Promotional"] = "PROMOTIONAL";
    SignupContext["ResumeSearch"] = "RESUME_SEARCH";
    SignupContext["ResumeSearchOtr"] = "RESUME_SEARCH_OTR";
    SignupContext["UnknownSignupContext"] = "UNKNOWN_SIGNUP_CONTEXT";
})(SignupContext || (SignupContext = {}));
/** The sponsorship plan a budget quote applies to. */
export var SjiCampaignSponsorshipPlan;
(function (SjiCampaignSponsorshipPlan) {
    SjiCampaignSponsorshipPlan["Premium"] = "PREMIUM";
    SjiCampaignSponsorshipPlan["Standard"] = "STANDARD";
})(SjiCampaignSponsorshipPlan || (SjiCampaignSponsorshipPlan = {}));
export var SjiEmailSubscriptionType;
(function (SjiEmailSubscriptionType) {
    SjiEmailSubscriptionType["MonthlyAdvertiserEmail"] = "MONTHLY_ADVERTISER_EMAIL";
})(SjiEmailSubscriptionType || (SjiEmailSubscriptionType = {}));
export var SjiStatsTimeGranularity;
(function (SjiStatsTimeGranularity) {
    SjiStatsTimeGranularity["Aggregated"] = "AGGREGATED";
    SjiStatsTimeGranularity["Daily"] = "DAILY";
})(SjiStatsTimeGranularity || (SjiStatsTimeGranularity = {}));
/** Variants of the SkillExperience optimization */
export var SkillExperienceOptimizationVariant;
(function (SkillExperienceOptimizationVariant) {
    SkillExperienceOptimizationVariant["SkillExperienceOptimizationVariantDefault"] = "SKILL_EXPERIENCE_OPTIMIZATION_VARIANT_DEFAULT";
})(SkillExperienceOptimizationVariant || (SkillExperienceOptimizationVariant = {}));
/** Variants of the SkillRequirement optimization */
export var SkillRequirementOptimizationVariant;
(function (SkillRequirementOptimizationVariant) {
    SkillRequirementOptimizationVariant["SkillRequirementOptimizationJocomoScoreGated"] = "SKILL_REQUIREMENT_OPTIMIZATION_JOCOMO_SCORE_GATED";
    SkillRequirementOptimizationVariant["SkillRequirementOptimizationVariantDefault"] = "SKILL_REQUIREMENT_OPTIMIZATION_VARIANT_DEFAULT";
})(SkillRequirementOptimizationVariant || (SkillRequirementOptimizationVariant = {}));
/** Reasons why an entity may be skipped during an upsert operation */
export var SkipReason;
(function (SkipReason) {
    /** Entity is not eligible for AutoInvite (e.g., job is closed, sponsored, or already in use) */
    SkipReason["Ineligible"] = "INELIGIBLE";
    /** No message configuration exists or was provided in the input */
    SkipReason["MissingMessageConfig"] = "MISSING_MESSAGE_CONFIG";
    /** Configuration is not owned by the current user's account */
    SkipReason["NotOwned"] = "NOT_OWNED";
    /** Has a pending manual review batch that hasn't timed out */
    SkipReason["PendingManualReview"] = "PENDING_MANUAL_REVIEW";
    /** Configuration has not been initialized (never queued for outreach) */
    SkipReason["Uninitialized"] = "UNINITIALIZED";
})(SkipReason || (SkipReason = {}));
export var SkipType;
(function (SkipType) {
    /** Auto skip */
    SkipType["Auto"] = "AUTO";
    /** Manual skip */
    SkipType["Manual"] = "MANUAL";
})(SkipType || (SkipType = {}));
export var SmartApplyApplicationStateDemographicQuestionDataType;
(function (SmartApplyApplicationStateDemographicQuestionDataType) {
    SmartApplyApplicationStateDemographicQuestionDataType["Decimal"] = "DECIMAL";
    SmartApplyApplicationStateDemographicQuestionDataType["Integer"] = "INTEGER";
    SmartApplyApplicationStateDemographicQuestionDataType["NumericText"] = "NUMERIC_TEXT";
    SmartApplyApplicationStateDemographicQuestionDataType["Text"] = "TEXT";
})(SmartApplyApplicationStateDemographicQuestionDataType || (SmartApplyApplicationStateDemographicQuestionDataType = {}));
export var SmartApplyApplicationStateDemographicQuestionFontSize;
(function (SmartApplyApplicationStateDemographicQuestionFontSize) {
    SmartApplyApplicationStateDemographicQuestionFontSize["Large"] = "LARGE";
    SmartApplyApplicationStateDemographicQuestionFontSize["Medium"] = "MEDIUM";
    SmartApplyApplicationStateDemographicQuestionFontSize["Small"] = "SMALL";
})(SmartApplyApplicationStateDemographicQuestionFontSize || (SmartApplyApplicationStateDemographicQuestionFontSize = {}));
export var SmartApplyApplicationStateDemographicQuestionRequirement;
(function (SmartApplyApplicationStateDemographicQuestionRequirement) {
    SmartApplyApplicationStateDemographicQuestionRequirement["Optional"] = "OPTIONAL";
    SmartApplyApplicationStateDemographicQuestionRequirement["Required"] = "REQUIRED";
})(SmartApplyApplicationStateDemographicQuestionRequirement || (SmartApplyApplicationStateDemographicQuestionRequirement = {}));
export var SmartApplyScreenerQuestionType;
(function (SmartApplyScreenerQuestionType) {
    SmartApplyScreenerQuestionType["Date"] = "DATE";
    SmartApplyScreenerQuestionType["File"] = "FILE";
    SmartApplyScreenerQuestionType["Hierarchical"] = "HIERARCHICAL";
    SmartApplyScreenerQuestionType["Information"] = "INFORMATION";
    SmartApplyScreenerQuestionType["Multifield"] = "MULTIFIELD";
    SmartApplyScreenerQuestionType["Multiselect"] = "MULTISELECT";
    SmartApplyScreenerQuestionType["Pagebreak"] = "PAGEBREAK";
    SmartApplyScreenerQuestionType["Select"] = "SELECT";
    SmartApplyScreenerQuestionType["Text"] = "TEXT";
    SmartApplyScreenerQuestionType["Textarea"] = "TEXTAREA";
})(SmartApplyScreenerQuestionType || (SmartApplyScreenerQuestionType = {}));
/** Represents the consent status for Smart Screening Terms & Conditions. */
export var SmartScreeningTocConsentStatus;
(function (SmartScreeningTocConsentStatus) {
    /** Employer has denied consent */
    SmartScreeningTocConsentStatus["Denied"] = "DENIED";
    /** Employer has granted consent */
    SmartScreeningTocConsentStatus["Granted"] = "GRANTED";
    /** Consent status is not specified */
    SmartScreeningTocConsentStatus["Unspecified"] = "UNSPECIFIED";
})(SmartScreeningTocConsentStatus || (SmartScreeningTocConsentStatus = {}));
/** Possible privilege values */
export var SocialImpactAdminPrivilege;
(function (SocialImpactAdminPrivilege) {
    SocialImpactAdminPrivilege["ModifyAll"] = "MODIFY_ALL";
    SocialImpactAdminPrivilege["ModifyInternal"] = "MODIFY_INTERNAL";
    SocialImpactAdminPrivilege["ViewAll"] = "VIEW_ALL";
    SocialImpactAdminPrivilege["ViewData"] = "VIEW_DATA";
    SocialImpactAdminPrivilege["ViewInternal"] = "VIEW_INTERNAL";
})(SocialImpactAdminPrivilege || (SocialImpactAdminPrivilege = {}));
/** List of currently accepted types of jobseeker events */
export var SocialImpactJobseekerEventType;
(function (SocialImpactJobseekerEventType) {
    SocialImpactJobseekerEventType["FoundAJob"] = "FOUND_A_JOB";
})(SocialImpactJobseekerEventType || (SocialImpactJobseekerEventType = {}));
/** Sort Direction options */
export var SocialImpactPartnersReportSortOrder;
(function (SocialImpactPartnersReportSortOrder) {
    SocialImpactPartnersReportSortOrder["Asc"] = "ASC";
    SocialImpactPartnersReportSortOrder["Desc"] = "DESC";
})(SocialImpactPartnersReportSortOrder || (SocialImpactPartnersReportSortOrder = {}));
/** Possible role values */
export var SocialImpactRoleName;
(function (SocialImpactRoleName) {
    SocialImpactRoleName["Admin"] = "admin";
    SocialImpactRoleName["AdminNoData"] = "adminNoData";
    SocialImpactRoleName["View"] = "view";
    SocialImpactRoleName["ViewData"] = "viewData";
})(SocialImpactRoleName || (SocialImpactRoleName = {}));
/** Enum of different status that partners and courses can be in */
export var SocialImpactStatus;
(function (SocialImpactStatus) {
    SocialImpactStatus["Disabled"] = "DISABLED";
    SocialImpactStatus["InReview"] = "IN_REVIEW";
    SocialImpactStatus["Published"] = "PUBLISHED";
})(SocialImpactStatus || (SocialImpactStatus = {}));
/** ASC or DESC enum for generic sorting */
export var Sort;
(function (Sort) {
    Sort["Asc"] = "ASC";
    Sort["Desc"] = "DESC";
})(Sort || (Sort = {}));
/** Popularity enum */
export var SortByOptions;
(function (SortByOptions) {
    SortByOptions["Alphabetical"] = "ALPHABETICAL";
    SortByOptions["Popularity"] = "POPULARITY";
})(SortByOptions || (SortByOptions = {}));
/** Sort direction */
export var SortDirection;
(function (SortDirection) {
    /** Sort in ascending order. */
    SortDirection["Asc"] = "ASC";
    /** Sort in descending order. */
    SortDirection["Desc"] = "DESC";
})(SortDirection || (SortDirection = {}));
/** Sort order options */
export var SortOrder;
(function (SortOrder) {
    /** Sort in Ascending value order */
    SortOrder["Asc"] = "ASC";
    /** Sort in Descending value order */
    SortOrder["Desc"] = "DESC";
})(SortOrder || (SortOrder = {}));
export var Source;
(function (Source) {
    Source["Judy"] = "JUDY";
    Source["JudyAndPdcs"] = "JUDY_AND_PDCS";
    Source["Pdcs"] = "PDCS";
})(Source || (Source = {}));
/** Source system indicating the origin or creation method of a proposal */
export var SourceSystem;
(function (SourceSystem) {
    /** Proposal generated from EA (Employer Agent) recommendations */
    SourceSystem["EaRecommendations"] = "EA_RECOMMENDATIONS";
    /** Proposal created via Proposal Builder */
    SourceSystem["ProposalBuilder"] = "PROPOSAL_BUILDER";
    /** Single job campaign created directly via the campaign mutation */
    SourceSystem["SingleJobCampaign"] = "SINGLE_JOB_CAMPAIGN";
})(SourceSystem || (SourceSystem = {}));
/** Account name source */
export var SourceTag;
(function (SourceTag) {
    SourceTag["EmployerSignUp"] = "EMPLOYER_SIGN_UP";
    SourceTag["EmployerUserSettings"] = "EMPLOYER_USER_SETTINGS";
    SourceTag["FacebookRegister"] = "FACEBOOK_REGISTER";
    SourceTag["FacebookSignIn"] = "FACEBOOK_SIGN_IN";
    /** User-provided name */
    SourceTag["GlobalSettings"] = "GLOBAL_SETTINGS";
    SourceTag["GoogleRegister"] = "GOOGLE_REGISTER";
    /** Inferred names */
    SourceTag["GoogleSignIn"] = "GOOGLE_SIGN_IN";
    SourceTag["Legacy"] = "LEGACY";
    SourceTag["MyIndeed"] = "MY_INDEED";
    SourceTag["Resume"] = "RESUME";
    SourceTag["ResumeBatch"] = "RESUME_BATCH";
})(SourceTag || (SourceTag = {}));
/** Types for formatting. */
export var SourcedJobPostingFormattingType;
(function (SourcedJobPostingFormattingType) {
    SourcedJobPostingFormattingType["RichFormatting"] = "RICH_FORMATTING";
    SourcedJobPostingFormattingType["Text"] = "TEXT";
})(SourcedJobPostingFormattingType || (SourcedJobPostingFormattingType = {}));
/** Activity Log Type enum */
export var SourcingAgentActivityLogType;
(function (SourcingAgentActivityLogType) {
    SourcingAgentActivityLogType["AgentInstructionUpdate"] = "AGENT_INSTRUCTION_UPDATE";
    SourcingAgentActivityLogType["AgentPauseReasonChange"] = "AGENT_PAUSE_REASON_CHANGE";
    SourcingAgentActivityLogType["AgentStatusChange"] = "AGENT_STATUS_CHANGE";
    SourcingAgentActivityLogType["BatchOutreachState"] = "BATCH_OUTREACH_STATE";
    SourcingAgentActivityLogType["DeepSourcingSession"] = "DEEP_SOURCING_SESSION";
    SourcingAgentActivityLogType["HitlPendingLearningSuggestion"] = "HITL_PENDING_LEARNING_SUGGESTION";
    SourcingAgentActivityLogType["HitlPendingQuestion"] = "HITL_PENDING_QUESTION";
    SourcingAgentActivityLogType["HitlResolvedLearningSuggestion"] = "HITL_RESOLVED_LEARNING_SUGGESTION";
    SourcingAgentActivityLogType["HitlResolvedQuestion"] = "HITL_RESOLVED_QUESTION";
    SourcingAgentActivityLogType["MatchCriteriaUpdate"] = "MATCH_CRITERIA_UPDATE";
    SourcingAgentActivityLogType["ScoringProspectsStarted"] = "SCORING_PROSPECTS_STARTED";
    SourcingAgentActivityLogType["SourcingAssistantStarted"] = "SOURCING_ASSISTANT_STARTED";
})(SourcingAgentActivityLogType || (SourcingAgentActivityLogType = {}));
export var SourcingBundleSubscriptionState;
(function (SourcingBundleSubscriptionState) {
    SourcingBundleSubscriptionState["ActivePaidSubscription"] = "ACTIVE_PAID_SUBSCRIPTION";
    SourcingBundleSubscriptionState["ActiveStandardSponjobSubscription"] = "ACTIVE_STANDARD_SPONJOB_SUBSCRIPTION";
    SourcingBundleSubscriptionState["ActiveTrialSubscription"] = "ACTIVE_TRIAL_SUBSCRIPTION";
    SourcingBundleSubscriptionState["NoActiveSubscription"] = "NO_ACTIVE_SUBSCRIPTION";
})(SourcingBundleSubscriptionState || (SourcingBundleSubscriptionState = {}));
export var SourcingElectionInput;
(function (SourcingElectionInput) {
    SourcingElectionInput["OptIn"] = "OPT_IN";
    SourcingElectionInput["OptOut"] = "OPT_OUT";
})(SourcingElectionInput || (SourcingElectionInput = {}));
/** Proposal discriminator used by Primary Agent answers. */
export var SourcingHitlProposalAnswerType;
(function (SourcingHitlProposalAnswerType) {
    /** The deterministic opt-out proposal for dismissing the question. */
    SourcingHitlProposalAnswerType["Dismiss"] = "DISMISS";
    /** A selectable proposal generated by the Primary Agent. */
    SourcingHitlProposalAnswerType["Selector"] = "SELECTOR";
})(SourcingHitlProposalAnswerType || (SourcingHitlProposalAnswerType = {}));
/** Answer shape used by the HITL question card. */
export var SourcingHitlQuestionStyle;
(function (SourcingHitlQuestionStyle) {
    /** The question should render as a yes or no decision. */
    SourcingHitlQuestionStyle["Boolean"] = "BOOLEAN";
    /** Multiple proposals can be selected. */
    SourcingHitlQuestionStyle["MultiSelect"] = "MULTI_SELECT";
    /** Exactly one proposal can be selected. */
    SourcingHitlQuestionStyle["SingleChoice"] = "SINGLE_CHOICE";
})(SourcingHitlQuestionStyle || (SourcingHitlQuestionStyle = {}));
export var SourcingMatchesPaginationType;
(function (SourcingMatchesPaginationType) {
    SourcingMatchesPaginationType["Original"] = "ORIGINAL";
    SourcingMatchesPaginationType["Relaxed"] = "RELAXED";
})(SourcingMatchesPaginationType || (SourcingMatchesPaginationType = {}));
/** Surfaces where Sourcing Outreach impressions can be triggered */
export var SourcingOutreachImpressionSurface;
(function (SourcingOutreachImpressionSurface) {
    SourcingOutreachImpressionSurface["SourcingMatches"] = "SOURCING_MATCHES";
})(SourcingOutreachImpressionSurface || (SourcingOutreachImpressionSurface = {}));
/** Sourcing Outreach impression types */
export var SourcingOutreachImpressionType;
(function (SourcingOutreachImpressionType) {
    SourcingOutreachImpressionType["InactiveUserMessageMatches"] = "INACTIVE_USER_MESSAGE_MATCHES";
    SourcingOutreachImpressionType["TrialOutreachNudge"] = "TRIAL_OUTREACH_NUDGE";
})(SourcingOutreachImpressionType || (SourcingOutreachImpressionType = {}));
/** Sourcing Profile Credential Type */
export var SourcingProfileCardCredentialType;
(function (SourcingProfileCardCredentialType) {
    /** Certification Credential Type */
    SourcingProfileCardCredentialType["Certification"] = "CERTIFICATION";
    /** License Credential Type */
    SourcingProfileCardCredentialType["License"] = "LICENSE";
})(SourcingProfileCardCredentialType || (SourcingProfileCardCredentialType = {}));
/** Sourcing Profile Data Source */
export var SourcingProfileDataSource;
(function (SourcingProfileDataSource) {
    /** Merida -> Resume */
    SourcingProfileDataSource["Resume"] = "RESUME";
    /** Merida -> NormalizedData -> MetadataService */
    SourcingProfileDataSource["ResumeExtracted"] = "RESUME_EXTRACTED";
    /** Merida->NormalizedData->User(Positive sentiments only) */
    SourcingProfileDataSource["UserSubmitted"] = "USER_SUBMITTED";
})(SourcingProfileDataSource || (SourcingProfileDataSource = {}));
/** Sourcing Profile Employment Eligibility */
export var SourcingProfileEmploymentEligibilityType;
(function (SourcingProfileEmploymentEligibilityType) {
    SourcingProfileEmploymentEligibilityType["Eligible"] = "ELIGIBLE";
    SourcingProfileEmploymentEligibilityType["Ineligible"] = "INELIGIBLE";
    SourcingProfileEmploymentEligibilityType["Unknown"] = "UNKNOWN";
    SourcingProfileEmploymentEligibilityType["WithSponsorship"] = "WITH_SPONSORSHIP";
})(SourcingProfileEmploymentEligibilityType || (SourcingProfileEmploymentEligibilityType = {}));
/** SourcingProfile License Type */
export var SourcingProfileLicenseType;
(function (SourcingProfileLicenseType) {
    /** Accounting License Type */
    SourcingProfileLicenseType["AccountingLicense"] = "ACCOUNTING_LICENSE";
    /** Divers License Type */
    SourcingProfileLicenseType["DriversLicense"] = "DRIVERS_LICENSE";
    /** Nurses License Type */
    SourcingProfileLicenseType["NursesLicense"] = "NURSES_LICENSE";
    /** Unknown License Type */
    SourcingProfileLicenseType["Unknown"] = "UNKNOWN";
})(SourcingProfileLicenseType || (SourcingProfileLicenseType = {}));
/** Sourcing Profile Preference Type */
export var SourcingProfilePreferenceType;
(function (SourcingProfilePreferenceType) {
    /** Attribute Preference */
    SourcingProfilePreferenceType["Attribute"] = "ATTRIBUTE";
    /** JobType Preference */
    SourcingProfilePreferenceType["JobType"] = "JOB_TYPE";
    /** Remote Work type */
    SourcingProfilePreferenceType["RemoteWorkType"] = "REMOTE_WORK_TYPE";
    /** Shift Preference */
    SourcingProfilePreferenceType["Shift"] = "SHIFT";
})(SourcingProfilePreferenceType || (SourcingProfilePreferenceType = {}));
export var SourcingSurfaceName;
(function (SourcingSurfaceName) {
    /** US Omni surface */
    SourcingSurfaceName["SourcingOmni"] = "SOURCING_OMNI";
})(SourcingSurfaceName || (SourcingSurfaceName = {}));
/** The type of total match count */
export var SourcingTotalMatchCountType;
(function (SourcingTotalMatchCountType) {
    SourcingTotalMatchCountType["ApproxGreaterThan"] = "APPROX_GREATER_THAN";
    SourcingTotalMatchCountType["Exact"] = "EXACT";
})(SourcingTotalMatchCountType || (SourcingTotalMatchCountType = {}));
/**  order by criteria in spend views  */
export var SpendOrderBy;
(function (SpendOrderBy) {
    SpendOrderBy["Acr"] = "ACR";
    SpendOrderBy["Asr"] = "ASR";
    SpendOrderBy["Cpa"] = "CPA";
    SpendOrderBy["Cpas"] = "CPAS";
    SpendOrderBy["Cpc"] = "CPC";
    SpendOrderBy["Ctr"] = "CTR";
})(SpendOrderBy || (SpendOrderBy = {}));
/** Spending level for an employer */
export var SpendingLevel;
(function (SpendingLevel) {
    SpendingLevel["L"] = "L";
    SpendingLevel["M"] = "M";
    SpendingLevel["S"] = "S";
    SpendingLevel["Xl"] = "XL";
})(SpendingLevel || (SpendingLevel = {}));
export var SponsorCompetitionErrorCode;
(function (SponsorCompetitionErrorCode) {
    /** Title normalizer RPC threw, timed out, or returned a server-fault status. */
    SponsorCompetitionErrorCode["NormalizeError"] = "NORMALIZE_ERROR";
    /** Artifact not yet loaded (should be impossible past readiness). */
    SponsorCompetitionErrorCode["NoArtifact"] = "NO_ARTIFACT";
    /** Any other unexpected exception, caught at the lookup boundary. */
    SponsorCompetitionErrorCode["Unexpected"] = "UNEXPECTED";
})(SponsorCompetitionErrorCode || (SponsorCompetitionErrorCode = {}));
export var SponsorCompetitionGeoLevel;
(function (SponsorCompetitionGeoLevel) {
    SponsorCompetitionGeoLevel["Admin1"] = "ADMIN1";
    SponsorCompetitionGeoLevel["Admin2"] = "ADMIN2";
    SponsorCompetitionGeoLevel["City"] = "CITY";
    SponsorCompetitionGeoLevel["Country"] = "COUNTRY";
})(SponsorCompetitionGeoLevel || (SponsorCompetitionGeoLevel = {}));
export var SponsorCompetitionInsufficientDataCode;
(function (SponsorCompetitionInsufficientDataCode) {
    /** Occupation present, but no row at any geo level we could build. */
    SponsorCompetitionInsufficientDataCode["GeoWalkupExhausted"] = "GEO_WALKUP_EXHAUSTED";
    /** Title normalized to GENERIC/UNNORMALIZED/BLACKLISTED/CATEGORY, or was empty. */
    SponsorCompetitionInsufficientDataCode["NormalizeMiss"] = "NORMALIZE_MISS";
    /** Job has no structured country. */
    SponsorCompetitionInsufficientDataCode["NoCountry"] = "NO_COUNTRY";
    /** (country, normTitle) absent from the artifact. */
    SponsorCompetitionInsufficientDataCode["OccupationMiss"] = "OCCUPATION_MISS";
})(SponsorCompetitionInsufficientDataCode || (SponsorCompetitionInsufficientDataCode = {}));
/** The sponsorship period type */
export var SponsorshipPeriod;
(function (SponsorshipPeriod) {
    SponsorshipPeriod["Daily"] = "DAILY";
    SponsorshipPeriod["Lifetime"] = "LIFETIME";
    SponsorshipPeriod["Monthly"] = "MONTHLY";
})(SponsorshipPeriod || (SponsorshipPeriod = {}));
/** Category of jobs for sponsorship resolution */
export var SponsorshipResolvedJobsCategory;
(function (SponsorshipResolvedJobsCategory) {
    /** Excluded jobs */
    SponsorshipResolvedJobsCategory["Excluded"] = "EXCLUDED";
})(SponsorshipResolvedJobsCategory || (SponsorshipResolvedJobsCategory = {}));
/** Specifies the possible values for a sponsorship status as defined in https://link.indeed.tech/MEEH9W */
export var SponsorshipStatus;
(function (SponsorshipStatus) {
    SponsorshipStatus["Free"] = "FREE";
    SponsorshipStatus["Sponsored"] = "SPONSORED";
})(SponsorshipStatus || (SponsorshipStatus = {}));
export var SponsorshipTier;
(function (SponsorshipTier) {
    SponsorshipTier["Basic"] = "BASIC";
    SponsorshipTier["Premium"] = "PREMIUM";
    SponsorshipTier["PremiumPlus"] = "PREMIUM_PLUS";
    SponsorshipTier["Standard"] = "STANDARD";
})(SponsorshipTier || (SponsorshipTier = {}));
/**  Sponsorship tier enum  */
export var SponsorshipTierType;
(function (SponsorshipTierType) {
    SponsorshipTierType["Free"] = "FREE";
    SponsorshipTierType["Other"] = "OTHER";
    SponsorshipTierType["Premium"] = "PREMIUM";
    SponsorshipTierType["Standard"] = "STANDARD";
})(SponsorshipTierType || (SponsorshipTierType = {}));
export var SpotlightPageCategory;
(function (SpotlightPageCategory) {
    SpotlightPageCategory["DepartmentOrTeam"] = "DEPARTMENT_OR_TEAM";
    SpotlightPageCategory["DivisionOrBusinessUnit"] = "DIVISION_OR_BUSINESS_UNIT";
    SpotlightPageCategory["EmployeeGroups"] = "EMPLOYEE_GROUPS";
    SpotlightPageCategory["FranchiseGroup"] = "FRANCHISE_GROUP";
    SpotlightPageCategory["HealthcareBranch"] = "HEALTHCARE_BRANCH";
    SpotlightPageCategory["Na"] = "NA";
    SpotlightPageCategory["Other"] = "OTHER";
    SpotlightPageCategory["RoleType"] = "ROLE_TYPE";
    SpotlightPageCategory["SharedBrandSubsidiary"] = "SHARED_BRAND_SUBSIDIARY";
})(SpotlightPageCategory || (SpotlightPageCategory = {}));
/**
 * User preference for screening question prefilling in AutoApply.
 * Using an enum allows for future states without breaking changes.
 */
export var SqPastAnswerPrefillPreference;
(function (SqPastAnswerPrefillPreference) {
    /** User has opted in to screening question prefilling */
    SqPastAnswerPrefillPreference["OptIn"] = "OPT_IN";
    /** User has opted out of screening question prefilling (default behavior due to legal requirement) */
    SqPastAnswerPrefillPreference["OptOut"] = "OPT_OUT";
})(SqPastAnswerPrefillPreference || (SqPastAnswerPrefillPreference = {}));
/** Delivery frequency for scheduled notifications */
export var SsiDeliveryFrequency;
(function (SsiDeliveryFrequency) {
    /** Send notifications once per day at a scheduled time */
    SsiDeliveryFrequency["Daily"] = "DAILY";
    /** Send notifications immediately as events occur */
    SsiDeliveryFrequency["Immediate"] = "IMMEDIATE";
    /** Send notifications once per week at a scheduled time and day */
    SsiDeliveryFrequency["Weekly"] = "WEEKLY";
})(SsiDeliveryFrequency || (SsiDeliveryFrequency = {}));
/** Destination types for notifications */
export var SsiNotificationDestinationType;
(function (SsiNotificationDestinationType) {
    /** Channel destination (e.g., Slack channel, Teams channel) */
    SsiNotificationDestinationType["Channel"] = "CHANNEL";
    /** Direct message destination (user DM) */
    SsiNotificationDestinationType["Dm"] = "DM";
})(SsiNotificationDestinationType || (SsiNotificationDestinationType = {}));
/** Notification event types that can trigger notifications */
export var SsiNotificationEventType;
(function (SsiNotificationEventType) {
    /** AI Screening notifications for applicant screening events */
    SsiNotificationEventType["AiScreening"] = "AI_SCREENING";
    /** License Verification notifications for license verification events */
    SsiNotificationEventType["LicenseVerification"] = "LICENSE_VERIFICATION";
})(SsiNotificationEventType || (SsiNotificationEventType = {}));
/** Filter types for job notifications */
export var SsiNotificationFilterType;
(function (SsiNotificationFilterType) {
    /** Send notifications for all jobs */
    SsiNotificationFilterType["AllJobs"] = "ALL_JOBS";
    /** Send notifications for specific jobs only */
    SsiNotificationFilterType["SpecificJobs"] = "SPECIFIC_JOBS";
})(SsiNotificationFilterType || (SsiNotificationFilterType = {}));
/** Supported platforms for AI Screening integration. This is a platform like Slack, Teams, or Discord. */
export var SsiPlatformType;
(function (SsiPlatformType) {
    SsiPlatformType["Slack"] = "SLACK";
    SsiPlatformType["Teams"] = "TEAMS";
})(SsiPlatformType || (SsiPlatformType = {}));
export var StartInterval;
(function (StartInterval) {
    /** Availability periods start at any time (e.g. 10:00, 10:01, 10:02, etc). */
    StartInterval["Minute_1"] = "MINUTE_1";
    /** Availability periods start at every 5 minute boundary (e.g. 10:00, 10:05, 10:10, etc). */
    StartInterval["Minute_5"] = "MINUTE_5";
    /** Availability periods start at every 10 minute boundary (e.g. 10:00, 10:10, 10:20, etc). */
    StartInterval["Minute_10"] = "MINUTE_10";
    /** Availability periods start at every 15 minute boundary (e.g. 10:00, 10:15, 10:30, etc). */
    StartInterval["Minute_15"] = "MINUTE_15";
    /** Availability periods start at every 20 minute boundary (e.g. 10:00, 10:20, 10:30, etc). */
    StartInterval["Minute_20"] = "MINUTE_20";
    /** Availability periods start at every 30 minute boundary (e.g. 10:00, 10:30, 11:00, etc). */
    StartInterval["Minute_30"] = "MINUTE_30";
    /** Availability periods start at every hour (e.g. 10:00, 11:00, 12:00, etc). */
    StartInterval["Minute_60"] = "MINUTE_60";
})(StartInterval || (StartInterval = {}));
/** when the subscription should be billed and started */
export var StartOption;
(function (StartOption) {
    StartOption["ChargeFullToday"] = "CHARGE_FULL_TODAY";
    StartOption["ChargeProratedToday"] = "CHARGE_PRORATED_TODAY";
    StartOption["StartNextBillingDay"] = "START_NEXT_BILLING_DAY";
})(StartOption || (StartOption = {}));
export var State;
(function (State) {
    State["Deleted"] = "DELETED";
    State["Hidden"] = "HIDDEN";
    State["Public"] = "PUBLIC";
    State["UnknownState"] = "UNKNOWN_STATE";
})(State || (State = {}));
export var Status;
(function (Status) {
    Status["Closed"] = "CLOSED";
    Status["Open"] = "OPEN";
})(Status || (Status = {}));
/** enum of StatusOfRequest */
export var StatusOfRequest;
(function (StatusOfRequest) {
    /** We have received it and are about to begin processing */
    StatusOfRequest["AddingRequestDetails"] = "ADDING_REQUEST_DETAILS";
    /** The request is open to datadrop workers to process */
    StatusOfRequest["Open"] = "OPEN";
    /** None of the above status. Ref: https://link.indeed.tech/GLYZG9GH3 */
    StatusOfRequest["Others"] = "OTHERS";
    /** The request is archived and for take requests you can no longer download the data */
    StatusOfRequest["RequestArchived"] = "REQUEST_ARCHIVED";
    /** The request is complete and for take requests you can download the data */
    StatusOfRequest["RequestComplete"] = "REQUEST_COMPLETE";
})(StatusOfRequest || (StatusOfRequest = {}));
/**  Predefined date range presets, mirroring Rey's DateRangePreset.  */
export var StoplightDateRangePreset;
(function (StoplightDateRangePreset) {
    /**  Last 6 Months  */
    StoplightDateRangePreset["Last_6Months"] = "LAST_6_MONTHS";
    /**  Last 30 Days  */
    StoplightDateRangePreset["Last_30Days"] = "LAST_30_DAYS";
    /**  Last Month  */
    StoplightDateRangePreset["LastMonth"] = "LAST_MONTH";
    /**  Last Quarter  */
    StoplightDateRangePreset["LastQtr"] = "LAST_QTR";
    /**  Last Year  */
    StoplightDateRangePreset["LastYear"] = "LAST_YEAR";
    /**  Month to Date  */
    StoplightDateRangePreset["Mtd"] = "MTD";
    /**  Year to Date  */
    StoplightDateRangePreset["Ytd"] = "YTD";
})(StoplightDateRangePreset || (StoplightDateRangePreset = {}));
/**  Job sponsoring type  */
export var StoplightJobSponsoringType;
(function (StoplightJobSponsoringType) {
    StoplightJobSponsoringType["Organic"] = "ORGANIC";
    StoplightJobSponsoringType["Sponsored"] = "SPONSORED";
})(StoplightJobSponsoringType || (StoplightJobSponsoringType = {}));
/**  Job status enum  */
export var StoplightJobStatus;
(function (StoplightJobStatus) {
    StoplightJobStatus["Active"] = "ACTIVE";
    StoplightJobStatus["Inactive"] = "INACTIVE";
})(StoplightJobStatus || (StoplightJobStatus = {}));
/**  Performance category type  */
export var StoplightPerformanceCategory;
(function (StoplightPerformanceCategory) {
    StoplightPerformanceCategory["Critical"] = "CRITICAL";
    StoplightPerformanceCategory["Ideal"] = "IDEAL";
    StoplightPerformanceCategory["Low"] = "LOW";
    StoplightPerformanceCategory["Moderate"] = "MODERATE";
})(StoplightPerformanceCategory || (StoplightPerformanceCategory = {}));
/**
 *  Classification logic options for stoplight performance.
 *
 * - APPLY_STARTS_THRESHOLD: Uses apply-start thresholds to classify jobs.
 *
 * Note: ADAPTIVE will be added in a future milestone.
 */
export var StoplightPerformanceClassificationLogic;
(function (StoplightPerformanceClassificationLogic) {
    StoplightPerformanceClassificationLogic["ApplyStartsThreshold"] = "APPLY_STARTS_THRESHOLD";
})(StoplightPerformanceClassificationLogic || (StoplightPerformanceClassificationLogic = {}));
/** Intent for how structured data should be handled in the mutation */
export var StructuredDataIntent;
(function (StructuredDataIntent) {
    /** Use manually entered structured data from input */
    StructuredDataIntent["Manual"] = "MANUAL";
    /** Auto-fetch structured data from previous application */
    StructuredDataIntent["Previous"] = "PREVIOUS";
})(StructuredDataIntent || (StructuredDataIntent = {}));
/** Source from which structured data was fetched */
export var StructuredDataSource;
(function (StructuredDataSource) {
    /** Data from current draft */
    StructuredDataSource["Draft"] = "DRAFT";
    /** Data from live resume parsing */
    StructuredDataSource["LiveParse"] = "LIVE_PARSE";
    /** No data available */
    StructuredDataSource["None"] = "NONE";
    /** Data from past application */
    StructuredDataSource["PastApplication"] = "PAST_APPLICATION";
    /** Data from job seeker profile */
    StructuredDataSource["Profile"] = "PROFILE";
})(StructuredDataSource || (StructuredDataSource = {}));
/** The opt-in status for a type of structured resume field */
export var StructuredResumeFieldOptInStatus;
(function (StructuredResumeFieldOptInStatus) {
    /** Not opted in to structured resume fields of a given type */
    StructuredResumeFieldOptInStatus["NotOptedIn"] = "NOT_OPTED_IN";
    /** Opted in to have structured resume questions of a given type be optional for the job seeker to answer */
    StructuredResumeFieldOptInStatus["QuestionsOptional"] = "QUESTIONS_OPTIONAL";
    /** Opted in to have structured resume questions of a given type be required for the job seeker to answer */
    StructuredResumeFieldOptInStatus["QuestionsRequired"] = "QUESTIONS_REQUIRED";
})(StructuredResumeFieldOptInStatus || (StructuredResumeFieldOptInStatus = {}));
/** Subject type enumeration */
export var SubjectType;
(function (SubjectType) {
    /** Account identifier */
    SubjectType["AccountId"] = "ACCOUNT_ID";
    /** Job application or candidate submission */
    SubjectType["Application"] = "APPLICATION";
    /** Job posting or requisition */
    SubjectType["Job"] = "JOB";
})(SubjectType || (SubjectType = {}));
/** Enum representing the result of the submitCompromised call */
export var SubmissionResult;
(function (SubmissionResult) {
    SubmissionResult["Failure"] = "FAILURE";
    SubmissionResult["Forbidden"] = "FORBIDDEN";
    SubmissionResult["PartialSuccess"] = "PARTIAL_SUCCESS";
    SubmissionResult["Success"] = "SUCCESS";
})(SubmissionResult || (SubmissionResult = {}));
export var SubmitApprovalRequestBankAccountType;
(function (SubmitApprovalRequestBankAccountType) {
    SubmitApprovalRequestBankAccountType["Dda"] = "DDA";
    SubmitApprovalRequestBankAccountType["Sa"] = "SA";
})(SubmitApprovalRequestBankAccountType || (SubmitApprovalRequestBankAccountType = {}));
export var SubmitApprovalRequestPaymentType;
(function (SubmitApprovalRequestPaymentType) {
    SubmitApprovalRequestPaymentType["Ach"] = "ACH";
    SubmitApprovalRequestPaymentType["Check"] = "CHECK";
    SubmitApprovalRequestPaymentType["Eft"] = "EFT";
    SubmitApprovalRequestPaymentType["Sepa"] = "SEPA";
    SubmitApprovalRequestPaymentType["Wire"] = "WIRE";
})(SubmitApprovalRequestPaymentType || (SubmitApprovalRequestPaymentType = {}));
export var SubmitApprovalRequestType;
(function (SubmitApprovalRequestType) {
    SubmitApprovalRequestType["Refund"] = "REFUND";
    SubmitApprovalRequestType["SubscriptionCancellation"] = "SUBSCRIPTION_CANCELLATION";
})(SubmitApprovalRequestType || (SubmitApprovalRequestType = {}));
export var SubscriptionFeature;
(function (SubscriptionFeature) {
    SubscriptionFeature["AiInterviewPrep"] = "AI_INTERVIEW_PREP";
    SubscriptionFeature["AiTailoredResume"] = "AI_TAILORED_RESUME";
    SubscriptionFeature["AssistedApply"] = "ASSISTED_APPLY";
    SubscriptionFeature["AutoApply"] = "AUTO_APPLY";
})(SubscriptionFeature || (SubscriptionFeature = {}));
/**
 * Time unit used to express the length of a subscription term.
 * Mirrors the period type options supported by the order service (e.g. ItemOverride.periodType).
 */
export var SubscriptionPeriodType;
(function (SubscriptionPeriodType) {
    SubscriptionPeriodType["Day"] = "DAY";
    SubscriptionPeriodType["Month"] = "MONTH";
    SubscriptionPeriodType["Week"] = "WEEK";
    SubscriptionPeriodType["Year"] = "YEAR";
})(SubscriptionPeriodType || (SubscriptionPeriodType = {}));
/**
 * Supported product name for subscription metadata filtering.
 *
 * Each enum value maps to a specific product name string used
 * in the order service queries. This provides type safety and ensures
 * consistent filtering criteria across the subscription system.
 */
export var SubscriptionProductName;
(function (SubscriptionProductName) {
    /** Employer Branding Suite product line - maps to "Employer Branding Suite" prefix */
    SubscriptionProductName["EmployerBrandingSuite"] = "EMPLOYER_BRANDING_SUITE";
    /** Smart Sourcing product line - maps to "Smart Sourcing" prefix */
    SubscriptionProductName["SmartSourcing"] = "SMART_SOURCING";
})(SubscriptionProductName || (SubscriptionProductName = {}));
/** Subscription state for a job alert. */
export var SubscriptionState;
(function (SubscriptionState) {
    /** Alert is confirmed and actively sending notifications */
    SubscriptionState["Active"] = "ACTIVE";
    /** Alert recipient has opted out of notifications */
    SubscriptionState["OptOut"] = "OPT_OUT";
    /** Alert is paused and not sending notifications */
    SubscriptionState["Paused"] = "PAUSED";
    /** Alert is pending email confirmation (unconfirmed) */
    SubscriptionState["Unconf"] = "UNCONF";
})(SubscriptionState || (SubscriptionState = {}));
/** The type of subscription status */
export var SubscriptionStatus;
(function (SubscriptionStatus) {
    /** @deprecated Use ACTIVE_AUTORENEW, ACTIVE_PENDING_EXPIRATION, or ACTIVE_PENDING_PAUSE instead */
    SubscriptionStatus["Active"] = "ACTIVE";
    SubscriptionStatus["ActiveAutorenew"] = "ACTIVE_AUTORENEW";
    SubscriptionStatus["ActiveAutoRenew"] = "ACTIVE_AUTO_RENEW";
    SubscriptionStatus["ActivePendingExpiration"] = "ACTIVE_PENDING_EXPIRATION";
    SubscriptionStatus["ActivePendingPause"] = "ACTIVE_PENDING_PAUSE";
    /** Zuora subscription expiring and assignment expired (due to payment timeout) */
    SubscriptionStatus["Cancelled"] = "CANCELLED";
    SubscriptionStatus["Created"] = "CREATED";
    SubscriptionStatus["Expired"] = "EXPIRED";
    /** @deprecated No longer supported */
    SubscriptionStatus["Modify"] = "MODIFY";
    SubscriptionStatus["Paused"] = "PAUSED";
    /** a temporary status for new subscriptions. They have pendingAction: true set by SES */
    SubscriptionStatus["Pending"] = "PENDING";
    /** Pending when payment is not completed, limited access to manage pending subscription */
    SubscriptionStatus["PendingPayment"] = "PENDING_PAYMENT";
    /** @deprecated No longer supported */
    SubscriptionStatus["Prepaid"] = "PREPAID";
    SubscriptionStatus["Revoked"] = "REVOKED";
    SubscriptionStatus["Scheduled"] = "SCHEDULED";
    SubscriptionStatus["Unknown"] = "UNKNOWN";
})(SubscriptionStatus || (SubscriptionStatus = {}));
/** Filter for subscription status when querying talent subscriptions */
export var SubscriptionStatusFilter;
(function (SubscriptionStatusFilter) {
    SubscriptionStatusFilter["Actionable"] = "ACTIONABLE";
    SubscriptionStatusFilter["Active"] = "ACTIVE";
    SubscriptionStatusFilter["ActiveAndScheduled"] = "ACTIVE_AND_SCHEDULED";
    SubscriptionStatusFilter["All"] = "ALL";
    SubscriptionStatusFilter["Paused"] = "PAUSED";
})(SubscriptionStatusFilter || (SubscriptionStatusFilter = {}));
/** Filter for subscription type when querying talent subscriptions */
export var SubscriptionTypeFilter;
(function (SubscriptionTypeFilter) {
    SubscriptionTypeFilter["EnterpriseAndSubscriptions"] = "ENTERPRISE_AND_SUBSCRIPTIONS";
    SubscriptionTypeFilter["EnterpriseOrSubscriptions"] = "ENTERPRISE_OR_SUBSCRIPTIONS";
})(SubscriptionTypeFilter || (SubscriptionTypeFilter = {}));
/** Success of glassdoorSubscription */
export var Success;
(function (Success) {
    Success["False"] = "FALSE";
    Success["True"] = "TRUE";
})(Success || (Success = {}));
export var SuggestionAction;
(function (SuggestionAction) {
    SuggestionAction["CompleteOnboarding"] = "COMPLETE_ONBOARDING";
    SuggestionAction["DirectForward"] = "DIRECT_FORWARD";
    SuggestionAction["UploadResume"] = "UPLOAD_RESUME";
    SuggestionAction["UserInputText"] = "USER_INPUT_TEXT";
    SuggestionAction["UserInputVoice"] = "USER_INPUT_VOICE";
})(SuggestionAction || (SuggestionAction = {}));
/** The type of action the suggestion recommends */
export var SuggestionActionType;
(function (SuggestionActionType) {
    SuggestionActionType["Add"] = "ADD";
    SuggestionActionType["Remove"] = "REMOVE";
    /** Fallback when action type data is missing or invalid */
    SuggestionActionType["Unknown"] = "UNKNOWN";
    SuggestionActionType["Update"] = "UPDATE";
})(SuggestionActionType || (SuggestionActionType = {}));
export var SuggestionIcon;
(function (SuggestionIcon) {
    SuggestionIcon["Keyboard"] = "KEYBOARD";
    SuggestionIcon["Mic"] = "MIC";
    SuggestionIcon["Upload"] = "UPLOAD";
})(SuggestionIcon || (SuggestionIcon = {}));
export var SuggestionStatus;
(function (SuggestionStatus) {
    /** Suggestion dismissed */
    SuggestionStatus["Dismissed"] = "DISMISSED";
    /** Suggestion seen */
    SuggestionStatus["Seen"] = "SEEN";
})(SuggestionStatus || (SuggestionStatus = {}));
/** Strength of a suggestion (REQUIRED, PREFERRED, UNKNOWN) */
export var SuggestionStrength;
(function (SuggestionStrength) {
    SuggestionStrength["Preferred"] = "PREFERRED";
    SuggestionStrength["Required"] = "REQUIRED";
    /** Fallback when strength data is missing or invalid */
    SuggestionStrength["Unknown"] = "UNKNOWN";
})(SuggestionStrength || (SuggestionStrength = {}));
/**  Summarized performance and insights group by fields  */
export var SummarizedPerformanceAndInsightsGroupBy;
(function (SummarizedPerformanceAndInsightsGroupBy) {
    /**  Group by country */
    SummarizedPerformanceAndInsightsGroupBy["Country"] = "COUNTRY";
    /**  Group by country and region */
    SummarizedPerformanceAndInsightsGroupBy["CountryRegion"] = "COUNTRY_REGION";
    /**  Group by country, region and city  */
    SummarizedPerformanceAndInsightsGroupBy["CountryRegionCity"] = "COUNTRY_REGION_CITY";
    /**  Group by norm title category  */
    SummarizedPerformanceAndInsightsGroupBy["NormTitleCategory"] = "NORM_TITLE_CATEGORY";
    /**  Group by norm title category and norm title  */
    SummarizedPerformanceAndInsightsGroupBy["NormTitleCategoryNormTitle"] = "NORM_TITLE_CATEGORY_NORM_TITLE";
})(SummarizedPerformanceAndInsightsGroupBy || (SummarizedPerformanceAndInsightsGroupBy = {}));
/**  Summarized performance and insights order by fields  */
export var SummarizedPerformanceAndInsightsOrderByField;
(function (SummarizedPerformanceAndInsightsOrderByField) {
    SummarizedPerformanceAndInsightsOrderByField["Acr"] = "ACR";
    SummarizedPerformanceAndInsightsOrderByField["ApplyRate"] = "APPLY_RATE";
    SummarizedPerformanceAndInsightsOrderByField["Asr"] = "ASR";
    SummarizedPerformanceAndInsightsOrderByField["Cpa"] = "CPA";
    SummarizedPerformanceAndInsightsOrderByField["Cpas"] = "CPAS";
    SummarizedPerformanceAndInsightsOrderByField["Cpc"] = "CPC";
    SummarizedPerformanceAndInsightsOrderByField["Ctr"] = "CTR";
    SummarizedPerformanceAndInsightsOrderByField["SelectedGroupByParameter"] = "SELECTED_GROUP_BY_PARAMETER";
    SummarizedPerformanceAndInsightsOrderByField["SumApplies"] = "SUM_APPLIES";
    SummarizedPerformanceAndInsightsOrderByField["SumApplyStarts"] = "SUM_APPLY_STARTS";
    SummarizedPerformanceAndInsightsOrderByField["SumClicks"] = "SUM_CLICKS";
    SummarizedPerformanceAndInsightsOrderByField["SumCostLocal"] = "SUM_COST_LOCAL";
    SummarizedPerformanceAndInsightsOrderByField["SumImpressions"] = "SUM_IMPRESSIONS";
})(SummarizedPerformanceAndInsightsOrderByField || (SummarizedPerformanceAndInsightsOrderByField = {}));
/** Type of errors */
export var SupplyPoolErrorKind;
(function (SupplyPoolErrorKind) {
    SupplyPoolErrorKind["InvalidInput"] = "INVALID_INPUT";
    SupplyPoolErrorKind["Nonretryable"] = "NONRETRYABLE";
    SupplyPoolErrorKind["Retryable"] = "RETRYABLE";
    SupplyPoolErrorKind["Unspecified"] = "UNSPECIFIED";
})(SupplyPoolErrorKind || (SupplyPoolErrorKind = {}));
/** Supported labels for labeling service */
export var SupportedRequestQuestionLabelInput;
(function (SupportedRequestQuestionLabelInput) {
    /** This is the label used to label AI opt-in/out questions */
    SupportedRequestQuestionLabelInput["AiOptInOut"] = "AI_OPT_IN_OUT";
    /** This is the label used to label EEO questions */
    SupportedRequestQuestionLabelInput["Demographic"] = "DEMOGRAPHIC";
    /** This is the label used to label Qualification Questions */
    SupportedRequestQuestionLabelInput["Qualification"] = "QUALIFICATION";
    /** Approved OFCCP (Office of Federal Contract Compliance Programs) self-identification redirect. */
    SupportedRequestQuestionLabelInput["RedirectOfccp"] = "REDIRECT_OFCCP";
    /** Question redirects job seekers off Indeed; off-Indeed URL detected without an approved-category match. */
    SupportedRequestQuestionLabelInput["RedirectSq"] = "REDIRECT_SQ";
    /** Approved state tax-credit / tax-form redirect (e.g. NY Youth Jobs, California New Employment Credit). */
    SupportedRequestQuestionLabelInput["RedirectTax"] = "REDIRECT_TAX";
    /** Approved WOTC (Work Opportunity Tax Credit) compliance redirect. */
    SupportedRequestQuestionLabelInput["RedirectWotc"] = "REDIRECT_WOTC";
    /** This is the label used to label screener questions */
    SupportedRequestQuestionLabelInput["Screener"] = "SCREENER";
    /** This is the label used for sensitive data questions (e.g. PII and other sensitive data). */
    SupportedRequestQuestionLabelInput["Sensitive"] = "SENSITIVE";
})(SupportedRequestQuestionLabelInput || (SupportedRequestQuestionLabelInput = {}));
/** the UI surface from which the subscription is purchased */
export var Surface;
(function (Surface) {
    Surface["InstantMatchLandingJob"] = "INSTANT_MATCH_LANDING_JOB";
})(Surface || (Surface = {}));
/** The surface that is making the request */
export var SurfaceContext;
(function (SurfaceContext) {
    SurfaceContext["MatchedCandidates"] = "MATCHED_CANDIDATES";
    SurfaceContext["SmartSourcing"] = "SMART_SOURCING";
})(SurfaceContext || (SurfaceContext = {}));
/** Synchronization health status for deployments and policies */
export var SyncHealth;
(function (SyncHealth) {
    /** One or more resources are being updated */
    SyncHealth["Degraded"] = "DEGRADED";
    /** One or more resources have sync errors */
    SyncHealth["Failed"] = "FAILED";
    /** All resources are in sync */
    SyncHealth["Synced"] = "SYNCED";
})(SyncHealth || (SyncHealth = {}));
/** Glassdoor sync operation enum */
export var SyncOperation;
(function (SyncOperation) {
    SyncOperation["Create"] = "CREATE";
    SyncOperation["Delete"] = "DELETE";
    SyncOperation["Modify"] = "MODIFY";
})(SyncOperation || (SyncOperation = {}));
/** Current sync status of the GlassdoorEpApiLog */
export var SyncStatus;
(function (SyncStatus) {
    SyncStatus["ErrorSyncing"] = "ERROR_SYNCING";
    SyncStatus["NotSynced"] = "NOT_SYNCED";
    SyncStatus["Synced"] = "SYNCED";
})(SyncStatus || (SyncStatus = {}));
/** Visual style variants for tag elements. */
export var TagStyle;
(function (TagStyle) {
    /** Critical tag (typically red) */
    TagStyle["Critical"] = "CRITICAL";
    /** Indeed Flex branded tag */
    TagStyle["Flex"] = "FLEX";
    /** Informational tag (typically blue) */
    TagStyle["Info"] = "INFO";
    /** Neutral filled tag */
    TagStyle["NeutralFill"] = "NEUTRAL_FILL";
    /** Prominent/highlighted tag */
    TagStyle["Prominent"] = "PROMINENT";
    /** Success tag (typically green) */
    TagStyle["Success"] = "SUCCESS";
    /** Warning tag (typically yellow/orange) */
    TagStyle["Warning"] = "WARNING";
})(TagStyle || (TagStyle = {}));
/** The statuses of the engagement action */
export var TalentEngagementActionStatus;
(function (TalentEngagementActionStatus) {
    /** The current user is permitted to perform this action */
    TalentEngagementActionStatus["Allowed"] = "ALLOWED";
    /** This action is not available at the moment */
    TalentEngagementActionStatus["DisabledFeature"] = "DISABLED_FEATURE";
    /** Something went wrong with the current user's account */
    TalentEngagementActionStatus["InvalidAccount"] = "INVALID_ACCOUNT";
    /** This candidate cannot receive this kind of engagement */
    TalentEngagementActionStatus["InvalidCandidate"] = "INVALID_CANDIDATE";
    /** The user's current subscription does not support this action */
    TalentEngagementActionStatus["InvalidSubscription"] = "INVALID_SUBSCRIPTION";
    /** Not enough contacts in the user's subscription to perform this action */
    TalentEngagementActionStatus["OutOfContacts"] = "OUT_OF_CONTACTS";
    /** Current user already contacted this candidate with this engagement-type. Allow 30 days to re-engage with the candidate */
    TalentEngagementActionStatus["RecentlyContacted"] = "RECENTLY_CONTACTED";
    /** The candidate indicated disinterest in engaging with the current user. Allow 30 days to re-engage with the candidate */
    TalentEngagementActionStatus["RecentlyDeclined"] = "RECENTLY_DECLINED";
})(TalentEngagementActionStatus || (TalentEngagementActionStatus = {}));
/** The engagement actions which require permission to act */
export var TalentEngagementActionType;
(function (TalentEngagementActionType) {
    /** Ability to create engagements with multiple candidates simultaneously */
    TalentEngagementActionType["BulkEngage"] = "BULK_ENGAGE";
    /** Ability to send email engagements to candidate(s) */
    TalentEngagementActionType["Email"] = "EMAIL";
    /** Ability to send simultaneous email & SMS message engagements to candidate(s) */
    TalentEngagementActionType["EmailSms"] = "EMAIL_SMS";
    /** Ability to send interview invitations to candidate(s) */
    TalentEngagementActionType["Interview"] = "INTERVIEW";
    /**
     * @deprecated(reason: no longer supported)
     * @deprecated no longer supported
     */
    TalentEngagementActionType["Phone"] = "PHONE";
})(TalentEngagementActionType || (TalentEngagementActionType = {}));
/** Type of interview */
export var TalentEngagementInterviewType;
(function (TalentEngagementInterviewType) {
    TalentEngagementInterviewType["AudioCall"] = "AUDIO_CALL";
    TalentEngagementInterviewType["VideoCall"] = "VIDEO_CALL";
})(TalentEngagementInterviewType || (TalentEngagementInterviewType = {}));
/** Keys for a message variable */
export var TalentEngagementMessageVariableKey;
(function (TalentEngagementMessageVariableKey) {
    TalentEngagementMessageVariableKey["CandidateFirstname"] = "CANDIDATE_FIRSTNAME";
    TalentEngagementMessageVariableKey["CandidateLastname"] = "CANDIDATE_LASTNAME";
    TalentEngagementMessageVariableKey["CandidateName"] = "CANDIDATE_NAME";
    TalentEngagementMessageVariableKey["CandidateQualifications"] = "CANDIDATE_QUALIFICATIONS";
    TalentEngagementMessageVariableKey["Company"] = "COMPANY";
    TalentEngagementMessageVariableKey["JobTitle"] = "JOB_TITLE";
    TalentEngagementMessageVariableKey["RecruiterName"] = "RECRUITER_NAME";
})(TalentEngagementMessageVariableKey || (TalentEngagementMessageVariableKey = {}));
/** Type of the Talent Engagement message variable */
export var TalentEngagementMessageVariableType;
(function (TalentEngagementMessageVariableType) {
    TalentEngagementMessageVariableType["Smart"] = "SMART";
    TalentEngagementMessageVariableType["Standard"] = "STANDARD";
})(TalentEngagementMessageVariableType || (TalentEngagementMessageVariableType = {}));
/** Type of talent engagement */
export var TalentEngagementType;
(function (TalentEngagementType) {
    TalentEngagementType["Email"] = "EMAIL";
    TalentEngagementType["Interview"] = "INTERVIEW";
    /** @deprecated no longer supported */
    TalentEngagementType["Phone"] = "PHONE";
})(TalentEngagementType || (TalentEngagementType = {}));
/** Indicates whether an entitlement is a feature or a resource with a limited quantity. */
export var TalentEntitlementType;
(function (TalentEntitlementType) {
    TalentEntitlementType["Feature"] = "FEATURE";
    TalentEntitlementType["Resource"] = "RESOURCE";
})(TalentEntitlementType || (TalentEntitlementType = {}));
/** The source of the resume/profile data used for profile-related fields. */
export var TalentRepresentationDataSource;
(function (TalentRepresentationDataSource) {
    TalentRepresentationDataSource["CallyResumeAttachment"] = "CALLY_RESUME_ATTACHMENT";
    TalentRepresentationDataSource["CallyResumeJson"] = "CALLY_RESUME_JSON";
    TalentRepresentationDataSource["None"] = "NONE";
})(TalentRepresentationDataSource || (TalentRepresentationDataSource = {}));
/** Employment eligibility type */
export var TalentRepresentationEligibility;
(function (TalentRepresentationEligibility) {
    TalentRepresentationEligibility["Eligible"] = "ELIGIBLE";
    TalentRepresentationEligibility["Ineligible"] = "INELIGIBLE";
    TalentRepresentationEligibility["Unknown"] = "UNKNOWN";
    TalentRepresentationEligibility["WithSponsorship"] = "WITH_SPONSORSHIP";
})(TalentRepresentationEligibility || (TalentRepresentationEligibility = {}));
/** Occupation type that is associated with a license */
export var TalentRepresentationLicenseType;
(function (TalentRepresentationLicenseType) {
    TalentRepresentationLicenseType["Accounting"] = "ACCOUNTING";
    TalentRepresentationLicenseType["Drivers"] = "DRIVERS";
    TalentRepresentationLicenseType["Nurses"] = "NURSES";
    TalentRepresentationLicenseType["Unknown"] = "UNKNOWN";
})(TalentRepresentationLicenseType || (TalentRepresentationLicenseType = {}));
/** Month type. UNSPECIFIED is used for NULL/not provided */
export var TalentRepresentationMonthType;
(function (TalentRepresentationMonthType) {
    TalentRepresentationMonthType["April"] = "APRIL";
    TalentRepresentationMonthType["August"] = "AUGUST";
    TalentRepresentationMonthType["December"] = "DECEMBER";
    TalentRepresentationMonthType["February"] = "FEBRUARY";
    TalentRepresentationMonthType["January"] = "JANUARY";
    TalentRepresentationMonthType["July"] = "JULY";
    TalentRepresentationMonthType["June"] = "JUNE";
    TalentRepresentationMonthType["March"] = "MARCH";
    TalentRepresentationMonthType["May"] = "MAY";
    TalentRepresentationMonthType["November"] = "NOVEMBER";
    TalentRepresentationMonthType["October"] = "OCTOBER";
    TalentRepresentationMonthType["September"] = "SEPTEMBER";
    TalentRepresentationMonthType["Unspecified"] = "UNSPECIFIED";
})(TalentRepresentationMonthType || (TalentRepresentationMonthType = {}));
export var TalentScoutEntityReferenceType;
(function (TalentScoutEntityReferenceType) {
    TalentScoutEntityReferenceType["Applicant"] = "APPLICANT";
    TalentScoutEntityReferenceType["Job"] = "JOB";
    TalentScoutEntityReferenceType["Prospect"] = "PROSPECT";
})(TalentScoutEntityReferenceType || (TalentScoutEntityReferenceType = {}));
export var TalentScoutEntityReferenceUnsupportedReason;
(function (TalentScoutEntityReferenceUnsupportedReason) {
    TalentScoutEntityReferenceUnsupportedReason["NonUsJobLocation"] = "NON_US_JOB_LOCATION";
})(TalentScoutEntityReferenceUnsupportedReason || (TalentScoutEntityReferenceUnsupportedReason = {}));
export var TalentScoutOutreachSummaryType;
(function (TalentScoutOutreachSummaryType) {
    TalentScoutOutreachSummaryType["Accepted"] = "ACCEPTED";
    TalentScoutOutreachSummaryType["Applied"] = "APPLIED";
    TalentScoutOutreachSummaryType["AwaitingReply"] = "AWAITING_REPLY";
    TalentScoutOutreachSummaryType["Declined"] = "DECLINED";
    TalentScoutOutreachSummaryType["InvitationsSent"] = "INVITATIONS_SENT";
})(TalentScoutOutreachSummaryType || (TalentScoutOutreachSummaryType = {}));
export var TalentScoutOutreachTimeWindow;
(function (TalentScoutOutreachTimeWindow) {
    TalentScoutOutreachTimeWindow["Last_6Months"] = "LAST_6_MONTHS";
    TalentScoutOutreachTimeWindow["Last_7Days"] = "LAST_7_DAYS";
    TalentScoutOutreachTimeWindow["Last_14Days"] = "LAST_14_DAYS";
    TalentScoutOutreachTimeWindow["Last_30Days"] = "LAST_30_DAYS";
    TalentScoutOutreachTimeWindow["Recent"] = "RECENT";
})(TalentScoutOutreachTimeWindow || (TalentScoutOutreachTimeWindow = {}));
/** Event type of subscription activity */
export var TalentSubscriptionActivityEventType;
(function (TalentSubscriptionActivityEventType) {
    TalentSubscriptionActivityEventType["AdvertiserSnapshot"] = "ADVERTISER_SNAPSHOT";
    TalentSubscriptionActivityEventType["AssignmentChanged"] = "ASSIGNMENT_CHANGED";
    TalentSubscriptionActivityEventType["AssistantSentContacts"] = "ASSISTANT_SENT_CONTACTS";
    TalentSubscriptionActivityEventType["ContactsCreated"] = "CONTACTS_CREATED";
    TalentSubscriptionActivityEventType["ContactsCredited"] = "CONTACTS_CREDITED";
    TalentSubscriptionActivityEventType["ContactsExpired"] = "CONTACTS_EXPIRED";
    TalentSubscriptionActivityEventType["ContactsGranted"] = "CONTACTS_GRANTED";
    TalentSubscriptionActivityEventType["ContactsMoved"] = "CONTACTS_MOVED";
    TalentSubscriptionActivityEventType["ContactsSent"] = "CONTACTS_SENT";
    TalentSubscriptionActivityEventType["FreeContactsSent"] = "FREE_CONTACTS_SENT";
    TalentSubscriptionActivityEventType["FreeContactResponse"] = "FREE_CONTACT_RESPONSE";
    TalentSubscriptionActivityEventType["SeatsCreated"] = "SEATS_CREATED";
    TalentSubscriptionActivityEventType["Snapshot"] = "SNAPSHOT";
    TalentSubscriptionActivityEventType["SubscriptionCreated"] = "SUBSCRIPTION_CREATED";
    TalentSubscriptionActivityEventType["TrialUpgradeStarted"] = "TRIAL_UPGRADE_STARTED";
})(TalentSubscriptionActivityEventType || (TalentSubscriptionActivityEventType = {}));
export var Target;
(function (Target) {
    Target["MinimumOccupationCriteria"] = "MINIMUM_OCCUPATION_CRITERIA";
    Target["YellowLightQuestions"] = "YELLOW_LIGHT_QUESTIONS";
})(Target || (Target = {}));
/**
 * Task execution status indicating the current state of a task or run attempt.
 *
 * Status Flow:
 * PENDING → RUNNING → [SUCCEEDED | FAILED | TIMED_OUT | CANCELED]
 *
 * - Use SUCCEEDED/FAILED to check if your task completed successfully
 * - TIMED_OUT indicates the task exceeded its configured timeout
 * - CANCELED means the task was manually stopped (if supported)
 */
export var TaskStatus;
(function (TaskStatus) {
    /** Task was manually canceled before completion */
    TaskStatus["Canceled"] = "CANCELED";
    /** Task cancellation is in progress */
    TaskStatus["Canceling"] = "CANCELING";
    /** Task execution failed due to an error or exception */
    TaskStatus["Failed"] = "FAILED";
    /** Task has been created but not yet started execution */
    TaskStatus["Pending"] = "PENDING";
    /** Task is currently executing in the runtime environment */
    TaskStatus["Running"] = "RUNNING";
    /** Task completed successfully with expected results */
    TaskStatus["Succeeded"] = "SUCCEEDED";
    /** Task exceeded its maximum allowed execution time */
    TaskStatus["TimedOut"] = "TIMED_OUT";
    /** Task status could not be determined (system error) */
    TaskStatus["Unknown"] = "UNKNOWN";
})(TaskStatus || (TaskStatus = {}));
export var TaxCertAiRecommendation;
(function (TaxCertAiRecommendation) {
    TaxCertAiRecommendation["LikelyApprove"] = "LIKELY_APPROVE";
    TaxCertAiRecommendation["LikelyReject"] = "LIKELY_REJECT";
    TaxCertAiRecommendation["NeedsInfo"] = "NEEDS_INFO";
})(TaxCertAiRecommendation || (TaxCertAiRecommendation = {}));
export var TaxCertStatus;
(function (TaxCertStatus) {
    TaxCertStatus["Approved"] = "APPROVED";
    TaxCertStatus["Failed"] = "FAILED";
    TaxCertStatus["MoreInfoRequested"] = "MORE_INFO_REQUESTED";
    TaxCertStatus["Rejected"] = "REJECTED";
    TaxCertStatus["Submitted"] = "SUBMITTED";
    TaxCertStatus["UnderReview"] = "UNDER_REVIEW";
})(TaxCertStatus || (TaxCertStatus = {}));
/** taxValidationResult enum */
export var TaxValidationResult;
(function (TaxValidationResult) {
    TaxValidationResult["Error"] = "ERROR";
    TaxValidationResult["Invalid"] = "INVALID";
    TaxValidationResult["NotPerformed"] = "NOT_PERFORMED";
    TaxValidationResult["NotRequired"] = "NOT_REQUIRED";
    TaxValidationResult["Valid"] = "VALID";
})(TaxValidationResult || (TaxValidationResult = {}));
/** The taxonomy attribute type */
export var TaxonomyAttributeType;
(function (TaxonomyAttributeType) {
    TaxonomyAttributeType["Experimental"] = "EXPERIMENTAL";
    TaxonomyAttributeType["None"] = "NONE";
    TaxonomyAttributeType["Official"] = "OFFICIAL";
    TaxonomyAttributeType["Other"] = "OTHER";
})(TaxonomyAttributeType || (TaxonomyAttributeType = {}));
/** Types of concepts. */
export var TaxonomyConceptType;
(function (TaxonomyConceptType) {
    /**
     * Skills, experiences, certifications, work environments, or other job characteristics. See [Search attributes](/job-sync-api/reference/search-attributes).
     *
     * **Example**: "Master's degree"
     */
    TaxonomyConceptType["Attribute"] = "ATTRIBUTE";
    /**
     * Company's primary business, commonly called *industry*.
     *
     * **Example**: "Aerospace & Defense"
     *
     * See [Company sectors](/employers/reference/company-sector).
     */
    TaxonomyConceptType["CompanySector"] = "COMPANY_SECTOR";
    /**
     * Japan-optimized tag for machine learning.
     *
     * **Example**: "Game distribution"
     */
    TaxonomyConceptType["CrowtagMatchTag"] = "CROWTAG_MATCH_TAG";
    /**
     * Japan-optimized version of `OCCUPATION`.
     *
     * **Example**: "Agriculture Researchers (Academic Research)"
     */
    TaxonomyConceptType["CrowtagOqvtOccupations"] = "CROWTAG_OQVT_OCCUPATIONS";
    /**
     * Japan-optimized question for an occupation, with selectable tag-linked answers.
     *
     * **Example**: "What types of operating environments have you commonly worked in?"
     */
    TaxonomyConceptType["CrowtagOqvtQuestion"] = "CROWTAG_OQVT_QUESTION";
    /**
     * Japan-optimized value for a selectable answer option.
     *
     * **Example**: "AndroidOS"
     */
    TaxonomyConceptType["CrowtagOqvtQuestionVal"] = "CROWTAG_OQVT_QUESTION_VAL";
    /**
     * Japan-optimized tag associated with an answer to a question.
     *
     * **Example**: "Android"
     */
    TaxonomyConceptType["CrowtagOqvtTag"] = "CROWTAG_OQVT_TAG";
    /**
     * Sorting bucket for concepts with a shared feature or similar use cases.
     *
     * **Example**: "Cross-Occupational Cluster"
     */
    TaxonomyConceptType["CustomClass"] = "CUSTOM_CLASS";
    /**
     * Jobs with similar core duties, regardless of environment or industry. See [Occupations](/job-sync-api/reference/occupations).
     *
     * **Example**: "Food & Beverage Servers"
     */
    TaxonomyConceptType["Occupation"] = "OCCUPATION";
})(TaxonomyConceptType || (TaxonomyConceptType = {}));
/** Enum specifies the type of title an input title is */
export var TcsInputTitleType;
(function (TcsInputTitleType) {
    TcsInputTitleType["ExplicitDesired"] = "EXPLICIT_DESIRED";
    TcsInputTitleType["ExplicitWorkHistory"] = "EXPLICIT_WORK_HISTORY";
    TcsInputTitleType["ExtractedResumePrimary"] = "EXTRACTED_RESUME_PRIMARY";
    TcsInputTitleType["ExtractedResumePrimaryLatest"] = "EXTRACTED_RESUME_PRIMARY_LATEST";
})(TcsInputTitleType || (TcsInputTitleType = {}));
/** Enum specifies the result of canonicalization */
export var TcsOperationStatus;
(function (TcsOperationStatus) {
    /** Result was above the configured distance threshold. Mirror of the gRPC value. */
    TcsOperationStatus["AboveThreshold"] = "ABOVE_THRESHOLD";
    TcsOperationStatus["CacheAboveThreshold"] = "CACHE_ABOVE_THRESHOLD";
    TcsOperationStatus["CacheGetFailure"] = "CACHE_GET_FAILURE";
    /** Result was a generic canonical title that was filtered out per request type / proctor config. Mirror of the gRPC value. */
    TcsOperationStatus["FoundGeneric"] = "FOUND_GENERIC";
    TcsOperationStatus["FoundGenericInCache"] = "FOUND_GENERIC_IN_CACHE";
    TcsOperationStatus["GeneralFailure"] = "GENERAL_FAILURE";
    TcsOperationStatus["InvalidRequest"] = "INVALID_REQUEST";
    /** No canonical title was found for this input. Mirror of the gRPC value. */
    TcsOperationStatus["NotFound"] = "NOT_FOUND";
    TcsOperationStatus["NotFoundInCache"] = "NOT_FOUND_IN_CACHE";
    TcsOperationStatus["Success"] = "SUCCESS";
    TcsOperationStatus["TesAboveThreshold"] = "TES_ABOVE_THRESHOLD";
    TcsOperationStatus["TesFoundGeneric"] = "TES_FOUND_GENERIC";
    TcsOperationStatus["TesVectorSearchFailure"] = "TES_VECTOR_SEARCH_FAILURE";
})(TcsOperationStatus || (TcsOperationStatus = {}));
/**
 * Identifies a single step in the title sanitization pipeline. Mirrors the gRPC `SanitizerType`
 * enum. Surfaced via `TcsSingleCanonicalTitleMatch.sanitizersApplied` in the upstream library's
 * pipeline order; empty when no sanitizer fired, contains only `OVERRIDE` when the overrides
 * artifact answered.
 */
export var TcsSanitizerType;
(function (TcsSanitizerType) {
    TcsSanitizerType["Acronym"] = "ACRONYM";
    TcsSanitizerType["BadPhrase"] = "BAD_PHRASE";
    TcsSanitizerType["Case"] = "CASE";
    /** The title matched the overrides artifact and was replaced wholesale; no other sanitizer ran. */
    TcsSanitizerType["Override"] = "OVERRIDE";
    TcsSanitizerType["Pay"] = "PAY";
    TcsSanitizerType["Post"] = "POST";
    TcsSanitizerType["Punctuation"] = "PUNCTUATION";
    TcsSanitizerType["Schedule"] = "SCHEDULE";
})(TcsSanitizerType || (TcsSanitizerType = {}));
/** The source from which to retrieve the template content. If not specified, defaults to DEFAULT. */
export var TemplateSource;
(function (TemplateSource) {
    TemplateSource["Default"] = "DEFAULT";
    TemplateSource["Xxl"] = "XXL";
})(TemplateSource || (TemplateSource = {}));
/** An employer provides one of the ternary options */
export var TernarySentimentInput;
(function (TernarySentimentInput) {
    TernarySentimentInput["Maybe"] = "maybe";
    TernarySentimentInput["No"] = "no";
    TernarySentimentInput["Yes"] = "yes";
})(TernarySentimentInput || (TernarySentimentInput = {}));
/** The category of a Terraform workspace variable */
export var TerraformWorkspaceVariableCategory;
(function (TerraformWorkspaceVariableCategory) {
    TerraformWorkspaceVariableCategory["Environment"] = "ENVIRONMENT";
    TerraformWorkspaceVariableCategory["Terraform"] = "TERRAFORM";
})(TerraformWorkspaceVariableCategory || (TerraformWorkspaceVariableCategory = {}));
/** Enum input to filter TimePunches from the boolean `approved` field */
export var TimePunchApprovedFilter;
(function (TimePunchApprovedFilter) {
    TimePunchApprovedFilter["All"] = "ALL";
    TimePunchApprovedFilter["Approved"] = "APPROVED";
    TimePunchApprovedFilter["NotApproved"] = "NOT_APPROVED";
})(TimePunchApprovedFilter || (TimePunchApprovedFilter = {}));
/** Enum input to filter TimePunches from the boolean `deleted` field */
export var TimePunchDeletedFilter;
(function (TimePunchDeletedFilter) {
    TimePunchDeletedFilter["All"] = "ALL";
    TimePunchDeletedFilter["Deleted"] = "DELETED";
    TimePunchDeletedFilter["NonDeleted"] = "NON_DELETED";
})(TimePunchDeletedFilter || (TimePunchDeletedFilter = {}));
/** Hardcoded limited set of countries supported by the Time Platform */
export var TimeRuleCountryCode;
(function (TimeRuleCountryCode) {
    TimeRuleCountryCode["Gb"] = "GB";
    TimeRuleCountryCode["Us"] = "US";
})(TimeRuleCountryCode || (TimeRuleCountryCode = {}));
export var TimeStampSortEnum;
(function (TimeStampSortEnum) {
    TimeStampSortEnum["Created"] = "CREATED";
    TimeStampSortEnum["Updated"] = "UPDATED";
})(TimeStampSortEnum || (TimeStampSortEnum = {}));
/**
 * The subject the associated data belongs to
 * Many forms of our data have separate, independent versions for different kinds of users
 * e.g. a Worker may say they worked this time, a Client may say another time
 */
export var TimeSubject;
(function (TimeSubject) {
    TimeSubject["Client"] = "CLIENT";
    TimeSubject["Worker"] = "WORKER";
})(TimeSubject || (TimeSubject = {}));
export var TimeUnit;
(function (TimeUnit) {
    TimeUnit["Day"] = "DAY";
    TimeUnit["Month"] = "MONTH";
    TimeUnit["UnknownTimeUnit"] = "UNKNOWN_TIME_UNIT";
    TimeUnit["Week"] = "WEEK";
    TimeUnit["Year"] = "YEAR";
})(TimeUnit || (TimeUnit = {}));
/** Type of Resource that can have timekeeping configuration */
export var TimekeepingConfigResourceType;
(function (TimekeepingConfigResourceType) {
    TimekeepingConfigResourceType["Employer"] = "EMPLOYER";
    TimekeepingConfigResourceType["Shift"] = "SHIFT";
    TimekeepingConfigResourceType["Worker"] = "WORKER";
    TimekeepingConfigResourceType["WorkLocation"] = "WORK_LOCATION";
})(TimekeepingConfigResourceType || (TimekeepingConfigResourceType = {}));
/** Coverage status for a datapoint in an integration tool */
export var ToolCoverageStatus;
(function (ToolCoverageStatus) {
    /** The tool supports this datapoint but it is not yet integrated */
    ToolCoverageStatus["NotImplemented"] = "NOT_IMPLEMENTED";
    /** The tool supports this datapoint */
    ToolCoverageStatus["Supported"] = "SUPPORTED";
    /** The datapoint status is unknown */
    ToolCoverageStatus["Unknown"] = "UNKNOWN";
    /** The tool does not support this datapoint */
    ToolCoverageStatus["Unsupported"] = "UNSUPPORTED";
})(ToolCoverageStatus || (ToolCoverageStatus = {}));
/** Current status of the Subscription */
export var TopLevelStatus;
(function (TopLevelStatus) {
    TopLevelStatus["Deactivated"] = "DEACTIVATED";
    TopLevelStatus["Error"] = "ERROR";
    TopLevelStatus["Live"] = "LIVE";
    TopLevelStatus["Processing"] = "PROCESSING";
    TopLevelStatus["Scheduled"] = "SCHEDULED";
})(TopLevelStatus || (TopLevelStatus = {}));
export var TotalMatchCountType;
(function (TotalMatchCountType) {
    TotalMatchCountType["ApproxGreaterThan"] = "APPROX_GREATER_THAN";
    TotalMatchCountType["Exact"] = "EXACT";
})(TotalMatchCountType || (TotalMatchCountType = {}));
/**
 * User's enrollment request for TPIA on Indeed.
 * Captures explicit user intent during job editing.
 */
export var TpiaEnrollmentRequest;
(function (TpiaEnrollmentRequest) {
    /**
     * User wants to enroll in TPIA on Indeed.
     * Candidates will be sent to both Indeed and ATS.
     */
    TpiaEnrollmentRequest["OptIn"] = "OPT_IN";
    /**
     * User wants to unenroll from TPIA on Indeed.
     * Candidates will only be sent to ATS.
     */
    TpiaEnrollmentRequest["OptOut"] = "OPT_OUT";
})(TpiaEnrollmentRequest || (TpiaEnrollmentRequest = {}));
/**
 * Type of TPIA integration.
 * Distinguishes between three distinct TPIA integration states.
 */
export var TpiaIntegrationType;
(function (TpiaIntegrationType) {
    /**
     * Legacy TPIA - read-only integration through career site/ATS.
     * Job came pre-configured from external ATS integration.
     */
    TpiaIntegrationType["Legacy"] = "LEGACY";
    /** No TPIA integration - standard job with EMAIL or WEBSITE apply method. */
    TpiaIntegrationType["None"] = "NONE";
    /**
     * TPIA on Indeed (M4) - bidirectional candidate sync between Indeed and ATS.
     * Employer can opt-in/opt-out of candidate management on Indeed.
     */
    TpiaIntegrationType["TpiaOnIndeed"] = "TPIA_ON_INDEED";
})(TpiaIntegrationType || (TpiaIntegrationType = {}));
/** Specifies the possible values for a TPIA On Indeed status. */
export var TpiaOnIndeedStatus;
(function (TpiaOnIndeedStatus) {
    TpiaOnIndeedStatus["OptedIn"] = "OPTED_IN";
    TpiaOnIndeedStatus["OptIn"] = "OPT_IN";
    TpiaOnIndeedStatus["OptOut"] = "OPT_OUT";
    TpiaOnIndeedStatus["PreOptOut"] = "PRE_OPT_OUT";
})(TpiaOnIndeedStatus || (TpiaOnIndeedStatus = {}));
export var TrackOnscreenAwarenessStatus;
(function (TrackOnscreenAwarenessStatus) {
    TrackOnscreenAwarenessStatus["Failure"] = "FAILURE";
    TrackOnscreenAwarenessStatus["Success"] = "SUCCESS";
})(TrackOnscreenAwarenessStatus || (TrackOnscreenAwarenessStatus = {}));
/** Tracking key type */
export var TrackingKeyType;
(function (TrackingKeyType) {
    TrackingKeyType["BillableEventTrackingKey"] = "BILLABLE_EVENT_TRACKING_KEY";
    TrackingKeyType["CustomizedTrackingKey"] = "CUSTOMIZED_TRACKING_KEY";
    TrackingKeyType["JobResultTrackingKey"] = "JOB_RESULT_TRACKING_KEY";
    TrackingKeyType["JobSearchTrackingKey"] = "JOB_SEARCH_TRACKING_KEY";
})(TrackingKeyType || (TrackingKeyType = {}));
/** Type of tracking metadata for analytics and routing */
export var TrackingMetadataType;
(function (TrackingMetadataType) {
    /** Next Best Action identifier */
    TrackingMetadataType["Nba"] = "NBA";
    /** Suggestion identifier */
    TrackingMetadataType["Suggestion"] = "SUGGESTION";
})(TrackingMetadataType || (TrackingMetadataType = {}));
/** Type of Traffic light signal */
export var TrafficLightSignal;
(function (TrafficLightSignal) {
    TrafficLightSignal["HighCoverageGreen"] = "HIGH_COVERAGE_GREEN";
    TrafficLightSignal["HighCoverageRed"] = "HIGH_COVERAGE_RED";
    TrafficLightSignal["HighPrecisionGreen"] = "HIGH_PRECISION_GREEN";
    TrafficLightSignal["HighPrecisionRed"] = "HIGH_PRECISION_RED";
    TrafficLightSignal["Unknown"] = "UNKNOWN";
    TrafficLightSignal["Yellow"] = "YELLOW";
})(TrafficLightSignal || (TrafficLightSignal = {}));
export var TransactionStatus;
(function (TransactionStatus) {
    TransactionStatus["Canceled"] = "CANCELED";
    TransactionStatus["Completed"] = "COMPLETED";
    TransactionStatus["Failed"] = "FAILED";
    TransactionStatus["Pending"] = "PENDING";
    TransactionStatus["Processing"] = "PROCESSING";
})(TransactionStatus || (TransactionStatus = {}));
/** The reason a trial subscription is ineligible */
export var TrialIneligibilityReason;
(function (TrialIneligibilityReason) {
    TrialIneligibilityReason["DisallowedAdvertiserId"] = "DISALLOWED_ADVERTISER_ID";
    TrialIneligibilityReason["DisallowedBillingCountry"] = "DISALLOWED_BILLING_COUNTRY";
    TrialIneligibilityReason["HasAssignedSubscription"] = "HAS_ASSIGNED_SUBSCRIPTION";
    TrialIneligibilityReason["HasEnterprisePlan"] = "HAS_ENTERPRISE_PLAN";
    TrialIneligibilityReason["NoBilling"] = "NO_BILLING";
    TrialIneligibilityReason["ServerError"] = "SERVER_ERROR";
    TrialIneligibilityReason["TrialAlreadyExists"] = "TRIAL_ALREADY_EXISTS";
})(TrialIneligibilityReason || (TrialIneligibilityReason = {}));
/** Acceptance status of a triggerAtsFullSync request. */
export var TriggerSyncStatus;
(function (TriggerSyncStatus) {
    /** The sync was dispatched to a background worker. */
    TriggerSyncStatus["Accepted"] = "ACCEPTED";
    /** The sync was not dispatched (e.g. invalid request). */
    TriggerSyncStatus["Rejected"] = "REJECTED";
})(TriggerSyncStatus || (TriggerSyncStatus = {}));
export var TrustTypeEnum;
(function (TrustTypeEnum) {
    TrustTypeEnum["CashManagementTrust"] = "CASH_MANAGEMENT_TRUST";
    TrustTypeEnum["CorporateUnitTrust"] = "CORPORATE_UNIT_TRUST";
    TrustTypeEnum["DeceasedEstate"] = "DECEASED_ESTATE";
    TrustTypeEnum["DiscretionaryInvestmentTrust"] = "DISCRETIONARY_INVESTMENT_TRUST";
    TrustTypeEnum["DiscretionaryServicesManagementTrust"] = "DISCRETIONARY_SERVICES_MANAGEMENT_TRUST";
    TrustTypeEnum["DiscretionaryTradingTrust"] = "DISCRETIONARY_TRADING_TRUST";
    TrustTypeEnum["FirstHomeSaverAccountsTrust"] = "FIRST_HOME_SAVER_ACCOUNTS_TRUST";
    TrustTypeEnum["FixedTrust"] = "FIXED_TRUST";
    TrustTypeEnum["FixedUnitTrust"] = "FIXED_UNIT_TRUST";
    TrustTypeEnum["HybridTrust"] = "HYBRID_TRUST";
    TrustTypeEnum["ListedPublicUnitTrust"] = "LISTED_PUBLIC_UNIT_TRUST";
    TrustTypeEnum["OtherTrust"] = "OTHER_TRUST";
    TrustTypeEnum["PooledSuperannuationTrust"] = "POOLED_SUPERANNUATION_TRUST";
    TrustTypeEnum["PublicTradingTrust"] = "PUBLIC_TRADING_TRUST";
    TrustTypeEnum["UnlistedPublicUnitTrust"] = "UNLISTED_PUBLIC_UNIT_TRUST";
})(TrustTypeEnum || (TrustTypeEnum = {}));
/** Enum for TypeOfPrivacyRequest */
export var TypeOfPrivacyRequest;
(function (TypeOfPrivacyRequest) {
    /** Take request */
    TypeOfPrivacyRequest["Access"] = "ACCESS";
    /** Sanitize request */
    TypeOfPrivacyRequest["Erasure"] = "ERASURE";
})(TypeOfPrivacyRequest || (TypeOfPrivacyRequest = {}));
/** Surfaced so clients can rely on a typed value instead of parsing untyped key/value metadata. */
export var TypedChatMetadataKey;
(function (TypedChatMetadataKey) {
    /**
     * The job seeker's account key.
     * @deprecated Transitional tech debt: a bridge while messaging core moves away from participant roles. Do not depend on or set JS_ACCOUNT_KEY — it is slated for removal.
     */
    TypedChatMetadataKey["JsAccountKey"] = "JS_ACCOUNT_KEY";
})(TypedChatMetadataKey || (TypedChatMetadataKey = {}));
/** Subcategory for why a notification was not delivered */
export var UndeliveredStatus;
(function (UndeliveredStatus) {
    /** Excluded by A/B test */
    UndeliveredStatus["ABTest"] = "A_B_TEST";
    /** Duplicate notification detected */
    UndeliveredStatus["Duplicate"] = "DUPLICATE";
    /** Explicitly excluded */
    UndeliveredStatus["Excluded"] = "EXCLUDED";
    /** Campaign in invalid state */
    UndeliveredStatus["InvalidCampaignState"] = "INVALID_CAMPAIGN_STATE";
    /** Missing required data */
    UndeliveredStatus["MissingData"] = "MISSING_DATA";
    /** Missing recipient contact information */
    UndeliveredStatus["MissingRecipientData"] = "MISSING_RECIPIENT_DATA";
    /** User opted out of this notification type */
    UndeliveredStatus["OptOut"] = "OPT_OUT";
    /** User preferences prevented delivery */
    UndeliveredStatus["Preference"] = "PREFERENCE";
    /** Template rendering failed */
    UndeliveredStatus["RenderingFailed"] = "RENDERING_FAILED";
    /** Retry attempts exhausted */
    UndeliveredStatus["RetryExhausted"] = "RETRY_EXHAUSTED";
    /** Notification exceeded send limit */
    UndeliveredStatus["SendLimit"] = "SEND_LIMIT";
    /** Uncaught exception during processing */
    UndeliveredStatus["UncaughtException"] = "UNCAUGHT_EXCEPTION";
    /** Unknown or unspecified reason */
    UndeliveredStatus["Unknown"] = "UNKNOWN";
})(UndeliveredStatus || (UndeliveredStatus = {}));
/** List type of Unified IDs that are supported by the endpoint */
export var UnifiedAccountType;
(function (UnifiedAccountType) {
    UnifiedAccountType["Glassdoor"] = "GLASSDOOR";
    UnifiedAccountType["Indeed"] = "INDEED";
})(UnifiedAccountType || (UnifiedAccountType = {}));
/**  Available advertiser types for unified sourcing queries  */
export var UnifiedSourcingAdvertiserType;
(function (UnifiedSourcingAdvertiserType) {
    UnifiedSourcingAdvertiserType["Job"] = "JOB";
    UnifiedSourcingAdvertiserType["Recruiter"] = "RECRUITER";
})(UnifiedSourcingAdvertiserType || (UnifiedSourcingAdvertiserType = {}));
/**  Available measure filters for unified sourcing queries  */
export var UnifiedSourcingMeasureFilterMember;
(function (UnifiedSourcingMeasureFilterMember) {
    UnifiedSourcingMeasureFilterMember["AllContacts"] = "ALL_CONTACTS";
    UnifiedSourcingMeasureFilterMember["AllResponsesCount"] = "ALL_RESPONSES_COUNT";
    UnifiedSourcingMeasureFilterMember["ApplyCount"] = "APPLY_COUNT";
    UnifiedSourcingMeasureFilterMember["ApplyStartCount"] = "APPLY_START_COUNT";
    UnifiedSourcingMeasureFilterMember["FreeContacts"] = "FREE_CONTACTS";
    UnifiedSourcingMeasureFilterMember["MatchPageViewCount"] = "MATCH_PAGE_VIEW_COUNT";
    UnifiedSourcingMeasureFilterMember["OverallResponseRate"] = "OVERALL_RESPONSE_RATE";
    UnifiedSourcingMeasureFilterMember["PositiveResponsesCount"] = "POSITIVE_RESPONSES_COUNT";
    UnifiedSourcingMeasureFilterMember["PositiveResponseRate"] = "POSITIVE_RESPONSE_RATE";
    UnifiedSourcingMeasureFilterMember["Searches"] = "SEARCHES";
    UnifiedSourcingMeasureFilterMember["SharedContacts"] = "SHARED_CONTACTS";
    UnifiedSourcingMeasureFilterMember["UnsentContacts"] = "UNSENT_CONTACTS";
    UnifiedSourcingMeasureFilterMember["Views"] = "VIEWS";
})(UnifiedSourcingMeasureFilterMember || (UnifiedSourcingMeasureFilterMember = {}));
/**  Available sorting capabilities for unified sourcing queries  */
export var UnifiedSourcingOrderByField;
(function (UnifiedSourcingOrderByField) {
    UnifiedSourcingOrderByField["ActivityDate"] = "ACTIVITY_DATE";
    UnifiedSourcingOrderByField["AiContactCount"] = "AI_CONTACT_COUNT";
    UnifiedSourcingOrderByField["AiPositiveResponsesCount"] = "AI_POSITIVE_RESPONSES_COUNT";
    UnifiedSourcingOrderByField["AiPositiveResponseRate"] = "AI_POSITIVE_RESPONSE_RATE";
    UnifiedSourcingOrderByField["AiResponsesCount"] = "AI_RESPONSES_COUNT";
    UnifiedSourcingOrderByField["AiResponseRate"] = "AI_RESPONSE_RATE";
    UnifiedSourcingOrderByField["AllContacts"] = "ALL_CONTACTS";
    UnifiedSourcingOrderByField["AllResponsesCount"] = "ALL_RESPONSES_COUNT";
    UnifiedSourcingOrderByField["ApplyCount"] = "APPLY_COUNT";
    UnifiedSourcingOrderByField["ApplyStartCount"] = "APPLY_START_COUNT";
    UnifiedSourcingOrderByField["CompanyName"] = "COMPANY_NAME";
    UnifiedSourcingOrderByField["CustomContactCount"] = "CUSTOM_CONTACT_COUNT";
    UnifiedSourcingOrderByField["CustomPositiveResponsesCount"] = "CUSTOM_POSITIVE_RESPONSES_COUNT";
    UnifiedSourcingOrderByField["CustomPositiveResponseRate"] = "CUSTOM_POSITIVE_RESPONSE_RATE";
    UnifiedSourcingOrderByField["CustomResponsesCount"] = "CUSTOM_RESPONSES_COUNT";
    UnifiedSourcingOrderByField["CustomResponseRate"] = "CUSTOM_RESPONSE_RATE";
    UnifiedSourcingOrderByField["FirstIndexedDate"] = "FIRST_INDEXED_DATE";
    UnifiedSourcingOrderByField["FreeContacts"] = "FREE_CONTACTS";
    UnifiedSourcingOrderByField["JobReferenceNumber"] = "JOB_REFERENCE_NUMBER";
    UnifiedSourcingOrderByField["JobTitle"] = "JOB_TITLE";
    UnifiedSourcingOrderByField["LastUpdatedDate"] = "LAST_UPDATED_DATE";
    UnifiedSourcingOrderByField["MatchPageViewCount"] = "MATCH_PAGE_VIEW_COUNT";
    UnifiedSourcingOrderByField["OverallResponseRate"] = "OVERALL_RESPONSE_RATE";
    UnifiedSourcingOrderByField["PositiveResponsesCount"] = "POSITIVE_RESPONSES_COUNT";
    UnifiedSourcingOrderByField["PositiveResponseRate"] = "POSITIVE_RESPONSE_RATE";
    UnifiedSourcingOrderByField["RecruiterEmail"] = "RECRUITER_EMAIL";
    UnifiedSourcingOrderByField["Searches"] = "SEARCHES";
    UnifiedSourcingOrderByField["SharedContacts"] = "SHARED_CONTACTS";
    UnifiedSourcingOrderByField["SrcAstContactCount"] = "SRC_AST_CONTACT_COUNT";
    UnifiedSourcingOrderByField["SrcAstPositiveResponsesCount"] = "SRC_AST_POSITIVE_RESPONSES_COUNT";
    UnifiedSourcingOrderByField["SrcAstPositiveResponseRate"] = "SRC_AST_POSITIVE_RESPONSE_RATE";
    UnifiedSourcingOrderByField["SrcAstResponsesCount"] = "SRC_AST_RESPONSES_COUNT";
    UnifiedSourcingOrderByField["SrcAstResponseRate"] = "SRC_AST_RESPONSE_RATE";
    UnifiedSourcingOrderByField["SubscriptionTier"] = "SUBSCRIPTION_TIER";
    UnifiedSourcingOrderByField["TemplateContactCount"] = "TEMPLATE_CONTACT_COUNT";
    UnifiedSourcingOrderByField["TemplatePositiveResponsesCount"] = "TEMPLATE_POSITIVE_RESPONSES_COUNT";
    UnifiedSourcingOrderByField["TemplatePositiveResponseRate"] = "TEMPLATE_POSITIVE_RESPONSE_RATE";
    UnifiedSourcingOrderByField["TemplateResponsesCount"] = "TEMPLATE_RESPONSES_COUNT";
    UnifiedSourcingOrderByField["TemplateResponseRate"] = "TEMPLATE_RESPONSE_RATE";
    UnifiedSourcingOrderByField["TopDeclineReason"] = "TOP_DECLINE_REASON";
    UnifiedSourcingOrderByField["UnsentContacts"] = "UNSENT_CONTACTS";
    UnifiedSourcingOrderByField["Views"] = "VIEWS";
})(UnifiedSourcingOrderByField || (UnifiedSourcingOrderByField = {}));
export var UnitOfWork;
(function (UnitOfWork) {
    UnitOfWork["Biweek"] = "BIWEEK";
    UnitOfWork["Day"] = "DAY";
    UnitOfWork["Hour"] = "HOUR";
    UnitOfWork["Month"] = "MONTH";
    UnitOfWork["Quarter"] = "QUARTER";
    UnitOfWork["Week"] = "WEEK";
    UnitOfWork["Year"] = "YEAR";
})(UnitOfWork || (UnitOfWork = {}));
export var UpdateCoWorkerProfileAction;
(function (UpdateCoWorkerProfileAction) {
    UpdateCoWorkerProfileAction["Undo"] = "UNDO";
    UpdateCoWorkerProfileAction["Update"] = "UPDATE";
})(UpdateCoWorkerProfileAction || (UpdateCoWorkerProfileAction = {}));
export var UpdateEmployerUserAccessRequestAction;
(function (UpdateEmployerUserAccessRequestAction) {
    UpdateEmployerUserAccessRequestAction["Approve"] = "APPROVE";
    UpdateEmployerUserAccessRequestAction["Deny"] = "DENY";
})(UpdateEmployerUserAccessRequestAction || (UpdateEmployerUserAccessRequestAction = {}));
export var UpdateMatchProfileDocumentStatus;
(function (UpdateMatchProfileDocumentStatus) {
    UpdateMatchProfileDocumentStatus["CriteriaEmpty"] = "CRITERIA_EMPTY";
    UpdateMatchProfileDocumentStatus["Error"] = "ERROR";
    UpdateMatchProfileDocumentStatus["Flagged"] = "FLAGGED";
    UpdateMatchProfileDocumentStatus["Success"] = "SUCCESS";
})(UpdateMatchProfileDocumentStatus || (UpdateMatchProfileDocumentStatus = {}));
/** Enum representing the source of company updates. */
export var UpdateSourceType;
(function (UpdateSourceType) {
    /** Both Indeed and Glassdoor updates */
    UpdateSourceType["Any"] = "ANY";
    /** Glassdoor-managed updates (UIDs starting with #) */
    UpdateSourceType["Glassdoor"] = "GLASSDOOR";
    /** Indeed-managed updates (UIDs not starting with #) */
    UpdateSourceType["Indeed"] = "INDEED";
})(UpdateSourceType || (UpdateSourceType = {}));
/**
 * Enum for Company News Status
 * SHOW is an active company News entry that will be returned by the service. DELETED News entries are hidden
 */
export var UpdateStatus;
(function (UpdateStatus) {
    UpdateStatus["Deleted"] = "DELETED";
    UpdateStatus["Show"] = "SHOW";
})(UpdateStatus || (UpdateStatus = {}));
export var UpdateSubscriptionStatusResult;
(function (UpdateSubscriptionStatusResult) {
    /** Subscription status has failed to update */
    UpdateSubscriptionStatusResult["Failure"] = "FAILURE";
    /** Subscription status has been updated successful */
    UpdateSubscriptionStatusResult["Success"] = "SUCCESS";
})(UpdateSubscriptionStatusResult || (UpdateSubscriptionStatusResult = {}));
export var UploadIoResponseStatus;
(function (UploadIoResponseStatus) {
    UploadIoResponseStatus["BadRequest"] = "BAD_REQUEST";
    UploadIoResponseStatus["InternalServerError"] = "INTERNAL_SERVER_ERROR";
    UploadIoResponseStatus["Success"] = "SUCCESS";
})(UploadIoResponseStatus || (UploadIoResponseStatus = {}));
/** Uploaded files status types */
export var UploadedDocumentStatus;
(function (UploadedDocumentStatus) {
    UploadedDocumentStatus["Deleted"] = "DELETED";
    UploadedDocumentStatus["Uploaded"] = "UPLOADED";
})(UploadedDocumentStatus || (UploadedDocumentStatus = {}));
/** Variants of the UrgentHire optimization */
export var UrgentHireOptimizationVariant;
(function (UrgentHireOptimizationVariant) {
    /** @deprecated Urgent Hire optimization is deprecated */
    UrgentHireOptimizationVariant["UrgentHireOptimizationVariantDefault"] = "URGENT_HIRE_OPTIMIZATION_VARIANT_DEFAULT";
})(UrgentHireOptimizationVariant || (UrgentHireOptimizationVariant = {}));
/**  Available usage categories for unified sourcing */
export var UsageCategory;
(function (UsageCategory) {
    UsageCategory["All"] = "ALL";
    UsageCategory["AllNonAi"] = "ALL_NON_AI";
    UsageCategory["Combined"] = "COMBINED";
    UsageCategory["CombinedAiSrcAst"] = "COMBINED_AI_SRC_AST";
    UsageCategory["MatchedCandidate"] = "MATCHED_CANDIDATE";
    UsageCategory["MatchedCandidateAiSrcAst"] = "MATCHED_CANDIDATE_AI_SRC_AST";
    UsageCategory["ResumeSearch"] = "RESUME_SEARCH";
    UsageCategory["ResumeSearchAiSrcAst"] = "RESUME_SEARCH_AI_SRC_AST";
    UsageCategory["Spend"] = "SPEND";
    UsageCategory["SpendAiSrcAst"] = "SPEND_AI_SRC_AST";
})(UsageCategory || (UsageCategory = {}));
/** User-defined question match types */
export var UserDefinedQualificationQuestionMatchType;
(function (UserDefinedQualificationQuestionMatchType) {
    UserDefinedQualificationQuestionMatchType["All"] = "ALL";
    UserDefinedQualificationQuestionMatchType["Any"] = "ANY";
})(UserDefinedQualificationQuestionMatchType || (UserDefinedQualificationQuestionMatchType = {}));
/** User-defined question requirement types */
export var UserDefinedQualificationQuestionQualificationType;
(function (UserDefinedQualificationQuestionQualificationType) {
    UserDefinedQualificationQuestionQualificationType["Knockout"] = "KNOCKOUT";
    UserDefinedQualificationQuestionQualificationType["Nonblocking"] = "NONBLOCKING";
})(UserDefinedQualificationQuestionQualificationType || (UserDefinedQualificationQuestionQualificationType = {}));
/**
 * GraphQL Schema Basics: https://www.apollographql.com/docs/apollo-server/schema/schema/
 * Indeed API Recommendations: https://link.indeed.tech/api-recommendations
 *
 * Need help designing your schema? Check out the schema designer tool: https://graphql-schema-designer.sandbox.indeed.net/
 */
export var UserIdType;
(function (UserIdType) {
    UserIdType["AccountId"] = "ACCOUNT_ID";
    UserIdType["Ctk"] = "CTK";
    UserIdType["JobId"] = "JOB_ID";
    UserIdType["TalentScoutTurnSlotId"] = "TALENT_SCOUT_TURN_SLOT_ID";
})(UserIdType || (UserIdType = {}));
/** Defines field types for user interaction custom logs */
export var UserInteractionCustomLogFieldType;
(function (UserInteractionCustomLogFieldType) {
    UserInteractionCustomLogFieldType["ArrayBoolean"] = "ARRAY_BOOLEAN";
    UserInteractionCustomLogFieldType["ArrayFloat"] = "ARRAY_FLOAT";
    UserInteractionCustomLogFieldType["ArrayInt"] = "ARRAY_INT";
    UserInteractionCustomLogFieldType["ArrayString"] = "ARRAY_STRING";
    UserInteractionCustomLogFieldType["Boolean"] = "BOOLEAN";
    UserInteractionCustomLogFieldType["Flag"] = "FLAG";
    UserInteractionCustomLogFieldType["Float"] = "FLOAT";
    UserInteractionCustomLogFieldType["Int"] = "INT";
    UserInteractionCustomLogFieldType["String"] = "STRING";
})(UserInteractionCustomLogFieldType || (UserInteractionCustomLogFieldType = {}));
export var UserInteractionSurface;
(function (UserInteractionSurface) {
    /** homepage */
    UserInteractionSurface["Hpclassic"] = "HPCLASSIC";
    /** serp mobile */
    UserInteractionSurface["Serp"] = "SERP";
    /** serp desktop */
    UserInteractionSurface["Serpglobal"] = "SERPGLOBAL";
})(UserInteractionSurface || (UserInteractionSurface = {}));
/** Defines selectable types for user interface flag */
export var UserInterfaceFlag;
(function (UserInterfaceFlag) {
    UserInterfaceFlag["HumanInteractionDetected"] = "HumanInteractionDetected";
    UserInterfaceFlag["WidgetInteracted"] = "WidgetInteracted";
    UserInterfaceFlag["WidgetInteractionCompleted"] = "WidgetInteractionCompleted";
})(UserInterfaceFlag || (UserInterfaceFlag = {}));
/** Defines the job status state for the job */
export var UserJobStatusState;
(function (UserJobStatusState) {
    UserJobStatusState["Archived"] = "ARCHIVED";
    UserJobStatusState["Deleted"] = "DELETED";
    UserJobStatusState["PostApply"] = "POST_APPLY";
    UserJobStatusState["Saved"] = "SAVED";
    UserJobStatusState["Visited"] = "VISITED";
})(UserJobStatusState || (UserJobStatusState = {}));
/** User Roles of the  user access */
export var UserRole;
(function (UserRole) {
    UserRole["Admin"] = "ADMIN";
    UserRole["Operator"] = "OPERATOR";
    UserRole["Viewer"] = "VIEWER";
})(UserRole || (UserRole = {}));
export var UtilizationIssuanceType;
(function (UtilizationIssuanceType) {
    UtilizationIssuanceType["IdVerification"] = "ID_VERIFICATION";
    UtilizationIssuanceType["LicenseVerification"] = "LICENSE_VERIFICATION";
})(UtilizationIssuanceType || (UtilizationIssuanceType = {}));
/** Validation error types for a billing account */
export var ValidationError;
(function (ValidationError) {
    ValidationError["BillingSyncError"] = "BILLING_SYNC_ERROR";
})(ValidationError || (ValidationError = {}));
export var ValidationResultValue;
(function (ValidationResultValue) {
    ValidationResultValue["Failure"] = "FAILURE";
    ValidationResultValue["Success"] = "SUCCESS";
})(ValidationResultValue || (ValidationResultValue = {}));
export var ValidationRuleEnum;
(function (ValidationRuleEnum) {
    ValidationRuleEnum["Required"] = "REQUIRED";
    ValidationRuleEnum["Restricted"] = "RESTRICTED";
})(ValidationRuleEnum || (ValidationRuleEnum = {}));
/**
 * Enum representing the high level availability/reason of verification for an employer.
 * These indicate if an employer should be directed to verify due to being in a state with reduced privileges.
 * See value documentation for details.
 */
export var VerificationAvailability;
(function (VerificationAvailability) {
    /**
     * Indicates that the employer attempted but failed verification,
     * but is allowed to make another attempt with additional information or via another verification option.
     */
    VerificationAvailability["SecondChanceEnabled"] = "SECOND_CHANCE_ENABLED";
    /**
     * Indicates that the employer has restricted features on the site and should be directed to verify
     * on the verification landing page in order to enable features that require enhanced privileges.
     */
    VerificationAvailability["VerificationRequired"] = "VERIFICATION_REQUIRED";
})(VerificationAvailability || (VerificationAvailability = {}));
/**
 * Categories of legal acknowledgements the system can require before a
 * verification option is started. New categories (e.g., a future Canadian
 * Quebec exclusion) are additive — existing values keep their meaning.
 */
export var VerificationLegalAcknowledgement;
(function (VerificationLegalAcknowledgement) {
    /**
     * Triggered for biometric verification options (ID.me, Persona) when any
     * user-jurisdiction signal indicates US. The user must attest they are not
     * located in Illinois, Texas, or Washington — the three states with BIPA-style
     * biometric privacy statutes.
     */
    VerificationLegalAcknowledgement["UsBiometricStateExclusion"] = "US_BIOMETRIC_STATE_EXCLUSION";
})(VerificationLegalAcknowledgement || (VerificationLegalAcknowledgement = {}));
export var VerifyEmployerOtpError;
(function (VerifyEmployerOtpError) {
    VerifyEmployerOtpError["InvalidOtp"] = "INVALID_OTP";
    VerifyEmployerOtpError["OtpExpired"] = "OTP_EXPIRED";
    VerifyEmployerOtpError["RetriesLimitReached"] = "RETRIES_LIMIT_REACHED";
    VerifyEmployerOtpError["SessionExpired"] = "SESSION_EXPIRED";
})(VerifyEmployerOtpError || (VerifyEmployerOtpError = {}));
export var Version;
(function (Version) {
    Version["V1"] = "V1";
    Version["V2"] = "V2";
})(Version || (Version = {}));
/** Enumeration of video availability values */
export var VideoAvailability;
(function (VideoAvailability) {
    VideoAvailability["Permanent"] = "PERMANENT";
    VideoAvailability["Temp"] = "TEMP";
})(VideoAvailability || (VideoAvailability = {}));
export var ViewJobRemoteWorkType;
(function (ViewJobRemoteWorkType) {
    ViewJobRemoteWorkType["RemoteAlways"] = "REMOTE_ALWAYS";
    ViewJobRemoteWorkType["RemoteCovidTemporary"] = "REMOTE_COVID_TEMPORARY";
    ViewJobRemoteWorkType["RemoteHybrid"] = "REMOTE_HYBRID";
})(ViewJobRemoteWorkType || (ViewJobRemoteWorkType = {}));
/**
 * Enum representing how violation was caused
 * Determined based on Violation Reason and location-based rules
 */
export var ViolationCause;
(function (ViolationCause) {
    ViolationCause["ShorterThanMinDuration"] = "SHORTER_THAN_MIN_DURATION";
    ViolationCause["Skipped"] = "SKIPPED";
    ViolationCause["StartedTooLate"] = "STARTED_TOO_LATE";
    ViolationCause["Unknown"] = "UNKNOWN";
})(ViolationCause || (ViolationCause = {}));
/** Category of reason why a violation occurred */
export var ViolationReason;
(function (ViolationReason) {
    ViolationReason["Involuntary"] = "INVOLUNTARY";
    ViolationReason["Voluntary"] = "VOLUNTARY";
})(ViolationReason || (ViolationReason = {}));
/** The type of job identifier given for a job, see https://indeed.atlassian.net/wiki/x/xrloEQ for more information */
export var VoldemortJobIdType;
(function (VoldemortJobIdType) {
    /** Encrypted aggJobId */
    VoldemortJobIdType["JobKey"] = "JOB_KEY";
    /** A job that is not listed on Indeed yet */
    VoldemortJobIdType["ProspectiveJobId"] = "PROSPECTIVE_JOB_ID";
})(VoldemortJobIdType || (VoldemortJobIdType = {}));
/** The time interval that a salary is paid */
export var VoldemortSalaryPayPeriod;
(function (VoldemortSalaryPayPeriod) {
    VoldemortSalaryPayPeriod["Day"] = "DAY";
    VoldemortSalaryPayPeriod["Hour"] = "HOUR";
    VoldemortSalaryPayPeriod["Month"] = "MONTH";
    VoldemortSalaryPayPeriod["Week"] = "WEEK";
    VoldemortSalaryPayPeriod["Year"] = "YEAR";
})(VoldemortSalaryPayPeriod || (VoldemortSalaryPayPeriod = {}));
export var WhatsAppUrlType;
(function (WhatsAppUrlType) {
    /** Apply URL Type */
    WhatsAppUrlType["Apply"] = "APPLY";
    /** Feedback Form URL Type */
    WhatsAppUrlType["FeedbackForm"] = "FEEDBACK_FORM";
})(WhatsAppUrlType || (WhatsAppUrlType = {}));
/**
 * Identifies which advertisers were affected by a `withdrawEmployerConsent`
 * call. Mirrors the `cascade` flag on the input: `CASCADE` when the call
 * extended to EHS descendants of the supplied advertiser, `SELF` when only the
 * supplied advertiser was withdrawn. The supplied advertiser may sit at any
 * position in the EHS hierarchy — root, intermediate, or leaf — so the scope
 * no longer depends on the advertiser's position in the tree.
 */
export var WithdrawalScope;
(function (WithdrawalScope) {
    /**
     * The supplied advertiser **and** every descendant under it in the EHS
     * hierarchy with an existing Employer Terms consent were withdrawn.
     * Returned when the caller set `cascade: true` on the input.
     */
    WithdrawalScope["Cascade"] = "CASCADE";
    /**
     * Only the supplied advertiser was withdrawn; ancestors and descendants
     * were untouched. Other advertisers in the hierarchy with their own active
     * consent remain compliant; descendants that previously inherited consent
     * from the supplied advertiser become non-compliant for forward-looking
     * evaluation. Returned when `cascade: false` (the default).
     */
    WithdrawalScope["Self"] = "SELF";
})(WithdrawalScope || (WithdrawalScope = {}));
export var WorkWeekEnd;
(function (WorkWeekEnd) {
    WorkWeekEnd["Friday"] = "FRIDAY";
    WorkWeekEnd["Monday"] = "MONDAY";
    WorkWeekEnd["Saturday"] = "SATURDAY";
    WorkWeekEnd["Sunday"] = "SUNDAY";
    WorkWeekEnd["Thursday"] = "THURSDAY";
    WorkWeekEnd["Tuesday"] = "TUESDAY";
    WorkWeekEnd["Wednesday"] = "WEDNESDAY";
})(WorkWeekEnd || (WorkWeekEnd = {}));
/** Authentication method used to authenticate with Workday */
export var WorkdayAuthenticationMethod;
(function (WorkdayAuthenticationMethod) {
    /** Authentication using machine secret with integration client ID, client secret, and refresh token */
    WorkdayAuthenticationMethod["MachineSecret"] = "MACHINE_SECRET";
    /**
     * Authentication using a public key with client ID and ISU name
     * @deprecated Use PUBLIC_KEY_EXPIRING_2026 or PUBLIC_KEY_EXPIRING_2027 instead.
     */
    WorkdayAuthenticationMethod["PublicKey"] = "PUBLIC_KEY";
    /** Legacy authentication using public key / JWT expiring in 2026 */
    WorkdayAuthenticationMethod["PublicKeyExpiring_2026"] = "PUBLIC_KEY_EXPIRING_2026";
    /** Legacy authentication using public key / JWT expiring in 2027 */
    WorkdayAuthenticationMethod["PublicKeyExpiring_2027"] = "PUBLIC_KEY_EXPIRING_2027";
    /** Authentication method is not recognized or not set */
    WorkdayAuthenticationMethod["Unknown"] = "UNKNOWN";
})(WorkdayAuthenticationMethod || (WorkdayAuthenticationMethod = {}));
/** Options for the source of location information for Workday jobs */
export var WorkdayJobLocationSource;
(function (WorkdayJobLocationSource) {
    /** Use the location information from the job posting */
    WorkdayJobLocationSource["JobPosting"] = "JOB_POSTING";
    /** Use the location information from the job requisition */
    WorkdayJobLocationSource["Requisition"] = "REQUISITION";
})(WorkdayJobLocationSource || (WorkdayJobLocationSource = {}));
/** Reasons why a WorkedShift may be flagged for review */
export var WorkedShiftFlaggedForReviewReason;
(function (WorkedShiftFlaggedForReviewReason) {
    WorkedShiftFlaggedForReviewReason["LocationClockInMissingGeolocation"] = "LOCATION_CLOCK_IN_MISSING_GEOLOCATION";
    WorkedShiftFlaggedForReviewReason["LocationClockInOutsideGeofence"] = "LOCATION_CLOCK_IN_OUTSIDE_GEOFENCE";
    WorkedShiftFlaggedForReviewReason["LocationClockOutMissingGeolocation"] = "LOCATION_CLOCK_OUT_MISSING_GEOLOCATION";
    WorkedShiftFlaggedForReviewReason["LocationClockOutOutsideGeofence"] = "LOCATION_CLOCK_OUT_OUTSIDE_GEOFENCE";
    WorkedShiftFlaggedForReviewReason["NoShowWithWorkerTime"] = "NO_SHOW_WITH_WORKER_TIME";
    WorkedShiftFlaggedForReviewReason["TimeTooDiffWithClientTime"] = "TIME_TOO_DIFF_WITH_CLIENT_TIME";
    WorkedShiftFlaggedForReviewReason["TimeTooDiffWithScheduledShift"] = "TIME_TOO_DIFF_WITH_SCHEDULED_SHIFT";
})(WorkedShiftFlaggedForReviewReason || (WorkedShiftFlaggedForReviewReason = {}));
/**
 * Discriminator enum for different types of Worker Home UI elements.
 * Used by clients to determine which component to render.
 */
export var WorkerHomeElementType;
(function (WorkerHomeElementType) {
    /** Text element with optional icon */
    WorkerHomeElementType["Banner"] = "BANNER";
    /** General-purpose card with title, message, and button */
    WorkerHomeElementType["Card"] = "CARD";
    /** Marketing/promotional card with illustration */
    WorkerHomeElementType["FeatureCard"] = "FEATURE_CARD";
    /** Informational bar with optional text button */
    WorkerHomeElementType["InfoBar"] = "INFO_BAR";
    /** Interview appointment details card */
    WorkerHomeElementType["InterviewCard"] = "INTERVIEW_CARD";
    /** Detailed job/shift information card */
    WorkerHomeElementType["JobCard"] = "JOB_CARD";
    /** Group of interactive list items */
    WorkerHomeElementType["ListItemGroup"] = "LIST_ITEM_GROUP";
    /** Multi-step progress tracker with states */
    WorkerHomeElementType["ListStepper"] = "LIST_STEPPER";
    /** Placement onboarding card */
    WorkerHomeElementType["PlacementCard"] = "PLACEMENT_CARD";
    /** Simple text element */
    WorkerHomeElementType["Text"] = "TEXT";
    /** Horizontal scrolling carousel of video cards */
    WorkerHomeElementType["VideoCarousel"] = "VIDEO_CAROUSEL";
})(WorkerHomeElementType || (WorkerHomeElementType = {}));
/** Workflow created sources */
export var WorkflowCreatedSource;
(function (WorkflowCreatedSource) {
    WorkflowCreatedSource["Ers"] = "ERS";
    WorkflowCreatedSource["Evaluate"] = "EVALUATE";
    WorkflowCreatedSource["HostedJob"] = "HOSTED_JOB";
    WorkflowCreatedSource["IhpSimpleScreening"] = "IHP_SIMPLE_SCREENING";
    WorkflowCreatedSource["IndeedHireJobPackage"] = "INDEED_HIRE_JOB_PACKAGE";
    WorkflowCreatedSource["JobLevelScreening"] = "JOB_LEVEL_SCREENING";
    WorkflowCreatedSource["Qfs"] = "QFS";
})(WorkflowCreatedSource || (WorkflowCreatedSource = {}));
/** Workflow statuses */
export var WorkflowStatus;
(function (WorkflowStatus) {
    WorkflowStatus["Active"] = "ACTIVE";
    WorkflowStatus["Approved"] = "APPROVED";
    WorkflowStatus["Disabled"] = "DISABLED";
    WorkflowStatus["Draft"] = "DRAFT";
    WorkflowStatus["Paused"] = "PAUSED";
    WorkflowStatus["PendingApproval"] = "PENDING_APPROVAL";
})(WorkflowStatus || (WorkflowStatus = {}));
/** YLQ Attribute Status */
export var YellowLightQuestionAttributeStatus;
(function (YellowLightQuestionAttributeStatus) {
    YellowLightQuestionAttributeStatus["Negative"] = "NEGATIVE";
    YellowLightQuestionAttributeStatus["None"] = "NONE";
})(YellowLightQuestionAttributeStatus || (YellowLightQuestionAttributeStatus = {}));
/** YLQ attribute types */
export var YellowLightQuestionAttributeType;
(function (YellowLightQuestionAttributeType) {
    YellowLightQuestionAttributeType["Certification"] = "CERTIFICATION";
    YellowLightQuestionAttributeType["Certifications"] = "CERTIFICATIONS";
    YellowLightQuestionAttributeType["Education"] = "EDUCATION";
    YellowLightQuestionAttributeType["Languages"] = "LANGUAGES";
    YellowLightQuestionAttributeType["License"] = "LICENSE";
    YellowLightQuestionAttributeType["Skills"] = "SKILLS";
})(YellowLightQuestionAttributeType || (YellowLightQuestionAttributeType = {}));
export var ClientFilterType;
(function (ClientFilterType) {
    /**
     * Filter for interviews displayed on the interviews tab and candidate detail pages
     * @deprecated Use INTERVIEWS_TAB_WITH_CANDIDATE_SUBMISSIONS
     */
    ClientFilterType["InterviewsTab"] = "INTERVIEWS_TAB";
    /** Filter for interviews tab including both Dradis candidates (INDEED_JOBSEEKER_ATS) and CandidateSubmissions */
    ClientFilterType["InterviewsTabWithCandidateSubmissions"] = "INTERVIEWS_TAB_WITH_CANDIDATE_SUBMISSIONS";
})(ClientFilterType || (ClientFilterType = {}));
export const BasicInfoResumeFieldsFragmentDoc = gql `
    fragment BasicInfoResumeFields on JobSeekerProfileResume {
  id
  resumeType
  firstName
  lastName
  firstNameFurigana
  lastNameFurigana
  dateOfBirth
  gender
  location {
    postalCode
    unknownLocation
    address
    address2
  }
  phoneNumber
  showPhoneNumber
}
    `;
export const EducationResumeFieldsFragmentDoc = gql `
    fragment EducationResumeFields on JobSeekerProfileResume {
  id
  resumeType
  dateOfBirth
  educations {
    id
    degree {
      id
      field
      degreeName
    }
    school
    dateRange {
      fromDate {
        month
        year
      }
      toDate {
        month
        year
      }
      isCurrent
    }
    location {
      country
      unknownLocation
    }
  }
}
    `;
export const PrefillResumeFieldsFragmentDoc = gql `
    fragment PrefillResumeFields on JobSeekerProfileResume {
  id
  resumeType
  firstName
  lastName
  firstNameFurigana
  lastNameFurigana
  gender
  dateOfBirth
  location {
    postalCode
    unknownLocation
    address
    address2
  }
  phoneNumber
  educations {
    school
    degree {
      field
    }
    dateRange {
      isCurrent
      fromDate {
        month
        year
      }
      toDate {
        month
        year
      }
    }
  }
  workExperiences {
    company
    dateRange {
      isCurrent
      fromDate {
        month
        year
      }
      toDate {
        month
        year
      }
    }
  }
}
    `;
export const WorkExperiencesResumeFieldsFragmentDoc = gql `
    fragment WorkExperiencesResumeFields on JobSeekerProfileResume {
  id
  resumeType
  workExperiences {
    id
    title
    company
    dateRange {
      isCurrent
      fromDate {
        month
        year
      }
      toDate {
        month
        year
      }
    }
  }
}
    `;
export const JobSeekerProfileAndResumeFieldsFragmentDoc = gql `
    fragment JobSeekerProfileAndResumeFields on JobSeekerProfileResume {
  id
  resumeType
  firstName
  lastName
  location {
    postalCode
    unknownLocation
  }
  phoneNumber
  summary
  educations {
    id
  }
  workExperiences {
    id
  }
}
    `;
export const ResumeIdentifierFieldsFragmentDoc = gql `
    fragment ResumeIdentifierFields on JobSeekerProfileResume {
  id
  resumeType
}
    `;
export const CreateEmptyIndeedResumeDocument = gql `
    mutation CreateEmptyIndeedResume($input: CreateEmptyJobSeekerProfileResumeInput!) {
  createEmptyJobSeekerProfileResume(input: $input) {
    resume {
      id
    }
  }
}
    `;
/**
 * __useCreateEmptyIndeedResumeMutation__
 *
 * To run a mutation, you first call `useCreateEmptyIndeedResumeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEmptyIndeedResumeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEmptyIndeedResumeMutation, { data, loading, error }] = useCreateEmptyIndeedResumeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateEmptyIndeedResumeMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(CreateEmptyIndeedResumeDocument, options);
}
export const GetBasicInfoDocument = gql `
    query GetBasicInfo($input: QueryJobSeekerProfileInput) {
  jobSeekerProfile(input: $input) {
    profile {
      defaultInfo {
        contactInformation {
          firstName
          lastName
          location {
            postalCode
            unknownLocation
            address
            address2
          }
          phoneNumber
        }
      }
      resume {
        ...BasicInfoResumeFields
      }
    }
  }
  jobSeekerResumes {
    resumes {
      resumeId
      resume {
        ...BasicInfoResumeFields
      }
    }
  }
  jobSeekerProfileDualResumesEnabled {
    allResumesEnabled
  }
}
    ${BasicInfoResumeFieldsFragmentDoc}`;
/**
 * __useGetBasicInfoQuery__
 *
 * To run a query within a React component, call `useGetBasicInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBasicInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBasicInfoQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetBasicInfoQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetBasicInfoDocument, options);
}
export function useGetBasicInfoLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetBasicInfoDocument, options);
}
export function useGetBasicInfoSuspenseQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(GetBasicInfoDocument, options);
}
export const GetEducationDocument = gql `
    query GetEducation($input: QueryJobSeekerProfileInput) {
  jobSeekerProfile(input: $input) {
    profile {
      resume {
        ...EducationResumeFields
      }
    }
  }
  jobSeekerResumes {
    resumes {
      resumeId
      resume {
        ...EducationResumeFields
      }
    }
  }
  jobSeekerProfileDualResumesEnabled {
    allResumesEnabled
  }
}
    ${EducationResumeFieldsFragmentDoc}`;
/**
 * __useGetEducationQuery__
 *
 * To run a query within a React component, call `useGetEducationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEducationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEducationQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetEducationQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetEducationDocument, options);
}
export function useGetEducationLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetEducationDocument, options);
}
export function useGetEducationSuspenseQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(GetEducationDocument, options);
}
export const GetJobSeekerProfileForPrefillDocument = gql `
    query GetJobSeekerProfileForPrefill($input: QueryJobSeekerProfileInput) {
  jobSeekerProfile(input: $input) {
    profile {
      resume {
        ...PrefillResumeFields
      }
    }
  }
  jobSeekerResumes {
    resumes {
      resumeId
      resume {
        ...PrefillResumeFields
      }
    }
  }
  jobSeekerProfileDualResumesEnabled {
    allResumesEnabled
  }
}
    ${PrefillResumeFieldsFragmentDoc}`;
/**
 * __useGetJobSeekerProfileForPrefillQuery__
 *
 * To run a query within a React component, call `useGetJobSeekerProfileForPrefillQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetJobSeekerProfileForPrefillQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetJobSeekerProfileForPrefillQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetJobSeekerProfileForPrefillQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetJobSeekerProfileForPrefillDocument, options);
}
export function useGetJobSeekerProfileForPrefillLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetJobSeekerProfileForPrefillDocument, options);
}
export function useGetJobSeekerProfileForPrefillSuspenseQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(GetJobSeekerProfileForPrefillDocument, options);
}
export const GetWorkExperiencesDocument = gql `
    query GetWorkExperiences($input: QueryJobSeekerProfileInput) {
  jobSeekerProfile(input: $input) {
    profile {
      resume {
        ...WorkExperiencesResumeFields
      }
    }
  }
  jobSeekerResumes {
    resumes {
      resumeId
      resume {
        ...WorkExperiencesResumeFields
      }
    }
  }
  jobSeekerProfileDualResumesEnabled {
    allResumesEnabled
  }
}
    ${WorkExperiencesResumeFieldsFragmentDoc}`;
/**
 * __useGetWorkExperiencesQuery__
 *
 * To run a query within a React component, call `useGetWorkExperiencesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkExperiencesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkExperiencesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetWorkExperiencesQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetWorkExperiencesDocument, options);
}
export function useGetWorkExperiencesLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetWorkExperiencesDocument, options);
}
export function useGetWorkExperiencesSuspenseQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(GetWorkExperiencesDocument, options);
}
export const GetJobSeekerProfileAndResumeDocument = gql `
    query GetJobSeekerProfileAndResume($input: QueryJobSeekerProfileInput) {
  jobSeekerProfile(input: $input) {
    profile {
      defaultInfo {
        contactInformation {
          firstName
          lastName
          location {
            postalCode
            unknownLocation
            address
            address2
          }
          phoneNumber
        }
      }
      resume {
        ...JobSeekerProfileAndResumeFields
      }
    }
  }
  jobSeekerResumes {
    resumes {
      resumeId
      resume {
        ...JobSeekerProfileAndResumeFields
      }
    }
  }
  jobSeekerProfileDualResumesEnabled {
    allResumesEnabled
  }
}
    ${JobSeekerProfileAndResumeFieldsFragmentDoc}`;
/**
 * __useGetJobSeekerProfileAndResumeQuery__
 *
 * To run a query within a React component, call `useGetJobSeekerProfileAndResumeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetJobSeekerProfileAndResumeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetJobSeekerProfileAndResumeQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetJobSeekerProfileAndResumeQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetJobSeekerProfileAndResumeDocument, options);
}
export function useGetJobSeekerProfileAndResumeLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetJobSeekerProfileAndResumeDocument, options);
}
export function useGetJobSeekerProfileAndResumeSuspenseQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(GetJobSeekerProfileAndResumeDocument, options);
}
export const GetResumeIdentifiersDocument = gql `
    query GetResumeIdentifiers($input: QueryJobSeekerProfileInput) {
  jobSeekerProfile(input: $input) {
    profile {
      resume {
        ...ResumeIdentifierFields
      }
    }
  }
  jobSeekerResumes {
    resumes {
      resumeId
      resume {
        ...ResumeIdentifierFields
      }
    }
  }
  jobSeekerProfileDualResumesEnabled {
    allResumesEnabled
  }
}
    ${ResumeIdentifierFieldsFragmentDoc}`;
/**
 * __useGetResumeIdentifiersQuery__
 *
 * To run a query within a React component, call `useGetResumeIdentifiersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetResumeIdentifiersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetResumeIdentifiersQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetResumeIdentifiersQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetResumeIdentifiersDocument, options);
}
export function useGetResumeIdentifiersLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetResumeIdentifiersDocument, options);
}
export function useGetResumeIdentifiersSuspenseQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(GetResumeIdentifiersDocument, options);
}
export const UpdateEducationsToIndeedResumeDocument = gql `
    mutation UpdateEducationsToIndeedResume($addEducationsInput: AddJobSeekerProfileEducationsInput!, $updateEducationsInput: UpdateJobSeekerProfileResumeEducationsInput!, $deleteEducationsInput: DeleteJobSeekerProfileResumeEducationsInput!) {
  addJobSeekerProfileResumeEducations(input: $addEducationsInput) {
    educations {
      id
    }
  }
  updateJobSeekerProfileResumeEducations(input: $updateEducationsInput) {
    educations {
      id
    }
  }
  deleteJobSeekerProfileResumeEducations(input: $deleteEducationsInput) {
    educationIds
  }
}
    `;
/**
 * __useUpdateEducationsToIndeedResumeMutation__
 *
 * To run a mutation, you first call `useUpdateEducationsToIndeedResumeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEducationsToIndeedResumeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEducationsToIndeedResumeMutation, { data, loading, error }] = useUpdateEducationsToIndeedResumeMutation({
 *   variables: {
 *      addEducationsInput: // value for 'addEducationsInput'
 *      updateEducationsInput: // value for 'updateEducationsInput'
 *      deleteEducationsInput: // value for 'deleteEducationsInput'
 *   },
 * });
 */
export function useUpdateEducationsToIndeedResumeMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(UpdateEducationsToIndeedResumeDocument, options);
}
export const SyncWorkExperiencesToIndeedResumeDocument = gql `
    mutation SyncWorkExperiencesToIndeedResume($addExperienceInput: AddJobSeekerProfileResumeWorkExperiencesInput!, $updateExperienceInput: UpdateJobSeekerProfileResumeWorkExperiencesInput!, $deleteExperienceInput: DeleteJobSeekerProfileResumeWorkExperiencesInput!) {
  addJobSeekerProfileResumeWorkExperiences(input: $addExperienceInput) {
    workExperiences {
      id
    }
  }
  updateJobSeekerProfileResumeWorkExperiences(input: $updateExperienceInput) {
    workExperiences {
      id
    }
  }
  deleteJobSeekerProfileResumeWorkExperiences(input: $deleteExperienceInput) {
    workExperienceIds
  }
}
    `;
/**
 * __useSyncWorkExperiencesToIndeedResumeMutation__
 *
 * To run a mutation, you first call `useSyncWorkExperiencesToIndeedResumeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSyncWorkExperiencesToIndeedResumeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [syncWorkExperiencesToIndeedResumeMutation, { data, loading, error }] = useSyncWorkExperiencesToIndeedResumeMutation({
 *   variables: {
 *      addExperienceInput: // value for 'addExperienceInput'
 *      updateExperienceInput: // value for 'updateExperienceInput'
 *      deleteExperienceInput: // value for 'deleteExperienceInput'
 *   },
 * });
 */
export function useSyncWorkExperiencesToIndeedResumeMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(SyncWorkExperiencesToIndeedResumeDocument, options);
}
export const UpdateBasicInfoDocument = gql `
    mutation UpdateBasicInfo($input: UpdateJobSeekerProfileResumeInput!) {
  updateJobSeekerProfileResume(input: $input) {
    resume {
      id
    }
  }
}
    `;
/**
 * __useUpdateBasicInfoMutation__
 *
 * To run a mutation, you first call `useUpdateBasicInfoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBasicInfoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBasicInfoMutation, { data, loading, error }] = useUpdateBasicInfoMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateBasicInfoMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(UpdateBasicInfoDocument, options);
}
export const UpdateSourcingElectionDocument = gql `
    mutation updateSourcingElection($input: UpdateSourcingElectionInput!) {
  jobSeekerProfileMutations {
    updateSourcingElection(input: $input) {
      sourcingElection
    }
  }
}
    `;
/**
 * __useUpdateSourcingElectionMutation__
 *
 * To run a mutation, you first call `useUpdateSourcingElectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSourcingElectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSourcingElectionMutation, { data, loading, error }] = useUpdateSourcingElectionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSourcingElectionMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(UpdateSourcingElectionDocument, options);
}
